(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.dl.bN === region.dW.bN)
	{
		return 'on line ' + region.dl.bN;
	}
	return 'on lines ' + region.dl.bN + ' through ' + region.dW.bN;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hQ,
		impl.kI,
		impl.ka,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		am: func(record.am),
		dn: record.dn,
		de: record.de
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		var n = _VirtualDom_doc.createTextNode(vNode.a);
		n.created_by_elm = true;
		return n
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);
	domNode.created_by_elm = true;

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.am;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.dn;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.de) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0, k = 0; j < Math.max(vKids.length, childNodes.length); j++, k++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);

		// 1. if unknown nodes have been inserted
		if(childNodes.length > vKids.length)
		{
			// skip them
			while(!childNodes[k].created_by_elm)
			{
				console.log("INFO 1: skipping DOM")
				k++
			}
		}
		// 2. if existing node has been removed
		if(childNodes.length < vKids.length)
		{
			if(childNodes[k])
			{
				// replace tha node using the old vdom
				console.log("WARN 1: redrawing DOM")
				_VirtualDom_applyPatchRedraw(childNodes[k], vKids[j], eventNode)
			}
			else
			{
				console.log("WARN 2: redrawing DOM")
				domNode.appendChild(_VirtualDom_render(vKids[j], eventNode));
			}
		}
		// 3. if existing node has been replaced with unknown node
		if(childNodes.length === vKids.length)
		{
			if(!childNodes[k].created_by_elm)
			{
				// replace tha node using the old vdom
				console.log("WARN 3: redrawing DOM")
				_VirtualDom_applyPatchRedraw(childNodes[k], vKids[j], eventNode)
			}
		}
		// 4. this is needed for some edge cases
		if(vKids[j].$ === 1 && (childNodes[k].tagName || "").toLowerCase() !== vKids[j].c)
		{
			console.log("WARN 4: redrawing DOM")
			_VirtualDom_applyPatchRedraw(childNodes[k], vKids[j], eventNode)
		}

		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[k], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			
			// patch for extension
			if(domNode.childNodes.length !== data.i + data.v)
			{
				console.log("INFO 0: using another logic")
				var removed = 0;
				var index = domNode.childNodes.length - 1;
				while (removed < data.i)
				{
					var childNode = domNode.childNodes[index];
					if(childNode.created_by_elm)
					{
						domNode.removeChild(childNode);
						removed++;
					}
					index--;
				}
				return domNode;
			}

			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	node.created_by_elm = true;
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hQ,
		impl.kI,
		impl.ka,
		function(sendToApp, initialModel) {
			var view = impl.kL;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hQ,
		impl.kI,
		impl.ka,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.dh && impl.dh(sendToApp)
			var view = impl.kL;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.bF);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.b0) && (_VirtualDom_doc.title = title = doc.b0);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.i_;
	var onUrlRequest = impl.i$;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		dh: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.eN === next.eN
							&& curr.ed === next.ed
							&& curr.eH.a === next.eH.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		hQ: function(flags)
		{
			return A3(impl.hQ, flags, _Browser_getUrl(), key);
		},
		kL: impl.kL,
		kI: impl.kI,
		ka: impl.ka
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hD: 'hidden', gp: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hD: 'mozHidden', gp: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hD: 'msHidden', gp: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hD: 'webkitHidden', gp: 'webkitvisibilitychange' }
		: { hD: 'hidden', gp: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		e1: _Browser_getScene(),
		fo: {
			fu: _Browser_window.pageXOffset,
			fv: _Browser_window.pageYOffset,
			dp: _Browser_doc.documentElement.clientWidth,
			bn: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		dp: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		bn: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			e1: {
				dp: node.scrollWidth,
				bn: node.scrollHeight
			},
			fo: {
				fu: node.scrollLeft,
				fv: node.scrollTop,
				dp: node.clientWidth,
				bn: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			e1: _Browser_getScene(),
			fo: {
				fu: x,
				fv: y,
				dp: _Browser_doc.documentElement.clientWidth,
				bn: _Browser_doc.documentElement.clientHeight
			},
			g2: {
				fu: x + rect.left,
				fv: y + rect.top,
				dp: rect.width,
				bn: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.cm.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.cm.b, xhr)); });
		$elm$core$Maybe$isJust(request.cH) && _Http_track(router, xhr, request.cH.a);

		try {
			xhr.open(request.cu, request.R, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.R));
		}

		_Http_configureRequest(xhr, request);

		request.bF.a && xhr.setRequestHeader('Content-Type', request.bF.a);
		xhr.send(request.bF.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.cp; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.cG.a || 0;
	xhr.responseType = request.cm.d;
	xhr.withCredentials = request.fT;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		R: xhr.responseURL,
		j3: xhr.status,
		j4: xhr.statusText,
		cp: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			jS: event.loaded,
			jW: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			jl: event.loaded,
			jW: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.iR) { flags += 'm'; }
	if (options.go) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$MsgUrlChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$MsgUrlRequested = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.I) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.L),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.L);
		} else {
			var treeLen = builder.I * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.M) : builder.M;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.I);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.L) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.L);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{M: nodeList, I: (len / $elm$core$Array$branchFactor) | 0, L: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {d6: fragment, ed: host, eD: path, eH: port_, eN: protocol, jk: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Main$ToastAlertsMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$T2$ToastAlerts$AlertMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$T2$Internal$Alert$StartAutoDismiss = function (a) {
	return {$: 1, a: a};
};
var $author$project$T2$Alert$cmdStartAutoDismiss = function (alertId) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(
			$author$project$T2$Internal$Alert$StartAutoDismiss(alertId)));
};
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$T2$ToastAlerts$addAlert = F2(
	function (alert, model) {
		var newModel = _Utils_update(
			model,
			{
				aa: A3($elm$core$Dict$insert, alert.ax, alert, model.aa)
			});
		var cmd = function () {
			var _v0 = alert.dx;
			if (!_v0.$) {
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$T2$ToastAlerts$AlertMsg(alert.ax),
					$author$project$T2$Alert$cmdStartAutoDismiss(alert.ax));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(newModel, cmd);
	});
var $author$project$Main$MsgGlobalGotServerLoadMessageResult = function (a) {
	return {$: 17, a: a};
};
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.j3));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {eU: reqs, fc: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.cH;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.eU));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.fc)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					fT: r.fT,
					bF: r.bF,
					cm: A2(_Http_mapExpect, func, r.cm),
					cp: r.cp,
					cu: r.cu,
					cG: r.cG,
					cH: r.cH,
					R: r.R
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{fT: true, bF: r.bF, cm: r.cm, cp: r.cp, cu: r.cu, cG: r.cG, cH: r.cH, R: r.R}));
};
var $author$project$Model$ServerLoadMessageResponse = F5(
	function (status, message, expirationTimestamp, expirationHumanReadable, errors) {
		return {g4: errors, g5: expirationHumanReadable, g6: expirationTimestamp, am: message, dm: status};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$T2$ApiModel$TkApiErrorVo = F4(
	function (target, errorCode, errorMessage, extraInfo) {
		return {dX: errorCode, bI: errorMessage, d0: extraInfo, ff: target};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$T2$ApiModel$TkApiErrorExtraInfoVo = F2(
	function (key, value) {
		return {en: key, m: value};
	});
var $author$project$T2$ApiModel$tkApiErrorExtraInfoVoDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$T2$ApiModel$TkApiErrorExtraInfoVo,
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string));
var $author$project$T2$ApiModel$tkApiErrorVoDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$T2$ApiModel$TkApiErrorVo,
	A2($elm$json$Json$Decode$field, 'target', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'error_code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'error_message', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'extra_info',
		$elm$json$Json$Decode$list($author$project$T2$ApiModel$tkApiErrorExtraInfoVoDecoder)));
var $author$project$Model$serverLoadMessageResponseDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'errors',
	$elm$json$Json$Decode$maybe(
		$elm$json$Json$Decode$list($author$project$T2$ApiModel$tkApiErrorVoDecoder)),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'expiration_human_readable',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'expiration_timestamp',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'message',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$ServerLoadMessageResponse))))));
var $author$project$Main$cmdBannerNotificationGlobalLoad = function (model) {
	return $elm$http$Http$riskyRequest(
		{
			bF: $elm$http$Http$emptyBody,
			cm: A2($elm$http$Http$expectJson, $author$project$Main$MsgGlobalGotServerLoadMessageResult, $author$project$Model$serverLoadMessageResponseDecoder),
			cp: _List_Nil,
			cu: 'POST',
			cG: $elm$core$Maybe$Just(model.J.ct),
			cH: $elm$core$Maybe$Nothing,
			R: model.J.bO + '/v1/admin/banner-notification/job-ads/get-public'
		});
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$getNotificationsFromLocalStorage = _Platform_outgoingPort(
	'getNotificationsFromLocalStorage',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$T2$ApiModel$TkRecruiterAlertMessageEmptyResponse = {$: 2};
var $author$project$T2$ApiModel$TkRecruiterBubbleMessageResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$T2$ApiModel$TkRecruiterToastMessageResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$T2$ApiModel$ToastOrBubbleDanger = 3;
var $author$project$T2$ApiModel$ToastOrBubbleSuccess = 0;
var $author$project$T2$ApiModel$ToastOrBubbleWarning = 2;
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {hM: index, iB: match, iV: number, j8: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{go: false, iR: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$core$String$cons = _String_cons;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $elm_community$string_extra$String$Extra$toTitleCase = function (ws) {
	var uppercaseMatch = A2(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('\\w+'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.iB;
			},
			$elm_community$string_extra$String$Extra$toSentenceCase));
	return A3(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('^([a-z])|\\s+([a-z])'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.iB;
			},
			uppercaseMatch),
		ws);
};
var $author$project$T2$ApiModel$processUrlParamAlert = F3(
	function (recruiterLoggedInInfo, candidateLoggedInInfo, _v0) {
		var urlParamName = _v0.a;
		var urlParamValuesList = _v0.b;
		var urlParamValueHeadOption = $elm$core$List$head(urlParamValuesList);
		if (urlParamName === 'msg') {
			if (!urlParamValueHeadOption.$) {
				switch (urlParamValueHeadOption.a) {
					case 'candidate_login_success':
						return candidateLoggedInInfo.dF ? $author$project$T2$ApiModel$TkRecruiterToastMessageResponse(
							{
								ax: 'candidate_login_success',
								am: 'has accedido a tu cuenta: ' + (A2($elm$core$Maybe$withDefault, '', candidateLoggedInInfo.gj) + ' satisfactoriamente.'),
								eZ: 0,
								b0: 'Hola ' + $elm_community$string_extra$String$Extra$toTitleCase(
									A2($elm$core$Maybe$withDefault, '', candidateLoggedInInfo.gk))
							}) : $author$project$T2$ApiModel$TkRecruiterAlertMessageEmptyResponse;
					case 'candidate_logged_in':
						return candidateLoggedInInfo.dF ? $author$project$T2$ApiModel$TkRecruiterToastMessageResponse(
							{
								ax: 'candidate_logged_in',
								am: 'has ingresado como: ' + (A2($elm$core$Maybe$withDefault, '', candidateLoggedInInfo.gj) + '. Si deseas hacerlo con otra cuenta, cierra esta sesión y dirígete a la pantalla de acceder'),
								eZ: 2,
								b0: 'Hola ' + $elm_community$string_extra$String$Extra$toTitleCase(
									A2($elm$core$Maybe$withDefault, '', candidateLoggedInInfo.gk))
							}) : $author$project$T2$ApiModel$TkRecruiterAlertMessageEmptyResponse;
					case 'recruiter_account_created':
						return $author$project$T2$ApiModel$TkRecruiterToastMessageResponse(
							{
								ax: 'recruiter_account_created',
								am: 'Tu cuenta ha sido creada con éxito.',
								eZ: 0,
								b0: 'Hola ' + A2($elm$core$Maybe$withDefault, '', recruiterLoggedInInfo.jv)
							});
					case 'candidate_logout':
						return $author$project$T2$ApiModel$TkRecruiterToastMessageResponse(
							{ax: 'candidate_logout', am: 'Has cerrado tu sesión satisfactoriamente', eZ: 0, b0: 'Talenteca'});
					case 'recruiter_logout':
						return $author$project$T2$ApiModel$TkRecruiterToastMessageResponse(
							{ax: 'recruiter_logout', am: 'Has cerrado tu sesión satisfactoriamente', eZ: 0, b0: 'Talenteca'});
					case 'blocked_account':
						return $author$project$T2$ApiModel$TkRecruiterBubbleMessageResponse(
							{ax: 'blocked_account', am: 'Tu cuenta de usuario ha sido bloqueada y por el momento no podrás publicar o republicar vacantes. Escríbenos a soporte@talenteca.com para obtener más información.', eZ: 3});
					case 'cv_received':
						return $author$project$T2$ApiModel$TkRecruiterBubbleMessageResponse(
							{ax: 'cv_received', am: '¡Tu CV ha sido recibido, aquí puedes encontrar más empleos!', eZ: 0});
					case 'account_validated':
						return $author$project$T2$ApiModel$TkRecruiterToastMessageResponse(
							{ax: 'account_validated', am: 'Muchas gracias por validar tu cuenta', eZ: 0, b0: 'Talenteca'});
					case 'account_validation_error':
						return $author$project$T2$ApiModel$TkRecruiterToastMessageResponse(
							{ax: 'account_validation_error', am: 'Ha ocurrido un error, disculpa las molestias, por favor intenta más tarde', eZ: 3, b0: 'Talenteca'});
					case 'candidate_password_changed':
						return $author$project$T2$ApiModel$TkRecruiterBubbleMessageResponse(
							{ax: 'candidate_password_changed', am: 'Has accedido a Talenteca y tu contraseña fue restablecida exitosamente!', eZ: 0});
					case 'cand_p_ch':
						return $author$project$T2$ApiModel$TkRecruiterBubbleMessageResponse(
							{ax: 'cand_p_ch', am: '¡Has actualizado tu contraseña correctamente!', eZ: 0});
					case 'invalid_merge':
						return $author$project$T2$ApiModel$TkRecruiterToastMessageResponse(
							{ax: 'recruiter_logout', am: 'Hubo un problema al validar la fusión de tus cuentas. Por favor, comunícate con nosotros a: soporte@talenteca.com', eZ: 3, b0: 'Talenteca'});
					case 'success_merge_email':
						return $author$project$T2$ApiModel$TkRecruiterToastMessageResponse(
							{ax: 'recruiter_logout', am: 'Tus cuentas han sido fusionadas correctamente, ahora puedes ingresar normalmente para continuar.', eZ: 0, b0: 'Talenteca'});
					case 'failed_redirect':
						return $author$project$T2$ApiModel$TkRecruiterToastMessageResponse(
							{ax: 'recruiter_logout', am: 'Ha ocurrido un error y hemos tenido que cerrar tu sesión. Por favor, inicia sesión nuevamente', eZ: 3, b0: 'Talenteca'});
					case 'interview_confirmation_success':
						return $author$project$T2$ApiModel$TkRecruiterBubbleMessageResponse(
							{ax: 'interview_confirmation', am: 'Se ha confirmado tu asistencia a la entrevista.', eZ: 0});
					case 'interview_confirmation_error':
						return $author$project$T2$ApiModel$TkRecruiterBubbleMessageResponse(
							{ax: 'interview_confirmation', am: 'Ha ocurrido un error al confirmar tu asistencia a la entrevista. Por favor, intenta nuevamente', eZ: 3});
					case 'interview_cancel_success':
						return $author$project$T2$ApiModel$TkRecruiterBubbleMessageResponse(
							{ax: 'interview_confirmation', am: 'Se ha cancelado tu asistencia a la entrevista.', eZ: 0});
					case 'interview_cancel_error':
						return $author$project$T2$ApiModel$TkRecruiterBubbleMessageResponse(
							{ax: 'interview_confirmation', am: 'Ha ocurrido un error al cancelar tu asistencia a la entrevista. Por favor, intenta nuevamente', eZ: 3});
					case 'account_deactivated_for_merging':
						return $author$project$T2$ApiModel$TkRecruiterBubbleMessageResponse(
							{ax: 'account_deactivated_for_merging', am: 'La cuenta de Talenteca a la que estás tratando de acceder está desactivada porque se ha actualizado a una nueva cuenta. Por favor accede con esta ó comunícate con nosotros a soporte@talenteca.com', eZ: 3});
					case 'internal_login_error':
						return $author$project$T2$ApiModel$TkRecruiterBubbleMessageResponse(
							{ax: 'internal_login_error', am: 'Ha ocurrido un error en el servidor al acceder a tu cuenta de Talenteca. Por favor intenta más tarde o comunícate con nosotros a: soporte@talenteca.com', eZ: 3});
					default:
						return $author$project$T2$ApiModel$TkRecruiterAlertMessageEmptyResponse;
				}
			} else {
				return $author$project$T2$ApiModel$TkRecruiterAlertMessageEmptyResponse;
			}
		} else {
			return $author$project$T2$ApiModel$TkRecruiterAlertMessageEmptyResponse;
		}
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $author$project$T2$Util$queryParameters = function (url) {
	var toTuples = function (str) {
		var _v2 = A2($elm$core$String$split, '=', str);
		if (_v2.b) {
			var key = _v2.a;
			var value = _v2.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					key,
					A2($elm$core$String$join, '=', value))
				]);
		} else {
			return _List_Nil;
		}
	};
	var addParam = F2(
		function (value, maybeValues) {
			if (!maybeValues.$) {
				var values = maybeValues.a;
				return $elm$core$Maybe$Just(
					A2($elm$core$List$cons, value, values));
			} else {
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[value]));
			}
		});
	var toDict = function (parameters) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, dict) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(
						$elm$core$Dict$update,
						k,
						addParam(v),
						dict);
				}),
			$elm$core$Dict$empty,
			parameters);
	};
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Dict$empty,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$split('&'),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$concatMap(toTuples),
					toDict)),
			A2($elm$core$Maybe$andThen, $elm$url$Url$percentDecode, url.jk)));
};
var $author$project$T2$ApiModel$getPublicAlertMessagesToShow = F3(
	function (recruiterLoggedInInfo, candidateLoggedInInfo, url) {
		var queryParams = $elm$core$Dict$toList(
			$author$project$T2$Util$queryParameters(url));
		var alertMessagesList = A2(
			$elm$core$List$map,
			function (_v2) {
				var urlParamName = _v2.a;
				var urlParamValuesList = _v2.b;
				return A3(
					$author$project$T2$ApiModel$processUrlParamAlert,
					recruiterLoggedInInfo,
					candidateLoggedInInfo,
					_Utils_Tuple2(urlParamName, urlParamValuesList));
			},
			queryParams);
		var bubbleAlertMessages = $elm$core$Dict$fromList(
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (alert) {
						if (alert.$ === 1) {
							var tkRecruiterBubbleMessageResponse = alert.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(tkRecruiterBubbleMessageResponse.ax, tkRecruiterBubbleMessageResponse)
								]);
						} else {
							return _List_Nil;
						}
					},
					alertMessagesList)));
		var toastAlertMessages = $elm$core$Dict$fromList(
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (alert) {
						if (!alert.$) {
							var tkRecruiterToastMessageResponse = alert.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(tkRecruiterToastMessageResponse.ax, tkRecruiterToastMessageResponse)
								]);
						} else {
							return _List_Nil;
						}
					},
					alertMessagesList)));
		return {dA: $elm$core$Dict$empty, gb: bubbleAlertMessages, dm: 'ok', kz: toastAlertMessages};
	});
var $author$project$T2$Internal$Alert$Error = 0;
var $author$project$T2$Internal$Alert$Low = 0;
var $author$project$T2$Internal$Alert$Medium = 1;
var $author$project$T2$Internal$Alert$Visible = 0;
var $author$project$T2$Internal$Alert$init = function (id) {
	return function (emphasis) {
		return function (status) {
			return function (size) {
				return function (label) {
					return function (action) {
						return function (title) {
							return function (dismissible) {
								return function (autoDismissSeconds) {
									return function (trailingLink) {
										return {dt: action, dx: autoDismissSeconds, dT: dismissible, dV: emphasis, ax: id, u: label, jW: size, K: 0, dm: status, b0: title, fj: trailingLink};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$T2$Alert$initAlertLowErrorMediumAutoDismissible = F2(
	function (id, message) {
		return $author$project$T2$Internal$Alert$init(id)(0)(0)(1)(message)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)(true)(
			$elm$core$Maybe$Just(8))($elm$core$Maybe$Nothing);
	});
var $author$project$T2$Internal$Alert$Info = 3;
var $author$project$T2$Alert$initAlertLowInfoMediumAutoDismissible = F2(
	function (id, message) {
		return $author$project$T2$Internal$Alert$init(id)(0)(3)(1)(message)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)(true)(
			$elm$core$Maybe$Just(8))($elm$core$Maybe$Nothing);
	});
var $author$project$T2$Internal$Alert$Success = 2;
var $author$project$T2$Alert$initAlertLowSuccessMediumAutoDismissible = F2(
	function (id, message) {
		return $author$project$T2$Internal$Alert$init(id)(0)(2)(1)(message)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)(true)(
			$elm$core$Maybe$Just(8))($elm$core$Maybe$Nothing);
	});
var $author$project$T2$Internal$Alert$Warning = 1;
var $author$project$T2$Alert$initAlertLowWarningMediumAutoDismissible = F2(
	function (id, message) {
		return $author$project$T2$Internal$Alert$init(id)(0)(1)(1)(message)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)(true)(
			$elm$core$Maybe$Just(8))($elm$core$Maybe$Nothing);
	});
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$T2$LargeScreen = 2;
var $author$project$T2$LargeXScreen = 3;
var $author$project$T2$MediumScreen = 1;
var $author$project$T2$SmallScreen = 0;
var $author$project$T2$Util$classifyScreen = function (width) {
	return (width <= 599) ? 0 : ((width <= 1135) ? 1 : ((width <= 1440) ? 2 : 3));
};
var $author$project$T2$Internal$Drawer$InternalModel = function (showDrawer) {
	return {di: showDrawer};
};
var $author$project$T2$Drawer$defaultInternalModel = $author$project$T2$Internal$Drawer$InternalModel(false);
var $author$project$T2$Internal$TopBar$InternalModel = F2(
	function (showUserAccountSubmenu, showNotifications) {
		return {e8: showNotifications, dj: showUserAccountSubmenu};
	});
var $author$project$T2$TopBar$defaultInternalModel = A2($author$project$T2$Internal$TopBar$InternalModel, false, false);
var $author$project$T2$ApiModel$defaultNotificationFromLocalStorage = {fI: _List_Nil, eO: _List_Nil};
var $author$project$T2$ApiModel$defaultTkNotificationsFromLocalStorage = {dL: 0, c0: $author$project$T2$ApiModel$defaultNotificationFromLocalStorage, fd: false};
var $author$project$Route$RouteHome = 0;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {aU: frag, a4: params, aP: unvisited, m: value, bg: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.aP;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.m);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.m);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.eD),
					$elm$url$Url$Parser$prepareQuery(url.jk),
					url.d6,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$baseSegment = 'postular';
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.bg;
		var unvisited = _v0.aP;
		var params = _v0.a4;
		var frag = _v0.aU;
		var value = _v0.m;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $author$project$Route$homeParser = $elm$url$Url$Parser$s($author$project$Route$baseSegment);
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.bg;
		var unvisited = _v0.aP;
		var params = _v0.a4;
		var frag = _v0.aU;
		var value = _v0.m;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.bg;
			var unvisited = _v1.aP;
			var params = _v1.a4;
			var frag = _v1.aU;
			var value = _v1.m;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Route$routeParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, 0, $author$project$Route$homeParser)
		]));
var $author$project$Route$fromUrl = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2($elm$url$Url$Parser$parse, $author$project$Route$routeParser, url));
};
var $author$project$T2$Util$getCommonModel = function (commonFlags) {
	return {
		cQ: commonFlags.cQ,
		gT: commonFlags.gT,
		h1: commonFlags.h1,
		h9: commonFlags.h9,
		ia: commonFlags.ia,
		ib: commonFlags.ib,
		ic: commonFlags.ic,
		ii: commonFlags.ii,
		bO: commonFlags.bO,
		ct: commonFlags.h1 ? 12000 : 10000,
		iz: commonFlags.h1 ? 60000 : 120000,
		iA: commonFlags.iA,
		eP: commonFlags.eP,
		cy: commonFlags.cy,
		e$: commonFlags.h1 ? 'development' : (commonFlags.h9 ? 'production' : 'unknown-run-mode'),
		jT: commonFlags.jT,
		kB: commonFlags.kB,
		b5: commonFlags.b5
	};
};
var $author$project$T2$ToastAlerts$init = {aa: $elm$core$Dict$empty};
var $author$project$T2$Internal$Dropdown$Closed = 0;
var $author$project$Model$EmailStep = 0;
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$Page$Home$MsgCityAutocompleteUpdate = function (a) {
	return {$: 120, a: a};
};
var $author$project$Page$Home$MsgCitySelected = function (a) {
	return {$: 121, a: a};
};
var $author$project$Page$Home$PassThrough = {$: 122};
var $author$project$Model$WelcomeStep = 0;
var $author$project$Model$categoryItemsList = _List_fromArray(
	[
		{
		t: false,
		u: 'Comercial / Ventas',
		m: {s: 'Comercial / Ventas', m: 'Comercial / Ventas'}
	},
		{
		t: false,
		u: 'Atención al cliente (incluye meseros, recepcionistas, etc)',
		m: {s: 'Atención al cliente (incluye meseros, recepcionistas, etc)', m: 'Atención al cliente'}
	},
		{
		t: false,
		u: 'Manufactura / Operaciones',
		m: {s: 'Manufactura / Operaciones', m: 'Manufactura / Operaciones'}
	},
		{
		t: false,
		u: 'Mantenimiento y reparaciones',
		m: {s: 'Mantenimiento y reparaciones', m: 'Mantenimiento y reparaciones'}
	},
		{
		t: false,
		u: 'Logística / Transporte',
		m: {s: 'Logística / Transporte', m: 'Logística / Transporte'}
	},
		{
		t: false,
		u: 'Contabilidad / Finanzas',
		m: {s: 'Contabilidad / Finanzas', m: 'Contabilidad / Finanzas'}
	},
		{
		t: false,
		u: 'Tecnología / Internet',
		m: {s: 'Tecnología / Internet', m: 'Tecnología / Internet'}
	},
		{
		t: false,
		u: 'Administrativo / Secretarial',
		m: {s: 'Administrativo / Secretarial', m: 'Administrativo / Secretarial'}
	},
		{
		t: false,
		u: 'Recursos humanos',
		m: {s: 'Recursos humanos', m: 'Recursos humanos'}
	},
		{
		t: false,
		u: 'Marketing / RRPP / Comunicación',
		m: {s: 'Marketing / RRPP / Comunicación', m: 'Marketing / RRPP / Comunicación'}
	},
		{
		t: false,
		u: 'Turismo / Hotelería',
		m: {s: 'Turismo / Hotelería', m: 'Turismo / Hotelería'}
	},
		{
		t: false,
		u: 'Medicina / Salud',
		m: {s: 'Medicina / Salud', m: 'Medicina / Salud'}
	},
		{
		t: false,
		u: 'Construcción',
		m: {s: 'Construcción', m: 'Construcción'}
	},
		{
		t: false,
		u: 'Legal',
		m: {s: 'Legal', m: 'Legal'}
	},
		{
		t: false,
		u: 'Educación',
		m: {s: 'Educación', m: 'Educación'}
	},
		{
		t: false,
		u: 'Arte / Diseño / Creativo',
		m: {s: 'Arte / Diseño / Creativo', m: 'Arte / Diseño / Creativo'}
	},
		{
		t: false,
		u: 'Arquitectura',
		m: {s: 'Arquitectura', m: 'Arquitectura'}
	},
		{
		t: false,
		u: 'Dirección de empresas',
		m: {s: 'Dirección de empresas', m: 'Dirección de empresas'}
	},
		{
		t: false,
		u: 'Recursos naturales',
		m: {s: 'Recursos naturales', m: 'Recursos naturales'}
	},
		{
		t: false,
		u: 'ONGs',
		m: {s: 'ONGs', m: 'ONGs'}
	},
		{
		t: false,
		u: 'Estatal / Ministerios',
		m: {s: 'Estatal / Ministerios', m: 'Estatal / Ministerios'}
	},
		{
		t: false,
		u: 'Minas / Petroleo',
		m: {s: 'Minas / Petroleo', m: 'Minas / Petroleo'}
	}
	]);
var $truqu$elm_base64$Base64$Decode$pad = function (input) {
	var _v0 = $elm$core$String$length(input) % 4;
	switch (_v0) {
		case 3:
			return input + '=';
		case 2:
			return input + '==';
		default:
			return input;
	}
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $truqu$elm_base64$Base64$Decode$charToInt = function (_char) {
	switch (_char) {
		case 'A':
			return 0;
		case 'B':
			return 1;
		case 'C':
			return 2;
		case 'D':
			return 3;
		case 'E':
			return 4;
		case 'F':
			return 5;
		case 'G':
			return 6;
		case 'H':
			return 7;
		case 'I':
			return 8;
		case 'J':
			return 9;
		case 'K':
			return 10;
		case 'L':
			return 11;
		case 'M':
			return 12;
		case 'N':
			return 13;
		case 'O':
			return 14;
		case 'P':
			return 15;
		case 'Q':
			return 16;
		case 'R':
			return 17;
		case 'S':
			return 18;
		case 'T':
			return 19;
		case 'U':
			return 20;
		case 'V':
			return 21;
		case 'W':
			return 22;
		case 'X':
			return 23;
		case 'Y':
			return 24;
		case 'Z':
			return 25;
		case 'a':
			return 26;
		case 'b':
			return 27;
		case 'c':
			return 28;
		case 'd':
			return 29;
		case 'e':
			return 30;
		case 'f':
			return 31;
		case 'g':
			return 32;
		case 'h':
			return 33;
		case 'i':
			return 34;
		case 'j':
			return 35;
		case 'k':
			return 36;
		case 'l':
			return 37;
		case 'm':
			return 38;
		case 'n':
			return 39;
		case 'o':
			return 40;
		case 'p':
			return 41;
		case 'q':
			return 42;
		case 'r':
			return 43;
		case 's':
			return 44;
		case 't':
			return 45;
		case 'u':
			return 46;
		case 'v':
			return 47;
		case 'w':
			return 48;
		case 'x':
			return 49;
		case 'y':
			return 50;
		case 'z':
			return 51;
		case '0':
			return 52;
		case '1':
			return 53;
		case '2':
			return 54;
		case '3':
			return 55;
		case '4':
			return 56;
		case '5':
			return 57;
		case '6':
			return 58;
		case '7':
			return 59;
		case '8':
			return 60;
		case '9':
			return 61;
		case '+':
			return 62;
		case '/':
			return 63;
		default:
			return 0;
	}
};
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Char$fromCode = _Char_fromCode;
var $truqu$elm_base64$Base64$Decode$intToString = A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar);
var $truqu$elm_base64$Base64$Decode$add = F2(
	function (_char, _v0) {
		var curr = _v0.a;
		var need = _v0.b;
		var res = _v0.c;
		var shiftAndAdd = function (_int) {
			return (63 & _int) | (curr << 6);
		};
		return (!need) ? ((!(128 & _char)) ? _Utils_Tuple3(
			0,
			0,
			_Utils_ap(
				res,
				$truqu$elm_base64$Base64$Decode$intToString(_char))) : (((224 & _char) === 192) ? _Utils_Tuple3(31 & _char, 1, res) : (((240 & _char) === 224) ? _Utils_Tuple3(15 & _char, 2, res) : _Utils_Tuple3(7 & _char, 3, res)))) : ((need === 1) ? _Utils_Tuple3(
			0,
			0,
			_Utils_ap(
				res,
				$truqu$elm_base64$Base64$Decode$intToString(
					shiftAndAdd(_char)))) : _Utils_Tuple3(
			shiftAndAdd(_char),
			need - 1,
			res));
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $truqu$elm_base64$Base64$Decode$toUTF16 = F2(
	function (_char, acc) {
		return _Utils_Tuple3(
			0,
			0,
			A2(
				$truqu$elm_base64$Base64$Decode$add,
				255 & (_char >>> 0),
				A2(
					$truqu$elm_base64$Base64$Decode$add,
					255 & (_char >>> 8),
					A2($truqu$elm_base64$Base64$Decode$add, 255 & (_char >>> 16), acc))));
	});
var $truqu$elm_base64$Base64$Decode$chomp = F2(
	function (char_, _v0) {
		var curr = _v0.a;
		var cnt = _v0.b;
		var utf8ToUtf16 = _v0.c;
		var _char = $truqu$elm_base64$Base64$Decode$charToInt(char_);
		if (cnt === 3) {
			return A2($truqu$elm_base64$Base64$Decode$toUTF16, curr | _char, utf8ToUtf16);
		} else {
			return _Utils_Tuple3((_char << ((3 - cnt) * 6)) | curr, cnt + 1, utf8ToUtf16);
		}
	});
var $elm$core$String$foldl = _String_foldl;
var $truqu$elm_base64$Base64$Decode$initial = _Utils_Tuple3(
	0,
	0,
	_Utils_Tuple3(0, 0, ''));
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $truqu$elm_base64$Base64$Decode$stripNulls = F2(
	function (input, output) {
		return A2($elm$core$String$endsWith, '==', input) ? A2($elm$core$String$dropRight, 2, output) : (A2($elm$core$String$endsWith, '=', input) ? A2($elm$core$String$dropRight, 1, output) : output);
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $truqu$elm_base64$Base64$Decode$validBase64Regex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([A-Za-z0-9\\/+]{4})*([A-Za-z0-9\\/+]{2}[A-Za-z0-9\\/+=]{2})?$'));
var $truqu$elm_base64$Base64$Decode$validate = function (input) {
	return A2($elm$regex$Regex$contains, $truqu$elm_base64$Base64$Decode$validBase64Regex, input) ? $elm$core$Result$Ok(input) : $elm$core$Result$Err('Invalid base64');
};
var $truqu$elm_base64$Base64$Decode$wrapUp = function (_v0) {
	var _v1 = _v0.c;
	var need = _v1.b;
	var res = _v1.c;
	return (need > 0) ? $elm$core$Result$Err('Invalid UTF-16') : $elm$core$Result$Ok(res);
};
var $truqu$elm_base64$Base64$Decode$validateAndDecode = function (input) {
	return A2(
		$elm$core$Result$map,
		$truqu$elm_base64$Base64$Decode$stripNulls(input),
		A2(
			$elm$core$Result$andThen,
			A2(
				$elm$core$Basics$composeR,
				A2($elm$core$String$foldl, $truqu$elm_base64$Base64$Decode$chomp, $truqu$elm_base64$Base64$Decode$initial),
				$truqu$elm_base64$Base64$Decode$wrapUp),
			$truqu$elm_base64$Base64$Decode$validate(input)));
};
var $truqu$elm_base64$Base64$Decode$decode = A2($elm$core$Basics$composeR, $truqu$elm_base64$Base64$Decode$pad, $truqu$elm_base64$Base64$Decode$validateAndDecode);
var $truqu$elm_base64$Base64$decode = $truqu$elm_base64$Base64$Decode$decode;
var $author$project$Model$defaultTkCommonField = {bI: $elm$core$Maybe$Nothing, cn: false, cr: '', m: $elm$core$Maybe$Nothing};
var $author$project$Model$defaultTkLocationField = {bI: $elm$core$Maybe$Nothing, cn: false, cr: '', e4: $elm$core$Maybe$Nothing, m: $elm$core$Maybe$Nothing};
var $author$project$Model$educationLevelItems = _List_fromArray(
	[
		{
		t: false,
		u: 'Básica',
		m: {s: 'Básica', m: 'Básica'}
	},
		{
		t: false,
		u: 'Media Superior',
		m: {s: 'Media Superior', m: 'Media Superior'}
	},
		{
		t: false,
		u: 'Superior - trunco',
		m: {s: 'Superior - trunco', m: 'Superior - trunco'}
	},
		{
		t: false,
		u: 'Superior - cursando',
		m: {s: 'Superior - cursando', m: 'Superior - cursando'}
	},
		{
		t: false,
		u: 'Superior - titulado',
		m: {s: 'Superior - titulado', m: 'Superior - titulado'}
	},
		{
		t: false,
		u: 'Maestría',
		m: {s: 'Maestría', m: 'Maestría'}
	},
		{
		t: false,
		u: 'Doctorado',
		m: {s: 'Doctorado', m: 'Doctorado'}
	}
	]);
var $author$project$Model$experienceLevelItemsList = _List_fromArray(
	[
		{
		t: false,
		u: 'Practicantes',
		m: {s: 'Practicantes', m: 'Practicantes'}
	},
		{
		t: false,
		u: 'Nivel Inicial',
		m: {s: 'Nivel Inicial', m: 'Nivel Inicial'}
	},
		{
		t: false,
		u: 'Nivel Medio',
		m: {s: 'Nivel Medio', m: 'Nivel Medio'}
	},
		{
		t: false,
		u: 'Nivel Experto',
		m: {s: 'Nivel Experto', m: 'Nivel Experto'}
	},
		{
		t: false,
		u: 'Nivel Gerencial',
		m: {s: 'Nivel Gerencial', m: 'Nivel Gerencial'}
	},
		{
		t: false,
		u: 'Nivel Alto Directivo',
		m: {s: 'Nivel Alto Directivo', m: 'Nivel Alto Directivo'}
	}
	]);
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.bg;
		var unvisited = _v1.aP;
		var params = _v1.a4;
		var frag = _v1.aU;
		var value = _v1.m;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$T2$Util$getUrlParam = F2(
	function (url, paramName) {
		var flattenUrl = _Utils_update(
			url,
			{eD: ''});
		return A2(
			$elm$core$Maybe$andThen,
			function (value) {
				return (value === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value);
			},
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$url$Url$Parser$parse,
					$elm$url$Url$Parser$query(
						$elm$url$Url$Parser$Query$string(paramName)),
					flattenUrl)));
	});
var $author$project$T2$Util$extractSearchArgument = F2(
	function (key, location) {
		return A2($author$project$T2$Util$getUrlParam, location, key);
	});
var $author$project$Page$Home$extractEmailFromUrl = function (url) {
	return A2($author$project$T2$Util$extractSearchArgument, 'email', url);
};
var $author$project$Page$Home$extractExternalRedirectFromUrl = function (url) {
	return A2($author$project$T2$Util$extractSearchArgument, 'external_apply', url);
};
var $author$project$Page$Home$extractJobAdIdFromUrl = function (url) {
	return A2($author$project$T2$Util$extractSearchArgument, 'j_id', url);
};
var $author$project$Page$Home$extractProviderFromUrl = function (url) {
	return A2($author$project$T2$Util$extractSearchArgument, 'provider', url);
};
var $author$project$Page$Home$extractSourceFromUrl = function (url) {
	return A2($author$project$T2$Util$extractSearchArgument, 'source', url);
};
var $author$project$Page$Home$extractTkUtmSourceFromUrl = function (url) {
	return A2($author$project$T2$Util$extractSearchArgument, 'tk_utm_source', url);
};
var $author$project$T2$Internal$Autocomplete$init = F6(
	function (id, toMsg, onSelect, onBlur, useSimpleMatch, items) {
		return {bl: items, ax: id, h7: false, bp: items, db: onBlur, a2: onSelect, jk: '', a7: 0, jR: $elm$core$Maybe$Nothing, aN: toMsg, b4: useSimpleMatch};
	});
var $author$project$T2$Autocomplete$initAutocomplete = F6(
	function (autocompleteId, toMsg, onSelectMsg, onBlurMsg, useSimpleMatch, items) {
		return A6($author$project$T2$Internal$Autocomplete$init, autocompleteId, toMsg, onSelectMsg, onBlurMsg, useSimpleMatch, items);
	});
var $author$project$T2$Internal$Dropdown$init = F5(
	function (dropdownId, items, selectedIndex, selectedItem, state) {
		return {ax: dropdownId, bp: items, a7: selectedIndex, a8: selectedItem, K: state};
	});
var $author$project$T2$Dropdown$initModel = F5(
	function (dropdownId, items, selectedIndex, selectedItem, state) {
		return A5($author$project$T2$Internal$Dropdown$init, dropdownId, items, selectedIndex, selectedItem, state);
	});
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $author$project$Page$Home$initModel = F5(
	function (windowSize, commonModel, url, navigationKey, applyScreenStep) {
		var source = function () {
			var _v3 = $author$project$Page$Home$extractSourceFromUrl(url);
			if (!_v3.$) {
				var value = _v3.a;
				return value;
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					'talenteca',
					$author$project$Page$Home$extractTkUtmSourceFromUrl(url));
			}
		}();
		var provider = A2(
			$elm$core$Maybe$withDefault,
			'talenteca',
			$author$project$Page$Home$extractProviderFromUrl(url));
		var jobAdId = $author$project$Page$Home$extractJobAdIdFromUrl(url);
		var isUploadCv = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (e) {
					return e === '000000000000000000000000';
				},
				jobAdId));
		var isDesktop = windowSize.dp > 600;
		var externalApplyRedirect = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (e) {
					return e === 'true';
				},
				$author$project$Page$Home$extractExternalRedirectFromUrl(url)));
		var _v0 = function () {
			var _v1 = $author$project$Page$Home$extractEmailFromUrl(url);
			if (!_v1.$) {
				var emailEncoded = _v1.a;
				var _v2 = $truqu$elm_base64$Base64$decode(emailEncoded);
				if (!_v2.$) {
					var emailDecoded = _v2.a;
					return _Utils_Tuple2(emailDecoded, true);
				} else {
					return _Utils_Tuple2('', false);
				}
			} else {
				return _Utils_Tuple2('', false);
			}
		}();
		var email = _v0.a;
		var isLinkToCompleteApplication = _v0.b;
		return {
			o: {
				q: {
					cS: {bI: $elm$core$Maybe$Nothing, m: $elm$core$Maybe$Nothing},
					cY: {bI: $elm$core$Maybe$Nothing, m: $elm$core$Maybe$Nothing},
					cZ: {bI: $elm$core$Maybe$Nothing, m: $elm$core$Maybe$Nothing},
					c_: {bI: $elm$core$Maybe$Nothing, m: ''},
					jY: A2(
						$elm$core$Array$repeat,
						2,
						{bI: $elm$core$Maybe$Nothing, m: ''})
				},
				ab: A5($author$project$T2$Dropdown$initModel, 'category', $author$project$Model$categoryItemsList, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, 0),
				ad: A5($author$project$T2$Dropdown$initModel, 'education_level', $author$project$Model$educationLevelItems, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, 0),
				ag: A5($author$project$T2$Dropdown$initModel, 'experience_level', $author$project$Model$experienceLevelItemsList, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, 0),
				bJ: false,
				Q: $elm$core$Maybe$Nothing
			},
			fZ: A2($elm$core$Maybe$withDefault, 0, applyScreenStep),
			x: {
				B: {ge: $elm$core$Maybe$Nothing, gl: $elm$core$Maybe$Nothing, am: '', jf: true, j9: true},
				bo: false,
				bu: false,
				aM: $elm$core$Maybe$Nothing
			},
			c: {
				w: 0,
				l: {
					gS: {bI: $elm$core$Maybe$Nothing, m: $elm$core$Maybe$Nothing},
					cl: $author$project$Model$defaultTkCommonField,
					c1: $author$project$Model$defaultTkCommonField,
					c4: $author$project$Model$defaultTkCommonField,
					cs: $author$project$Model$defaultTkLocationField,
					i6: _Utils_update(
						$author$project$Model$defaultTkCommonField,
						{cr: ''})
				},
				aj: A6($author$project$T2$Autocomplete$initAutocomplete, 'cities', $author$project$Page$Home$MsgCityAutocompleteUpdate, $author$project$Page$Home$MsgCitySelected, $author$project$Page$Home$PassThrough, false, _List_Nil),
				Y: A5($author$project$T2$Dropdown$initModel, 'country_code', _List_Nil, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, 0),
				D: false,
				bK: false,
				aA: 0,
				bV: false,
				Q: $elm$core$Maybe$Nothing
			},
			J: commonModel,
			gT: $elm$core$Maybe$Nothing,
			cX: _List_Nil,
			ak: $elm$core$Maybe$Nothing,
			ci: 0,
			cj: false,
			N: {cl: email, hl: $elm$core$Maybe$Nothing, hv: false, hz: false, d9: false},
			bk: false,
			c$: externalApplyRedirect,
			A: {fW: $elm$core$Dict$empty, bL: false, bP: 0, Q: $elm$core$Maybe$Nothing},
			ec: 0,
			ay: false,
			G: isDesktop,
			V: isLinkToCompleteApplication,
			aH: isUploadCv,
			az: _List_Nil,
			em: jobAdId,
			bM: $krisajenkins$remotedata$RemoteData$Loading,
			bq: 0,
			p: {ch: 0, E: false, ao: $elm$core$Maybe$Nothing, ah: false, ai: false, bW: false},
			n: {co: false, E: false, aX: '', aY: '', aZ: '', a_: '', a$: '', a0: '', a9: false, bA: 0},
			cv: navigationKey,
			df: provider,
			cy: commonModel.cy,
			a6: false,
			r: {
				cl: {bI: $elm$core$Maybe$Nothing, m: ''},
				av: {bI: $elm$core$Maybe$Nothing, m: ''},
				aw: {bI: $elm$core$Maybe$Nothing, m: ''},
				E: false,
				aC: {bI: $elm$core$Maybe$Nothing, m: ''},
				cC: '',
				Q: $elm$core$Maybe$Nothing,
				cD: false
			},
			bU: false,
			bv: false,
			bX: false,
			bY: false,
			W: source,
			bc: 64,
			R: url,
			bz: false,
			bC: 0,
			S: windowSize
		};
	});
var $author$project$Main$initModel = F4(
	function (theme, commonFlags, url, navigationKey) {
		var screenSize = $author$project$T2$Util$classifyScreen(commonFlags.S.dp);
		var currentRoute = $author$project$Route$fromUrl(url);
		var commonModel = $author$project$T2$Util$getCommonModel(commonFlags);
		return {
			bh: $elm$core$Maybe$Nothing,
			J: commonModel,
			U: {bT: screenSize, cF: theme, b5: commonFlags.b5, S: commonFlags.S},
			_: A5($author$project$Page$Home$initModel, commonFlags.S, commonModel, url, navigationKey, $elm$core$Maybe$Nothing),
			aI: $author$project$T2$Drawer$defaultInternalModel,
			cv: navigationKey,
			cy: commonFlags.cy,
			bS: currentRoute,
			bZ: $krisajenkins$remotedata$RemoteData$NotAsked,
			e9: {e8: false, cA: false, cB: false},
			at: {e8: false, cA: false, cB: false},
			bx: $author$project$T2$ApiModel$defaultTkNotificationsFromLocalStorage,
			aD: $author$project$T2$ToastAlerts$init,
			aO: $author$project$T2$TopBar$defaultInternalModel,
			R: url,
			bC: 0,
			S: commonFlags.S
		};
	});
var $author$project$Main$MsgHome = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Home$MsgGotCurrentYear = function (a) {
	return {$: 43, a: a};
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.dl, posixMinutes) < 0) {
					return posixMinutes + era.iW;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		dS: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		et: month,
		fw: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).fw;
	});
var $author$project$Page$Home$getCurrentYear = A2(
	$elm$core$Task$perform,
	$author$project$Page$Home$MsgGotCurrentYear,
	A3($elm$core$Task$map2, $elm$time$Time$toYear, $elm$time$Time$here, $elm$time$Time$now));
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Model$TkJobAdSummaryDo = function (id) {
	return function (isActive) {
		return function (position) {
			return function (location) {
				return function (salary) {
					return function (description) {
						return function (publishDate) {
							return function (jobAdLink) {
								return function (skillsList) {
									return function (companyName) {
										return function (recruiterId) {
											return function (recruiterPlanType) {
												return function (recruiterPlanIsPaid) {
													return function (countryCode) {
														return function (contryJsonUrl) {
															return function (externalApplyUrl) {
																return function (hostname) {
																	return function (googleClientId) {
																		return function (companyId) {
																			return {gH: companyId, gI: companyName, gO: contryJsonUrl, gT: countryCode, g$: description, g8: externalApplyUrl, hq: googleClientId, hF: hostname, ax: id, hX: isActive, ik: jobAdLink, cs: location, jb: position, ji: publishDate, jp: recruiterId, jx: recruiterPlanIsPaid, jy: recruiterPlanType, jJ: salary, dk: skillsList};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$tkJobAdSummaryJsonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'company_id',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'google_client_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hostname',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'external_apply_url',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'country_json_url',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'country_code',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'recruiter_plan_is_paid',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'recruiter_plan_type',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'recruiter_id',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'company_name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'skills_list',
											$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'job_ad_link',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'publish_date',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'description_plain_text',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'salary',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'location',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'position',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'is_active',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$elm$json$Json$Decode$string,
																			$elm$json$Json$Decode$succeed($author$project$Model$TkJobAdSummaryDo))))))))))))))))))));
var $author$project$Page$Home$MsgServerGotJobAdSummaryResponse = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $author$project$Page$Home$upgradeMsgGotJobAdInfoResult = function (result) {
	return $author$project$Page$Home$MsgServerGotJobAdSummaryResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$getJobAdSummary = function (model) {
	var _v0 = model.em;
	if (!_v0.$) {
		var jobAdId = _v0.a;
		return $elm$http$Http$riskyRequest(
			{
				bF: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(jobAdId)),
								_Utils_Tuple2(
								'source',
								$elm$json$Json$Encode$string(model.W))
							]))),
				cm: A2($elm$http$Http$expectJson, $author$project$Page$Home$upgradeMsgGotJobAdInfoResult, $author$project$Model$tkJobAdSummaryJsonDecoder),
				cp: _List_Nil,
				cu: 'POST',
				cG: $elm$core$Maybe$Just(model.J.ct),
				cH: $elm$core$Maybe$Nothing,
				R: model.J.bO + '/v1/apply/job-ad'
			});
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Page$Home$cmds = function (model) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Page$Home$getJobAdSummary(model),
				$author$project$Page$Home$getCurrentYear
			]));
};
var $author$project$Page$Home$initCmd = function (model) {
	return $author$project$Page$Home$cmds(model);
};
var $author$project$Main$initPageCmds = function (model) {
	var _v0 = model.bS;
	return A2(
		$elm$core$Platform$Cmd$map,
		$author$project$Main$MsgHome,
		$author$project$Page$Home$initCmd(model._));
};
var $author$project$Main$MsgServerSidebarMenuItemsResult = function (a) {
	return {$: 5, a: a};
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$T2$Sidebar$TkSidebarMenuItemsResponse = F5(
	function (mainMenuItems, loggedInMenuItems, footerMenuItems, accountInfo, headerSlogan) {
		return {fy: accountInfo, hg: footerMenuItems, hB: headerSlogan, iv: loggedInMenuItems, iy: mainMenuItems};
	});
var $author$project$T2$Sidebar$TkAccountInfo = F4(
	function (fullname, email, actionItems, candidateDefaultProfileIconUrl) {
		return {fA: actionItems, gf: candidateDefaultProfileIconUrl, cl: email, c1: fullname};
	});
var $author$project$T2$Sidebar$TkAccountInfoActionItem = F2(
	function (label, uri) {
		return {u: label, kJ: uri};
	});
var $author$project$T2$Sidebar$tkAccountInfoActionItemDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uri',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$T2$Sidebar$TkAccountInfoActionItem)));
var $author$project$T2$Sidebar$tkAccountInfoDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'candidate_default_profile_icon_url',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'action_items',
		$elm$json$Json$Decode$list($author$project$T2$Sidebar$tkAccountInfoActionItemDecoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'email',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'fullname',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$T2$Sidebar$TkAccountInfo)))));
var $author$project$T2$Sidebar$TkSidebarMenuItem = F4(
	function (id, label, logo, url) {
		return {ax: id, u: label, iw: logo, R: url};
	});
var $author$project$T2$Sidebar$tkSidebarMenuItemDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'logo',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'id',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$T2$Sidebar$TkSidebarMenuItem)))));
var $author$project$T2$Sidebar$tkSidebarMenuItemsResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'header_slogan',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'account_info',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$T2$Sidebar$tkAccountInfoDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'footer_menu_items',
			$elm$json$Json$Decode$list($author$project$T2$Sidebar$tkSidebarMenuItemDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'logged_in_menu_items',
				$elm$json$Json$Decode$list($author$project$T2$Sidebar$tkSidebarMenuItemDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'main_menu_items',
					$elm$json$Json$Decode$list($author$project$T2$Sidebar$tkSidebarMenuItemDecoder),
					$elm$json$Json$Decode$succeed($author$project$T2$Sidebar$TkSidebarMenuItemsResponse))))));
var $author$project$Main$fetchSidebarMenuItems = function (model) {
	var toMsgConverter = function (result) {
		return $author$project$Main$MsgServerSidebarMenuItemsResult(
			$krisajenkins$remotedata$RemoteData$fromResult(result));
	};
	var endpointUrl = A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			['v1', 'get-sidebar-items']),
		_List_Nil);
	return $elm$http$Http$riskyRequest(
		{
			bF: $elm$http$Http$emptyBody,
			cm: A2($elm$http$Http$expectJson, toMsgConverter, $author$project$T2$Sidebar$tkSidebarMenuItemsResponseDecoder),
			cp: _List_Nil,
			cu: 'POST',
			cG: $elm$core$Maybe$Just(model.J.ct),
			cH: $elm$core$Maybe$Nothing,
			R: _Utils_ap(model.J.bO, endpointUrl)
		});
};
var $author$project$T2$Util$isMediumScreenOrLarger = function (screenSize) {
	switch (screenSize) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return true;
	}
};
var $author$project$Main$sidebarMenuItemsCmd = function (model) {
	return $author$project$T2$Util$isMediumScreenOrLarger(model.U.bT) ? $author$project$Main$fetchSidebarMenuItems(model) : $elm$core$Platform$Cmd$none;
};
var $author$project$T2$Dark = 1;
var $author$project$T2$Light = 0;
var $author$project$T2$Log$warn = _Platform_outgoingPort(
	'warn',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string($.am))
				]));
	});
var $author$project$T2$Util$stringToTheme = function (themeString) {
	return (themeString === 'dark') ? _Utils_Tuple2(1, $elm$core$Platform$Cmd$none) : ((themeString === 'light') ? _Utils_Tuple2(0, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
		0,
		$author$project$T2$Log$warn(
			{am: 'Invalid theme, using default [' + (themeString + ']')})));
};
var $author$project$T2$Util$themeToString = function (theme) {
	if (!theme) {
		return 'light';
	} else {
		return 'dark';
	}
};
var $author$project$Main$PassThrough = {$: 19};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Basics$not = _Basics_not;
var $author$project$Model$removeQueryParam = F2(
	function (param, query) {
		var queryParams = function () {
			if (!query.$) {
				var queryString = query.a;
				return A2(
					$elm$core$List$filter,
					function (q) {
						return !A2($elm$core$String$startsWith, param + '=', q);
					},
					A2($elm$core$String$split, '&', queryString));
			} else {
				return _List_Nil;
			}
		}();
		return $elm$core$List$isEmpty(queryParams) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2($elm$core$String$join, '&', queryParams));
	});
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Main$trackUtmInfo = function (model) {
	var queryParamsFromUrl = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'',
		function (uq) {
			return '?' + uq;
		},
		A2($author$project$Model$removeQueryParam, 'ci', model.R.jk));
	return $elm$http$Http$riskyRequest(
		{
			bF: $elm$http$Http$emptyBody,
			cm: $elm$http$Http$expectWhatever(
				function (_v0) {
					return $author$project$Main$PassThrough;
				}),
			cp: _List_Nil,
			cu: 'POST',
			cG: $elm$core$Maybe$Just(model.J.ct),
			cH: $elm$core$Maybe$Nothing,
			R: model.J.bO + ('/v1/utm/track' + queryParamsFromUrl)
		});
};
var $author$project$T2$ThemePorts$userThemeChanged = _Platform_outgoingPort('userThemeChanged', $elm$json$Json$Encode$string);
var $author$project$Main$init = F3(
	function (commonFlags, url, navigationKey) {
		var toastAlertsFromToastAlertMessages = function (toastAlertMessages) {
			return A2(
				$elm$core$List$map,
				function (_v6) {
					var alert = _v6.b;
					var _v7 = alert.eZ;
					switch (_v7) {
						case 0:
							return A2($author$project$T2$Alert$initAlertLowSuccessMediumAutoDismissible, alert.ax, alert.b0 + (' ' + alert.am));
						case 2:
							return A2($author$project$T2$Alert$initAlertLowWarningMediumAutoDismissible, alert.ax, alert.b0 + (' ' + alert.am));
						case 3:
							return A2($author$project$T2$Alert$initAlertLowErrorMediumAutoDismissible, alert.ax, alert.b0 + (' ' + alert.am));
						default:
							return A2($author$project$T2$Alert$initAlertLowInfoMediumAutoDismissible, alert.ax, alert.b0 + (' ' + alert.am));
					}
				},
				$elm$core$Dict$toList(toastAlertMessages));
		};
		var toastAlertsFromBubbleAlertMessages = function (bubbleAlertMessages) {
			return A2(
				$elm$core$List$map,
				function (_v4) {
					var alert = _v4.b;
					var _v5 = alert.eZ;
					switch (_v5) {
						case 0:
							return A2($author$project$T2$Alert$initAlertLowSuccessMediumAutoDismissible, alert.ax, alert.am);
						case 2:
							return A2($author$project$T2$Alert$initAlertLowWarningMediumAutoDismissible, alert.ax, alert.am);
						case 3:
							return A2($author$project$T2$Alert$initAlertLowErrorMediumAutoDismissible, alert.ax, alert.am);
						default:
							return A2($author$project$T2$Alert$initAlertLowInfoMediumAutoDismissible, alert.ax, alert.am);
					}
				},
				$elm$core$Dict$toList(bubbleAlertMessages));
		};
		var createAlert = F2(
			function (newAlert, _v3) {
				var currentToastAlerts = _v3.a;
				var cmds = _v3.b;
				var _v2 = A2($author$project$T2$ToastAlerts$addAlert, newAlert, currentToastAlerts);
				var newToastAlerts = _v2.a;
				var toastCmd = _v2.b;
				return _Utils_Tuple2(
					newToastAlerts,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmds,
								A2($elm$core$Platform$Cmd$map, $author$project$Main$ToastAlertsMsg, toastCmd)
							])));
			});
		var _v0 = $author$project$T2$Util$stringToTheme(commonFlags.fg);
		var theme = _v0.a;
		var cmdThemeParsingFeedback = _v0.b;
		var cmdUserThemeChanged = $author$project$T2$ThemePorts$userThemeChanged(
			$author$project$T2$Util$themeToString(theme));
		var initialModel = A4($author$project$Main$initModel, theme, commonFlags, url, navigationKey);
		var alertsResponse = A3($author$project$T2$ApiModel$getPublicAlertMessagesToShow, initialModel.J.eP, initialModel.J.cQ, initialModel.R);
		var _v1 = A3(
			$elm$core$List$foldl,
			createAlert,
			_Utils_Tuple2(initialModel.aD, $elm$core$Platform$Cmd$none),
			_Utils_ap(
				toastAlertsFromBubbleAlertMessages(alertsResponse.gb),
				toastAlertsFromToastAlertMessages(alertsResponse.kz)));
		var toastAlerts = _v1.a;
		var toastCmds = _v1.b;
		var initialModelWithAlerts = _Utils_update(
			initialModel,
			{aD: toastAlerts});
		return _Utils_Tuple2(
			initialModelWithAlerts,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Main$sidebarMenuItemsCmd(initialModelWithAlerts),
						$author$project$Main$initPageCmds(initialModelWithAlerts),
						$author$project$Main$trackUtmInfo(initialModelWithAlerts),
						$author$project$Ports$getNotificationsFromLocalStorage(0),
						cmdThemeParsingFeedback,
						cmdUserThemeChanged,
						toastCmds,
						$author$project$Main$cmdBannerNotificationGlobalLoad(initialModelWithAlerts)
					])));
	});
var $author$project$Main$MsgChangeWindowSize = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Main$MsgGotVisualViewportHeight = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$MsgSubscriptionReceiveNotificationsFromLocalStorage = function (a) {
	return {$: 6, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {eG: pids, fc: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {dY: event, en: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.eG,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.en;
		var event = _v0.dY;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.fc);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Ports$receiveNotificationsFromLocalStorage = _Platform_incomingPort('receiveNotificationsFromLocalStorage', $elm$json$Json$Decode$value);
var $author$project$Ports$receiveVisualViewportHeight = _Platform_incomingPort('receiveVisualViewportHeight', $elm$json$Json$Decode$value);
var $author$project$Page$Home$MsgCountryDropdownClosed = {$: 116};
var $author$project$Page$Home$MsgCvFileFromCandidateApplyRead = function (a) {
	return {$: 104, a: a};
};
var $author$project$Page$Home$MsgGotGoogleSignInError = function (a) {
	return {$: 76, a: a};
};
var $author$project$Page$Home$MsgGotShowGoogleSignInButton = function (a) {
	return {$: 75, a: a};
};
var $author$project$Page$Home$MsgServerNavigateToSuccessUrl = function (a) {
	return {$: 102, a: a};
};
var $author$project$Page$Home$MsgTrackGoogleSignInButtonClick = function (a) {
	return {$: 109, a: a};
};
var $author$project$Page$Home$MsgUserPressedCancelButtonWhenUploadingCv = function (a) {
	return {$: 106, a: a};
};
var $author$project$Ports$fileContentRead = _Platform_incomingPort(
	'fileContentRead',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$json$Json$Decode$andThen,
					function (fileUrl) {
						return A2(
							$elm$json$Json$Decode$andThen,
							function (fileType) {
								return A2(
									$elm$json$Json$Decode$andThen,
									function (fileSize) {
										return A2(
											$elm$json$Json$Decode$andThen,
											function (fileName) {
												return A2(
													$elm$json$Json$Decode$andThen,
													function (contents) {
														return $elm$json$Json$Decode$succeed(
															{cV: contents, ha: fileName, hb: fileSize, d1: fileType, hc: fileUrl});
													},
													A2($elm$json$Json$Decode$field, 'contents', $elm$json$Json$Decode$string));
											},
											A2($elm$json$Json$Decode$field, 'fileName', $elm$json$Json$Decode$string));
									},
									A2($elm$json$Json$Decode$field, 'fileSize', $elm$json$Json$Decode$int));
							},
							A2($elm$json$Json$Decode$field, 'fileType', $elm$json$Json$Decode$string));
					},
					A2($elm$json$Json$Decode$field, 'fileUrl', $elm$json$Json$Decode$string)))
			])));
var $author$project$Ports$receiveGoogleSignInError = _Platform_incomingPort(
	'receiveGoogleSignInError',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$receiveGoogleSignInShowButton = _Platform_incomingPort(
	'receiveGoogleSignInShowButton',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$receiveRefreshCandidateSessionFinished = _Platform_incomingPort('receiveRefreshCandidateSessionFinished', $elm$json$Json$Decode$value);
var $author$project$T2$Internal$Autocomplete$KeyDownGrouped = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, 0, 'mousedown');
var $author$project$T2$Internal$Autocomplete$Close = {$: 2};
var $author$project$T2$Internal$Autocomplete$NoOp = {$: 8};
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $author$project$T2$Internal$Autocomplete$isInsideComponent = function (componentId) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					return (_Utils_eq(id, componentId) || (_Utils_eq(id, componentId + '-input') || _Utils_eq(id, componentId + '-menu'))) ? $elm$json$Json$Decode$succeed(true) : $elm$json$Json$Decode$fail('continue');
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
				A2(
				$elm$json$Json$Decode$andThen,
				function (_class) {
					return A2($elm$core$String$contains, 'autocomplete-item', _class) ? $elm$json$Json$Decode$succeed(true) : $elm$json$Json$Decode$fail('continue');
				},
				A2($elm$json$Json$Decode$field, 'className', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentElement',
						$author$project$T2$Internal$Autocomplete$isInsideComponent(componentId));
				}),
				$elm$json$Json$Decode$succeed(false)
			]));
};
var $author$project$T2$Internal$Autocomplete$outsideDecoder = function (componentId) {
	return A2(
		$elm$json$Json$Decode$map,
		function (isInside) {
			return isInside ? $author$project$T2$Internal$Autocomplete$NoOp : $author$project$T2$Internal$Autocomplete$Close;
		},
		A2(
			$elm$json$Json$Decode$field,
			'target',
			$author$project$T2$Internal$Autocomplete$isInsideComponent(componentId)));
};
var $author$project$T2$Internal$Autocomplete$subscriptionsGrouped = F2(
	function (model, groupedItems) {
		return model.h7 ? $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					model.aN,
					$elm$browser$Browser$Events$onMouseDown(
						$author$project$T2$Internal$Autocomplete$outsideDecoder(model.ax))),
					A2(
					$elm$core$Platform$Sub$map,
					model.aN,
					$elm$browser$Browser$Events$onKeyDown(
						A2(
							$elm$json$Json$Decode$map,
							function (k) {
								return A2($author$project$T2$Internal$Autocomplete$KeyDownGrouped, k, groupedItems);
							},
							$elm$html$Html$Events$keyCode)))
				])) : $elm$core$Platform$Sub$none;
	});
var $author$project$T2$Internal$Autocomplete$GroupedEntry = function (a) {
	return {$: 1, a: a};
};
var $author$project$T2$Internal$Autocomplete$toUngrouped = $elm$core$List$map($author$project$T2$Internal$Autocomplete$GroupedEntry);
var $author$project$T2$Internal$Autocomplete$subscriptions = function (model) {
	return A2(
		$author$project$T2$Internal$Autocomplete$subscriptionsGrouped,
		model,
		$author$project$T2$Internal$Autocomplete$toUngrouped(model.bp));
};
var $author$project$T2$Autocomplete$subscription = function (autocompleteModel) {
	return $author$project$T2$Internal$Autocomplete$subscriptions(autocompleteModel);
};
var $author$project$T2$Internal$Dropdown$Open = 1;
var $author$project$T2$Dropdown$isInsideDropdown = function (dropdownId) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					return (_Utils_eq(id, dropdownId) || _Utils_eq(id, dropdownId + '-menu')) ? $elm$json$Json$Decode$succeed(true) : $elm$json$Json$Decode$fail('continue');
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentNode',
						$author$project$T2$Dropdown$isInsideDropdown(dropdownId));
				}),
				$elm$json$Json$Decode$succeed(false)
			]));
};
var $author$project$T2$Dropdown$outsideDecoder = F3(
	function (dropdownId, noOpMsg, closeDropdownMsg) {
		return A2(
			$elm$json$Json$Decode$map,
			function (isInside) {
				return isInside ? noOpMsg : closeDropdownMsg;
			},
			A2(
				$elm$json$Json$Decode$field,
				'target',
				$author$project$T2$Dropdown$isInsideDropdown(dropdownId)));
	});
var $author$project$T2$Dropdown$subscription = F3(
	function (dropdown, noOpMsg, closeDropdownMsg) {
		return (dropdown.K === 1) ? $elm$browser$Browser$Events$onMouseDown(
			A3($author$project$T2$Dropdown$outsideDecoder, dropdown.ax, noOpMsg, closeDropdownMsg)) : $elm$core$Platform$Sub$none;
	});
var $author$project$Ports$trackGoogleSignInButtonClick = _Platform_incomingPort(
	'trackGoogleSignInButtonClick',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$userPressedCancelButtonWhenUploadingCv = _Platform_incomingPort('userPressedCancelButtonWhenUploadingCv', $elm$json$Json$Decode$bool);
var $author$project$Page$Home$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$receiveGoogleSignInShowButton($author$project$Page$Home$MsgGotShowGoogleSignInButton),
				$author$project$Ports$receiveGoogleSignInError($author$project$Page$Home$MsgGotGoogleSignInError),
				$author$project$Ports$receiveRefreshCandidateSessionFinished($author$project$Page$Home$MsgServerNavigateToSuccessUrl),
				$author$project$Ports$fileContentRead($author$project$Page$Home$MsgCvFileFromCandidateApplyRead),
				$author$project$Ports$userPressedCancelButtonWhenUploadingCv($author$project$Page$Home$MsgUserPressedCancelButtonWhenUploadingCv),
				$author$project$Ports$trackGoogleSignInButtonClick($author$project$Page$Home$MsgTrackGoogleSignInButtonClick),
				A3($author$project$T2$Dropdown$subscription, model.c.Y, $author$project$Page$Home$PassThrough, $author$project$Page$Home$MsgCountryDropdownClosed),
				$author$project$T2$Autocomplete$subscription(model.c.aj)
			]));
};
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$MsgHome,
				$author$project$Page$Home$subscriptions(model._)),
				$elm$browser$Browser$Events$onResize($author$project$Main$MsgChangeWindowSize),
				$author$project$Ports$receiveVisualViewportHeight($author$project$Main$MsgGotVisualViewportHeight),
				$author$project$Ports$receiveNotificationsFromLocalStorage($author$project$Main$MsgSubscriptionReceiveNotificationsFromLocalStorage)
			]));
};
var $author$project$T2$Banner$Warning = 1;
var $author$project$T2$ApiModel$TkApiSimpleStatusResponse = function (status) {
	return {dm: status};
};
var $author$project$T2$ApiModel$apiResponseSimpleStatusJsonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$T2$ApiModel$TkApiSimpleStatusResponse));
var $author$project$T2$Alert$mapMsg = F2(
	function (f, alert) {
		return {
			dt: A2(
				$elm$core$Maybe$map,
				function (a) {
					return {
						b: a.b,
						a: A2(
							$elm$core$Maybe$map,
							function (m) {
								return f(m);
							},
							a.a),
						u: a.u
					};
				},
				alert.dt),
			dx: alert.dx,
			dT: alert.dT,
			dV: alert.dV,
			ax: alert.ax,
			u: alert.u,
			jW: alert.jW,
			K: alert.K,
			dm: alert.dm,
			b0: alert.b0,
			fj: alert.fj
		};
	});
var $author$project$Main$doAction = F4(
	function (action, msgMapper, model, cmd) {
		var _v0 = function () {
			if (!action.$) {
				var alert = action.a;
				var newAlert = A2($author$project$T2$Alert$mapMsg, msgMapper, alert);
				var _v2 = A2($author$project$T2$ToastAlerts$addAlert, newAlert, model.aD);
				var newToastAlerts = _v2.a;
				var toastCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aD: newToastAlerts}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ToastAlertsMsg, toastCmd));
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}();
		var updatedModel = _v0.a;
		var actionCmd = _v0.b;
		return _Utils_Tuple2(
			updatedModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, actionCmd])));
	});
var $author$project$T2$Log$error = _Platform_outgoingPort(
	'error',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string($.am))
				]));
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Main$MsgSavedJobAdsSynchronizedWithLocalStorageResponse = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$getMsgSavedJobAdsSynchronizedWithLocalStorageResponseDo = function (result) {
	return $author$project$Main$MsgSavedJobAdsSynchronizedWithLocalStorageResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Ports$getVisualViewportHeight = _Platform_outgoingPort(
	'getVisualViewportHeight',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$goToTonkeanUrl = _Platform_outgoingPort('goToTonkeanUrl', $elm$json$Json$Encode$string);
var $author$project$T2$Util$httpErrorToString = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return 'BadUrl: The request is invalid for ' + url;
		case 1:
			return 'Timeout: Time out trying to reach the service, try again';
		case 2:
			return 'NetworkError: Unable to reach the service, check your network connection';
		case 3:
			var status = error.a;
			var statusString = '(HTTP ' + ($elm$core$String$fromInt(status) + ')');
			return (status === 403) ? ('Service call not allowed, check your credentials ' + statusString) : (((status >= 400) && (status <= 499)) ? ('Invalid request, verify your information and try again ' + statusString) : (((status >= 500) && (status <= 599)) ? ('The server had a problem, try again later ' + statusString) : ('Unknown service response status ' + statusString)));
		default:
			var errorMessage = error.a;
			return 'BadBody: Unable to parse the service data :: ' + errorMessage;
	}
};
var $author$project$Route$isTonkeanUrl = function (url) {
	return A2($elm$core$String$startsWith, '/', url.eD);
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Ports$scrollToChatBottom = _Platform_outgoingPort(
	'scrollToChatBottom',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$scrollToDocumentTop = _Platform_outgoingPort(
	'scrollToDocumentTop',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$setNotificationsAsSynchronizedWithLoggedInCandidate = _Platform_outgoingPort(
	'setNotificationsAsSynchronizedWithLoggedInCandidate',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Page$Home$MsgVisualViewportHeightOffsetChanged = function (a) {
	return {$: 77, a: a};
};
var $author$project$T2$Util$msgToCmd = function (msg) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return msg;
		},
		$elm$core$Task$succeed(0));
};
var $author$project$Page$Home$syncViewportHeightOffset = function (visualViewportHeightOffset) {
	return $author$project$T2$Util$msgToCmd(
		$author$project$Page$Home$MsgVisualViewportHeightOffsetChanged(visualViewportHeightOffset));
};
var $author$project$Main$syncViewportHeightOffset = F2(
	function (url, visualViewportHeightOffset) {
		var _v0 = $author$project$Route$fromUrl(url);
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Main$MsgHome,
			$author$project$Page$Home$syncViewportHeightOffset(visualViewportHeightOffset));
	});
var $author$project$Page$Home$MsgChangeWindowSize = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Home$syncWindowSize = function (windowSize) {
	return $author$project$T2$Util$msgToCmd(
		$author$project$Page$Home$MsgChangeWindowSize(windowSize));
};
var $author$project$Main$syncWindowSize = F2(
	function (url, windowSize) {
		var _v0 = $author$project$Route$fromUrl(url);
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Main$MsgHome,
			$author$project$Page$Home$syncWindowSize(windowSize));
	});
var $author$project$T2$ApiModel$TkNotificationsFromLocalStorage = F3(
	function (favorites, counterRecentNotifications, synchronizedWithLoggedInCandidate) {
		return {dL: counterRecentNotifications, c0: favorites, fd: synchronizedWithLoggedInCandidate};
	});
var $author$project$T2$ApiModel$TkFavoriteNotificationFromLocalStorage = F3(
	function (id, position, savedAtMillis) {
		return {ax: id, jb: position, jM: savedAtMillis};
	});
var $author$project$T2$ApiModel$tkFavoriteNotificationFromLocalStorageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'savedAtMillis',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'position',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$T2$ApiModel$TkFavoriteNotificationFromLocalStorage))));
var $author$project$T2$ApiModel$TkNotificationFromLocalStorage = F2(
	function (added, recentlyAdded) {
		return {fI: added, eO: recentlyAdded};
	});
var $author$project$T2$ApiModel$tkNotificationFromLocalStorageDecoder = function (decoderForSpecificNotification) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'recentlyAdded',
		$elm$json$Json$Decode$list(decoderForSpecificNotification),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'added',
			$elm$json$Json$Decode$list(decoderForSpecificNotification),
			_List_Nil,
			$elm$json$Json$Decode$succeed($author$project$T2$ApiModel$TkNotificationFromLocalStorage)));
};
var $author$project$T2$ApiModel$tkNotificationsFromLocalStorageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'synchronizedWithLoggedInCandidate',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'counterRecentNotifications',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'favorites',
			$author$project$T2$ApiModel$tkNotificationFromLocalStorageDecoder($author$project$T2$ApiModel$tkFavoriteNotificationFromLocalStorageDecoder),
			$author$project$T2$ApiModel$defaultNotificationFromLocalStorage,
			$elm$json$Json$Decode$succeed($author$project$T2$ApiModel$TkNotificationsFromLocalStorage))));
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.eN;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.d6,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.jk,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.eH,
					_Utils_ap(http, url.ed)),
				url.eD)));
};
var $elm$core$String$trim = _String_trim;
var $krisajenkins$remotedata$RemoteData$unwrap = F3(
	function (_default, _function, remoteData) {
		if (remoteData.$ === 3) {
			var data = remoteData.a;
			return _function(data);
		} else {
			return _default;
		}
	});
var $author$project$Model$ApplyQuestionsStep = 4;
var $author$project$Model$CandidateCvStep = 5;
var $author$project$Model$CandidateInfoStep = 1;
var $author$project$Model$CountryStepOptional = 3;
var $author$project$Model$EmptyScreenStep = 7;
var $author$project$Model$ExternalApplyStep = 2;
var $author$project$Model$FilterQuestionsStep = 3;
var $author$project$Model$FinalStep = 6;
var $author$project$Model$FullnameStep = 1;
var $author$project$Model$HeadlineStep = 5;
var $author$project$Model$LocationStep = 4;
var $author$project$Page$Home$MsgBrowserGetContinueWithTalentecaWidthResult = function (a) {
	return {$: 99, a: a};
};
var $author$project$Page$Home$MsgHideApplyQuestionsStageErrorMessage = {$: 53};
var $author$project$Page$Home$MsgHideCandidateCVStageErrorMessage = {$: 51};
var $author$project$Page$Home$MsgHideCandidateInfoStageErrorMessage = {$: 52};
var $author$project$Page$Home$MsgHideFilterQuestionsStageErrorMessage = {$: 29};
var $author$project$Page$Home$MsgLoadCandidateInfo = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Page$Home$MsgRedirectToExternalUrl = function (a) {
	return {$: 78, a: a};
};
var $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputFive = function (a) {
	return {$: 94, a: a};
};
var $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputFour = function (a) {
	return {$: 92, a: a};
};
var $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputSix = function (a) {
	return {$: 96, a: a};
};
var $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputThree = function (a) {
	return {$: 90, a: a};
};
var $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputTwo = function (a) {
	return {$: 88, a: a};
};
var $author$project$Page$Home$MsgUserChangedOpenFilterQuestionAnswer = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Page$Home$MsgUserClickedSendMagicLink = function (a) {
	return {$: 72, a: a};
};
var $author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton = {$: 100};
var $author$project$Page$Home$MsgUserPressedValidateMagicLinkCodeButton = {$: 98};
var $author$project$Model$NoGlobalAction = {$: 1};
var $author$project$Model$PhoneStep = 2;
var $author$project$T2$Internal$Autocomplete$ReceiveItemList = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$ShowToastAlert = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var tailLen = $elm$core$Elm$JsArray$length(tail);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.L)) - tailLen;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.L, tail);
		return (notAppended < 0) ? {
			M: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.M),
			I: builder.I + 1,
			L: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
		} : ((!notAppended) ? {
			M: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.M),
			I: builder.I + 1,
			L: $elm$core$Elm$JsArray$empty
		} : {M: builder.M, I: builder.I, L: appended});
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!value.$) {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$appendHelpTree = F2(
	function (toAppend, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		var itemsToAppend = $elm$core$Elm$JsArray$length(toAppend);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(tail)) - itemsToAppend;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, tail, toAppend);
		var newArray = A2($elm$core$Array$unsafeReplaceTail, appended, array);
		if (notAppended < 0) {
			var nextTail = A3($elm$core$Elm$JsArray$slice, notAppended, itemsToAppend, toAppend);
			return A2($elm$core$Array$unsafeReplaceTail, nextTail, newArray);
		} else {
			return newArray;
		}
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$builderFromArray = function (_v0) {
	var len = _v0.a;
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = F2(
		function (node, acc) {
			if (!node.$) {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
			} else {
				return A2($elm$core$List$cons, node, acc);
			}
		});
	return {
		M: A3($elm$core$Elm$JsArray$foldl, helper, _List_Nil, tree),
		I: (len / $elm$core$Array$branchFactor) | 0,
		L: tail
	};
};
var $elm$core$Array$append = F2(
	function (a, _v0) {
		var aTail = a.d;
		var bLen = _v0.a;
		var bTree = _v0.c;
		var bTail = _v0.d;
		if (_Utils_cmp(bLen, $elm$core$Array$branchFactor * 4) < 1) {
			var foldHelper = F2(
				function (node, array) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, array, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpTree, leaf, array);
					}
				});
			return A2(
				$elm$core$Array$appendHelpTree,
				bTail,
				A3($elm$core$Elm$JsArray$foldl, foldHelper, a, bTree));
		} else {
			var foldHelper = F2(
				function (node, builder) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, builder, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpBuilder, leaf, builder);
					}
				});
			return A2(
				$elm$core$Array$builderToArray,
				true,
				A2(
					$elm$core$Array$appendHelpBuilder,
					bTail,
					A3(
						$elm$core$Elm$JsArray$foldl,
						foldHelper,
						$elm$core$Array$builderFromArray(a),
						bTree)));
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Navigation$back = F2(
	function (key, n) {
		return A2(_Browser_go, key, -n);
	});
var $elm$browser$Browser$Dom$blur = _Browser_call('blur');
var $author$project$Model$TkApiExistingCandidateDo = F5(
	function (hasAccount, hasPassword, hasGoogleSignIn, fullName, email) {
		return {cl: email, hl: fullName, hv: hasAccount, hz: hasGoogleSignIn, d9: hasPassword};
	});
var $author$project$Model$tkApiExistingCandidateDoJsonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'full_name',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'has_google_sign_in',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'has_password',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'has_account',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$Model$TkApiExistingCandidateDo))))));
var $author$project$Page$Home$MsgServerGotCheckAcountForEmailResponse = function (a) {
	return {$: 70, a: a};
};
var $author$project$Page$Home$upgradeMsgServerGotCheckAcountForEmailResponse = function (result) {
	return $author$project$Page$Home$MsgServerGotCheckAcountForEmailResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$checkAccountForEmail = F2(
	function (model, email) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'source',
					$elm$json$Json$Encode$string(model.W))
				]));
		return $elm$http$Http$riskyRequest(
			{
				bF: $elm$http$Http$jsonBody(body),
				cm: A2($elm$http$Http$expectJson, $author$project$Page$Home$upgradeMsgServerGotCheckAcountForEmailResponse, $author$project$Model$tkApiExistingCandidateDoJsonDecoder),
				cp: _List_Nil,
				cu: 'POST',
				cG: $elm$core$Maybe$Just(model.J.ct),
				cH: $elm$core$Maybe$Nothing,
				R: model.J.bO + '/v1/apply/check-existing-account'
			});
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$String$toUpper = _String_toUpper;
var $elm_community$string_extra$String$Extra$camelize = function (string) {
	return A3(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('[-_\\s]+(.)?'),
		function (_v0) {
			var submatches = _v0.j8;
			if (submatches.b && (!submatches.a.$)) {
				var match = submatches.a.a;
				return $elm$core$String$toUpper(match);
			} else {
				return '';
			}
		},
		$elm$core$String$trim(string));
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $elm_community$string_extra$String$Extra$classify = function (string) {
	return $elm_community$string_extra$String$Extra$toSentenceCase(
		A3(
			$elm$core$String$replace,
			' ',
			'',
			$elm_community$string_extra$String$Extra$camelize(
				A3(
					$elm$regex$Regex$replace,
					$elm_community$string_extra$String$Extra$regexFromString('[\\W_]'),
					$elm$core$Basics$always(' '),
					string))));
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $author$project$T2$ApiModel$cvFileTypeAccepted = _List_fromArray(
	['application/pdf', 'application/x-pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-word.document.12', 'application/vnd.oasis.opendocument.text', 'application/rtf']);
var $author$project$Page$Home$cvInputFieldIdForApply = 'CvInputFieldIdForApply';
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Page$Home$delayHideNotification = function (msg) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return msg;
		},
		$elm$core$Process$sleep(5000));
};
var $elm$file$File$Download$url = function (href) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$never,
		_File_downloadUrl(href));
};
var $author$project$Page$Home$downloadCV = function (link) {
	return $elm$file$File$Download$url(link);
};
var $author$project$Page$Home$extractCurrentApplyFromUrl = function (url) {
	return A2($author$project$T2$Util$extractSearchArgument, 'ci', url);
};
var $elm$core$String$toLower = _String_toLower;
var $author$project$Page$Home$extractStageFromUrl = function (url) {
	return A2(
		$elm$core$Maybe$map,
		function (stage) {
			var _v0 = $elm$core$String$toLower(stage);
			switch (_v0) {
				case 'filterquestions':
					return 3;
				case 'applyquestions':
					return 4;
				case 'candidatecv':
					return 5;
				case 'complete':
					return 5;
				default:
					return 1;
			}
		},
		A2($author$project$T2$Util$extractSearchArgument, 'stage', url));
};
var $author$project$Ports$fileSelected = _Platform_outgoingPort('fileSelected', $elm$json$Json$Encode$string);
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{M: nodeList, I: nodeListSize, L: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Page$Home$MsgServerSendCountriesListResult = function (a) {
	return {$: 113, a: a};
};
var $author$project$Page$Home$msgGotCountriesResponse = function (result) {
	return $author$project$Page$Home$MsgServerSendCountriesListResult(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Model$TkCountriesDo = F2(
	function (value, text) {
		return {s: text, m: value};
	});
var $author$project$Model$tkCountriesDoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'text',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$TkCountriesDo)));
var $author$project$Page$Home$getCountries = function (model) {
	return $elm$http$Http$riskyRequest(
		{
			bF: $elm$http$Http$emptyBody,
			cm: A2(
				$elm$http$Http$expectJson,
				$author$project$Page$Home$msgGotCountriesResponse,
				$elm$json$Json$Decode$list($author$project$Model$tkCountriesDoDecoder)),
			cp: _List_Nil,
			cu: 'GET',
			cG: $elm$core$Maybe$Just(model.J.ct),
			cH: $elm$core$Maybe$Nothing,
			R: model.J.iA + '/country/all'
		});
};
var $author$project$Model$TkApiCandidateApplyInfoDo = function (email) {
	return function (fullname) {
		return function (phoneNumber) {
			return function (location) {
				return function (headline) {
					return function (category) {
						return function (experienceLevel) {
							return function (educationLevel) {
								return function (experienceYears) {
									return function (skillsList) {
										return function (privateCv) {
											return function (attachmentPath) {
												return function (attachmentHash) {
													return function (mimeType) {
														return function (cvDownloadLink) {
															return function (candidateAlreadyApplied) {
																return function (countryCode) {
																	return function (message) {
																		return function (isCurrentCvFromProfile) {
																			return function (cvCreatedAtHumanReadable) {
																				return {cM: attachmentHash, cN: attachmentPath, dD: candidateAlreadyApplied, cS: category, gT: countryCode, dQ: cvCreatedAtHumanReadable, dR: cvDownloadLink, cY: educationLevel, cl: email, cZ: experienceLevel, c_: experienceYears, c1: fullname, c4: headline, ej: isCurrentCvFromProfile, cs: location, am: message, c9: mimeType, eF: phoneNumber, eI: privateCv, dk: skillsList};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$TkApplyCandidateLocationDo = F5(
	function (displayName, cityName, cityId, regionName, regionId) {
		return {dI: cityId, dJ: cityName, dU: displayName, eR: regionId, eS: regionName};
	});
var $author$project$Model$tkApplyCandidateLocationDoJsonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'region_id',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'region_name',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'city_id',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'city_name',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'display_name',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					$elm$json$Json$Decode$succeed($author$project$Model$TkApplyCandidateLocationDo))))));
var $author$project$Model$tkApiCandidateApplyInfoDoJsonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'cv_created_at_human_readable',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_current_cv_from_profile',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'message',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'country_code',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'candidate_already_applied',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'cv_download_link',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'mime_type',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'attachment_hash',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'attachment_path',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'private_cv',
										$elm$json$Json$Decode$bool,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'skills_list',
											A2(
												$elm$json$Json$Decode$map,
												$elm$core$Maybe$Just,
												$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'experience_years',
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'education_level',
													A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'experience_level',
														A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'category',
															A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
															$elm$core$Maybe$Nothing,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'headline',
																A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																$elm$core$Maybe$Nothing,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'location',
																	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Model$tkApplyCandidateLocationDoJsonDecoder),
																	$elm$core$Maybe$Nothing,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'phone_number',
																		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																		$elm$core$Maybe$Nothing,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'full_name',
																			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																			$elm$core$Maybe$Nothing,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'email',
																				$elm$json$Json$Decode$string,
																				$elm$json$Json$Decode$succeed($author$project$Model$TkApiCandidateApplyInfoDo)))))))))))))))))))));
var $author$project$Page$Home$MsgServerGotCurrentCandidateApplyInfoResponse = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Home$upgradeMsgGotCurrentCandidateApplyInfoResult = F2(
	function (jobAdSummaryDo, result) {
		return A2(
			$author$project$Page$Home$MsgServerGotCurrentCandidateApplyInfoResponse,
			jobAdSummaryDo,
			$krisajenkins$remotedata$RemoteData$fromResult(result));
	});
var $author$project$Page$Home$getCurrentCandidateApplyInfo = F2(
	function (model, jobAdSummaryDo) {
		var _v0 = model.em;
		if (!_v0.$) {
			var jobAdId = _v0.a;
			return $elm$http$Http$riskyRequest(
				{
					bF: $elm$http$Http$jsonBody(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'job_ad_id',
									$elm$json$Json$Encode$string(jobAdId)),
									_Utils_Tuple2(
									'source',
									$elm$json$Json$Encode$string(model.W))
								]))),
					cm: A2(
						$elm$http$Http$expectJson,
						$author$project$Page$Home$upgradeMsgGotCurrentCandidateApplyInfoResult(jobAdSummaryDo),
						$author$project$Model$tkApiCandidateApplyInfoDoJsonDecoder),
					cp: _List_Nil,
					cu: 'POST',
					cG: $elm$core$Maybe$Just(model.J.ct),
					cH: $elm$core$Maybe$Nothing,
					R: model.J.bO + '/v1/apply/current-candidate'
				});
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$Page$Home$validateFullname = function (fullname) {
	var isValid = function () {
		if (fullname === '') {
			return false;
		} else {
			var validateTwoFirstWords = F2(
				function (n1, n2) {
					return ($elm$core$String$length(n1) >= 2) && ($elm$core$String$length(n2) >= 2);
				});
			var fullNameSpplited = A2($elm$core$String$split, ' ', fullname);
			if (fullNameSpplited.b && fullNameSpplited.b.b) {
				var n1 = fullNameSpplited.a;
				var _v1 = fullNameSpplited.b;
				var n2 = _v1.a;
				return A2(validateTwoFirstWords, n1, n2);
			} else {
				return false;
			}
		}
	}();
	return isValid ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Por favor ingresa un nombre y apellido válido');
};
var $author$project$Page$Home$getFullnameSubmittedAndValidatedModel = function (model) {
	var loginModel = model.p;
	var currentCandidateInfoStageModel = model.c;
	var currentApplyInfo = currentCandidateInfoStageModel.l;
	var currentFullnameField = currentApplyInfo.c1;
	var fullnameProcessed = $elm$core$String$trim(currentFullnameField.cr);
	var fullnameError = $author$project$Page$Home$validateFullname(fullnameProcessed);
	var newActiveQuestion = _Utils_eq(fullnameError, $elm$core$Maybe$Nothing) ? (currentCandidateInfoStageModel.D ? currentCandidateInfoStageModel.aA : 2) : currentCandidateInfoStageModel.w;
	var newIsEditingQuestion = _Utils_eq(fullnameError, $elm$core$Maybe$Nothing) ? false : currentCandidateInfoStageModel.D;
	var newFullnameField = _Utils_update(
		currentFullnameField,
		{bI: fullnameError, cn: true, cr: fullnameProcessed});
	var newFullnameFieldWithValue = _Utils_eq(fullnameError, $elm$core$Maybe$Nothing) ? _Utils_update(
		newFullnameField,
		{
			m: $elm$core$Maybe$Just(fullnameProcessed)
		}) : newFullnameField;
	var newModel = _Utils_update(
		model,
		{
			c: _Utils_update(
				currentCandidateInfoStageModel,
				{
					w: newActiveQuestion,
					l: _Utils_update(
						currentApplyInfo,
						{c1: newFullnameFieldWithValue}),
					D: newIsEditingQuestion
				})
		});
	var newModelWithNextStep = _Utils_eq(fullnameError, $elm$core$Maybe$Nothing) ? _Utils_update(
		newModel,
		{
			fZ: 7,
			p: _Utils_update(
				loginModel,
				{ah: model.N.hv, ai: false})
		}) : newModel;
	return newModelWithNextStep;
};
var $author$project$Page$Home$validateHeadline = function (headline) {
	return (headline === '') ? $elm$core$Maybe$Just('Por favor ingresa tu perfil profesional') : (($elm$core$String$length(headline) > 75) ? $elm$core$Maybe$Just('Por favor ingresa menos de 75 letras') : $elm$core$Maybe$Nothing);
};
var $author$project$Page$Home$getHeadlineSubmittedAndValidatedModel = function (model) {
	var currentCandidateInfoStageModel = model.c;
	var currentApplyInfo = currentCandidateInfoStageModel.l;
	var currentHeadlineField = currentApplyInfo.c4;
	var headlineProcessed = $elm$core$String$trim(currentHeadlineField.cr);
	var headlineError = $author$project$Page$Home$validateHeadline(headlineProcessed);
	var newActiveQuestion = _Utils_eq(headlineError, $elm$core$Maybe$Nothing) ? (currentCandidateInfoStageModel.D ? currentCandidateInfoStageModel.aA : 6) : currentCandidateInfoStageModel.w;
	var newIsEditingQuestion = _Utils_eq(headlineError, $elm$core$Maybe$Nothing) ? false : currentCandidateInfoStageModel.D;
	var newHeadlineField = _Utils_update(
		currentHeadlineField,
		{bI: headlineError, cn: true, cr: headlineProcessed});
	var newHeadlineFieldWithValue = _Utils_eq(headlineError, $elm$core$Maybe$Nothing) ? _Utils_update(
		newHeadlineField,
		{
			m: $elm$core$Maybe$Just(headlineProcessed)
		}) : newHeadlineField;
	var newModel = _Utils_update(
		model,
		{
			c: _Utils_update(
				currentCandidateInfoStageModel,
				{
					w: newActiveQuestion,
					l: _Utils_update(
						currentApplyInfo,
						{c4: newHeadlineFieldWithValue}),
					D: newIsEditingQuestion
				})
		});
	var newModelWithNextStep = _Utils_eq(headlineError, $elm$core$Maybe$Nothing) ? _Utils_update(
		newModel,
		{fZ: 7}) : newModel;
	return newModelWithNextStep;
};
var $author$project$Model$TkJobAdFilterQuestion = F6(
	function (id, typeQuestion, titleQuestion, answersList, openAnswerMaxCharacters, openAnswerMinCharacters) {
		return {fW: answersList, ax: id, i1: openAnswerMaxCharacters, i2: openAnswerMinCharacters, kw: titleQuestion, kG: typeQuestion};
	});
var $author$project$Model$TkJobAdFilterQuestionAnswerOptions = function (titleAnswer) {
	return {kv: titleAnswer};
};
var $author$project$Model$tkJobAdFilterQuestionAnswerOptionsJsonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'title_answer',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$TkJobAdFilterQuestionAnswerOptions));
var $author$project$Model$tkJobAdFilterQuestionJsonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'open_answer_min_characters',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'open_answer_max_characters',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'answers_list',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				$elm$json$Json$Decode$list($author$project$Model$tkJobAdFilterQuestionAnswerOptionsJsonDecoder)),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title_question',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type_question',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$TkJobAdFilterQuestion)))))));
var $author$project$Model$tkJobAdFilterQuestionListJsonDecoder = $elm$json$Json$Decode$list($author$project$Model$tkJobAdFilterQuestionJsonDecoder);
var $author$project$Page$Home$MsgServerGotJobAdFilterQuestionsResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Home$upgradeMsgGotJobAdFilterQuestionsResult = function (result) {
	return $author$project$Page$Home$MsgServerGotJobAdFilterQuestionsResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$getJobAdFilterQuestions = function (model) {
	var _v0 = model.em;
	if (!_v0.$) {
		var jobAdId = _v0.a;
		return $elm$http$Http$riskyRequest(
			{
				bF: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'job_ad_id',
								$elm$json$Json$Encode$string(jobAdId))
							]))),
				cm: A2($elm$http$Http$expectJson, $author$project$Page$Home$upgradeMsgGotJobAdFilterQuestionsResult, $author$project$Model$tkJobAdFilterQuestionListJsonDecoder),
				cp: _List_Nil,
				cu: 'POST',
				cG: $elm$core$Maybe$Just(model.J.ct),
				cH: $elm$core$Maybe$Nothing,
				R: model.J.bO + '/v1/job-ad/filter-questions'
			});
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Page$Home$getLocationSubmittedAndValidatedModel = function (model) {
	var currentCandidateInfoStageModel = model.c;
	var currentApplyInfo = currentCandidateInfoStageModel.l;
	var currentLocationField = currentApplyInfo.cs;
	var locationError = ($elm$core$String$trim(currentLocationField.cr) === '') ? $elm$core$Maybe$Just('Por favor ingresa el lugar donde vives') : $elm$core$Maybe$Nothing;
	var newActiveQuestion = _Utils_eq(locationError, $elm$core$Maybe$Nothing) ? (currentCandidateInfoStageModel.D ? currentCandidateInfoStageModel.aA : 5) : currentCandidateInfoStageModel.w;
	var newIsEditingQuestion = _Utils_eq(locationError, $elm$core$Maybe$Nothing) ? false : currentCandidateInfoStageModel.D;
	var newLocationField = _Utils_update(
		currentLocationField,
		{bI: locationError, cn: true, cr: currentLocationField.cr});
	var newLocationFieldWithValue = _Utils_eq(locationError, $elm$core$Maybe$Nothing) ? _Utils_update(
		newLocationField,
		{
			m: $elm$core$Maybe$Just(currentLocationField.cr)
		}) : newLocationField;
	var newModel = _Utils_update(
		model,
		{
			c: _Utils_update(
				currentCandidateInfoStageModel,
				{
					w: newActiveQuestion,
					l: _Utils_update(
						currentApplyInfo,
						{cs: newLocationFieldWithValue}),
					D: newIsEditingQuestion
				})
		});
	return newModel;
};
var $author$project$Page$Home$validatePhone = F2(
	function (phone, countryCode) {
		if (phone === '') {
			return $elm$core$Maybe$Just('Por favor ingresa un número celular válido');
		} else {
			if (countryCode === 'mx') {
				var phoneRegex = A2(
					$elm$core$Maybe$withDefault,
					$elm$regex$Regex$never,
					$elm$regex$Regex$fromString('^([0-9]|\\+)[0-9]{9,12}$'));
				return A2($elm$regex$Regex$contains, phoneRegex, phone) ? (A2($elm$core$String$startsWith, '+52', phone) ? (($elm$core$String$length(phone) === 13) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Por favor ingresa 10 dígitos además del código de país')) : (($elm$core$String$length(phone) === 10) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Por favor ingresa 10 dígitos'))) : $elm$core$Maybe$Just('Por favor incluye 10 dígitos sin guiones ni caracteres especiales');
			} else {
				var phoneRegex = A2(
					$elm$core$Maybe$withDefault,
					$elm$regex$Regex$never,
					$elm$regex$Regex$fromString('^([0-9]|\\+)[0-9]*$'));
				return A2($elm$regex$Regex$contains, phoneRegex, phone) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Por favor ingresa un número celular válido');
			}
		}
	});
var $author$project$Page$Home$getPhoneSubmittedAndValidatedModel = F2(
	function (model, jobAdSummaryDo) {
		var removeWhiteSpacesRegex = '\\s';
		var currentCandidateInfoStageModel = model.c;
		var currentApplyInfo = currentCandidateInfoStageModel.l;
		var currentPhoneField = currentApplyInfo.i6;
		var phoneProcessed = function () {
			var _v0 = $elm$regex$Regex$fromString(removeWhiteSpacesRegex);
			if (_v0.$ === 1) {
				return $elm$core$String$trim(currentPhoneField.cr);
			} else {
				var regex = _v0.a;
				return $elm$core$String$trim(
					A3(
						$elm$regex$Regex$replace,
						regex,
						function (_v1) {
							return '';
						},
						currentPhoneField.cr));
			}
		}();
		var phoneError = A2($author$project$Page$Home$validatePhone, phoneProcessed, jobAdSummaryDo.gT);
		var newActiveQuestion = _Utils_eq(phoneError, $elm$core$Maybe$Nothing) ? (currentCandidateInfoStageModel.D ? currentCandidateInfoStageModel.aA : 4) : currentCandidateInfoStageModel.w;
		var newIsEditingQuestion = _Utils_eq(phoneError, $elm$core$Maybe$Nothing) ? false : currentCandidateInfoStageModel.D;
		var newPhoneField = _Utils_update(
			currentPhoneField,
			{bI: phoneError, cn: true, cr: phoneProcessed});
		var newPhoneFieldWithValue = _Utils_eq(phoneError, $elm$core$Maybe$Nothing) ? _Utils_update(
			newPhoneField,
			{
				m: $elm$core$Maybe$Just(phoneProcessed)
			}) : newPhoneField;
		var newModel = _Utils_update(
			model,
			{
				c: _Utils_update(
					currentCandidateInfoStageModel,
					{
						w: newActiveQuestion,
						l: _Utils_update(
							currentApplyInfo,
							{i6: newPhoneFieldWithValue}),
						D: newIsEditingQuestion
					})
			});
		var newModelWithNextStep = _Utils_eq(phoneError, $elm$core$Maybe$Nothing) ? _Utils_update(
			newModel,
			{fZ: 7}) : newModel;
		return newModelWithNextStep;
	});
var $author$project$T2$Util$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map = F2(
	function (func, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = function (node) {
			if (!node.$) {
				var subTree = node.a;
				return $elm$core$Array$SubTree(
					A2($elm$core$Elm$JsArray$map, helper, subTree));
			} else {
				var values = node.a;
				return $elm$core$Array$Leaf(
					A2($elm$core$Elm$JsArray$map, func, values));
			}
		};
		return A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A2($elm$core$Elm$JsArray$map, helper, tree),
			A2($elm$core$Elm$JsArray$map, func, tail));
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $author$project$Ports$redirectoToExternalUrl = _Platform_outgoingPort(
	'redirectoToExternalUrl',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'externalApplyUrl',
					$elm$json$Json$Encode$string($.g8))
				]));
	});
var $author$project$Ports$refreshCandidateSession = _Platform_outgoingPort(
	'refreshCandidateSession',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'successUrl',
					$elm$json$Json$Encode$string($.kd))
				]));
	});
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm_community$string_extra$String$Extra$accentRegex = function () {
	var matches = _List_fromArray(
		[
			_Utils_Tuple2('[à-æ]', 'a'),
			_Utils_Tuple2('[À-Æ]', 'A'),
			_Utils_Tuple2('ç', 'c'),
			_Utils_Tuple2('Ç', 'C'),
			_Utils_Tuple2('[è-ë]', 'e'),
			_Utils_Tuple2('[È-Ë]', 'E'),
			_Utils_Tuple2('[ì-ï]', 'i'),
			_Utils_Tuple2('[Ì-Ï]', 'I'),
			_Utils_Tuple2('ñ', 'n'),
			_Utils_Tuple2('Ñ', 'N'),
			_Utils_Tuple2('[ò-ö]', 'o'),
			_Utils_Tuple2('[Ò-Ö]', 'O'),
			_Utils_Tuple2('[ù-ü]', 'u'),
			_Utils_Tuple2('[Ù-Ü]', 'U'),
			_Utils_Tuple2('ý', 'y'),
			_Utils_Tuple2('ÿ', 'y'),
			_Utils_Tuple2('Ý', 'Y')
		]);
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$mapFirst($elm_community$string_extra$String$Extra$regexFromString),
		matches);
}();
var $elm_community$string_extra$String$Extra$removeAccents = function (string) {
	if ($elm$core$String$isEmpty(string)) {
		return string;
	} else {
		var do_regex_to_remove_acents = function (_v1) {
			var regex = _v1.a;
			var replace_character = _v1.b;
			return A2(
				$elm$regex$Regex$replace,
				regex,
				function (_v0) {
					return replace_character;
				});
		};
		return A3($elm$core$List$foldl, do_regex_to_remove_acents, string, $elm_community$string_extra$String$Extra$accentRegex);
	}
};
var $author$project$Ports$removeGoogleSignInButton = _Platform_outgoingPort(
	'removeGoogleSignInButton',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$renderGoogleSignInButton = _Platform_outgoingPort(
	'renderGoogleSignInButton',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'googleClientId',
					$elm$json$Json$Encode$string($.hq))
				]));
	});
var $author$project$Ports$saveJobAdAsFavoriteFromLocalStorage = _Platform_outgoingPort(
	'saveJobAdAsFavoriteFromLocalStorage',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Page$Home$MsgServerGotSavedJobAdResponse = F3(
	function (a, b, c) {
		return {$: 111, a: a, b: b, c: c};
	});
var $author$project$Page$Home$upgradeMsgServerGotSavedJobAdResponse = F3(
	function (jobAdId, position, result) {
		return A3(
			$author$project$Page$Home$MsgServerGotSavedJobAdResponse,
			jobAdId,
			position,
			$krisajenkins$remotedata$RemoteData$fromResult(result));
	});
var $author$project$Page$Home$saveJobAdAsFavorite = F2(
	function (model, position) {
		var _v0 = model.em;
		if (!_v0.$) {
			var jobAdId = _v0.a;
			var candidateIsLoggedIn = model.J.cQ.dF;
			var body = $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'job_ad_id',
						$elm$json$Json$Encode$string(jobAdId)),
						_Utils_Tuple2(
						'source',
						$elm$json$Json$Encode$string('new-apply'))
					]));
			return candidateIsLoggedIn ? _Utils_Tuple3(
				model,
				$elm$http$Http$riskyRequest(
					{
						bF: $elm$http$Http$jsonBody(body),
						cm: A2(
							$elm$http$Http$expectJson,
							A2($author$project$Page$Home$upgradeMsgServerGotSavedJobAdResponse, jobAdId, position),
							$author$project$T2$ApiModel$apiResponseSimpleStatusJsonDecoder),
						cp: _List_Nil,
						cu: 'POST',
						cG: $elm$core$Maybe$Just(model.J.ct),
						cH: $elm$core$Maybe$Nothing,
						R: model.J.bO + '/v1/candidate/save-job-ad'
					}),
				$author$project$Model$NoGlobalAction) : _Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Ports$saveJobAdAsFavoriteFromLocalStorage(
							_Utils_Tuple2(jobAdId, position))
						])),
				$author$project$Model$ShowToastAlert(
					A2($author$project$T2$Alert$initAlertLowSuccessMediumAutoDismissible, 'save-job-ad-ok', 'Vacante añadida como favorita')));
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
		}
	});
var $author$project$Ports$scrollToChatTop = _Platform_outgoingPort(
	'scrollToChatTop',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Model$TkMagicLinkLoginResponseDo = F4(
	function (status, candidateFullname, candidateEmailHint, hasPassword) {
		return {gg: candidateEmailHint, gh: candidateFullname, d9: hasPassword, dm: status};
	});
var $author$project$Model$tkMagicLinkLoginResponseDoJsonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'has_password',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'candidate_email_hint',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'candidate_fullname',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$TkMagicLinkLoginResponseDo)))));
var $author$project$Page$Home$MsgServerGotMagicLinkResponse = function (a) {
	return {$: 73, a: a};
};
var $author$project$Page$Home$upgradeMsgServerGotMagicLinkResponse = function (result) {
	return $author$project$Page$Home$MsgServerGotMagicLinkResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$sendMagicLinkLogin = F2(
	function (model, email) {
		var minimized = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (m) {
					return m === 'true';
				},
				A2($author$project$T2$Util$extractSearchArgument, 'minimized', model.R)));
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'resume_link',
					$elm$json$Json$Encode$string(
						$elm$url$Url$toString(model.R))),
					_Utils_Tuple2(
					'minimized',
					$elm$json$Json$Encode$bool(minimized))
				]));
		return $elm$http$Http$riskyRequest(
			{
				bF: $elm$http$Http$jsonBody(body),
				cm: A2($elm$http$Http$expectJson, $author$project$Page$Home$upgradeMsgServerGotMagicLinkResponse, $author$project$Model$tkMagicLinkLoginResponseDoJsonDecoder),
				cp: _List_Nil,
				cu: 'POST',
				cG: $elm$core$Maybe$Just(model.J.ct),
				cH: $elm$core$Maybe$Nothing,
				R: model.J.bO + '/v1/candidate/auth/digits/request-by-email'
			});
	});
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $author$project$Page$Home$MsgServerGotSendToFriendSavedResponse = function (a) {
	return {$: 69, a: a};
};
var $author$project$Page$Home$upgradeMsgServerGotSendToFriendSentResponse = function (result) {
	return $author$project$Page$Home$MsgServerGotSendToFriendSavedResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$sendSendToFriendForm = function (model) {
	var _v0 = model.em;
	if (!_v0.$) {
		var jobAdId = _v0.a;
		var sendToFriendModel = model.r;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'job_ad_id',
					$elm$json$Json$Encode$string(jobAdId)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(sendToFriendModel.cl.m)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(sendToFriendModel.aC.m)),
					_Utils_Tuple2(
					'friend_email',
					$elm$json$Json$Encode$string(sendToFriendModel.av.m)),
					_Utils_Tuple2(
					'friend_name',
					$elm$json$Json$Encode$string(sendToFriendModel.aw.m)),
					_Utils_Tuple2(
					'spam_control',
					$elm$json$Json$Encode$string(sendToFriendModel.cC))
				]));
		return $elm$http$Http$riskyRequest(
			{
				bF: $elm$http$Http$jsonBody(body),
				cm: $elm$http$Http$expectString($author$project$Page$Home$upgradeMsgServerGotSendToFriendSentResponse),
				cp: _List_Nil,
				cu: 'POST',
				cG: $elm$core$Maybe$Just(model.J.ct),
				cH: $elm$core$Maybe$Nothing,
				R: model.J.bO + '/v1/job-ad/send-to-a-friend'
			});
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$Array$sliceLeft = F2(
	function (from, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		if (!from) {
			return array;
		} else {
			if (_Utils_cmp(
				from,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					len - from,
					$elm$core$Array$shiftStep,
					$elm$core$Elm$JsArray$empty,
					A3(
						$elm$core$Elm$JsArray$slice,
						from - $elm$core$Array$tailIndex(len),
						$elm$core$Elm$JsArray$length(tail),
						tail));
			} else {
				var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
				var helper = F2(
					function (node, acc) {
						if (!node.$) {
							var subTree = node.a;
							return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
						} else {
							var leaf = node.a;
							return A2($elm$core$List$cons, leaf, acc);
						}
					});
				var leafNodes = A3(
					$elm$core$Elm$JsArray$foldr,
					helper,
					_List_fromArray(
						[tail]),
					tree);
				var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);
				if (!nodesToInsert.b) {
					return $elm$core$Array$empty;
				} else {
					var head = nodesToInsert.a;
					var rest = nodesToInsert.b;
					var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
					var initialBuilder = {
						M: _List_Nil,
						I: 0,
						L: A3(
							$elm$core$Elm$JsArray$slice,
							firstSlice,
							$elm$core$Elm$JsArray$length(head),
							head)
					};
					return A2(
						$elm$core$Array$builderToArray,
						true,
						A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
				}
			}
		}
	});
var $elm$core$Array$fetchNewTail = F4(
	function (shift, end, treeEnd, tree) {
		fetchNewTail:
		while (true) {
			var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var sub = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$end = end,
					$temp$treeEnd = treeEnd,
					$temp$tree = sub;
				shift = $temp$shift;
				end = $temp$end;
				treeEnd = $temp$treeEnd;
				tree = $temp$tree;
				continue fetchNewTail;
			} else {
				var values = _v0.a;
				return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
			}
		}
	});
var $elm$core$Array$hoistTree = F3(
	function (oldShift, newShift, tree) {
		hoistTree:
		while (true) {
			if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
				return tree;
			} else {
				var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
				if (!_v0.$) {
					var sub = _v0.a;
					var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
						$temp$newShift = newShift,
						$temp$tree = sub;
					oldShift = $temp$oldShift;
					newShift = $temp$newShift;
					tree = $temp$tree;
					continue hoistTree;
				} else {
					return tree;
				}
			}
		}
	});
var $elm$core$Array$sliceTree = F3(
	function (shift, endIdx, tree) {
		var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
		if (!_v0.$) {
			var sub = _v0.a;
			var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
			return (!$elm$core$Elm$JsArray$length(newSub)) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
				$elm$core$Elm$JsArray$unsafeSet,
				lastPos,
				$elm$core$Array$SubTree(newSub),
				A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
		} else {
			return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
		}
	});
var $elm$core$Array$sliceRight = F2(
	function (end, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		if (_Utils_eq(end, len)) {
			return array;
		} else {
			if (_Utils_cmp(
				end,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					startShift,
					tree,
					A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
			} else {
				var endIdx = $elm$core$Array$tailIndex(end);
				var depth = $elm$core$Basics$floor(
					A2(
						$elm$core$Basics$logBase,
						$elm$core$Array$branchFactor,
						A2($elm$core$Basics$max, 1, endIdx - 1)));
				var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					newShift,
					A3(
						$elm$core$Array$hoistTree,
						startShift,
						newShift,
						A3($elm$core$Array$sliceTree, startShift, endIdx, tree)),
					A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
			}
		}
	});
var $elm$core$Array$translateIndex = F2(
	function (index, _v0) {
		var len = _v0.a;
		var posIndex = (index < 0) ? (len + index) : index;
		return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
	});
var $elm$core$Array$slice = F3(
	function (from, to, array) {
		var correctTo = A2($elm$core$Array$translateIndex, to, array);
		var correctFrom = A2($elm$core$Array$translateIndex, from, array);
		return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : A2(
			$elm$core$Array$sliceLeft,
			correctFrom,
			A2($elm$core$Array$sliceRight, correctTo, array));
	});
var $author$project$Page$Home$MsgServerApplyQuestionsSavedResponse = function (a) {
	return {$: 45, a: a};
};
var $author$project$Page$Home$upgradeMsgServerApplyQuestionsSavedResponse = function (result) {
	return $author$project$Page$Home$MsgServerApplyQuestionsSavedResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$submitApplyQuestions = function (model) {
	var _v0 = model.em;
	if (!_v0.$) {
		var jobAdId = _v0.a;
		var candidateInfoDo = model.c.l;
		var applyQuestionsDo = model.o.q;
		var body = $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'job_ad_id',
						$elm$json$Json$Encode$string(jobAdId)),
						_Utils_Tuple2(
						'source',
						$elm$json$Json$Encode$string(model.W)),
						_Utils_Tuple2(
						'experience_years',
						$elm$json$Json$Encode$string(applyQuestionsDo.c_.m)),
						_Utils_Tuple2(
						'skills_list',
						A2(
							$elm$json$Json$Encode$list,
							$elm$json$Json$Encode$string,
							$elm$core$Array$toList(
								A2(
									$elm$core$Array$map,
									function ($) {
										return $.m;
									},
									applyQuestionsDo.jY))))
					]),
				_Utils_ap(
					function () {
						var _v1 = candidateInfoDo.cl.m;
						if (!_v1.$) {
							var email = _v1.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(email))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v2 = applyQuestionsDo.cS.m;
							if (!_v2.$) {
								var category = _v2.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'category',
										$elm$json$Json$Encode$string(category.m))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						_Utils_ap(
							function () {
								var _v3 = applyQuestionsDo.cZ.m;
								if (!_v3.$) {
									var experience = _v3.a;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'experience_level',
											$elm$json$Json$Encode$string(experience.m))
										]);
								} else {
									return _List_Nil;
								}
							}(),
							function () {
								var _v4 = applyQuestionsDo.cY.m;
								if (!_v4.$) {
									var educationLevel = _v4.a;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'education_level',
											$elm$json$Json$Encode$string(educationLevel.m))
										]);
								} else {
									return _List_Nil;
								}
							}())))));
		return $elm$http$Http$riskyRequest(
			{
				bF: $elm$http$Http$jsonBody(body),
				cm: $elm$http$Http$expectWhatever($author$project$Page$Home$upgradeMsgServerApplyQuestionsSavedResponse),
				cp: _List_Nil,
				cu: 'POST',
				cG: $elm$core$Maybe$Just(model.J.ct),
				cH: $elm$core$Maybe$Nothing,
				R: model.J.bO + '/v1/apply/apply-questions'
			});
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Model$TkApplyApiResultDo = F3(
	function (success, succesMessage, errorMessage) {
		return {bI: errorMessage, kb: succesMessage, kc: success};
	});
var $author$project$Model$tkApplyApiResultDoJsonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'error_message',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'success_message',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'success',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Model$TkApplyApiResultDo))));
var $author$project$Page$Home$MsgServerCandidateCvSavedResponse = F3(
	function (a, b, c) {
		return {$: 54, a: a, b: b, c: c};
	});
var $author$project$Page$Home$upgradeMsgServerCandidateCvSavedResponse = F3(
	function (jobAdId, companyName, result) {
		return A3(
			$author$project$Page$Home$MsgServerCandidateCvSavedResponse,
			jobAdId,
			companyName,
			$krisajenkins$remotedata$RemoteData$fromResult(result));
	});
var $author$project$Page$Home$submitCandidateCv = function (model) {
	var _v0 = model.em;
	if (!_v0.$) {
		var jobAdId = _v0.a;
		var queryParamsFromUrl = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (uq) {
				return '?' + uq;
			},
			A2($author$project$Model$removeQueryParam, 'ci', model.R.jk));
		var companyName = A3(
			$krisajenkins$remotedata$RemoteData$unwrap,
			$elm$core$Maybe$Nothing,
			function (summary) {
				return $elm$core$Maybe$Just(summary.gI);
			},
			model.bM);
		var candidateInfoDo = model.c.l;
		var candidateCvDo = model.x.B;
		var body = $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'job_ad_id',
						$elm$json$Json$Encode$string(jobAdId)),
						_Utils_Tuple2(
						'source',
						$elm$json$Json$Encode$string(model.W)),
						_Utils_Tuple2(
						'message',
						$elm$json$Json$Encode$string(candidateCvDo.am)),
						_Utils_Tuple2(
						'private_cv',
						$elm$json$Json$Encode$bool(!candidateCvDo.jf)),
						_Utils_Tuple2(
						'subscribe_to_notifications',
						$elm$json$Json$Encode$bool(candidateCvDo.j9))
					]),
				_Utils_ap(
					function () {
						var _v1 = candidateInfoDo.cl.m;
						if (!_v1.$) {
							var email = _v1.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(email))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v2 = candidateCvDo.gl;
							if (!_v2.$) {
								var candidateNewCv = _v2.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'new_cv',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'array_bytes',
													$elm$json$Json$Encode$string(candidateNewCv.f$)),
													_Utils_Tuple2(
													'mime_type',
													$elm$json$Json$Encode$string(candidateNewCv.c9)),
													_Utils_Tuple2(
													'file_name',
													$elm$json$Json$Encode$string(candidateNewCv.ha))
												])))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						function () {
							var _v3 = candidateCvDo.ge;
							if (!_v3.$) {
								var candidateCurrentCv = _v3.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'current_cv',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'attachment_path',
													$elm$json$Json$Encode$string(candidateCurrentCv.cN)),
													_Utils_Tuple2(
													'attachment_hash',
													$elm$json$Json$Encode$string(candidateCurrentCv.cM)),
													_Utils_Tuple2(
													'attachment_mime_type',
													$elm$json$Json$Encode$string(candidateCurrentCv.f0))
												])))
									]);
							} else {
								return _List_Nil;
							}
						}()))));
		return $elm$http$Http$riskyRequest(
			{
				bF: $elm$http$Http$jsonBody(body),
				cm: A2(
					$elm$http$Http$expectJson,
					A2($author$project$Page$Home$upgradeMsgServerCandidateCvSavedResponse, jobAdId, companyName),
					$author$project$Model$tkApplyApiResultDoJsonDecoder),
				cp: _List_Nil,
				cu: 'POST',
				cG: $elm$core$Maybe$Just(model.J.iz),
				cH: $elm$core$Maybe$Nothing,
				R: model.J.bO + ('/v1/apply/candidate-cv' + queryParamsFromUrl)
			});
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Page$Home$MsgServerCandidateInfoSavedResponse = F3(
	function (a, b, c) {
		return {$: 21, a: a, b: b, c: c};
	});
var $author$project$Page$Home$upgradeMsgServerCandidateInfoSavedResponse = F3(
	function (jobAdId, tkJobAdSummaryDo, result) {
		return A3(
			$author$project$Page$Home$MsgServerCandidateInfoSavedResponse,
			jobAdId,
			tkJobAdSummaryDo,
			$krisajenkins$remotedata$RemoteData$fromResult(result));
	});
var $author$project$Page$Home$submitCandidateInfo = F2(
	function (model, tkJobAdSummaryDo) {
		var _v0 = model.em;
		if (!_v0.$) {
			var jobAdId = _v0.a;
			var candidateInfoDo = model.c.l;
			var candidateInfoBody = $elm$json$Json$Encode$object(
				_Utils_ap(
					function () {
						var _v1 = candidateInfoDo.cl.m;
						if (!_v1.$) {
							var email = _v1.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(email))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v2 = candidateInfoDo.c1.m;
							if (!_v2.$) {
								var fullname = _v2.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'full_name',
										$elm$json$Json$Encode$string(fullname))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						_Utils_ap(
							function () {
								var _v3 = candidateInfoDo.i6.m;
								if (!_v3.$) {
									var phone = _v3.a;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'phone_number',
											$elm$json$Json$Encode$string(phone))
										]);
								} else {
									return _List_Nil;
								}
							}(),
							_Utils_ap(
								function () {
									var _v4 = candidateInfoDo.c4.m;
									if (!_v4.$) {
										var headline = _v4.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'headline',
												$elm$json$Json$Encode$string(headline))
											]);
									} else {
										return _List_Nil;
									}
								}(),
								_Utils_ap(
									function () {
										var _v5 = tkJobAdSummaryDo.gH;
										if (!_v5.$) {
											var companyId = _v5.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'corporate_id',
													$elm$json$Json$Encode$string(companyId))
												]);
										} else {
											return _List_Nil;
										}
									}(),
									_Utils_ap(
										function () {
											var _v6 = candidateInfoDo.cs.m;
											if (!_v6.$) {
												var location = _v6.a;
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'location',
														$elm$json$Json$Encode$object(
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2(
																	'display_name',
																	$elm$json$Json$Encode$string(location)),
																_Utils_ap(
																	A2(
																		$elm$core$Maybe$withDefault,
																		_List_Nil,
																		A2(
																			$elm$core$Maybe$map,
																			function (l) {
																				return _List_fromArray(
																					[
																						_Utils_Tuple2(
																						'city_name',
																						$elm$json$Json$Encode$string(l.gr))
																					]);
																			},
																			candidateInfoDo.cs.e4)),
																	_Utils_ap(
																		A2(
																			$elm$core$Maybe$withDefault,
																			_List_Nil,
																			A2(
																				$elm$core$Maybe$map,
																				function (l) {
																					return _List_fromArray(
																						[
																							_Utils_Tuple2(
																							'city_id',
																							$elm$json$Json$Encode$string(l.gq))
																						]);
																				},
																				candidateInfoDo.cs.e4)),
																		_Utils_ap(
																			A2(
																				$elm$core$Maybe$withDefault,
																				_List_Nil,
																				A2(
																					$elm$core$Maybe$map,
																					function (l) {
																						return _List_fromArray(
																							[
																								_Utils_Tuple2(
																								'region_name',
																								$elm$json$Json$Encode$string(l.jE))
																							]);
																					},
																					candidateInfoDo.cs.e4)),
																			A2(
																				$elm$core$Maybe$withDefault,
																				_List_Nil,
																				A2(
																					$elm$core$Maybe$map,
																					function (l) {
																						return _List_fromArray(
																							[
																								_Utils_Tuple2(
																								'region_id',
																								$elm$json$Json$Encode$string(l.jD))
																							]);
																					},
																					candidateInfoDo.cs.e4))))))))
													]);
											} else {
												return _List_Nil;
											}
										}(),
										_List_fromArray(
											[
												_Utils_Tuple2(
												'recruiter_id',
												$elm$json$Json$Encode$string(tkJobAdSummaryDo.jp)),
												_Utils_Tuple2(
												'recruiter_plan_type',
												$elm$json$Json$Encode$string(tkJobAdSummaryDo.jy)),
												_Utils_Tuple2(
												'recruiter_plan_is_paid',
												$elm$json$Json$Encode$bool(tkJobAdSummaryDo.jx)),
												_Utils_Tuple2(
												'country_code',
												$elm$json$Json$Encode$string(
													A2($elm$core$Maybe$withDefault, tkJobAdSummaryDo.gT, model.gT))),
												_Utils_Tuple2(
												'source',
												$elm$json$Json$Encode$string(model.W))
											]))))))));
			var body = $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'job_ad_id',
						$elm$json$Json$Encode$string(jobAdId)),
						_Utils_Tuple2('candidate_info', candidateInfoBody)
					]));
			return $elm$http$Http$riskyRequest(
				{
					bF: $elm$http$Http$jsonBody(body),
					cm: $elm$http$Http$expectWhatever(
						A2($author$project$Page$Home$upgradeMsgServerCandidateInfoSavedResponse, jobAdId, tkJobAdSummaryDo)),
					cp: _List_Nil,
					cu: 'POST',
					cG: $elm$core$Maybe$Just(model.J.ct),
					cH: $elm$core$Maybe$Nothing,
					R: model.J.bO + '/v1/apply/candidate/info'
				});
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Page$Home$MsgServerFilterQuestionsSavedResponse = function (a) {
	return {$: 27, a: a};
};
var $author$project$Page$Home$upgradeMsgServerFilterQuestionsSavedResponse = function (result) {
	return $author$project$Page$Home$MsgServerFilterQuestionsSavedResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$submitFilterQuestions = function (model) {
	var _v0 = model.em;
	if (!_v0.$) {
		var jobAdId = _v0.a;
		var candidateInfoDo = model.c.l;
		var answersList = model.A.fW;
		var answersEncoder = function (_v2) {
			var id = _v2.a;
			var answer = _v2.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(id)),
						_Utils_Tuple2(
						'answer',
						$elm$json$Json$Encode$string(answer.m))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'job_ad_id',
						$elm$json$Json$Encode$string(jobAdId)),
						_Utils_Tuple2(
						'source',
						$elm$json$Json$Encode$string(model.W)),
						_Utils_Tuple2(
						'answers',
						A2(
							$elm$json$Json$Encode$list,
							answersEncoder,
							$elm$core$Dict$toList(answersList)))
					]),
				function () {
					var _v1 = candidateInfoDo.cl.m;
					if (!_v1.$) {
						var email = _v1.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(email))
							]);
					} else {
						return _List_Nil;
					}
				}()));
		return $elm$http$Http$riskyRequest(
			{
				bF: $elm$http$Http$jsonBody(body),
				cm: $elm$http$Http$expectWhatever($author$project$Page$Home$upgradeMsgServerFilterQuestionsSavedResponse),
				cp: _List_Nil,
				cu: 'POST',
				cG: $elm$core$Maybe$Just(model.J.ct),
				cH: $elm$core$Maybe$Nothing,
				R: model.J.bO + '/v1/apply/filter-questions'
			});
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Model$TkCurrentCandidateApplyDo = F3(
	function (currentStep, jobAdId, candidateApplyInfo) {
		return {dE: candidateApplyInfo, dO: currentStep, em: jobAdId};
	});
var $author$project$Model$CompleteApplyStep = 6;
var $author$project$Model$applyScreenStringAsStep = function (step) {
	switch (step) {
		case 'WelcomeStep':
			return 0;
		case 'CandidateInfoStep':
			return 1;
		case 'ExternalApplyStep':
			return 2;
		case 'FilterQuestionsStep':
			return 3;
		case 'ApplyQuestionsStep':
			return 4;
		case 'CandidateCvStep':
			return 5;
		case 'CompleteApplyStep':
			return 6;
		default:
			return 1;
	}
};
var $author$project$Model$tkCurrentCandidateApplyDoJsonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'apply_info',
	$author$project$Model$tkApiCandidateApplyInfoDoJsonDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'job_ad_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'current_step',
			A2($elm$json$Json$Decode$map, $author$project$Model$applyScreenStringAsStep, $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Model$TkCurrentCandidateApplyDo))));
var $author$project$T2$Dropdown$toggleState = function (current) {
	if (!current) {
		return 1;
	} else {
		return 0;
	}
};
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $author$project$Ports$trackCompleteApplication = _Platform_outgoingPort(
	'trackCompleteApplication',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'companyName',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.gI)),
					_Utils_Tuple2(
					'jobAdId',
					$elm$json$Json$Encode$string($.em)),
					_Utils_Tuple2(
					'source',
					$elm$json$Json$Encode$string($.W))
				]));
	});
var $author$project$Page$Home$trackExternalApplication = F3(
	function (model, jobAdId, companyId) {
		var body = $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'job_ad_id',
						$elm$json$Json$Encode$string(jobAdId)),
						_Utils_Tuple2(
						'source',
						$elm$json$Json$Encode$string(model.W)),
						_Utils_Tuple2(
						'provider',
						$elm$json$Json$Encode$string(model.df))
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (e) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'company_id',
									$elm$json$Json$Encode$string(e))
								]);
						},
						companyId))));
		return $elm$http$Http$riskyRequest(
			{
				bF: $elm$http$Http$jsonBody(body),
				cm: $elm$http$Http$expectString(
					function (_v0) {
						return $author$project$Page$Home$PassThrough;
					}),
				cp: _List_Nil,
				cu: 'POST',
				cG: $elm$core$Maybe$Just(model.J.ct),
				cH: $elm$core$Maybe$Nothing,
				R: model.J.bO + '/v1/apply/track-external-application'
			});
	});
var $author$project$Page$Home$trackGoogleSignInButtonClick = function (model) {
	return $elm$http$Http$riskyRequest(
		{
			bF: $elm$http$Http$emptyBody,
			cm: $elm$http$Http$expectString(
				function (_v0) {
					return $author$project$Page$Home$PassThrough;
				}),
			cp: _List_Nil,
			cu: 'POST',
			cG: $elm$core$Maybe$Just(model.J.ct),
			cH: $elm$core$Maybe$Nothing,
			R: model.J.bO + '/v1/apply/track-google-sign-in'
		});
};
var $author$project$Ports$trackInitiateApplication = _Platform_outgoingPort(
	'trackInitiateApplication',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jobAdId',
					$elm$json$Json$Encode$string($.em)),
					_Utils_Tuple2(
					'source',
					$elm$json$Json$Encode$string($.W))
				]));
	});
var $author$project$Ports$triggerUploadButton = _Platform_outgoingPort('triggerUploadButton', $elm$json$Json$Encode$string);
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $author$project$T2$Internal$Autocomplete$filteredItems = F2(
	function (query, items) {
		var lowerQuery = $elm$core$String$toLower(query);
		return A2(
			$elm$core$List$filter,
			function (item) {
				return A2(
					$elm$core$String$contains,
					lowerQuery,
					$elm$core$String$toLower(item.u));
			},
			items);
	});
var $author$project$T2$Internal$Autocomplete$getGroupedItemAt = F2(
	function (index, groupedItems) {
		return $elm$core$List$head(
			A2($elm$core$List$drop, index, groupedItems));
	});
var $author$project$T2$Internal$Autocomplete$getItemAt = F2(
	function (index, items) {
		return $elm$core$List$head(
			A2($elm$core$List$drop, index, items));
	});
var $author$project$T2$Internal$Autocomplete$handleSelection = function (model) {
	var _v0 = A2(
		$author$project$T2$Internal$Autocomplete$getItemAt,
		model.a7,
		model.b4 ? model.bl : model.bp);
	if (!_v0.$) {
		var item = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					h7: false,
					jk: item.u,
					jR: $elm$core$Maybe$Just(item.m)
				}),
			A2(
				$elm$core$Task$perform,
				$elm$core$Basics$identity,
				$elm$core$Task$succeed(
					model.a2(item.m))));
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$T2$Internal$Autocomplete$isValidSelection = F2(
	function (index, model) {
		var _v0 = A2(
			$author$project$T2$Internal$Autocomplete$getItemAt,
			index,
			model.b4 ? model.bl : model.bp);
		if (!_v0.$) {
			var item = _v0.a;
			return !item.t;
		} else {
			return false;
		}
	});
var $author$project$T2$Internal$Autocomplete$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var query = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bl: A2($author$project$T2$Internal$Autocomplete$filteredItems, query, model.bp),
							h7: true,
							jk: query,
							a7: 0,
							jR: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{h7: !model.h7}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{h7: false}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var index = msg.a;
				if (A2($author$project$T2$Internal$Autocomplete$isValidSelection, index, model)) {
					var _v1 = A2(
						$author$project$T2$Internal$Autocomplete$getItemAt,
						index,
						model.b4 ? model.bl : model.bp);
					if (!_v1.$) {
						var item = _v1.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									h7: false,
									jk: item.u,
									jR: $elm$core$Maybe$Just(item.m)
								}),
							A2(
								$elm$core$Task$perform,
								$elm$core$Basics$identity,
								$elm$core$Task$succeed(
									model.a2(item.m))));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				var keyCode = msg.a;
				switch (keyCode) {
					case 13:
						return $author$project$T2$Internal$Autocomplete$handleSelection(model);
					case 27:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{h7: false}),
							$elm$core$Platform$Cmd$none);
					case 38:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a7: A3(
										$elm$core$Basics$clamp,
										0,
										$elm$core$List$length(model.bp) - 1,
										model.a7 - 1)
								}),
							$elm$core$Platform$Cmd$none);
					case 40:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a7: A3(
										$elm$core$Basics$clamp,
										0,
										$elm$core$List$length(model.bp) - 1,
										model.a7 + 1)
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 5:
				var keyCode = msg.a;
				var groupedItems = msg.b;
				var rowCount = $elm$core$List$length(groupedItems);
				switch (keyCode) {
					case 13:
						var _v4 = A2($author$project$T2$Internal$Autocomplete$getGroupedItemAt, model.a7, groupedItems);
						if (!_v4.$) {
							if (_v4.a.$ === 1) {
								var item = _v4.a.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											h7: false,
											jk: item.u,
											jR: $elm$core$Maybe$Just(item.m)
										}),
									A2(
										$elm$core$Task$perform,
										$elm$core$Basics$identity,
										$elm$core$Task$succeed(
											model.a2(item.m))));
							} else {
								var value = _v4.a.a.m;
								var label = _v4.a.a.u;
								if (!value.$) {
									var v = value.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												h7: false,
												jk: label,
												jR: $elm$core$Maybe$Just(v)
											}),
										A2(
											$elm$core$Task$perform,
											$elm$core$Basics$identity,
											$elm$core$Task$succeed(
												model.a2(v))));
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							}
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 27:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{h7: false}),
							$elm$core$Platform$Cmd$none);
					case 38:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a7: A3($elm$core$Basics$clamp, 0, rowCount - 1, model.a7 - 1)
								}),
							$elm$core$Platform$Cmd$none);
					case 40:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a7: A3($elm$core$Basics$clamp, 0, rowCount - 1, model.a7 + 1)
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				var value = msg.a;
				var label = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							h7: false,
							jk: label,
							jR: $elm$core$Maybe$Just(value)
						}),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$identity,
						$elm$core$Task$succeed(
							model.a2(value))));
			case 7:
				var items = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bp: items}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $truqu$elm_base64$Base64$Encode$intToBase64 = function (i) {
	switch (i) {
		case 0:
			return 'A';
		case 1:
			return 'B';
		case 2:
			return 'C';
		case 3:
			return 'D';
		case 4:
			return 'E';
		case 5:
			return 'F';
		case 6:
			return 'G';
		case 7:
			return 'H';
		case 8:
			return 'I';
		case 9:
			return 'J';
		case 10:
			return 'K';
		case 11:
			return 'L';
		case 12:
			return 'M';
		case 13:
			return 'N';
		case 14:
			return 'O';
		case 15:
			return 'P';
		case 16:
			return 'Q';
		case 17:
			return 'R';
		case 18:
			return 'S';
		case 19:
			return 'T';
		case 20:
			return 'U';
		case 21:
			return 'V';
		case 22:
			return 'W';
		case 23:
			return 'X';
		case 24:
			return 'Y';
		case 25:
			return 'Z';
		case 26:
			return 'a';
		case 27:
			return 'b';
		case 28:
			return 'c';
		case 29:
			return 'd';
		case 30:
			return 'e';
		case 31:
			return 'f';
		case 32:
			return 'g';
		case 33:
			return 'h';
		case 34:
			return 'i';
		case 35:
			return 'j';
		case 36:
			return 'k';
		case 37:
			return 'l';
		case 38:
			return 'm';
		case 39:
			return 'n';
		case 40:
			return 'o';
		case 41:
			return 'p';
		case 42:
			return 'q';
		case 43:
			return 'r';
		case 44:
			return 's';
		case 45:
			return 't';
		case 46:
			return 'u';
		case 47:
			return 'v';
		case 48:
			return 'w';
		case 49:
			return 'x';
		case 50:
			return 'y';
		case 51:
			return 'z';
		case 52:
			return '0';
		case 53:
			return '1';
		case 54:
			return '2';
		case 55:
			return '3';
		case 56:
			return '4';
		case 57:
			return '5';
		case 58:
			return '6';
		case 59:
			return '7';
		case 60:
			return '8';
		case 61:
			return '9';
		case 62:
			return '+';
		default:
			return '/';
	}
};
var $truqu$elm_base64$Base64$Encode$toBase64 = function (_int) {
	return _Utils_ap(
		$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 18)),
		_Utils_ap(
			$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 12)),
			_Utils_ap(
				$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 6)),
				$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 0)))));
};
var $truqu$elm_base64$Base64$Encode$add = F2(
	function (_char, _v0) {
		var res = _v0.a;
		var count = _v0.b;
		var acc = _v0.c;
		var current = (acc << 8) | _char;
		if (count === 2) {
			return _Utils_Tuple3(
				_Utils_ap(
					res,
					$truqu$elm_base64$Base64$Encode$toBase64(current)),
				0,
				0);
		} else {
			return _Utils_Tuple3(res, count + 1, current);
		}
	});
var $truqu$elm_base64$Base64$Encode$chomp = F2(
	function (char_, acc) {
		var _char = $elm$core$Char$toCode(char_);
		return (_char < 128) ? A2($truqu$elm_base64$Base64$Encode$add, _char, acc) : ((_char < 2048) ? A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2($truqu$elm_base64$Base64$Encode$add, 192 | (_char >>> 6), acc)) : (((_char < 55296) || ((_char >= 57344) && (_char <= 65535))) ? A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2(
				$truqu$elm_base64$Base64$Encode$add,
				128 | (63 & (_char >>> 6)),
				A2($truqu$elm_base64$Base64$Encode$add, 224 | (_char >>> 12), acc))) : A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2(
				$truqu$elm_base64$Base64$Encode$add,
				128 | (63 & (_char >>> 6)),
				A2(
					$truqu$elm_base64$Base64$Encode$add,
					128 | (63 & (_char >>> 12)),
					A2($truqu$elm_base64$Base64$Encode$add, 240 | (_char >>> 18), acc))))));
	});
var $truqu$elm_base64$Base64$Encode$initial = _Utils_Tuple3('', 0, 0);
var $truqu$elm_base64$Base64$Encode$wrapUp = function (_v0) {
	var res = _v0.a;
	var cnt = _v0.b;
	var acc = _v0.c;
	switch (cnt) {
		case 1:
			return res + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 2)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc << 4)) + '=='));
		case 2:
			return res + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 10)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 4)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc << 2)) + '=')));
		default:
			return res;
	}
};
var $truqu$elm_base64$Base64$Encode$encode = function (input) {
	return $truqu$elm_base64$Base64$Encode$wrapUp(
		A3($elm$core$String$foldl, $truqu$elm_base64$Base64$Encode$chomp, $truqu$elm_base64$Base64$Encode$initial, input));
};
var $truqu$elm_base64$Base64$encode = $truqu$elm_base64$Base64$Encode$encode;
var $author$project$Model$applyScreenStepAsString = function (step) {
	switch (step) {
		case 0:
			return 'WelcomeStep';
		case 1:
			return 'CandidateInfoStep';
		case 2:
			return 'ExternalApplyStep';
		case 3:
			return 'FilterQuestionsStep';
		case 4:
			return 'ApplyQuestionsStep';
		case 5:
			return 'CandidateCvStep';
		case 6:
			return 'CompleteApplyStep';
		default:
			return 'EmptyScreenStep';
	}
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Model$tkApplyCandidateLocationDoEncoder = function (locationDo) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			function () {
				var _v0 = locationDo.dU;
				if (!_v0.$) {
					var displayName = _v0.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'display_name',
							$elm$json$Json$Encode$string(displayName))
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _v1 = locationDo.dJ;
					if (!_v1.$) {
						var cityName = _v1.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'city_name',
								$elm$json$Json$Encode$string(cityName))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						var _v2 = locationDo.dI;
						if (!_v2.$) {
							var cityId = _v2.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'city_id',
									$elm$json$Json$Encode$string(cityId))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v3 = locationDo.eS;
							if (!_v3.$) {
								var regionName = _v3.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'region_name',
										$elm$json$Json$Encode$string(regionName))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						function () {
							var _v4 = locationDo.eR;
							if (!_v4.$) {
								var regionId = _v4.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'region_id',
										$elm$json$Json$Encode$string(regionId))
									]);
							} else {
								return _List_Nil;
							}
						}())))));
};
var $author$project$Model$tkApiCandidateApplyInfoDoEncoder = function (applyInfo) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(applyInfo.cl)),
					_Utils_Tuple2(
					'private_cv',
					$elm$json$Json$Encode$bool(applyInfo.eI)),
					_Utils_Tuple2(
					'candidate_already_applied',
					$elm$json$Json$Encode$bool(applyInfo.dD))
				]),
			_Utils_ap(
				function () {
					var _v0 = applyInfo.c1;
					if (!_v0.$) {
						var fullname = _v0.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'full_name',
								$elm$json$Json$Encode$string(fullname))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						var _v1 = applyInfo.eF;
						if (!_v1.$) {
							var phone = _v1.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'phone_number',
									$elm$json$Json$Encode$string(phone))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v2 = applyInfo.cs;
							if (!_v2.$) {
								var location = _v2.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'location',
										$author$project$Model$tkApplyCandidateLocationDoEncoder(location))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						_Utils_ap(
							function () {
								var _v3 = applyInfo.c4;
								if (!_v3.$) {
									var headline = _v3.a;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'headline',
											$elm$json$Json$Encode$string(headline))
										]);
								} else {
									return _List_Nil;
								}
							}(),
							_Utils_ap(
								function () {
									var _v4 = applyInfo.cS;
									if (!_v4.$) {
										var category = _v4.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'category',
												$elm$json$Json$Encode$string(category))
											]);
									} else {
										return _List_Nil;
									}
								}(),
								_Utils_ap(
									function () {
										var _v5 = applyInfo.cZ;
										if (!_v5.$) {
											var experience = _v5.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'experience_level',
													$elm$json$Json$Encode$string(experience))
												]);
										} else {
											return _List_Nil;
										}
									}(),
									_Utils_ap(
										function () {
											var _v6 = applyInfo.cY;
											if (!_v6.$) {
												var educationLevel = _v6.a;
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'education_level',
														$elm$json$Json$Encode$string(educationLevel))
													]);
											} else {
												return _List_Nil;
											}
										}(),
										_Utils_ap(
											function () {
												var _v7 = applyInfo.c_;
												if (!_v7.$) {
													var experienceYears = _v7.a;
													return _List_fromArray(
														[
															_Utils_Tuple2(
															'experience_years',
															$elm$json$Json$Encode$int(experienceYears))
														]);
												} else {
													return _List_Nil;
												}
											}(),
											_Utils_ap(
												function () {
													var _v8 = applyInfo.dk;
													if (!_v8.$) {
														var skillsList = _v8.a;
														return _List_fromArray(
															[
																_Utils_Tuple2(
																'skills_list',
																A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, skillsList))
															]);
													} else {
														return _List_Nil;
													}
												}(),
												_Utils_ap(
													function () {
														var _v9 = applyInfo.cN;
														if (!_v9.$) {
															var attachmentPath = _v9.a;
															return _List_fromArray(
																[
																	_Utils_Tuple2(
																	'attachment_path',
																	$elm$json$Json$Encode$string(attachmentPath))
																]);
														} else {
															return _List_Nil;
														}
													}(),
													_Utils_ap(
														function () {
															var _v10 = applyInfo.cM;
															if (!_v10.$) {
																var attachmentHash = _v10.a;
																return _List_fromArray(
																	[
																		_Utils_Tuple2(
																		'attachment_hash',
																		$elm$json$Json$Encode$string(attachmentHash))
																	]);
															} else {
																return _List_Nil;
															}
														}(),
														_Utils_ap(
															function () {
																var _v11 = applyInfo.c9;
																if (!_v11.$) {
																	var mimeType = _v11.a;
																	return _List_fromArray(
																		[
																			_Utils_Tuple2(
																			'mime_type',
																			$elm$json$Json$Encode$string(mimeType))
																		]);
																} else {
																	return _List_Nil;
																}
															}(),
															_Utils_ap(
																function () {
																	var _v12 = applyInfo.dR;
																	if (!_v12.$) {
																		var cvDownloadLink = _v12.a;
																		return _List_fromArray(
																			[
																				_Utils_Tuple2(
																				'cv_download_link',
																				$elm$json$Json$Encode$string(cvDownloadLink))
																			]);
																	} else {
																		return _List_Nil;
																	}
																}(),
																_Utils_ap(
																	function () {
																		var _v13 = applyInfo.am;
																		if (!_v13.$) {
																			var message = _v13.a;
																			return _List_fromArray(
																				[
																					_Utils_Tuple2(
																					'message',
																					$elm$json$Json$Encode$string(message))
																				]);
																		} else {
																			return _List_Nil;
																		}
																	}(),
																	_Utils_ap(
																		function () {
																			var _v14 = applyInfo.dQ;
																			if (!_v14.$) {
																				var cvCreatedAtHumanReadable = _v14.a;
																				return _List_fromArray(
																					[
																						_Utils_Tuple2(
																						'cv_created_at_human_readable',
																						$elm$json$Json$Encode$string(cvCreatedAtHumanReadable))
																					]);
																			} else {
																				return _List_Nil;
																			}
																		}(),
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				'is_current_cv_from_profile',
																				$elm$json$Json$Encode$bool(applyInfo.ej))
																			]))))))))))))))))));
};
var $author$project$Model$tkCurrentCandidateApplyDoEncoder = function (currentCandidateApplyDo) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'current_step',
				$elm$json$Json$Encode$string(
					$author$project$Model$applyScreenStepAsString(currentCandidateApplyDo.dO))),
				_Utils_Tuple2(
				'job_ad_id',
				$elm$json$Json$Encode$string(currentCandidateApplyDo.em)),
				_Utils_Tuple2(
				'apply_info',
				$author$project$Model$tkApiCandidateApplyInfoDoEncoder(currentCandidateApplyDo.dE))
			]));
};
var $author$project$Page$Home$getCandidateInfoEncoded = function (currentApplyInfo) {
	var currentApplyInfoEncoded = $author$project$Model$tkCurrentCandidateApplyDoEncoder(currentApplyInfo);
	var currentApplyAsString = A2($elm$json$Json$Encode$encode, 0, currentApplyInfoEncoded);
	return $truqu$elm_base64$Base64$encode(currentApplyAsString);
};
var $sporto$qs$QS$One = function (a) {
	return {$: 0, a: a};
};
var $sporto$qs$QS$Config = $elm$core$Basics$identity;
var $sporto$qs$QS$config = {b7: true, bH: true};
var $sporto$qs$QS$Many = function (a) {
	return {$: 1, a: a};
};
var $sporto$qs$QS$get = F2(
	function (key, query) {
		return A2($elm$core$Dict$get, key, query);
	});
var $sporto$qs$QS$rawValueToValue = F2(
	function (cfg, val) {
		var trimmed = $elm$core$String$trim(val);
		var isEmpty = trimmed === '';
		return isEmpty ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(trimmed);
	});
var $sporto$qs$QS$set = F3(
	function (key, value, query) {
		return A3($elm$core$Dict$insert, key, value, query);
	});
var $sporto$qs$QS$addListValToQuery = F4(
	function (cfg, key, rawValue, query) {
		var currentVals = A2($sporto$qs$QS$get, key, query);
		var pushValue = function (value) {
			if (!currentVals.$) {
				if (currentVals.a.$ === 1) {
					var vals = currentVals.a.a;
					return $sporto$qs$QS$Many(
						A2(
							$elm$core$List$append,
							vals,
							_List_fromArray(
								[value])));
				} else {
					var preValue = currentVals.a.a;
					return $sporto$qs$QS$Many(
						_List_fromArray(
							[preValue, value]));
				}
			} else {
				return $sporto$qs$QS$Many(
					_List_fromArray(
						[value]));
			}
		};
		var _v0 = A2($sporto$qs$QS$rawValueToValue, cfg, rawValue);
		if (_v0.$ === 1) {
			return query;
		} else {
			var value = _v0.a;
			return A3(
				$sporto$qs$QS$set,
				key,
				pushValue(value),
				query);
		}
	});
var $sporto$qs$QS$addUniqueValToQuery = F4(
	function (cfg, key, val, query) {
		var _v0 = A2($sporto$qs$QS$rawValueToValue, cfg, val);
		if (_v0.$ === 1) {
			return query;
		} else {
			var value = _v0.a;
			return A3(
				$sporto$qs$QS$set,
				key,
				$sporto$qs$QS$One(value),
				query);
		}
	});
var $sporto$qs$QS$querySegmentToTuple = function (element) {
	var splitted = A2($elm$core$String$split, '=', element);
	var second = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2($elm$core$List$drop, 1, splitted)));
	var secondDecoded = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$url$Url$percentDecode(second));
	var first = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(splitted));
	var firstDecoded = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$url$Url$percentDecode(first));
	return _Utils_Tuple2(firstDecoded, secondDecoded);
};
var $sporto$qs$QS$addSegmentToQuery = F3(
	function (cfg, segment, query) {
		var _v0 = $sporto$qs$QS$querySegmentToTuple(segment);
		var key = _v0.a;
		var val = _v0.b;
		if (A2($elm$core$String$endsWith, '[]', key)) {
			var newKey = A2($elm$core$String$dropRight, 2, key);
			return A4($sporto$qs$QS$addListValToQuery, cfg, newKey, val, query);
		} else {
			return A4($sporto$qs$QS$addUniqueValToQuery, cfg, key, val, query);
		}
	});
var $sporto$qs$QS$empty = $elm$core$Dict$empty;
var $sporto$qs$QS$parse = F2(
	function (_v0, queryString) {
		var cfg = _v0;
		var trimmed = A2(
			$elm$core$String$join,
			'',
			A2($elm$core$String$split, '?', queryString));
		return $elm$core$String$isEmpty(trimmed) ? $sporto$qs$QS$empty : A3(
			$elm$core$List$foldl,
			$sporto$qs$QS$addSegmentToQuery(cfg),
			$sporto$qs$QS$empty,
			A2($elm$core$String$split, '&', trimmed));
	});
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Page$Home$getNewUrl = F2(
	function (model, currentApplyAsBase64) {
		var queryParamsParsed = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Dict$empty,
			A2(
				$elm$core$Maybe$map,
				function (e) {
					return A2($sporto$qs$QS$parse, $sporto$qs$QS$config, e);
				},
				model.R.jk));
		var queryParamsWithApplyInfoParam = A3(
			$elm$core$Dict$insert,
			'ci',
			$sporto$qs$QS$One(currentApplyAsBase64),
			queryParamsParsed);
		var urlQs = A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					model.J.kB,
					A3(
					$elm$core$String$slice,
					1,
					$elm$core$String$length(model.R.eD),
					model.R.eD)
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var q = _v0.a;
					var v = _v0.b;
					var value = function () {
						if (q === 'ci') {
							return currentApplyAsBase64;
						} else {
							if (!v.$) {
								var oneVal = v.a;
								return oneVal;
							} else {
								if (v.a.b) {
									var _v2 = v.a;
									var val = _v2.a;
									return val;
								} else {
									return '';
								}
							}
						}
					}();
					return A2($elm$url$Url$Builder$string, q, value);
				},
				$elm$core$List$reverse(
					A2(
						$elm$core$List$filter,
						function (_v3) {
							var q = _v3.a;
							return (!(A2($elm$core$String$contains, 'utm', q) && (!A2($elm$core$String$contains, 'tk_utm', q)))) && (!A2($elm$core$String$contains, 'email', q));
						},
						$elm$core$Dict$toList(queryParamsWithApplyInfoParam)))));
		return urlQs;
	});
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Page$Home$updateUrlWithCurrentCandidateApplyInfo = F3(
	function (model, currentStep, nextstep) {
		var currentCandidateInfoStageModel = model.c;
		var currentCandidateApplyInfo = model.ak;
		var candidateInfoDo = currentCandidateInfoStageModel.l;
		var applyQuestionsInfoDo = model.o.q;
		var currentApplyInfo = {
			dE: {
				cM: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.cM;
					},
					currentCandidateApplyInfo),
				cN: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.cN;
					},
					currentCandidateApplyInfo),
				dD: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (c) {
							return c.dD;
						},
						currentCandidateApplyInfo)),
				cS: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.m;
					},
					applyQuestionsInfoDo.cS.m),
				gT: model.gT,
				dQ: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.dQ;
					},
					currentCandidateApplyInfo),
				dR: A2(
					$elm$core$Maybe$andThen,
					function (c) {
						return c.dR;
					},
					currentCandidateApplyInfo),
				cY: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.m;
					},
					applyQuestionsInfoDo.cY.m),
				cl: A2($elm$core$Maybe$withDefault, '', candidateInfoDo.cl.m),
				cZ: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.m;
					},
					applyQuestionsInfoDo.cZ.m),
				c_: $elm$core$String$toInt(applyQuestionsInfoDo.c_.m),
				c1: candidateInfoDo.c1.m,
				c4: candidateInfoDo.c4.m,
				ej: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (c) {
							return c.ej;
						},
						currentCandidateApplyInfo)),
				cs: $elm$core$Maybe$Just(
					{
						dI: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.gq;
							},
							candidateInfoDo.cs.e4),
						dJ: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.gr;
							},
							candidateInfoDo.cs.e4),
						dU: candidateInfoDo.cs.m,
						eR: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.jD;
							},
							candidateInfoDo.cs.e4),
						eS: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.jE;
							},
							candidateInfoDo.cs.e4)
					}),
				am: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.am;
					},
					currentCandidateApplyInfo),
				c9: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.c9;
					},
					currentCandidateApplyInfo),
				eF: candidateInfoDo.i6.m,
				eI: false,
				dk: $elm$core$Maybe$Just(
					$elm$core$Array$toList(
						A2(
							$elm$core$Array$map,
							function ($) {
								return $.m;
							},
							applyQuestionsInfoDo.jY)))
			},
			dO: currentStep,
			em: A2($elm$core$Maybe$withDefault, '', model.em)
		};
		var nextStepApplyInfo = _Utils_update(
			currentApplyInfo,
			{dO: nextstep});
		var nextStepApplyAsBase64 = $author$project$Page$Home$getCandidateInfoEncoded(nextStepApplyInfo);
		var urlWithNextStep = A2($author$project$Page$Home$getNewUrl, model, nextStepApplyAsBase64);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					R: A2(
						$elm$core$Maybe$withDefault,
						model.R,
						$elm$url$Url$fromString(urlWithNextStep))
				}),
			A2($elm$browser$Browser$Navigation$replaceUrl, model.cv, urlWithNextStep));
	});
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $author$project$Page$Home$validateApplyQuestions = function (model) {
	var validateSkillAndAddErrorMessage = function (skill) {
		return _Utils_update(
			skill,
			{
				bI: ($elm$core$String$trim(skill.m) === '') ? $elm$core$Maybe$Just('Por favor ingresa una habilidad') : $elm$core$Maybe$Nothing
			});
	};
	var currentApplyQuestionsStageModel = model.o;
	var currentCategoryField = currentApplyQuestionsStageModel.q.cS;
	var currentEducationLevelField = currentApplyQuestionsStageModel.q.cY;
	var educationLevelError = _Utils_eq(currentEducationLevelField.m, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just('Por favor selecciona una opción') : $elm$core$Maybe$Nothing;
	var currentExperienceLevelField = currentApplyQuestionsStageModel.q.cZ;
	var experienceError = _Utils_eq(currentExperienceLevelField.m, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just('Por favor selecciona una opción') : $elm$core$Maybe$Nothing;
	var currentExperienceYearsField = currentApplyQuestionsStageModel.q.c_;
	var experienceYearsError = ($elm$core$String$trim(currentExperienceYearsField.m) === '') ? $elm$core$Maybe$Just('Ingresa tus años de experiencia profesional') : $elm$core$Maybe$Nothing;
	var currentSkillsField = currentApplyQuestionsStageModel.q.jY;
	var newSkillsWithErrorMessages = A2($elm$core$Array$map, validateSkillAndAddErrorMessage, currentSkillsField);
	var skillsHaveErrors = A3(
		$elm$core$Array$foldl,
		F2(
			function (skill, acc) {
				return (!_Utils_eq(skill.bI, $elm$core$Maybe$Nothing)) || acc;
			}),
		false,
		newSkillsWithErrorMessages);
	var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.q;
	var categoryError = _Utils_eq(currentCategoryField.m, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just('Por favor selecciona una opción') : $elm$core$Maybe$Nothing;
	var formaHasErrors = (!_Utils_eq(categoryError, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(experienceError, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(educationLevelError, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(experienceYearsError, $elm$core$Maybe$Nothing)) || skillsHaveErrors)));
	var newModelWithErrorsUpdated = _Utils_update(
		model,
		{
			o: _Utils_update(
				currentApplyQuestionsStageModel,
				{
					q: _Utils_update(
						currentApplyQuestionsInfo,
						{
							cS: _Utils_update(
								currentCategoryField,
								{bI: categoryError}),
							cY: _Utils_update(
								currentEducationLevelField,
								{bI: educationLevelError}),
							cZ: _Utils_update(
								currentExperienceLevelField,
								{bI: experienceError}),
							c_: _Utils_update(
								currentExperienceYearsField,
								{bI: experienceYearsError}),
							jY: newSkillsWithErrorMessages
						})
				})
		});
	return _Utils_Tuple2(newModelWithErrorsUpdated, formaHasErrors);
};
var $author$project$T2$Util$emailRegexPattern = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^(([^<>()\\[\\]\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'));
var $author$project$T2$Util$isValidEmail = function (email) {
	return A2(
		$elm$regex$Regex$contains,
		$author$project$T2$Util$emailRegexPattern,
		$elm$core$String$trim(
			$elm$core$String$toLower(email)));
};
var $author$project$Page$Home$validateEmail = function (email) {
	return $author$project$T2$Util$isValidEmail(email) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Ingresa un correo electrónico válido');
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Page$Home$MsgServerGotMagicLinkVerifyResponse = function (a) {
	return {$: 101, a: a};
};
var $author$project$Page$Home$upgradeMsgServerGotMagicLinkVerifyResponse = function (result) {
	return $author$project$Page$Home$MsgServerGotMagicLinkVerifyResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$verifyMagicLink = function (model) {
	var body = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(model.N.cl)),
				_Utils_Tuple2(
				'digits_code',
				$elm$json$Json$Encode$string(
					_Utils_ap(
						model.n.aZ,
						_Utils_ap(
							model.n.a0,
							_Utils_ap(
								model.n.a$,
								_Utils_ap(
									model.n.aY,
									_Utils_ap(model.n.aX, model.n.a_)))))))
			]));
	return $elm$http$Http$riskyRequest(
		{
			bF: $elm$http$Http$jsonBody(body),
			cm: $elm$http$Http$expectWhatever($author$project$Page$Home$upgradeMsgServerGotMagicLinkVerifyResponse),
			cp: _List_Nil,
			cu: 'POST',
			cG: $elm$core$Maybe$Just(model.J.ct),
			cH: $elm$core$Maybe$Nothing,
			R: model.J.bO + '/v1/candidate/auth/digits/login'
		});
};
var $author$project$Page$Home$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					var windowSize = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{S: windowSize}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 77:
					var visualViewportHeightOffset = msg.a;
					var lastNotZeroViewportHeightOffset = (visualViewportHeightOffset < 100) ? ((model.bC > 100) ? model.bC : model.bq) : visualViewportHeightOffset;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bq: lastNotZeroViewportHeightOffset, bC: visualViewportHeightOffset}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 43:
					var currentYear = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ci: currentYear}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 1:
					return _Utils_Tuple3(
						model,
						$author$project$Page$Home$getJobAdSummary(model),
						$author$project$Model$NoGlobalAction);
				case 2:
					var result = msg.a;
					var nextCmd = function () {
						switch (result.$) {
							case 0:
								return $elm$core$Platform$Cmd$none;
							case 2:
								return $elm$core$Platform$Cmd$none;
							case 1:
								return $elm$core$Platform$Cmd$none;
							default:
								var jobAdSummaryDo = result.a;
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Page$Home$getCurrentCandidateApplyInfo, model, jobAdSummaryDo),
											$author$project$Page$Home$getJobAdFilterQuestions(model)
										]));
						}
					}();
					var newExternalApplyEnabled = function () {
						switch (result.$) {
							case 0:
								return false;
							case 2:
								return false;
							case 1:
								return false;
							default:
								var jobAd = result.a;
								return model.c$ && (!_Utils_eq(jobAd.g8, $elm$core$Maybe$Nothing));
						}
					}();
					var modelWithDefaultPhoneNumber = function () {
						switch (result.$) {
							case 0:
								return model;
							case 2:
								return model;
							case 1:
								return model;
							default:
								var jobAd = result.a;
								var candidateInfoStageModel = model.c;
								var candidateInfoDo = candidateInfoStageModel.l;
								var phoneField = candidateInfoDo.i6;
								return _Utils_update(
									model,
									{
										c: _Utils_update(
											candidateInfoStageModel,
											{
												l: _Utils_update(
													candidateInfoDo,
													{
														i6: _Utils_update(
															phoneField,
															{
																cr: (jobAd.gT === 'mx') ? '+52' : ''
															})
													})
											})
									});
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							modelWithDefaultPhoneNumber,
							{bk: newExternalApplyEnabled, bM: result}),
						nextCmd,
						$author$project$Model$NoGlobalAction);
				case 3:
					var jobAdSummaryDo = msg.a;
					var result = msg.b;
					var maybeCurrentApplyFromUrl = A2(
						$elm$core$Maybe$andThen,
						function (applyAsBase64) {
							var _v6 = $truqu$elm_base64$Base64$decode(applyAsBase64);
							if (!_v6.$) {
								var applyDecoded = _v6.a;
								var _v7 = A2($elm$json$Json$Decode$decodeString, $author$project$Model$tkCurrentCandidateApplyDoJsonDecoder, applyDecoded);
								if (!_v7.$) {
									var applyParsed = _v7.a;
									return $elm$core$Maybe$Just(applyParsed);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						$author$project$Page$Home$extractCurrentApplyFromUrl(model.R));
					if (!maybeCurrentApplyFromUrl.$) {
						var currentApply = maybeCurrentApplyFromUrl.a;
						var $temp$msg = A3(
							$author$project$Page$Home$MsgLoadCandidateInfo,
							currentApply.dE,
							jobAdSummaryDo,
							_Utils_eq(currentApply.em, jobAdSummaryDo.ax) ? $elm$core$Maybe$Just(currentApply.dO) : $elm$core$Maybe$Nothing),
							$temp$model = model;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						switch (result.$) {
							case 1:
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
							case 0:
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
							case 2:
								return _Utils_Tuple3(
									model,
									model.V ? $author$project$T2$Util$msgToCmd(
										$author$project$Page$Home$MsgUserClickedSendMagicLink(model.N.cl)) : $author$project$Ports$renderGoogleSignInButton(
										{hq: jobAdSummaryDo.hq}),
									$author$project$Model$NoGlobalAction);
							default:
								var currentCandidateInfo = result.a;
								var maybeCurrentStep = currentCandidateInfo.dD ? $author$project$Page$Home$extractStageFromUrl(model.R) : $elm$core$Maybe$Nothing;
								var $temp$msg = A3($author$project$Page$Home$MsgLoadCandidateInfo, currentCandidateInfo, jobAdSummaryDo, maybeCurrentStep),
									$temp$model = model;
								msg = $temp$msg;
								model = $temp$model;
								continue update;
						}
					}
				case 4:
					var result = msg.a;
					switch (result.$) {
						case 1:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 0:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 2:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						default:
							var jobAdFilterQuestions = result.a;
							var filterQuestionsStageModel = model.A;
							var answersList = $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									function (e) {
										return _Utils_Tuple2(
											e.ax,
											{bI: $elm$core$Maybe$Nothing, cn: false, m: ''});
									},
									jobAdFilterQuestions));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										A: _Utils_update(
											filterQuestionsStageModel,
											{fW: answersList}),
										az: jobAdFilterQuestions
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Model$NoGlobalAction);
					}
				case 6:
					var candidateInfo = msg.a;
					var jobAdSummaryDo = msg.b;
					var maybeCurrentStep = msg.c;
					var newModel = function () {
						if ($elm$core$String$trim(candidateInfo.cl) === '') {
							return model;
						} else {
							var selectedExperienceLevelItem = A2(
								$elm$core$Maybe$andThen,
								function (experienceLevel) {
									return $elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function (_v22) {
												var item = _v22.b;
												return _Utils_eq(experienceLevel, item.m.m);
											},
											A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, $author$project$Model$experienceLevelItemsList)));
								},
								candidateInfo.cZ);
							var selectedExperienceLevelIndex = A2($elm$core$Maybe$map, $elm$core$Tuple$first, selectedExperienceLevelItem);
							var selectedExperienceLevel = A2($elm$core$Maybe$map, $elm$core$Tuple$second, selectedExperienceLevelItem);
							var selectedEducationLevelItem = A2(
								$elm$core$Maybe$andThen,
								function (educationLevel) {
									return $elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function (_v21) {
												var item = _v21.b;
												return _Utils_eq(educationLevel, item.m.m);
											},
											A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, $author$project$Model$educationLevelItems)));
								},
								candidateInfo.cY);
							var selectedEducationLevelIndex = A2($elm$core$Maybe$map, $elm$core$Tuple$first, selectedEducationLevelItem);
							var selectedEducationLevel = A2($elm$core$Maybe$map, $elm$core$Tuple$second, selectedEducationLevelItem);
							var selectedCategoryItem = A2(
								$elm$core$Maybe$andThen,
								function (category) {
									return $elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function (_v20) {
												var item = _v20.b;
												return _Utils_eq(category, item.m.m);
											},
											A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, $author$project$Model$categoryItemsList)));
								},
								candidateInfo.cS);
							var selectedCategoryIndex = A2($elm$core$Maybe$map, $elm$core$Tuple$first, selectedCategoryItem);
							var selectedCategory = A2($elm$core$Maybe$map, $elm$core$Tuple$second, selectedCategoryItem);
							var emailProcessed = $elm$core$String$trim(
								$elm$core$String$toLower(candidateInfo.cl));
							var emailError = $author$project$Page$Home$validateEmail(emailProcessed);
							var currentLoginModel = model.p;
							var currentExperienceLevelDropdownModel = model.o.ag;
							var currentEducationLevelDropdownModel = model.o.ad;
							var currentCvDo = A2(
								$elm$core$Maybe$andThen,
								function (attachmentPath) {
									return A2(
										$elm$core$Maybe$andThen,
										function (attachmentHash) {
											return A2(
												$elm$core$Maybe$map,
												function (mimeType) {
													return {cM: attachmentHash, f0: mimeType, cN: attachmentPath};
												},
												candidateInfo.c9);
										},
										candidateInfo.cM);
								},
								candidateInfo.cN);
							var currentCategoryDropdownModel = model.o.ab;
							var candidateInfoStageModel = model.c;
							var candidateInfoDo = candidateInfoStageModel.l;
							var emailField = candidateInfoDo.cl;
							var newEmailField = _Utils_update(
								emailField,
								{
									bI: emailError,
									cn: true,
									cr: emailProcessed,
									m: _Utils_eq(emailError, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(emailProcessed) : $elm$core$Maybe$Nothing
								});
							var newFullnameField = function () {
								var _v19 = candidateInfo.c1;
								if (!_v19.$) {
									var fullname = _v19.a;
									var fullnameProcessed = $elm$core$String$trim(fullname);
									var fullnameField = candidateInfoDo.c1;
									var fullnameError = $author$project$Page$Home$validateFullname(fullnameProcessed);
									return _Utils_update(
										fullnameField,
										{
											bI: fullnameError,
											cn: true,
											cr: fullnameProcessed,
											m: _Utils_eq(newEmailField.m, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : (_Utils_eq(fullnameError, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(fullnameProcessed) : $elm$core$Maybe$Nothing)
										});
								} else {
									return candidateInfoDo.c1;
								}
							}();
							var newPhoneField = function () {
								var _v16 = candidateInfo.eF;
								if (!_v16.$) {
									var phone = _v16.a;
									var removeWhiteSpacesRegex = '\\s';
									var phoneProcessed = function () {
										var _v17 = $elm$regex$Regex$fromString(removeWhiteSpacesRegex);
										if (_v17.$ === 1) {
											return $elm$core$String$trim(phone);
										} else {
											var regex = _v17.a;
											return $elm$core$String$trim(
												A3(
													$elm$regex$Regex$replace,
													regex,
													function (_v18) {
														return '';
													},
													phone));
										}
									}();
									var phoneWithCountryCode = (jobAdSummaryDo.gT === 'mx') ? (A2($elm$core$String$startsWith, '+52', phoneProcessed) ? phoneProcessed : ('+52' + phoneProcessed)) : phoneProcessed;
									var phoneField = candidateInfoDo.i6;
									var phoneError = A2($author$project$Page$Home$validatePhone, phoneWithCountryCode, jobAdSummaryDo.gT);
									return _Utils_update(
										phoneField,
										{
											bI: phoneError,
											cn: true,
											cr: phoneWithCountryCode,
											m: _Utils_eq(newFullnameField.m, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : (_Utils_eq(phoneError, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(phoneWithCountryCode) : $elm$core$Maybe$Nothing)
										});
								} else {
									return candidateInfoDo.i6;
								}
							}();
							var newLocationField = function () {
								var _v15 = candidateInfo.cs;
								if (!_v15.$) {
									var location = _v15.a;
									var newSelectedCity = A2(
										$elm$core$Maybe$andThen,
										function (cityId) {
											return A2(
												$elm$core$Maybe$andThen,
												function (cityName) {
													return A2(
														$elm$core$Maybe$andThen,
														function (regionName) {
															return A2(
																$elm$core$Maybe$map,
																function (regionId) {
																	return {gq: cityId, gr: cityName, jD: regionId, jE: regionName};
																},
																location.eR);
														},
														location.eS);
												},
												location.dJ);
										},
										location.dI);
									var locationField = candidateInfoDo.cs;
									var locationError = ($elm$core$String$trim(
										A2($elm$core$Maybe$withDefault, '', location.dU)) === '') ? $elm$core$Maybe$Just('Por favor ingresa el lugar donde vives') : $elm$core$Maybe$Nothing;
									return _Utils_update(
										locationField,
										{
											bI: locationError,
											cn: true,
											cr: A2($elm$core$Maybe$withDefault, '', location.dU),
											e4: newSelectedCity,
											m: _Utils_eq(newPhoneField.m, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : ((!_Utils_eq(newSelectedCity, $elm$core$Maybe$Nothing)) ? location.dU : $elm$core$Maybe$Nothing)
										});
								} else {
									return candidateInfoDo.cs;
								}
							}();
							var newHeadlineField = function () {
								var _v14 = candidateInfo.c4;
								if (!_v14.$) {
									var headline = _v14.a;
									var headlineProcessed = $elm$core$String$trim(headline);
									var headlineField = candidateInfoDo.c4;
									var headlineError = $author$project$Page$Home$validateHeadline(headlineProcessed);
									return _Utils_update(
										headlineField,
										{
											bI: headlineError,
											cn: true,
											cr: headlineProcessed,
											m: _Utils_eq(newLocationField.m, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : (_Utils_eq(headlineError, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(headlineProcessed) : $elm$core$Maybe$Nothing)
										});
								} else {
									return candidateInfoDo.c4;
								}
							}();
							var newActiveQuestion = _Utils_eq(newEmailField.m, $elm$core$Maybe$Nothing) ? 0 : (_Utils_eq(newFullnameField.m, $elm$core$Maybe$Nothing) ? 1 : (_Utils_eq(newPhoneField.m, $elm$core$Maybe$Nothing) ? 2 : (model.bz ? 3 : (_Utils_eq(newLocationField.m, $elm$core$Maybe$Nothing) ? 4 : (_Utils_eq(newHeadlineField.m, $elm$core$Maybe$Nothing) ? 5 : 6)))));
							var candidateCvStageModel = model.x;
							var candidateCvDo = candidateCvStageModel.B;
							var message = A2($elm$core$Maybe$withDefault, candidateCvDo.am, candidateInfo.am);
							var newCandidateCvDo = _Utils_update(
								candidateCvDo,
								{ge: currentCvDo, am: message, jf: !candidateInfo.eI});
							var applyQuestionsStageModelWithCandidateInfoUpdated = model.o;
							var applyQuestionsInfo = applyQuestionsStageModelWithCandidateInfoUpdated.q;
							var newCategory = function () {
								if (!selectedCategory.$) {
									var category = selectedCategory.a;
									return $elm$core$Maybe$Just(category.m);
								} else {
									return applyQuestionsInfo.cS.m;
								}
							}();
							var newEducationLevel = function () {
								if (!selectedEducationLevel.$) {
									var educationLevel = selectedEducationLevel.a;
									return $elm$core$Maybe$Just(educationLevel.m);
								} else {
									return applyQuestionsInfo.cY.m;
								}
							}();
							var newExperienceLevel = function () {
								if (!selectedExperienceLevel.$) {
									var experienceLevel = selectedExperienceLevel.a;
									return $elm$core$Maybe$Just(experienceLevel.m);
								} else {
									return applyQuestionsInfo.cZ.m;
								}
							}();
							var newApplyQuestionsInfo = _Utils_update(
								applyQuestionsInfo,
								{
									cS: {bI: $elm$core$Maybe$Nothing, m: newCategory},
									cY: {bI: $elm$core$Maybe$Nothing, m: newEducationLevel},
									cZ: {bI: $elm$core$Maybe$Nothing, m: newExperienceLevel},
									c_: {
										bI: $elm$core$Maybe$Nothing,
										m: A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, candidateInfo.c_))
									},
									jY: A2(
										$elm$core$Maybe$withDefault,
										applyQuestionsInfo.jY,
										A2(
											$elm$core$Maybe$map,
											function (skillList) {
												return $elm$core$Array$fromList(
													A2(
														$elm$core$List$map,
														function (skill) {
															return {bI: $elm$core$Maybe$Nothing, m: skill};
														},
														skillList));
											},
											candidateInfo.dk))
								});
							var modelWithNewApplyQuestionsInfo = _Utils_update(
								model,
								{
									o: _Utils_update(
										applyQuestionsStageModelWithCandidateInfoUpdated,
										{
											q: newApplyQuestionsInfo,
											ab: _Utils_update(
												currentCategoryDropdownModel,
												{
													a7: selectedCategoryIndex,
													a8: A2(
														$elm$core$Maybe$map,
														function ($) {
															return $.m;
														},
														selectedCategory)
												}),
											ad: _Utils_update(
												currentEducationLevelDropdownModel,
												{
													a7: selectedEducationLevelIndex,
													a8: A2(
														$elm$core$Maybe$map,
														function ($) {
															return $.m;
														},
														selectedEducationLevel)
												}),
											ag: _Utils_update(
												currentExperienceLevelDropdownModel,
												{
													a7: selectedExperienceLevelIndex,
													a8: A2(
														$elm$core$Maybe$map,
														function ($) {
															return $.m;
														},
														selectedExperienceLevel)
												})
										}),
									fZ: 7,
									x: _Utils_update(
										candidateCvStageModel,
										{
											B: newCandidateCvDo,
											bu: !_Utils_eq(newCandidateCvDo.ge, $elm$core$Maybe$Nothing)
										}),
									c: _Utils_update(
										candidateInfoStageModel,
										{
											w: newActiveQuestion,
											l: _Utils_update(
												candidateInfoDo,
												{cl: newEmailField, c1: newFullnameField, c4: newHeadlineField, cs: newLocationField, i6: newPhoneField}),
											bV: function () {
												if (!maybeCurrentStep.$) {
													return false;
												} else {
													return !model.bk;
												}
											}()
										}),
									p: _Utils_update(
										currentLoginModel,
										{ah: false, ai: false}),
									bU: candidateInfo.dD
								});
							var _v9 = $author$project$Page$Home$validateApplyQuestions(modelWithNewApplyQuestionsInfo);
							var modelWithApplyQuestionsValidated = _v9.a;
							return _Utils_eq(
								maybeCurrentStep,
								$elm$core$Maybe$Just(4)) ? _Utils_update(
								modelWithNewApplyQuestionsInfo,
								{V: false}) : _Utils_update(
								modelWithApplyQuestionsValidated,
								{V: false});
						}
					}();
					var loginModel = model.p;
					var logInToCompleteApplicationFromCustomMessage = newModel.V ? $author$project$T2$Util$msgToCmd(
						$author$project$Page$Home$MsgUserClickedSendMagicLink(model.N.cl)) : $elm$core$Platform$Cmd$none;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{
								fZ: A2($elm$core$Maybe$withDefault, 1, maybeCurrentStep),
								gT: candidateInfo.gT,
								ak: $elm$core$Maybe$Just(candidateInfo),
								p: _Utils_update(
									loginModel,
									{bW: true})
							}),
						logInToCompleteApplicationFromCustomMessage,
						$author$project$Model$NoGlobalAction);
				case 5:
					var newEmail = msg.a;
					var currentCandidateInfoStageModel = model.c;
					var currentApplyInfo = currentCandidateInfoStageModel.l;
					var currentEmailField = currentApplyInfo.cl;
					if (currentEmailField.cn) {
						var emailProcessed = $elm$core$String$trim(
							$elm$core$String$toLower(newEmail));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									c: _Utils_update(
										currentCandidateInfoStageModel,
										{
											l: _Utils_update(
												currentApplyInfo,
												{
													cl: _Utils_update(
														currentEmailField,
														{
															bI: $author$project$Page$Home$validateEmail(emailProcessed),
															cr: emailProcessed
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Model$NoGlobalAction);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									c: _Utils_update(
										currentCandidateInfoStageModel,
										{
											l: _Utils_update(
												currentApplyInfo,
												{
													cl: _Utils_update(
														currentEmailField,
														{cr: newEmail})
												})
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Model$NoGlobalAction);
					}
				case 14:
					var currentCandidateInfoStageModel = model.c;
					var currentApplyInfo = currentCandidateInfoStageModel.l;
					var currentEmailField = currentApplyInfo.cl;
					var emailProcessed = $elm$core$String$trim(
						$elm$core$String$toLower(currentEmailField.cr));
					var errorMessage = ((emailProcessed === '') && (!currentEmailField.cn)) ? currentEmailField.bI : $author$project$Page$Home$validateEmail(emailProcessed);
					var firstInputMade = ((emailProcessed === '') && (!currentEmailField.cn)) ? false : true;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{
										l: _Utils_update(
											currentApplyInfo,
											{
												cl: _Utils_update(
													currentEmailField,
													{bI: errorMessage, cn: firstInputMade, cr: emailProcessed})
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 7:
					var canSubmitEmail = !(!_Utils_eq(model.c.l.cl.bI, $elm$core$Maybe$Nothing));
					if (canSubmitEmail) {
						var currentCandidateInfoStageModel = model.c;
						var currentApplyInfo = currentCandidateInfoStageModel.l;
						var currentEmailField = currentApplyInfo.cl;
						var emailProcessed = $elm$core$String$trim(
							$elm$core$String$toLower(currentApplyInfo.cl.cr));
						var emailError = $author$project$Page$Home$validateEmail(emailProcessed);
						var newActiveQuestion = _Utils_eq(emailError, $elm$core$Maybe$Nothing) ? (currentCandidateInfoStageModel.D ? currentCandidateInfoStageModel.aA : 1) : currentCandidateInfoStageModel.w;
						var newIsEditingQuestion = _Utils_eq(emailError, $elm$core$Maybe$Nothing) ? false : currentCandidateInfoStageModel.D;
						var newEmailField = _Utils_update(
							currentEmailField,
							{bI: emailError, cn: true, cr: emailProcessed});
						var newEmailFieldWithValue = _Utils_eq(emailError, $elm$core$Maybe$Nothing) ? _Utils_update(
							newEmailField,
							{
								m: $elm$core$Maybe$Just(emailProcessed)
							}) : newEmailField;
						var newModel = _Utils_update(
							model,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{
										w: newActiveQuestion,
										l: _Utils_update(
											currentApplyInfo,
											{cl: newEmailFieldWithValue}),
										D: newIsEditingQuestion
									})
							});
						return _Utils_eq(emailError, $elm$core$Maybe$Nothing) ? _Utils_Tuple3(
							_Utils_update(
								newModel,
								{fZ: 1}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Ports$removeGoogleSignInButton(0),
										A2($author$project$Page$Home$checkAccountForEmail, model, emailProcessed)
									])),
							$author$project$Model$NoGlobalAction) : _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
					}
				case 8:
					var newFullname = msg.a;
					var currentCandidateInfoStageModel = model.c;
					var currentApplyInfo = currentCandidateInfoStageModel.l;
					var currentFullnameField = currentApplyInfo.c1;
					if (currentFullnameField.cn) {
						var fullnameProcessed = $elm$core$String$trim(newFullname);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									c: _Utils_update(
										currentCandidateInfoStageModel,
										{
											l: _Utils_update(
												currentApplyInfo,
												{
													c1: _Utils_update(
														currentFullnameField,
														{
															bI: $author$project$Page$Home$validateFullname(fullnameProcessed),
															cr: newFullname
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Model$NoGlobalAction);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									c: _Utils_update(
										currentCandidateInfoStageModel,
										{
											l: _Utils_update(
												currentApplyInfo,
												{
													c1: _Utils_update(
														currentFullnameField,
														{cr: newFullname})
												})
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Model$NoGlobalAction);
					}
				case 15:
					var currentCandidateInfoStageModel = model.c;
					var currentApplyInfo = currentCandidateInfoStageModel.l;
					var currentFullnameField = currentApplyInfo.c1;
					var fullnameProcessed = $elm$core$String$trim(currentFullnameField.cr);
					var errorMessage = ((fullnameProcessed === '') && (!currentFullnameField.cn)) ? currentFullnameField.bI : $author$project$Page$Home$validateFullname(fullnameProcessed);
					var firstInputMade = ((fullnameProcessed === '') && (!currentFullnameField.cn)) ? false : true;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{
										l: _Utils_update(
											currentApplyInfo,
											{
												c1: _Utils_update(
													currentFullnameField,
													{bI: errorMessage, cn: firstInputMade, cr: fullnameProcessed})
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 9:
					var canSubmitFullname = !((!_Utils_eq(model.c.l.c1.bI, $elm$core$Maybe$Nothing)) || (model.c.l.c1.cr === ''));
					if (canSubmitFullname) {
						var newModel = $author$project$Page$Home$getFullnameSubmittedAndValidatedModel(model);
						return _Utils_Tuple3(
							_Utils_update(
								newModel,
								{fZ: 1}),
							$elm$core$Platform$Cmd$none,
							$author$project$Model$NoGlobalAction);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
					}
				case 10:
					var jobAdSummaryDo = msg.a;
					var newPhone = msg.b;
					var currentCandidateInfoStageModel = model.c;
					var currentApplyInfo = currentCandidateInfoStageModel.l;
					var currentPhoneField = currentApplyInfo.i6;
					if (currentPhoneField.cn) {
						var removeWhiteSpacesRegex = '\\s';
						var phoneProcessed = function () {
							var _v23 = $elm$regex$Regex$fromString(removeWhiteSpacesRegex);
							if (_v23.$ === 1) {
								return $elm$core$String$trim(newPhone);
							} else {
								var regex = _v23.a;
								return $elm$core$String$trim(
									A3(
										$elm$regex$Regex$replace,
										regex,
										function (_v24) {
											return '';
										},
										newPhone));
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									c: _Utils_update(
										currentCandidateInfoStageModel,
										{
											l: _Utils_update(
												currentApplyInfo,
												{
													i6: _Utils_update(
														currentPhoneField,
														{
															bI: A2($author$project$Page$Home$validatePhone, phoneProcessed, jobAdSummaryDo.gT),
															cr: newPhone
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Model$NoGlobalAction);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									c: _Utils_update(
										currentCandidateInfoStageModel,
										{
											l: _Utils_update(
												currentApplyInfo,
												{
													i6: _Utils_update(
														currentPhoneField,
														{cr: newPhone})
												})
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Model$NoGlobalAction);
					}
				case 16:
					var jobAdSummaryDo = msg.a;
					var removeWhiteSpacesRegex = '\\s';
					var currentCandidateInfoStageModel = model.c;
					var currentApplyInfo = currentCandidateInfoStageModel.l;
					var currentPhoneField = currentApplyInfo.i6;
					var phoneProcessed = function () {
						var _v25 = $elm$regex$Regex$fromString(removeWhiteSpacesRegex);
						if (_v25.$ === 1) {
							return $elm$core$String$trim(currentPhoneField.cr);
						} else {
							var regex = _v25.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v26) {
										return '';
									},
									currentPhoneField.cr));
						}
					}();
					var errorMessage = ((phoneProcessed === '') && (!currentPhoneField.cn)) ? currentPhoneField.bI : A2($author$project$Page$Home$validatePhone, phoneProcessed, jobAdSummaryDo.gT);
					var firstInputMade = ((phoneProcessed === '') && (!currentPhoneField.cn)) ? false : true;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{
										l: _Utils_update(
											currentApplyInfo,
											{
												i6: _Utils_update(
													currentPhoneField,
													{bI: errorMessage, cn: firstInputMade})
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 11:
					var tkJobAdSummaryDo = msg.a;
					var canSubmitPhone = !((!_Utils_eq(model.c.l.i6.bI, $elm$core$Maybe$Nothing)) || (model.c.l.i6.cr === ''));
					if (canSubmitPhone) {
						var newModel = A2($author$project$Page$Home$getPhoneSubmittedAndValidatedModel, model, tkJobAdSummaryDo);
						return _Utils_Tuple3(
							_Utils_update(
								newModel,
								{fZ: 1}),
							$author$project$Ports$scrollToChatBottom(0),
							$author$project$Model$NoGlobalAction);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
					}
				case 12:
					var canSubmitLocation = !((!_Utils_eq(model.c.l.cs.bI, $elm$core$Maybe$Nothing)) || (model.c.l.cs.cr === ''));
					if (canSubmitLocation) {
						var newModel = $author$project$Page$Home$getLocationSubmittedAndValidatedModel(model);
						return _Utils_Tuple3(
							_Utils_update(
								newModel,
								{fZ: 1}),
							$author$project$Ports$scrollToChatBottom(0),
							$author$project$Model$NoGlobalAction);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
					}
				case 17:
					var newHeadline = msg.a;
					var currentCandidateInfoStageModel = model.c;
					var currentApplyInfo = currentCandidateInfoStageModel.l;
					var currentHeadlineField = currentApplyInfo.c4;
					if (currentHeadlineField.cn) {
						var headlineProcessed = $elm$core$String$trim(newHeadline);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									c: _Utils_update(
										currentCandidateInfoStageModel,
										{
											l: _Utils_update(
												currentApplyInfo,
												{
													c4: _Utils_update(
														currentHeadlineField,
														{
															bI: $author$project$Page$Home$validateHeadline(headlineProcessed),
															cr: newHeadline
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Model$NoGlobalAction);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									c: _Utils_update(
										currentCandidateInfoStageModel,
										{
											l: _Utils_update(
												currentApplyInfo,
												{
													c4: _Utils_update(
														currentHeadlineField,
														{cr: newHeadline})
												})
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Model$NoGlobalAction);
					}
				case 18:
					var currentCandidateInfoStageModel = model.c;
					var currentApplyInfo = currentCandidateInfoStageModel.l;
					var currentHeadlineField = currentApplyInfo.c4;
					var headlineProcessed = $elm$core$String$trim(currentHeadlineField.cr);
					var errorMessage = ((headlineProcessed === '') && (!currentHeadlineField.cn)) ? currentHeadlineField.bI : $author$project$Page$Home$validateHeadline(headlineProcessed);
					var firstInputMade = ((headlineProcessed === '') && (!currentHeadlineField.cn)) ? false : true;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{
										l: _Utils_update(
											currentApplyInfo,
											{
												c4: _Utils_update(
													currentHeadlineField,
													{bI: errorMessage, cn: firstInputMade})
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 19:
					var canSubmitHeadline = !((!_Utils_eq(model.c.l.c4.bI, $elm$core$Maybe$Nothing)) || (model.c.l.c4.cr === ''));
					if (canSubmitHeadline) {
						var newModel = $author$project$Page$Home$getHeadlineSubmittedAndValidatedModel(model);
						return _Utils_Tuple3(
							_Utils_update(
								newModel,
								{fZ: 1}),
							$author$project$Ports$scrollToChatBottom(0),
							$author$project$Model$NoGlobalAction);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
					}
				case 13:
					var question = msg.a;
					var currentCandidateInfoStageModel = model.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{w: question, D: true, aA: model.c.w})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 28:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fZ: 5}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 20:
					var tkJobAdInfo = msg.a;
					var currentCandidateInfoStageModel = model.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{bK: true})
							}),
						A2($author$project$Page$Home$submitCandidateInfo, model, tkJobAdInfo),
						$author$project$Model$NoGlobalAction);
				case 22:
					var question = msg.a;
					var answer = msg.b;
					var filterQuestionsStageModel = model.A;
					var firstInputMade = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.cn;
							},
							A2($elm$core$Dict$get, question.ax, filterQuestionsStageModel.fW)));
					var errorMessage = function () {
						if (firstInputMade) {
							var openAnswerMinCharacters = A2($elm$core$Maybe$withDefault, 2, question.i2);
							var openAnswerMaxCharacters = A2($elm$core$Maybe$withDefault, 80, question.i1);
							return (_Utils_cmp(
								$elm$core$String$length(answer),
								openAnswerMinCharacters) < 0) ? $elm$core$Maybe$Just(
								'Por favor ingresa entre ' + ($elm$core$String$fromInt(openAnswerMinCharacters) + (' y ' + ($elm$core$String$fromInt(openAnswerMaxCharacters) + ' caracteres')))) : $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					var answerDo = {bI: errorMessage, cn: true, m: answer};
					var newAnswersList = A3($elm$core$Dict$insert, question.ax, answerDo, filterQuestionsStageModel.fW);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								A: _Utils_update(
									filterQuestionsStageModel,
									{fW: newAnswersList})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 23:
					var question = msg.a;
					var answer = msg.b;
					var filterQuestionsStageModel = model.A;
					var currentAnswer = A2(
						$elm$core$Maybe$map,
						function (e) {
							return _Utils_update(
								e,
								{cn: true});
						},
						A2($elm$core$Dict$get, question.ax, filterQuestionsStageModel.fW));
					var newAnswersList = A2(
						$elm$core$Maybe$withDefault,
						filterQuestionsStageModel.fW,
						A2(
							$elm$core$Maybe$map,
							function (e) {
								return A3($elm$core$Dict$insert, question.ax, e, filterQuestionsStageModel.fW);
							},
							currentAnswer));
					var $temp$msg = A2($author$project$Page$Home$MsgUserChangedOpenFilterQuestionAnswer, question, answer),
						$temp$model = _Utils_update(
						model,
						{
							A: _Utils_update(
								filterQuestionsStageModel,
								{fW: newAnswersList}),
							a6: false
						});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 24:
					var question = msg.a;
					var answer = msg.b;
					var filterQuestionsStageModel = model.A;
					var answerDo = {bI: $elm$core$Maybe$Nothing, cn: false, m: answer};
					var newAnswersList = A3($elm$core$Dict$insert, question.ax, answerDo, filterQuestionsStageModel.fW);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								A: _Utils_update(
									filterQuestionsStageModel,
									{fW: newAnswersList})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 25:
					var validateSkillAndAddErrorMessage = function (skill) {
						return _Utils_update(
							skill,
							{bI: $elm$core$Maybe$Nothing});
					};
					var currentApplyQuestionsStageModel = model.o;
					var currentSkillsField = currentApplyQuestionsStageModel.q.jY;
					var newSkillsWithErrorMessages = A2($elm$core$Array$map, validateSkillAndAddErrorMessage, currentSkillsField);
					var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.q;
					var currentCategoryField = currentApplyQuestionsInfo.cS;
					var currentEducationLevelField = currentApplyQuestionsInfo.cY;
					var currentExperienceLevelField = currentApplyQuestionsInfo.cZ;
					var currentExperienceYearsField = currentApplyQuestionsInfo.c_;
					var newModelErrorsCleaned = _Utils_update(
						model,
						{
							o: _Utils_update(
								currentApplyQuestionsStageModel,
								{
									q: _Utils_update(
										currentApplyQuestionsInfo,
										{
											cS: _Utils_update(
												currentCategoryField,
												{bI: $elm$core$Maybe$Nothing}),
											cY: _Utils_update(
												currentEducationLevelField,
												{bI: $elm$core$Maybe$Nothing}),
											cZ: _Utils_update(
												currentExperienceLevelField,
												{bI: $elm$core$Maybe$Nothing}),
											c_: _Utils_update(
												currentExperienceYearsField,
												{bI: $elm$core$Maybe$Nothing}),
											jY: newSkillsWithErrorMessages
										})
								})
						});
					return _Utils_Tuple3(
						_Utils_update(
							newModelErrorsCleaned,
							{fZ: 4}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 26:
					var isOpenAnswerOutOfLimits = F2(
						function (question, answer) {
							return (question.kG === 'OPEN_QUESTION_TYPE') && ((_Utils_cmp(
								$elm$core$String$length(answer.m),
								A2($elm$core$Maybe$withDefault, 2, question.i2)) < 0) || (_Utils_cmp(
								$elm$core$String$length(answer.m),
								A2($elm$core$Maybe$withDefault, 80, question.i1)) > 0));
						});
					var filterQuestionsStageModel = model.A;
					var maxRetriesReached = filterQuestionsStageModel.bP >= 2;
					var hasOpenAnswerOutOfLimits = (!maxRetriesReached) && A2(
						$elm$core$List$any,
						function (filterQuestion) {
							return A2(
								isOpenAnswerOutOfLimits,
								filterQuestion,
								A2(
									$elm$core$Maybe$withDefault,
									{bI: $elm$core$Maybe$Nothing, cn: false, m: ''},
									A2($elm$core$Dict$get, filterQuestion.ax, filterQuestionsStageModel.fW)));
						},
						model.az);
					var validateAnswer = F2(
						function (question, answer) {
							var openAnswerMinCharacters = A2($elm$core$Maybe$withDefault, 2, question.i2);
							var openAnswerMaxCharacters = A2($elm$core$Maybe$withDefault, 80, question.i1);
							return (question.kG === 'OPEN_QUESTION_TYPE') ? ((A2(isOpenAnswerOutOfLimits, question, answer) && (!maxRetriesReached)) ? _Utils_update(
								answer,
								{
									bI: $elm$core$Maybe$Just(
										'Por favor ingresa entre ' + ($elm$core$String$fromInt(openAnswerMinCharacters) + (' y ' + ($elm$core$String$fromInt(openAnswerMaxCharacters) + ' caracteres'))))
								}) : _Utils_update(
								answer,
								{bI: $elm$core$Maybe$Nothing})) : ((answer.m === '') ? _Utils_update(
								answer,
								{
									bI: $elm$core$Maybe$Just('Por favor selecciona una opción')
								}) : answer);
						});
					var validatedAnswers = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (filterQuestion) {
								return A2(
									$elm$core$Maybe$withDefault,
									_Utils_Tuple2(
										filterQuestion.ax,
										A2(
											validateAnswer,
											filterQuestion,
											{bI: $elm$core$Maybe$Nothing, cn: false, m: ''})),
									A2(
										$elm$core$Maybe$map,
										function (answer) {
											return _Utils_Tuple2(
												filterQuestion.ax,
												A2(validateAnswer, filterQuestion, answer));
										},
										A2($elm$core$Dict$get, filterQuestion.ax, filterQuestionsStageModel.fW)));
							},
							model.az));
					var modelWithFilterQuestionsValidated = _Utils_update(
						model,
						{
							A: _Utils_update(
								filterQuestionsStageModel,
								{
									fW: validatedAnswers,
									bP: hasOpenAnswerOutOfLimits ? (filterQuestionsStageModel.bP + 1) : filterQuestionsStageModel.bP
								})
						});
					var areErrors = A2(
						$elm$core$List$any,
						function (answer) {
							return $author$project$T2$Util$isJust(answer.bI);
						},
						$elm$core$Dict$values(validatedAnswers));
					return areErrors ? _Utils_Tuple3(modelWithFilterQuestionsValidated, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction) : _Utils_Tuple3(
						_Utils_update(
							modelWithFilterQuestionsValidated,
							{
								A: _Utils_update(
									filterQuestionsStageModel,
									{bL: true})
							}),
						$author$project$Page$Home$submitFilterQuestions(model),
						$author$project$Model$NoGlobalAction);
				case 27:
					var response = msg.a;
					switch (response.$) {
						case 1:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 0:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 2:
							var currentFilterQuestionsStageModel = model.A;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										A: _Utils_update(
											currentFilterQuestionsStageModel,
											{
												bL: false,
												Q: $elm$core$Maybe$Just('Ha ocurrido un error en el proceso de aplicación, por favor intenta nuevamente.')
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideFilterQuestionsStageErrorMessage),
								$author$project$Model$NoGlobalAction);
						default:
							var currentFilterQuestionsStageModel = model.A;
							var _v28 = A3($author$project$Page$Home$updateUrlWithCurrentCandidateApplyInfo, model, 3, 4);
							var newModel = _v28.a;
							var updateUrlCmd = _v28.b;
							return _Utils_Tuple3(
								_Utils_update(
									newModel,
									{
										fZ: 4,
										A: _Utils_update(
											currentFilterQuestionsStageModel,
											{bL: false})
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Ports$scrollToChatTop(0),
											updateUrlCmd
										])),
								$author$project$Model$NoGlobalAction);
					}
				case 29:
					var currentFilterQuestionsStageModel = model.A;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								A: _Utils_update(
									currentFilterQuestionsStageModel,
									{Q: $elm$core$Maybe$Nothing})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 21:
					var jobAdId = msg.a;
					var jobAdSummaryDo = msg.b;
					var response = msg.c;
					switch (response.$) {
						case 1:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 0:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 2:
							var currentCandidateInfoStageModel = model.c;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										c: _Utils_update(
											currentCandidateInfoStageModel,
											{
												bK: false,
												Q: $elm$core$Maybe$Just('Ha ocurrido un error en el proceso de aplicación, por favor intenta nuevamente.')
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideCandidateInfoStageErrorMessage),
								$author$project$Model$NoGlobalAction);
						default:
							var nextStep = model.bk ? 2 : ((!$elm$core$List$length(model.az)) ? 4 : 3);
							var currentCandidateInfoStageModel = model.c;
							var _v30 = A3($author$project$Page$Home$updateUrlWithCurrentCandidateApplyInfo, model, 1, nextStep);
							var newModel = _v30.a;
							var updateUrlCmd = _v30.b;
							var externalApplyCmds = model.bk ? _List_fromArray(
								[
									A3($author$project$Page$Home$trackExternalApplication, model, jobAdId, jobAdSummaryDo.gH),
									$author$project$Page$Home$delayHideNotification(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Page$Home$PassThrough,
										A2(
											$elm$core$Maybe$map,
											function (url) {
												return $author$project$Page$Home$MsgRedirectToExternalUrl(url);
											},
											jobAdSummaryDo.g8)))
								]) : _List_fromArray(
								[updateUrlCmd]);
							return _Utils_Tuple3(
								_Utils_update(
									newModel,
									{
										fZ: nextStep,
										c: _Utils_update(
											currentCandidateInfoStageModel,
											{bK: false})
									}),
								$elm$core$Platform$Cmd$batch(
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Ports$trackInitiateApplication(
												{em: jobAdId, W: model.W}),
												$author$project$Ports$scrollToChatTop(0)
											]),
										externalApplyCmds)),
								$author$project$Model$NoGlobalAction);
					}
				case 52:
					var currentCandidateInfoStageModel = model.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{Q: $elm$core$Maybe$Nothing})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 32:
					var index = msg.a;
					var currentApplyQuestionsStageModel = model.o;
					var dropdownModel = currentApplyQuestionsStageModel.ab;
					var selected = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.m;
						},
						A2(
							$elm$core$Array$get,
							index,
							$elm$core$Array$fromList(currentApplyQuestionsStageModel.ab.bp)));
					var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.q;
					var currentCategoryField = currentApplyQuestionsInfo.cS;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										q: _Utils_update(
											currentApplyQuestionsInfo,
											{
												cS: _Utils_update(
													currentCategoryField,
													{bI: $elm$core$Maybe$Nothing, m: selected})
											}),
										ab: _Utils_update(
											dropdownModel,
											{
												a7: $elm$core$Maybe$Just(index),
												a8: selected,
												K: 0
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 30:
					var currentApplyQuestionsStageModel = model.o;
					var dropdownModel = currentApplyQuestionsStageModel.ab;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										ab: _Utils_update(
											dropdownModel,
											{
												K: $author$project$T2$Dropdown$toggleState(currentApplyQuestionsStageModel.ab.K)
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 31:
					var currentApplyQuestionsStageModel = model.o;
					var dropdownModel = currentApplyQuestionsStageModel.ab;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										ab: _Utils_update(
											dropdownModel,
											{K: 0})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 33:
					var currentApplyQuestionsStageModel = model.o;
					var dropdownModel = currentApplyQuestionsStageModel.ag;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										ag: _Utils_update(
											dropdownModel,
											{
												K: $author$project$T2$Dropdown$toggleState(currentApplyQuestionsStageModel.ag.K)
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 34:
					var currentApplyQuestionsStageModel = model.o;
					var dropdownModel = currentApplyQuestionsStageModel.ag;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										ag: _Utils_update(
											dropdownModel,
											{K: 0})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 35:
					var index = msg.a;
					var currentApplyQuestionsStageModel = model.o;
					var dropdownModel = currentApplyQuestionsStageModel.ag;
					var selected = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.m;
						},
						A2(
							$elm$core$Array$get,
							index,
							$elm$core$Array$fromList(currentApplyQuestionsStageModel.ag.bp)));
					var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.q;
					var currentExperienceField = currentApplyQuestionsInfo.cZ;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										q: _Utils_update(
											currentApplyQuestionsInfo,
											{
												cZ: _Utils_update(
													currentExperienceField,
													{bI: $elm$core$Maybe$Nothing, m: selected})
											}),
										ag: _Utils_update(
											dropdownModel,
											{
												a7: $elm$core$Maybe$Just(index),
												a8: selected,
												K: 0
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 36:
					var currentApplyQuestionsStageModel = model.o;
					var dropdownModel = currentApplyQuestionsStageModel.ad;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										ad: _Utils_update(
											dropdownModel,
											{
												K: $author$project$T2$Dropdown$toggleState(currentApplyQuestionsStageModel.ad.K)
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 37:
					var currentApplyQuestionsStageModel = model.o;
					var dropdownModel = currentApplyQuestionsStageModel.ad;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										ad: _Utils_update(
											dropdownModel,
											{K: 0})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 38:
					var index = msg.a;
					var currentApplyQuestionsStageModel = model.o;
					var dropdownModel = currentApplyQuestionsStageModel.ad;
					var selected = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.m;
						},
						A2(
							$elm$core$Array$get,
							index,
							$elm$core$Array$fromList(currentApplyQuestionsStageModel.ad.bp)));
					var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.q;
					var currentEducationLevelField = currentApplyQuestionsInfo.cY;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										q: _Utils_update(
											currentApplyQuestionsInfo,
											{
												cY: _Utils_update(
													currentEducationLevelField,
													{bI: $elm$core$Maybe$Nothing, m: selected})
											}),
										ad: _Utils_update(
											dropdownModel,
											{
												a7: $elm$core$Maybe$Just(index),
												a8: selected,
												K: 0
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 42:
					var experienceYears = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var experienceYearsProcessed = function () {
						var _v31 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v31.$ === 1) {
							return $elm$core$String$trim(experienceYears);
						} else {
							var regex = _v31.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v32) {
										return '';
									},
									experienceYears));
						}
					}();
					var currentApplyQuestionsStageModel = model.o;
					var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.q;
					var currentExperienceYearsField = currentApplyQuestionsInfo.c_;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										q: _Utils_update(
											currentApplyQuestionsInfo,
											{
												c_: _Utils_update(
													currentExperienceYearsField,
													{m: experienceYearsProcessed})
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 39:
					var index = msg.a;
					var skillValue = msg.b;
					var currentApplyQuestionsStageModel = model.o;
					var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.q;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										q: _Utils_update(
											currentApplyQuestionsInfo,
											{
												jY: A3(
													$elm$core$Array$set,
													index,
													{bI: $elm$core$Maybe$Nothing, m: skillValue},
													currentApplyQuestionsInfo.jY)
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 40:
					var currentApplyQuestionsStageModel = model.o;
					var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.q;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										q: _Utils_update(
											currentApplyQuestionsInfo,
											{
												jY: A2(
													$elm$core$Array$push,
													{bI: $elm$core$Maybe$Nothing, m: ''},
													currentApplyQuestionsInfo.jY)
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 41:
					var index = msg.a;
					var currentApplyQuestionsStageModel = model.o;
					var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.q;
					var a2 = A3(
						$elm$core$Array$slice,
						index + 1,
						$elm$core$Array$length(currentApplyQuestionsInfo.jY),
						currentApplyQuestionsInfo.jY);
					var a1 = A3($elm$core$Array$slice, 0, index, currentApplyQuestionsInfo.jY);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										q: _Utils_update(
											currentApplyQuestionsInfo,
											{
												jY: A2($elm$core$Array$append, a1, a2)
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 44:
					var _v33 = $author$project$Page$Home$validateApplyQuestions(model);
					var modelWithApplyQuestionsValidated = _v33.a;
					var areErrors = _v33.b;
					var applyQuestionsStageModel = modelWithApplyQuestionsValidated.o;
					return areErrors ? _Utils_Tuple3(modelWithApplyQuestionsValidated, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction) : _Utils_Tuple3(
						_Utils_update(
							modelWithApplyQuestionsValidated,
							{
								o: _Utils_update(
									applyQuestionsStageModel,
									{bJ: true})
							}),
						$author$project$Page$Home$submitApplyQuestions(model),
						$author$project$Model$NoGlobalAction);
				case 45:
					var response = msg.a;
					switch (response.$) {
						case 1:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 0:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 2:
							var currentApplyQuestionsStageModel = model.o;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										o: _Utils_update(
											currentApplyQuestionsStageModel,
											{
												bJ: false,
												Q: $elm$core$Maybe$Just('Ha ocurrido un error en el proceso de aplicación, por favor intenta nuevamente.')
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideApplyQuestionsStageErrorMessage),
								$author$project$Model$NoGlobalAction);
						default:
							var currentApplyQuestionsStageModel = model.o;
							var _v35 = A3($author$project$Page$Home$updateUrlWithCurrentCandidateApplyInfo, model, 4, 5);
							var newModel = _v35.a;
							var cmd = _v35.b;
							return _Utils_Tuple3(
								_Utils_update(
									newModel,
									{
										o: _Utils_update(
											currentApplyQuestionsStageModel,
											{bJ: false}),
										fZ: 5
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Ports$scrollToChatTop(0),
											cmd
										])),
								$author$project$Model$NoGlobalAction);
					}
				case 53:
					var currentApplyQuestionsStageModel = model.o;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentApplyQuestionsStageModel,
									{Q: $elm$core$Maybe$Nothing})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 46:
					var newMessage = msg.a;
					var currentCandidateCvStageModel = model.x;
					var currentCandidateCvInfo = currentCandidateCvStageModel.B;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								x: _Utils_update(
									currentCandidateCvStageModel,
									{
										B: _Utils_update(
											currentCandidateCvInfo,
											{am: newMessage})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 47:
					var newValue = msg.a;
					var currentCandidateCvStageModel = model.x;
					var currentCandidateCvInfo = currentCandidateCvStageModel.B;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								x: _Utils_update(
									currentCandidateCvStageModel,
									{
										B: _Utils_update(
											currentCandidateCvInfo,
											{j9: newValue})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 48:
					var newValue = msg.a;
					var currentCandidateCvStageModel = model.x;
					var currentCandidateCvInfo = currentCandidateCvStageModel.B;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								x: _Utils_update(
									currentCandidateCvStageModel,
									{
										B: _Utils_update(
											currentCandidateCvInfo,
											{jf: newValue})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 49:
					var currentCandidateCvStageModel = model.x;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								x: _Utils_update(
									currentCandidateCvStageModel,
									{bu: true})
							}),
						$author$project$Ports$scrollToChatBottom(0),
						$author$project$Model$NoGlobalAction);
				case 103:
					return _Utils_Tuple3(
						model,
						$author$project$Ports$fileSelected($author$project$Page$Home$cvInputFieldIdForApply),
						$author$project$Model$NoGlobalAction);
				case 104:
					var maybeFile = msg.a;
					if (!maybeFile.$) {
						var file = maybeFile.a;
						if (file.hb > 11010048) {
							var currentCandidateCvStageModel = model.x;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										x: _Utils_update(
											currentCandidateCvStageModel,
											{
												aM: $elm$core$Maybe$Just('El CV que has intentado subir excede los límites. El archivo debe ser de máximo 10MB.')
											}),
										ay: false
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideCandidateCVStageErrorMessage),
								$author$project$Model$NoGlobalAction);
						} else {
							if (!A2($elm$core$List$member, file.d1, $author$project$T2$ApiModel$cvFileTypeAccepted)) {
								var currentCandidateCvStageModel = model.x;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											x: _Utils_update(
												currentCandidateCvStageModel,
												{
													aM: $elm$core$Maybe$Just('El CV que has intentado subir no es admitido.')
												}),
											ay: false
										}),
									$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideCandidateCVStageErrorMessage),
									$author$project$Model$NoGlobalAction);
							} else {
								var currentCandidateCvStageModel = model.x;
								var currentCandidateCvInfo = currentCandidateCvStageModel.B;
								var arrayBytesMaybe = A2(
									$elm$core$Maybe$map,
									function (index) {
										return A3(
											$elm$core$String$slice,
											index + 1,
											$elm$core$String$length(file.cV),
											file.cV);
									},
									$elm$core$List$head(
										A2($elm$core$String$indexes, ',', file.cV)));
								var candidateNewCv = A2(
									$elm$core$Maybe$map,
									function (arrayBytes) {
										return {f$: arrayBytes, ha: file.ha, c9: file.d1};
									},
									arrayBytesMaybe);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											x: _Utils_update(
												currentCandidateCvStageModel,
												{
													B: _Utils_update(
														currentCandidateCvInfo,
														{gl: candidateNewCv})
												}),
											ay: false
										}),
									$author$project$Ports$scrollToChatBottom(0),
									$author$project$Model$NoGlobalAction);
							}
						}
					} else {
						var reportErrorCmd = $author$project$T2$Log$error(
							{am: 'Unable to get a cv-file on candidate gelada apply '});
						var currentCandidateCvStageModel = model.x;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									x: _Utils_update(
										currentCandidateCvStageModel,
										{
											aM: $elm$core$Maybe$Just('Hubo un problema a procesar el CV que has intentado subir. Reintenta por favor.')
										}),
									ay: false
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										reportErrorCmd,
										$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideCandidateCVStageErrorMessage)
									])),
							$author$project$Model$NoGlobalAction);
					}
				case 105:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ay: true}),
						$author$project$Ports$triggerUploadButton($author$project$Page$Home$cvInputFieldIdForApply),
						$author$project$Model$NoGlobalAction);
				case 106:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ay: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 51:
					var currentCandidateCvStageModel = model.x;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								x: _Utils_update(
									currentCandidateCvStageModel,
									{aM: $elm$core$Maybe$Nothing})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 50:
					var currentCandidateCvStageModel = model.x;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								x: _Utils_update(
									currentCandidateCvStageModel,
									{bo: true})
							}),
						$author$project$Page$Home$submitCandidateCv(model),
						$author$project$Model$NoGlobalAction);
				case 54:
					var jobAdId = msg.a;
					var companyName = msg.b;
					var response = msg.c;
					var currentCandidateCvStageModel = model.x;
					var errorModelAndCmd = _Utils_Tuple3(
						_Utils_update(
							model,
							{
								x: _Utils_update(
									currentCandidateCvStageModel,
									{
										bo: false,
										aM: $elm$core$Maybe$Just('Ha ocurrido un error en el proceso de aplicación, por favor intenta nuevamente.')
									})
							}),
						$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideCandidateCVStageErrorMessage),
						$author$project$Model$NoGlobalAction);
					switch (response.$) {
						case 1:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 0:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 2:
							return errorModelAndCmd;
						default:
							var result = response.a;
							if (result.kc) {
								var _v38 = result.kb;
								if (!_v38.$) {
									var successUri = _v38.a;
									var newModel = _Utils_update(
										model,
										{
											x: _Utils_update(
												currentCandidateCvStageModel,
												{bo: false})
										});
									var localCmds = _List_fromArray(
										[
											$author$project$Ports$refreshCandidateSession(
											{kd: successUri}),
											$author$project$Ports$trackCompleteApplication(
											{
												gI: A2(
													$elm$core$Maybe$map,
													function (cn) {
														return $elm_community$string_extra$String$Extra$classify(
															$elm_community$string_extra$String$Extra$removeAccents(cn));
													},
													companyName),
												em: jobAdId,
												W: model.W
											})
										]);
									var modelWithFinalStep = _Utils_Tuple3(
										newModel,
										$elm$core$Platform$Cmd$batch(localCmds),
										$author$project$Model$NoGlobalAction);
									return modelWithFinalStep;
								} else {
									return errorModelAndCmd;
								}
							} else {
								var _v39 = result.bI;
								if (!_v39.$) {
									var errorCode = _v39.a;
									var warningMessage = function () {
										switch (errorCode) {
											case 'invalid_cv_mime_type':
												return 'El formato del CV que has intentado subir no está permitido. Los formatos permitos son: imágenes, PDFs y documentos';
											case 'cv_size_exceeded':
												return 'El CV que has intentado subir excede los límites. El archivo debe ser de máximo 10MB.';
											default:
												return 'Ocurrió un error al subir tu CV, reintenta por favor. Si el error persiste comunícate con nosotros.';
										}
									}();
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												x: _Utils_update(
													currentCandidateCvStageModel,
													{
														bo: false,
														aM: $elm$core$Maybe$Just(warningMessage)
													})
											}),
										$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideCandidateCVStageErrorMessage),
										$author$project$Model$NoGlobalAction);
								} else {
									return errorModelAndCmd;
								}
							}
					}
				case 102:
					var response = msg.a;
					var _v41 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, response);
					if (!_v41.$) {
						var successUrl = _v41.a;
						return _Utils_Tuple3(
							model,
							$elm$browser$Browser$Navigation$load(successUrl),
							$author$project$Model$NoGlobalAction);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
					}
				case 55:
					return _Utils_Tuple3(
						model,
						$elm$browser$Browser$Navigation$load('/postular?j_id=000000000000000000000000'),
						$author$project$Model$NoGlobalAction);
				case 56:
					return _Utils_Tuple3(
						model,
						$elm$browser$Browser$Navigation$load('/empleos'),
						$author$project$Model$NoGlobalAction);
				case 78:
					var url = msg.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$elm$browser$Browser$Navigation$load(url),
									$author$project$Ports$redirectoToExternalUrl(
									{g8: url})
								])),
						$author$project$Model$NoGlobalAction);
				case 57:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bY: true}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 58:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bY: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 59:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bv: true}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 60:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bv: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 61:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bX: true}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 62:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bX: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 63:
					var newEmail = msg.a;
					var sendToFriendModel = model.r;
					var email = sendToFriendModel.cl;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									sendToFriendModel,
									{
										cl: _Utils_update(
											email,
											{m: newEmail})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 64:
					var newName = msg.a;
					var sendToFriendModel = model.r;
					var name = sendToFriendModel.aC;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									sendToFriendModel,
									{
										aC: _Utils_update(
											name,
											{m: newName})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 65:
					var newEmail = msg.a;
					var sendToFriendModel = model.r;
					var friendEmail = sendToFriendModel.av;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									sendToFriendModel,
									{
										av: _Utils_update(
											friendEmail,
											{m: newEmail})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 66:
					var newName = msg.a;
					var sendToFriendModel = model.r;
					var friendName = sendToFriendModel.aw;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									sendToFriendModel,
									{
										aw: _Utils_update(
											friendName,
											{m: newName})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 67:
					var newValue = msg.a;
					var sendToFriendModel = model.r;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									sendToFriendModel,
									{cC: newValue})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 68:
					var sendToFriendModel = model.r;
					var name = sendToFriendModel.aC;
					var nameError = ($elm$core$String$trim(name.m) === '') ? $elm$core$Maybe$Just('Ingresa tu nombre') : $elm$core$Maybe$Nothing;
					var friendName = sendToFriendModel.aw;
					var friendNameError = ($elm$core$String$trim(friendName.m) === '') ? $elm$core$Maybe$Just('Ingresa el nombre de tu amigo') : $elm$core$Maybe$Nothing;
					var friendEmail = sendToFriendModel.av;
					var friendEmailError = $author$project$Page$Home$validateEmail(friendEmail.m);
					var email = sendToFriendModel.cl;
					var emailError = $author$project$Page$Home$validateEmail(email.m);
					var newModelAndCmd = (_Utils_eq(emailError, $elm$core$Maybe$Nothing) && (_Utils_eq(nameError, $elm$core$Maybe$Nothing) && (_Utils_eq(friendEmailError, $elm$core$Maybe$Nothing) && _Utils_eq(friendNameError, $elm$core$Maybe$Nothing)))) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									sendToFriendModel,
									{E: true})
							}),
						$author$project$Page$Home$sendSendToFriendForm(model),
						$author$project$Model$NoGlobalAction) : _Utils_Tuple3(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									sendToFriendModel,
									{
										cl: _Utils_update(
											email,
											{bI: emailError}),
										av: _Utils_update(
											friendEmail,
											{bI: friendEmailError}),
										aw: _Utils_update(
											friendName,
											{bI: friendNameError}),
										aC: _Utils_update(
											name,
											{bI: nameError})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
					return newModelAndCmd;
				case 69:
					var response = msg.a;
					switch (response.$) {
						case 1:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 0:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 2:
							var sendToFriendModel = model.r;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										r: _Utils_update(
											sendToFriendModel,
											{
												E: false,
												Q: $elm$core$Maybe$Just('Ha ocurrido un error al enviar a un amigo, por favor intenta nuevamente.')
											})
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Model$NoGlobalAction);
						default:
							var result = response.a;
							if (result === 'true') {
								var sendToFriendModel = model.r;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											r: _Utils_update(
												sendToFriendModel,
												{E: false, cD: true})
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Model$NoGlobalAction);
							} else {
								var sendToFriendModel = model.r;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											r: _Utils_update(
												sendToFriendModel,
												{
													E: false,
													Q: $elm$core$Maybe$Just('Ha ocurrido un error al enviar la vacante, por favor intenta nuevamente.'),
													cD: false
												})
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Model$NoGlobalAction);
							}
					}
				case 70:
					var response = msg.a;
					switch (response.$) {
						case 1:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 0:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 2:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						default:
							var result = response.a;
							var existAccount = result.hv;
							var showCandidateNotLoggedInMessage = existAccount;
							var currentMagicLinkCodeValidationModel = model.n;
							var currentLoginModel = model.p;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										N: result,
										p: _Utils_update(
											currentLoginModel,
											{ai: showCandidateNotLoggedInMessage}),
										n: _Utils_update(
											currentMagicLinkCodeValidationModel,
											{a9: false})
									}),
								showCandidateNotLoggedInMessage ? A2(
									$elm$core$Task$attempt,
									$author$project$Page$Home$MsgBrowserGetContinueWithTalentecaWidthResult,
									$elm$browser$Browser$Dom$getElement('continueWithTalentecaButton')) : $elm$core$Platform$Cmd$none,
								$author$project$Model$NoGlobalAction);
					}
				case 71:
					var currentLoginModel = model.p;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								V: false,
								p: _Utils_update(
									currentLoginModel,
									{ah: false, ai: false}),
								n: {co: false, E: false, aX: '', aY: '', aZ: '', a_: '', a$: '', a0: '', a9: false, bA: 0}
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 72:
					var email = msg.a;
					var loginModel = model.p;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								p: _Utils_update(
									loginModel,
									{E: true})
							}),
						A2($author$project$Page$Home$sendMagicLinkLogin, model, email),
						$author$project$Model$NoGlobalAction);
				case 73:
					var response = msg.a;
					var loginModel = model.p;
					switch (response.$) {
						case 1:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 0:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										V: false,
										p: _Utils_update(
											loginModel,
											{
												E: false,
												ao: $elm$core$Maybe$Just('Hubo un fallo al procesar tu solicitud. Por favor continúa tu proceso de postulación'),
												ah: false,
												ai: false
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton),
								$author$project$Model$NoGlobalAction);
						default:
							var result = response.a;
							var currentMagicLinkCodeValidationModel = model.n;
							var newModelAndCmd = (result.dm === 'ok') ? _Utils_Tuple3(
								_Utils_update(
									model,
									{
										p: _Utils_update(
											loginModel,
											{E: false}),
										n: _Utils_update(
											currentMagicLinkCodeValidationModel,
											{a9: true})
									}),
								A2(
									$elm$core$Task$attempt,
									function (_v45) {
										return $author$project$Page$Home$PassThrough;
									},
									$elm$browser$Browser$Dom$focus('magic-link-input-1')),
								$author$project$Model$NoGlobalAction) : ((result.dm === 'email-wrong') ? _Utils_Tuple3(
								_Utils_update(
									model,
									{
										V: false,
										p: _Utils_update(
											loginModel,
											{
												E: false,
												ao: $elm$core$Maybe$Just(
													'El correo electrónico ingresado no es correcto.' + A2(
														$elm$core$Maybe$withDefault,
														'',
														A2(
															$elm$core$Maybe$map,
															function (h) {
																return ' ¿Quizás quisiste decir: ' + h;
															},
															result.gg))),
												ah: false,
												ai: false
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton),
								$author$project$Model$NoGlobalAction) : ((result.dm === 'failed') ? _Utils_Tuple3(
								_Utils_update(
									model,
									{
										V: false,
										p: _Utils_update(
											loginModel,
											{
												E: false,
												ao: $elm$core$Maybe$Just('Hubo un fallo al procesar tu solicitud. Por favor continúa tu proceso de postulación'),
												ah: false,
												ai: false
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton),
								$author$project$Model$NoGlobalAction) : _Utils_Tuple3(
								_Utils_update(
									model,
									{
										V: false,
										p: _Utils_update(
											loginModel,
											{
												E: false,
												ao: $elm$core$Maybe$Just('Hubo un fallo al procesar tu solicitud. Por favor continúa tu proceso de postulación'),
												ah: false,
												ai: false
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton),
								$author$project$Model$NoGlobalAction)));
							return newModelAndCmd;
					}
				case 74:
					var candidateInfoStageModel = model.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									candidateInfoStageModel,
									{bV: false})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 75:
					var loginModel = model.p;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								p: _Utils_update(
									loginModel,
									{bW: true})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 76:
					var loginModel = model.p;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								p: _Utils_update(
									loginModel,
									{
										E: false,
										ao: $elm$core$Maybe$Just('No se ha podido iniciar sesión con Google. Por favor intenta nuevamente')
									})
							}),
						$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton),
						$author$project$Model$NoGlobalAction);
				case 79:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{a6: true}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 80:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{a6: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 81:
					return _Utils_Tuple3(
						model,
						$elm$browser$Browser$Navigation$load('/empleos'),
						$author$project$Model$NoGlobalAction);
				case 82:
					var googleClientId = msg.a;
					var previousStep = function () {
						var _v48 = model.fZ;
						switch (_v48) {
							case 0:
								return $elm$core$Maybe$Nothing;
							case 1:
								return (!_Utils_eq(model.ak, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(0);
							case 2:
								return $elm$core$Maybe$Just(1);
							case 3:
								return $elm$core$Maybe$Just(1);
							case 4:
								return (!$elm$core$List$length(model.az)) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Just(3);
							case 5:
								return $elm$core$Maybe$Just(4);
							case 6:
								return $elm$core$Maybe$Just(5);
							default:
								return $elm$core$Maybe$Nothing;
						}
					}();
					if (!previousStep.$) {
						var step = previousStep.a;
						var currentCandidateInfoStageModel = model.c;
						var _v47 = (!step) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: _Utils_update(
										currentCandidateInfoStageModel,
										{
											w: 0,
											l: {
												gS: {bI: $elm$core$Maybe$Nothing, m: $elm$core$Maybe$Nothing},
												cl: $author$project$Model$defaultTkCommonField,
												c1: $author$project$Model$defaultTkCommonField,
												c4: $author$project$Model$defaultTkCommonField,
												cs: $author$project$Model$defaultTkLocationField,
												i6: _Utils_update(
													$author$project$Model$defaultTkCommonField,
													{cr: ''})
											},
											aA: 0
										})
								}),
							$author$project$Ports$renderGoogleSignInButton(
								{hq: googleClientId})) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						var newModel = _v47.a;
						var newCmd = _v47.b;
						return _Utils_Tuple3(
							_Utils_update(
								newModel,
								{fZ: step}),
							newCmd,
							$author$project$Model$NoGlobalAction);
					} else {
						return _Utils_Tuple3(
							model,
							A2($elm$browser$Browser$Navigation$back, model.cv, 1),
							$author$project$Model$NoGlobalAction);
					}
				case 83:
					var loginModel = model.p;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								p: _Utils_update(
									loginModel,
									{ah: true, ai: false})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 84:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bU: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 85:
					var inputId = msg.a;
					return _Utils_Tuple3(
						model,
						A2(
							$elm$core$Task$attempt,
							function (_v49) {
								return $author$project$Page$Home$PassThrough;
							},
							$elm$browser$Browser$Dom$blur(inputId)),
						$author$project$Model$NoGlobalAction);
				case 86:
					var jobAdLink = msg.a;
					return _Utils_Tuple3(
						model,
						$elm$browser$Browser$Navigation$load(jobAdLink),
						$author$project$Model$NoGlobalAction);
				case 87:
					var value = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var valueProcessed = function () {
						var _v52 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v52.$ === 1) {
							return $elm$core$String$trim(value);
						} else {
							var regex = _v52.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v53) {
										return '';
									},
									value));
						}
					}();
					var magickLinkValidation = model.n;
					var getNewMagickLinkValidation = function (inputValue) {
						var newMagickLinkValidation = _Utils_update(
							magickLinkValidation,
							{aZ: inputValue});
						return newMagickLinkValidation;
					};
					var newModelAndCmd = function () {
						var _v50 = A2($elm$core$String$split, '', valueProcessed);
						if (!_v50.b) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										n: getNewMagickLinkValidation('')
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Model$NoGlobalAction);
						} else {
							if (!_v50.b.b) {
								var inputValue = _v50.a;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{n: magicLinkValidationWithErrors}),
									A2(
										$elm$core$Task$attempt,
										function (_v51) {
											return $author$project$Page$Home$PassThrough;
										},
										$elm$browser$Browser$Dom$focus('magic-link-input-2')),
									$author$project$Model$NoGlobalAction);
							} else {
								var inputValue = _v50.a;
								var tail = _v50.b;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								var newModel = _Utils_update(
									model,
									{n: magicLinkValidationWithErrors});
								return A2(
									$author$project$Page$Home$update,
									$author$project$Page$Home$MsgUserChangeMagicLinkValidationInputTwo(
										$elm$core$String$concat(tail)),
									newModel);
							}
						}
					}();
					return newModelAndCmd;
				case 88:
					var value = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var valueProcessed = function () {
						var _v56 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v56.$ === 1) {
							return $elm$core$String$trim(value);
						} else {
							var regex = _v56.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v57) {
										return '';
									},
									value));
						}
					}();
					var magickLinkValidation = model.n;
					var getNewMagickLinkValidation = function (inputValue) {
						var newMagickLinkValidation = _Utils_update(
							magickLinkValidation,
							{a0: inputValue});
						return newMagickLinkValidation;
					};
					var newModelAndCmd = function () {
						var _v54 = A2($elm$core$String$split, '', valueProcessed);
						if (!_v54.b) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										n: getNewMagickLinkValidation('')
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Model$NoGlobalAction);
						} else {
							if (!_v54.b.b) {
								var inputValue = _v54.a;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{n: magicLinkValidationWithErrors}),
									A2(
										$elm$core$Task$attempt,
										function (_v55) {
											return $author$project$Page$Home$PassThrough;
										},
										$elm$browser$Browser$Dom$focus('magic-link-input-3')),
									$author$project$Model$NoGlobalAction);
							} else {
								var inputValue = _v54.a;
								var tail = _v54.b;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								var newModel = _Utils_update(
									model,
									{n: magicLinkValidationWithErrors});
								return A2(
									$author$project$Page$Home$update,
									$author$project$Page$Home$MsgUserChangeMagicLinkValidationInputThree(
										$elm$core$String$concat(tail)),
									newModel);
							}
						}
					}();
					return newModelAndCmd;
				case 90:
					var value = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var valueProcessed = function () {
						var _v60 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v60.$ === 1) {
							return $elm$core$String$trim(value);
						} else {
							var regex = _v60.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v61) {
										return '';
									},
									value));
						}
					}();
					var magickLinkValidation = model.n;
					var getNewMagickLinkValidation = function (inputValue) {
						var newMagickLinkValidation = _Utils_update(
							magickLinkValidation,
							{a$: inputValue});
						return newMagickLinkValidation;
					};
					var newModelAndCmd = function () {
						var _v58 = A2($elm$core$String$split, '', valueProcessed);
						if (!_v58.b) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										n: getNewMagickLinkValidation('')
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Model$NoGlobalAction);
						} else {
							if (!_v58.b.b) {
								var inputValue = _v58.a;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{n: magicLinkValidationWithErrors}),
									A2(
										$elm$core$Task$attempt,
										function (_v59) {
											return $author$project$Page$Home$PassThrough;
										},
										$elm$browser$Browser$Dom$focus('magic-link-input-4')),
									$author$project$Model$NoGlobalAction);
							} else {
								var inputValue = _v58.a;
								var tail = _v58.b;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								var newModel = _Utils_update(
									model,
									{n: magicLinkValidationWithErrors});
								return A2(
									$author$project$Page$Home$update,
									$author$project$Page$Home$MsgUserChangeMagicLinkValidationInputFour(
										$elm$core$String$concat(tail)),
									newModel);
							}
						}
					}();
					return newModelAndCmd;
				case 92:
					var value = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var valueProcessed = function () {
						var _v64 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v64.$ === 1) {
							return $elm$core$String$trim(value);
						} else {
							var regex = _v64.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v65) {
										return '';
									},
									value));
						}
					}();
					var magickLinkValidation = model.n;
					var getNewMagickLinkValidation = function (inputValue) {
						var newMagickLinkValidation = _Utils_update(
							magickLinkValidation,
							{aY: inputValue});
						return newMagickLinkValidation;
					};
					var newModelAndCmd = function () {
						var _v62 = A2($elm$core$String$split, '', valueProcessed);
						if (!_v62.b) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										n: getNewMagickLinkValidation('')
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Model$NoGlobalAction);
						} else {
							if (!_v62.b.b) {
								var inputValue = _v62.a;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{n: magicLinkValidationWithErrors}),
									A2(
										$elm$core$Task$attempt,
										function (_v63) {
											return $author$project$Page$Home$PassThrough;
										},
										$elm$browser$Browser$Dom$focus('magic-link-input-5')),
									$author$project$Model$NoGlobalAction);
							} else {
								var inputValue = _v62.a;
								var tail = _v62.b;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								var newModel = _Utils_update(
									model,
									{n: magicLinkValidationWithErrors});
								return A2(
									$author$project$Page$Home$update,
									$author$project$Page$Home$MsgUserChangeMagicLinkValidationInputFive(
										$elm$core$String$concat(tail)),
									newModel);
							}
						}
					}();
					return newModelAndCmd;
				case 89:
					return _Utils_Tuple3(
						model,
						A2(
							$elm$core$Task$attempt,
							function (_v66) {
								return $author$project$Page$Home$PassThrough;
							},
							$elm$browser$Browser$Dom$focus('magic-link-input-1')),
						$author$project$Model$NoGlobalAction);
				case 91:
					return _Utils_Tuple3(
						model,
						A2(
							$elm$core$Task$attempt,
							function (_v67) {
								return $author$project$Page$Home$PassThrough;
							},
							$elm$browser$Browser$Dom$focus('magic-link-input-2')),
						$author$project$Model$NoGlobalAction);
				case 93:
					return _Utils_Tuple3(
						model,
						A2(
							$elm$core$Task$attempt,
							function (_v68) {
								return $author$project$Page$Home$PassThrough;
							},
							$elm$browser$Browser$Dom$focus('magic-link-input-3')),
						$author$project$Model$NoGlobalAction);
				case 95:
					return _Utils_Tuple3(
						model,
						A2(
							$elm$core$Task$attempt,
							function (_v69) {
								return $author$project$Page$Home$PassThrough;
							},
							$elm$browser$Browser$Dom$focus('magic-link-input-4')),
						$author$project$Model$NoGlobalAction);
				case 97:
					return _Utils_Tuple3(
						model,
						A2(
							$elm$core$Task$attempt,
							function (_v70) {
								return $author$project$Page$Home$PassThrough;
							},
							$elm$browser$Browser$Dom$focus('magic-link-input-5')),
						$author$project$Model$NoGlobalAction);
				case 94:
					var value = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var valueProcessed = function () {
						var _v73 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v73.$ === 1) {
							return $elm$core$String$trim(value);
						} else {
							var regex = _v73.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v74) {
										return '';
									},
									value));
						}
					}();
					var magickLinkValidation = model.n;
					var getNewMagickLinkValidation = function (inputValue) {
						var newMagickLinkValidation = _Utils_update(
							magickLinkValidation,
							{aX: inputValue});
						return newMagickLinkValidation;
					};
					var newModelAndCmd = function () {
						var _v71 = A2($elm$core$String$split, '', valueProcessed);
						if (!_v71.b) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										n: getNewMagickLinkValidation('')
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Model$NoGlobalAction);
						} else {
							if (!_v71.b.b) {
								var inputValue = _v71.a;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{n: magicLinkValidationWithErrors}),
									A2(
										$elm$core$Task$attempt,
										function (_v72) {
											return $author$project$Page$Home$PassThrough;
										},
										$elm$browser$Browser$Dom$focus('magic-link-input-6')),
									$author$project$Model$NoGlobalAction);
							} else {
								var inputValue = _v71.a;
								var tail = _v71.b;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								var newModel = _Utils_update(
									model,
									{n: magicLinkValidationWithErrors});
								return A2(
									$author$project$Page$Home$update,
									$author$project$Page$Home$MsgUserChangeMagicLinkValidationInputSix(
										$elm$core$String$concat(tail)),
									newModel);
							}
						}
					}();
					return newModelAndCmd;
				case 96:
					var value = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var valueProcessed = function () {
						var _v76 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v76.$ === 1) {
							return $elm$core$String$trim(value);
						} else {
							var regex = _v76.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v77) {
										return '';
									},
									value));
						}
					}();
					var magickLinkValidation = model.n;
					var getNewMagickLinkValidation = function (inputValue) {
						var newMagickLinkValidation = _Utils_update(
							magickLinkValidation,
							{a_: inputValue});
						return newMagickLinkValidation;
					};
					var commonModelAndCmd = function (inputValue) {
						var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
						var newModel = _Utils_update(
							model,
							{n: magicLinkValidationWithErrors});
						return A2($author$project$Page$Home$update, $author$project$Page$Home$MsgUserPressedValidateMagicLinkCodeButton, newModel);
					};
					var newModelAndCmd = function () {
						var _v75 = A2($elm$core$String$split, '', valueProcessed);
						if (!_v75.b) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										n: getNewMagickLinkValidation('')
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Model$NoGlobalAction);
						} else {
							if (!_v75.b.b) {
								var inputValue = _v75.a;
								return commonModelAndCmd(inputValue);
							} else {
								var inputValue = _v75.a;
								return commonModelAndCmd(inputValue);
							}
						}
					}();
					return newModelAndCmd;
				case 98:
					var magickLinkValidation = model.n;
					return ((magickLinkValidation.aZ === '') && ((magickLinkValidation.a0 === '') && ((magickLinkValidation.a$ === '') && ((magickLinkValidation.aY === '') && ((magickLinkValidation.aX === '') && (magickLinkValidation.a_ === '')))))) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction) : _Utils_Tuple3(
						_Utils_update(
							model,
							{
								n: _Utils_update(
									magickLinkValidation,
									{E: true})
							}),
						$author$project$Page$Home$verifyMagicLink(model),
						$author$project$Model$NoGlobalAction);
				case 101:
					var response = msg.a;
					var loginModel = model.p;
					switch (response.$) {
						case 1:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 0:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 2:
							var httpError = response.a;
							var magickLinkValidation = model.n;
							var newModelAfterError = function (errorMessage) {
								return (magickLinkValidation.bA < 2) ? _Utils_Tuple3(
									_Utils_update(
										model,
										{
											p: _Utils_update(
												loginModel,
												{
													ao: $elm$core$Maybe$Just(errorMessage + ' Por favor intenta nuevamente')
												}),
											n: _Utils_update(
												magickLinkValidation,
												{E: false, bA: magickLinkValidation.bA + 1})
										}),
									$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton),
									$author$project$Model$NoGlobalAction) : _Utils_Tuple3(
									_Utils_update(
										model,
										{
											V: false,
											p: _Utils_update(
												loginModel,
												{
													ao: $elm$core$Maybe$Just(errorMessage + ' Por favor continúa tu proceso de postulación'),
													ah: false,
													ai: false
												}),
											n: {co: false, E: false, aX: '', aY: '', aZ: '', a_: '', a$: '', a0: '', a9: false, bA: 0}
										}),
									$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton),
									$author$project$Model$NoGlobalAction);
							};
							if (httpError.$ === 3) {
								var status = httpError.a;
								return (status === 403) ? newModelAfterError('El código ingresado es incorrecto.') : newModelAfterError('Hubo un fallo al procesar tu solicitud.');
							} else {
								return newModelAfterError('Hubo un fallo al procesar tu solicitud.');
							}
						default:
							var currentMagicLinkCodeValidationModel = model.n;
							var newModelAndCmd = _Utils_Tuple3(
								_Utils_update(
									model,
									{
										V: false,
										p: _Utils_update(
											loginModel,
											{E: false}),
										n: _Utils_update(
											currentMagicLinkCodeValidationModel,
											{a9: false})
									}),
								$elm$browser$Browser$Navigation$reload,
								$author$project$Model$NoGlobalAction);
							return newModelAndCmd;
					}
				case 99:
					if (!msg.a.$) {
						var element = msg.a.a;
						var loginModel = model.p;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									p: _Utils_update(
										loginModel,
										{
											ch: $elm$core$Basics$ceiling(element.g2.dp)
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Model$NoGlobalAction);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
					}
				case 100:
					var loginModel = model.p;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								p: _Utils_update(
									loginModel,
									{ao: $elm$core$Maybe$Nothing})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 107:
					var link = msg.a;
					return _Utils_Tuple3(
						model,
						$author$project$Page$Home$downloadCV(link),
						$author$project$Model$NoGlobalAction);
				case 108:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cj: true}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 109:
					return _Utils_Tuple3(
						model,
						$author$project$Page$Home$trackGoogleSignInButtonClick(model),
						$author$project$Model$NoGlobalAction);
				case 110:
					var position = msg.a;
					return A2($author$project$Page$Home$saveJobAdAsFavorite, model, position);
				case 111:
					var jobAdId = msg.a;
					var position = msg.b;
					var response = msg.c;
					switch (response.$) {
						case 1:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 0:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 2:
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Model$ShowToastAlert(
									A2($author$project$T2$Alert$initAlertLowErrorMediumAutoDismissible, 'save-job-ad-failure', 'Ha ocurrido un error al guardar la vacante, por favor intenta nuevamente')));
						default:
							var result = response.a;
							return ((result.dm === 'ok') || (result.dm === 'notification-not-send')) ? _Utils_Tuple3(
								model,
								$author$project$Ports$saveJobAdAsFavoriteFromLocalStorage(
									_Utils_Tuple2(jobAdId, position)),
								$author$project$Model$ShowToastAlert(
									A2($author$project$T2$Alert$initAlertLowSuccessMediumAutoDismissible, 'save-job-ad-ok', 'Vacante añadida como favorita'))) : _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Model$ShowToastAlert(
									A2($author$project$T2$Alert$initAlertLowErrorMediumAutoDismissible, 'save-job-ad-failure', 'Ha ocurrido un error al guardar la vacante, por favor intenta nuevamente')));
					}
				case 112:
					var currentCandidateInfoStageModel = model.c;
					var newModel = _Utils_update(
						model,
						{
							c: _Utils_update(
								currentCandidateInfoStageModel,
								{w: 3}),
							bz: true
						});
					return _Utils_Tuple3(
						newModel,
						$author$project$Page$Home$getCountries(newModel),
						$author$project$Model$NoGlobalAction);
				case 113:
					var response = msg.a;
					switch (response.$) {
						case 1:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 0:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						case 2:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
						default:
							var result = response.a;
							var currentCandidateInfoStageModel = model.c;
							var currentCountryDropdownModel = currentCandidateInfoStageModel.Y;
							var countryItemsList = A2(
								$elm$core$List$map,
								function (country) {
									return {
										t: false,
										u: country.s,
										m: {s: country.s, m: country.m}
									};
								},
								result);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										c: _Utils_update(
											currentCandidateInfoStageModel,
											{
												Y: _Utils_update(
													currentCountryDropdownModel,
													{bp: countryItemsList})
											}),
										cX: countryItemsList
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Model$NoGlobalAction);
					}
				case 114:
					var updateLocation = function (location) {
						return _Utils_update(
							location,
							{cn: false, cr: '', m: $elm$core$Maybe$Nothing});
					};
					var oldCommonModel = model.J;
					var newModel = function () {
						var _v82 = model.c.l.gS.m;
						if (!_v82.$) {
							var tkCommonDropdownItem = _v82.a;
							var newCurrentCandidateApplyInfo = A2(
								$elm$core$Maybe$map,
								function (currentCandidateApplyInfo) {
									return _Utils_update(
										currentCandidateApplyInfo,
										{
											gT: $elm$core$Maybe$Just(tkCommonDropdownItem.m)
										});
								},
								model.ak);
							var newCommonModel = _Utils_update(
								oldCommonModel,
								{gT: tkCommonDropdownItem.m});
							return _Utils_update(
								model,
								{
									J: newCommonModel,
									gT: $elm$core$Maybe$Just(tkCommonDropdownItem.m),
									ak: newCurrentCandidateApplyInfo
								});
						} else {
							return model;
						}
					}();
					var currentCandidateInfoStageModel = model.c;
					var updatedCandidateInfoDo = function (infoDo) {
						return _Utils_update(
							infoDo,
							{
								cs: updateLocation(infoDo.cs)
							});
					}(currentCandidateInfoStageModel.l);
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{w: 4, l: updatedCandidateInfoDo}),
								bz: false
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 115:
					var currentCandidateInfoStageModel = model.c;
					var dropdownModel = currentCandidateInfoStageModel.Y;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{
										Y: _Utils_update(
											dropdownModel,
											{
												K: $author$project$T2$Dropdown$toggleState(currentCandidateInfoStageModel.Y.K)
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 116:
					var currentCandidateInfoStageModel = model.c;
					var dropdownModel = currentCandidateInfoStageModel.Y;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{
										Y: _Utils_update(
											dropdownModel,
											{K: 0})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 117:
					var index = msg.a;
					var currentCandidateInfoStageModel = model.c;
					var dropdownModel = currentCandidateInfoStageModel.Y;
					var selected = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.m;
						},
						A2(
							$elm$core$Array$get,
							index,
							$elm$core$Array$fromList(currentCandidateInfoStageModel.Y.bp)));
					var currentCandidateInfoDo = currentCandidateInfoStageModel.l;
					var currentCountryField = currentCandidateInfoDo.gS;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{
										l: _Utils_update(
											currentCandidateInfoDo,
											{
												gS: _Utils_update(
													currentCountryField,
													{bI: $elm$core$Maybe$Nothing, m: selected})
											}),
										Y: _Utils_update(
											dropdownModel,
											{
												a7: $elm$core$Maybe$Just(index),
												a8: selected,
												K: 0
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				case 118:
					var currentCandidateInfoStageModel = model.c;
					var newModel = _Utils_update(
						model,
						{
							c: _Utils_update(
								currentCandidateInfoStageModel,
								{w: 4}),
							bz: false
						});
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
				case 119:
					var result = msg.a;
					var currentCandidateInfoStageModel = model.c;
					var cityItems = function (cityList) {
						return A2(
							$elm$core$List$map,
							function (city) {
								return {t: false, u: city.gr, m: city};
							},
							cityList);
					};
					var _v83 = A2(
						$author$project$T2$Internal$Autocomplete$update,
						$author$project$T2$Internal$Autocomplete$ReceiveItemList(
							cityItems(result)),
						currentCandidateInfoStageModel.aj);
					var newAutocomplete = _v83.a;
					var cmd = _v83.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{aj: newAutocomplete})
							}),
						cmd,
						$author$project$Model$NoGlobalAction);
				case 120:
					var autocompleteMsg = msg.a;
					var currentCandidateInfoStageModel = model.c;
					var currentApplyInfo = currentCandidateInfoStageModel.l;
					var currentLocationField = currentApplyInfo.cs;
					var _v84 = A2($author$project$T2$Internal$Autocomplete$update, autocompleteMsg, model.c.aj);
					var newAutocomplete = _v84.a;
					var cmd = _v84.b;
					var errorMessage = (($elm$core$String$trim(newAutocomplete.jk) === '') && (!(currentCandidateInfoStageModel.aj.jk === ''))) ? $elm$core$Maybe$Just('Por favor ingresa el lugar donde vives') : $elm$core$Maybe$Nothing;
					var newSelectedCity = _Utils_eq(newAutocomplete.jk, currentLocationField.cr) ? currentLocationField.e4 : $elm$core$Maybe$Nothing;
					var newModel = _Utils_update(
						model,
						{
							c: _Utils_update(
								currentCandidateInfoStageModel,
								{
									l: _Utils_update(
										currentApplyInfo,
										{
											cs: _Utils_update(
												currentLocationField,
												{bI: errorMessage, cr: newAutocomplete.jk, e4: newSelectedCity})
										}),
									aj: newAutocomplete
								})
						});
					return _Utils_Tuple3(newModel, cmd, $author$project$Model$NoGlobalAction);
				case 121:
					var cityDo = msg.a;
					var currentCandidateInfoStageModel = model.c;
					var currentApplyInfo = currentCandidateInfoStageModel.l;
					var currentLocationField = currentApplyInfo.cs;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									currentCandidateInfoStageModel,
									{
										l: _Utils_update(
											currentApplyInfo,
											{
												cs: _Utils_update(
													currentLocationField,
													{
														bI: $elm$core$Maybe$Nothing,
														cr: cityDo.gr + (' - ' + cityDo.jE),
														e4: $elm$core$Maybe$Just(cityDo)
													})
											})
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Model$NoGlobalAction);
				default:
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Model$NoGlobalAction);
			}
		}
	});
var $author$project$T2$Internal$Alert$Dismiss = function (a) {
	return {$: 0, a: a};
};
var $author$project$T2$Internal$Alert$Dismissing = 2;
var $author$project$T2$Internal$Alert$FinishDismiss = function (a) {
	return {$: 2, a: a};
};
var $author$project$T2$Internal$Alert$Hidden = 1;
var $author$project$T2$Internal$Alert$update = F2(
	function (msg, alert) {
		switch (msg.$) {
			case 0:
				var alertId = msg.a;
				return _Utils_eq(alert.ax, alertId) ? _Utils_Tuple2(
					_Utils_update(
						alert,
						{K: 2}),
					A2(
						$elm$core$Task$perform,
						function (_v1) {
							return $author$project$T2$Internal$Alert$FinishDismiss(alertId);
						},
						$elm$core$Task$succeed(0))) : _Utils_Tuple2(alert, $elm$core$Platform$Cmd$none);
			case 1:
				var alertId = msg.a;
				if (_Utils_eq(alert.ax, alertId) && (!alert.K)) {
					var _v2 = alert.dx;
					if (!_v2.$) {
						var seconds = _v2.a;
						return _Utils_Tuple2(
							alert,
							A2(
								$elm$core$Task$perform,
								function (_v3) {
									return $author$project$T2$Internal$Alert$Dismiss(alertId);
								},
								$elm$core$Process$sleep(seconds * 1000)));
					} else {
						return _Utils_Tuple2(alert, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(alert, $elm$core$Platform$Cmd$none);
				}
			default:
				var alertId = msg.a;
				return _Utils_eq(alert.ax, alertId) ? _Utils_Tuple2(
					_Utils_update(
						alert,
						{K: 1}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(alert, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$T2$Alert$update = $author$project$T2$Internal$Alert$update;
var $author$project$T2$ToastAlerts$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var alertId = msg.a;
			var alertMsg = msg.b;
			var _v1 = A2($elm$core$Dict$get, alertId, model.aa);
			if (!_v1.$) {
				var alert = _v1.a;
				var _v2 = A2($author$project$T2$Alert$update, alertMsg, alert);
				var updatedAlert = _v2.a;
				var alertCmd = _v2.b;
				var newAlerts = function () {
					var _v3 = updatedAlert.K;
					if (_v3 === 1) {
						return A2($elm$core$Dict$remove, alertId, model.aa);
					} else {
						return A3($elm$core$Dict$insert, alertId, updatedAlert, model.aa);
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aa: newAlerts}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$T2$ToastAlerts$AlertMsg(alertId),
						alertCmd));
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			var alertId = msg.a;
			var _v4 = A2($elm$core$Dict$get, alertId, model.aa);
			if (!_v4.$) {
				var alert = _v4.a;
				var _v5 = A2(
					$author$project$T2$Alert$update,
					$author$project$T2$Internal$Alert$Dismiss(alertId),
					alert);
				var updatedAlert = _v5.a;
				var alertCmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aa: A3($elm$core$Dict$insert, alertId, updatedAlert, model.aa)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$T2$ToastAlerts$AlertMsg(alertId),
						alertCmd));
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 19:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var width = msg.a;
				var height = msg.b;
				var newWindowSize = {bn: height, dp: width};
				var context = model.U;
				var newModel = _Utils_update(
					model,
					{
						U: _Utils_update(
							context,
							{S: newWindowSize}),
						S: newWindowSize
					});
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Main$syncWindowSize, newModel.R, newModel.S),
								$author$project$Ports$getVisualViewportHeight(0)
							])));
			case 4:
				var response = msg.a;
				var _v1 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$float, response);
				if (!_v1.$) {
					var height = _v1.a;
					var newModel = _Utils_update(
						model,
						{
							bC: $elm$core$Basics$ceiling(height)
						});
					return _Utils_Tuple2(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Main$syncViewportHeightOffset, newModel.R, newModel.bC),
									$author$project$Ports$scrollToDocumentTop(0),
									$author$project$Ports$scrollToChatBottom(0)
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 0:
				var msgHome = msg.a;
				var _v2 = A2($author$project$Page$Home$update, msgHome, model._);
				var modelHome = _v2.a;
				var cmd = _v2.b;
				var action = _v2.c;
				return A4(
					$author$project$Main$doAction,
					action,
					$author$project$Main$MsgHome,
					_Utils_update(
						model,
						{_: modelHome}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$MsgHome, cmd));
			case 2:
				var urlRequest = msg.a;
				if (!urlRequest.$) {
					var url = urlRequest.a;
					return $author$project$Route$isTonkeanUrl(url) ? _Utils_Tuple2(
						model,
						$author$project$Ports$goToTonkeanUrl(
							$elm$url$Url$toString(url))) : _Utils_Tuple2(
						_Utils_update(
							model,
							{R: url}),
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							model.cv,
							$elm$url$Url$toString(url)));
				} else {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(url));
				}
			case 3:
				var url = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bS: $author$project$Route$fromUrl(url),
						R: url
					});
				var mainModelWithPageInitialized = function () {
					var _v4 = newModel.bS;
					var applyStepToShow = newModel._.fZ;
					return _Utils_update(
						newModel,
						{
							_: A5(
								$author$project$Page$Home$initModel,
								newModel.S,
								newModel.J,
								newModel.R,
								newModel.cv,
								$elm$core$Maybe$Just(applyStepToShow))
						});
				}();
				return _Utils_Tuple2(
					mainModelWithPageInitialized,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$elm$core$Platform$Cmd$none,
								$author$project$Main$initPageCmds(mainModelWithPageInitialized)
							])));
			case 5:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bZ: result}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var response = msg.a;
				var _v5 = A2($elm$json$Json$Decode$decodeValue, $author$project$T2$ApiModel$tkNotificationsFromLocalStorageDecoder, response);
				if (!_v5.$) {
					var tkNotificationsFromLocalStorage = _v5.a;
					var jobAdsIdsSavedAsFavoriteInLocalStorage = A2(
						$elm$core$List$map,
						function (f) {
							return f.ax;
						},
						_Utils_ap(tkNotificationsFromLocalStorage.c0.fI, tkNotificationsFromLocalStorage.c0.eO));
					var candidateIsLoggedIn = model.J.cQ.dF;
					var cmdToSynchronize = (candidateIsLoggedIn && ((!tkNotificationsFromLocalStorage.fd) && ($elm$core$List$length(jobAdsIdsSavedAsFavoriteInLocalStorage) > 0))) ? $elm$http$Http$riskyRequest(
						{
							bF: $elm$http$Http$jsonBody(
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'list_job_ads_ids_to_synchronize',
											A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, jobAdsIdsSavedAsFavoriteInLocalStorage)),
											_Utils_Tuple2(
											'source',
											$elm$json$Json$Encode$string('new-jobads-search'))
										]))),
							cm: A2($elm$http$Http$expectJson, $author$project$Main$getMsgSavedJobAdsSynchronizedWithLocalStorageResponseDo, $author$project$T2$ApiModel$apiResponseSimpleStatusJsonDecoder),
							cp: _List_Nil,
							cu: 'POST',
							cG: $elm$core$Maybe$Just(model.J.ct),
							cH: $elm$core$Maybe$Nothing,
							R: model.J.bO + '/v1/candidate/synchronize-save-job-ads'
						}) : $elm$core$Platform$Cmd$none;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bx: tkNotificationsFromLocalStorage}),
						cmdToSynchronize);
				} else {
					var error = _v5.a;
					return _Utils_Tuple2(
						model,
						$author$project$T2$Log$error(
							{
								am: 'Error while getting favorite jobads from local storage. Error: ' + $elm$json$Json$Decode$errorToString(error)
							}));
				}
			case 7:
				var response = msg.a;
				var oldTkNotificationsFromLocalStorage = model.bx;
				var _v6 = A3(
					$krisajenkins$remotedata$RemoteData$unwrap,
					_Utils_Tuple2(oldTkNotificationsFromLocalStorage, $elm$core$Platform$Cmd$none),
					function (r) {
						return ((r.dm === 'ok') || (r.dm === 'notification-not-send')) ? _Utils_Tuple2(
							_Utils_update(
								oldTkNotificationsFromLocalStorage,
								{fd: true}),
							$author$project$Ports$setNotificationsAsSynchronizedWithLoggedInCandidate(0)) : _Utils_Tuple2(oldTkNotificationsFromLocalStorage, $elm$core$Platform$Cmd$none);
					},
					response);
				var tkNotificationsFromLocalStorage = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bx: tkNotificationsFromLocalStorage}),
					cmd);
			case 9:
				var oldstatesForMenu = model.at;
				var newStatesForMenu = _Utils_update(
					oldstatesForMenu,
					{cA: true});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{at: newStatesForMenu}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var oldstatesForMenu = model.at;
				var newStatesForMenu = _Utils_update(
					oldstatesForMenu,
					{cA: false});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{at: newStatesForMenu}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var oldstatesForMenu = model.at;
				var newStatesForMenu = _Utils_update(
					oldstatesForMenu,
					{cB: !oldstatesForMenu.cB});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{at: newStatesForMenu}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var newTheme = function () {
					var _v7 = model.U.cF;
					if (!_v7) {
						return 1;
					} else {
						return 0;
					}
				}();
				var newThemeString = $author$project$T2$Util$themeToString(newTheme);
				var currentContext = model.U;
				var newContext = _Utils_update(
					currentContext,
					{cF: newTheme});
				var cmdTheme = $author$project$T2$ThemePorts$userThemeChanged(newThemeString);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U: newContext}),
					cmdTheme);
			case 12:
				var currentTopBarModel = model.aO;
				var updatedTopBarModel = _Utils_update(
					currentTopBarModel,
					{dj: !currentTopBarModel.dj});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aO: updatedTopBarModel}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var currentTopBarModel = model.aO;
				var updatedTopBarModel = _Utils_update(
					currentTopBarModel,
					{dj: false});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aO: updatedTopBarModel}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var currentNavigationDrawerModel = model.aI;
				var updatedNavigationDrawerModel = _Utils_update(
					currentNavigationDrawerModel,
					{di: !currentNavigationDrawerModel.di});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aI: updatedNavigationDrawerModel}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var currentNavigationDrawerModel = model.aI;
				var updatedNavigationDrawerModel = _Utils_update(
					currentNavigationDrawerModel,
					{di: false});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aI: updatedNavigationDrawerModel}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var toastMsg = msg.a;
				var _v8 = A2($author$project$T2$ToastAlerts$update, toastMsg, model.aD);
				var newToastAlerts = _v8.a;
				var toastCmd = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aD: newToastAlerts}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ToastAlertsMsg, toastCmd));
			case 17:
				var result = msg.a;
				if (!result.$) {
					var response = result.a;
					if (response.dm === 'ok') {
						var homeCurrentModel = model._;
						var _v10 = function () {
							var _v11 = response.am;
							if (!_v11.$) {
								var text = _v11.a;
								var trimmedText = $elm$core$String$trim(text);
								return (trimmedText === '') ? _Utils_Tuple2($elm$core$Maybe$Nothing, 0) : _Utils_Tuple2(
									$elm$core$Maybe$Just(
										_Utils_Tuple2(trimmedText, 1)),
									64);
							} else {
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							}
						}();
						var pageAlert = _v10.a;
						var heightSizeToReduce = _v10.b;
						var homeModelWithHeightSizeToReduceUpdated = _Utils_update(
							homeCurrentModel,
							{ec: heightSizeToReduce});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{bh: pageAlert, _: homeModelWithHeightSizeToReduceUpdated}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$T2$Log$error(
							{
								am: 'Error displaying global banner info on jobads search page: ' + $author$project$T2$Util$httpErrorToString(err)
							}));
				}
			default:
				var homeCurrentModel = model._;
				var homeModelWithHeightSizeToReduceUpdated = _Utils_update(
					homeCurrentModel,
					{ec: 0});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bh: $elm$core$Maybe$Nothing, _: homeModelWithHeightSizeToReduceUpdated}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$MsgHideAccountInfoDropdown = {$: 8};
var $author$project$Main$MsgShowAccountInfoDropdown = {$: 9};
var $author$project$Main$MsgUserCloseNavigationDrawer = {$: 15};
var $author$project$Main$MsgUserPressedDismissAlertButton = {$: 18};
var $author$project$Main$MsgUserPressedHideTopBarAccountBtn = {$: 13};
var $author$project$Main$MsgUserPressedMenuButtonMobile = {$: 10};
var $author$project$Main$MsgUserPressedToggleTheme = {$: 11};
var $author$project$Main$MsgUserPressedTopBarAccountBtn = {$: 12};
var $author$project$Main$MsgUserPressedTopBarMobileMenuBtn = {$: 14};
var $author$project$T2$NoFooter = 0;
var $mdgriffith$elm_ui$Internal$Model$Rgba = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Element$rgb255 = F3(
	function (red, green, blue) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, red / 255, green / 255, blue / 255, 1);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$rgb255 = $mdgriffith$elm_ui$Element$rgb255;
var $author$project$T2$Internal$Color$Swatch$green00 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 18, 14);
var $author$project$T2$Internal$Color$Swatch$white = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 255, 255);
var $author$project$T2$Internal$Color$bgPrimary = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$Swatch$gray99 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 251, 250, 250);
var $author$project$T2$Internal$Color$Swatch$green10 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 46, 35);
var $author$project$T2$Internal$Color$contentPrimary = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Unkeyed = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$AsEl = 2;
var $mdgriffith$elm_ui$Internal$Model$asEl = 2;
var $mdgriffith$elm_ui$Internal$Model$Generic = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$div = $mdgriffith$elm_ui$Internal$Model$Generic;
var $mdgriffith$elm_ui$Internal$Model$NoNearbyChildren = {$: 0};
var $mdgriffith$elm_ui$Internal$Style$classes = {fx: 'a', fD: 'atv', fL: 'ab', fM: 'cx', fN: 'cy', fO: 'acb', fP: 'accx', fQ: 'accy', fR: 'acr', du: 'al', dv: 'ar', fS: 'at', cJ: 'ah', cK: 'av', fX: 's', f3: 'bh', f4: 'b', f7: 'w7', f8: 'bd', f9: 'bdt', b8: 'bn', ga: 'bs', ca: 'cpe', gt: 'cp', gu: 'cpx', gv: 'cpy', aF: 'c', cd: 'ctr', ce: 'cb', cf: 'ccx', aG: 'ccy', bG: 'cl', cg: 'cr', gM: 'ct', gW: 'cptr', gX: 'ctxt', he: 'fcs', d5: 'focus-within', hm: 'fs', hs: 'g', c3: 'hbh', c5: 'hc', ea: 'he', c6: 'hf', eb: 'hfp', hG: 'hv', hJ: 'ic', hL: 'fr', cq: 'lbl', hR: 'iml', hS: 'imlf', hT: 'imlp', hU: 'implw', hV: 'it', ij: 'i', eq: 'lnk', bs: 'nb', eu: 'notxt', iY: 'ol', iZ: 'or', a3: 'oq', i3: 'oh', ez: 'pg', eC: 'p', i5: 'ppe', jH: 'ui', e_: 'r', jN: 'sb', jO: 'sbx', jP: 'sby', jQ: 'sbt', jV: 'e', jX: 'cap', j_: 'sev', j6: 'sk', s: 't', kg: 'tc', kh: 'w8', ki: 'w2', kj: 'w9', kk: 'tj', cE: 'tja', kl: 'tl', km: 'w3', kn: 'w5', ko: 'w4', kp: 'tr', kq: 'w6', kr: 'w1', ks: 'tun', fk: 'ts', bf: 'clr', kH: 'u', dq: 'wc', fs: 'we', dr: 'wf', ft: 'wfp', ds: 'wrp'};
var $mdgriffith$elm_ui$Internal$Model$columnClass = $mdgriffith$elm_ui$Internal$Style$classes.fX + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.aF);
var $mdgriffith$elm_ui$Internal$Model$gridClass = $mdgriffith$elm_ui$Internal$Style$classes.fX + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.hs);
var $mdgriffith$elm_ui$Internal$Model$pageClass = $mdgriffith$elm_ui$Internal$Style$classes.fX + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ez);
var $mdgriffith$elm_ui$Internal$Model$paragraphClass = $mdgriffith$elm_ui$Internal$Style$classes.fX + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.eC);
var $mdgriffith$elm_ui$Internal$Model$rowClass = $mdgriffith$elm_ui$Internal$Style$classes.fX + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.e_);
var $mdgriffith$elm_ui$Internal$Model$singleClass = $mdgriffith$elm_ui$Internal$Style$classes.fX + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.jV);
var $mdgriffith$elm_ui$Internal$Model$contextClasses = function (context) {
	switch (context) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Model$rowClass;
		case 1:
			return $mdgriffith$elm_ui$Internal$Model$columnClass;
		case 2:
			return $mdgriffith$elm_ui$Internal$Model$singleClass;
		case 3:
			return $mdgriffith$elm_ui$Internal$Model$gridClass;
		case 4:
			return $mdgriffith$elm_ui$Internal$Model$paragraphClass;
		default:
			return $mdgriffith$elm_ui$Internal$Model$pageClass;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Keyed = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$NoStyleSheet = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$Styled = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Unstyled = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addChildren = F2(
	function (existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(behind, existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(existing, inFront);
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					behind,
					_Utils_ap(existing, inFront));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$addKeyedChildren = F3(
	function (key, existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(
					existing,
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						inFront));
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					_Utils_ap(
						existing,
						A2(
							$elm$core$List$map,
							function (x) {
								return _Utils_Tuple2(key, x);
							},
							inFront)));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$AsParagraph = 4;
var $mdgriffith$elm_ui$Internal$Model$asParagraph = 4;
var $mdgriffith$elm_ui$Internal$Flag$Flag = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Second = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$flag = function (i) {
	return (i > 31) ? $mdgriffith$elm_ui$Internal$Flag$Second(1 << (i - 32)) : $mdgriffith$elm_ui$Internal$Flag$Flag(1 << i);
};
var $mdgriffith$elm_ui$Internal$Flag$alignBottom = $mdgriffith$elm_ui$Internal$Flag$flag(41);
var $mdgriffith$elm_ui$Internal$Flag$alignRight = $mdgriffith$elm_ui$Internal$Flag$flag(40);
var $mdgriffith$elm_ui$Internal$Flag$centerX = $mdgriffith$elm_ui$Internal$Flag$flag(42);
var $mdgriffith$elm_ui$Internal$Flag$centerY = $mdgriffith$elm_ui$Internal$Flag$flag(43);
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $mdgriffith$elm_ui$Internal$Model$lengthClassName = function (x) {
	switch (x.$) {
		case 0:
			var px = x.a;
			return $elm$core$String$fromInt(px) + 'px';
		case 1:
			return 'auto';
		case 2:
			var i = x.a;
			return $elm$core$String$fromInt(i) + 'fr';
		case 3:
			var min = x.a;
			var len = x.b;
			return 'min' + ($elm$core$String$fromInt(min) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
		default:
			var max = x.a;
			var len = x.b;
			return 'max' + ($elm$core$String$fromInt(max) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
	}
};
var $elm$core$Basics$round = _Basics_round;
var $mdgriffith$elm_ui$Internal$Model$floatClass = function (x) {
	return $elm$core$String$fromInt(
		$elm$core$Basics$round(x * 255));
};
var $mdgriffith$elm_ui$Internal$Model$transformClass = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'mv-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(x) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(y) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(z))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			return $elm$core$Maybe$Just(
				'tfrm-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ty) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ox) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oz) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(angle))))))))))))))))))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$getStyleName = function (style) {
	switch (style.$) {
		case 13:
			var name = style.a;
			return name;
		case 12:
			var name = style.a;
			var o = style.b;
			return name;
		case 0:
			var _class = style.a;
			return _class;
		case 1:
			var name = style.a;
			return name;
		case 2:
			var i = style.a;
			return 'font-size-' + $elm$core$String$fromInt(i);
		case 3:
			var _class = style.a;
			return _class;
		case 4:
			var _class = style.a;
			return _class;
		case 5:
			var cls = style.a;
			var x = style.b;
			var y = style.c;
			return cls;
		case 7:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 6:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 8:
			var template = style.a;
			return 'grid-rows-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.jI)) + ('-cols-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.cc)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.j$.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.j$.b)))))));
		case 9:
			var pos = style.a;
			return 'gp grid-pos-' + ($elm$core$String$fromInt(pos.e_) + ('-' + ($elm$core$String$fromInt(pos.dK) + ('-' + ($elm$core$String$fromInt(pos.dp) + ('-' + $elm$core$String$fromInt(pos.bn)))))));
		case 11:
			var selector = style.a;
			var subStyle = style.b;
			var name = function () {
				switch (selector) {
					case 0:
						return 'fs';
					case 1:
						return 'hv';
					default:
						return 'act';
				}
			}();
			return A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					function (sty) {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$getStyleName(sty);
						if (_v1 === '') {
							return '';
						} else {
							var styleName = _v1;
							return styleName + ('-' + name);
						}
					},
					subStyle));
		default:
			var x = style.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$mdgriffith$elm_ui$Internal$Model$transformClass(x));
	}
};
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $mdgriffith$elm_ui$Internal$Model$reduceStyles = F2(
	function (style, nevermind) {
		var cache = nevermind.a;
		var existing = nevermind.b;
		var styleName = $mdgriffith$elm_ui$Internal$Model$getStyleName(style);
		return A2($elm$core$Set$member, styleName, cache) ? nevermind : _Utils_Tuple2(
			A2($elm$core$Set$insert, styleName, cache),
			A2($elm$core$List$cons, style, existing));
	});
var $mdgriffith$elm_ui$Internal$Model$Property = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$Style = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$dot = function (c) {
	return '.' + c;
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $mdgriffith$elm_ui$Internal$Model$formatColor = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return 'rgba(' + ($elm$core$String$fromInt(
		$elm$core$Basics$round(red * 255)) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(green * 255))) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(blue * 255))) + (',' + ($elm$core$String$fromFloat(alpha) + ')')))));
};
var $mdgriffith$elm_ui$Internal$Model$formatBoxShadow = function (shadow) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					shadow.eg ? $elm$core$Maybe$Just('inset') : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.iW.a) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.iW.b) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.f6) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.jW) + 'px'),
					$elm$core$Maybe$Just(
					$mdgriffith$elm_ui$Internal$Model$formatColor(shadow.gy))
				])));
};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $mdgriffith$elm_ui$Internal$Model$renderFocusStyle = function (focus) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.d5) + ':focus-within',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.dC),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.dz),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										f6: shadow.f6,
										gy: shadow.gy,
										eg: false,
										iW: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.iW)),
										jW: shadow.jW
									}));
						},
						focus.e7),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					]))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX) + ':focus .focusable, ') + (($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX) + '.focusable:focus, ') + ('.ui-slide-bar:focus + ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX) + ' .focusable-thumb'))),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.dC),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.dz),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										f6: shadow.f6,
										gy: shadow.gy,
										eg: false,
										iW: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.iW)),
										jW: shadow.jW
									}));
						},
						focus.e7),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					])))
		]);
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $mdgriffith$elm_ui$Internal$Style$AllChildren = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Batch = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Style$Child = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Class = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Descriptor = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Left = 3;
var $mdgriffith$elm_ui$Internal$Style$Prop = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Right = 2;
var $mdgriffith$elm_ui$Internal$Style$Self = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Supports = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Content = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Bottom = 1;
var $mdgriffith$elm_ui$Internal$Style$CenterX = 4;
var $mdgriffith$elm_ui$Internal$Style$CenterY = 5;
var $mdgriffith$elm_ui$Internal$Style$Top = 0;
var $mdgriffith$elm_ui$Internal$Style$alignments = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $mdgriffith$elm_ui$Internal$Style$contentName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gM);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ce);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cg);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bG);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cf);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aG);
	}
};
var $mdgriffith$elm_ui$Internal$Style$selfName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fS);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fL);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dv);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.du);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fM);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fN);
	}
};
var $mdgriffith$elm_ui$Internal$Style$describeAlignment = function (values) {
	var createDescription = function (alignment) {
		var _v0 = values(alignment);
		var content = _v0.a;
		var indiv = _v0.b;
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$contentName(alignment),
				content),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						indiv)
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$elDescription = _List_fromArray(
	[
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c3),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f3),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jQ),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.s),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c6),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dr),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'auto !important')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c5),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c6),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dr),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ft),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dq),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
			])),
		$mdgriffith$elm_ui$Internal$Style$describeAlignment(
		function (alignment) {
			switch (alignment) {
				case 0:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
							]));
				case 1:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
							]));
				case 2:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
							]));
				case 3:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							]));
				case 4:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
							]));
				default:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
									]))
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
							]));
			}
		})
	]);
var $mdgriffith$elm_ui$Internal$Style$gridAlignments = function (values) {
	var createDescription = function (alignment) {
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						values(alignment))
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$Above = 0;
var $mdgriffith$elm_ui$Internal$Style$Behind = 5;
var $mdgriffith$elm_ui$Internal$Style$Below = 1;
var $mdgriffith$elm_ui$Internal$Style$OnLeft = 3;
var $mdgriffith$elm_ui$Internal$Style$OnRight = 2;
var $mdgriffith$elm_ui$Internal$Style$Within = 4;
var $mdgriffith$elm_ui$Internal$Style$locations = function () {
	var loc = 0;
	var _v0 = function () {
		switch (loc) {
			case 0:
				return 0;
			case 1:
				return 0;
			case 2:
				return 0;
			case 3:
				return 0;
			case 4:
				return 0;
			default:
				return 0;
		}
	}();
	return _List_fromArray(
		[0, 1, 2, 3, 4, 5]);
}();
var $mdgriffith$elm_ui$Internal$Style$baseSheet = _List_fromArray(
	[
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		'html,body',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		_Utils_ap(
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX),
			_Utils_ap(
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jV),
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hJ))),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c6),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-height', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dr),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX) + ':focus',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'outline', 'none')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jH),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'min-height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c6)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c6),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hL),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bs),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bs),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jV),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				$mdgriffith$elm_ui$Internal$Style$Batch(
				function (fn) {
					return A2($elm$core$List$map, fn, $mdgriffith$elm_ui$Internal$Style$locations);
				}(
					function (loc) {
						switch (loc) {
							case 0:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fx),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c6),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dr),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
												])),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 1:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f4),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c6),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												]))
										]));
							case 2:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iZ),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 3:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iY),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'right', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 4:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hL),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							default:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f3),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
						}
					}))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'resize', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'box-sizing', 'border-box'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-size', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-family', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'inherit'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ds),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-wrap', 'wrap')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eu),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-moz-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-webkit-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-ms-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'user-select', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gW),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'pointer')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gX),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.i5),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ca),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bf),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.a3),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.hG, $mdgriffith$elm_ui$Internal$Style$classes.bf)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.hG, $mdgriffith$elm_ui$Internal$Style$classes.a3)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.he, $mdgriffith$elm_ui$Internal$Style$classes.bf)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.he, $mdgriffith$elm_ui$Internal$Style$classes.a3)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.fD, $mdgriffith$elm_ui$Internal$Style$classes.bf)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.fD, $mdgriffith$elm_ui$Internal$Style$classes.a3)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fk),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Prop,
						'transition',
						A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								function (x) {
									return x + ' 160ms';
								},
								_List_fromArray(
									['transform', 'opacity', 'filter', 'background-color', 'color', 'font-size']))))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jN),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jO),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e_),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jP),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aF),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jV),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gt),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gu),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gv),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dq),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', 'auto')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.b8),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f8),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dashed')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f9),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dotted')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ga),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.s),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hV),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1.05'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background', 'transparent'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'inherit')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jV),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e_),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', '0%'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fs),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eq),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c6),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eb),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dr),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cd),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fR,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fP,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fM),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-left', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fP,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fM),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-right', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fP,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fN),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.fP + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.fR + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.fP)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_Nil);
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_Nil);
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j_),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cq),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'baseline')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aF),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', '0px'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'min-height', 'min-content'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ea),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c6),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dr),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ft),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dq),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fO,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fQ,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fN),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fQ,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fN),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fQ,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fN),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.fQ + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.fO + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.fQ)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cd),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j_),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hs),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', '-ms-grid'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'.gp',
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Supports,
						_Utils_Tuple2('display', 'grid'),
						_List_fromArray(
							[
								_Utils_Tuple2('display', 'grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$gridAlignments(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
										]);
								case 1:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
										]);
								case 2:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
										]);
								case 3:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
										]);
								case 4:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
										]);
								default:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
										]);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ez),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX + ':first-child'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.fX + ($mdgriffith$elm_ui$Internal$Style$selfName(3) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.fX))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.fX + ($mdgriffith$elm_ui$Internal$Style$selfName(2) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.fX))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\"\"'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\"\"'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hR),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background-color', 'transparent')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hU),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jV),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hT),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hS),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'transparent')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eC),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-wrap', 'break-word'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c3),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f3),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.s),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eC),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::after',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::before',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jV),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fs),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hL),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f3),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fx),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f4),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iZ),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iY),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.s),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e_),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aF),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-flex')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hs),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left')
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.hidden',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kr),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '100')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ki),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '200')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.km),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '300')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ko),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '400')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kn),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '500')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kq),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '600')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f7),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '700')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kh),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '800')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kj),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '900')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ij),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'italic')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j6),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kH),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kH),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j6)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ks),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'normal')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kk),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cE),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify-all')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kg),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'center')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kp),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'right')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kl),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'left')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.modal',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none')
					]))
			]))
	]);
var $mdgriffith$elm_ui$Internal$Style$fontVariant = function (_var) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + _var,
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\"' + (_var + '\"'))
				])),
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + (_var + '-off'),
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\"' + (_var + '\" 0'))
				]))
		]);
};
var $mdgriffith$elm_ui$Internal$Style$commonValues = $elm$core$List$concat(
	_List_fromArray(
		[
			A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.border-' + $elm$core$String$fromInt(x),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'border-width',
							$elm$core$String$fromInt(x) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 6)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 8, 32)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.p-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'padding',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 24)),
			_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'small-caps')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp-off',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'normal')
					]))
			]),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('zero'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('onum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('liga'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('dlig'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('ordn'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('tnum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('afrc'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('frac')
		]));
var $mdgriffith$elm_ui$Internal$Style$explainer = '\n.explain {\n    border: 6px solid rgb(174, 121, 15) !important;\n}\n.explain > .' + ($mdgriffith$elm_ui$Internal$Style$classes.fX + (' {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n.ctr {\n    border: none !important;\n}\n.explain > .ctr > .' + ($mdgriffith$elm_ui$Internal$Style$classes.fX + ' {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n')));
var $mdgriffith$elm_ui$Internal$Style$inputTextReset = '\ninput[type="search"],\ninput[type="search"]::-webkit-search-decoration,\ninput[type="search"]::-webkit-search-cancel-button,\ninput[type="search"]::-webkit-search-results-button,\ninput[type="search"]::-webkit-search-results-decoration {\n  -webkit-appearance:none;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$sliderReset = '\ninput[type=range] {\n  -webkit-appearance: none; \n  background: transparent;\n  position:absolute;\n  left:0;\n  top:0;\n  z-index:10;\n  width: 100%;\n  outline: dashed 1px;\n  height: 100%;\n  opacity: 0;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$thumbReset = '\ninput[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-moz-range-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-ms-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range][orient=vertical]{\n    writing-mode: bt-lr; /* IE */\n    -webkit-appearance: slider-vertical;  /* WebKit */\n}\n';
var $mdgriffith$elm_ui$Internal$Style$trackReset = '\ninput[type=range]::-moz-range-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-ms-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-webkit-slider-runnable-track {\n    background: transparent;\n    cursor: pointer;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$overrides = '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e_) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX) + (' { flex-basis: auto !important; } ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e_) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cd) + (' { flex-basis: auto !important; }}' + ($mdgriffith$elm_ui$Internal$Style$inputTextReset + ($mdgriffith$elm_ui$Internal$Style$sliderReset + ($mdgriffith$elm_ui$Internal$Style$trackReset + ($mdgriffith$elm_ui$Internal$Style$thumbReset + $mdgriffith$elm_ui$Internal$Style$explainer)))))))))))))));
var $mdgriffith$elm_ui$Internal$Style$Intermediate = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$emptyIntermediate = F2(
	function (selector, closing) {
		return {cb: closing, P: _List_Nil, aL: _List_Nil, ar: selector};
	});
var $mdgriffith$elm_ui$Internal$Style$renderRules = F2(
	function (_v0, rulesToRender) {
		var parent = _v0;
		var generateIntermediates = F2(
			function (rule, rendered) {
				switch (rule.$) {
					case 0:
						var name = rule.a;
						var val = rule.b;
						return _Utils_update(
							rendered,
							{
								aL: A2(
									$elm$core$List$cons,
									_Utils_Tuple2(name, val),
									rendered.aL)
							});
					case 3:
						var _v2 = rule.a;
						var prop = _v2.a;
						var value = _v2.b;
						var props = rule.b;
						return _Utils_update(
							rendered,
							{
								P: A2(
									$elm$core$List$cons,
									{cb: '\n}', P: _List_Nil, aL: props, ar: '@supports (' + (prop + (':' + (value + (') {' + parent.ar))))},
									rendered.P)
							});
					case 5:
						var selector = rule.a;
						var adjRules = rule.b;
						return _Utils_update(
							rendered,
							{
								P: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.ar + (' + ' + selector), ''),
										adjRules),
									rendered.P)
							});
					case 1:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								P: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.ar + (' > ' + child), ''),
										childRules),
									rendered.P)
							});
					case 2:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								P: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.ar + (' ' + child), ''),
										childRules),
									rendered.P)
							});
					case 4:
						var descriptor = rule.a;
						var descriptorRules = rule.b;
						return _Utils_update(
							rendered,
							{
								P: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2(
											$mdgriffith$elm_ui$Internal$Style$emptyIntermediate,
											_Utils_ap(parent.ar, descriptor),
											''),
										descriptorRules),
									rendered.P)
							});
					default:
						var batched = rule.a;
						return _Utils_update(
							rendered,
							{
								P: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.ar, ''),
										batched),
									rendered.P)
							});
				}
			});
		return A3($elm$core$List$foldr, generateIntermediates, parent, rulesToRender);
	});
var $mdgriffith$elm_ui$Internal$Style$renderCompact = function (styleClasses) {
	var renderValues = function (values) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				function (_v3) {
					var x = _v3.a;
					var y = _v3.b;
					return x + (':' + (y + ';'));
				},
				values));
	};
	var renderClass = function (rule) {
		var _v2 = rule.aL;
		if (!_v2.b) {
			return '';
		} else {
			return rule.ar + ('{' + (renderValues(rule.aL) + (rule.cb + '}')));
		}
	};
	var renderIntermediate = function (_v0) {
		var rule = _v0;
		return _Utils_ap(
			renderClass(rule),
			$elm$core$String$concat(
				A2($elm$core$List$map, renderIntermediate, rule.P)));
	};
	return $elm$core$String$concat(
		A2(
			$elm$core$List$map,
			renderIntermediate,
			A3(
				$elm$core$List$foldr,
				F2(
					function (_v1, existing) {
						var name = _v1.a;
						var styleRules = _v1.b;
						return A2(
							$elm$core$List$cons,
							A2(
								$mdgriffith$elm_ui$Internal$Style$renderRules,
								A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, name, ''),
								styleRules),
							existing);
					}),
				_List_Nil,
				styleClasses)));
};
var $mdgriffith$elm_ui$Internal$Style$rules = _Utils_ap(
	$mdgriffith$elm_ui$Internal$Style$overrides,
	$mdgriffith$elm_ui$Internal$Style$renderCompact(
		_Utils_ap($mdgriffith$elm_ui$Internal$Style$baseSheet, $mdgriffith$elm_ui$Internal$Style$commonValues)));
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $mdgriffith$elm_ui$Internal$Model$staticRoot = function (opts) {
	var _v0 = opts.iE;
	switch (_v0) {
		case 0:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'div',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$elm$virtual_dom$VirtualDom$node,
						'style',
						_List_Nil,
						_List_fromArray(
							[
								$elm$virtual_dom$VirtualDom$text($mdgriffith$elm_ui$Internal$Style$rules)
							]))
					]));
		case 1:
			return $elm$virtual_dom$VirtualDom$text('');
		default:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'elm-ui-static-rules',
				_List_fromArray(
					[
						A2(
						$elm$virtual_dom$VirtualDom$property,
						'rules',
						$elm$json$Json$Encode$string($mdgriffith$elm_ui$Internal$Style$rules))
					]),
				_List_Nil);
	}
};
var $mdgriffith$elm_ui$Internal$Model$fontName = function (font) {
	switch (font.$) {
		case 0:
			return 'serif';
		case 1:
			return 'sans-serif';
		case 2:
			return 'monospace';
		case 3:
			var name = font.a;
			return '\"' + (name + '\"');
		case 4:
			var name = font.a;
			var url = font.b;
			return '\"' + (name + '\"');
		default:
			var name = font.a.aC;
			return '\"' + (name + '\"');
	}
};
var $mdgriffith$elm_ui$Internal$Model$isSmallCaps = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return name === 'smcp';
		case 1:
			var name = _var.a;
			return false;
		default:
			var name = _var.a;
			var index = _var.b;
			return (name === 'smcp') && (index === 1);
	}
};
var $mdgriffith$elm_ui$Internal$Model$hasSmallCaps = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$isSmallCaps, font.fm);
	} else {
		return false;
	}
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $mdgriffith$elm_ui$Internal$Model$renderProps = F3(
	function (force, _v0, existing) {
		var key = _v0.a;
		var val = _v0.b;
		return force ? (existing + ('\n  ' + (key + (': ' + (val + ' !important;'))))) : (existing + ('\n  ' + (key + (': ' + (val + ';')))));
	});
var $mdgriffith$elm_ui$Internal$Model$renderStyle = F4(
	function (options, maybePseudo, selector, props) {
		if (maybePseudo.$ === 1) {
			return _List_fromArray(
				[
					selector + ('{' + (A3(
					$elm$core$List$foldl,
					$mdgriffith$elm_ui$Internal$Model$renderProps(false),
					'',
					props) + '\n}'))
				]);
		} else {
			var pseudo = maybePseudo.a;
			switch (pseudo) {
				case 1:
					var _v2 = options.hG;
					switch (_v2) {
						case 0:
							return _List_Nil;
						case 2:
							return _List_fromArray(
								[
									selector + ('-hv {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(true),
									'',
									props) + '\n}'))
								]);
						default:
							return _List_fromArray(
								[
									selector + ('-hv:hover {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(false),
									'',
									props) + '\n}'))
								]);
					}
				case 0:
					var renderedProps = A3(
						$elm$core$List$foldl,
						$mdgriffith$elm_ui$Internal$Model$renderProps(false),
						'',
						props);
					return _List_fromArray(
						[
							selector + ('-fs:focus {' + (renderedProps + '\n}')),
							('.' + ($mdgriffith$elm_ui$Internal$Style$classes.fX + (':focus ' + (selector + '-fs  {')))) + (renderedProps + '\n}'),
							(selector + '-fs:focus-within {') + (renderedProps + '\n}'),
							('.ui-slide-bar:focus + ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fX) + (' .focusable-thumb' + (selector + '-fs {')))) + (renderedProps + '\n}')
						]);
				default:
					return _List_fromArray(
						[
							selector + ('-act:active {' + (A3(
							$elm$core$List$foldl,
							$mdgriffith$elm_ui$Internal$Model$renderProps(false),
							'',
							props) + '\n}'))
						]);
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderVariant = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return '\"' + (name + '\"');
		case 1:
			var name = _var.a;
			return '\"' + (name + '\" 0');
		default:
			var name = _var.a;
			var index = _var.b;
			return '\"' + (name + ('\" ' + $elm$core$String$fromInt(index)));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderVariants = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$renderVariant, font.fm)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$transformValue = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'translate3d(' + ($elm$core$String$fromFloat(x) + ('px, ' + ($elm$core$String$fromFloat(y) + ('px, ' + ($elm$core$String$fromFloat(z) + 'px)'))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			var translate = 'translate3d(' + ($elm$core$String$fromFloat(tx) + ('px, ' + ($elm$core$String$fromFloat(ty) + ('px, ' + ($elm$core$String$fromFloat(tz) + 'px)')))));
			var scale = 'scale3d(' + ($elm$core$String$fromFloat(sx) + (', ' + ($elm$core$String$fromFloat(sy) + (', ' + ($elm$core$String$fromFloat(sz) + ')')))));
			var rotate = 'rotate3d(' + ($elm$core$String$fromFloat(ox) + (', ' + ($elm$core$String$fromFloat(oy) + (', ' + ($elm$core$String$fromFloat(oz) + (', ' + ($elm$core$String$fromFloat(angle) + 'rad)')))))));
			return $elm$core$Maybe$Just(translate + (' ' + (scale + (' ' + rotate))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderStyleRule = F3(
	function (options, rule, maybePseudo) {
		switch (rule.$) {
			case 0:
				var selector = rule.a;
				var props = rule.b;
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, selector, props);
			case 13:
				var name = rule.a;
				var prop = rule.b;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, 'box-shadow', prop)
						]));
			case 12:
				var name = rule.a;
				var transparency = rule.b;
				var opacity = A2(
					$elm$core$Basics$max,
					0,
					A2($elm$core$Basics$min, 1, 1 - transparency));
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'opacity',
							$elm$core$String$fromFloat(opacity))
						]));
			case 2:
				var i = rule.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			case 1:
				var name = rule.a;
				var typefaces = rule.b;
				var features = A2(
					$elm$core$String$join,
					', ',
					A2($elm$core$List$filterMap, $mdgriffith$elm_ui$Internal$Model$renderVariants, typefaces));
				var families = _List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-family',
						A2(
							$elm$core$String$join,
							', ',
							A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$fontName, typefaces))),
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'font-feature-settings', features),
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-variant',
						A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$hasSmallCaps, typefaces) ? 'small-caps' : 'normal')
					]);
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, '.' + name, families);
			case 3:
				var _class = rule.a;
				var prop = rule.b;
				var val = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, prop, val)
						]));
			case 4:
				var _class = rule.a;
				var prop = rule.b;
				var color = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							prop,
							$mdgriffith$elm_ui$Internal$Model$formatColor(color))
						]));
			case 5:
				var cls = rule.a;
				var x = rule.b;
				var y = rule.c;
				var yPx = $elm$core$String$fromInt(y) + 'px';
				var xPx = $elm$core$String$fromInt(x) + 'px';
				var single = '.' + $mdgriffith$elm_ui$Internal$Style$classes.jV;
				var row = '.' + $mdgriffith$elm_ui$Internal$Style$classes.e_;
				var wrappedRow = '.' + ($mdgriffith$elm_ui$Internal$Style$classes.ds + row);
				var right = '.' + $mdgriffith$elm_ui$Internal$Style$classes.dv;
				var paragraph = '.' + $mdgriffith$elm_ui$Internal$Style$classes.eC;
				var page = '.' + $mdgriffith$elm_ui$Internal$Style$classes.ez;
				var left = '.' + $mdgriffith$elm_ui$Internal$Style$classes.du;
				var halfY = $elm$core$String$fromFloat(y / 2) + 'px';
				var halfX = $elm$core$String$fromFloat(x / 2) + 'px';
				var column = '.' + $mdgriffith$elm_ui$Internal$Style$classes.aF;
				var _class = '.' + cls;
				var any = '.' + $mdgriffith$elm_ui$Internal$Style$classes.fX;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (row + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (wrappedRow + (' > ' + any)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin', halfY + (' ' + halfX))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (column + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_Utils_ap(_class, paragraph),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							'textarea' + (any + _class),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)')),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'height',
									'calc(100% + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::after'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\'\''),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-top',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::before'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\'\''),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-bottom',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								]))
						]));
			case 7:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'padding',
							$elm$core$String$fromFloat(top) + ('px ' + ($elm$core$String$fromFloat(right) + ('px ' + ($elm$core$String$fromFloat(bottom) + ('px ' + ($elm$core$String$fromFloat(left) + 'px')))))))
						]));
			case 6:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'border-width',
							$elm$core$String$fromInt(top) + ('px ' + ($elm$core$String$fromInt(right) + ('px ' + ($elm$core$String$fromInt(bottom) + ('px ' + ($elm$core$String$fromInt(left) + 'px')))))))
						]));
			case 8:
				var template = rule.a;
				var toGridLengthHelper = F3(
					function (minimum, maximum, x) {
						toGridLengthHelper:
						while (true) {
							switch (x.$) {
								case 0:
									var px = x.a;
									return $elm$core$String$fromInt(px) + 'px';
								case 1:
									var _v2 = _Utils_Tuple2(minimum, maximum);
									if (_v2.a.$ === 1) {
										if (_v2.b.$ === 1) {
											var _v3 = _v2.a;
											var _v4 = _v2.b;
											return 'max-content';
										} else {
											var _v6 = _v2.a;
											var maxSize = _v2.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v2.b.$ === 1) {
											var minSize = _v2.a.a;
											var _v5 = _v2.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + 'max-content)'));
										} else {
											var minSize = _v2.a.a;
											var maxSize = _v2.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 2:
									var i = x.a;
									var _v7 = _Utils_Tuple2(minimum, maximum);
									if (_v7.a.$ === 1) {
										if (_v7.b.$ === 1) {
											var _v8 = _v7.a;
											var _v9 = _v7.b;
											return $elm$core$String$fromInt(i) + 'fr';
										} else {
											var _v11 = _v7.a;
											var maxSize = _v7.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v7.b.$ === 1) {
											var minSize = _v7.a.a;
											var _v10 = _v7.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(i) + ('fr' + 'fr)'))));
										} else {
											var minSize = _v7.a.a;
											var maxSize = _v7.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 3:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = $elm$core$Maybe$Just(m),
										$temp$maximum = maximum,
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
								default:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = minimum,
										$temp$maximum = $elm$core$Maybe$Just(m),
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
							}
						}
					});
				var toGridLength = function (x) {
					return A3(toGridLengthHelper, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, x);
				};
				var xSpacing = toGridLength(template.j$.a);
				var ySpacing = toGridLength(template.j$.b);
				var rows = function (x) {
					return 'grid-template-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.jI)));
				var msRows = function (x) {
					return '-ms-grid-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.cc)));
				var msColumns = function (x) {
					return '-ms-grid-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.cc)));
				var gapY = 'grid-row-gap:' + (toGridLength(template.j$.b) + ';');
				var gapX = 'grid-column-gap:' + (toGridLength(template.j$.a) + ';');
				var columns = function (x) {
					return 'grid-template-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.cc)));
				var _class = '.grid-rows-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.jI)) + ('-cols-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.cc)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.j$.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.j$.b)))))));
				var modernGrid = _class + ('{' + (columns + (rows + (gapX + (gapY + '}')))));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msColumns + (msRows + '}')));
				return _List_fromArray(
					[base, supports]);
			case 9:
				var position = rule.a;
				var msPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'-ms-grid-row: ' + ($elm$core$String$fromInt(position.e_) + ';'),
							'-ms-grid-row-span: ' + ($elm$core$String$fromInt(position.bn) + ';'),
							'-ms-grid-column: ' + ($elm$core$String$fromInt(position.dK) + ';'),
							'-ms-grid-column-span: ' + ($elm$core$String$fromInt(position.dp) + ';')
						]));
				var modernPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'grid-row: ' + ($elm$core$String$fromInt(position.e_) + (' / ' + ($elm$core$String$fromInt(position.e_ + position.bn) + ';'))),
							'grid-column: ' + ($elm$core$String$fromInt(position.dK) + (' / ' + ($elm$core$String$fromInt(position.dK + position.dp) + ';')))
						]));
				var _class = '.grid-pos-' + ($elm$core$String$fromInt(position.e_) + ('-' + ($elm$core$String$fromInt(position.dK) + ('-' + ($elm$core$String$fromInt(position.dp) + ('-' + $elm$core$String$fromInt(position.bn)))))));
				var modernGrid = _class + ('{' + (modernPosition + '}'));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msPosition + '}'));
				return _List_fromArray(
					[base, supports]);
			case 11:
				var _class = rule.a;
				var styles = rule.b;
				var renderPseudoRule = function (style) {
					return A3(
						$mdgriffith$elm_ui$Internal$Model$renderStyleRule,
						options,
						style,
						$elm$core$Maybe$Just(_class));
				};
				return A2($elm$core$List$concatMap, renderPseudoRule, styles);
			default:
				var transform = rule.a;
				var val = $mdgriffith$elm_ui$Internal$Model$transformValue(transform);
				var _class = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				var _v12 = _Utils_Tuple2(_class, val);
				if ((!_v12.a.$) && (!_v12.b.$)) {
					var cls = _v12.a.a;
					var v = _v12.b.a;
					return A4(
						$mdgriffith$elm_ui$Internal$Model$renderStyle,
						options,
						maybePseudo,
						'.' + cls,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Model$Property, 'transform', v)
							]));
				} else {
					return _List_Nil;
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$encodeStyles = F2(
	function (options, stylesheet) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$map,
				function (style) {
					var styled = A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing);
					return _Utils_Tuple2(
						$mdgriffith$elm_ui$Internal$Model$getStyleName(style),
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, styled));
				},
				stylesheet));
	});
var $mdgriffith$elm_ui$Internal$Model$bracket = F2(
	function (selector, rules) {
		var renderPair = function (_v0) {
			var name = _v0.a;
			var val = _v0.b;
			return name + (': ' + (val + ';'));
		};
		return selector + (' {' + (A2(
			$elm$core$String$join,
			'',
			A2($elm$core$List$map, renderPair, rules)) + '}'));
	});
var $mdgriffith$elm_ui$Internal$Model$fontRule = F3(
	function (name, modifier, _v0) {
		var parentAdj = _v0.a;
		var textAdjustment = _v0.b;
		return _List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + (', ' + ('.' + (name + (' .' + modifier))))))), parentAdj),
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.s + (', .' + (name + (' .' + (modifier + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.s)))))))))), textAdjustment)
			]);
	});
var $mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule = F3(
	function (fontToAdjust, _v0, otherFontName) {
		var full = _v0.a;
		var capital = _v0.b;
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_Utils_ap(
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.jX, capital),
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.hm, full)));
	});
var $mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule = F2(
	function (fontToAdjust, otherFontName) {
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.jX + (', ' + ('.' + (name + (' .' + $mdgriffith$elm_ui$Internal$Style$classes.jX))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('line-height', '1')
						])),
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.jX + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.s + (', .' + (name + (' .' + ($mdgriffith$elm_ui$Internal$Style$classes.jX + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.s)))))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('vertical-align', '0'),
							_Utils_Tuple2('line-height', '1')
						]))
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$adjust = F3(
	function (size, height, vertical) {
		return {bn: height / size, jW: size, fn: vertical};
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$convertAdjustment = function (adjustment) {
	var lines = _List_fromArray(
		[adjustment.gn, adjustment.f2, adjustment.g_, adjustment.ix]);
	var lineHeight = 1.5;
	var normalDescender = (lineHeight - 1) / 2;
	var oldMiddle = lineHeight / 2;
	var descender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.g_,
		$elm$core$List$minimum(lines));
	var newBaseline = A2(
		$elm$core$Maybe$withDefault,
		adjustment.f2,
		$elm$core$List$minimum(
			A2(
				$elm$core$List$filter,
				function (x) {
					return !_Utils_eq(x, descender);
				},
				lines)));
	var base = lineHeight;
	var ascender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.gn,
		$elm$core$List$maximum(lines));
	var capitalSize = 1 / (ascender - newBaseline);
	var capitalVertical = 1 - ascender;
	var fullSize = 1 / (ascender - descender);
	var fullVertical = 1 - ascender;
	var newCapitalMiddle = ((ascender - newBaseline) / 2) + newBaseline;
	var newFullMiddle = ((ascender - descender) / 2) + descender;
	return {
		gn: A3($mdgriffith$elm_ui$Internal$Model$adjust, capitalSize, ascender - newBaseline, capitalVertical),
		d7: A3($mdgriffith$elm_ui$Internal$Model$adjust, fullSize, ascender - descender, fullVertical)
	};
};
var $mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules = function (converted) {
	return _Utils_Tuple2(
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'block')
			]),
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'inline-block'),
				_Utils_Tuple2(
				'line-height',
				$elm$core$String$fromFloat(converted.bn)),
				_Utils_Tuple2(
				'vertical-align',
				$elm$core$String$fromFloat(converted.fn) + 'em'),
				_Utils_Tuple2(
				'font-size',
				$elm$core$String$fromFloat(converted.jW) + 'em')
			]));
};
var $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment = function (typefaces) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (face, found) {
				if (found.$ === 1) {
					if (face.$ === 5) {
						var _with = face.a;
						var _v2 = _with.fJ;
						if (_v2.$ === 1) {
							return found;
						} else {
							var adjustment = _v2.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.d7;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment))),
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.gn;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment)))));
						}
					} else {
						return found;
					}
				} else {
					return found;
				}
			}),
		$elm$core$Maybe$Nothing,
		typefaces);
};
var $mdgriffith$elm_ui$Internal$Model$renderTopLevelValues = function (rules) {
	var withImport = function (font) {
		if (font.$ === 4) {
			var url = font.b;
			return $elm$core$Maybe$Just('@import url(\'' + (url + '\');'));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var fontImports = function (_v2) {
		var name = _v2.a;
		var typefaces = _v2.b;
		var imports = A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$filterMap, withImport, typefaces));
		return imports;
	};
	var allNames = A2($elm$core$List$map, $elm$core$Tuple$first, rules);
	var fontAdjustments = function (_v1) {
		var name = _v1.a;
		var typefaces = _v1.b;
		var _v0 = $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment(typefaces);
		if (_v0.$ === 1) {
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					$mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule(name),
					allNames));
		} else {
			var adjustment = _v0.a;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					A2($mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule, name, adjustment),
					allNames));
		}
	};
	return _Utils_ap(
		A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$map, fontImports, rules)),
		A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$map, fontAdjustments, rules)));
};
var $mdgriffith$elm_ui$Internal$Model$topLevelValue = function (rule) {
	if (rule.$ === 1) {
		var name = rule.a;
		var typefaces = rule.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(name, typefaces));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$toStyleSheetString = F2(
	function (options, stylesheet) {
		var combine = F2(
			function (style, rendered) {
				return {
					cz: _Utils_ap(
						rendered.cz,
						A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing)),
					b1: function () {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$topLevelValue(style);
						if (_v1.$ === 1) {
							return rendered.b1;
						} else {
							var topLevel = _v1.a;
							return A2($elm$core$List$cons, topLevel, rendered.b1);
						}
					}()
				};
			});
		var _v0 = A3(
			$elm$core$List$foldl,
			combine,
			{cz: _List_Nil, b1: _List_Nil},
			stylesheet);
		var topLevel = _v0.b1;
		var rules = _v0.cz;
		return _Utils_ap(
			$mdgriffith$elm_ui$Internal$Model$renderTopLevelValues(topLevel),
			$elm$core$String$concat(rules));
	});
var $mdgriffith$elm_ui$Internal$Model$toStyleSheet = F2(
	function (options, styleSheet) {
		var _v0 = options.iE;
		switch (_v0) {
			case 0:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			case 1:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			default:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'elm-ui-rules',
					_List_fromArray(
						[
							A2(
							$elm$virtual_dom$VirtualDom$property,
							'rules',
							A2($mdgriffith$elm_ui$Internal$Model$encodeStyles, options, styleSheet))
						]),
					_List_Nil);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$embedKeyed = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.he)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'static-stylesheet',
				$mdgriffith$elm_ui$Internal$Model$staticRoot(opts)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
				children)) : A2(
			$elm$core$List$cons,
			_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
			children);
	});
var $mdgriffith$elm_ui$Internal$Model$embedWith = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.he)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			$mdgriffith$elm_ui$Internal$Model$staticRoot(opts),
			A2($elm$core$List$cons, dynamicStyleSheet, children)) : A2($elm$core$List$cons, dynamicStyleSheet, children);
	});
var $mdgriffith$elm_ui$Internal$Flag$heightBetween = $mdgriffith$elm_ui$Internal$Flag$flag(45);
var $mdgriffith$elm_ui$Internal$Flag$heightFill = $mdgriffith$elm_ui$Internal$Flag$flag(37);
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $mdgriffith$elm_ui$Internal$Flag$present = F2(
	function (myFlag, _v0) {
		var fieldOne = _v0.a;
		var fieldTwo = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return _Utils_eq(first & fieldOne, first);
		} else {
			var second = myFlag.a;
			return _Utils_eq(second & fieldTwo, second);
		}
	});
var $elm$html$Html$s = _VirtualDom_node('s');
var $elm$html$Html$u = _VirtualDom_node('u');
var $mdgriffith$elm_ui$Internal$Flag$widthBetween = $mdgriffith$elm_ui$Internal$Flag$flag(44);
var $mdgriffith$elm_ui$Internal$Flag$widthFill = $mdgriffith$elm_ui$Internal$Flag$flag(39);
var $mdgriffith$elm_ui$Internal$Model$finalizeNode = F6(
	function (has, node, attributes, children, embedMode, parentContext) {
		var createNode = F2(
			function (nodeName, attrs) {
				if (children.$ === 1) {
					var keyed = children.a;
					return A3(
						$elm$virtual_dom$VirtualDom$keyedNode,
						nodeName,
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return keyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, false, opts, styles, keyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, true, opts, styles, keyed);
							}
						}());
				} else {
					var unkeyed = children.a;
					return A2(
						function () {
							switch (nodeName) {
								case 'div':
									return $elm$html$Html$div;
								case 'p':
									return $elm$html$Html$p;
								default:
									return $elm$virtual_dom$VirtualDom$node(nodeName);
							}
						}(),
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return unkeyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, false, opts, styles, unkeyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, true, opts, styles, unkeyed);
							}
						}());
				}
			});
		var html = function () {
			switch (node.$) {
				case 0:
					return A2(createNode, 'div', attributes);
				case 1:
					var nodeName = node.a;
					return A2(createNode, nodeName, attributes);
				default:
					var nodeName = node.a;
					var internal = node.b;
					return A3(
						$elm$virtual_dom$VirtualDom$node,
						nodeName,
						attributes,
						_List_fromArray(
							[
								A2(
								createNode,
								internal,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Style$classes.fX + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.jV))
									]))
							]));
			}
		}();
		switch (parentContext) {
			case 0:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignRight, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.fX, $mdgriffith$elm_ui$Internal$Style$classes.jV, $mdgriffith$elm_ui$Internal$Style$classes.cd, $mdgriffith$elm_ui$Internal$Style$classes.aG, $mdgriffith$elm_ui$Internal$Style$classes.fR])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerX, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.fX, $mdgriffith$elm_ui$Internal$Style$classes.jV, $mdgriffith$elm_ui$Internal$Style$classes.cd, $mdgriffith$elm_ui$Internal$Style$classes.aG, $mdgriffith$elm_ui$Internal$Style$classes.fP])))
						]),
					_List_fromArray(
						[html])) : html));
			case 1:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerY, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.fX, $mdgriffith$elm_ui$Internal$Style$classes.jV, $mdgriffith$elm_ui$Internal$Style$classes.cd, $mdgriffith$elm_ui$Internal$Style$classes.fQ])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignBottom, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.fX, $mdgriffith$elm_ui$Internal$Style$classes.jV, $mdgriffith$elm_ui$Internal$Style$classes.cd, $mdgriffith$elm_ui$Internal$Style$classes.fO])))
						]),
					_List_fromArray(
						[html])) : html));
			default:
				return html;
		}
	});
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $mdgriffith$elm_ui$Internal$Model$textElementClasses = $mdgriffith$elm_ui$Internal$Style$classes.fX + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.s + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.dq + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.c5)))));
var $mdgriffith$elm_ui$Internal$Model$textElement = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$textElementFillClasses = $mdgriffith$elm_ui$Internal$Style$classes.fX + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.s + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.dr + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.c6)))));
var $mdgriffith$elm_ui$Internal$Model$textElementFill = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementFillClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$createElement = F3(
	function (context, children, rendered) {
		var gatherKeyed = F2(
			function (_v8, _v9) {
				var key = _v8.a;
				var child = _v8.b;
				var htmls = _v9.a;
				var existingStyles = _v9.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.hH, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.j7 : _Utils_ap(styled.j7, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.hH, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.j7 : _Utils_ap(styled.j7, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str)),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		var gather = F2(
			function (child, _v6) {
				var htmls = _v6.a;
				var existingStyles = _v6.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.hH, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.j7 : _Utils_ap(styled.j7, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.hH, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.j7 : _Utils_ap(styled.j7, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		if (children.$ === 1) {
			var keyedChildren = children.a;
			var _v1 = A3(
				$elm$core$List$foldr,
				gatherKeyed,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				keyedChildren);
			var keyed = _v1.a;
			var styles = _v1.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.j7 : _Utils_ap(rendered.j7, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered.aW,
						rendered.a1,
						rendered.aQ,
						$mdgriffith$elm_ui$Internal$Model$Keyed(
							A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.aT)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						hH: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered.aW,
							rendered.a1,
							rendered.aQ,
							$mdgriffith$elm_ui$Internal$Model$Keyed(
								A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.aT))),
						j7: allStyles
					});
			}
		} else {
			var unkeyedChildren = children.a;
			var _v3 = A3(
				$elm$core$List$foldr,
				gather,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				unkeyedChildren);
			var unkeyed = _v3.a;
			var styles = _v3.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.j7 : _Utils_ap(rendered.j7, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered.aW,
						rendered.a1,
						rendered.aQ,
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.aT)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						hH: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered.aW,
							rendered.a1,
							rendered.aQ,
							$mdgriffith$elm_ui$Internal$Model$Unkeyed(
								A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.aT))),
						j7: allStyles
					});
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Single = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$Transform = function (a) {
	return {$: 10, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$add = F2(
	function (myFlag, _v0) {
		var one = _v0.a;
		var two = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, first | one, two);
		} else {
			var second = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, one, second | two);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehind = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenInFront = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$nearbyElement = F2(
	function (location, elem) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					function () {
						switch (location) {
							case 0:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bs, $mdgriffith$elm_ui$Internal$Style$classes.jV, $mdgriffith$elm_ui$Internal$Style$classes.fx]));
							case 1:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bs, $mdgriffith$elm_ui$Internal$Style$classes.jV, $mdgriffith$elm_ui$Internal$Style$classes.f4]));
							case 2:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bs, $mdgriffith$elm_ui$Internal$Style$classes.jV, $mdgriffith$elm_ui$Internal$Style$classes.iZ]));
							case 3:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bs, $mdgriffith$elm_ui$Internal$Style$classes.jV, $mdgriffith$elm_ui$Internal$Style$classes.iY]));
							case 4:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bs, $mdgriffith$elm_ui$Internal$Style$classes.jV, $mdgriffith$elm_ui$Internal$Style$classes.hL]));
							default:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bs, $mdgriffith$elm_ui$Internal$Style$classes.jV, $mdgriffith$elm_ui$Internal$Style$classes.f3]));
						}
					}())
				]),
			_List_fromArray(
				[
					function () {
					switch (elem.$) {
						case 3:
							return $elm$virtual_dom$VirtualDom$text('');
						case 2:
							var str = elem.a;
							return $mdgriffith$elm_ui$Internal$Model$textElement(str);
						case 0:
							var html = elem.a;
							return html($mdgriffith$elm_ui$Internal$Model$asEl);
						default:
							var styled = elem.a;
							return A2(styled.hH, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, $mdgriffith$elm_ui$Internal$Model$asEl);
					}
				}()
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$addNearbyElement = F3(
	function (location, elem, existing) {
		var nearby = A2($mdgriffith$elm_ui$Internal$Model$nearbyElement, location, elem);
		switch (existing.$) {
			case 0:
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						_List_fromArray(
							[nearby]));
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						_List_fromArray(
							[nearby]));
				}
			case 1:
				var existingBehind = existing.a;
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						A2($elm$core$List$cons, nearby, existingBehind));
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						_List_fromArray(
							[nearby]));
				}
			case 2:
				var existingInFront = existing.a;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						_List_fromArray(
							[nearby]),
						existingInFront);
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						A2($elm$core$List$cons, nearby, existingInFront));
				}
			default:
				var existingBehind = existing.a;
				var existingInFront = existing.b;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						A2($elm$core$List$cons, nearby, existingBehind),
						existingInFront);
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						A2($elm$core$List$cons, nearby, existingInFront));
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Embedded = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$NodeName = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addNodeName = F2(
	function (newNode, old) {
		switch (old.$) {
			case 0:
				return $mdgriffith$elm_ui$Internal$Model$NodeName(newNode);
			case 1:
				var name = old.a;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, name, newNode);
			default:
				var x = old.a;
				var y = old.b;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, x, y);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$alignXName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.cJ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.du);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.cJ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dv);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.cJ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fM);
	}
};
var $mdgriffith$elm_ui$Internal$Model$alignYName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.cK + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fS);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.cK + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fL);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.cK + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fN);
	}
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $mdgriffith$elm_ui$Internal$Model$FullTransform = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Internal$Model$Moved = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$composeTransformation = F2(
	function (transform, component) {
		switch (transform.$) {
			case 0:
				switch (component.$) {
					case 0:
						var x = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, 0, 0));
					case 1:
						var y = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, y, 0));
					case 2:
						var z = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, 0, z));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var xyz = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							xyz,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			case 1:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(newX, y, z));
					case 1:
						var newY = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, newY, z));
					case 2:
						var newZ = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, y, newZ));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var scale = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							scale,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			default:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				var scaled = transform.b;
				var origin = transform.c;
				var angle = transform.d;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(newX, y, z),
							scaled,
							origin,
							angle);
					case 1:
						var newY = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, newY, z),
							scaled,
							origin,
							angle);
					case 2:
						var newZ = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, y, newZ),
							scaled,
							origin,
							angle);
					case 3:
						var newMove = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, newMove, scaled, origin, angle);
					case 4:
						var newOrigin = component.a;
						var newAngle = component.b;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, scaled, newOrigin, newAngle);
					default:
						var newScale = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, newScale, origin, angle);
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$height = $mdgriffith$elm_ui$Internal$Flag$flag(7);
var $mdgriffith$elm_ui$Internal$Flag$heightContent = $mdgriffith$elm_ui$Internal$Flag$flag(36);
var $mdgriffith$elm_ui$Internal$Flag$merge = F2(
	function (_v0, _v1) {
		var one = _v0.a;
		var two = _v0.b;
		var three = _v1.a;
		var four = _v1.b;
		return A2($mdgriffith$elm_ui$Internal$Flag$Field, one | three, two | four);
	});
var $mdgriffith$elm_ui$Internal$Flag$none = A2($mdgriffith$elm_ui$Internal$Flag$Field, 0, 0);
var $mdgriffith$elm_ui$Internal$Model$renderHeight = function (h) {
	switch (h.$) {
		case 0:
			var px = h.a;
			var val = $elm$core$String$fromInt(px);
			var name = 'height-px-' + val;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.ea + (' ' + name),
				_List_fromArray(
					[
						A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height', val + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.c5,
				_List_Nil);
		case 2:
			var portion = h.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.c6,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.eb + (' height-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.fX + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.aF + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'height-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = h.a;
			var len = h.b;
			var cls = 'min-height-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-height',
				$elm$core$String$fromInt(minSize) + 'px !important');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = h.a;
			var len = h.b;
			var cls = 'max-height-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-height',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$widthContent = $mdgriffith$elm_ui$Internal$Flag$flag(38);
var $mdgriffith$elm_ui$Internal$Model$renderWidth = function (w) {
	switch (w.$) {
		case 0:
			var px = w.a;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.fs + (' width-px-' + $elm$core$String$fromInt(px)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						'width-px-' + $elm$core$String$fromInt(px),
						'width',
						$elm$core$String$fromInt(px) + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.dq,
				_List_Nil);
		case 2:
			var portion = w.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.dr,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.ft + (' width-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.fX + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.e_ + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'width-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = w.a;
			var len = w.b;
			var cls = 'min-width-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-width',
				$elm$core$String$fromInt(minSize) + 'px');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = w.a;
			var len = w.b;
			var cls = 'max-width-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-width',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$borderWidth = $mdgriffith$elm_ui$Internal$Flag$flag(27);
var $mdgriffith$elm_ui$Internal$Model$skippable = F2(
	function (flag, style) {
		if (_Utils_eq(flag, $mdgriffith$elm_ui$Internal$Flag$borderWidth)) {
			if (style.$ === 3) {
				var val = style.c;
				switch (val) {
					case '0px':
						return true;
					case '1px':
						return true;
					case '2px':
						return true;
					case '3px':
						return true;
					case '4px':
						return true;
					case '5px':
						return true;
					case '6px':
						return true;
					default:
						return false;
				}
			} else {
				return false;
			}
		} else {
			switch (style.$) {
				case 2:
					var i = style.a;
					return (i >= 8) && (i <= 32);
				case 7:
					var name = style.a;
					var t = style.b;
					var r = style.c;
					var b = style.d;
					var l = style.e;
					return _Utils_eq(t, b) && (_Utils_eq(t, r) && (_Utils_eq(t, l) && ((t >= 0) && (t <= 24))));
				default:
					return false;
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$width = $mdgriffith$elm_ui$Internal$Flag$flag(6);
var $mdgriffith$elm_ui$Internal$Flag$xAlign = $mdgriffith$elm_ui$Internal$Flag$flag(30);
var $mdgriffith$elm_ui$Internal$Flag$yAlign = $mdgriffith$elm_ui$Internal$Flag$flag(29);
var $mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive = F8(
	function (classes, node, has, transform, styles, attrs, children, elementAttrs) {
		gatherAttrRecursive:
		while (true) {
			if (!elementAttrs.b) {
				var _v1 = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				if (_v1.$ === 1) {
					return {
						aQ: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes),
							attrs),
						aT: children,
						aW: has,
						a1: node,
						j7: styles
					};
				} else {
					var _class = _v1.a;
					return {
						aQ: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes + (' ' + _class)),
							attrs),
						aT: children,
						aW: has,
						a1: node,
						j7: A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$Transform(transform),
							styles)
					};
				}
			} else {
				var attribute = elementAttrs.a;
				var remaining = elementAttrs.b;
				switch (attribute.$) {
					case 0:
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 3:
						var flag = attribute.a;
						var exactClassName = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = exactClassName + (' ' + classes),
								$temp$node = node,
								$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					case 1:
						var actualAttribute = attribute.a;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = A2($elm$core$List$cons, actualAttribute, attrs),
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 4:
						var flag = attribute.a;
						var style = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							if (A2($mdgriffith$elm_ui$Internal$Model$skippable, flag, style)) {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							} else {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = A2($elm$core$List$cons, style, styles),
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							}
						}
					case 10:
						var flag = attribute.a;
						var component = attribute.b;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
							$temp$transform = A2($mdgriffith$elm_ui$Internal$Model$composeTransformation, transform, component),
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 7:
						var width = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$width, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (width.$) {
								case 0:
									var px = width.a;
									var $temp$classes = ($mdgriffith$elm_ui$Internal$Style$classes.fs + (' width-px-' + $elm$core$String$fromInt(px))) + (' ' + classes),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3(
											$mdgriffith$elm_ui$Internal$Model$Single,
											'width-px-' + $elm$core$String$fromInt(px),
											'width',
											$elm$core$String$fromInt(px) + 'px'),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dq),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$widthContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = width.a;
									if (portion === 1) {
										var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dr),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.ft + (' width-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.fX + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.e_ + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'width-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v4 = $mdgriffith$elm_ui$Internal$Model$renderWidth(width);
									var addToFlags = _v4.a;
									var newClass = _v4.b;
									var newStyles = _v4.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 8:
						var height = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$height, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (height.$) {
								case 0:
									var px = height.a;
									var val = $elm$core$String$fromInt(px) + 'px';
									var name = 'height-px-' + val;
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.ea + (' ' + (name + (' ' + classes))),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height ', val),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.c5 + (' ' + classes),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$heightContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = height.a;
									if (portion === 1) {
										var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.c6 + (' ' + classes),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.eb + (' height-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.fX + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.aF + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'height-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v6 = $mdgriffith$elm_ui$Internal$Model$renderHeight(height);
									var addToFlags = _v6.a;
									var newClass = _v6.b;
									var newStyles = _v6.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 2:
						var description = attribute.a;
						switch (description.$) {
							case 0:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'main', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 1:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'nav', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 2:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'footer', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 3:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'aside', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 4:
								var i = description.a;
								if (i <= 1) {
									var $temp$classes = classes,
										$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h1', node),
										$temp$has = has,
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								} else {
									if (i < 7) {
										var $temp$classes = classes,
											$temp$node = A2(
											$mdgriffith$elm_ui$Internal$Model$addNodeName,
											'h' + $elm$core$String$fromInt(i),
											node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes,
											$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h6', node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								}
							case 9:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 8:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'role', 'button'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 5:
								var label = description.a;
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-label', label),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 6:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'polite'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							default:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'assertive'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
						}
					case 9:
						var location = attribute.a;
						var elem = attribute.b;
						var newStyles = function () {
							switch (elem.$) {
								case 3:
									return styles;
								case 2:
									var str = elem.a;
									return styles;
								case 0:
									var html = elem.a;
									return styles;
								default:
									var styled = elem.a;
									return _Utils_ap(styles, styled.j7);
							}
						}();
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = newStyles,
							$temp$attrs = attrs,
							$temp$children = A3($mdgriffith$elm_ui$Internal$Model$addNearbyElement, location, elem, children),
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 6:
						var x = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignXName(x) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (x) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerX, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignRight, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					default:
						var y = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignYName(y) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (y) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerY, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignBottom, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
				}
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Untransformed = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$untransformed = $mdgriffith$elm_ui$Internal$Model$Untransformed;
var $mdgriffith$elm_ui$Internal$Model$element = F4(
	function (context, node, attributes, children) {
		return A3(
			$mdgriffith$elm_ui$Internal$Model$createElement,
			context,
			children,
			A8(
				$mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive,
				$mdgriffith$elm_ui$Internal$Model$contextClasses(context),
				node,
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Model$untransformed,
				_List_Nil,
				_List_Nil,
				$mdgriffith$elm_ui$Internal$Model$NoNearbyChildren,
				$elm$core$List$reverse(attributes)));
	});
var $mdgriffith$elm_ui$Internal$Model$Height = function (a) {
	return {$: 8, a: a};
};
var $mdgriffith$elm_ui$Element$height = $mdgriffith$elm_ui$Internal$Model$Height;
var $mdgriffith$elm_ui$Internal$Model$Content = {$: 1};
var $mdgriffith$elm_ui$Element$shrink = $mdgriffith$elm_ui$Internal$Model$Content;
var $mdgriffith$elm_ui$Internal$Model$Width = function (a) {
	return {$: 7, a: a};
};
var $mdgriffith$elm_ui$Element$width = $mdgriffith$elm_ui$Internal$Model$Width;
var $mdgriffith$elm_ui$Element$el = F2(
	function (attrs, child) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					attrs)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[child])));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$run = F2(
	function (context, _v0) {
		var f = _v0;
		return f(context);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$Element = $elm$core$Basics$identity;
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$attributes = F2(
	function (context, attrs) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var f = _v0;
				return f(context);
			},
			attrs);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs = F4(
	function (ctor, f, attrs, child) {
		return function (context) {
			return A2(
				ctor,
				A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$attributes, context, attrs),
				A2(f, context, child));
		};
	});
var $lucamug$elm_ui_with_context$Element$WithContext$el = A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs, $mdgriffith$elm_ui$Element$el, $lucamug$elm_ui_with_context$Element$WithContext$Internal$run);
var $mdgriffith$elm_ui$Internal$Model$Fill = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$fill = $mdgriffith$elm_ui$Internal$Model$Fill(1);
var $lucamug$elm_ui_with_context$Element$WithContext$fill = $mdgriffith$elm_ui$Element$fill;
var $mdgriffith$elm_ui$Internal$Model$FocusStyleOption = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Element$focusStyle = $mdgriffith$elm_ui$Internal$Model$FocusStyleOption;
var $lucamug$elm_ui_with_context$Element$WithContext$focusStyle = $mdgriffith$elm_ui$Element$focusStyle;
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$Attribute = $elm$core$Basics$identity;
var $lucamug$elm_ui_with_context$Element$WithContext$attribute = function (elem) {
	return function (_v0) {
		return elem;
	};
};
var $lucamug$elm_ui_with_context$Element$WithContext$height = function (l) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
		$mdgriffith$elm_ui$Element$height(l));
};
var $mdgriffith$elm_ui$Internal$Model$Attr = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$htmlClass = function (cls) {
	return $mdgriffith$elm_ui$Internal$Model$Attr(
		$elm$html$Html$Attributes$class(cls));
};
var $mdgriffith$elm_ui$Internal$Model$OnlyDynamic = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$AllowHover = 1;
var $mdgriffith$elm_ui$Internal$Model$Layout = 0;
var $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle = {
	dz: $elm$core$Maybe$Nothing,
	dC: $elm$core$Maybe$Nothing,
	e7: $elm$core$Maybe$Just(
		{
			f6: 0,
			gy: A4($mdgriffith$elm_ui$Internal$Model$Rgba, 155 / 255, 203 / 255, 1, 1),
			iW: _Utils_Tuple2(0, 0),
			jW: 3
		})
};
var $mdgriffith$elm_ui$Internal$Model$optionsToRecord = function (options) {
	var combine = F2(
		function (opt, record) {
			switch (opt.$) {
				case 0:
					var hoverable = opt.a;
					var _v4 = record.hG;
					if (_v4.$ === 1) {
						return _Utils_update(
							record,
							{
								hG: $elm$core$Maybe$Just(hoverable)
							});
					} else {
						return record;
					}
				case 1:
					var focusStyle = opt.a;
					var _v5 = record.he;
					if (_v5.$ === 1) {
						return _Utils_update(
							record,
							{
								he: $elm$core$Maybe$Just(focusStyle)
							});
					} else {
						return record;
					}
				default:
					var renderMode = opt.a;
					var _v6 = record.iE;
					if (_v6.$ === 1) {
						return _Utils_update(
							record,
							{
								iE: $elm$core$Maybe$Just(renderMode)
							});
					} else {
						return record;
					}
			}
		});
	var andFinally = function (record) {
		return {
			he: function () {
				var _v0 = record.he;
				if (_v0.$ === 1) {
					return $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle;
				} else {
					var focusable = _v0.a;
					return focusable;
				}
			}(),
			hG: function () {
				var _v1 = record.hG;
				if (_v1.$ === 1) {
					return 1;
				} else {
					var hoverable = _v1.a;
					return hoverable;
				}
			}(),
			iE: function () {
				var _v2 = record.iE;
				if (_v2.$ === 1) {
					return 0;
				} else {
					var actualMode = _v2.a;
					return actualMode;
				}
			}()
		};
	};
	return andFinally(
		A3(
			$elm$core$List$foldr,
			combine,
			{he: $elm$core$Maybe$Nothing, hG: $elm$core$Maybe$Nothing, iE: $elm$core$Maybe$Nothing},
			options));
};
var $mdgriffith$elm_ui$Internal$Model$toHtml = F2(
	function (mode, el) {
		switch (el.$) {
			case 0:
				var html = el.a;
				return html($mdgriffith$elm_ui$Internal$Model$asEl);
			case 1:
				var styles = el.a.j7;
				var html = el.a.hH;
				return A2(
					html,
					mode(styles),
					$mdgriffith$elm_ui$Internal$Model$asEl);
			case 2:
				var text = el.a;
				return $mdgriffith$elm_ui$Internal$Model$textElement(text);
			default:
				return $mdgriffith$elm_ui$Internal$Model$textElement('');
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderRoot = F3(
	function (optionList, attributes, child) {
		var options = $mdgriffith$elm_ui$Internal$Model$optionsToRecord(optionList);
		var embedStyle = function () {
			var _v0 = options.iE;
			if (_v0 === 1) {
				return $mdgriffith$elm_ui$Internal$Model$OnlyDynamic(options);
			} else {
				return $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic(options);
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Internal$Model$toHtml,
			embedStyle,
			A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				attributes,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[child]))));
	});
var $mdgriffith$elm_ui$Internal$Model$Colored = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$FontFamily = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$FontSize = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$SansSerif = {$: 1};
var $mdgriffith$elm_ui$Internal$Model$StyleClass = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$Typeface = function (a) {
	return {$: 3, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$bgColor = $mdgriffith$elm_ui$Internal$Flag$flag(8);
var $mdgriffith$elm_ui$Internal$Flag$fontColor = $mdgriffith$elm_ui$Internal$Flag$flag(14);
var $mdgriffith$elm_ui$Internal$Flag$fontFamily = $mdgriffith$elm_ui$Internal$Flag$flag(5);
var $mdgriffith$elm_ui$Internal$Flag$fontSize = $mdgriffith$elm_ui$Internal$Flag$flag(4);
var $mdgriffith$elm_ui$Internal$Model$formatColorClass = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return $mdgriffith$elm_ui$Internal$Model$floatClass(red) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(green) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(blue) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(alpha))))));
};
var $elm$core$String$words = _String_words;
var $mdgriffith$elm_ui$Internal$Model$renderFontClassName = F2(
	function (font, current) {
		return _Utils_ap(
			current,
			function () {
				switch (font.$) {
					case 0:
						return 'serif';
					case 1:
						return 'sans-serif';
					case 2:
						return 'monospace';
					case 3:
						var name = font.a;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					case 4:
						var name = font.a;
						var url = font.b;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					default:
						var name = font.a.aC;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
				}
			}());
	});
var $mdgriffith$elm_ui$Internal$Model$rootStyle = function () {
	var families = _List_fromArray(
		[
			$mdgriffith$elm_ui$Internal$Model$Typeface('Open Sans'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Helvetica'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Verdana'),
			$mdgriffith$elm_ui$Internal$Model$SansSerif
		]);
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$bgColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'bg-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0)),
				'background-color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'fc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1)),
				'color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontSize,
			$mdgriffith$elm_ui$Internal$Model$FontSize(20)),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontFamily,
			A2(
				$mdgriffith$elm_ui$Internal$Model$FontFamily,
				A3($elm$core$List$foldl, $mdgriffith$elm_ui$Internal$Model$renderFontClassName, 'font-', families),
				families))
		]);
}();
var $mdgriffith$elm_ui$Element$layoutWith = F3(
	function (_v0, attrs, child) {
		var options = _v0.ey;
		return A3(
			$mdgriffith$elm_ui$Internal$Model$renderRoot,
			options,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[$mdgriffith$elm_ui$Internal$Style$classes.jH, $mdgriffith$elm_ui$Internal$Style$classes.fX, $mdgriffith$elm_ui$Internal$Style$classes.jV]))),
				_Utils_ap($mdgriffith$elm_ui$Internal$Model$rootStyle, attrs)),
			child);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$layoutWith = F4(
	function (context, options, attrs, _v0) {
		var f = _v0;
		return A3(
			$mdgriffith$elm_ui$Element$layoutWith,
			options,
			A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$attributes, context, attrs),
			f(context));
	});
var $author$project$T2$Internal$Text$ParagraphMedium = 18;
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr = function (a) {
	return function (_v0) {
		return a;
	};
};
var $mdgriffith$elm_ui$Element$Font$color = function (fontColor) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'fc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(fontColor),
			'color',
			fontColor));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Font$color = function (fontColor) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr(
		$mdgriffith$elm_ui$Element$Font$color(fontColor));
};
var $author$project$T2$Internal$Font$FontLato = 0;
var $author$project$T2$Internal$Font$FontLatoMedium = 1;
var $author$project$T2$Internal$Font$FontRubik = 3;
var $author$project$T2$Internal$Text$getFont = F2(
	function (typography, context) {
		var _v0 = _Utils_Tuple2(context.cF, typography);
		if (!_v0.a) {
			switch (_v0.b) {
				case 0:
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return 3;
				case 1:
					var _v5 = _v0.a;
					var _v6 = _v0.b;
					return 1;
				case 2:
					var _v9 = _v0.a;
					var _v10 = _v0.b;
					return 1;
				case 3:
					var _v13 = _v0.a;
					var _v14 = _v0.b;
					return 1;
				case 4:
					var _v17 = _v0.a;
					var _v18 = _v0.b;
					return 3;
				case 5:
					var _v21 = _v0.a;
					var _v22 = _v0.b;
					return 3;
				case 6:
					var _v25 = _v0.a;
					var _v26 = _v0.b;
					return 3;
				case 7:
					var _v29 = _v0.a;
					var _v30 = _v0.b;
					return 3;
				case 8:
					var _v33 = _v0.a;
					var _v34 = _v0.b;
					return 3;
				case 9:
					var _v37 = _v0.a;
					var _v38 = _v0.b;
					return 3;
				case 10:
					var _v41 = _v0.a;
					var _v42 = _v0.b;
					return 3;
				case 11:
					var _v45 = _v0.a;
					var _v46 = _v0.b;
					return 1;
				case 12:
					var _v49 = _v0.a;
					var _v50 = _v0.b;
					return 1;
				case 13:
					var _v53 = _v0.a;
					var _v54 = _v0.b;
					return 1;
				case 14:
					var _v57 = _v0.a;
					var _v58 = _v0.b;
					return 1;
				case 15:
					var _v61 = _v0.a;
					var _v62 = _v0.b;
					return 1;
				case 16:
					var _v65 = _v0.a;
					var _v66 = _v0.b;
					return 0;
				case 17:
					var _v69 = _v0.a;
					var _v70 = _v0.b;
					return 0;
				case 18:
					var _v73 = _v0.a;
					var _v74 = _v0.b;
					return 0;
				case 19:
					var _v77 = _v0.a;
					var _v78 = _v0.b;
					return 0;
				case 20:
					var _v81 = _v0.a;
					var _v82 = _v0.b;
					return 0;
				case 21:
					var _v85 = _v0.a;
					var _v86 = _v0.b;
					return 0;
				case 22:
					var _v89 = _v0.a;
					var _v90 = _v0.b;
					return 1;
				case 23:
					var _v93 = _v0.a;
					var _v94 = _v0.b;
					return 1;
				case 24:
					var _v97 = _v0.a;
					var _v98 = _v0.b;
					return 1;
				case 25:
					var _v101 = _v0.a;
					var _v102 = _v0.b;
					return 1;
				case 26:
					var _v105 = _v0.a;
					var _v106 = _v0.b;
					return 1;
				case 27:
					var _v109 = _v0.a;
					var _v110 = _v0.b;
					return 1;
				case 28:
					var _v113 = _v0.a;
					var _v114 = _v0.b;
					return 0;
				case 29:
					var _v117 = _v0.a;
					var _v118 = _v0.b;
					return 0;
				case 30:
					var _v121 = _v0.a;
					var _v122 = _v0.b;
					return 0;
				case 31:
					var _v125 = _v0.a;
					var _v126 = _v0.b;
					return 0;
				case 32:
					var _v129 = _v0.a;
					var _v130 = _v0.b;
					return 0;
				case 36:
					var _v133 = _v0.a;
					var _v134 = _v0.b;
					return 0;
				case 37:
					var _v137 = _v0.a;
					var _v138 = _v0.b;
					return 0;
				case 38:
					var _v141 = _v0.a;
					var _v142 = _v0.b;
					return 0;
				case 33:
					var _v145 = _v0.a;
					var _v146 = _v0.b;
					return 0;
				case 34:
					var _v149 = _v0.a;
					var _v150 = _v0.b;
					return 0;
				default:
					var _v153 = _v0.a;
					var _v154 = _v0.b;
					return 0;
			}
		} else {
			switch (_v0.b) {
				case 0:
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					return 3;
				case 1:
					var _v7 = _v0.a;
					var _v8 = _v0.b;
					return 1;
				case 2:
					var _v11 = _v0.a;
					var _v12 = _v0.b;
					return 1;
				case 3:
					var _v15 = _v0.a;
					var _v16 = _v0.b;
					return 1;
				case 4:
					var _v19 = _v0.a;
					var _v20 = _v0.b;
					return 3;
				case 5:
					var _v23 = _v0.a;
					var _v24 = _v0.b;
					return 3;
				case 6:
					var _v27 = _v0.a;
					var _v28 = _v0.b;
					return 3;
				case 7:
					var _v31 = _v0.a;
					var _v32 = _v0.b;
					return 3;
				case 8:
					var _v35 = _v0.a;
					var _v36 = _v0.b;
					return 3;
				case 9:
					var _v39 = _v0.a;
					var _v40 = _v0.b;
					return 3;
				case 10:
					var _v43 = _v0.a;
					var _v44 = _v0.b;
					return 3;
				case 11:
					var _v47 = _v0.a;
					var _v48 = _v0.b;
					return 1;
				case 12:
					var _v51 = _v0.a;
					var _v52 = _v0.b;
					return 1;
				case 13:
					var _v55 = _v0.a;
					var _v56 = _v0.b;
					return 1;
				case 14:
					var _v59 = _v0.a;
					var _v60 = _v0.b;
					return 1;
				case 15:
					var _v63 = _v0.a;
					var _v64 = _v0.b;
					return 1;
				case 16:
					var _v67 = _v0.a;
					var _v68 = _v0.b;
					return 0;
				case 17:
					var _v71 = _v0.a;
					var _v72 = _v0.b;
					return 0;
				case 18:
					var _v75 = _v0.a;
					var _v76 = _v0.b;
					return 0;
				case 19:
					var _v79 = _v0.a;
					var _v80 = _v0.b;
					return 0;
				case 20:
					var _v83 = _v0.a;
					var _v84 = _v0.b;
					return 0;
				case 21:
					var _v87 = _v0.a;
					var _v88 = _v0.b;
					return 0;
				case 22:
					var _v91 = _v0.a;
					var _v92 = _v0.b;
					return 1;
				case 23:
					var _v95 = _v0.a;
					var _v96 = _v0.b;
					return 1;
				case 24:
					var _v99 = _v0.a;
					var _v100 = _v0.b;
					return 1;
				case 25:
					var _v103 = _v0.a;
					var _v104 = _v0.b;
					return 1;
				case 26:
					var _v107 = _v0.a;
					var _v108 = _v0.b;
					return 1;
				case 27:
					var _v111 = _v0.a;
					var _v112 = _v0.b;
					return 1;
				case 28:
					var _v115 = _v0.a;
					var _v116 = _v0.b;
					return 0;
				case 29:
					var _v119 = _v0.a;
					var _v120 = _v0.b;
					return 0;
				case 30:
					var _v123 = _v0.a;
					var _v124 = _v0.b;
					return 0;
				case 31:
					var _v127 = _v0.a;
					var _v128 = _v0.b;
					return 0;
				case 32:
					var _v131 = _v0.a;
					var _v132 = _v0.b;
					return 0;
				case 36:
					var _v135 = _v0.a;
					var _v136 = _v0.b;
					return 0;
				case 37:
					var _v139 = _v0.a;
					var _v140 = _v0.b;
					return 0;
				case 38:
					var _v143 = _v0.a;
					var _v144 = _v0.b;
					return 0;
				case 33:
					var _v147 = _v0.a;
					var _v148 = _v0.b;
					return 0;
				case 34:
					var _v151 = _v0.a;
					var _v152 = _v0.b;
					return 0;
				default:
					var _v155 = _v0.a;
					var _v156 = _v0.b;
					return 0;
			}
		}
	});
var $author$project$T2$Internal$Text$FontConfig = F3(
	function (size, weightAttribute, lineHeight) {
		return {ep: lineHeight, jW: size, fr: weightAttribute};
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute = function (a) {
	return function (_v0) {
		return a;
	};
};
var $mdgriffith$elm_ui$Internal$Model$Class = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$fontWeight = $mdgriffith$elm_ui$Internal$Flag$flag(13);
var $mdgriffith$elm_ui$Element$Font$medium = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.kn);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$medium = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$medium);
var $mdgriffith$elm_ui$Element$Font$regular = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.ko);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$regular = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$regular);
var $mdgriffith$elm_ui$Element$Font$semiBold = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.kq);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$semiBold);
var $author$project$T2$Internal$Text$getFontConfig = function (typography) {
	switch (typography) {
		case 0:
			return A3($author$project$T2$Internal$Text$FontConfig, 96, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 112);
		case 1:
			return A3($author$project$T2$Internal$Text$FontConfig, 52, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 64);
		case 2:
			return A3($author$project$T2$Internal$Text$FontConfig, 44, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 52);
		case 3:
			return A3($author$project$T2$Internal$Text$FontConfig, 36, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 44);
		case 4:
			return A3($author$project$T2$Internal$Text$FontConfig, 40, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 40);
		case 5:
			return A3($author$project$T2$Internal$Text$FontConfig, 36, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 36);
		case 6:
			return A3($author$project$T2$Internal$Text$FontConfig, 32, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 32);
		case 7:
			return A3($author$project$T2$Internal$Text$FontConfig, 28, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 28);
		case 8:
			return A3($author$project$T2$Internal$Text$FontConfig, 24, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 24);
		case 9:
			return A3($author$project$T2$Internal$Text$FontConfig, 20, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 20);
		case 10:
			return A3($author$project$T2$Internal$Text$FontConfig, 18, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 18);
		case 11:
			return A3($author$project$T2$Internal$Text$FontConfig, 20, $lucamug$elm_ui_with_context$Element$WithContext$Font$medium, 28);
		case 12:
			return A3($author$project$T2$Internal$Text$FontConfig, 18, $lucamug$elm_ui_with_context$Element$WithContext$Font$medium, 24);
		case 13:
			return A3($author$project$T2$Internal$Text$FontConfig, 16, $lucamug$elm_ui_with_context$Element$WithContext$Font$medium, 20);
		case 14:
			return A3($author$project$T2$Internal$Text$FontConfig, 14, $lucamug$elm_ui_with_context$Element$WithContext$Font$medium, 16);
		case 15:
			return A3($author$project$T2$Internal$Text$FontConfig, 12, $lucamug$elm_ui_with_context$Element$WithContext$Font$medium, 16);
		case 16:
			return A3($author$project$T2$Internal$Text$FontConfig, 20, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 32);
		case 17:
			return A3($author$project$T2$Internal$Text$FontConfig, 18, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 28);
		case 18:
			return A3($author$project$T2$Internal$Text$FontConfig, 16, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 24);
		case 19:
			return A3($author$project$T2$Internal$Text$FontConfig, 14, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 20);
		case 20:
			return A3($author$project$T2$Internal$Text$FontConfig, 12, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 16);
		case 21:
			return A3($author$project$T2$Internal$Text$FontConfig, 10, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 12);
		case 23:
			return A3($author$project$T2$Internal$Text$FontConfig, 20, $lucamug$elm_ui_with_context$Element$WithContext$Font$medium, 32);
		case 22:
			return A3($author$project$T2$Internal$Text$FontConfig, 18, $lucamug$elm_ui_with_context$Element$WithContext$Font$medium, 28);
		case 24:
			return A3($author$project$T2$Internal$Text$FontConfig, 16, $lucamug$elm_ui_with_context$Element$WithContext$Font$medium, 24);
		case 25:
			return A3($author$project$T2$Internal$Text$FontConfig, 14, $lucamug$elm_ui_with_context$Element$WithContext$Font$medium, 20);
		case 26:
			return A3($author$project$T2$Internal$Text$FontConfig, 12, $lucamug$elm_ui_with_context$Element$WithContext$Font$medium, 16);
		case 27:
			return A3($author$project$T2$Internal$Text$FontConfig, 10, $lucamug$elm_ui_with_context$Element$WithContext$Font$medium, 12);
		case 29:
			return A3($author$project$T2$Internal$Text$FontConfig, 18, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 28);
		case 28:
			return A3($author$project$T2$Internal$Text$FontConfig, 20, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 32);
		case 30:
			return A3($author$project$T2$Internal$Text$FontConfig, 16, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 24);
		case 31:
			return A3($author$project$T2$Internal$Text$FontConfig, 14, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 20);
		case 32:
			return A3($author$project$T2$Internal$Text$FontConfig, 12, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 16);
		case 33:
			return A3($author$project$T2$Internal$Text$FontConfig, 18, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 28);
		case 34:
			return A3($author$project$T2$Internal$Text$FontConfig, 16, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 24);
		case 35:
			return A3($author$project$T2$Internal$Text$FontConfig, 14, $lucamug$elm_ui_with_context$Element$WithContext$Font$regular, 20);
		case 36:
			return A3($author$project$T2$Internal$Text$FontConfig, 18, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 28);
		case 37:
			return A3($author$project$T2$Internal$Text$FontConfig, 16, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 24);
		default:
			return A3($author$project$T2$Internal$Text$FontConfig, 14, $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, 20);
	}
};
var $mdgriffith$elm_ui$Internal$Flag$letterSpacing = $mdgriffith$elm_ui$Internal$Flag$flag(16);
var $mdgriffith$elm_ui$Element$Font$letterSpacing = function (offset) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$letterSpacing,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			'ls-' + $mdgriffith$elm_ui$Internal$Model$floatClass(offset),
			'letter-spacing',
			$elm$core$String$fromFloat(offset) + 'px'));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Font$letterSpacing = function (offset) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Font$letterSpacing(offset));
};
var $mdgriffith$elm_ui$Element$Font$family = function (families) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontFamily,
		A2(
			$mdgriffith$elm_ui$Internal$Model$FontFamily,
			A3($elm$core$List$foldl, $mdgriffith$elm_ui$Internal$Model$renderFontClassName, 'ff-', families),
			families));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Font$family = function (families) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Font$family(families));
};
var $mdgriffith$elm_ui$Element$Font$sansSerif = $mdgriffith$elm_ui$Internal$Model$SansSerif;
var $lucamug$elm_ui_with_context$Element$WithContext$Font$sansSerif = $mdgriffith$elm_ui$Element$Font$sansSerif;
var $mdgriffith$elm_ui$Element$Font$typeface = $mdgriffith$elm_ui$Internal$Model$Typeface;
var $lucamug$elm_ui_with_context$Element$WithContext$Font$typeface = function (name) {
	return $mdgriffith$elm_ui$Element$Font$typeface(name);
};
var $author$project$T2$Internal$Font$renderFont = function (font) {
	var _v0 = function () {
		switch (font) {
			case 0:
				return _Utils_Tuple2('Lato Regular', $lucamug$elm_ui_with_context$Element$WithContext$Font$sansSerif);
			case 1:
				return _Utils_Tuple2('Lato Medium', $lucamug$elm_ui_with_context$Element$WithContext$Font$sansSerif);
			case 2:
				return _Utils_Tuple2('Lato Bold', $lucamug$elm_ui_with_context$Element$WithContext$Font$sansSerif);
			case 3:
				return _Utils_Tuple2('Rubik', $lucamug$elm_ui_with_context$Element$WithContext$Font$sansSerif);
			default:
				return _Utils_Tuple2('Open Sans', $lucamug$elm_ui_with_context$Element$WithContext$Font$sansSerif);
		}
	}();
	var typeface = _v0.a;
	var fallbackFont = _v0.b;
	return $lucamug$elm_ui_with_context$Element$WithContext$Font$family(
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$Font$typeface(typeface),
				fallbackFont
			]));
};
var $mdgriffith$elm_ui$Element$Font$size = function (i) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontSize,
		$mdgriffith$elm_ui$Internal$Model$FontSize(i));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Font$size = function (i) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr(
		$mdgriffith$elm_ui$Element$Font$size(i));
};
var $mdgriffith$elm_ui$Internal$Model$SpacingStyle = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Flag$spacing = $mdgriffith$elm_ui$Internal$Flag$flag(3);
var $mdgriffith$elm_ui$Internal$Model$spacingName = F2(
	function (x, y) {
		return 'spacing-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y)));
	});
var $mdgriffith$elm_ui$Element$spacing = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$spacing,
		A3(
			$mdgriffith$elm_ui$Internal$Model$SpacingStyle,
			A2($mdgriffith$elm_ui$Internal$Model$spacingName, x, x),
			x,
			x));
};
var $lucamug$elm_ui_with_context$Element$WithContext$spacing = function (x) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
		$mdgriffith$elm_ui$Element$spacing(x));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$runAttr = F2(
	function (context, _v0) {
		var f = _v0;
		return f(context);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$withContextAttribute = function (f) {
	return function (context) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$Internal$runAttr,
			context,
			f(context));
	};
};
var $author$project$T2$Internal$Text$renderAttributes = F3(
	function (attrs, typography, color) {
		var fontConfig = $author$project$T2$Internal$Text$getFontConfig(typography);
		var paragraphLineSpacing = fontConfig.ep - fontConfig.jW;
		var textAttrs = _Utils_ap(
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$withContextAttribute(
					function (context) {
						return $author$project$T2$Internal$Font$renderFont(
							A2($author$project$T2$Internal$Text$getFont, typography, context));
					}),
					$lucamug$elm_ui_with_context$Element$WithContext$Font$letterSpacing(0),
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(fontConfig.jW),
					fontConfig.fr,
					$lucamug$elm_ui_with_context$Element$WithContext$Font$color(color),
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(paragraphLineSpacing)
				]),
			attrs);
		return textAttrs;
	});
var $author$project$T2$Text$paragraphMediumAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 18, color);
	});
var $author$project$T2$Internal$Background$Primary = 0;
var $author$project$T2$Internal$Color$Swatch$turquoise60 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 48, 222, 216);
var $author$project$T2$Internal$Color$bgAccent = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	}
};
var $author$project$T2$Internal$Color$Swatch$red20 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 201, 0, 0);
var $author$project$T2$Internal$Color$Swatch$red30 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 225, 25, 0);
var $author$project$T2$Internal$Color$bgError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$Swatch$gray40 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 100, 99, 99);
var $author$project$T2$Internal$Color$Swatch$gray80 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 227, 226, 226);
var $author$project$T2$Internal$Color$bgGrey = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	}
};
var $author$project$T2$Internal$Color$Swatch$red01 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 102, 0, 0);
var $author$project$T2$Internal$Color$Swatch$red99 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 253, 231, 230);
var $author$project$T2$Internal$Color$bgLightOrDarkError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red01;
	}
};
var $author$project$T2$Internal$Color$Swatch$sGreen10 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 77, 33);
var $author$project$T2$Internal$Color$Swatch$sGreen99 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 228, 248, 237);
var $author$project$T2$Internal$Color$bgLightOrDarkSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen10;
	}
};
var $author$project$T2$Internal$Color$Swatch$yellow01 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 153, 115, 40);
var $author$project$T2$Internal$Color$Swatch$yellow99 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 253, 232);
var $author$project$T2$Internal$Color$bgLightOrDarkWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow01;
	}
};
var $mdgriffith$elm_ui$Element$rgba255 = F4(
	function (red, green, blue, a) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, red / 255, green / 255, blue / 255, a);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$rgba255 = $mdgriffith$elm_ui$Element$rgba255;
var $author$project$T2$Internal$Color$Swatch$greenAlfa30Percent = A4($lucamug$elm_ui_with_context$Element$WithContext$rgba255, 0, 18, 14, 0.3);
var $author$project$T2$Internal$Color$Swatch$greenAlfa50Percent = A4($lucamug$elm_ui_with_context$Element$WithContext$rgba255, 0, 18, 14, 0.5);
var $author$project$T2$Internal$Color$bgOverlayDark = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$greenAlfa30Percent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$greenAlfa50Percent;
	}
};
var $author$project$T2$Internal$Color$bgOverlayDarker = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$greenAlfa30Percent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$greenAlfa50Percent;
	}
};
var $author$project$T2$Internal$Color$Swatch$greenAlfa08Percent = A4($lucamug$elm_ui_with_context$Element$WithContext$rgba255, 0, 18, 14, 0.08);
var $author$project$T2$Internal$Color$bgOverlayLight = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$greenAlfa08Percent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$greenAlfa30Percent;
	}
};
var $author$project$T2$Internal$Color$Swatch$gray95 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 244, 244, 244);
var $author$project$T2$Internal$Color$Swatch$green05 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 33, 26);
var $author$project$T2$Internal$Color$bgSecondary = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$Swatch$sGreen30 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 143, 70);
var $author$project$T2$Internal$Color$Swatch$sGreen40 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 160, 82);
var $author$project$T2$Internal$Color$bgSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen30;
	}
};
var $author$project$T2$Internal$Color$Swatch$green99 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 223, 242, 240);
var $author$project$T2$Internal$Color$bgTertiary = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$Swatch$green50 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 133, 120);
var $author$project$T2$Internal$Color$bgVariantPrimary = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green99;
	}
};
var $author$project$T2$Internal$Color$bgVariantSecondary = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen99;
	}
};
var $author$project$T2$Internal$Color$Swatch$yellow30 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 229, 173, 60);
var $author$project$T2$Internal$Color$Swatch$yellow40 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 192, 67);
var $author$project$T2$Internal$Color$bgWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow30;
	}
};
var $mdgriffith$elm_ui$Element$Background$color = function (clr) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$bgColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'bg-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr),
			'background-color',
			clr));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Background$color = function (clr) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr(
		$mdgriffith$elm_ui$Element$Background$color(clr));
};
var $author$project$T2$Internal$Background$renderBackgroundColor = function (style) {
	var color = function () {
		switch (style) {
			case 0:
				return $author$project$T2$Internal$Color$bgPrimary;
			case 1:
				return $author$project$T2$Internal$Color$bgSecondary;
			case 2:
				return $author$project$T2$Internal$Color$bgTertiary;
			case 3:
				return $author$project$T2$Internal$Color$bgGrey;
			case 4:
				return $author$project$T2$Internal$Color$bgVariantPrimary;
			case 5:
				return $author$project$T2$Internal$Color$bgVariantSecondary;
			case 6:
				return $author$project$T2$Internal$Color$bgOverlayDarker;
			case 7:
				return $author$project$T2$Internal$Color$bgOverlayDark;
			case 8:
				return $author$project$T2$Internal$Color$bgOverlayLight;
			case 9:
				return $author$project$T2$Internal$Color$bgSuccess;
			case 10:
				return $author$project$T2$Internal$Color$bgLightOrDarkSuccess;
			case 11:
				return $author$project$T2$Internal$Color$bgError;
			case 12:
				return $author$project$T2$Internal$Color$bgLightOrDarkError;
			case 13:
				return $author$project$T2$Internal$Color$bgWarning;
			case 14:
				return $author$project$T2$Internal$Color$bgLightOrDarkWarning;
			default:
				return $author$project$T2$Internal$Color$bgAccent;
		}
	}();
	return $lucamug$elm_ui_with_context$Element$WithContext$withContextAttribute(
		function (context) {
			return $lucamug$elm_ui_with_context$Element$WithContext$Background$color(
				color(context));
		});
};
var $author$project$T2$Background$primary = $author$project$T2$Internal$Background$renderBackgroundColor(0);
var $mdgriffith$elm_ui$Internal$Model$AlignY = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Bottom = 2;
var $mdgriffith$elm_ui$Element$alignBottom = $mdgriffith$elm_ui$Internal$Model$AlignY(2);
var $lucamug$elm_ui_with_context$Element$WithContext$alignBottom = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$alignBottom);
var $mdgriffith$elm_ui$Internal$Model$AsColumn = 1;
var $mdgriffith$elm_ui$Internal$Model$asColumn = 1;
var $mdgriffith$elm_ui$Element$column = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.gM + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.bG)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapContainer = F3(
	function (container, attrs, children) {
		return function (context) {
			return A2(
				container,
				A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$attributes, context, attrs),
				A2(
					$elm$core$List$map,
					$lucamug$elm_ui_with_context$Element$WithContext$Internal$run(context),
					children));
		};
	});
var $lucamug$elm_ui_with_context$Element$WithContext$column = $lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapContainer($mdgriffith$elm_ui$Element$column);
var $mdgriffith$elm_ui$Internal$Model$AlignX = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Left = 0;
var $mdgriffith$elm_ui$Element$alignLeft = $mdgriffith$elm_ui$Internal$Model$AlignX(0);
var $lucamug$elm_ui_with_context$Element$WithContext$alignLeft = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$alignLeft);
var $mdgriffith$elm_ui$Internal$Model$Right = 2;
var $mdgriffith$elm_ui$Element$alignRight = $mdgriffith$elm_ui$Internal$Model$AlignX(2);
var $lucamug$elm_ui_with_context$Element$WithContext$alignRight = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$alignRight);
var $mdgriffith$elm_ui$Internal$Model$Top = 0;
var $mdgriffith$elm_ui$Element$alignTop = $mdgriffith$elm_ui$Internal$Model$AlignY(0);
var $lucamug$elm_ui_with_context$Element$WithContext$alignTop = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$alignTop);
var $author$project$T2$Internal$Color$bgTopLinks = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$Swatch$gray30 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 69, 68, 68);
var $author$project$T2$Internal$Color$contentSecondary = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Divider$Divider1 = 0;
var $lucamug$elm_ui_with_context$Element$WithContext$element = function (elem) {
	return function (_v0) {
		return elem;
	};
};
var $mdgriffith$elm_ui$Internal$Model$Empty = {$: 3};
var $mdgriffith$elm_ui$Element$none = $mdgriffith$elm_ui$Internal$Model$Empty;
var $lucamug$elm_ui_with_context$Element$WithContext$none = $lucamug$elm_ui_with_context$Element$WithContext$element($mdgriffith$elm_ui$Element$none);
var $mdgriffith$elm_ui$Internal$Model$Px = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$px = $mdgriffith$elm_ui$Internal$Model$Px;
var $lucamug$elm_ui_with_context$Element$WithContext$px = $mdgriffith$elm_ui$Element$px;
var $lucamug$elm_ui_with_context$Element$WithContext$width = function (l) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
		$mdgriffith$elm_ui$Element$width(l));
};
var $author$project$T2$Internal$Divider$renderDivider = F2(
	function (divider, color) {
		var weight = function () {
			switch (divider) {
				case 0:
					return 1;
				case 1:
					return 2;
				default:
					return 4;
			}
		}();
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(weight)),
					$lucamug$elm_ui_with_context$Element$WithContext$Background$color(color)
				]),
			$lucamug$elm_ui_with_context$Element$WithContext$none);
	});
var $author$project$T2$Divider$divider1 = function (color) {
	return A2($author$project$T2$Internal$Divider$renderDivider, 0, color);
};
var $author$project$T2$Internal$Color$fgTopLinkTitle = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	}
};
var $author$project$T2$Internal$Color$Swatch$sGreen70 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 205, 131);
var $author$project$T2$Internal$Color$footerDivider = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen70;
	}
};
var $mdgriffith$elm_ui$Element$htmlAttribute = $mdgriffith$elm_ui$Internal$Model$Attr;
var $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute = function (child) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
		$mdgriffith$elm_ui$Element$htmlAttribute(child));
};
var $author$project$T2$Internal$Text$LabelMedium = 13;
var $author$project$T2$Text$labelMediumAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 13, color);
	});
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $mdgriffith$elm_ui$Element$link = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$NodeName('a'),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Attr(
					$elm$html$Html$Attributes$href(url)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$Attr(
						$elm$html$Html$Attributes$rel('noopener noreferrer')),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cf + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.aG + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.eq)))),
								attrs))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$link = A2(
	$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
	$mdgriffith$elm_ui$Element$link,
	F2(
		function (context, _v0) {
			var url = _v0.R;
			var label = _v0.u;
			return {
				u: A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$run, context, label),
				R: url
			};
		}));
var $author$project$T2$Internal$Link$ContentInverse = 3;
var $author$project$T2$Internal$Link$Enabled = 0;
var $author$project$T2$Internal$Link$OpenAtCurrentPage = {$: 0};
var $author$project$T2$Internal$Link$Small = 3;
var $author$project$T2$Internal$Link$Subtle = 0;
var $author$project$T2$Internal$Link$Disabled = 1;
var $author$project$T2$Internal$Icon$Large = 4;
var $author$project$T2$Internal$Icon$Medium = 2;
var $author$project$T2$Internal$Icon$MediumX = 3;
var $author$project$T2$Internal$Icon$Small = 1;
var $author$project$T2$Internal$Icon$SmallX = 0;
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $mdgriffith$elm_ui$Internal$Model$Button = {$: 8};
var $mdgriffith$elm_ui$Internal$Model$Describe = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $mdgriffith$elm_ui$Element$Input$enter = 'Enter';
var $mdgriffith$elm_ui$Internal$Model$NoAttribute = {$: 0};
var $mdgriffith$elm_ui$Element$Input$hasFocusStyle = function (attr) {
	if (((attr.$ === 4) && (attr.b.$ === 11)) && (!attr.b.a)) {
		var _v1 = attr.b;
		var _v2 = _v1.a;
		return true;
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Element$Input$focusDefault = function (attrs) {
	return A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, attrs) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass('focusable');
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $mdgriffith$elm_ui$Element$Events$onClick = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onClick);
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $mdgriffith$elm_ui$Element$Input$onKeyLookup = function (lookup) {
	var decode = function (code) {
		var _v0 = lookup(code);
		if (_v0.$ === 1) {
			return $elm$json$Json$Decode$fail('No key matched');
		} else {
			var msg = _v0.a;
			return $elm$json$Json$Decode$succeed(msg);
		}
	};
	var isKey = A2(
		$elm$json$Json$Decode$andThen,
		decode,
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	return $mdgriffith$elm_ui$Internal$Model$Attr(
		A2(
			$elm$html$Html$Events$preventDefaultOn,
			'keydown',
			A2(
				$elm$json$Json$Decode$map,
				function (fired) {
					return _Utils_Tuple2(fired, true);
				},
				isKey)));
};
var $mdgriffith$elm_ui$Internal$Flag$cursor = $mdgriffith$elm_ui$Internal$Flag$flag(21);
var $mdgriffith$elm_ui$Element$pointer = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.gW);
var $mdgriffith$elm_ui$Element$Input$space = ' ';
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $mdgriffith$elm_ui$Element$Input$button = F2(
	function (attrs, _v0) {
		var onPress = _v0.ew;
		var label = _v0.u;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cf + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.aG + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.jQ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.eu)))))),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$pointer,
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$Input$focusDefault(attrs),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Button),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Internal$Model$Attr(
											$elm$html$Html$Attributes$tabindex(0)),
										function () {
											if (onPress.$ === 1) {
												return A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Internal$Model$Attr(
														$elm$html$Html$Attributes$disabled(true)),
													attrs);
											} else {
												var msg = onPress.a;
												return A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Element$Events$onClick(msg),
													A2(
														$elm$core$List$cons,
														$mdgriffith$elm_ui$Element$Input$onKeyLookup(
															function (code) {
																return _Utils_eq(code, $mdgriffith$elm_ui$Element$Input$enter) ? $elm$core$Maybe$Just(msg) : (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space) ? $elm$core$Maybe$Just(msg) : $elm$core$Maybe$Nothing);
															}),
														attrs));
											}
										}()))))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$button = A2(
	$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
	$mdgriffith$elm_ui$Element$Input$button,
	F2(
		function (context, _v0) {
			var onPress = _v0.ew;
			var label = _v0.u;
			return {
				u: A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$run, context, label),
				ew: onPress
			};
		}));
var $mdgriffith$elm_ui$Internal$Model$CenterY = 1;
var $mdgriffith$elm_ui$Element$centerY = $mdgriffith$elm_ui$Internal$Model$AlignY(1);
var $lucamug$elm_ui_with_context$Element$WithContext$centerY = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$centerY);
var $author$project$T2$Internal$Color$contentErrorLinkEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$contentInverseLinkEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$contentPrimaryLinkEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$contentSecondaryLinkEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Text$LinkLarge = 29;
var $author$project$T2$Text$linkLargeAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 29, color);
	});
var $author$project$T2$Internal$Text$LinkLargeX = 28;
var $author$project$T2$Text$linkLargeXAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 28, color);
	});
var $author$project$T2$Internal$Text$LinkMedium = 30;
var $author$project$T2$Text$linkMediumAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 30, color);
	});
var $author$project$T2$Internal$Text$LinkSmall = 31;
var $author$project$T2$Text$linkSmallAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 31, color);
	});
var $author$project$T2$Internal$Text$LinkSmallX = 32;
var $author$project$T2$Text$linkSmallXAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 32, color);
	});
var $mdgriffith$elm_ui$Internal$Model$Paragraph = {$: 9};
var $mdgriffith$elm_ui$Element$paragraph = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asParagraph,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Paragraph),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$spacing(5),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$paragraph = $lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapContainer($mdgriffith$elm_ui$Element$paragraph);
var $mdgriffith$elm_ui$Internal$Model$Text = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$text = function (content) {
	return $mdgriffith$elm_ui$Internal$Model$Text(content);
};
var $lucamug$elm_ui_with_context$Element$WithContext$text = function (content) {
	return $lucamug$elm_ui_with_context$Element$WithContext$element(
		$mdgriffith$elm_ui$Element$text(content));
};
var $author$project$T2$Internal$Link$internalRenderLabel = F3(
	function (size, labelText, color) {
		var fontAttrs = function () {
			switch (size) {
				case 4:
					return $author$project$T2$Text$linkSmallXAttrs;
				case 3:
					return $author$project$T2$Text$linkSmallAttrs;
				case 2:
					return $author$project$T2$Text$linkMediumAttrs;
				case 1:
					return $author$project$T2$Text$linkLargeAttrs;
				default:
					return $author$project$T2$Text$linkLargeXAttrs;
			}
		}();
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
			A2(
				fontAttrs,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
					]),
				color),
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$text(labelText)
				]));
	});
var $author$project$T2$Internal$Color$Swatch$gray60 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 148, 148, 148);
var $author$project$T2$Internal$Color$linkDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$Swatch$sGreen60 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 195, 107);
var $author$project$T2$Internal$Color$Swatch$turquoise10 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 110, 110);
var $author$project$T2$Internal$Color$linkEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen60;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Min = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$minimum = F2(
	function (i, l) {
		return A2($mdgriffith$elm_ui$Internal$Model$Min, i, l);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$minimum = $mdgriffith$elm_ui$Element$minimum;
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $mdgriffith$elm_ui$Element$newTabLink = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$NodeName('a'),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Attr(
					$elm$html$Html$Attributes$href(url)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$Attr(
						$elm$html$Html$Attributes$rel('noopener noreferrer')),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$Attr(
							$elm$html$Html$Attributes$target('_blank')),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cf + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.aG + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.eq)))),
									attrs)))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$newTabLink = A2(
	$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
	$mdgriffith$elm_ui$Element$newTabLink,
	F2(
		function (context, _v0) {
			var url = _v0.R;
			var label = _v0.u;
			return {
				u: A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$run, context, label),
				R: url
			};
		}));
var $lucamug$elm_ui_with_context$Element$WithContext$pointer = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$pointer);
var $mdgriffith$elm_ui$Internal$Model$AsRow = 0;
var $mdgriffith$elm_ui$Internal$Model$asRow = 0;
var $mdgriffith$elm_ui$Element$row = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asRow,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bG + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.aG)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$row = $lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapContainer($mdgriffith$elm_ui$Element$row);
var $lucamug$elm_ui_with_context$Element$WithContext$shrink = $mdgriffith$elm_ui$Element$shrink;
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $lucamug$elm_ui_with_context$Element$WithContext$withContext = function (f) {
	return function (context) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$Internal$run,
			context,
			f(context));
	};
};
var $author$project$T2$Internal$Link$renderLink = function (attrs) {
	return function (state) {
		return function (size) {
			return function (emphasis) {
				return function (leftIconMaybe) {
					return function (labelText) {
						return function (url) {
							return function (rightIconMaybe) {
								return function (behaviour) {
									return function (colorType) {
										return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
											function (context) {
												var linkLabelSpacingValue = function () {
													switch (size) {
														case 4:
															return 4;
														case 3:
															return 6;
														case 2:
															return 8;
														case 1:
															return 8;
														default:
															return 8;
													}
												}();
												var linkLabelHeightValue = function () {
													switch (size) {
														case 4:
															return 16;
														case 3:
															return 20;
														case 2:
															return 24;
														case 1:
															return 28;
														default:
															return 32;
													}
												}();
												var iconSize = function () {
													switch (size) {
														case 4:
															return 0;
														case 3:
															return 1;
														case 2:
															return 3;
														case 1:
															return 2;
														default:
															return 4;
													}
												}();
												var externalLinkClassThemeAttr = function () {
													var _v7 = context.cF;
													if (!_v7) {
														switch (colorType) {
															case 0:
																return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$class('tt-link-light'));
															case 1:
																return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$class('tt-content-primary-link-light'));
															case 2:
																return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$class('tt-content-secondary-link-light'));
															case 3:
																return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$class('tt-content-inverse-link-light'));
															default:
																return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$class('tt-content-error-link-light'));
														}
													} else {
														switch (colorType) {
															case 0:
																return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$class('tt-link-dark'));
															case 1:
																return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$class('tt-content-primary-link-dark'));
															case 2:
																return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$class('tt-content-secondary-link-dark'));
															case 3:
																return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$class('tt-content-inverse-link-dark'));
															default:
																return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$class('tt-content-error-link-dark'));
														}
													}
												}();
												var externalLinkClassStateAttr = function () {
													if (!state) {
														return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
															$elm$html$Html$Attributes$class('tt-link-enabled'));
													} else {
														return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
															$elm$html$Html$Attributes$class('tt-link-disabled'));
													}
												}();
												var externalLinkClassEmphasisAttr = function () {
													if (!emphasis) {
														return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
															$elm$html$Html$Attributes$class('tt-link-subtle'));
													} else {
														return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
															$elm$html$Html$Attributes$class('tt-link-bold'));
													}
												}();
												var cursorAttrs = (state === 1) ? _List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
														$elm$html$Html$Attributes$class('tt-cursor-not-allowed'))
													]) : _List_fromArray(
													[$lucamug$elm_ui_with_context$Element$WithContext$pointer]);
												var color = function () {
													if (!state) {
														switch (colorType) {
															case 0:
																return $author$project$T2$Internal$Color$linkEnabled(context);
															case 1:
																return $author$project$T2$Internal$Color$contentPrimaryLinkEnabled(context);
															case 2:
																return $author$project$T2$Internal$Color$contentSecondaryLinkEnabled(context);
															case 3:
																return $author$project$T2$Internal$Color$contentInverseLinkEnabled(context);
															default:
																return $author$project$T2$Internal$Color$contentErrorLinkEnabled(context);
														}
													} else {
														return $author$project$T2$Internal$Color$linkDisabled(context);
													}
												}();
												var leftIconElement = function () {
													if (!leftIconMaybe.$) {
														var leftIconRenderer = leftIconMaybe.a;
														return A2(
															$lucamug$elm_ui_with_context$Element$WithContext$el,
															_List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink)
																]),
															A4(leftIconRenderer, iconSize, color, $elm$core$Maybe$Nothing, labelText));
													} else {
														return $lucamug$elm_ui_with_context$Element$WithContext$none;
													}
												}();
												var rightIconElement = function () {
													if (!rightIconMaybe.$) {
														var rightIconRenderer = rightIconMaybe.a;
														return A2(
															$lucamug$elm_ui_with_context$Element$WithContext$el,
															_List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink)
																]),
															A4(rightIconRenderer, iconSize, color, $elm$core$Maybe$Nothing, labelText));
													} else {
														return $lucamug$elm_ui_with_context$Element$WithContext$none;
													}
												}();
												var labelElement = A2(
													$lucamug$elm_ui_with_context$Element$WithContext$row,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$spacing(linkLabelSpacingValue),
															$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
															$lucamug$elm_ui_with_context$Element$WithContext$centerY,
															$lucamug$elm_ui_with_context$Element$WithContext$height(
															A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, linkLabelHeightValue, $lucamug$elm_ui_with_context$Element$WithContext$fill))
														]),
													_List_fromArray(
														[
															leftIconElement,
															A3($author$project$T2$Internal$Link$internalRenderLabel, size, labelText, color),
															rightIconElement
														]));
												var ariaAttrs = (state === 1) ? _List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
														A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true'))
													]) : _List_fromArray(
													[$lucamug$elm_ui_with_context$Element$WithContext$pointer]);
												var baseLinkAttrs = _Utils_ap(
													cursorAttrs,
													_Utils_ap(
														ariaAttrs,
														_Utils_ap(
															_List_fromArray(
																[
																	externalLinkClassEmphasisAttr,
																	externalLinkClassThemeAttr,
																	externalLinkClassStateAttr,
																	$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
																	$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	A2($elm$html$Html$Attributes$style, 'display', 'inline-block')),
																	$lucamug$elm_ui_with_context$Element$WithContext$Font$color(color),
																	$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink)
																]),
															attrs)));
												switch (behaviour.$) {
													case 0:
														return A2(
															$lucamug$elm_ui_with_context$Element$WithContext$link,
															baseLinkAttrs,
															{u: labelElement, R: url});
													case 1:
														return A2(
															$lucamug$elm_ui_with_context$Element$WithContext$newTabLink,
															baseLinkAttrs,
															{u: labelElement, R: url});
													default:
														var msg = behaviour.a;
														return A2(
															$lucamug$elm_ui_with_context$Element$WithContext$Input$button,
															baseLinkAttrs,
															{
																u: labelElement,
																ew: $elm$core$Maybe$Just(msg)
															});
												}
											});
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$T2$Link$linkContentInverseSubtleEnabledSmall = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(3)(0)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(3);
	});
var $author$project$T2$Internal$Link$ContentPrimary = 1;
var $author$project$T2$Link$linkContentPrimarySubtleEnabledSmall = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(3)(0)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(1);
	});
var $author$project$T2$Internal$Link$Link = 0;
var $author$project$T2$Internal$Link$Medium = 2;
var $author$project$T2$Link$linkSubtleEnabledMedium = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(2)(0)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(0);
	});
var $author$project$T2$Internal$Link$OpenAtNewTab = {$: 1};
var $author$project$T2$Link$linkSubtleEnabledMediumForNewTab = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(2)(0)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtNewTab)(0);
	});
var $mdgriffith$elm_ui$Internal$Model$Max = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$maximum = F2(
	function (i, l) {
		return A2($mdgriffith$elm_ui$Internal$Model$Max, i, l);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$maximum = $mdgriffith$elm_ui$Element$maximum;
var $mdgriffith$elm_ui$Internal$Model$PaddingStyle = F5(
	function (a, b, c, d, e) {
		return {$: 7, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Internal$Flag$padding = $mdgriffith$elm_ui$Internal$Flag$flag(2);
var $mdgriffith$elm_ui$Element$paddingXY = F2(
	function (x, y) {
		if (_Utils_eq(x, y)) {
			var f = x;
			return A2(
				$mdgriffith$elm_ui$Internal$Model$StyleClass,
				$mdgriffith$elm_ui$Internal$Flag$padding,
				A5(
					$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
					'p-' + $elm$core$String$fromInt(x),
					f,
					f,
					f,
					f));
		} else {
			var yFloat = y;
			var xFloat = x;
			return A2(
				$mdgriffith$elm_ui$Internal$Model$StyleClass,
				$mdgriffith$elm_ui$Internal$Flag$padding,
				A5(
					$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
					'p-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y))),
					yFloat,
					xFloat,
					yFloat,
					xFloat));
		}
	});
var $lucamug$elm_ui_with_context$Element$WithContext$paddingXY = F2(
	function (x, y) {
		return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
			A2($mdgriffith$elm_ui$Element$paddingXY, x, y));
	});
var $author$project$T2$Internal$Text$ParagraphSmall = 19;
var $author$project$T2$Text$paragraphSmallAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 19, color);
	});
var $author$project$T2$Internal$Color$primaryA = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Spacing$spacing16 = 16;
var $author$project$T2$Internal$Spacing$spacing24 = 24;
var $author$project$T2$Internal$Spacing$spacing36 = 36;
var $author$project$T2$Internal$Spacing$spacing48 = 48;
var $author$project$T2$Internal$Spacing$spacing64 = 64;
var $author$project$T2$Internal$Logo$Normal = 0;
var $author$project$T2$Internal$Logo$Principal = 0;
var $author$project$T2$Internal$Logo$AlternativePrimary = 3;
var $author$project$T2$Internal$Logo$AlternativeSecondary = 4;
var $author$project$T2$Internal$Logo$DarkPrimary = 1;
var $author$project$T2$Internal$Logo$DarkSecondary = 2;
var $author$project$T2$Internal$Logo$Primary = 0;
var $mdgriffith$elm_ui$Internal$Model$unstyled = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Unstyled, $elm$core$Basics$always);
var $mdgriffith$elm_ui$Element$html = $mdgriffith$elm_ui$Internal$Model$unstyled;
var $lucamug$elm_ui_with_context$Element$WithContext$html = function (child) {
	return $lucamug$elm_ui_with_context$Element$WithContext$element(
		$mdgriffith$elm_ui$Element$html(child));
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$style = $elm$svg$Svg$trustedNode('style');
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$xmlSpace = A2(_VirtualDom_attributeNS, 'http://www.w3.org/XML/1998/namespace', 'xml:space');
var $author$project$T2$Internal$Logo$internalLogoIsotypeOnlyAlternativeSecondarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 646 646'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 646 646'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st0{fill:#002e23}.st2{fill:#008578}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st2'),
							$elm$svg$Svg$Attributes$cx('322.97'),
							$elm$svg$Svg$Attributes$cy('315.55'),
							$elm$svg$Svg$Attributes$r('107.19')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st2'),
							$elm$svg$Svg$Attributes$d('M214.27 473.58c4.94 3.55 10.08 6.89 15.42 10 27.54 17.31 58.64 25.98 93.27 25.98 33.07 0 63.97-8.46 92.71-25.38 5.11-3.01 10.04-6.2 14.79-9.58 0 0 52.3 27.86 79.18 108.34C452.97 623.09 390.67 643 322.96 643c-57.47 0-110.79-14.38-160-43.11-9.43-5.51-18.64-11.16-27.3-17.43 0 0 19.29-66.22 78.61-108.88z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st0'),
							$elm$svg$Svg$Attributes$d('M94.92 547.38c11.24-26.7 35.98-72.84 82.62-109.15-5.64-7.09-11-14.49-15.74-22.55-16.93-28.73-25.39-59.63-25.39-92.7.01-34.64 8.67-65.73 26-93.28 16.52-28.34 39.16-50.98 67.89-67.89 28.73-16.93 59.63-25.38 92.69-25.38 33.86 0 64.95 8.26 93.28 24.8 28.35 17.31 50.98 40.36 67.91 69.1 16.92 28.73 25.39 59.63 25.38 92.69 0 33.85-8.27 64.95-24.81 93.28-4.97 8.13-10.58 15.62-16.48 22.81 20.32 14.65 57.25 47.93 82.17 108.93C607.64 490.22 643 410.75 643 323 643 146.27 499.73 3 323 3S3 146.27 3 323c0 87.42 35.09 166.63 91.92 224.38z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st0'),
							$elm$svg$Svg$Attributes$d('M214.27 473.57c-.03.02-.06.05-.1.07.03-.02.06-.04.1-.07z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$T2$Internal$Logo$internalLogoIsotypeOnlyDarkPrimarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 646 646.23'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 646 646.23'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st1{fill:#fafafa}.st4{fill:#00cd83}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st1'),
							$elm$svg$Svg$Attributes$cx('322.97'),
							$elm$svg$Svg$Attributes$cy('315.55'),
							$elm$svg$Svg$Attributes$r('107.19')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st1'),
							$elm$svg$Svg$Attributes$d('M214.27 473.58c4.94 3.55 10.08 6.89 15.42 10 27.54 17.31 58.64 25.98 93.27 25.98 33.07 0 63.97-8.46 92.71-25.38 5.11-3.01 10.04-6.2 14.79-9.58 0 0 52.3 27.86 79.18 108.34C452.97 623.09 390.67 643 322.96 643c-57.47 0-110.79-14.38-160-43.11-9.43-5.51-18.64-11.16-27.3-17.43 0 0 19.29-66.22 78.61-108.88z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st4'),
							$elm$svg$Svg$Attributes$d('M94.92 547.38c11.24-26.7 35.98-72.84 82.62-109.15-5.64-7.09-11-14.49-15.74-22.55-16.93-28.73-25.39-59.63-25.39-92.7.01-34.64 8.67-65.73 26-93.28 16.52-28.34 39.16-50.98 67.89-67.89 28.73-16.93 59.63-25.38 92.69-25.38 33.86 0 64.95 8.26 93.28 24.8 28.35 17.31 50.98 40.36 67.91 69.1 16.92 28.73 25.39 59.63 25.38 92.69 0 33.85-8.27 64.95-24.81 93.28-4.97 8.13-10.58 15.62-16.48 22.81 20.32 14.65 57.25 47.93 82.17 108.93C607.64 490.22 643 410.75 643 323 643 146.27 499.73 3 323 3S3 146.27 3 323c0 87.42 35.09 166.63 91.92 224.38z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st4'),
							$elm$svg$Svg$Attributes$d('M214.27 473.57c-.03.02-.06.05-.1.07.03-.02.06-.04.1-.07z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$T2$Internal$Logo$internalLogoIsotypeOnlyDarkSecondaryAndAlternativePrimarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 646 646'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 646 646'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st0{fill:#002e23}.st1{fill:#fafafa}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st1'),
							$elm$svg$Svg$Attributes$cx('322.97'),
							$elm$svg$Svg$Attributes$cy('315.55'),
							$elm$svg$Svg$Attributes$r('107.19')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st1'),
							$elm$svg$Svg$Attributes$d('M214.27 473.58c4.94 3.55 10.08 6.89 15.42 10 27.54 17.31 58.64 25.98 93.27 25.98 33.07 0 63.97-8.46 92.71-25.38 5.11-3.01 10.04-6.2 14.79-9.58 0 0 52.3 27.86 79.18 108.34C452.97 623.09 390.67 643 322.96 643c-57.47 0-110.79-14.38-160-43.11-9.43-5.51-18.64-11.16-27.3-17.43 0 0 19.29-66.22 78.61-108.88z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st0'),
							$elm$svg$Svg$Attributes$d('M94.92 547.38c11.24-26.7 35.98-72.84 82.62-109.15-5.64-7.09-11-14.49-15.74-22.55-16.93-28.73-25.39-59.63-25.39-92.7.01-34.64 8.67-65.73 26-93.28 16.52-28.34 39.16-50.98 67.89-67.89 28.73-16.93 59.63-25.38 92.69-25.38 33.86 0 64.95 8.26 93.28 24.8 28.35 17.31 50.98 40.36 67.91 69.1 16.92 28.73 25.39 59.63 25.38 92.69 0 33.85-8.27 64.95-24.81 93.28-4.97 8.13-10.58 15.62-16.48 22.81 20.32 14.65 57.25 47.93 82.17 108.93C607.64 490.22 643 410.75 643 323 643 146.27 499.73 3 323 3S3 146.27 3 323c0 87.42 35.09 166.63 91.92 224.38z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st0'),
							$elm$svg$Svg$Attributes$d('M214.27 473.57c-.03.02-.06.05-.1.07.03-.02.06-.04.1-.07z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$T2$Internal$Logo$internalLogoIsotypeOnlyPrimarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 646 646'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 646 646'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st0{fill:#002e23}.st4{fill:#00cd83}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st4'),
							$elm$svg$Svg$Attributes$cx('322.97'),
							$elm$svg$Svg$Attributes$cy('315.55'),
							$elm$svg$Svg$Attributes$r('107.19')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st4'),
							$elm$svg$Svg$Attributes$d('M214.27 473.58c4.94 3.55 10.08 6.89 15.42 10 27.54 17.31 58.64 25.98 93.27 25.98 33.07 0 63.97-8.46 92.71-25.38 5.11-3.01 10.04-6.2 14.79-9.58 0 0 52.3 27.86 79.18 108.34C452.97 623.09 390.67 643 322.96 643c-57.47 0-110.79-14.38-160-43.11-9.43-5.51-18.64-11.16-27.3-17.43 0 0 19.29-66.22 78.61-108.88z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st0'),
							$elm$svg$Svg$Attributes$d('M94.92 547.38c11.24-26.7 35.98-72.84 82.62-109.15-5.64-7.09-11-14.49-15.74-22.55-16.93-28.73-25.39-59.63-25.39-92.7.01-34.64 8.67-65.73 26-93.28 16.52-28.34 39.16-50.98 67.89-67.89 28.73-16.93 59.63-25.38 92.69-25.38 33.86 0 64.95 8.26 93.28 24.8 28.35 17.31 50.98 40.36 67.91 69.1 16.92 28.73 25.39 59.63 25.38 92.69 0 33.85-8.27 64.95-24.81 93.28-4.97 8.13-10.58 15.62-16.48 22.81 20.32 14.65 57.25 47.93 82.17 108.93C607.64 490.22 643 410.75 643 323 643 146.27 499.73 3 323 3S3 146.27 3 323c0 87.42 35.09 166.63 91.92 224.38z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st0'),
							$elm$svg$Svg$Attributes$d('M214.27 473.57c-.03.02-.06.05-.1.07.03-.02.06-.04.1-.07z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$T2$Internal$Logo$internalLogoPrincipalAlternativeSecondarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 1403.63 265.89'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 1403.63 265.89'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st0{fill:#002e23}.st2{fill:#008578}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st0'),
							$elm$svg$Svg$Attributes$d('M363.5 82.9V47.28h34.47V82.9h24.84v28.7h-24.84v54.18c0 9.47 1.48 15.8 4.43 19.01 2.95 3.21 7.98 4.82 15.08 4.82 2.36 0 4.47-.08 6.34-.25v29.91c-3.55.84-8.54 1.27-14.96 1.27-15.72 0-27.25-4.44-34.6-13.31-7.35-8.87-11.03-22.35-11.03-40.43v-55.2h-13.94V82.9h14.21zM934.42 82.9V47.28h34.47V82.9h24.84v28.7h-24.84v54.18c0 9.47 1.48 15.8 4.43 19.01 2.95 3.21 7.98 4.82 15.08 4.82 2.36 0 4.47-.08 6.34-.25v29.91c-3.55.84-8.54 1.27-14.96 1.27-15.72 0-27.25-4.44-34.6-13.31-7.35-8.87-11.03-22.35-11.03-40.43v-55.2h-13.94V82.9h14.21zM440.71 176.66c0-12.87 4.73-23.31 14.2-31.34 9.46-8.02 21.88-12.03 37.26-12.03 12 0 21.55 2.43 28.64 7.27v-8.52c0-5.85-2.11-10.53-6.34-14.04s-10.14-5.26-17.74-5.27c-11.32 0-23.07 3.09-35.24 9.27l-13.18-23.57c6.42-4.34 14.32-8.02 23.7-11.03 9.38-3.01 18.89-4.51 28.52-4.51 19.94 0 34.13 4.56 42.59 13.67 8.45 9.11 12.67 21.69 12.67 37.73l-.01 86.24h-30.06l-3.15-11.78c-7.44 7.86-18.17 11.78-32.19 11.78-14.03 0-25.82-3.97-35.36-11.91-9.53-7.93-14.31-18.59-14.31-31.96zm41.32-14.16c-4.23 3.43-6.34 7.81-6.34 13.16 0 5.35 2.19 9.7 6.59 13.04 4.39 3.35 9.88 5.02 16.48 5.02 6.76 0 12.25-1.63 16.48-4.89 4.22-3.26 6.34-7.65 6.34-13.16 0-5.68-2.11-10.15-6.34-13.41s-9.8-4.89-16.73-4.89c-6.76-.01-12.26 1.71-16.48 5.13zM1285.74 176.66c0-12.87 4.73-23.31 14.2-31.34 9.46-8.02 21.88-12.03 37.26-12.03 12 0 21.55 2.43 28.64 7.27v-8.52c0-5.85-2.11-10.53-6.34-14.04s-10.14-5.26-17.74-5.27c-11.32 0-23.07 3.09-35.24 9.27l-13.18-23.57c6.42-4.34 14.32-8.02 23.7-11.03 9.38-3.01 18.89-4.51 28.52-4.51 19.94 0 34.13 4.56 42.59 13.67 8.45 9.11 12.67 21.69 12.67 37.73l-.01 86.24h-30.06l-3.15-11.78c-7.44 7.86-18.17 11.78-32.19 11.78-14.03 0-25.82-3.97-35.36-11.91-9.54-7.93-14.31-18.59-14.31-31.96zm41.32-14.16c-4.23 3.43-6.34 7.81-6.34 13.16 0 5.35 2.19 9.7 6.59 13.04 4.39 3.35 9.88 5.02 16.48 5.02 6.76 0 12.25-1.63 16.48-4.89 4.22-3.26 6.34-7.65 6.34-13.16 0-5.68-2.11-10.15-6.34-13.41s-9.8-4.89-16.73-4.89c-6.76-.01-12.26 1.71-16.48 5.13zM581.64 220.53l.01-173.26h34.98l-.01 173.26h-34.98zM642.48 152.1c0-19.89 6.12-36.39 18.38-49.51 12.25-13.12 27.76-19.68 46.51-19.68 20.28 0 36.08 6.23 47.4 18.68s16.98 29.54 16.98 51.26c0 3.35-.09 5.85-.26 7.52l-93.28-.01c.34 8.86 3.71 16.09 10.14 21.68 6.42 5.6 14.53 8.4 24.33 8.4 14.03 0 24.75-5.34 32.19-16.04l23.07 17.3c-3.72 6.69-10.31 13.16-19.78 19.43s-21.46 9.4-35.99 9.4c-20.96 0-37.81-6.39-50.57-19.18-12.74-12.78-19.12-29.2-19.12-49.25zm36.76-14.29h57.03c-.34-8.02-3.13-14.45-8.36-19.3-5.24-4.85-11.91-7.27-20.03-7.27-8.11 0-14.7 2.51-19.77 7.52s-8.03 11.37-8.87 19.05zM1010.96 152.1c0-19.89 6.12-36.39 18.38-49.51 12.25-13.12 27.76-19.68 46.51-19.68 20.28 0 36.08 6.23 47.4 18.68s16.98 29.54 16.98 51.26c0 3.35-.09 5.85-.26 7.52l-93.28-.01c.34 8.86 3.71 16.09 10.14 21.68 6.42 5.6 14.53 8.4 24.33 8.4 14.03 0 24.75-5.34 32.19-16.04l23.07 17.3c-3.72 6.69-10.31 13.16-19.78 19.43s-21.46 9.4-35.99 9.4c-20.96 0-37.81-6.39-50.57-19.18-12.75-12.78-19.12-29.2-19.12-49.25zm36.75-14.29h57.03c-.34-8.02-3.13-14.45-8.36-19.3-5.24-4.85-11.91-7.27-20.03-7.27-8.11 0-14.7 2.51-19.77 7.52-5.06 5.01-8.02 11.37-8.87 19.05zM858.12 82.9c30.58 0 45.88 20.66 45.88 60.2l-.01 77.43h-34.98l.01-81.49c0-7.1-2.15-12.84-6.46-17.24-4.31-4.39-9.51-6.59-15.59-6.59-7.1 0-12.8 2.32-17.11 6.97-4.31 4.65-6.47 10.61-6.47 17.87l-.01 80.49H788.4l.01-137.64h34.22v19.64c3.21-5.07 7.94-9.46 14.19-13.18 6.26-3.72 13.35-6.46 21.3-6.46zM1229.42 189.28c10.31 0 20.28-3.9 29.91-11.7l9.38 28.14c-11.83 9.3-25.6 14.82-41.32 14.82-20.62 0-37.56-7.27-50.82-20.06-13.27-12.78-19.9-29.05-19.89-48.81 0-19.75 6.72-36.14 20.16-49.18 13.43-13.03 30.2-19.54 50.32-19.54 15.55 0 29.49 4.65 41.82 13.95l-9.89 28.88c-9.3-8.3-19.61-12.45-30.93-12.45-10.99 0-19.81 3.65-26.49 10.95-6.68 7.31-10.01 16.35-10.01 27.14 0 11.12 3.55 20.21 10.64 27.27 7.09 7.06 16.13 10.59 27.12 10.59z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st2'),
									$elm$svg$Svg$Attributes$cx('132.93'),
									$elm$svg$Svg$Attributes$cy('129.92'),
									$elm$svg$Svg$Attributes$r('43.53')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st2'),
									$elm$svg$Svg$Attributes$d('M88.79 194.09c2.01 1.44 4.09 2.8 6.26 4.06 11.18 7.03 23.81 10.55 37.87 10.55 13.43 0 25.98-3.43 37.65-10.3 2.08-1.22 4.08-2.52 6.01-3.89 0 0 21.24 11.31 32.15 44-23.02 16.3-48.32 24.38-75.81 24.38-23.34 0-44.99-5.84-64.97-17.51-3.83-2.24-7.57-4.53-11.09-7.08.01 0 7.85-26.88 31.93-44.21z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st0'),
									$elm$svg$Svg$Attributes$d('M40.33 224.06c4.56-10.84 14.61-29.58 33.55-44.32-2.29-2.88-4.47-5.88-6.39-9.16-6.88-11.67-10.31-24.21-10.31-37.64.01-14.07 3.52-26.69 10.56-37.88 6.71-11.51 15.9-20.7 27.57-27.57 11.67-6.88 24.22-10.31 37.64-10.31 13.75 0 26.37 3.35 37.88 10.07 11.51 7.03 20.7 16.39 27.58 28.06 6.87 11.67 10.31 24.22 10.3 37.64 0 13.75-3.36 26.37-10.07 37.88-2.02 3.3-4.29 6.34-6.69 9.26 8.25 5.95 23.25 19.46 33.37 44.23 23.23-23.48 37.59-55.74 37.59-91.38C262.89 61.18 204.71 3 132.94 3S3 61.18 3 132.94c0 35.5 14.25 67.67 37.33 91.12z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st0'),
									$elm$svg$Svg$Attributes$d('M88.79 194.09c-.01.01-.03.02-.04.03.01-.01.03-.02.04-.03z')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$T2$Internal$Logo$internalLogoPrincipalDarkPrimarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 1403.82 266.28'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 1403.82 266.28'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st1{fill:#fafafa}.st4{fill:#00cd83}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st4'),
							$elm$svg$Svg$Attributes$d('M363.5 82.9V47.28h34.47V82.9h24.84v28.7h-24.84v54.18c0 9.47 1.48 15.8 4.43 19.01 2.95 3.21 7.98 4.82 15.08 4.82 2.36 0 4.47-.08 6.34-.25v29.91c-3.55.84-8.54 1.27-14.96 1.27-15.72 0-27.25-4.44-34.6-13.31-7.35-8.87-11.03-22.35-11.03-40.43v-55.2h-13.94V82.9h14.21zM934.42 82.9V47.28h34.47V82.9h24.84v28.7h-24.84v54.18c0 9.47 1.48 15.8 4.43 19.01 2.95 3.21 7.98 4.82 15.08 4.82 2.36 0 4.47-.08 6.34-.25v29.91c-3.55.84-8.54 1.27-14.96 1.27-15.72 0-27.25-4.44-34.6-13.31-7.35-8.87-11.03-22.35-11.03-40.43v-55.2h-13.94V82.9h14.21zM440.71 176.66c0-12.87 4.73-23.31 14.2-31.34 9.46-8.02 21.88-12.03 37.26-12.03 12 0 21.55 2.43 28.64 7.27v-8.52c0-5.85-2.11-10.53-6.34-14.04s-10.14-5.26-17.74-5.27c-11.32 0-23.07 3.09-35.24 9.27l-13.18-23.57c6.42-4.34 14.32-8.02 23.7-11.03 9.38-3.01 18.89-4.51 28.52-4.51 19.94 0 34.13 4.56 42.59 13.67 8.45 9.11 12.67 21.69 12.67 37.73l-.01 86.24h-30.06l-3.15-11.78c-7.44 7.86-18.17 11.78-32.19 11.78-14.03 0-25.82-3.97-35.36-11.91-9.53-7.93-14.31-18.59-14.31-31.96zm41.32-14.16c-4.23 3.43-6.34 7.81-6.34 13.16 0 5.35 2.19 9.7 6.59 13.04 4.39 3.35 9.88 5.02 16.48 5.02 6.76 0 12.25-1.63 16.48-4.89 4.22-3.26 6.34-7.65 6.34-13.16 0-5.68-2.11-10.15-6.34-13.41s-9.8-4.89-16.73-4.89c-6.76-.01-12.26 1.71-16.48 5.13zM1285.74 176.66c0-12.87 4.73-23.31 14.2-31.34 9.46-8.02 21.88-12.03 37.26-12.03 12 0 21.55 2.43 28.64 7.27v-8.52c0-5.85-2.11-10.53-6.34-14.04s-10.14-5.26-17.74-5.27c-11.32 0-23.07 3.09-35.24 9.27l-13.18-23.57c6.42-4.34 14.32-8.02 23.7-11.03 9.38-3.01 18.89-4.51 28.52-4.51 19.94 0 34.13 4.56 42.59 13.67 8.45 9.11 12.67 21.69 12.67 37.73l-.01 86.24h-30.06l-3.15-11.78c-7.44 7.86-18.17 11.78-32.19 11.78-14.03 0-25.82-3.97-35.36-11.91-9.54-7.93-14.31-18.59-14.31-31.96zm41.32-14.16c-4.23 3.43-6.34 7.81-6.34 13.16 0 5.35 2.19 9.7 6.59 13.04 4.39 3.35 9.88 5.02 16.48 5.02 6.76 0 12.25-1.63 16.48-4.89 4.22-3.26 6.34-7.65 6.34-13.16 0-5.68-2.11-10.15-6.34-13.41s-9.8-4.89-16.73-4.89c-6.76-.01-12.26 1.71-16.48 5.13zM581.64 220.53l.01-173.26h34.98l-.01 173.26h-34.98zM642.48 152.1c0-19.89 6.12-36.39 18.38-49.51 12.25-13.12 27.76-19.68 46.51-19.68 20.28 0 36.08 6.23 47.4 18.68s16.98 29.54 16.98 51.26c0 3.35-.09 5.85-.26 7.52l-93.28-.01c.34 8.86 3.71 16.09 10.14 21.68 6.42 5.6 14.53 8.4 24.33 8.4 14.03 0 24.75-5.34 32.19-16.04l23.07 17.3c-3.72 6.69-10.31 13.16-19.78 19.43s-21.46 9.4-35.99 9.4c-20.96 0-37.81-6.39-50.57-19.18-12.74-12.78-19.12-29.2-19.12-49.25zm36.76-14.29h57.03c-.34-8.02-3.13-14.45-8.36-19.3-5.24-4.85-11.91-7.27-20.03-7.27-8.11 0-14.7 2.51-19.77 7.52s-8.03 11.37-8.87 19.05zM1010.96 152.1c0-19.89 6.12-36.39 18.38-49.51 12.25-13.12 27.76-19.68 46.51-19.68 20.28 0 36.08 6.23 47.4 18.68s16.98 29.54 16.98 51.26c0 3.35-.09 5.85-.26 7.52l-93.28-.01c.34 8.86 3.71 16.09 10.14 21.68 6.42 5.6 14.53 8.4 24.33 8.4 14.03 0 24.75-5.34 32.19-16.04l23.07 17.3c-3.72 6.69-10.31 13.16-19.78 19.43s-21.46 9.4-35.99 9.4c-20.96 0-37.81-6.39-50.57-19.18-12.75-12.78-19.12-29.2-19.12-49.25zm36.75-14.29h57.03c-.34-8.02-3.13-14.45-8.36-19.3-5.24-4.85-11.91-7.27-20.03-7.27-8.11 0-14.7 2.51-19.77 7.52-5.06 5.01-8.02 11.37-8.87 19.05zM858.12 82.9c30.58 0 45.88 20.66 45.88 60.2l-.01 77.43h-34.98l.01-81.49c0-7.1-2.15-12.84-6.46-17.24-4.31-4.39-9.51-6.59-15.59-6.59-7.1 0-12.8 2.32-17.11 6.97-4.31 4.65-6.47 10.61-6.47 17.87l-.01 80.49H788.4l.01-137.64h34.22v19.64c3.21-5.07 7.94-9.46 14.19-13.18 6.26-3.72 13.35-6.46 21.3-6.46zM1229.42 189.28c10.31 0 20.28-3.9 29.91-11.7l9.38 28.14c-11.83 9.3-25.6 14.82-41.32 14.82-20.62 0-37.56-7.27-50.82-20.06-13.27-12.78-19.9-29.05-19.89-48.81 0-19.75 6.72-36.14 20.16-49.18 13.43-13.03 30.2-19.54 50.32-19.54 15.55 0 29.49 4.65 41.82 13.95l-9.89 28.88c-9.3-8.3-19.61-12.45-30.93-12.45-10.99 0-19.81 3.65-26.49 10.95-6.68 7.31-10.01 16.35-10.01 27.14 0 11.12 3.55 20.21 10.64 27.27 7.09 7.06 16.13 10.59 27.12 10.59z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st1'),
									$elm$svg$Svg$Attributes$cx('132.93'),
									$elm$svg$Svg$Attributes$cy('129.92'),
									$elm$svg$Svg$Attributes$r('43.53')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st1'),
									$elm$svg$Svg$Attributes$d('M88.79 194.09c2.01 1.44 4.09 2.8 6.26 4.06 11.18 7.03 23.81 10.55 37.87 10.55 13.43 0 25.98-3.43 37.65-10.3 2.08-1.22 4.08-2.52 6.01-3.89 0 0 21.24 11.31 32.15 44-23.02 16.3-48.32 24.38-75.81 24.38-23.34 0-44.99-5.84-64.97-17.51-3.83-2.24-7.57-4.53-11.09-7.08.01 0 7.85-26.88 31.93-44.21z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st4'),
									$elm$svg$Svg$Attributes$d('M40.33 224.06c4.56-10.84 14.61-29.58 33.55-44.32-2.29-2.88-4.47-5.88-6.39-9.16-6.88-11.67-10.31-24.21-10.31-37.64.01-14.07 3.52-26.69 10.56-37.88 6.71-11.51 15.9-20.7 27.57-27.57 11.67-6.88 24.22-10.31 37.64-10.31 13.75 0 26.37 3.35 37.88 10.07 11.51 7.03 20.7 16.39 27.58 28.06 6.87 11.67 10.31 24.22 10.3 37.64 0 13.75-3.36 26.37-10.07 37.88-2.02 3.3-4.29 6.34-6.69 9.26 8.25 5.95 23.25 19.46 33.37 44.23 23.23-23.48 37.59-55.74 37.59-91.38C262.89 61.18 204.71 3 132.94 3S3 61.18 3 132.94c0 35.5 14.25 67.67 37.33 91.12z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st4'),
									$elm$svg$Svg$Attributes$d('M88.79 194.09c-.01.01-.03.02-.04.03.01-.01.03-.02.04-.03z')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$T2$Internal$Logo$internalLogoPrincipalDarkSecondaryAndAlternativePrimarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 1403.83 265.89'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 1403.83 265.89'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st0{fill:#002e23}.st1{fill:#fafafa}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st0'),
							$elm$svg$Svg$Attributes$d('M363.5 82.9V47.28h34.47V82.9h24.84v28.7h-24.84v54.18c0 9.47 1.48 15.8 4.43 19.01 2.95 3.21 7.98 4.82 15.08 4.82 2.36 0 4.47-.08 6.34-.25v29.91c-3.55.84-8.54 1.27-14.96 1.27-15.72 0-27.25-4.44-34.6-13.31-7.35-8.87-11.03-22.35-11.03-40.43v-55.2h-13.94V82.9h14.21zM934.42 82.9V47.28h34.47V82.9h24.84v28.7h-24.84v54.18c0 9.47 1.48 15.8 4.43 19.01 2.95 3.21 7.98 4.82 15.08 4.82 2.36 0 4.47-.08 6.34-.25v29.91c-3.55.84-8.54 1.27-14.96 1.27-15.72 0-27.25-4.44-34.6-13.31-7.35-8.87-11.03-22.35-11.03-40.43v-55.2h-13.94V82.9h14.21zM440.71 176.66c0-12.87 4.73-23.31 14.2-31.34 9.46-8.02 21.88-12.03 37.26-12.03 12 0 21.55 2.43 28.64 7.27v-8.52c0-5.85-2.11-10.53-6.34-14.04s-10.14-5.26-17.74-5.27c-11.32 0-23.07 3.09-35.24 9.27l-13.18-23.57c6.42-4.34 14.32-8.02 23.7-11.03 9.38-3.01 18.89-4.51 28.52-4.51 19.94 0 34.13 4.56 42.59 13.67 8.45 9.11 12.67 21.69 12.67 37.73l-.01 86.24h-30.06l-3.15-11.78c-7.44 7.86-18.17 11.78-32.19 11.78-14.03 0-25.82-3.97-35.36-11.91-9.53-7.93-14.31-18.59-14.31-31.96zm41.32-14.16c-4.23 3.43-6.34 7.81-6.34 13.16 0 5.35 2.19 9.7 6.59 13.04 4.39 3.35 9.88 5.02 16.48 5.02 6.76 0 12.25-1.63 16.48-4.89 4.22-3.26 6.34-7.65 6.34-13.16 0-5.68-2.11-10.15-6.34-13.41s-9.8-4.89-16.73-4.89c-6.76-.01-12.26 1.71-16.48 5.13zM1285.74 176.66c0-12.87 4.73-23.31 14.2-31.34 9.46-8.02 21.88-12.03 37.26-12.03 12 0 21.55 2.43 28.64 7.27v-8.52c0-5.85-2.11-10.53-6.34-14.04s-10.14-5.26-17.74-5.27c-11.32 0-23.07 3.09-35.24 9.27l-13.18-23.57c6.42-4.34 14.32-8.02 23.7-11.03 9.38-3.01 18.89-4.51 28.52-4.51 19.94 0 34.13 4.56 42.59 13.67 8.45 9.11 12.67 21.69 12.67 37.73l-.01 86.24h-30.06l-3.15-11.78c-7.44 7.86-18.17 11.78-32.19 11.78-14.03 0-25.82-3.97-35.36-11.91-9.54-7.93-14.31-18.59-14.31-31.96zm41.32-14.16c-4.23 3.43-6.34 7.81-6.34 13.16 0 5.35 2.19 9.7 6.59 13.04 4.39 3.35 9.88 5.02 16.48 5.02 6.76 0 12.25-1.63 16.48-4.89 4.22-3.26 6.34-7.65 6.34-13.16 0-5.68-2.11-10.15-6.34-13.41s-9.8-4.89-16.73-4.89c-6.76-.01-12.26 1.71-16.48 5.13zM581.64 220.53l.01-173.26h34.98l-.01 173.26h-34.98zM642.48 152.1c0-19.89 6.12-36.39 18.38-49.51 12.25-13.12 27.76-19.68 46.51-19.68 20.28 0 36.08 6.23 47.4 18.68s16.98 29.54 16.98 51.26c0 3.35-.09 5.85-.26 7.52l-93.28-.01c.34 8.86 3.71 16.09 10.14 21.68 6.42 5.6 14.53 8.4 24.33 8.4 14.03 0 24.75-5.34 32.19-16.04l23.07 17.3c-3.72 6.69-10.31 13.16-19.78 19.43s-21.46 9.4-35.99 9.4c-20.96 0-37.81-6.39-50.57-19.18-12.74-12.78-19.12-29.2-19.12-49.25zm36.76-14.29h57.03c-.34-8.02-3.13-14.45-8.36-19.3-5.24-4.85-11.91-7.27-20.03-7.27-8.11 0-14.7 2.51-19.77 7.52s-8.03 11.37-8.87 19.05zM1010.96 152.1c0-19.89 6.12-36.39 18.38-49.51 12.25-13.12 27.76-19.68 46.51-19.68 20.28 0 36.08 6.23 47.4 18.68s16.98 29.54 16.98 51.26c0 3.35-.09 5.85-.26 7.52l-93.28-.01c.34 8.86 3.71 16.09 10.14 21.68 6.42 5.6 14.53 8.4 24.33 8.4 14.03 0 24.75-5.34 32.19-16.04l23.07 17.3c-3.72 6.69-10.31 13.16-19.78 19.43s-21.46 9.4-35.99 9.4c-20.96 0-37.81-6.39-50.57-19.18-12.75-12.78-19.12-29.2-19.12-49.25zm36.75-14.29h57.03c-.34-8.02-3.13-14.45-8.36-19.3-5.24-4.85-11.91-7.27-20.03-7.27-8.11 0-14.7 2.51-19.77 7.52-5.06 5.01-8.02 11.37-8.87 19.05zM858.12 82.9c30.58 0 45.88 20.66 45.88 60.2l-.01 77.43h-34.98l.01-81.49c0-7.1-2.15-12.84-6.46-17.24-4.31-4.39-9.51-6.59-15.59-6.59-7.1 0-12.8 2.32-17.11 6.97-4.31 4.65-6.47 10.61-6.47 17.87l-.01 80.49H788.4l.01-137.64h34.22v19.64c3.21-5.07 7.94-9.46 14.19-13.18 6.26-3.72 13.35-6.46 21.3-6.46zM1229.42 189.28c10.31 0 20.28-3.9 29.91-11.7l9.38 28.14c-11.83 9.3-25.6 14.82-41.32 14.82-20.62 0-37.56-7.27-50.82-20.06-13.27-12.78-19.9-29.05-19.89-48.81 0-19.75 6.72-36.14 20.16-49.18 13.43-13.03 30.2-19.54 50.32-19.54 15.55 0 29.49 4.65 41.82 13.95l-9.89 28.88c-9.3-8.3-19.61-12.45-30.93-12.45-10.99 0-19.81 3.65-26.49 10.95-6.68 7.31-10.01 16.35-10.01 27.14 0 11.12 3.55 20.21 10.64 27.27 7.09 7.06 16.13 10.59 27.12 10.59z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st1'),
									$elm$svg$Svg$Attributes$cx('132.93'),
									$elm$svg$Svg$Attributes$cy('129.92'),
									$elm$svg$Svg$Attributes$r('43.53')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st1'),
									$elm$svg$Svg$Attributes$d('M88.79 194.09c2.01 1.44 4.09 2.8 6.26 4.06 11.18 7.03 23.81 10.55 37.87 10.55 13.43 0 25.98-3.43 37.65-10.3 2.08-1.22 4.08-2.52 6.01-3.89 0 0 21.24 11.31 32.15 44-23.02 16.3-48.32 24.38-75.81 24.38-23.34 0-44.99-5.84-64.97-17.51-3.83-2.24-7.57-4.53-11.09-7.08.01 0 7.85-26.88 31.93-44.21z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st0'),
									$elm$svg$Svg$Attributes$d('M40.33 224.06c4.56-10.84 14.61-29.58 33.55-44.32-2.29-2.88-4.47-5.88-6.39-9.16-6.88-11.67-10.31-24.21-10.31-37.64.01-14.07 3.52-26.69 10.56-37.88 6.71-11.51 15.9-20.7 27.57-27.57 11.67-6.88 24.22-10.31 37.64-10.31 13.75 0 26.37 3.35 37.88 10.07 11.51 7.03 20.7 16.39 27.58 28.06 6.87 11.67 10.31 24.22 10.3 37.64 0 13.75-3.36 26.37-10.07 37.88-2.02 3.3-4.29 6.34-6.69 9.26 8.25 5.95 23.25 19.46 33.37 44.23 23.23-23.48 37.59-55.74 37.59-91.38C262.89 61.18 204.71 3 132.94 3S3 61.18 3 132.94c0 35.5 14.25 67.67 37.33 91.12z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st0'),
									$elm$svg$Svg$Attributes$d('M88.79 194.09c-.01.01-.03.02-.04.03.01-.01.03-.02.04-.03z')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$T2$Internal$Logo$internalLogoPrincipalPrimarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 1403.83 266.28'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 1403.83 266.28'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st0{fill:#002e23}.st4{fill:#00cd83}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st0'),
							$elm$svg$Svg$Attributes$d('M363.5 82.9V47.28h34.47V82.9h24.84v28.7h-24.84v54.18c0 9.47 1.48 15.8 4.43 19.01 2.95 3.21 7.98 4.82 15.08 4.82 2.36 0 4.47-.08 6.34-.25v29.91c-3.55.84-8.54 1.27-14.96 1.27-15.72 0-27.25-4.44-34.6-13.31-7.35-8.87-11.03-22.35-11.03-40.43v-55.2h-13.94V82.9h14.21zM934.42 82.9V47.28h34.47V82.9h24.84v28.7h-24.84v54.18c0 9.47 1.48 15.8 4.43 19.01 2.95 3.21 7.98 4.82 15.08 4.82 2.36 0 4.47-.08 6.34-.25v29.91c-3.55.84-8.54 1.27-14.96 1.27-15.72 0-27.25-4.44-34.6-13.31-7.35-8.87-11.03-22.35-11.03-40.43v-55.2h-13.94V82.9h14.21zM440.71 176.66c0-12.87 4.73-23.31 14.2-31.34 9.46-8.02 21.88-12.03 37.26-12.03 12 0 21.55 2.43 28.64 7.27v-8.52c0-5.85-2.11-10.53-6.34-14.04s-10.14-5.26-17.74-5.27c-11.32 0-23.07 3.09-35.24 9.27l-13.18-23.57c6.42-4.34 14.32-8.02 23.7-11.03 9.38-3.01 18.89-4.51 28.52-4.51 19.94 0 34.13 4.56 42.59 13.67 8.45 9.11 12.67 21.69 12.67 37.73l-.01 86.24h-30.06l-3.15-11.78c-7.44 7.86-18.17 11.78-32.19 11.78-14.03 0-25.82-3.97-35.36-11.91-9.53-7.93-14.31-18.59-14.31-31.96zm41.32-14.16c-4.23 3.43-6.34 7.81-6.34 13.16 0 5.35 2.19 9.7 6.59 13.04 4.39 3.35 9.88 5.02 16.48 5.02 6.76 0 12.25-1.63 16.48-4.89 4.22-3.26 6.34-7.65 6.34-13.16 0-5.68-2.11-10.15-6.34-13.41s-9.8-4.89-16.73-4.89c-6.76-.01-12.26 1.71-16.48 5.13zM1285.74 176.66c0-12.87 4.73-23.31 14.2-31.34 9.46-8.02 21.88-12.03 37.26-12.03 12 0 21.55 2.43 28.64 7.27v-8.52c0-5.85-2.11-10.53-6.34-14.04s-10.14-5.26-17.74-5.27c-11.32 0-23.07 3.09-35.24 9.27l-13.18-23.57c6.42-4.34 14.32-8.02 23.7-11.03 9.38-3.01 18.89-4.51 28.52-4.51 19.94 0 34.13 4.56 42.59 13.67 8.45 9.11 12.67 21.69 12.67 37.73l-.01 86.24h-30.06l-3.15-11.78c-7.44 7.86-18.17 11.78-32.19 11.78-14.03 0-25.82-3.97-35.36-11.91-9.54-7.93-14.31-18.59-14.31-31.96zm41.32-14.16c-4.23 3.43-6.34 7.81-6.34 13.16 0 5.35 2.19 9.7 6.59 13.04 4.39 3.35 9.88 5.02 16.48 5.02 6.76 0 12.25-1.63 16.48-4.89 4.22-3.26 6.34-7.65 6.34-13.16 0-5.68-2.11-10.15-6.34-13.41s-9.8-4.89-16.73-4.89c-6.76-.01-12.26 1.71-16.48 5.13zM581.64 220.53l.01-173.26h34.98l-.01 173.26h-34.98zM642.48 152.1c0-19.89 6.12-36.39 18.38-49.51 12.25-13.12 27.76-19.68 46.51-19.68 20.28 0 36.08 6.23 47.4 18.68s16.98 29.54 16.98 51.26c0 3.35-.09 5.85-.26 7.52l-93.28-.01c.34 8.86 3.71 16.09 10.14 21.68 6.42 5.6 14.53 8.4 24.33 8.4 14.03 0 24.75-5.34 32.19-16.04l23.07 17.3c-3.72 6.69-10.31 13.16-19.78 19.43s-21.46 9.4-35.99 9.4c-20.96 0-37.81-6.39-50.57-19.18-12.74-12.78-19.12-29.2-19.12-49.25zm36.76-14.29h57.03c-.34-8.02-3.13-14.45-8.36-19.3-5.24-4.85-11.91-7.27-20.03-7.27-8.11 0-14.7 2.51-19.77 7.52s-8.03 11.37-8.87 19.05zM1010.96 152.1c0-19.89 6.12-36.39 18.38-49.51 12.25-13.12 27.76-19.68 46.51-19.68 20.28 0 36.08 6.23 47.4 18.68s16.98 29.54 16.98 51.26c0 3.35-.09 5.85-.26 7.52l-93.28-.01c.34 8.86 3.71 16.09 10.14 21.68 6.42 5.6 14.53 8.4 24.33 8.4 14.03 0 24.75-5.34 32.19-16.04l23.07 17.3c-3.72 6.69-10.31 13.16-19.78 19.43s-21.46 9.4-35.99 9.4c-20.96 0-37.81-6.39-50.57-19.18-12.75-12.78-19.12-29.2-19.12-49.25zm36.75-14.29h57.03c-.34-8.02-3.13-14.45-8.36-19.3-5.24-4.85-11.91-7.27-20.03-7.27-8.11 0-14.7 2.51-19.77 7.52-5.06 5.01-8.02 11.37-8.87 19.05zM858.12 82.9c30.58 0 45.88 20.66 45.88 60.2l-.01 77.43h-34.98l.01-81.49c0-7.1-2.15-12.84-6.46-17.24-4.31-4.39-9.51-6.59-15.59-6.59-7.1 0-12.8 2.32-17.11 6.97-4.31 4.65-6.47 10.61-6.47 17.87l-.01 80.49H788.4l.01-137.64h34.22v19.64c3.21-5.07 7.94-9.46 14.19-13.18 6.26-3.72 13.35-6.46 21.3-6.46zM1229.42 189.28c10.31 0 20.28-3.9 29.91-11.7l9.38 28.14c-11.83 9.3-25.6 14.82-41.32 14.82-20.62 0-37.56-7.27-50.82-20.06-13.27-12.78-19.9-29.05-19.89-48.81 0-19.75 6.72-36.14 20.16-49.18 13.43-13.03 30.2-19.54 50.32-19.54 15.55 0 29.49 4.65 41.82 13.95l-9.89 28.88c-9.3-8.3-19.61-12.45-30.93-12.45-10.99 0-19.81 3.65-26.49 10.95-6.68 7.31-10.01 16.35-10.01 27.14 0 11.12 3.55 20.21 10.64 27.27 7.09 7.06 16.13 10.59 27.12 10.59z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st4'),
									$elm$svg$Svg$Attributes$cx('132.93'),
									$elm$svg$Svg$Attributes$cy('129.92'),
									$elm$svg$Svg$Attributes$r('43.53')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st4'),
									$elm$svg$Svg$Attributes$d('M88.79 194.09c2.01 1.44 4.09 2.8 6.26 4.06 11.18 7.03 23.81 10.55 37.87 10.55 13.43 0 25.98-3.43 37.65-10.3 2.08-1.22 4.08-2.52 6.01-3.89 0 0 21.24 11.31 32.15 44-23.02 16.3-48.32 24.38-75.81 24.38-23.34 0-44.99-5.84-64.97-17.51-3.83-2.24-7.57-4.53-11.09-7.08.01 0 7.85-26.88 31.93-44.21z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st0'),
									$elm$svg$Svg$Attributes$d('M40.33 224.06c4.56-10.84 14.61-29.58 33.55-44.32-2.29-2.88-4.47-5.88-6.39-9.16-6.88-11.67-10.31-24.21-10.31-37.64.01-14.07 3.52-26.69 10.56-37.88 6.71-11.51 15.9-20.7 27.57-27.57 11.67-6.88 24.22-10.31 37.64-10.31 13.75 0 26.37 3.35 37.88 10.07 11.51 7.03 20.7 16.39 27.58 28.06 6.87 11.67 10.31 24.22 10.3 37.64 0 13.75-3.36 26.37-10.07 37.88-2.02 3.3-4.29 6.34-6.69 9.26 8.25 5.95 23.25 19.46 33.37 44.23 23.23-23.48 37.59-55.74 37.59-91.38C262.89 61.18 204.71 3 132.94 3S3 61.18 3 132.94c0 35.5 14.25 67.67 37.33 91.12z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st0'),
									$elm$svg$Svg$Attributes$d('M88.79 194.09c-.01.01-.03.02-.04.03.01-.01.03-.02.04-.03z')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$T2$Internal$Logo$internalLogoTextOnlyDarkPrimarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 1290.95 217.72'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 1290.95 217.72'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st4{fill:#00cd83}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st4'),
							$elm$svg$Svg$Attributes$d('M20.35 46.53V3h42.13v43.52h30.36V81.6H62.48v66.21c0 11.57 1.81 19.31 5.42 23.23 3.61 3.93 9.76 5.89 18.43 5.89 2.89 0 5.47-.1 7.74-.31v36.55c-4.34 1.03-10.43 1.55-18.28 1.55-19.2 0-33.3-5.42-42.28-16.26-8.98-10.84-13.48-27.31-13.47-49.41V81.6H3V46.53h17.35zM718 46.53V3h42.13v43.52h30.36V81.6h-30.36v66.21c0 11.57 1.81 19.31 5.42 23.23 3.61 3.93 9.76 5.89 18.43 5.89 2.89 0 5.47-.1 7.74-.31v36.55c-4.34 1.03-10.43 1.55-18.28 1.55-19.2 0-33.3-5.42-42.28-16.26-8.98-10.84-13.48-27.31-13.47-49.41V81.6h-17.04V46.53H718zM114.71 161.1c0-15.72 5.78-28.49 17.35-38.29 11.56-9.8 26.74-14.7 45.53-14.7 14.66 0 26.33 2.96 35 8.89v-10.42c0-7.15-2.58-12.87-7.74-17.16-5.16-4.29-12.39-6.43-21.68-6.43-13.84 0-28.19 3.78-43.06 11.33l-16.1-28.8c7.85-5.31 17.5-9.8 28.96-13.48 11.46-3.68 23.08-5.51 34.85-5.51 24.36 0 41.71 5.57 52.04 16.7 10.32 11.13 15.49 26.5 15.48 46.11l-.01 105.38H218.6l-3.85-14.4c-9.09 9.6-22.2 14.4-39.34 14.4-17.14 0-31.55-4.85-43.21-14.55-11.66-9.71-17.49-22.73-17.49-39.07zm50.49-17.31c-5.16 4.19-7.74 9.55-7.74 16.08 0 6.54 2.68 11.85 8.05 15.93 5.37 4.09 12.08 6.13 20.13 6.13 8.26 0 14.97-1.99 20.13-5.97 5.16-3.98 7.75-9.34 7.75-16.08 0-6.94-2.58-12.41-7.74-16.39-5.16-3.98-11.98-5.97-20.44-5.97-8.27 0-14.98 2.09-20.14 6.27zM1147.32 161.1c0-15.72 5.78-28.49 17.35-38.29 11.56-9.8 26.74-14.7 45.53-14.7 14.66 0 26.33 2.96 35 8.89v-10.42c0-7.15-2.58-12.87-7.74-17.16-5.16-4.29-12.39-6.43-21.68-6.43-13.84 0-28.19 3.78-43.06 11.33l-16.1-28.8c7.85-5.31 17.5-9.8 28.96-13.48 11.46-3.68 23.08-5.51 34.85-5.51 24.36 0 41.71 5.57 52.04 16.7 10.32 11.13 15.49 26.5 15.48 46.11l-.01 105.38h-36.73l-3.85-14.4c-9.09 9.6-22.2 14.4-39.34 14.4-17.14 0-31.55-4.85-43.21-14.55-11.66-9.71-17.49-22.73-17.49-39.07zm50.49-17.31c-5.16 4.19-7.74 9.55-7.74 16.08 0 6.54 2.68 11.85 8.05 15.93 5.37 4.09 12.08 6.13 20.13 6.13 8.26 0 14.97-1.99 20.13-5.97 5.16-3.98 7.75-9.34 7.75-16.08 0-6.94-2.58-12.41-7.74-16.39-5.16-3.98-11.98-5.97-20.44-5.97-8.27 0-14.98 2.09-20.14 6.27zM286.92 214.71 286.94 3h42.75l-.02 211.72-42.75-.01zM361.27 131.08c0-24.3 7.48-44.46 22.46-60.5 14.97-16.03 33.92-24.04 56.84-24.04 24.78 0 44.09 7.61 57.92 22.82 13.83 15.22 20.75 36.1 20.75 62.64 0 4.09-.11 7.15-.31 9.19l-113.99-.01c.41 10.83 4.54 19.66 12.39 26.5 7.84 6.84 17.76 10.26 29.73 10.26 17.14 0 30.25-6.53 39.34-19.6l28.19 21.14c-4.55 8.17-12.6 16.08-24.16 23.74-11.57 7.66-26.23 11.48-43.98 11.48-25.61 0-46.21-7.81-61.79-23.44-15.6-15.6-23.39-35.67-23.39-60.18zm44.91-17.45h69.7c-.41-9.8-3.82-17.66-10.22-23.59-6.4-5.92-14.56-8.88-24.47-8.88-9.91 0-17.97 3.06-24.16 9.19-6.2 6.12-9.81 13.89-10.85 23.28zM811.54 131.08c0-24.3 7.48-44.46 22.46-60.5 14.97-16.03 33.92-24.04 56.84-24.04 24.78 0 44.09 7.61 57.92 22.82 13.83 15.22 20.75 36.1 20.75 62.64 0 4.09-.11 7.15-.31 9.19l-113.99-.01c.41 10.83 4.54 19.66 12.39 26.5 7.84 6.84 17.76 10.26 29.73 10.26 17.14 0 30.25-6.53 39.34-19.6l28.19 21.14c-4.55 8.17-12.6 16.08-24.16 23.74-11.57 7.66-26.23 11.48-43.98 11.48-25.61 0-46.21-7.81-61.79-23.44-15.6-15.6-23.39-35.67-23.39-60.18zm44.91-17.45h69.7c-.41-9.8-3.82-17.66-10.22-23.59-6.4-5.92-14.56-8.88-24.47-8.88-9.91 0-17.97 3.06-24.16 9.19-6.2 6.12-9.81 13.89-10.85 23.28zM624.77 46.53c37.37 0 56.06 25.24 56.06 73.56l-.01 94.62h-42.75l.01-99.58c0-8.67-2.63-15.69-7.89-21.06-5.27-5.37-11.62-8.05-19.05-8.06-8.67 0-15.64 2.84-20.91 8.52s-7.9 12.96-7.9 21.84l-.01 98.35h-42.75l.01-168.19h41.82v23.99c3.92-6.19 9.7-11.56 17.35-16.11 7.64-4.53 16.31-7.88 26.02-7.88zM1078.49 176.52c12.59 0 24.78-4.76 36.55-14.3l11.46 34.38c-14.46 11.36-31.29 18.12-50.49 18.11-25.2 0-45.9-8.89-62.1-24.51-16.21-15.62-24.31-35.5-24.31-59.64s8.21-44.17 24.63-60.09c16.42-15.92 36.91-23.88 61.49-23.88 19 0 36.03 5.68 51.11 17.04l-12.08 35.3c-11.36-10.14-23.96-15.22-37.79-15.22-13.43 0-24.21 4.46-32.37 13.39-8.16 8.93-12.24 19.98-12.24 33.17 0 13.59 4.33 24.7 13.01 33.32 8.66 8.62 19.7 12.93 33.13 12.93z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$T2$Internal$Logo$internalLogoTextOnlyPrimaryDarkSecondaryAlternativePrimaryAndAlternativeSecondarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 1290.95 217.72'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 1290.95 217.72'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st0{fill:#002e23}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st0'),
							$elm$svg$Svg$Attributes$d('M20.35 46.53V3h42.13v43.52h30.36V81.6H62.48v66.21c0 11.57 1.81 19.31 5.42 23.23 3.61 3.93 9.76 5.89 18.43 5.89 2.89 0 5.47-.1 7.74-.31v36.55c-4.34 1.03-10.43 1.55-18.28 1.55-19.2 0-33.3-5.42-42.28-16.26-8.98-10.84-13.48-27.31-13.47-49.41V81.6H3V46.53h17.35zM718 46.53V3h42.13v43.52h30.36V81.6h-30.36v66.21c0 11.57 1.81 19.31 5.42 23.23 3.61 3.93 9.76 5.89 18.43 5.89 2.89 0 5.47-.1 7.74-.31v36.55c-4.34 1.03-10.43 1.55-18.28 1.55-19.2 0-33.3-5.42-42.28-16.26-8.98-10.84-13.48-27.31-13.47-49.41V81.6h-17.04V46.53H718zM114.71 161.1c0-15.72 5.78-28.49 17.35-38.29 11.56-9.8 26.74-14.7 45.53-14.7 14.66 0 26.33 2.96 35 8.89v-10.42c0-7.15-2.58-12.87-7.74-17.16-5.16-4.29-12.39-6.43-21.68-6.43-13.84 0-28.19 3.78-43.06 11.33l-16.1-28.8c7.85-5.31 17.5-9.8 28.96-13.48 11.46-3.68 23.08-5.51 34.85-5.51 24.36 0 41.71 5.57 52.04 16.7 10.32 11.13 15.49 26.5 15.48 46.11l-.01 105.38H218.6l-3.85-14.4c-9.09 9.6-22.2 14.4-39.34 14.4-17.14 0-31.55-4.85-43.21-14.55-11.66-9.71-17.49-22.73-17.49-39.07zm50.49-17.31c-5.16 4.19-7.74 9.55-7.74 16.08 0 6.54 2.68 11.85 8.05 15.93 5.37 4.09 12.08 6.13 20.13 6.13 8.26 0 14.97-1.99 20.13-5.97 5.16-3.98 7.75-9.34 7.75-16.08 0-6.94-2.58-12.41-7.74-16.39-5.16-3.98-11.98-5.97-20.44-5.97-8.27 0-14.98 2.09-20.14 6.27zM1147.32 161.1c0-15.72 5.78-28.49 17.35-38.29 11.56-9.8 26.74-14.7 45.53-14.7 14.66 0 26.33 2.96 35 8.89v-10.42c0-7.15-2.58-12.87-7.74-17.16-5.16-4.29-12.39-6.43-21.68-6.43-13.84 0-28.19 3.78-43.06 11.33l-16.1-28.8c7.85-5.31 17.5-9.8 28.96-13.48 11.46-3.68 23.08-5.51 34.85-5.51 24.36 0 41.71 5.57 52.04 16.7 10.32 11.13 15.49 26.5 15.48 46.11l-.01 105.38h-36.73l-3.85-14.4c-9.09 9.6-22.2 14.4-39.34 14.4-17.14 0-31.55-4.85-43.21-14.55-11.66-9.71-17.49-22.73-17.49-39.07zm50.49-17.31c-5.16 4.19-7.74 9.55-7.74 16.08 0 6.54 2.68 11.85 8.05 15.93 5.37 4.09 12.08 6.13 20.13 6.13 8.26 0 14.97-1.99 20.13-5.97 5.16-3.98 7.75-9.34 7.75-16.08 0-6.94-2.58-12.41-7.74-16.39-5.16-3.98-11.98-5.97-20.44-5.97-8.27 0-14.98 2.09-20.14 6.27zM286.92 214.71 286.94 3h42.75l-.02 211.72-42.75-.01zM361.27 131.08c0-24.3 7.48-44.46 22.46-60.5 14.97-16.03 33.92-24.04 56.84-24.04 24.78 0 44.09 7.61 57.92 22.82 13.83 15.22 20.75 36.1 20.75 62.64 0 4.09-.11 7.15-.31 9.19l-113.99-.01c.41 10.83 4.54 19.66 12.39 26.5 7.84 6.84 17.76 10.26 29.73 10.26 17.14 0 30.25-6.53 39.34-19.6l28.19 21.14c-4.55 8.17-12.6 16.08-24.16 23.74-11.57 7.66-26.23 11.48-43.98 11.48-25.61 0-46.21-7.81-61.79-23.44-15.6-15.6-23.39-35.67-23.39-60.18zm44.91-17.45h69.7c-.41-9.8-3.82-17.66-10.22-23.59-6.4-5.92-14.56-8.88-24.47-8.88-9.91 0-17.97 3.06-24.16 9.19-6.2 6.12-9.81 13.89-10.85 23.28zM811.54 131.08c0-24.3 7.48-44.46 22.46-60.5 14.97-16.03 33.92-24.04 56.84-24.04 24.78 0 44.09 7.61 57.92 22.82 13.83 15.22 20.75 36.1 20.75 62.64 0 4.09-.11 7.15-.31 9.19l-113.99-.01c.41 10.83 4.54 19.66 12.39 26.5 7.84 6.84 17.76 10.26 29.73 10.26 17.14 0 30.25-6.53 39.34-19.6l28.19 21.14c-4.55 8.17-12.6 16.08-24.16 23.74-11.57 7.66-26.23 11.48-43.98 11.48-25.61 0-46.21-7.81-61.79-23.44-15.6-15.6-23.39-35.67-23.39-60.18zm44.91-17.45h69.7c-.41-9.8-3.82-17.66-10.22-23.59-6.4-5.92-14.56-8.88-24.47-8.88-9.91 0-17.97 3.06-24.16 9.19-6.2 6.12-9.81 13.89-10.85 23.28zM624.77 46.53c37.37 0 56.06 25.24 56.06 73.56l-.01 94.62h-42.75l.01-99.58c0-8.67-2.63-15.69-7.89-21.06-5.27-5.37-11.62-8.05-19.05-8.06-8.67 0-15.64 2.84-20.91 8.52s-7.9 12.96-7.9 21.84l-.01 98.35h-42.75l.01-168.19h41.82v23.99c3.92-6.19 9.7-11.56 17.35-16.11 7.64-4.53 16.31-7.88 26.02-7.88zM1078.49 176.52c12.59 0 24.78-4.76 36.55-14.3l11.46 34.38c-14.46 11.36-31.29 18.12-50.49 18.11-25.2 0-45.9-8.89-62.1-24.51-16.21-15.62-24.31-35.5-24.31-59.64s8.21-44.17 24.63-60.09c16.42-15.92 36.91-23.88 61.49-23.88 19 0 36.03 5.68 51.11 17.04l-12.08 35.3c-11.36-10.14-23.96-15.22-37.79-15.22-13.43 0-24.21 4.46-32.37 13.39-8.16 8.93-12.24 19.98-12.24 33.17 0 13.59 4.33 24.7 13.01 33.32 8.66 8.62 19.7 12.93 33.13 12.93z')
						]),
					_List_Nil)
				]))
		]));
var $author$project$T2$Internal$Logo$internalLogoVerticalAlternativeSecondarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 1290.95 642.26'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 1290.95 642.26'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st0{fill:#002e23}.st2{fill:#008578}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st0'),
							$elm$svg$Svg$Attributes$d('M20.35 470.07v-43.53h42.13v43.52h30.36v35.08H62.48v66.21c0 11.57 1.81 19.31 5.42 23.23 3.61 3.93 9.76 5.89 18.43 5.89 2.89 0 5.47-.1 7.74-.31v36.55c-4.34 1.03-10.43 1.55-18.28 1.55-19.2 0-33.3-5.42-42.28-16.26-8.98-10.84-13.48-27.31-13.47-49.41v-67.45H3v-35.07h17.35zM718 470.07v-43.53h42.13v43.52h30.36v35.08h-30.36v66.21c0 11.57 1.81 19.31 5.42 23.23 3.61 3.93 9.76 5.89 18.43 5.89 2.89 0 5.47-.1 7.74-.31v36.55c-4.34 1.03-10.43 1.55-18.28 1.55-19.2 0-33.3-5.42-42.28-16.26-8.98-10.84-13.48-27.31-13.47-49.41v-67.45h-17.04v-35.07H718zM114.71 584.64c0-15.72 5.78-28.49 17.35-38.29 11.56-9.8 26.74-14.7 45.53-14.7 14.66 0 26.33 2.96 35 8.89v-10.42c0-7.15-2.58-12.87-7.74-17.16-5.16-4.29-12.39-6.43-21.68-6.43-13.84 0-28.19 3.78-43.06 11.33l-16.1-28.8c7.85-5.31 17.5-9.8 28.96-13.48 11.46-3.68 23.08-5.51 34.85-5.51 24.36 0 41.71 5.57 52.04 16.7 10.32 11.13 15.49 26.5 15.48 46.11l-.01 105.38H218.6l-3.85-14.4c-9.09 9.6-22.2 14.4-39.34 14.4-17.14 0-31.55-4.85-43.21-14.55-11.66-9.7-17.49-22.72-17.49-39.07zm50.49-17.3c-5.16 4.19-7.74 9.55-7.74 16.08 0 6.54 2.68 11.85 8.05 15.93 5.37 4.09 12.08 6.13 20.13 6.13 8.26 0 14.97-1.99 20.13-5.97 5.16-3.98 7.75-9.34 7.75-16.08 0-6.94-2.58-12.41-7.74-16.39-5.16-3.98-11.98-5.97-20.44-5.97-8.27-.01-14.98 2.08-20.14 6.27zM1147.32 584.64c0-15.72 5.78-28.49 17.35-38.29 11.56-9.8 26.74-14.7 45.53-14.7 14.66 0 26.33 2.96 35 8.89v-10.42c0-7.15-2.58-12.87-7.74-17.16-5.16-4.29-12.39-6.43-21.68-6.43-13.84 0-28.19 3.78-43.06 11.33l-16.1-28.8c7.85-5.31 17.5-9.8 28.96-13.48 11.46-3.68 23.08-5.51 34.85-5.51 24.36 0 41.71 5.57 52.04 16.7 10.32 11.13 15.49 26.5 15.48 46.11l-.01 105.38h-36.73l-3.85-14.4c-9.09 9.6-22.2 14.4-39.34 14.4-17.14 0-31.55-4.85-43.21-14.55-11.66-9.7-17.49-22.72-17.49-39.07zm50.49-17.3c-5.16 4.19-7.74 9.55-7.74 16.08 0 6.54 2.68 11.85 8.05 15.93 5.37 4.09 12.08 6.13 20.13 6.13 8.26 0 14.97-1.99 20.13-5.97 5.16-3.98 7.75-9.34 7.75-16.08 0-6.94-2.58-12.41-7.74-16.39-5.16-3.98-11.98-5.97-20.44-5.97-8.27-.01-14.98 2.08-20.14 6.27zM286.92 638.26l.02-211.72h42.75l-.02 211.72h-42.75zM361.27 554.63c0-24.3 7.48-44.46 22.46-60.5 14.97-16.03 33.92-24.04 56.84-24.04 24.78 0 44.09 7.61 57.92 22.82 13.83 15.22 20.75 36.1 20.75 62.64 0 4.09-.11 7.15-.31 9.19l-113.99-.01c.41 10.83 4.54 19.66 12.39 26.5 7.84 6.84 17.76 10.26 29.73 10.26 17.14 0 30.25-6.53 39.34-19.6l28.19 21.14c-4.55 8.17-12.6 16.08-24.16 23.74-11.57 7.66-26.23 11.48-43.98 11.48-25.61 0-46.21-7.81-61.79-23.44-15.6-15.61-23.39-35.68-23.39-60.18zm44.91-17.46h69.7c-.41-9.8-3.82-17.66-10.22-23.59-6.4-5.92-14.56-8.88-24.47-8.88-9.91 0-17.97 3.06-24.16 9.19-6.2 6.13-9.81 13.89-10.85 23.28zM811.54 554.63c0-24.3 7.48-44.46 22.46-60.5 14.97-16.03 33.92-24.04 56.84-24.04 24.78 0 44.09 7.61 57.92 22.82 13.83 15.22 20.75 36.1 20.75 62.64 0 4.09-.11 7.15-.31 9.19l-113.99-.01c.41 10.83 4.54 19.66 12.39 26.5 7.84 6.84 17.76 10.26 29.73 10.26 17.14 0 30.25-6.53 39.34-19.6l28.19 21.14c-4.55 8.17-12.6 16.08-24.16 23.74-11.57 7.66-26.23 11.48-43.98 11.48-25.61 0-46.21-7.81-61.79-23.44-15.6-15.61-23.39-35.68-23.39-60.18zm44.91-17.46h69.7c-.41-9.8-3.82-17.66-10.22-23.59-6.4-5.92-14.56-8.88-24.47-8.88-9.91 0-17.97 3.06-24.16 9.19-6.2 6.13-9.81 13.89-10.85 23.28zM624.77 470.07c37.37 0 56.06 25.24 56.06 73.56l-.01 94.62h-42.75l.01-99.58c0-8.67-2.63-15.69-7.89-21.06-5.27-5.37-11.62-8.05-19.05-8.06-8.67 0-15.64 2.84-20.91 8.52s-7.9 12.96-7.9 21.84l-.01 98.35h-42.75l.01-168.19h41.82v23.99c3.92-6.19 9.7-11.56 17.35-16.11 7.64-4.53 16.31-7.88 26.02-7.88zM1078.49 600.06c12.59 0 24.78-4.76 36.55-14.3l11.46 34.38c-14.46 11.36-31.29 18.12-50.49 18.11-25.2 0-45.9-8.89-62.1-24.51-16.21-15.62-24.31-35.5-24.31-59.64s8.21-44.17 24.63-60.09c16.42-15.92 36.91-23.88 61.49-23.88 19 0 36.03 5.68 51.11 17.04l-12.08 35.3c-11.36-10.14-23.96-15.22-37.79-15.22-13.43 0-24.21 4.46-32.37 13.39-8.16 8.93-12.24 19.98-12.24 33.17 0 13.59 4.33 24.7 13.01 33.32 8.66 8.62 19.7 12.93 33.13 12.93z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st2'),
									$elm$svg$Svg$Attributes$cx('646.7'),
									$elm$svg$Svg$Attributes$cy('158.07'),
									$elm$svg$Svg$Attributes$r('53.18')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st2'),
									$elm$svg$Svg$Attributes$d('M592.77 236.47c2.45 1.76 5 3.42 7.65 4.96 13.67 8.59 29.09 12.89 46.27 12.89 16.41 0 31.74-4.2 46-12.59 2.54-1.49 4.98-3.08 7.34-4.75 0 0 25.95 13.82 39.29 53.75-28.12 19.91-59.03 29.79-92.62 29.79-28.51 0-54.97-7.13-79.38-21.39-4.68-2.73-9.25-5.54-13.55-8.65 0 .01 9.57-32.84 39-54.01z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st0'),
									$elm$svg$Svg$Attributes$d('M533.56 273.09c5.58-13.25 17.85-36.14 40.99-54.15-2.8-3.52-5.46-7.19-7.81-11.19-8.4-14.25-12.6-29.58-12.6-45.99.01-17.19 4.3-32.61 12.9-46.28 8.2-14.06 19.43-25.29 33.68-33.68 14.26-8.4 29.59-12.59 45.99-12.59 16.8 0 32.22 4.1 46.28 12.3 14.07 8.59 25.29 20.03 33.69 34.28 8.39 14.26 12.6 29.59 12.59 45.98 0 16.79-4.1 32.22-12.31 46.28-2.46 4.03-5.25 7.75-8.18 11.32 10.08 7.27 28.4 23.78 40.77 54.04 28.38-28.68 45.92-68.11 45.92-111.64C805.48 74.08 734.4 3 646.71 3S487.95 74.08 487.95 161.76c0 43.38 17.41 82.67 45.61 111.33z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st0'),
									$elm$svg$Svg$Attributes$d('M592.77 236.47c-.02.01-.03.02-.05.04.02-.02.03-.03.05-.04z')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$T2$Internal$Logo$internalLogoVerticalDarkPrimarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 1290.95 642.26'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 1290.95 642.26'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st1{fill:#fafafa}.st4{fill:#00cd83}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st4'),
							$elm$svg$Svg$Attributes$d('M20.35 470.07v-43.53h42.13v43.52h30.36v35.08H62.48v66.21c0 11.57 1.81 19.31 5.42 23.23 3.61 3.93 9.76 5.89 18.43 5.89 2.89 0 5.47-.1 7.74-.31v36.55c-4.34 1.03-10.43 1.55-18.28 1.55-19.2 0-33.3-5.42-42.28-16.26-8.98-10.84-13.48-27.31-13.47-49.41v-67.45H3v-35.07h17.35zM718 470.07v-43.53h42.13v43.52h30.36v35.08h-30.36v66.21c0 11.57 1.81 19.31 5.42 23.23 3.61 3.93 9.76 5.89 18.43 5.89 2.89 0 5.47-.1 7.74-.31v36.55c-4.34 1.03-10.43 1.55-18.28 1.55-19.2 0-33.3-5.42-42.28-16.26-8.98-10.84-13.48-27.31-13.47-49.41v-67.45h-17.04v-35.07H718zM114.71 584.64c0-15.72 5.78-28.49 17.35-38.29 11.56-9.8 26.74-14.7 45.53-14.7 14.66 0 26.33 2.96 35 8.89v-10.42c0-7.15-2.58-12.87-7.74-17.16-5.16-4.29-12.39-6.43-21.68-6.43-13.84 0-28.19 3.78-43.06 11.33l-16.1-28.8c7.85-5.31 17.5-9.8 28.96-13.48 11.46-3.68 23.08-5.51 34.85-5.51 24.36 0 41.71 5.57 52.04 16.7 10.32 11.13 15.49 26.5 15.48 46.11l-.01 105.38H218.6l-3.85-14.4c-9.09 9.6-22.2 14.4-39.34 14.4-17.14 0-31.55-4.85-43.21-14.55-11.66-9.7-17.49-22.72-17.49-39.07zm50.49-17.3c-5.16 4.19-7.74 9.55-7.74 16.08 0 6.54 2.68 11.85 8.05 15.93 5.37 4.09 12.08 6.13 20.13 6.13 8.26 0 14.97-1.99 20.13-5.97 5.16-3.98 7.75-9.34 7.75-16.08 0-6.94-2.58-12.41-7.74-16.39-5.16-3.98-11.98-5.97-20.44-5.97-8.27-.01-14.98 2.08-20.14 6.27zM1147.32 584.64c0-15.72 5.78-28.49 17.35-38.29 11.56-9.8 26.74-14.7 45.53-14.7 14.66 0 26.33 2.96 35 8.89v-10.42c0-7.15-2.58-12.87-7.74-17.16-5.16-4.29-12.39-6.43-21.68-6.43-13.84 0-28.19 3.78-43.06 11.33l-16.1-28.8c7.85-5.31 17.5-9.8 28.96-13.48 11.46-3.68 23.08-5.51 34.85-5.51 24.36 0 41.71 5.57 52.04 16.7 10.32 11.13 15.49 26.5 15.48 46.11l-.01 105.38h-36.73l-3.85-14.4c-9.09 9.6-22.2 14.4-39.34 14.4-17.14 0-31.55-4.85-43.21-14.55-11.66-9.7-17.49-22.72-17.49-39.07zm50.49-17.3c-5.16 4.19-7.74 9.55-7.74 16.08 0 6.54 2.68 11.85 8.05 15.93 5.37 4.09 12.08 6.13 20.13 6.13 8.26 0 14.97-1.99 20.13-5.97 5.16-3.98 7.75-9.34 7.75-16.08 0-6.94-2.58-12.41-7.74-16.39-5.16-3.98-11.98-5.97-20.44-5.97-8.27-.01-14.98 2.08-20.14 6.27zM286.92 638.26l.02-211.72h42.75l-.02 211.72h-42.75zM361.27 554.63c0-24.3 7.48-44.46 22.46-60.5 14.97-16.03 33.92-24.04 56.84-24.04 24.78 0 44.09 7.61 57.92 22.82 13.83 15.22 20.75 36.1 20.75 62.64 0 4.09-.11 7.15-.31 9.19l-113.99-.01c.41 10.83 4.54 19.66 12.39 26.5 7.84 6.84 17.76 10.26 29.73 10.26 17.14 0 30.25-6.53 39.34-19.6l28.19 21.14c-4.55 8.17-12.6 16.08-24.16 23.74-11.57 7.66-26.23 11.48-43.98 11.48-25.61 0-46.21-7.81-61.79-23.44-15.6-15.61-23.39-35.68-23.39-60.18zm44.91-17.46h69.7c-.41-9.8-3.82-17.66-10.22-23.59-6.4-5.92-14.56-8.88-24.47-8.88-9.91 0-17.97 3.06-24.16 9.19-6.2 6.13-9.81 13.89-10.85 23.28zM811.54 554.63c0-24.3 7.48-44.46 22.46-60.5 14.97-16.03 33.92-24.04 56.84-24.04 24.78 0 44.09 7.61 57.92 22.82 13.83 15.22 20.75 36.1 20.75 62.64 0 4.09-.11 7.15-.31 9.19l-113.99-.01c.41 10.83 4.54 19.66 12.39 26.5 7.84 6.84 17.76 10.26 29.73 10.26 17.14 0 30.25-6.53 39.34-19.6l28.19 21.14c-4.55 8.17-12.6 16.08-24.16 23.74-11.57 7.66-26.23 11.48-43.98 11.48-25.61 0-46.21-7.81-61.79-23.44-15.6-15.61-23.39-35.68-23.39-60.18zm44.91-17.46h69.7c-.41-9.8-3.82-17.66-10.22-23.59-6.4-5.92-14.56-8.88-24.47-8.88-9.91 0-17.97 3.06-24.16 9.19-6.2 6.13-9.81 13.89-10.85 23.28zM624.77 470.07c37.37 0 56.06 25.24 56.06 73.56l-.01 94.62h-42.75l.01-99.58c0-8.67-2.63-15.69-7.89-21.06-5.27-5.37-11.62-8.05-19.05-8.06-8.67 0-15.64 2.84-20.91 8.52s-7.9 12.96-7.9 21.84l-.01 98.35h-42.75l.01-168.19h41.82v23.99c3.92-6.19 9.7-11.56 17.35-16.11 7.64-4.53 16.31-7.88 26.02-7.88zM1078.49 600.06c12.59 0 24.78-4.76 36.55-14.3l11.46 34.38c-14.46 11.36-31.29 18.12-50.49 18.11-25.2 0-45.9-8.89-62.1-24.51-16.21-15.62-24.31-35.5-24.31-59.64s8.21-44.17 24.63-60.09c16.42-15.92 36.91-23.88 61.49-23.88 19 0 36.03 5.68 51.11 17.04l-12.08 35.3c-11.36-10.14-23.96-15.22-37.79-15.22-13.43 0-24.21 4.46-32.37 13.39-8.16 8.93-12.24 19.98-12.24 33.17 0 13.59 4.33 24.7 13.01 33.32 8.66 8.62 19.7 12.93 33.13 12.93z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st1'),
									$elm$svg$Svg$Attributes$cx('646.7'),
									$elm$svg$Svg$Attributes$cy('158.07'),
									$elm$svg$Svg$Attributes$r('53.18')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st1'),
									$elm$svg$Svg$Attributes$d('M592.77 236.47c2.45 1.76 5 3.42 7.65 4.96 13.67 8.59 29.09 12.89 46.27 12.89 16.41 0 31.74-4.2 46-12.59 2.54-1.49 4.98-3.08 7.34-4.75 0 0 25.95 13.82 39.29 53.75-28.12 19.91-59.03 29.79-92.62 29.79-28.51 0-54.97-7.13-79.38-21.39-4.68-2.73-9.25-5.54-13.55-8.65 0 .01 9.57-32.84 39-54.01z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st4'),
									$elm$svg$Svg$Attributes$d('M533.56 273.09c5.58-13.25 17.85-36.14 40.99-54.15-2.8-3.52-5.46-7.19-7.81-11.19-8.4-14.25-12.6-29.58-12.6-45.99.01-17.19 4.3-32.61 12.9-46.28 8.2-14.06 19.43-25.29 33.68-33.68 14.26-8.4 29.59-12.59 45.99-12.59 16.8 0 32.22 4.1 46.28 12.3 14.07 8.59 25.29 20.03 33.69 34.28 8.39 14.26 12.6 29.59 12.59 45.98 0 16.79-4.1 32.22-12.31 46.28-2.46 4.03-5.25 7.75-8.18 11.32 10.08 7.27 28.4 23.78 40.77 54.04 28.38-28.68 45.92-68.11 45.92-111.64C805.48 74.08 734.4 3 646.71 3S487.95 74.08 487.95 161.76c0 43.38 17.41 82.67 45.61 111.33z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st4'),
									$elm$svg$Svg$Attributes$d('M592.77 236.47c-.02.01-.03.02-.05.04.02-.02.03-.03.05-.04z')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$T2$Internal$Logo$internalLogoVerticalDarkSecondaryAndAlternativePrimarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 1290.95 642.26'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 1290.95 642.26'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st0{fill:#002e23}.st1{fill:#fafafa}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st0'),
							$elm$svg$Svg$Attributes$d('M20.35 470.07v-43.53h42.13v43.52h30.36v35.08H62.48v66.21c0 11.57 1.81 19.31 5.42 23.23 3.61 3.93 9.76 5.89 18.43 5.89 2.89 0 5.47-.1 7.74-.31v36.55c-4.34 1.03-10.43 1.55-18.28 1.55-19.2 0-33.3-5.42-42.28-16.26-8.98-10.84-13.48-27.31-13.47-49.41v-67.45H3v-35.07h17.35zM718 470.07v-43.53h42.13v43.52h30.36v35.08h-30.36v66.21c0 11.57 1.81 19.31 5.42 23.23 3.61 3.93 9.76 5.89 18.43 5.89 2.89 0 5.47-.1 7.74-.31v36.55c-4.34 1.03-10.43 1.55-18.28 1.55-19.2 0-33.3-5.42-42.28-16.26-8.98-10.84-13.48-27.31-13.47-49.41v-67.45h-17.04v-35.07H718zM114.71 584.64c0-15.72 5.78-28.49 17.35-38.29 11.56-9.8 26.74-14.7 45.53-14.7 14.66 0 26.33 2.96 35 8.89v-10.42c0-7.15-2.58-12.87-7.74-17.16-5.16-4.29-12.39-6.43-21.68-6.43-13.84 0-28.19 3.78-43.06 11.33l-16.1-28.8c7.85-5.31 17.5-9.8 28.96-13.48 11.46-3.68 23.08-5.51 34.85-5.51 24.36 0 41.71 5.57 52.04 16.7 10.32 11.13 15.49 26.5 15.48 46.11l-.01 105.38H218.6l-3.85-14.4c-9.09 9.6-22.2 14.4-39.34 14.4-17.14 0-31.55-4.85-43.21-14.55-11.66-9.7-17.5-22.72-17.49-39.07zm50.49-17.3c-5.16 4.19-7.74 9.55-7.74 16.08 0 6.54 2.68 11.85 8.05 15.93 5.37 4.09 12.08 6.13 20.13 6.13 8.26 0 14.97-1.99 20.13-5.97 5.16-3.98 7.75-9.34 7.75-16.08 0-6.94-2.58-12.41-7.74-16.39-5.16-3.98-11.98-5.97-20.44-5.97-8.27-.01-14.98 2.08-20.14 6.27zM1147.32 584.64c0-15.72 5.78-28.49 17.35-38.29 11.56-9.8 26.74-14.7 45.53-14.7 14.66 0 26.33 2.96 35 8.89v-10.42c0-7.15-2.58-12.87-7.74-17.16-5.16-4.29-12.39-6.43-21.68-6.43-13.84 0-28.19 3.78-43.06 11.33l-16.1-28.8c7.85-5.31 17.5-9.8 28.96-13.48 11.46-3.68 23.08-5.51 34.85-5.51 24.36 0 41.71 5.57 52.04 16.7 10.32 11.13 15.49 26.5 15.48 46.11l-.01 105.38h-36.73l-3.85-14.4c-9.09 9.6-22.2 14.4-39.34 14.4-17.14 0-31.55-4.85-43.21-14.55-11.66-9.7-17.5-22.72-17.49-39.07zm50.49-17.3c-5.16 4.19-7.74 9.55-7.74 16.08 0 6.54 2.68 11.85 8.05 15.93 5.37 4.09 12.08 6.13 20.13 6.13 8.26 0 14.97-1.99 20.13-5.97 5.16-3.98 7.75-9.34 7.75-16.08 0-6.94-2.58-12.41-7.74-16.39-5.16-3.98-11.98-5.97-20.44-5.97-8.27-.01-14.98 2.08-20.14 6.27zM286.92 638.26l.02-211.72h42.75l-.02 211.72h-42.75zM361.27 554.63c0-24.3 7.48-44.46 22.46-60.5 14.97-16.03 33.92-24.04 56.84-24.04 24.78 0 44.09 7.61 57.92 22.82 13.83 15.22 20.75 36.1 20.75 62.64 0 4.09-.11 7.15-.31 9.19l-113.99-.01c.41 10.83 4.54 19.66 12.39 26.5 7.84 6.84 17.76 10.26 29.73 10.26 17.14 0 30.25-6.53 39.34-19.6l28.19 21.14c-4.55 8.17-12.6 16.08-24.16 23.74-11.57 7.66-26.23 11.48-43.98 11.48-25.61 0-46.21-7.81-61.79-23.44-15.61-15.61-23.4-35.68-23.39-60.18zm44.91-17.46h69.7c-.41-9.8-3.82-17.66-10.22-23.59-6.4-5.92-14.56-8.88-24.47-8.88-9.91 0-17.97 3.06-24.16 9.19-6.2 6.13-9.82 13.89-10.85 23.28zM811.54 554.63c0-24.3 7.48-44.46 22.46-60.5 14.97-16.03 33.92-24.04 56.84-24.04 24.78 0 44.09 7.61 57.92 22.82 13.83 15.22 20.75 36.1 20.75 62.64 0 4.09-.11 7.15-.31 9.19l-113.99-.01c.41 10.83 4.54 19.66 12.39 26.5 7.84 6.84 17.76 10.26 29.73 10.26 17.14 0 30.25-6.53 39.34-19.6l28.19 21.14c-4.55 8.17-12.6 16.08-24.16 23.74-11.57 7.66-26.23 11.48-43.98 11.48-25.61 0-46.21-7.81-61.79-23.44-15.61-15.61-23.4-35.68-23.39-60.18zm44.91-17.46h69.7c-.41-9.8-3.82-17.66-10.22-23.59-6.4-5.92-14.56-8.88-24.47-8.88-9.91 0-17.97 3.06-24.16 9.19-6.2 6.13-9.82 13.89-10.85 23.28zM624.77 470.07c37.37 0 56.06 25.24 56.06 73.56l-.01 94.62h-42.75l.01-99.58c0-8.67-2.63-15.69-7.89-21.06-5.27-5.37-11.62-8.05-19.05-8.06-8.67 0-15.64 2.84-20.91 8.52s-7.9 12.96-7.9 21.84l-.01 98.35h-42.75l.01-168.19h41.82v23.99c3.92-6.19 9.7-11.56 17.35-16.11 7.64-4.53 16.31-7.88 26.02-7.88zM1078.49 600.06c12.59 0 24.78-4.76 36.55-14.3l11.46 34.38c-14.46 11.36-31.29 18.12-50.49 18.11-25.2 0-45.9-8.89-62.1-24.51-16.21-15.62-24.31-35.5-24.31-59.64s8.21-44.17 24.63-60.09c16.42-15.92 36.91-23.88 61.49-23.88 19 0 36.03 5.68 51.11 17.04l-12.08 35.3c-11.36-10.14-23.96-15.22-37.79-15.22-13.43 0-24.21 4.46-32.37 13.39-8.16 8.93-12.24 19.98-12.24 33.17 0 13.59 4.33 24.7 13.01 33.32 8.66 8.62 19.7 12.93 33.13 12.93z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st1'),
									$elm$svg$Svg$Attributes$cx('646.7'),
									$elm$svg$Svg$Attributes$cy('158.07'),
									$elm$svg$Svg$Attributes$r('53.18')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st1'),
									$elm$svg$Svg$Attributes$d('M592.77 236.47c2.45 1.76 5 3.42 7.65 4.96 13.67 8.59 29.09 12.89 46.27 12.89 16.41 0 31.74-4.2 46-12.59 2.54-1.49 4.98-3.08 7.34-4.75 0 0 25.95 13.82 39.29 53.75-28.12 19.91-59.03 29.79-92.62 29.79-28.51 0-54.97-7.13-79.38-21.39-4.68-2.73-9.25-5.54-13.55-8.65 0 .01 9.57-32.84 39-54.01z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st0'),
									$elm$svg$Svg$Attributes$d('M533.55 273.09c5.58-13.25 17.85-36.14 40.99-54.15-2.8-3.52-5.46-7.19-7.81-11.19-8.4-14.25-12.6-29.58-12.6-45.99.01-17.19 4.3-32.61 12.9-46.28 8.2-14.06 19.43-25.29 33.68-33.68 14.26-8.4 29.59-12.59 45.99-12.59 16.8 0 32.22 4.1 46.28 12.3 14.07 8.59 25.29 20.03 33.69 34.28 8.39 14.26 12.6 29.59 12.59 45.98 0 16.79-4.1 32.22-12.31 46.28-2.46 4.03-5.25 7.75-8.18 11.32 10.08 7.27 28.4 23.78 40.77 54.04 28.38-28.68 45.92-68.11 45.92-111.64C805.48 74.08 734.39 3 646.71 3S487.95 74.08 487.95 161.76c0 43.38 17.41 82.67 45.6 111.33z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st0'),
									$elm$svg$Svg$Attributes$d('M592.77 236.47c-.02.01-.03.02-.05.04.02-.02.03-.03.05-.04z')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$T2$Internal$Logo$internalLogoVerticalPrimarySvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 1290.95 642.26'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 1290.95 642.26'),
			$elm$svg$Svg$Attributes$xmlSpace('preserve')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$style,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text('.st0{fill:#002e23}.st4{fill:#00cd83}')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('Layer_1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('st0'),
							$elm$svg$Svg$Attributes$d('M20.35 470.07v-43.53h42.13v43.52h30.36v35.08H62.48v66.21c0 11.57 1.81 19.31 5.42 23.23 3.61 3.93 9.76 5.89 18.43 5.89 2.89 0 5.47-.1 7.74-.31v36.55c-4.34 1.03-10.43 1.55-18.28 1.55-19.2 0-33.3-5.42-42.28-16.26-8.98-10.84-13.48-27.31-13.47-49.41v-67.45H3v-35.07h17.35zM718 470.07v-43.53h42.13v43.52h30.36v35.08h-30.36v66.21c0 11.57 1.81 19.31 5.42 23.23 3.61 3.93 9.76 5.89 18.43 5.89 2.89 0 5.47-.1 7.74-.31v36.55c-4.34 1.03-10.43 1.55-18.28 1.55-19.2 0-33.3-5.42-42.28-16.26-8.98-10.84-13.48-27.31-13.47-49.41v-67.45h-17.04v-35.07H718zM114.71 584.64c0-15.72 5.78-28.49 17.35-38.29 11.56-9.8 26.74-14.7 45.53-14.7 14.66 0 26.33 2.96 35 8.89v-10.42c0-7.15-2.58-12.87-7.74-17.16-5.16-4.29-12.39-6.43-21.68-6.43-13.84 0-28.19 3.78-43.06 11.33l-16.1-28.8c7.85-5.31 17.5-9.8 28.96-13.48 11.46-3.68 23.08-5.51 34.85-5.51 24.36 0 41.71 5.57 52.04 16.7 10.32 11.13 15.49 26.5 15.48 46.11l-.01 105.38H218.6l-3.85-14.4c-9.09 9.6-22.2 14.4-39.34 14.4-17.14 0-31.55-4.85-43.21-14.55-11.66-9.7-17.49-22.72-17.49-39.07zm50.49-17.3c-5.16 4.19-7.74 9.55-7.74 16.08 0 6.54 2.68 11.85 8.05 15.93 5.37 4.09 12.08 6.13 20.13 6.13 8.26 0 14.97-1.99 20.13-5.97 5.16-3.98 7.75-9.34 7.75-16.08 0-6.94-2.58-12.41-7.74-16.39-5.16-3.98-11.98-5.97-20.44-5.97-8.27-.01-14.98 2.08-20.14 6.27zM1147.32 584.64c0-15.72 5.78-28.49 17.35-38.29 11.56-9.8 26.74-14.7 45.53-14.7 14.66 0 26.33 2.96 35 8.89v-10.42c0-7.15-2.58-12.87-7.74-17.16-5.16-4.29-12.39-6.43-21.68-6.43-13.84 0-28.19 3.78-43.06 11.33l-16.1-28.8c7.85-5.31 17.5-9.8 28.96-13.48 11.46-3.68 23.08-5.51 34.85-5.51 24.36 0 41.71 5.57 52.04 16.7 10.32 11.13 15.49 26.5 15.48 46.11l-.01 105.38h-36.73l-3.85-14.4c-9.09 9.6-22.2 14.4-39.34 14.4-17.14 0-31.55-4.85-43.21-14.55-11.66-9.7-17.49-22.72-17.49-39.07zm50.49-17.3c-5.16 4.19-7.74 9.55-7.74 16.08 0 6.54 2.68 11.85 8.05 15.93 5.37 4.09 12.08 6.13 20.13 6.13 8.26 0 14.97-1.99 20.13-5.97 5.16-3.98 7.75-9.34 7.75-16.08 0-6.94-2.58-12.41-7.74-16.39-5.16-3.98-11.98-5.97-20.44-5.97-8.27-.01-14.98 2.08-20.14 6.27zM286.92 638.26l.02-211.72h42.75l-.02 211.72h-42.75zM361.27 554.63c0-24.3 7.48-44.46 22.46-60.5 14.97-16.03 33.92-24.04 56.84-24.04 24.78 0 44.09 7.61 57.92 22.82 13.83 15.22 20.75 36.1 20.75 62.64 0 4.09-.11 7.15-.31 9.19l-113.99-.01c.41 10.83 4.54 19.66 12.39 26.5 7.84 6.84 17.76 10.26 29.73 10.26 17.14 0 30.25-6.53 39.34-19.6l28.19 21.14c-4.55 8.17-12.6 16.08-24.16 23.74-11.57 7.66-26.23 11.48-43.98 11.48-25.61 0-46.21-7.81-61.79-23.44-15.6-15.61-23.39-35.68-23.39-60.18zm44.91-17.46h69.7c-.41-9.8-3.82-17.66-10.22-23.59-6.4-5.92-14.56-8.88-24.47-8.88-9.91 0-17.97 3.06-24.16 9.19-6.2 6.13-9.81 13.89-10.85 23.28zM811.54 554.63c0-24.3 7.48-44.46 22.46-60.5 14.97-16.03 33.92-24.04 56.84-24.04 24.78 0 44.09 7.61 57.92 22.82 13.83 15.22 20.75 36.1 20.75 62.64 0 4.09-.11 7.15-.31 9.19l-113.99-.01c.41 10.83 4.54 19.66 12.39 26.5 7.84 6.84 17.76 10.26 29.73 10.26 17.14 0 30.25-6.53 39.34-19.6l28.19 21.14c-4.55 8.17-12.6 16.08-24.16 23.74-11.57 7.66-26.23 11.48-43.98 11.48-25.61 0-46.21-7.81-61.79-23.44-15.6-15.61-23.39-35.68-23.39-60.18zm44.91-17.46h69.7c-.41-9.8-3.82-17.66-10.22-23.59-6.4-5.92-14.56-8.88-24.47-8.88-9.91 0-17.97 3.06-24.16 9.19-6.2 6.13-9.81 13.89-10.85 23.28zM624.77 470.07c37.37 0 56.06 25.24 56.06 73.56l-.01 94.62h-42.75l.01-99.58c0-8.67-2.63-15.69-7.89-21.06-5.27-5.37-11.62-8.05-19.05-8.06-8.67 0-15.64 2.84-20.91 8.52s-7.9 12.96-7.9 21.84l-.01 98.35h-42.75l.01-168.19h41.82v23.99c3.92-6.19 9.7-11.56 17.35-16.11 7.64-4.53 16.31-7.88 26.02-7.88zM1078.49 600.06c12.59 0 24.78-4.76 36.55-14.3l11.46 34.38c-14.46 11.36-31.29 18.12-50.49 18.11-25.2 0-45.9-8.89-62.1-24.51-16.21-15.62-24.31-35.5-24.31-59.64s8.21-44.17 24.63-60.09c16.42-15.92 36.91-23.88 61.49-23.88 19 0 36.03 5.68 51.11 17.04l-12.08 35.3c-11.36-10.14-23.96-15.22-37.79-15.22-13.43 0-24.21 4.46-32.37 13.39-8.16 8.93-12.24 19.98-12.24 33.17 0 13.59 4.33 24.7 13.01 33.32 8.66 8.62 19.7 12.93 33.13 12.93z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st4'),
									$elm$svg$Svg$Attributes$cx('646.7'),
									$elm$svg$Svg$Attributes$cy('158.07'),
									$elm$svg$Svg$Attributes$r('53.18')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st4'),
									$elm$svg$Svg$Attributes$d('M592.77 236.47c2.45 1.76 5 3.42 7.65 4.96 13.67 8.59 29.09 12.89 46.27 12.89 16.41 0 31.74-4.2 46-12.59 2.54-1.49 4.98-3.08 7.34-4.75 0 0 25.95 13.82 39.29 53.75-28.12 19.91-59.03 29.79-92.62 29.79-28.51 0-54.97-7.13-79.38-21.39-4.68-2.73-9.25-5.54-13.55-8.65 0 .01 9.57-32.84 39-54.01z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st0'),
									$elm$svg$Svg$Attributes$d('M533.56 273.09c5.58-13.25 17.85-36.14 40.99-54.15-2.8-3.52-5.46-7.19-7.81-11.19-8.4-14.25-12.6-29.58-12.6-45.99.01-17.19 4.3-32.61 12.9-46.28 8.2-14.06 19.43-25.29 33.68-33.68 14.26-8.4 29.59-12.59 45.99-12.59 16.8 0 32.22 4.1 46.28 12.3 14.07 8.59 25.29 20.03 33.69 34.28 8.39 14.26 12.6 29.59 12.59 45.98 0 16.79-4.1 32.22-12.31 46.28-2.46 4.03-5.25 7.75-8.18 11.32 10.08 7.27 28.4 23.78 40.77 54.04 28.38-28.68 45.92-68.11 45.92-111.64C805.48 74.08 734.4 3 646.71 3S487.95 74.08 487.95 161.76c0 43.38 17.41 82.67 45.61 111.33z')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('st0'),
									$elm$svg$Svg$Attributes$d('M592.77 236.47c-.02.01-.03.02-.05.04.02-.02.03-.03.05-.04z')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$T2$Internal$Logo$internalRenderSvg = F2(
	function (shape, style) {
		var _v0 = _Utils_Tuple2(shape, style);
		switch (_v0.a) {
			case 0:
				switch (_v0.b) {
					case 0:
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoPrincipalPrimarySvg;
					case 1:
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoPrincipalDarkPrimarySvg;
					case 2:
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoPrincipalDarkSecondaryAndAlternativePrimarySvg;
					case 3:
						var _v7 = _v0.a;
						var _v8 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoPrincipalDarkSecondaryAndAlternativePrimarySvg;
					default:
						var _v9 = _v0.a;
						var _v10 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoPrincipalAlternativeSecondarySvg;
				}
			case 1:
				switch (_v0.b) {
					case 0:
						var _v11 = _v0.a;
						var _v12 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoVerticalPrimarySvg;
					case 1:
						var _v13 = _v0.a;
						var _v14 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoVerticalDarkPrimarySvg;
					case 2:
						var _v15 = _v0.a;
						var _v16 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoVerticalDarkSecondaryAndAlternativePrimarySvg;
					case 3:
						var _v17 = _v0.a;
						var _v18 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoVerticalDarkSecondaryAndAlternativePrimarySvg;
					default:
						var _v19 = _v0.a;
						var _v20 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoVerticalAlternativeSecondarySvg;
				}
			case 2:
				switch (_v0.b) {
					case 0:
						var _v21 = _v0.a;
						var _v22 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoIsotypeOnlyPrimarySvg;
					case 1:
						var _v23 = _v0.a;
						var _v24 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoIsotypeOnlyDarkPrimarySvg;
					case 2:
						var _v25 = _v0.a;
						var _v26 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoIsotypeOnlyDarkSecondaryAndAlternativePrimarySvg;
					case 3:
						var _v27 = _v0.a;
						var _v28 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoIsotypeOnlyDarkSecondaryAndAlternativePrimarySvg;
					default:
						var _v29 = _v0.a;
						var _v30 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoIsotypeOnlyAlternativeSecondarySvg;
				}
			default:
				switch (_v0.b) {
					case 0:
						var _v31 = _v0.a;
						var _v32 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoTextOnlyPrimaryDarkSecondaryAlternativePrimaryAndAlternativeSecondarySvg;
					case 1:
						var _v33 = _v0.a;
						var _v34 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoTextOnlyDarkPrimarySvg;
					case 2:
						var _v35 = _v0.a;
						var _v36 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoTextOnlyPrimaryDarkSecondaryAlternativePrimaryAndAlternativeSecondarySvg;
					case 3:
						var _v37 = _v0.a;
						var _v38 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoTextOnlyPrimaryDarkSecondaryAlternativePrimaryAndAlternativeSecondarySvg;
					default:
						var _v39 = _v0.a;
						var _v40 = _v0.b;
						return $author$project$T2$Internal$Logo$internalLogoTextOnlyPrimaryDarkSecondaryAlternativePrimaryAndAlternativeSecondarySvg;
				}
		}
	});
var $author$project$T2$Internal$Logo$renderLogo = F3(
	function (attrs, shape, style) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var internalStyle = function () {
					var _v0 = _Utils_Tuple2(style, context.cF);
					if (!_v0.b) {
						switch (_v0.a) {
							case 0:
								var _v1 = _v0.a;
								var _v2 = _v0.b;
								return 0;
							case 1:
								var _v5 = _v0.a;
								var _v6 = _v0.b;
								return 3;
							case 2:
								var _v9 = _v0.a;
								var _v10 = _v0.b;
								return 3;
							default:
								var _v13 = _v0.a;
								var _v14 = _v0.b;
								return 4;
						}
					} else {
						switch (_v0.a) {
							case 0:
								var _v3 = _v0.a;
								var _v4 = _v0.b;
								return 1;
							case 1:
								var _v7 = _v0.a;
								var _v8 = _v0.b;
								return 1;
							case 2:
								var _v11 = _v0.a;
								var _v12 = _v0.b;
								return 1;
							default:
								var _v15 = _v0.a;
								var _v16 = _v0.b;
								return 2;
						}
					}
				}();
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					attrs,
					$lucamug$elm_ui_with_context$Element$WithContext$html(
						A2($author$project$T2$Internal$Logo$internalRenderSvg, shape, internalStyle)));
			});
	});
var $author$project$T2$Logo$talentecaLogoHorizontalNormal = function (attrs) {
	return A3($author$project$T2$Internal$Logo$renderLogo, attrs, 0, 0);
};
var $author$project$T2$Internal$Footer$renderDesktopFooter = function (topLinksMaybe) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			var topLinksSection = function () {
				if (!topLinksMaybe.$) {
					var allTopLinks = topLinksMaybe.a;
					var topLinksColumn = F2(
						function (topLinksTitle, topLinks) {
							if ($elm$core$List$isEmpty(topLinks)) {
								return $lucamug$elm_ui_with_context$Element$WithContext$none;
							} else {
								var topLinkEl = function (topLink) {
									return A2(
										(context.cF === 1) ? $author$project$T2$Link$linkContentPrimarySubtleEnabledSmall : $author$project$T2$Link$linkContentInverseSubtleEnabledSmall,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width(
												A2($lucamug$elm_ui_with_context$Element$WithContext$maximum, 150, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis')),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'))
											]),
										{u: topLink.u, R: topLink.R});
								};
								return A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16),
											$lucamug$elm_ui_with_context$Element$WithContext$alignTop
										]),
									_List_fromArray(
										[
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											A2(
												$author$project$T2$Text$labelMediumAttrs,
												_List_Nil,
												$author$project$T2$Internal$Color$fgTopLinkTitle(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$text('TOP ' + topLinksTitle)),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$column,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16)
												]),
											A2($elm$core$List$map, topLinkEl, topLinks))
										]));
							}
						});
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								$author$project$T2$Internal$Color$bgTopLinks(context)),
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, $author$project$T2$Internal$Spacing$spacing64, $author$project$T2$Internal$Spacing$spacing36)
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$row,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
										$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
										$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing48)
									]),
								_List_fromArray(
									[
										A2(topLinksColumn, 'EMPRESAS', allTopLinks.gR.gx),
										A2(topLinksColumn, 'REGIONES', allTopLinks.eQ.gx),
										A2(topLinksColumn, 'CIUDADES', allTopLinks.cT.gx),
										A2(topLinksColumn, 'CATEGORÍAS', allTopLinks.cS.gx)
									]))
							]));
				} else {
					return $lucamug$elm_ui_with_context$Element$WithContext$none;
				}
			}();
			var followUsSection = F2(
				function (dividerColor, trademarkColor) {
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, $author$project$T2$Internal$Spacing$spacing64, $author$project$T2$Internal$Spacing$spacing36),
								$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing36)
							]),
						_List_fromArray(
							[
								$author$project$T2$Divider$divider1(
								dividerColor(context)),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$row,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing24)
									]),
								_List_fromArray(
									[
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$row,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
												$lucamug$elm_ui_with_context$Element$WithContext$spacing(24),
												$lucamug$elm_ui_with_context$Element$WithContext$alignLeft
											]),
										_List_fromArray(
											[
												A2(
												$author$project$T2$Link$linkSubtleEnabledMedium,
												_List_Nil,
												{u: 'Blog', R: 'https://www.talenteca.com/blog'}),
												A2(
												$author$project$T2$Link$linkSubtleEnabledMediumForNewTab,
												_List_Nil,
												{u: 'LinkedIn', R: 'https://www.linkedin.com/company/talenteca/'}),
												A2(
												$author$project$T2$Link$linkSubtleEnabledMediumForNewTab,
												_List_Nil,
												{u: 'Facebook', R: 'https://www.facebook.com/talenteca'}),
												A2(
												$author$project$T2$Link$linkSubtleEnabledMediumForNewTab,
												_List_Nil,
												{u: 'Twitter', R: 'https://x.com/talenteca'})
											])),
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_Utils_ap(
											A2(
												$author$project$T2$Text$paragraphSmallAttrs,
												_List_Nil,
												trademarkColor(context)),
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
													$lucamug$elm_ui_with_context$Element$WithContext$alignRight
												])),
										$lucamug$elm_ui_with_context$Element$WithContext$text('© 2026 un servicio de Listatree S.A.'))
									]))
							]));
				});
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$shrink)
					]),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$row,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paddingXY,
								function () {
									var _v0 = context.bT;
									switch (_v0) {
										case 0:
											return $author$project$T2$Internal$Spacing$spacing16;
										case 1:
											return $author$project$T2$Internal$Spacing$spacing36;
										case 2:
											return $author$project$T2$Internal$Spacing$spacing64;
										default:
											return $author$project$T2$Internal$Spacing$spacing64;
									}
								}(),
								$author$project$T2$Internal$Spacing$spacing36)
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$link,
								_List_fromArray(
									[$lucamug$elm_ui_with_context$Element$WithContext$alignLeft]),
								{
									u: $author$project$T2$Logo$talentecaLogoHorizontalNormal(
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width(
												A2(
													$lucamug$elm_ui_with_context$Element$WithContext$maximum,
													258,
													A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 258, $lucamug$elm_ui_with_context$Element$WithContext$fill)))
											])),
									R: '/'
								}),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$row,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
										$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
										$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing48)
									]),
								_List_fromArray(
									[
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$column,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16),
												$lucamug$elm_ui_with_context$Element$WithContext$alignTop
											]),
										_List_fromArray(
											[
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$el,
												A2(
													$author$project$T2$Text$paragraphSmallAttrs,
													_List_Nil,
													$author$project$T2$Internal$Color$primaryA(context)),
												$lucamug$elm_ui_with_context$Element$WithContext$text('BUSCO EMPLEO')),
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$column,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Buscar empleo', R: '/empleos'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Subir tu hoja de vida', R: '/postular?j_id=000000000000000000000000'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Acceder como candidato', R: '/acceder-como-candidato'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Soporte', R: '/preguntas-frecuentes?section=candidatos'})
													]))
											])),
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$column,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16),
												$lucamug$elm_ui_with_context$Element$WithContext$alignTop
											]),
										_List_fromArray(
											[
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$el,
												A2(
													$author$project$T2$Text$paragraphSmallAttrs,
													_List_Nil,
													$author$project$T2$Internal$Color$primaryA(context)),
												$lucamug$elm_ui_with_context$Element$WithContext$text('BUSCO PERSONAL')),
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$column,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Buscar candidatos', R: '/base-de-candidatos'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Publicar nuevo empleo', R: '/reclutador/publicar'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Precios', R: '/precios'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Acceder como reclutador', R: '/acceder-como-reclutador'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Soporte', R: '/preguntas-frecuentes?section=reclutadores'})
													]))
											])),
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$column,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16),
												$lucamug$elm_ui_with_context$Element$WithContext$alignTop
											]),
										_List_fromArray(
											[
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$el,
												A2(
													$author$project$T2$Text$paragraphSmallAttrs,
													_List_Nil,
													$author$project$T2$Internal$Color$primaryA(context)),
												$lucamug$elm_ui_with_context$Element$WithContext$text('EMPRESA')),
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$column,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Sobre nosotros', R: '/sobre-talenteca'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Términos y condiciones', R: '/terminos-y-condiciones'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Políticas de privacidad', R: '/politica-de-privacidad'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Trabaja con nosotros', R: '/mexico/bolsa-de-trabajo-de-talenteca'})
													]))
											]))
									]))
							])),
						topLinksSection,
						function () {
						if (!topLinksMaybe.$) {
							return $lucamug$elm_ui_with_context$Element$WithContext$none;
						} else {
							return A2(followUsSection, $author$project$T2$Internal$Color$footerDivider, $author$project$T2$Internal$Color$contentSecondary);
						}
					}()
					]));
		});
};
var $mdgriffith$elm_ui$Internal$Flag$fontAlignment = $mdgriffith$elm_ui$Internal$Flag$flag(12);
var $mdgriffith$elm_ui$Element$Font$center = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.kg);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$center = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$center);
var $mdgriffith$elm_ui$Internal$Model$CenterX = 1;
var $mdgriffith$elm_ui$Element$centerX = $mdgriffith$elm_ui$Internal$Model$AlignX(1);
var $lucamug$elm_ui_with_context$Element$WithContext$centerX = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$centerX);
var $author$project$T2$Internal$Color$followUsTitle = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Text$HeadingSmallX = 9;
var $author$project$T2$Text$headingSmallXAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 9, color);
	});
var $author$project$T2$Internal$Link$ContentSecondary = 2;
var $author$project$T2$Link$linkContentSecondarySubtleEnabledSmall = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(3)(0)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(2);
	});
var $author$project$T2$Link$linkSubtleEnabledSmall = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(3)(0)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(0);
	});
var $author$project$T2$Link$linkSubtleEnabledSmallForNewTab = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(3)(0)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtNewTab)(0);
	});
var $mdgriffith$elm_ui$Element$padding = function (x) {
	var f = x;
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$padding,
		A5(
			$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
			'p-' + $elm$core$String$fromInt(x),
			f,
			f,
			f,
			f));
};
var $lucamug$elm_ui_with_context$Element$WithContext$padding = function (x) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
		$mdgriffith$elm_ui$Element$padding(x));
};
var $mdgriffith$elm_ui$Internal$Model$paddingName = F4(
	function (top, right, bottom, left) {
		return 'pad-' + ($elm$core$String$fromInt(top) + ('-' + ($elm$core$String$fromInt(right) + ('-' + ($elm$core$String$fromInt(bottom) + ('-' + $elm$core$String$fromInt(left)))))));
	});
var $mdgriffith$elm_ui$Element$paddingEach = function (_v0) {
	var top = _v0.by;
	var right = _v0.bt;
	var bottom = _v0.bi;
	var left = _v0.br;
	if (_Utils_eq(top, right) && (_Utils_eq(top, bottom) && _Utils_eq(top, left))) {
		var topFloat = top;
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$padding,
			A5(
				$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
				'p-' + $elm$core$String$fromInt(top),
				topFloat,
				topFloat,
				topFloat,
				topFloat));
	} else {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$padding,
			A5(
				$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
				A4($mdgriffith$elm_ui$Internal$Model$paddingName, top, right, bottom, left),
				top,
				right,
				bottom,
				left));
	}
};
var $lucamug$elm_ui_with_context$Element$WithContext$paddingEach = function (paddings) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
		$mdgriffith$elm_ui$Element$paddingEach(paddings));
};
var $author$project$T2$Internal$Text$ParagraphSmallX = 20;
var $author$project$T2$Text$paragraphSmallXAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 20, color);
	});
var $author$project$T2$Internal$Spacing$spacing12 = 12;
var $author$project$T2$Internal$Spacing$spacing32 = 32;
var $author$project$T2$Internal$Spacing$spacing4 = 4;
var $author$project$T2$Internal$Spacing$spacing8 = 8;
var $mdgriffith$elm_ui$Internal$Model$Padding = F5(
	function (a, b, c, d, e) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Internal$Model$Spaced = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$extractSpacingAndPadding = function (attrs) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (attr, _v0) {
				var pad = _v0.a;
				var spacing = _v0.b;
				return _Utils_Tuple2(
					function () {
						if (!pad.$) {
							var x = pad.a;
							return pad;
						} else {
							if ((attr.$ === 4) && (attr.b.$ === 7)) {
								var _v3 = attr.b;
								var name = _v3.a;
								var t = _v3.b;
								var r = _v3.c;
								var b = _v3.d;
								var l = _v3.e;
								return $elm$core$Maybe$Just(
									A5($mdgriffith$elm_ui$Internal$Model$Padding, name, t, r, b, l));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}(),
					function () {
						if (!spacing.$) {
							var x = spacing.a;
							return spacing;
						} else {
							if ((attr.$ === 4) && (attr.b.$ === 5)) {
								var _v6 = attr.b;
								var name = _v6.a;
								var x = _v6.b;
								var y = _v6.c;
								return $elm$core$Maybe$Just(
									A3($mdgriffith$elm_ui$Internal$Model$Spaced, name, x, y));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}());
			}),
		_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
		attrs);
};
var $mdgriffith$elm_ui$Internal$Model$paddingNameFloat = F4(
	function (top, right, bottom, left) {
		return 'pad-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(top) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(right) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(bottom) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(left)))))));
	});
var $mdgriffith$elm_ui$Element$wrappedRow = F2(
	function (attrs, children) {
		var _v0 = $mdgriffith$elm_ui$Internal$Model$extractSpacingAndPadding(attrs);
		var padded = _v0.a;
		var spaced = _v0.b;
		if (spaced.$ === 1) {
			return A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asRow,
				$mdgriffith$elm_ui$Internal$Model$div,
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bG + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.aG + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ds)))),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
							attrs))),
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
		} else {
			var _v2 = spaced.a;
			var spaceName = _v2.a;
			var x = _v2.b;
			var y = _v2.c;
			var newPadding = function () {
				if (!padded.$) {
					var _v5 = padded.a;
					var name = _v5.a;
					var t = _v5.b;
					var r = _v5.c;
					var b = _v5.d;
					var l = _v5.e;
					if ((_Utils_cmp(r, x / 2) > -1) && (_Utils_cmp(b, y / 2) > -1)) {
						var newTop = t - (y / 2);
						var newRight = r - (x / 2);
						var newLeft = l - (x / 2);
						var newBottom = b - (y / 2);
						return $elm$core$Maybe$Just(
							A2(
								$mdgriffith$elm_ui$Internal$Model$StyleClass,
								$mdgriffith$elm_ui$Internal$Flag$padding,
								A5(
									$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
									A4($mdgriffith$elm_ui$Internal$Model$paddingNameFloat, newTop, newRight, newBottom, newLeft),
									newTop,
									newRight,
									newBottom,
									newLeft)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			if (!newPadding.$) {
				var pad = newPadding.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asRow,
					$mdgriffith$elm_ui$Internal$Model$div,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bG + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.aG + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ds)))),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
								_Utils_ap(
									attrs,
									_List_fromArray(
										[pad]))))),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
			} else {
				var halfY = -(y / 2);
				var halfX = -(x / 2);
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					attrs,
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[
								A4(
								$mdgriffith$elm_ui$Internal$Model$element,
								$mdgriffith$elm_ui$Internal$Model$asRow,
								$mdgriffith$elm_ui$Internal$Model$div,
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bG + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.aG + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ds)))),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Internal$Model$Attr(
											A2(
												$elm$html$Html$Attributes$style,
												'margin',
												$elm$core$String$fromFloat(halfY) + ('px' + (' ' + ($elm$core$String$fromFloat(halfX) + 'px'))))),
										A2(
											$elm$core$List$cons,
											$mdgriffith$elm_ui$Internal$Model$Attr(
												A2(
													$elm$html$Html$Attributes$style,
													'width',
													'calc(100% + ' + ($elm$core$String$fromInt(x) + 'px)'))),
											A2(
												$elm$core$List$cons,
												$mdgriffith$elm_ui$Internal$Model$Attr(
													A2(
														$elm$html$Html$Attributes$style,
														'height',
														'calc(100% + ' + ($elm$core$String$fromInt(y) + 'px)'))),
												A2(
													$elm$core$List$cons,
													A2(
														$mdgriffith$elm_ui$Internal$Model$StyleClass,
														$mdgriffith$elm_ui$Internal$Flag$spacing,
														A3($mdgriffith$elm_ui$Internal$Model$SpacingStyle, spaceName, x, y)),
													_List_Nil))))),
								$mdgriffith$elm_ui$Internal$Model$Unkeyed(children))
							])));
			}
		}
	});
var $lucamug$elm_ui_with_context$Element$WithContext$wrappedRow = $lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapContainer($mdgriffith$elm_ui$Element$wrappedRow);
var $author$project$T2$Internal$Footer$renderMobileFooter = F2(
	function (withFollowUs, topLinksMaybe) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var topLinksSection = function () {
					if (!topLinksMaybe.$) {
						var allTopLinks = topLinksMaybe.a;
						var topLinksColumn = F2(
							function (topLinksTitle, topLinks) {
								if ($elm$core$List$isEmpty(topLinks)) {
									return $lucamug$elm_ui_with_context$Element$WithContext$none;
								} else {
									var topLinkEl = function (topLink) {
										return A2(
											(context.cF === 1) ? $author$project$T2$Link$linkContentPrimarySubtleEnabledSmall : $author$project$T2$Link$linkContentInverseSubtleEnabledSmall,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$width(
													$lucamug$elm_ui_with_context$Element$WithContext$px((context.S.dp / 3) | 0)),
													$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
													A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis')),
													$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
													A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')),
													$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
													A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'))
												]),
											{u: topLink.u, R: topLink.R});
									};
									return A2(
										$lucamug$elm_ui_with_context$Element$WithContext$column,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
												$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16),
												$lucamug$elm_ui_with_context$Element$WithContext$alignTop
											]),
										_List_fromArray(
											[
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$el,
												A2(
													$author$project$T2$Text$labelMediumAttrs,
													_List_Nil,
													$author$project$T2$Internal$Color$fgTopLinkTitle(context)),
												$lucamug$elm_ui_with_context$Element$WithContext$text('TOP ' + topLinksTitle)),
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$column,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16)
													]),
												A2($elm$core$List$map, topLinkEl, topLinks))
											]));
								}
							});
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
									$author$project$T2$Internal$Color$bgTopLinks(context)),
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, $author$project$T2$Internal$Spacing$spacing12, $author$project$T2$Internal$Spacing$spacing24),
									$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing32)
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$row,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing12)
										]),
									_List_fromArray(
										[
											A2(topLinksColumn, 'EMPRESAS', allTopLinks.gR.gx),
											A2(topLinksColumn, 'REGIONES', allTopLinks.eQ.gx)
										])),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$row,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing12)
										]),
									_List_fromArray(
										[
											A2(topLinksColumn, 'CIUDADES', allTopLinks.cT.gx),
											A2(topLinksColumn, 'CATEGORÍAS', allTopLinks.cS.gx)
										]))
								]));
					} else {
						return $lucamug$elm_ui_with_context$Element$WithContext$none;
					}
				}();
				var isSmallScreen = !context.bT;
				var followUsSection = F3(
					function (linkTypeInternal, linkType, spacing) {
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(spacing),
									$lucamug$elm_ui_with_context$Element$WithContext$alignLeft,
									$lucamug$elm_ui_with_context$Element$WithContext$centerX
								]),
							_List_fromArray(
								[
									A2(
									linkTypeInternal,
									_List_Nil,
									{u: 'blog', R: 'https://www.talenteca.com/blog'}),
									A2(
									linkType,
									_List_Nil,
									{u: 'linkedIn', R: 'https://www.linkedin.com/company/talenteca/'}),
									A2(
									linkType,
									_List_Nil,
									{u: 'facebook', R: 'https://www.facebook.com/talenteca'}),
									A2(
									linkType,
									_List_Nil,
									{u: 'twitter', R: 'https://x.com/talenteca'})
								]));
					});
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$shrink)
						]),
					_List_fromArray(
						[
							withFollowUs ? A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$padding($author$project$T2$Internal$Spacing$spacing16),
									$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing24)
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_Utils_ap(
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
												$lucamug$elm_ui_with_context$Element$WithContext$Font$center
											]),
										A2(
											$author$project$T2$Text$headingSmallXAttrs,
											_List_Nil,
											$author$project$T2$Internal$Color$followUsTitle(context))),
									$lucamug$elm_ui_with_context$Element$WithContext$text('Síguenos')),
									A3(followUsSection, $author$project$T2$Link$linkSubtleEnabledMedium, $author$project$T2$Link$linkSubtleEnabledMediumForNewTab, $author$project$T2$Internal$Spacing$spacing24)
								])) : $lucamug$elm_ui_with_context$Element$WithContext$none,
							topLinksSection,
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
									{
										bi: isSmallScreen ? $author$project$T2$Internal$Spacing$spacing16 : $author$project$T2$Internal$Spacing$spacing32,
										br: $author$project$T2$Internal$Spacing$spacing16,
										bt: $author$project$T2$Internal$Spacing$spacing16,
										by: $author$project$T2$Internal$Spacing$spacing16
									}),
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(
									isSmallScreen ? $author$project$T2$Internal$Spacing$spacing4 : ($author$project$T2$Internal$Spacing$spacing4 + 2))
								]),
							_List_fromArray(
								[
									withFollowUs ? $lucamug$elm_ui_with_context$Element$WithContext$none : (isSmallScreen ? A3(followUsSection, $author$project$T2$Link$linkSubtleEnabledSmall, $author$project$T2$Link$linkSubtleEnabledSmallForNewTab, $author$project$T2$Internal$Spacing$spacing12) : A3(followUsSection, $author$project$T2$Link$linkSubtleEnabledMedium, $author$project$T2$Link$linkSubtleEnabledMediumForNewTab, $author$project$T2$Internal$Spacing$spacing12)),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$wrappedRow,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
											$lucamug$elm_ui_with_context$Element$WithContext$centerX,
											$lucamug$elm_ui_with_context$Element$WithContext$spacing(
											isSmallScreen ? $author$project$T2$Internal$Spacing$spacing4 : $author$project$T2$Internal$Spacing$spacing8)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$T2$Link$linkContentSecondarySubtleEnabledSmall,
											_List_Nil,
											{u: 'Sobre nosotros', R: '/sobre-talenteca'}),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											A2(
												$author$project$T2$Text$paragraphSmallAttrs,
												_List_Nil,
												$author$project$T2$Internal$Color$contentSecondary(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$text(' · ')),
											A2(
											$author$project$T2$Link$linkContentSecondarySubtleEnabledSmall,
											_List_Nil,
											{u: 'Privacidad', R: '/politica-de-privacidad'}),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											A2(
												$author$project$T2$Text$paragraphSmallAttrs,
												_List_Nil,
												$author$project$T2$Internal$Color$contentSecondary(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$text(' · ')),
											A2(
											$author$project$T2$Link$linkContentSecondarySubtleEnabledSmall,
											_List_Nil,
											{u: 'Condiciones', R: '/terminos-y-condiciones'})
										])),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									isSmallScreen ? _Utils_ap(
										A2(
											$author$project$T2$Text$paragraphSmallXAttrs,
											_List_Nil,
											$author$project$T2$Internal$Color$contentSecondary(context)),
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
												$lucamug$elm_ui_with_context$Element$WithContext$centerX
											])) : _Utils_ap(
										A2(
											$author$project$T2$Text$paragraphSmallAttrs,
											_List_Nil,
											$author$project$T2$Internal$Color$contentSecondary(context)),
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
												$lucamug$elm_ui_with_context$Element$WithContext$centerX
											])),
									$lucamug$elm_ui_with_context$Element$WithContext$text('© 2026 un servicio de Listatree S.A.'))
								]))
						]));
			});
	});
var $author$project$T2$Internal$Text$ParagraphSmallBold = 25;
var $author$project$T2$Text$paragraphSmallBoldAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 25, color);
	});
var $mdgriffith$elm_ui$Element$spacingXY = F2(
	function (x, y) {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$spacing,
			A3(
				$mdgriffith$elm_ui$Internal$Model$SpacingStyle,
				A2($mdgriffith$elm_ui$Internal$Model$spacingName, x, y),
				x,
				y));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$spacingXY = F2(
	function (x, y) {
		return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
			A2($mdgriffith$elm_ui$Element$spacingXY, x, y));
	});
var $author$project$T2$Internal$Footer$renderTabletFooter = function (topLinksMaybe) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			var topLinksSection = function () {
				if (!topLinksMaybe.$) {
					var allTopLinks = topLinksMaybe.a;
					var topLinksColumn = F2(
						function (topLinksTitle, topLinks) {
							if ($elm$core$List$isEmpty(topLinks)) {
								return $lucamug$elm_ui_with_context$Element$WithContext$none;
							} else {
								var topLinkEl = function (topLink) {
									return A2(
										(context.cF === 1) ? $author$project$T2$Link$linkContentPrimarySubtleEnabledSmall : $author$project$T2$Link$linkContentInverseSubtleEnabledSmall,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width(
												A2($lucamug$elm_ui_with_context$Element$WithContext$maximum, 150, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis')),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'))
											]),
										{u: topLink.u, R: topLink.R});
								};
								return A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16),
											$lucamug$elm_ui_with_context$Element$WithContext$alignTop
										]),
									_List_fromArray(
										[
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											A2(
												$author$project$T2$Text$labelMediumAttrs,
												_List_Nil,
												$author$project$T2$Internal$Color$fgTopLinkTitle(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$text('TOP ' + topLinksTitle)),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$column,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16)
												]),
											A2($elm$core$List$map, topLinkEl, topLinks))
										]));
							}
						});
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								$author$project$T2$Internal$Color$bgTopLinks(context)),
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, $author$project$T2$Internal$Spacing$spacing64, $author$project$T2$Internal$Spacing$spacing36)
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$row,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
										$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
										$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing48)
									]),
								_List_fromArray(
									[
										A2(topLinksColumn, 'EMPRESAS', allTopLinks.gR.gx),
										A2(topLinksColumn, 'REGIONES', allTopLinks.eQ.gx),
										A2(topLinksColumn, 'CIUDADES', allTopLinks.cT.gx),
										A2(topLinksColumn, 'CATEGORÍAS', allTopLinks.cS.gx)
									]))
							]));
				} else {
					return $lucamug$elm_ui_with_context$Element$WithContext$none;
				}
			}();
			var followUsSection = F2(
				function (dividerColor, trademarkColor) {
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, $author$project$T2$Internal$Spacing$spacing64, $author$project$T2$Internal$Spacing$spacing36),
								$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing36)
							]),
						_List_fromArray(
							[
								$author$project$T2$Divider$divider1(
								dividerColor(context)),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$row,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing24)
									]),
								_List_fromArray(
									[
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$row,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
												$lucamug$elm_ui_with_context$Element$WithContext$spacing(24),
												$lucamug$elm_ui_with_context$Element$WithContext$alignLeft
											]),
										_List_fromArray(
											[
												A2(
												$author$project$T2$Link$linkSubtleEnabledMedium,
												_List_Nil,
												{u: 'Blog', R: 'https://www.talenteca.com/blog'}),
												A2(
												$author$project$T2$Link$linkSubtleEnabledMediumForNewTab,
												_List_Nil,
												{u: 'LinkedIn', R: 'https://www.linkedin.com/company/talenteca/'}),
												A2(
												$author$project$T2$Link$linkSubtleEnabledMediumForNewTab,
												_List_Nil,
												{u: 'Facebook', R: 'https://www.facebook.com/talenteca'}),
												A2(
												$author$project$T2$Link$linkSubtleEnabledMediumForNewTab,
												_List_Nil,
												{u: 'Twitter', R: 'https://x.com/talenteca'})
											])),
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_Utils_ap(
											A2(
												$author$project$T2$Text$paragraphSmallAttrs,
												_List_Nil,
												trademarkColor(context)),
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
													$lucamug$elm_ui_with_context$Element$WithContext$alignRight
												])),
										$lucamug$elm_ui_with_context$Element$WithContext$text('© 2026 un servicio de Listatree S.A.'))
									]))
							]));
				});
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$shrink)
					]),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$padding($author$project$T2$Internal$Spacing$spacing36),
								A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 0, $author$project$T2$Internal$Spacing$spacing48),
								$lucamug$elm_ui_with_context$Element$WithContext$centerX
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$link,
								_List_fromArray(
									[
										(context.S.dp > 820) ? $lucamug$elm_ui_with_context$Element$WithContext$centerX : $lucamug$elm_ui_with_context$Element$WithContext$alignLeft
									]),
								{
									u: $author$project$T2$Logo$talentecaLogoHorizontalNormal(
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width(
												A2(
													$lucamug$elm_ui_with_context$Element$WithContext$maximum,
													258,
													A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 258, $lucamug$elm_ui_with_context$Element$WithContext$fill)))
											])),
									R: '/'
								}),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$wrappedRow,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
										$lucamug$elm_ui_with_context$Element$WithContext$centerX,
										$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing64)
									]),
								_List_fromArray(
									[
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$column,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16),
												$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
											]),
										_List_fromArray(
											[
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$el,
												A2(
													$author$project$T2$Text$paragraphSmallBoldAttrs,
													_List_Nil,
													$author$project$T2$Internal$Color$primaryA(context)),
												$lucamug$elm_ui_with_context$Element$WithContext$text('BUSCO EMPLEO')),
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$column,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Buscar empleo', R: '/empleos'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Subir tu hoja de vida', R: '/postular?j_id=000000000000000000000000'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Acceder como candidato', R: '/acceder-como-candidato'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Soporte', R: '/preguntas-frecuentes?section=candidatos'})
													]))
											])),
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$column,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16),
												$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
											]),
										_List_fromArray(
											[
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$el,
												A2(
													$author$project$T2$Text$paragraphSmallBoldAttrs,
													_List_Nil,
													$author$project$T2$Internal$Color$primaryA(context)),
												$lucamug$elm_ui_with_context$Element$WithContext$text('BUSCO PERSONAL')),
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$column,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Buscar candidatos', R: '/base-de-candidatos'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Publicar nuevo empleo', R: '/reclutador/publicar'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Precios', R: '/precios'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Acceder como reclutador', R: '/acceder-como-reclutador'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Soporte', R: '/preguntas-frecuentes?section=reclutadores'})
													]))
											])),
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$column,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16),
												$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
											]),
										_List_fromArray(
											[
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$el,
												A2(
													$author$project$T2$Text$paragraphSmallBoldAttrs,
													_List_Nil,
													$author$project$T2$Internal$Color$primaryA(context)),
												$lucamug$elm_ui_with_context$Element$WithContext$text('EMPRESA')),
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$column,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Sobre nosotros', R: '/sobre-talenteca'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Términos y condiciones', R: '/terminos-y-condiciones'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Políticas de privacidad', R: '/politica-de-privacidad'}),
														A2(
														$author$project$T2$Link$linkContentPrimarySubtleEnabledSmall,
														_List_Nil,
														{u: 'Trabaja con nosotros', R: '/mexico/bolsa-de-trabajo-de-talenteca'})
													]))
											]))
									]))
							])),
						topLinksSection,
						function () {
						if (!topLinksMaybe.$) {
							return $lucamug$elm_ui_with_context$Element$WithContext$none;
						} else {
							return A2(followUsSection, $author$project$T2$Internal$Color$footerDivider, $author$project$T2$Internal$Color$contentSecondary);
						}
					}()
					]));
		});
};
var $author$project$T2$Footer$footerWithoutTopLinksAndWithFollowUs = $lucamug$elm_ui_with_context$Element$WithContext$withContext(
	function (context) {
		var _v0 = context.bT;
		switch (_v0) {
			case 0:
				return A2($author$project$T2$Internal$Footer$renderMobileFooter, true, $elm$core$Maybe$Nothing);
			case 1:
				return $author$project$T2$Internal$Footer$renderTabletFooter($elm$core$Maybe$Nothing);
			case 2:
				return $author$project$T2$Internal$Footer$renderDesktopFooter($elm$core$Maybe$Nothing);
			default:
				return $author$project$T2$Internal$Footer$renderDesktopFooter($elm$core$Maybe$Nothing);
		}
	});
var $lucamug$elm_ui_with_context$Element$WithContext$createNearby = F2(
	function (toAttr, _v0) {
		var f = _v0;
		return A2($elm$core$Basics$composeR, f, toAttr);
	});
var $mdgriffith$elm_ui$Internal$Model$InFront = 4;
var $mdgriffith$elm_ui$Internal$Model$Nearby = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$createNearby = F2(
	function (loc, element) {
		if (element.$ === 3) {
			return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
		} else {
			return A2($mdgriffith$elm_ui$Internal$Model$Nearby, loc, element);
		}
	});
var $mdgriffith$elm_ui$Element$inFront = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 4, element);
};
var $lucamug$elm_ui_with_context$Element$WithContext$inFront = $lucamug$elm_ui_with_context$Element$WithContext$createNearby($mdgriffith$elm_ui$Element$inFront);
var $author$project$T2$Internal$Drawer$Candidate = function (a) {
	return {$: 1, a: a};
};
var $author$project$T2$Internal$Drawer$Recruiter = function (a) {
	return {$: 0, a: a};
};
var $author$project$T2$Internal$Drawer$Visitor = {$: 2};
var $author$project$T2$Internal$Link$OnClick = function (a) {
	return {$: 2, a: a};
};
var $author$project$T2$Link$actionLinkContentSecondarySubtleEnabledMediumWithLeftIcon = F4(
	function (attrs, icon, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(2)(0)(
			$elm$core$Maybe$Just(icon))(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(2);
	});
var $author$project$T2$Internal$Color$bgDrawer = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Elevation$Elevation1 = 0;
var $author$project$T2$Internal$Elevation$renderElevation = function (elevation) {
	var shadow = function () {
		switch (elevation) {
			case 0:
				return '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)';
			case 1:
				return '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)';
			case 2:
				return '0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)';
			case 3:
				return '0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)';
			default:
				return '0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)';
		}
	}();
	return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
		A2($elm$html$Html$Attributes$style, 'box-shadow', shadow));
};
var $author$project$T2$Elevation$elevation1 = $author$project$T2$Internal$Elevation$renderElevation(0);
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $noahzgordon$elm_color_extra$Color$Convert$toRadix = function (n) {
	var getChr = function (c) {
		return (c < 10) ? $elm$core$String$fromInt(c) : $elm$core$String$fromChar(
			$elm$core$Char$fromCode(87 + c));
	};
	return (n < 16) ? getChr(n) : _Utils_ap(
		$noahzgordon$elm_color_extra$Color$Convert$toRadix((n / 16) | 0),
		getChr(
			A2($elm$core$Basics$modBy, 16, n)));
};
var $noahzgordon$elm_color_extra$Color$Convert$toHex = A2(
	$elm$core$Basics$composeR,
	$noahzgordon$elm_color_extra$Color$Convert$toRadix,
	A2($elm$core$String$padLeft, 2, '0'));
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {cL: a, cP: b, c2: g, dg: r};
};
var $noahzgordon$elm_color_extra$Color$Convert$colorToHex = function (cl) {
	var _v0 = $avh4$elm_color$Color$toRgba(cl);
	var red = _v0.dg;
	var green = _v0.c2;
	var blue = _v0.cP;
	return A2(
		$elm$core$String$join,
		'',
		A2(
			$elm$core$List$cons,
			'#',
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $elm$core$Basics$round, $noahzgordon$elm_color_extra$Color$Convert$toHex),
				_List_fromArray(
					[red * 255, green * 255, blue * 255]))));
};
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$rgba = F4(
	function (r, g, b, a) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, a);
	});
var $mdgriffith$elm_ui$Element$toRgb = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {cL: a, cP: b, c2: g, dg: r};
};
var $author$project$T2$Internal$Color$Extra$toColor = function (elementColor) {
	var cl = $mdgriffith$elm_ui$Element$toRgb(elementColor);
	return A4($avh4$elm_color$Color$rgba, cl.dg, cl.c2, cl.cP, cl.cL);
};
var $author$project$T2$Internal$Color$Extra$colorToHex = function (elementColor) {
	var cl = $author$project$T2$Internal$Color$Extra$toColor(elementColor);
	return $noahzgordon$elm_color_extra$Color$Convert$colorToHex(cl);
};
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $author$project$T2$Internal$Icon$pixelsForSize = function (size) {
	switch (size) {
		case 0:
			return 14;
		case 1:
			return 18;
		case 3:
			return 20;
		case 2:
			return 24;
		case 4:
			return 28;
		case 6:
			return 32;
		case 5:
			return 36;
		case 7:
			return 40;
		case 8:
			return 44;
		case 9:
			return 64;
		case 10:
			return 96;
		default:
			return 120;
	}
};
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $elm$svg$Svg$title = $elm$svg$Svg$trustedNode('title');
var $elm$svg$Svg$use = $elm$svg$Svg$trustedNode('use');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$T2$Internal$Icon$internalRenderIconSvg = F4(
	function (size, title, svgAttributes, iconId) {
		var svgTitle = A2(
			$elm$svg$Svg$title,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$text(title)
				]));
		var svgPaths = _List_fromArray(
			[
				A2(
				$elm$svg$Svg$use,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'href', iconId)
					]),
				_List_Nil)
			]);
		var svgRoot = A2($elm$core$List$cons, svgTitle, svgPaths);
		var fontSize = $author$project$T2$Internal$Icon$pixelsForSize(size);
		var svgSize = $elm$core$String$fromInt(fontSize) + 'px';
		var renderSvgAttributes = _Utils_ap(
			svgAttributes,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
					$elm$svg$Svg$Attributes$height(svgSize),
					$elm$svg$Svg$Attributes$width(svgSize),
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$fill('none')
				]));
		var svgAsHtml = A2($elm$svg$Svg$svg, renderSvgAttributes, svgRoot);
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(fontSize),
					$lucamug$elm_ui_with_context$Element$WithContext$centerX,
					$lucamug$elm_ui_with_context$Element$WithContext$centerY
				]),
			$lucamug$elm_ui_with_context$Element$WithContext$html(svgAsHtml));
	});
var $author$project$T2$Internal$Icon$internalExit = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#exit');
	});
var $author$project$T2$Icon$exitIconContentSecondaryOutlinedEnabledMedium = function (altLabel) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			return A4(
				$author$project$T2$Internal$Icon$internalExit,
				2,
				$author$project$T2$Internal$Color$contentSecondary(context),
				$elm$core$Maybe$Nothing,
				altLabel);
		});
};
var $author$project$T2$Link$linkContentSecondarySubtleEnabledMedium = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(2)(0)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(2);
	});
var $author$project$T2$Internal$Icon$internalMoon = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#darkmode');
	});
var $author$project$T2$Icon$moon = $author$project$T2$Internal$Icon$internalMoon;
var $lucamug$elm_ui_with_context$Element$WithContext$attr = function (elem) {
	return function (_v0) {
		return elem;
	};
};
var $mdgriffith$elm_ui$Internal$Model$MoveY = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$TransformComponent = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$moveY = $mdgriffith$elm_ui$Internal$Flag$flag(26);
var $mdgriffith$elm_ui$Element$moveUp = function (y) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveY,
		$mdgriffith$elm_ui$Internal$Model$MoveY(-y));
};
var $lucamug$elm_ui_with_context$Element$WithContext$moveUp = function (y) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attr(
		$mdgriffith$elm_ui$Element$moveUp(y));
};
var $mdgriffith$elm_ui$Internal$Model$Navigation = {$: 1};
var $mdgriffith$elm_ui$Element$Region$navigation = $mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Navigation);
var $lucamug$elm_ui_with_context$Element$WithContext$Region$navigation = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Region$navigation);
var $lucamug$elm_ui_with_context$Element$WithContext$Events$onClick = function (msg) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Events$onClick(msg));
};
var $elm$core$String$append = _String_append;
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $elm_community$string_extra$String$Extra$softBreakRegexp = function (width) {
	return $elm_community$string_extra$String$Extra$regexFromString(
		'.{1,' + ($elm$core$String$fromInt(width) + '}(\\s+|$)|\\S+?(\\s+|$)'));
};
var $elm_community$string_extra$String$Extra$softEllipsis = F2(
	function (howLong, string) {
		return (_Utils_cmp(
			$elm$core$String$length(string),
			howLong) < 1) ? string : function (a) {
			return A2($elm$core$String$append, a, '...');
		}(
			A3(
				$elm$regex$Regex$replace,
				$elm_community$string_extra$String$Extra$regexFromString('([\\.,;:\\s])+$'),
				$elm$core$Basics$always(''),
				A2(
					$elm$core$String$join,
					'',
					A2(
						$elm$core$List$map,
						function ($) {
							return $.iB;
						},
						A3(
							$elm$regex$Regex$findAtMost,
							1,
							$elm_community$string_extra$String$Extra$softBreakRegexp(howLong),
							string)))));
	});
var $author$project$T2$Util$stringFromBool = function (value) {
	return value ? 'True' : 'False';
};
var $author$project$T2$Internal$Icon$internalSun = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#lightmode');
	});
var $author$project$T2$Icon$sun = $author$project$T2$Internal$Icon$internalSun;
var $author$project$T2$Internal$Drawer$renderNavigationDrawer = F6(
	function (urlPath, internalUserInfo, windowSize, internalModel, msgCloseNavigationDrawer, msgToggleTheme) {
		var viewNavigationDrawer = function (menuContent) {
			return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
				function (context) {
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$column,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width(
										$lucamug$elm_ui_with_context$Element$WithContext$px(((windowSize.dp / 3) | 0) * 2)),
										$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
										$author$project$T2$Internal$Color$bgDrawer(context)),
										$author$project$T2$Elevation$elevation1,
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$style, 'position', 'fixed')),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('tt-drawer')),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2(
											$elm$html$Html$Attributes$attribute,
											'data-expanded',
											$elm$core$String$toLower(
												$author$project$T2$Util$stringFromBool(internalModel.di)))),
										A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 24),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$style, 'height', '100%')),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$style, 'z-index', '299'))
									]),
								_List_fromArray(
									[menuContent])),
								internalModel.di ? A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
										$author$project$T2$Internal$Color$bgOverlayDark(context)),
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(msgCloseNavigationDrawer),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$style, 'position', 'fixed')),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$style, 'z-index', '199')),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$style, 'height', '100%'))
									]),
								$lucamug$elm_ui_with_context$Element$WithContext$none) : $lucamug$elm_ui_with_context$Element$WithContext$none
							]));
				});
		};
		return internalModel.di ? $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var themeChangerMenuItem = function () {
					var _v3 = context.cF;
					if (!_v3) {
						return A4($author$project$T2$Link$actionLinkContentSecondarySubtleEnabledMediumWithLeftIcon, _List_Nil, $author$project$T2$Icon$moon, 'Cambiar a modo oscuro', msgToggleTheme);
					} else {
						return A4($author$project$T2$Link$actionLinkContentSecondarySubtleEnabledMediumWithLeftIcon, _List_Nil, $author$project$T2$Icon$sun, 'Cambiar a modo claro', msgToggleTheme);
					}
				}();
				var drawerMenuItem = F2(
					function (label, url) {
						var linkEl = (_Utils_eq(urlPath, url) || (((url === '/candidato/home') && (urlPath === '/candidato')) || (((url === '/empleos') && A2($elm$core$String$startsWith, '/empleos-', urlPath)) || (((url === '/reclutador/publicar') && A2($elm$core$String$startsWith, '/reclutador/publicar/', urlPath)) || (((url === '/reclutador/tus-anuncios') && A2($elm$core$String$startsWith, '/admin/tus-candidatos', urlPath)) || (((url === '/admin-console/') && A2($elm$core$String$startsWith, '/admin-console/', urlPath)) || (((url === '/preguntas-frecuentes?section=reclutadores') && A2($elm$core$String$startsWith, '/preguntas-frecuentes', urlPath)) || ((url === '/preguntas-frecuentes?section=candidatos') && A2($elm$core$String$startsWith, '/preguntas-frecuentes', urlPath))))))))) ? $author$project$T2$Link$linkSubtleEnabledMedium : $author$project$T2$Link$linkContentSecondarySubtleEnabledMedium;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$height(
									$lucamug$elm_ui_with_context$Element$WithContext$px(40))
								]),
							A2(
								linkEl,
								_List_Nil,
								{u: label, R: url}));
					});
				switch (internalUserInfo.$) {
					case 0:
						var recruiterLoggedInInfo = internalUserInfo.a;
						var fullnameLabel = function () {
							var _v1 = recruiterLoggedInInfo.c1;
							if (!_v1.$) {
								var fullname = _v1.a;
								return 'HOLA ' + A2(
									$elm_community$string_extra$String$Extra$softEllipsis,
									14,
									$elm$core$String$toUpper(fullname));
							} else {
								return 'HOLA';
							}
						}();
						var menuContent = A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8),
									$lucamug$elm_ui_with_context$Element$WithContext$Region$navigation
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_Utils_ap(
										A2(
											$author$project$T2$Text$headingSmallXAttrs,
											_List_Nil,
											$author$project$T2$Internal$Color$contentSecondary(context)),
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
												{bi: 12, br: 0, bt: 0, by: 0})
											])),
									$lucamug$elm_ui_with_context$Element$WithContext$text(fullnameLabel)),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									_List_fromArray(
										[
											A2(drawerMenuItem, 'Buscar empleos', '/empleos'),
											A2(drawerMenuItem, 'Publicar empleo', '/reclutador/publicar'),
											A2(drawerMenuItem, 'Panel', '/reclutador'),
											A2(drawerMenuItem, 'Vacantes', '/reclutador/tus-anuncios'),
											A2(drawerMenuItem, 'Plantillas de vacantes', '/reclutador/tus-plantillas'),
											A2(drawerMenuItem, 'Base de candidatos', '/base-de-candidatos'),
											recruiterLoggedInInfo.hY ? A2(drawerMenuItem, 'Administración', '/admin-console/') : $lucamug$elm_ui_with_context$Element$WithContext$none,
											recruiterLoggedInInfo.h_ ? A2(drawerMenuItem, 'Consola corporativa', '/reclutador/consola-corporativa') : $lucamug$elm_ui_with_context$Element$WithContext$none
										])),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
											$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
											{bi: $author$project$T2$Internal$Spacing$spacing24, br: 0, bt: 0, by: 0})
										]),
									_List_fromArray(
										[
											A2(drawerMenuItem, 'Precios', '/precios'),
											A2(drawerMenuItem, 'Soporte', '/preguntas-frecuentes?section=reclutadores')
										])),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$alignBottom
										]),
									themeChangerMenuItem)
								]));
						return viewNavigationDrawer(menuContent);
					case 1:
						var possibleFullname = internalUserInfo.a;
						var fullnameLabel = function () {
							if (!possibleFullname.$) {
								var fullname = possibleFullname.a;
								return 'HOLA ' + A2(
									$elm_community$string_extra$String$Extra$softEllipsis,
									14,
									$elm$core$String$toUpper(fullname));
							} else {
								return 'HOLA';
							}
						}();
						var menuContent = A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8),
									$lucamug$elm_ui_with_context$Element$WithContext$Region$navigation
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_Utils_ap(
										A2(
											$author$project$T2$Text$headingSmallXAttrs,
											_List_Nil,
											$author$project$T2$Internal$Color$contentSecondary(context)),
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
												{bi: 12, br: 0, bt: 0, by: 0})
											])),
									$lucamug$elm_ui_with_context$Element$WithContext$text(fullnameLabel)),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									_List_fromArray(
										[
											A2(drawerMenuItem, 'Buscar empleos', '/empleos'),
											A2(drawerMenuItem, 'Panel', '/candidato/home'),
											A2(drawerMenuItem, 'Hoja de vida', '/candidato/mi-hoja-de-vida'),
											A2(drawerMenuItem, 'Postulaciones', '/candidato/tus-postulaciones'),
											A2(drawerMenuItem, 'Empleos favoritos', '/candidato/tus-empleos-guardados'),
											A2(drawerMenuItem, 'Alertas de empleos', '/candidato/tus-alertas')
										])),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
											$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
											{bi: $author$project$T2$Internal$Spacing$spacing24, br: 0, bt: 0, by: 0})
										]),
									_List_fromArray(
										[
											A2(drawerMenuItem, 'Soporte', '/preguntas-frecuentes?section=candidatos')
										])),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$alignBottom
										]),
									themeChangerMenuItem)
								]));
						return viewNavigationDrawer(menuContent);
					default:
						var menuContent = A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(24)
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									_List_fromArray(
										[
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$row,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
													$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
													{bi: 12, br: 0, bt: 0, by: 0})
												]),
											_List_fromArray(
												[
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$el,
													A2(
														$author$project$T2$Text$headingSmallXAttrs,
														_List_Nil,
														$author$project$T2$Internal$Color$contentSecondary(context)),
													$lucamug$elm_ui_with_context$Element$WithContext$text('BUSCO EMPLEO')),
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$el,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
															$lucamug$elm_ui_with_context$Element$WithContext$moveUp(12),
															$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(msgCloseNavigationDrawer)
														]),
													$author$project$T2$Icon$exitIconContentSecondaryOutlinedEnabledMedium('cerrar'))
												])),
											A2(drawerMenuItem, 'Buscar empleos', '/empleos'),
											A2(drawerMenuItem, 'Subir tu hoja de vida - CV', '/postular?j_id=000000000000000000000000'),
											A2(drawerMenuItem, 'Acceder', '/acceder'),
											A2(drawerMenuItem, 'Soporte candidatos', '/preguntas-frecuentes?section=candidatos')
										])),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									_List_fromArray(
										[
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											A2(
												$author$project$T2$Text$headingSmallXAttrs,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
														{bi: 12, br: 0, bt: 0, by: 0})
													]),
												$author$project$T2$Internal$Color$contentSecondary(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$text('BUSCO PERSONAL')),
											A2(drawerMenuItem, 'Publicar empleo', '/reclutador/publicar'),
											A2(drawerMenuItem, 'Acceder', '/acceder'),
											A2(drawerMenuItem, 'Precios', '/precios'),
											A2(drawerMenuItem, 'Soporte reclutadores', '/preguntas-frecuentes?section=reclutadores')
										])),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									_List_fromArray(
										[
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
													$lucamug$elm_ui_with_context$Element$WithContext$alignBottom
												]),
											themeChangerMenuItem)
										]))
								]));
						return viewNavigationDrawer(menuContent);
				}
			}) : $lucamug$elm_ui_with_context$Element$WithContext$none;
	});
var $author$project$T2$Drawer$navigationDrawer = F4(
	function (config, internalModel, msgCloseNavigationDrawer, msgToggleTheme) {
		var internalUserInfo = config.bR.js ? $author$project$T2$Internal$Drawer$Recruiter(
			{c1: config.bR.jv, hY: config.bR.jq, h_: config.bR.jr}) : (config.cR.dF ? $author$project$T2$Internal$Drawer$Candidate(config.cR.gk) : $author$project$T2$Internal$Drawer$Visitor);
		return A6($author$project$T2$Internal$Drawer$renderNavigationDrawer, config.fl, internalUserInfo, config.S, internalModel, msgCloseNavigationDrawer, msgToggleTheme);
	});
var $author$project$T2$Internal$TopBar$Candidate = function (a) {
	return {$: 1, a: a};
};
var $author$project$T2$Internal$TopBar$InternalLoggedUserInfo = F4(
	function (fullname, email, profilePictureUrl, closeSessionUrl) {
		return {gw: closeSessionUrl, cl: email, c1: fullname, eM: profilePictureUrl};
	});
var $author$project$T2$Internal$TopBar$Recruiter = function (a) {
	return {$: 0, a: a};
};
var $author$project$T2$Internal$TopBar$Visitor = {$: 2};
var $author$project$T2$Internal$Avatar$Enabled = 0;
var $author$project$T2$Internal$Avatar$Image = function (a) {
	return {$: 2, a: a};
};
var $author$project$T2$Internal$Avatar$Medium = 1;
var $author$project$T2$Internal$Avatar$Disabled = 1;
var $author$project$T2$Internal$Icon$Large32 = 6;
var $author$project$T2$Internal$Avatar$Small = 0;
var $mdgriffith$elm_ui$Internal$Model$Transparency = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$transparency = $mdgriffith$elm_ui$Internal$Flag$flag(0);
var $mdgriffith$elm_ui$Element$alpha = function (o) {
	var transparency = function (x) {
		return 1 - x;
	}(
		A2(
			$elm$core$Basics$min,
			1.0,
			A2($elm$core$Basics$max, 0.0, o)));
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2(
			$mdgriffith$elm_ui$Internal$Model$Transparency,
			'transparency-' + $mdgriffith$elm_ui$Internal$Model$floatClass(transparency),
			transparency));
};
var $lucamug$elm_ui_with_context$Element$WithContext$alpha = function (o) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attr(
		$mdgriffith$elm_ui$Element$alpha(o));
};
var $author$project$T2$Internal$Color$Swatch$gray90 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 240, 239, 239);
var $author$project$T2$Internal$Color$bgAvatarPrimaryDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	}
};
var $author$project$T2$Internal$Color$bgAvatarPrimaryEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$bgAvatarSecondaryDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	}
};
var $author$project$T2$Internal$Color$bgAvatarSecondaryEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $mdgriffith$elm_ui$Internal$Flag$overflow = $mdgriffith$elm_ui$Internal$Flag$flag(20);
var $mdgriffith$elm_ui$Element$clip = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.gt);
var $lucamug$elm_ui_with_context$Element$WithContext$clip = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$clip);
var $author$project$T2$Internal$Color$Swatch$gray00 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 0, 0);
var $author$project$T2$Internal$Color$fgAvatarPrimaryDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray00;
	}
};
var $author$project$T2$Internal$Color$fgAvatarPrimaryEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$fgAvatarSecondaryDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgAvatarSecondaryEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Text$HeadingSmall = 8;
var $author$project$T2$Text$headingSmallAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 8, color);
	});
var $author$project$T2$Internal$Text$HeadingSmallXX = 10;
var $author$project$T2$Text$headingSmallXXAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 10, color);
	});
var $mdgriffith$elm_ui$Element$Background$image = function (src) {
	return $mdgriffith$elm_ui$Internal$Model$Attr(
		A2($elm$virtual_dom$VirtualDom$style, 'background', 'url(\"' + (src + '\") center / cover no-repeat')));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Background$image = function (src) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Background$image(src));
};
var $mdgriffith$elm_ui$Internal$Flag$borderRound = $mdgriffith$elm_ui$Internal$Flag$flag(17);
var $mdgriffith$elm_ui$Element$Border$rounded = function (radius) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderRound,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			'br-' + $elm$core$String$fromInt(radius),
			'border-radius',
			$elm$core$String$fromInt(radius) + 'px'));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded = function (radius) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Border$rounded(radius));
};
var $author$project$T2$Internal$Avatar$renderAvatar = F6(
	function (attrs, size, appearance, state, iconMaybe, fullLabel) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var iconSize = function () {
					switch (size) {
						case 0:
							return 0;
						case 1:
							return 3;
						case 2:
							return 4;
						default:
							return 6;
					}
				}();
				var cleanedFullLabel = $elm$core$String$trim(fullLabel);
				var fullLabelAsList = A2($elm$core$String$split, ' ', cleanedFullLabel);
				var label = function () {
					if (!size) {
						return A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$elm$core$String$left(1),
								$elm$core$List$head(fullLabelAsList)));
					} else {
						if (!fullLabelAsList.b) {
							return '';
						} else {
							var head = fullLabelAsList.a;
							var xs = fullLabelAsList.b;
							return _Utils_ap(
								A2($elm$core$String$left, 1, head),
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$elm$core$String$left(1),
										$elm$core$List$head(xs))));
						}
					}
				}();
				var avatarSize = function () {
					switch (size) {
						case 0:
							return 24;
						case 1:
							return 32;
						case 2:
							return 40;
						default:
							return 48;
					}
				}();
				var _v0 = function () {
					switch (appearance.$) {
						case 0:
							if (!state) {
								return _Utils_Tuple2($author$project$T2$Internal$Color$fgAvatarPrimaryEnabled, $author$project$T2$Internal$Color$bgAvatarPrimaryEnabled);
							} else {
								return _Utils_Tuple2($author$project$T2$Internal$Color$fgAvatarPrimaryDisabled, $author$project$T2$Internal$Color$bgAvatarPrimaryDisabled);
							}
						case 1:
							if (!state) {
								return _Utils_Tuple2($author$project$T2$Internal$Color$fgAvatarSecondaryEnabled, $author$project$T2$Internal$Color$bgAvatarSecondaryEnabled);
							} else {
								return _Utils_Tuple2($author$project$T2$Internal$Color$fgAvatarSecondaryDisabled, $author$project$T2$Internal$Color$bgAvatarSecondaryDisabled);
							}
						default:
							return _Utils_Tuple2($author$project$T2$Internal$Color$fgAvatarSecondaryEnabled, $author$project$T2$Internal$Color$bgAvatarSecondaryEnabled);
					}
				}();
				var fgColor = _v0.a;
				var bgColor = _v0.b;
				var labelAttrs = A2(
					function () {
						switch (size) {
							case 0:
								return $author$project$T2$Text$headingSmallXXAttrs;
							case 1:
								return $author$project$T2$Text$headingSmallXXAttrs;
							case 2:
								return $author$project$T2$Text$headingSmallXAttrs;
							default:
								return $author$project$T2$Text$headingSmallAttrs;
						}
					}(),
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
							{bi: 0, br: 0, bt: 0, by: 2})
						]),
					fgColor(context));
				var innerElement = function () {
					var textEl = A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_Utils_ap(
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$centerY]),
							labelAttrs),
						$lucamug$elm_ui_with_context$Element$WithContext$text(
							$elm$core$String$toUpper(label)));
					var iconEl = function (icon) {
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$centerY]),
							A4(
								icon,
								iconSize,
								fgColor(context),
								$elm$core$Maybe$Nothing,
								cleanedFullLabel));
					};
					switch (appearance.$) {
						case 2:
							var imageUrl = appearance.a;
							return A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_Utils_ap(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(150),
											$lucamug$elm_ui_with_context$Element$WithContext$clip,
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											A2($elm$html$Html$Attributes$attribute, 'role', 'img'))
										]),
									(state === 1) ? _List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
											$author$project$T2$Internal$Color$bgOverlayDark(context))
										]) : _List_Nil),
								A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_Utils_ap(
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Background$image(imageUrl),
												$lucamug$elm_ui_with_context$Element$WithContext$width(
												$lucamug$elm_ui_with_context$Element$WithContext$px(avatarSize)),
												$lucamug$elm_ui_with_context$Element$WithContext$height(
												$lucamug$elm_ui_with_context$Element$WithContext$px(avatarSize)),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'))
											]),
										(state === 1) ? _List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.6)
											]) : _List_Nil),
									$lucamug$elm_ui_with_context$Element$WithContext$none));
						case 0:
							if (!iconMaybe.$) {
								var icon = iconMaybe.a;
								return iconEl(icon);
							} else {
								return textEl;
							}
						default:
							if (!iconMaybe.$) {
								var icon = iconMaybe.a;
								return iconEl(icon);
							} else {
								return textEl;
							}
					}
				}();
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_Utils_ap(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'border-radius', '50%')),
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								bgColor(context)),
								$lucamug$elm_ui_with_context$Element$WithContext$width(
								$lucamug$elm_ui_with_context$Element$WithContext$px(avatarSize)),
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								$lucamug$elm_ui_with_context$Element$WithContext$px(avatarSize)),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, 'aria-label', cleanedFullLabel))
							]),
						attrs),
					innerElement);
			});
	});
var $author$project$T2$Avatar$avatarImageEnabledMedium = F3(
	function (attrs, imageUrl, altText) {
		return A6(
			$author$project$T2$Internal$Avatar$renderAvatar,
			attrs,
			1,
			$author$project$T2$Internal$Avatar$Image(imageUrl),
			0,
			$elm$core$Maybe$Nothing,
			altText);
	});
var $author$project$T2$Internal$Avatar$Secondary = {$: 1};
var $author$project$T2$Avatar$avatarSecondaryEnabledMedium = F2(
	function (attrs, label) {
		return A6($author$project$T2$Internal$Avatar$renderAvatar, attrs, 1, $author$project$T2$Internal$Avatar$Secondary, 0, $elm$core$Maybe$Nothing, label);
	});
var $author$project$T2$Internal$Badge$Primary = 0;
var $author$project$T2$Internal$Badge$XSmall = 0;
var $author$project$T2$Internal$Color$bgBadgeDanger = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$bgBadgeDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgBadgeNeutral = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	}
};
var $author$project$T2$Internal$Color$bgBadgePrimary = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$bgBadgeSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	}
};
var $author$project$T2$Internal$Color$bgBadgeWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$Color$fgBadgeDanger = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgBadgeDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	}
};
var $author$project$T2$Internal$Color$fgBadgeNeutral = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgBadgePrimary = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$fgBadgeSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green00;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgBadgeWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Text$ParagraphSmallXX = 21;
var $author$project$T2$Text$paragraphSmallXXAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 21, color);
	});
var $author$project$T2$Internal$Badge$renderBadge = F4(
	function (attrs, size, appearance, label) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var badgeSize = function () {
					switch (size) {
						case 0:
							return 18;
						case 1:
							return 21;
						case 2:
							return 24;
						default:
							return 28;
					}
				}();
				var _v0 = function () {
					switch (appearance) {
						case 0:
							return _Utils_Tuple2($author$project$T2$Internal$Color$fgBadgePrimary, $author$project$T2$Internal$Color$bgBadgePrimary);
						case 1:
							return _Utils_Tuple2($author$project$T2$Internal$Color$fgBadgeNeutral, $author$project$T2$Internal$Color$bgBadgeNeutral);
						case 2:
							return _Utils_Tuple2($author$project$T2$Internal$Color$fgBadgeDanger, $author$project$T2$Internal$Color$bgBadgeDanger);
						case 3:
							return _Utils_Tuple2($author$project$T2$Internal$Color$fgBadgeWarning, $author$project$T2$Internal$Color$bgBadgeWarning);
						case 4:
							return _Utils_Tuple2($author$project$T2$Internal$Color$fgBadgeSuccess, $author$project$T2$Internal$Color$bgBadgeSuccess);
						default:
							return _Utils_Tuple2($author$project$T2$Internal$Color$fgBadgeDisabled, $author$project$T2$Internal$Color$bgBadgeDisabled);
					}
				}();
				var fgColor = _v0.a;
				var bgColor = _v0.b;
				var fontAttrs = function () {
					switch (size) {
						case 0:
							return $author$project$T2$Text$paragraphSmallXXAttrs(
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
										{bi: 5, br: 0, bt: 0, by: 3}),
										$lucamug$elm_ui_with_context$Element$WithContext$Font$center
									]));
						case 1:
							return $author$project$T2$Text$paragraphSmallXAttrs(
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
										{bi: 5, br: 0, bt: 0, by: 4}),
										$lucamug$elm_ui_with_context$Element$WithContext$Font$center
									]));
						case 2:
							return $author$project$T2$Text$paragraphSmallAttrs(
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
										{bi: 6, br: 0, bt: 0, by: 4}),
										$lucamug$elm_ui_with_context$Element$WithContext$Font$center
									]));
						default:
							return $author$project$T2$Text$paragraphMediumAttrs(
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
										{bi: 7, br: 0, bt: 0, by: 5}),
										$lucamug$elm_ui_with_context$Element$WithContext$Font$center
									]));
					}
				}()(
					fgColor(context));
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_Utils_ap(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'border-radius', '50%')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'flex-basis', 'fit-content')),
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								bgColor(context)),
								$lucamug$elm_ui_with_context$Element$WithContext$width(
								A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, badgeSize, $lucamug$elm_ui_with_context$Element$WithContext$shrink))
							]),
						_Utils_ap(attrs, fontAttrs)),
					$lucamug$elm_ui_with_context$Element$WithContext$text(label));
			});
	});
var $author$project$T2$Badge$badgePrimaryXSmall = F2(
	function (attrs, labelText) {
		return A4($author$project$T2$Internal$Badge$renderBadge, attrs, 0, 0, labelText);
	});
var $mdgriffith$elm_ui$Internal$Model$Below = 1;
var $mdgriffith$elm_ui$Element$below = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 1, element);
};
var $lucamug$elm_ui_with_context$Element$WithContext$below = $lucamug$elm_ui_with_context$Element$WithContext$createNearby($mdgriffith$elm_ui$Element$below);
var $author$project$T2$Internal$Color$bgTopBar = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$Swatch$green01 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 26, 20);
var $author$project$T2$Internal$Color$Swatch$green95 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 175, 222, 216);
var $author$project$T2$Internal$Color$bgUserAccountButtonTopBarFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgUserAccountButtonTopBarHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$T2$Internal$Color$fgUserEmailTopBar = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgUserFullnameTopBar = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgUserMenuIconTopBar = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Focus = 0;
var $mdgriffith$elm_ui$Internal$Model$PseudoSelector = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$focus = $mdgriffith$elm_ui$Internal$Flag$flag(31);
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $mdgriffith$elm_ui$Internal$Model$map = F2(
	function (fn, el) {
		switch (el.$) {
			case 1:
				var styled = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						hH: F2(
							function (add, context) {
								return A2(
									$elm$virtual_dom$VirtualDom$map,
									fn,
									A2(styled.hH, add, context));
							}),
						j7: styled.j7
					});
			case 0:
				var html = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A2(
						$elm$core$Basics$composeL,
						$elm$virtual_dom$VirtualDom$map(fn),
						html));
			case 2:
				var str = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Text(str);
			default:
				return $mdgriffith$elm_ui$Internal$Model$Empty;
		}
	});
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle = F2(
	function (fn, attr) {
		switch (attr.$) {
			case 0:
				return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
			case 2:
				var description = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Describe(description);
			case 6:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$AlignX(x);
			case 5:
				var y = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$AlignY(y);
			case 7:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Width(x);
			case 8:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Height(x);
			case 3:
				var x = attr.a;
				var y = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$Class, x, y);
			case 4:
				var flag = attr.a;
				var style = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$StyleClass, flag, style);
			case 9:
				var location = attr.a;
				var elem = attr.b;
				return A2(
					$mdgriffith$elm_ui$Internal$Model$Nearby,
					location,
					A2($mdgriffith$elm_ui$Internal$Model$map, fn, elem));
			case 1:
				var htmlAttr = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Attr(
					A2($elm$virtual_dom$VirtualDom$mapAttribute, fn, htmlAttr));
			default:
				var fl = attr.a;
				var trans = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$TransformComponent, fl, trans);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$removeNever = function (style) {
	return A2($mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle, $elm$core$Basics$never, style);
};
var $mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper = F2(
	function (attr, _v0) {
		var styles = _v0.a;
		var trans = _v0.b;
		var _v1 = $mdgriffith$elm_ui$Internal$Model$removeNever(attr);
		switch (_v1.$) {
			case 4:
				var style = _v1.b;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, style, styles),
					trans);
			case 10:
				var flag = _v1.a;
				var component = _v1.b;
				return _Utils_Tuple2(
					styles,
					A2($mdgriffith$elm_ui$Internal$Model$composeTransformation, trans, component));
			default:
				return _Utils_Tuple2(styles, trans);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$unwrapDecorations = function (attrs) {
	var _v0 = A3(
		$elm$core$List$foldl,
		$mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper,
		_Utils_Tuple2(_List_Nil, $mdgriffith$elm_ui$Internal$Model$Untransformed),
		attrs);
	var styles = _v0.a;
	var transform = _v0.b;
	return A2(
		$elm$core$List$cons,
		$mdgriffith$elm_ui$Internal$Model$Transform(transform),
		styles);
};
var $mdgriffith$elm_ui$Element$focused = function (decs) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$focus,
		A2(
			$mdgriffith$elm_ui$Internal$Model$PseudoSelector,
			0,
			$mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
};
var $lucamug$elm_ui_with_context$Element$WithContext$focused = function (decs) {
	return function (context) {
		return $mdgriffith$elm_ui$Element$focused(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var f = _v0;
					return f(context);
				},
				decs));
	};
};
var $author$project$T2$Internal$Icon$internalHamburger = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#hamburger');
	});
var $author$project$T2$Icon$hamburger = $author$project$T2$Internal$Icon$internalHamburger;
var $author$project$T2$Internal$IconButton$Enabled = 0;
var $author$project$T2$Internal$IconButton$Icon = 2;
var $author$project$T2$Internal$IconButton$Medium = 1;
var $author$project$T2$Internal$IconButton$OnClick = function (a) {
	return {$: 1, a: a};
};
var $author$project$T2$Internal$IconButton$Disabled = 1;
var $author$project$T2$Internal$IconButton$Elevated = 4;
var $author$project$T2$Internal$IconButton$Loading = 2;
var $author$project$T2$Internal$IconButton$Outlined = 1;
var $author$project$T2$Internal$Color$bcIconButtonOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$Swatch$green30 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 102, 85);
var $author$project$T2$Internal$Color$bcIconButtonOutlinedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$bcIconButtonOutlinedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonAccentDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonAccentEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	}
};
var $author$project$T2$Internal$Color$Swatch$turquoise40 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 20, 191, 191);
var $author$project$T2$Internal$Color$bgIconButtonAccentFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise40;
	}
};
var $author$project$T2$Internal$Color$Swatch$turquoise50 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 37, 208, 202);
var $author$project$T2$Internal$Color$bgIconButtonAccentHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise50;
	}
};
var $author$project$T2$Internal$Color$Swatch$sGreen50 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 179, 96);
var $author$project$T2$Internal$Color$bgIconButtonAccentPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonElevatedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonElevatedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$Swatch$green90 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 122, 201, 191);
var $author$project$T2$Internal$Color$bgIconButtonElevatedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonElevatedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonElevatedPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonFilledDangerDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonFilledDangerEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$Swatch$red05 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 128, 1, 1);
var $author$project$T2$Internal$Color$Swatch$red10 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 165, 1, 1);
var $author$project$T2$Internal$Color$bgIconButtonFilledDangerFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red05;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonFilledDangerHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red20;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red10;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonFilledDangerPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red05;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonFilledDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonFilledFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$Swatch$green40 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 118, 100);
var $author$project$T2$Internal$Color$bgIconButtonFilledHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray90;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonFilledPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonFilledSecondaryDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonFilledSecondaryEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen70;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen70;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonFilledSecondaryFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonFilledSecondaryHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen60;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonFilledSecondaryPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	}
};
var $author$project$T2$Internal$Color$Swatch$transparent = A4($lucamug$elm_ui_with_context$Element$WithContext$rgba255, 255, 255, 255, 0);
var $author$project$T2$Internal$Color$bgIconButtonIconContentInverseDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconContentInverseEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconContentInverseFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green01;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconContentInverseHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green99;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconDangerDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconDangerEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$Swatch$red95 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 199, 184);
var $author$project$T2$Internal$Color$bgIconButtonIconDangerFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red01;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconDangerHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red01;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconDangerPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red01;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconTertiaryDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconTertiaryEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconTertiaryFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconTertiaryHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonIconTertiaryPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonOutlinedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonOutlinedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonOutlinedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgIconButtonOutlinedPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $mdgriffith$elm_ui$Internal$Flag$borderColor = $mdgriffith$elm_ui$Internal$Flag$flag(28);
var $mdgriffith$elm_ui$Element$Border$color = function (clr) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'bc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr),
			'border-color',
			clr));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$color = function (clr) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr(
		$mdgriffith$elm_ui$Element$Border$color(clr));
};
var $author$project$T2$Internal$Color$fgIconButtonAccentDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonAccentEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonElevatedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonElevatedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonFilledDangerDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonFilledDangerEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonFilledDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonFilledSecondaryDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonFilledSecondaryEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonIconContentInverseDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonIconContentInverseEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonIconDangerEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonIconDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonIconEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonIconTertiaryEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonOutlinedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$fgIconButtonOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$LoadingSpinner$Small = 1;
var $author$project$T2$Internal$LoadingSpinner$getSpinnerSize = function (size) {
	switch (size) {
		case 0:
			return 12;
		case 1:
			return 20;
		case 2:
			return 32;
		default:
			return 56;
	}
};
var $elm$svg$Svg$animateTransform = $elm$svg$Svg$trustedNode('animateTransform');
var $elm$svg$Svg$Attributes$attributeName = _VirtualDom_attribute('attributeName');
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$dur = _VirtualDom_attribute('dur');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $elm$svg$Svg$Attributes$from = function (value) {
	return A2(
		_VirtualDom_attribute,
		'from',
		_VirtualDom_noJavaScriptUri(value));
};
var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$Attributes$repeatCount = _VirtualDom_attribute('repeatCount');
var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');
var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');
var $elm$svg$Svg$Attributes$stopOpacity = _VirtualDom_attribute('stop-opacity');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$Attributes$to = function (value) {
	return A2(
		_VirtualDom_attribute,
		'to',
		_VirtualDom_noJavaScriptUri(value));
};
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $elm$svg$Svg$Attributes$type_ = _VirtualDom_attribute('type');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$T2$Internal$LoadingSpinner$internalSpinnerRotation = F2(
	function (size, color) {
		var speed = '0.6s';
		var colorString = $author$project$T2$Internal$Color$Extra$colorToHex(color);
		var idElement = 'id' + A2($elm$core$String$dropLeft, 1, colorString);
		return $lucamug$elm_ui_with_context$Element$WithContext$html(
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox('0 0 38 38'),
						$elm$svg$Svg$Attributes$xmlSpace('http://www.w3.org/2000/svg'),
						$elm$svg$Svg$Attributes$width(
						$elm$core$String$fromInt(size)),
						$elm$svg$Svg$Attributes$height(
						$elm$core$String$fromInt(size))
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id(idElement),
										$elm$svg$Svg$Attributes$x1('8%'),
										$elm$svg$Svg$Attributes$x2('65.7%'),
										$elm$svg$Svg$Attributes$y1('0%'),
										$elm$svg$Svg$Attributes$y2('23.9%')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor(colorString),
												$elm$svg$Svg$Attributes$stopOpacity('0')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('63.1%'),
												$elm$svg$Svg$Attributes$stopColor(colorString),
												$elm$svg$Svg$Attributes$stopOpacity('.6')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor(colorString)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$fill('none'),
								$elm$svg$Svg$Attributes$fillRule('evenodd'),
								$elm$svg$Svg$Attributes$transform('translate(1 1)')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M36 18C36 8 28 0 18 0'),
										$elm$svg$Svg$Attributes$stroke('url(#' + (idElement + ')')),
										$elm$svg$Svg$Attributes$strokeWidth('2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$animateTransform,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$attributeName('transform'),
												$elm$svg$Svg$Attributes$dur(speed),
												$elm$svg$Svg$Attributes$from('0 18 18'),
												$elm$svg$Svg$Attributes$repeatCount('indefinite'),
												$elm$svg$Svg$Attributes$to('360 18 18'),
												$elm$svg$Svg$Attributes$type_('rotate')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$cx('36'),
										$elm$svg$Svg$Attributes$cy('18'),
										$elm$svg$Svg$Attributes$fill(colorString),
										$elm$svg$Svg$Attributes$r('1')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$animateTransform,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$attributeName('transform'),
												$elm$svg$Svg$Attributes$dur(speed),
												$elm$svg$Svg$Attributes$from('0 18 18'),
												$elm$svg$Svg$Attributes$repeatCount('indefinite'),
												$elm$svg$Svg$Attributes$to('360 18 18'),
												$elm$svg$Svg$Attributes$type_('rotate')
											]),
										_List_Nil)
									]))
							]))
					])));
	});
var $author$project$T2$Internal$LoadingSpinner$renderInlineLoadingSpinner = function (size) {
	var spinnerSize = $author$project$T2$Internal$LoadingSpinner$getSpinnerSize(size);
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$centerY]),
				A2(
					$author$project$T2$Internal$LoadingSpinner$internalSpinnerRotation,
					spinnerSize,
					$author$project$T2$Internal$Color$contentSecondary(context)));
		});
};
var $author$project$T2$LoadingSpinner$inlineLoadingSpinnerSmall = $author$project$T2$Internal$LoadingSpinner$renderInlineLoadingSpinner(1);
var $author$project$T2$Internal$LoadingSpinner$SmallX = 0;
var $author$project$T2$LoadingSpinner$inlineLoadingSpinnerSmallX = $author$project$T2$Internal$LoadingSpinner$renderInlineLoadingSpinner(0);
var $author$project$T2$Internal$IconButton$internalRenderIconView = F5(
	function (iconRenderer, color, size, iconButtonLabel, attrs) {
		var iconSize = function () {
			switch (size) {
				case 0:
					return 1;
				case 1:
					return 2;
				default:
					return 4;
			}
		}();
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_Utils_ap(
				attrs,
				_List_fromArray(
					[$lucamug$elm_ui_with_context$Element$WithContext$centerX])),
			A4(iconRenderer, iconSize, color, $elm$core$Maybe$Nothing, iconButtonLabel));
	});
var $mdgriffith$elm_ui$Internal$Model$Active = 2;
var $mdgriffith$elm_ui$Internal$Flag$active = $mdgriffith$elm_ui$Internal$Flag$flag(32);
var $mdgriffith$elm_ui$Element$mouseDown = function (decs) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$active,
		A2(
			$mdgriffith$elm_ui$Internal$Model$PseudoSelector,
			2,
			$mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
};
var $lucamug$elm_ui_with_context$Element$WithContext$mouseDown = function (decs) {
	return function (context) {
		return $mdgriffith$elm_ui$Element$mouseDown(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var f = _v0;
					return f(context);
				},
				decs));
	};
};
var $mdgriffith$elm_ui$Internal$Model$Hover = 1;
var $mdgriffith$elm_ui$Internal$Flag$hover = $mdgriffith$elm_ui$Internal$Flag$flag(33);
var $mdgriffith$elm_ui$Element$mouseOver = function (decs) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$hover,
		A2(
			$mdgriffith$elm_ui$Internal$Model$PseudoSelector,
			1,
			$mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
};
var $lucamug$elm_ui_with_context$Element$WithContext$mouseOver = function (decs) {
	return function (context) {
		return $mdgriffith$elm_ui$Element$mouseOver(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var f = _v0;
					return f(context);
				},
				decs));
	};
};
var $mdgriffith$elm_ui$Internal$Flag$borderStyle = $mdgriffith$elm_ui$Internal$Flag$flag(11);
var $mdgriffith$elm_ui$Element$Border$solid = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$borderStyle, $mdgriffith$elm_ui$Internal$Style$classes.ga);
var $lucamug$elm_ui_with_context$Element$WithContext$Border$solid = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Border$solid);
var $mdgriffith$elm_ui$Internal$Model$BorderWidth = F5(
	function (a, b, c, d, e) {
		return {$: 6, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Element$Border$width = function (v) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderWidth,
		A5(
			$mdgriffith$elm_ui$Internal$Model$BorderWidth,
			'b-' + $elm$core$String$fromInt(v),
			v,
			v,
			v,
			v));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$width = function (v) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Border$width(v));
};
var $author$project$T2$Internal$IconButton$renderIconButton = F7(
	function (attrs, style, state, size, behaviour, iconRenderer, iconButtonLabel) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var shadowAttrs = (style === 4) ? _List_fromArray(
					[$author$project$T2$Elevation$elevation1]) : _List_Nil;
				var cursorAttrs = ((state === 1) || (state === 2)) ? _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$class('tt-cursor-not-allowed'))
					]) : _List_fromArray(
					[$lucamug$elm_ui_with_context$Element$WithContext$pointer]);
				var borderAttrs = (style === 1) ? (((state === 1) || (state === 2)) ? _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Border$solid,
						$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
						$author$project$T2$Internal$Color$fgIconButtonOutlinedDisabled(context))
					]) : _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Border$solid,
						$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
						$author$project$T2$Internal$Color$bcIconButtonOutlinedEnabled(context))
					])) : _List_Nil;
				var ariaAttrs = ((state === 1) || (state === 2)) ? _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true'))
					]) : _List_fromArray(
					[$lucamug$elm_ui_with_context$Element$WithContext$pointer]);
				var buttonAttrs = function () {
					var dimention = function () {
						switch (size) {
							case 0:
								return $lucamug$elm_ui_with_context$Element$WithContext$px(34);
							case 1:
								return $lucamug$elm_ui_with_context$Element$WithContext$px(40);
							default:
								return $lucamug$elm_ui_with_context$Element$WithContext$px(44);
						}
					}();
					return _Utils_ap(
						cursorAttrs,
						_Utils_ap(
							ariaAttrs,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$height(dimention),
									$lucamug$elm_ui_with_context$Element$WithContext$width(dimention),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$style, 'border-radius', '50%')),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('tt-element-hover-transition', true),
												_Utils_Tuple2('tt-button', true)
											]))),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$attribute, 'aria-label', iconButtonLabel))
								])));
				}();
				var _v0 = function () {
					switch (style) {
						case 0:
							return _Utils_Tuple3($author$project$T2$Internal$Color$bgIconButtonFilledFocused, $author$project$T2$Internal$Color$bgIconButtonFilledHovered, $author$project$T2$Internal$Color$bgIconButtonFilledPressed);
						case 1:
							return _Utils_Tuple3($author$project$T2$Internal$Color$bgIconButtonOutlinedFocused, $author$project$T2$Internal$Color$bgIconButtonOutlinedHovered, $author$project$T2$Internal$Color$bgIconButtonOutlinedPressed);
						case 2:
							return _Utils_Tuple3($author$project$T2$Internal$Color$bgIconButtonIconFocused, $author$project$T2$Internal$Color$bgIconButtonIconHovered, $author$project$T2$Internal$Color$bgIconButtonIconPressed);
						case 3:
							return _Utils_Tuple3($author$project$T2$Internal$Color$bgIconButtonIconTertiaryFocused, $author$project$T2$Internal$Color$bgIconButtonIconTertiaryHovered, $author$project$T2$Internal$Color$bgIconButtonIconTertiaryPressed);
						case 4:
							return _Utils_Tuple3($author$project$T2$Internal$Color$bgIconButtonElevatedFocused, $author$project$T2$Internal$Color$bgIconButtonElevatedHovered, $author$project$T2$Internal$Color$bgIconButtonElevatedPressed);
						case 5:
							return _Utils_Tuple3($author$project$T2$Internal$Color$bgIconButtonFilledSecondaryFocused, $author$project$T2$Internal$Color$bgIconButtonFilledSecondaryHovered, $author$project$T2$Internal$Color$bgIconButtonFilledSecondaryPressed);
						case 6:
							return _Utils_Tuple3($author$project$T2$Internal$Color$bgIconButtonAccentFocused, $author$project$T2$Internal$Color$bgIconButtonAccentHovered, $author$project$T2$Internal$Color$bgIconButtonAccentPressed);
						case 7:
							return _Utils_Tuple3($author$project$T2$Internal$Color$bgIconButtonFilledDangerFocused, $author$project$T2$Internal$Color$bgIconButtonFilledDangerHovered, $author$project$T2$Internal$Color$bgIconButtonFilledDangerPressed);
						case 8:
							return _Utils_Tuple3($author$project$T2$Internal$Color$bgIconButtonIconDangerFocused, $author$project$T2$Internal$Color$bgIconButtonIconDangerHovered, $author$project$T2$Internal$Color$bgIconButtonIconDangerPressed);
						default:
							return _Utils_Tuple3($author$project$T2$Internal$Color$bgIconButtonIconContentInverseFocused, $author$project$T2$Internal$Color$bgIconButtonIconContentInverseHovered, $author$project$T2$Internal$Color$bgIconButtonIconContentInverseFocused);
					}
				}();
				var bgFocused = _v0.a;
				var bgHovered = _v0.b;
				var bgPressed = _v0.c;
				var bgFocusedAttrs = ((state === 1) || (state === 2)) ? _List_Nil : _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						bgFocused(context))
					]);
				var bgHoveredAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						bgHovered(context))
					]);
				var buttonPressedAttrs = ((state === 1) || (state === 2)) ? _List_Nil : _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$mouseDown(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								bgPressed(context))
							]))
					]);
				var _v2 = function () {
					var _v3 = _Utils_Tuple2(style, state);
					switch (_v3.b) {
						case 0:
							switch (_v3.a) {
								case 0:
									var _v4 = _v3.a;
									var _v5 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonFilledEnabled, $author$project$T2$Internal$Color$bgIconButtonFilledEnabled);
								case 1:
									var _v10 = _v3.a;
									var _v11 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonOutlinedEnabled, $author$project$T2$Internal$Color$bgIconButtonOutlinedEnabled);
								case 2:
									var _v16 = _v3.a;
									var _v17 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonIconEnabled, $author$project$T2$Internal$Color$bgIconButtonIconEnabled);
								case 3:
									var _v22 = _v3.a;
									var _v23 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonIconTertiaryEnabled, $author$project$T2$Internal$Color$bgIconButtonIconTertiaryEnabled);
								case 4:
									var _v28 = _v3.a;
									var _v29 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonElevatedEnabled, $author$project$T2$Internal$Color$bgIconButtonElevatedEnabled);
								case 5:
									var _v34 = _v3.a;
									var _v35 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonFilledSecondaryEnabled, $author$project$T2$Internal$Color$bgIconButtonFilledSecondaryEnabled);
								case 6:
									var _v40 = _v3.a;
									var _v41 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonAccentEnabled, $author$project$T2$Internal$Color$bgIconButtonAccentEnabled);
								case 7:
									var _v46 = _v3.a;
									var _v47 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonFilledDangerEnabled, $author$project$T2$Internal$Color$bgIconButtonFilledDangerEnabled);
								case 8:
									var _v52 = _v3.a;
									var _v53 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonIconDangerEnabled, $author$project$T2$Internal$Color$bgIconButtonIconDangerEnabled);
								default:
									var _v58 = _v3.a;
									var _v59 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonIconContentInverseEnabled, $author$project$T2$Internal$Color$bgIconButtonIconContentInverseEnabled);
							}
						case 1:
							switch (_v3.a) {
								case 0:
									var _v6 = _v3.a;
									var _v7 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonFilledDisabled, $author$project$T2$Internal$Color$bgIconButtonFilledDisabled);
								case 1:
									var _v12 = _v3.a;
									var _v13 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonOutlinedDisabled, $author$project$T2$Internal$Color$bgIconButtonOutlinedDisabled);
								case 2:
									var _v18 = _v3.a;
									var _v19 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonIconDisabled, $author$project$T2$Internal$Color$bgIconButtonIconDisabled);
								case 3:
									var _v24 = _v3.a;
									var _v25 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonIconDisabled, $author$project$T2$Internal$Color$bgIconButtonIconTertiaryDisabled);
								case 4:
									var _v30 = _v3.a;
									var _v31 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonElevatedDisabled, $author$project$T2$Internal$Color$bgIconButtonElevatedDisabled);
								case 5:
									var _v36 = _v3.a;
									var _v37 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonFilledSecondaryDisabled, $author$project$T2$Internal$Color$bgIconButtonFilledSecondaryDisabled);
								case 6:
									var _v42 = _v3.a;
									var _v43 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonAccentDisabled, $author$project$T2$Internal$Color$bgIconButtonAccentDisabled);
								case 7:
									var _v48 = _v3.a;
									var _v49 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonFilledDangerDisabled, $author$project$T2$Internal$Color$bgIconButtonFilledDangerDisabled);
								case 8:
									var _v54 = _v3.a;
									var _v55 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonIconDisabled, $author$project$T2$Internal$Color$bgIconButtonIconDangerDisabled);
								default:
									var _v60 = _v3.a;
									var _v61 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonIconContentInverseDisabled, $author$project$T2$Internal$Color$bgIconButtonIconContentInverseDisabled);
							}
						default:
							switch (_v3.a) {
								case 0:
									var _v8 = _v3.a;
									var _v9 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonFilledDisabled, $author$project$T2$Internal$Color$bgIconButtonFilledDisabled);
								case 1:
									var _v14 = _v3.a;
									var _v15 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonOutlinedDisabled, $author$project$T2$Internal$Color$bgIconButtonOutlinedDisabled);
								case 2:
									var _v20 = _v3.a;
									var _v21 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonIconDisabled, $author$project$T2$Internal$Color$bgIconButtonIconDisabled);
								case 3:
									var _v26 = _v3.a;
									var _v27 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonIconDisabled, $author$project$T2$Internal$Color$bgIconButtonIconTertiaryDisabled);
								case 4:
									var _v32 = _v3.a;
									var _v33 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonElevatedDisabled, $author$project$T2$Internal$Color$bgIconButtonElevatedDisabled);
								case 5:
									var _v38 = _v3.a;
									var _v39 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonFilledSecondaryDisabled, $author$project$T2$Internal$Color$bgIconButtonFilledSecondaryDisabled);
								case 6:
									var _v44 = _v3.a;
									var _v45 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonAccentDisabled, $author$project$T2$Internal$Color$bgIconButtonAccentDisabled);
								case 7:
									var _v50 = _v3.a;
									var _v51 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonFilledDangerDisabled, $author$project$T2$Internal$Color$bgIconButtonFilledDangerDisabled);
								case 8:
									var _v56 = _v3.a;
									var _v57 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonIconDisabled, $author$project$T2$Internal$Color$bgIconButtonIconDangerDisabled);
								default:
									var _v62 = _v3.a;
									var _v63 = _v3.b;
									return _Utils_Tuple2($author$project$T2$Internal$Color$fgIconButtonIconContentInverseDisabled, $author$project$T2$Internal$Color$bgIconButtonIconContentInverseDisabled);
							}
					}
				}();
				var fgColor = _v2.a;
				var bgColor = _v2.b;
				var bgColorAttrs = ((state === 1) && (style === 1)) ? _List_Nil : _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						bgColor(context))
					]);
				var labelView = function () {
					if (state === 2) {
						switch (size) {
							case 0:
								return $author$project$T2$LoadingSpinner$inlineLoadingSpinnerSmallX;
							case 1:
								return $author$project$T2$LoadingSpinner$inlineLoadingSpinnerSmallX;
							default:
								return $author$project$T2$LoadingSpinner$inlineLoadingSpinnerSmall;
						}
					} else {
						return A5(
							$author$project$T2$Internal$IconButton$internalRenderIconView,
							iconRenderer,
							fgColor(context),
							size,
							iconButtonLabel,
							cursorAttrs);
					}
				}();
				var _v64 = (style === 1) ? (((state === 1) || (state === 2)) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
					$elm$core$Maybe$Just(
						$author$project$T2$Internal$Color$bcIconButtonOutlinedHovered(context)),
					$elm$core$Maybe$Just(
						$author$project$T2$Internal$Color$bcIconButtonOutlinedFocused(context)))) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
				var bcHovered = _v64.a;
				var bcFocused = _v64.b;
				var bcFocusedAttrs = function () {
					if (!bcFocused.$) {
						var color = bcFocused.a;
						return _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Border$color(color)
							]);
					} else {
						return _List_Nil;
					}
				}();
				var buttonFocusedAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$focused(
						_Utils_ap(bcFocusedAttrs, bgFocusedAttrs))
					]);
				var bcHoveredAttrs = function () {
					if (!bcHovered.$) {
						var color = bcHovered.a;
						return _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Border$color(color)
							]);
					} else {
						return _List_Nil;
					}
				}();
				var buttonHoveredAttrs = ((state === 1) || (state === 2)) ? _List_Nil : _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
						_Utils_ap(bgHoveredAttrs, bcHoveredAttrs))
					]);
				switch (behaviour.$) {
					case 0:
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$Input$button,
							_Utils_ap(
								buttonAttrs,
								_Utils_ap(
									borderAttrs,
									_Utils_ap(
										bgColorAttrs,
										_Utils_ap(
											buttonPressedAttrs,
											_Utils_ap(
												buttonFocusedAttrs,
												_Utils_ap(
													buttonHoveredAttrs,
													_Utils_ap(shadowAttrs, attrs))))))),
							{u: labelView, ew: $elm$core$Maybe$Nothing});
					case 1:
						var msg = behaviour.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$Input$button,
							_Utils_ap(
								buttonAttrs,
								_Utils_ap(
									borderAttrs,
									_Utils_ap(
										bgColorAttrs,
										_Utils_ap(
											buttonPressedAttrs,
											_Utils_ap(
												buttonFocusedAttrs,
												_Utils_ap(
													buttonHoveredAttrs,
													_Utils_ap(shadowAttrs, attrs))))))),
							{
								u: labelView,
								ew: $elm$core$Maybe$Just(msg)
							});
					case 2:
						var url = behaviour.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$link,
							_Utils_ap(
								buttonAttrs,
								_Utils_ap(
									borderAttrs,
									_Utils_ap(
										bgColorAttrs,
										_Utils_ap(
											buttonPressedAttrs,
											_Utils_ap(
												buttonFocusedAttrs,
												_Utils_ap(
													buttonHoveredAttrs,
													_Utils_ap(shadowAttrs, attrs))))))),
							{u: labelView, R: url});
					default:
						var url = behaviour.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$newTabLink,
							_Utils_ap(
								buttonAttrs,
								_Utils_ap(
									borderAttrs,
									_Utils_ap(
										bgColorAttrs,
										_Utils_ap(
											buttonPressedAttrs,
											_Utils_ap(
												buttonFocusedAttrs,
												_Utils_ap(
													buttonHoveredAttrs,
													_Utils_ap(shadowAttrs, attrs))))))),
							{u: labelView, R: url});
				}
			});
	});
var $author$project$T2$IconButton$iconButtonIconEnabledMedium = F4(
	function (attrs, msg, icon, alt) {
		return A7(
			$author$project$T2$Internal$IconButton$renderIconButton,
			attrs,
			2,
			0,
			1,
			$author$project$T2$Internal$IconButton$OnClick(msg),
			icon,
			alt);
	});
var $author$project$T2$Internal$IconButton$IconTertiary = 3;
var $author$project$T2$IconButton$iconButtonIconTertiaryEnabledMedium = F4(
	function (attrs, msg, icon, alt) {
		return A7(
			$author$project$T2$Internal$IconButton$renderIconButton,
			attrs,
			3,
			0,
			1,
			$author$project$T2$Internal$IconButton$OnClick(msg),
			icon,
			alt);
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$T2$Internal$Icon$internalChevronDown = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#chevron-down');
	});
var $author$project$T2$Internal$TopBar$internalOnBlurAttribute = F2(
	function (id, hideMsg) {
		var dataInnerElementDecoder = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['relatedTarget', 'firstElementChild', 'attributes', 'data-dropdown-id', 'value']),
			$elm$json$Json$Decode$string);
		var dataDecoder = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['relatedTarget', 'attributes', 'data-dropdown-id', 'value']),
			$elm$json$Json$Decode$string);
		var attrToMsg = function (maybeAttr) {
			if (!maybeAttr.$) {
				var attr = maybeAttr.a;
				return _Utils_eq(attr, id) ? $elm$json$Json$Decode$fail('') : $elm$json$Json$Decode$succeed(hideMsg);
			} else {
				return $elm$json$Json$Decode$succeed(hideMsg);
			}
		};
		var checkInnerDecoder = function (maybeAttr) {
			if (!maybeAttr.$) {
				return attrToMsg(maybeAttr);
			} else {
				return A2(
					$elm$json$Json$Decode$andThen,
					attrToMsg,
					$elm$json$Json$Decode$maybe(dataInnerElementDecoder));
			}
		};
		return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
			A2(
				$elm$html$Html$Events$on,
				'blur',
				A2(
					$elm$json$Json$Decode$andThen,
					checkInnerDecoder,
					$elm$json$Json$Decode$maybe(dataDecoder))));
	});
var $author$project$T2$Internal$Text$LabelSmallX = 15;
var $author$project$T2$Text$labelSmalXAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 15, color);
	});
var $author$project$T2$Internal$Text$LabelSmall = 14;
var $author$project$T2$Text$labelSmallAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 14, color);
	});
var $author$project$T2$Internal$Button$Enabled = 0;
var $author$project$T2$Internal$Button$FilledSecondary = 4;
var $author$project$T2$Internal$Button$LinkForCurrentPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$T2$Internal$Button$Medium = 1;
var $author$project$T2$Internal$Button$Disabled = 1;
var $author$project$T2$Internal$Button$Elevated = 3;
var $author$project$T2$Internal$Button$Loading = 2;
var $author$project$T2$Internal$Button$Outlined = 1;
var $author$project$T2$Internal$Color$Swatch$red50 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 253, 46, 12);
var $author$project$T2$Internal$Color$bcButtonOutlinedDangerEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red50;
	}
};
var $author$project$T2$Internal$Color$bcButtonOutlinedDangerFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red50;
	}
};
var $author$project$T2$Internal$Color$Swatch$red40 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 239, 38, 5);
var $author$project$T2$Internal$Color$bcButtonOutlinedDangerHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red40;
	}
};
var $author$project$T2$Internal$Color$bcButtonOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$bcButtonOutlinedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$bcButtonOutlinedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$bcButtonOutlinedWarningEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$Color$Swatch$yellow20 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 204, 154, 54);
var $author$project$T2$Internal$Color$bcButtonOutlinedWarningFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow20;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$Color$bcButtonOutlinedWarningHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow20;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$Color$bgButtonAccentDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonAccentEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	}
};
var $author$project$T2$Internal$Color$bgButtonAccentFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise40;
	}
};
var $author$project$T2$Internal$Color$bgButtonAccentHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise50;
	}
};
var $author$project$T2$Internal$Color$bgButtonAccentLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonAccentPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	}
};
var $author$project$T2$Internal$Color$bgButtonElevatedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonElevatedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$bgButtonElevatedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgButtonElevatedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$bgButtonElevatedLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonElevatedPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledDangerDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledDangerEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledDangerFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red05;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledDangerHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red20;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red10;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledDangerLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledDangerPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red05;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledFacebookDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$Swatch$externalBrandFacebook = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 24, 119, 242);
var $author$project$T2$Internal$Color$bgButtonFilledFacebookEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$externalBrandFacebook;
	} else {
		return $author$project$T2$Internal$Color$Swatch$externalBrandFacebook;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledFacebookFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$externalBrandFacebook;
	} else {
		return $author$project$T2$Internal$Color$Swatch$externalBrandFacebook;
	}
};
var $avh4$elm_color$Color$hsla = F4(
	function (hue, sat, light, alpha) {
		var _v0 = _Utils_Tuple3(hue, sat, light);
		var h = _v0.a;
		var s = _v0.b;
		var l = _v0.c;
		var m2 = (l <= 0.5) ? (l * (s + 1)) : ((l + s) - (l * s));
		var m1 = (l * 2) - m2;
		var hueToRgb = function (h__) {
			var h_ = (h__ < 0) ? (h__ + 1) : ((h__ > 1) ? (h__ - 1) : h__);
			return ((h_ * 6) < 1) ? (m1 + (((m2 - m1) * h_) * 6)) : (((h_ * 2) < 1) ? m2 : (((h_ * 3) < 2) ? (m1 + (((m2 - m1) * ((2 / 3) - h_)) * 6)) : m1));
		};
		var b = hueToRgb(h - (1 / 3));
		var g = hueToRgb(h);
		var r = hueToRgb(h + (1 / 3));
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, alpha);
	});
var $noahzgordon$elm_color_extra$Color$Manipulate$limit = A2($elm$core$Basics$clamp, 0, 1);
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $avh4$elm_color$Color$toHsla = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var minColor = A2(
		$elm$core$Basics$min,
		r,
		A2($elm$core$Basics$min, g, b));
	var maxColor = A2(
		$elm$core$Basics$max,
		r,
		A2($elm$core$Basics$max, g, b));
	var l = (minColor + maxColor) / 2;
	var s = _Utils_eq(minColor, maxColor) ? 0 : ((l < 0.5) ? ((maxColor - minColor) / (maxColor + minColor)) : ((maxColor - minColor) / ((2 - maxColor) - minColor)));
	var h1 = _Utils_eq(maxColor, r) ? ((g - b) / (maxColor - minColor)) : (_Utils_eq(maxColor, g) ? (2 + ((b - r) / (maxColor - minColor))) : (4 + ((r - g) / (maxColor - minColor))));
	var h2 = h1 * (1 / 6);
	var h3 = $elm$core$Basics$isNaN(h2) ? 0 : ((h2 < 0) ? (h2 + 1) : h2);
	return {cL: a, ee: h3, eo: l, e0: s};
};
var $noahzgordon$elm_color_extra$Color$Manipulate$darken = F2(
	function (offset, cl) {
		var _v0 = $avh4$elm_color$Color$toHsla(cl);
		var hue = _v0.ee;
		var saturation = _v0.e0;
		var lightness = _v0.eo;
		var alpha = _v0.cL;
		return A4(
			$avh4$elm_color$Color$hsla,
			hue,
			saturation,
			$noahzgordon$elm_color_extra$Color$Manipulate$limit(lightness - offset),
			alpha);
	});
var $mdgriffith$elm_ui$Element$rgba = $mdgriffith$elm_ui$Internal$Model$Rgba;
var $author$project$T2$Internal$Color$Extra$fromColor = function (elementColor) {
	var cl = $avh4$elm_color$Color$toRgba(elementColor);
	return A4($mdgriffith$elm_ui$Element$rgba, cl.dg, cl.c2, cl.cP, cl.cL);
};
var $author$project$T2$Internal$Color$Extra$darken = F2(
	function (offset, elementColor) {
		var cl = $author$project$T2$Internal$Color$Extra$toColor(elementColor);
		return $author$project$T2$Internal$Color$Extra$fromColor(
			A2($noahzgordon$elm_color_extra$Color$Manipulate$darken, offset, cl));
	});
var $author$project$T2$Internal$Color$bgButtonFilledFacebookHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return A2($author$project$T2$Internal$Color$Extra$darken, 0.1, $author$project$T2$Internal$Color$Swatch$externalBrandFacebook);
	} else {
		return A2($author$project$T2$Internal$Color$Extra$darken, 0.1, $author$project$T2$Internal$Color$Swatch$externalBrandFacebook);
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledFacebookLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $noahzgordon$elm_color_extra$Color$Manipulate$lighten = F2(
	function (offset, cl) {
		return A2($noahzgordon$elm_color_extra$Color$Manipulate$darken, -offset, cl);
	});
var $author$project$T2$Internal$Color$Extra$lighten = F2(
	function (offset, elementColor) {
		var cl = $author$project$T2$Internal$Color$Extra$toColor(elementColor);
		return $author$project$T2$Internal$Color$Extra$fromColor(
			A2($noahzgordon$elm_color_extra$Color$Manipulate$lighten, offset, cl));
	});
var $author$project$T2$Internal$Color$bgButtonFilledFacebookPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return A2($author$project$T2$Internal$Color$Extra$lighten, 0.08, $author$project$T2$Internal$Color$Swatch$externalBrandFacebook);
	} else {
		return A2($author$project$T2$Internal$Color$Extra$lighten, 0.08, $author$project$T2$Internal$Color$Swatch$externalBrandFacebook);
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray90;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledLinkedinDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$Swatch$externalBrandLinkedin = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 10, 102, 194);
var $author$project$T2$Internal$Color$bgButtonFilledLinkedinEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$externalBrandLinkedin;
	} else {
		return $author$project$T2$Internal$Color$Swatch$externalBrandLinkedin;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledLinkedinFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$externalBrandLinkedin;
	} else {
		return $author$project$T2$Internal$Color$Swatch$externalBrandLinkedin;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledLinkedinHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return A2($author$project$T2$Internal$Color$Extra$darken, 0.12, $author$project$T2$Internal$Color$Swatch$externalBrandLinkedin);
	} else {
		return A2($author$project$T2$Internal$Color$Extra$darken, 0.12, $author$project$T2$Internal$Color$Swatch$externalBrandLinkedin);
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledLinkedinLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledLinkedinPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return A2($author$project$T2$Internal$Color$Extra$darken, 0.14, $author$project$T2$Internal$Color$Swatch$externalBrandLinkedin);
	} else {
		return A2($author$project$T2$Internal$Color$Extra$darken, 0.14, $author$project$T2$Internal$Color$Swatch$externalBrandLinkedin);
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledSecondaryDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledSecondaryEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen70;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen70;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledSecondaryFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledSecondaryHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen60;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledSecondaryLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledSecondaryPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledTwitterXDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$Swatch$externalBrandTwitterX = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 20, 23, 26);
var $author$project$T2$Internal$Color$bgButtonFilledTwitterXEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$externalBrandTwitterX;
	} else {
		return $author$project$T2$Internal$Color$Swatch$externalBrandTwitterX;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledTwitterXFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$externalBrandTwitterX;
	} else {
		return $author$project$T2$Internal$Color$Swatch$externalBrandTwitterX;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledTwitterXHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return A2($author$project$T2$Internal$Color$Extra$lighten, 0.16, $author$project$T2$Internal$Color$Swatch$externalBrandTwitterX);
	} else {
		return A2($author$project$T2$Internal$Color$Extra$lighten, 0.16, $author$project$T2$Internal$Color$Swatch$externalBrandTwitterX);
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledTwitterXPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return A2($author$project$T2$Internal$Color$Extra$lighten, 0.2, $author$project$T2$Internal$Color$Swatch$externalBrandTwitterX);
	} else {
		return A2($author$project$T2$Internal$Color$Extra$lighten, 0.2, $author$project$T2$Internal$Color$Swatch$externalBrandTwitterX);
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledWarningDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledWarningEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow20;
	}
};
var $author$project$T2$Internal$Color$Swatch$yellow05 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 166, 125, 44);
var $author$project$T2$Internal$Color$Swatch$yellow10 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 178, 134, 47);
var $author$project$T2$Internal$Color$bgButtonFilledWarningFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow05;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledWarningHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow20;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow10;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledWarningLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledWarningPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow05;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledWhatsappDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$Swatch$externalBrandWhatsapp = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 37, 211, 102);
var $author$project$T2$Internal$Color$bgButtonFilledWhatsappEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$externalBrandWhatsapp;
	} else {
		return $author$project$T2$Internal$Color$Swatch$externalBrandWhatsapp;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledWhatsappFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$externalBrandWhatsapp;
	} else {
		return $author$project$T2$Internal$Color$Swatch$externalBrandWhatsapp;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledWhatsappHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return A2($author$project$T2$Internal$Color$Extra$darken, 0.1, $author$project$T2$Internal$Color$Swatch$externalBrandWhatsapp);
	} else {
		return A2($author$project$T2$Internal$Color$Extra$darken, 0.1, $author$project$T2$Internal$Color$Swatch$externalBrandWhatsapp);
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledWhatsappLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonFilledWhatsappPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return A2($author$project$T2$Internal$Color$Extra$lighten, 0.08, $author$project$T2$Internal$Color$Swatch$externalBrandWhatsapp);
	} else {
		return A2($author$project$T2$Internal$Color$Extra$lighten, 0.08, $author$project$T2$Internal$Color$Swatch$externalBrandWhatsapp);
	}
};
var $author$project$T2$Internal$Color$bgButtonOutlinedDangerEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$Swatch$red00 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 77, 0, 0);
var $author$project$T2$Internal$Color$bgButtonOutlinedDangerFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red00;
	}
};
var $author$project$T2$Internal$Color$bgButtonOutlinedDangerHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgButtonOutlinedDangerPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red00;
	}
};
var $author$project$T2$Internal$Color$bgButtonOutlinedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgButtonOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgButtonOutlinedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgButtonOutlinedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgButtonOutlinedLoading = function (context) {
	return $author$project$T2$Internal$Color$Swatch$transparent;
};
var $author$project$T2$Internal$Color$bgButtonOutlinedPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgButtonOutlinedWarningEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$Swatch$yellow00 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 140, 106, 37);
var $author$project$T2$Internal$Color$Swatch$yellow95 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 248, 199);
var $author$project$T2$Internal$Color$bgButtonOutlinedWarningFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow00;
	}
};
var $author$project$T2$Internal$Color$bgButtonOutlinedWarningHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$Swatch$yellow80 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 239, 126);
var $author$project$T2$Internal$Color$bgButtonOutlinedWarningPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow01;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextDangerEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextDangerFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red00;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextDangerHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red00;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextDangerPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red00;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextOnlyDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextOnlyEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextOnlyFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextOnlyHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextOnlyLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextOnlyPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextSecondaryContentDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextSecondaryContentEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextSecondaryContentFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextSecondaryContentHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextSecondaryContentLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgButtonTextSecondaryContentPressed = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Border$RoundedAll = 0;
var $mdgriffith$elm_ui$Element$Border$roundEach = function (_v0) {
	var topLeft = _v0.bd;
	var topRight = _v0.be;
	var bottomLeft = _v0.aR;
	var bottomRight = _v0.aS;
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderRound,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			'br-' + ($elm$core$String$fromInt(topLeft) + ('-' + ($elm$core$String$fromInt(topRight) + ($elm$core$String$fromInt(bottomLeft) + ('-' + $elm$core$String$fromInt(bottomRight)))))),
			'border-radius',
			$elm$core$String$fromInt(topLeft) + ('px ' + ($elm$core$String$fromInt(topRight) + ('px ' + ($elm$core$String$fromInt(bottomRight) + ('px ' + ($elm$core$String$fromInt(bottomLeft) + 'px'))))))));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach = function (edges) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Border$roundEach(edges));
};
var $author$project$T2$Internal$Border$borderShapeAttr = function (borderShape) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContextAttribute(
		function (context) {
			var roundedValue = 10;
			switch (borderShape) {
				case 0:
					return $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(roundedValue);
				case 1:
					return $lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
						{aR: 0, aS: 0, bd: roundedValue, be: roundedValue});
				case 2:
					return $lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
						{aR: roundedValue, aS: roundedValue, bd: 0, be: 0});
				case 3:
					return $lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
						{aR: roundedValue, aS: 0, bd: roundedValue, be: 0});
				case 4:
					return $lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
						{aR: 0, aS: roundedValue, bd: 0, be: roundedValue});
				default:
					return $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(0);
			}
		});
};
var $author$project$T2$Border$borderRoundedDefault = $author$project$T2$Internal$Border$borderShapeAttr(0);
var $author$project$T2$Internal$Color$fgButtonAccentDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgButtonAccentEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$fgButtonAccentLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonElevatedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgButtonElevatedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonElevatedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray95;
	}
};
var $author$project$T2$Internal$Color$fgButtonElevatedLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledDangerDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledDangerEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledDangerLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledFacebookDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledFacebookEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledFacebookLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledLinkedinDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledLinkedinEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledLinkedinLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledSecondaryDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledSecondaryEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledSecondaryLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledTwitterXDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledTwitterXEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledTwitterXFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledWarningDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledWarningEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledWarningLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledWhatsappDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledWhatsappEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonFilledWhatsappLoading = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonOutlinedDangerEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red50;
	}
};
var $author$project$T2$Internal$Color$fgButtonOutlinedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$fgButtonOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonOutlinedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgButtonOutlinedLoading = function (context) {
	return $author$project$T2$Internal$Color$Swatch$gray60;
};
var $author$project$T2$Internal$Color$fgButtonOutlinedWarningEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow00;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$Color$fgButtonTextDangerEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red20;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red50;
	}
};
var $author$project$T2$Internal$Color$Swatch$externalBrandIndeed = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 37, 87, 167);
var $author$project$T2$Internal$Color$fgButtonTextIndeedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$externalBrandIndeed;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonTextIndeedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return A2($author$project$T2$Internal$Color$Extra$darken, 0.1, $author$project$T2$Internal$Color$Swatch$externalBrandIndeed);
	} else {
		return A2($author$project$T2$Internal$Color$Extra$darken, 0.1, $author$project$T2$Internal$Color$Swatch$white);
	}
};
var $author$project$T2$Internal$Color$fgButtonTextOnlyDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$fgButtonTextOnlyEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgButtonTextOnlyHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgButtonTextOnlyLoading = function (context) {
	return $author$project$T2$Internal$Color$Swatch$gray60;
};
var $author$project$T2$Internal$Color$fgButtonTextSecondaryContentDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$fgButtonTextSecondaryContentEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$Swatch$gray10 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 24, 24, 24);
var $author$project$T2$Internal$Color$Swatch$gray70 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 192, 191, 191);
var $author$project$T2$Internal$Color$fgButtonTextSecondaryContentHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray70;
	}
};
var $author$project$T2$Internal$Color$fgButtonTextSecondaryContentLoading = function (context) {
	return $author$project$T2$Internal$Color$Swatch$gray60;
};
var $author$project$T2$Internal$Button$internalRenderIconView = F5(
	function (iconAttrs, iconRendererOption, color, size, altText) {
		if (!iconRendererOption.$) {
			var iconRenderer = iconRendererOption.a;
			var iconSize = function () {
				switch (size) {
					case 0:
						return 1;
					case 1:
						return 2;
					default:
						return 4;
				}
			}();
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				iconAttrs,
				A4(iconRenderer, iconSize, color, $elm$core$Maybe$Nothing, altText));
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$none;
		}
	});
var $author$project$T2$Internal$Text$LabelLarge = 12;
var $author$project$T2$Text$labelLargeAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 12, color);
	});
var $author$project$T2$Internal$Spacing$spacing20 = 20;
var $author$project$T2$Internal$Button$renderButtonInternal = function (attrs) {
	return function (style) {
		return function (state) {
			return function (size) {
				return function (behaviour) {
					return function (leftIconRendererMaybe) {
						return function (rightIconRendererMaybe) {
							return function (label) {
								return function (altText) {
									return function (preserveLabel) {
										return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
											function (context) {
												var shadowAttrs = (style === 3) ? _List_fromArray(
													[$author$project$T2$Elevation$elevation1]) : _List_Nil;
												var paddingWithoutElement = function () {
													switch (size) {
														case 0:
															return $author$project$T2$Internal$Spacing$spacing8;
														case 1:
															return $author$project$T2$Internal$Spacing$spacing12;
														default:
															return $author$project$T2$Internal$Spacing$spacing16;
													}
												}();
												var paddingWithElement = function () {
													switch (size) {
														case 0:
															return $author$project$T2$Internal$Spacing$spacing12;
														case 1:
															return $author$project$T2$Internal$Spacing$spacing16;
														default:
															return $author$project$T2$Internal$Spacing$spacing20;
													}
												}();
												var loadingSpinnerInlined = function () {
													if (state === 2) {
														switch (size) {
															case 0:
																return $author$project$T2$LoadingSpinner$inlineLoadingSpinnerSmallX;
															case 1:
																return $author$project$T2$LoadingSpinner$inlineLoadingSpinnerSmallX;
															default:
																return $author$project$T2$LoadingSpinner$inlineLoadingSpinnerSmall;
														}
													} else {
														return $lucamug$elm_ui_with_context$Element$WithContext$none;
													}
												}();
												var cursorAttrs = ((state === 1) || (state === 2)) ? _List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
														$elm$html$Html$Attributes$class('tt-cursor-not-allowed'))
													]) : _List_fromArray(
													[$lucamug$elm_ui_with_context$Element$WithContext$pointer]);
												var buttonPaddingRight = function () {
													if (state === 2) {
														return paddingWithElement;
													} else {
														if (!rightIconRendererMaybe.$) {
															return paddingWithElement;
														} else {
															return paddingWithoutElement;
														}
													}
												}();
												var buttonPaddingLeft = function () {
													if (state === 2) {
														return paddingWithElement;
													} else {
														if (!leftIconRendererMaybe.$) {
															return paddingWithElement;
														} else {
															return paddingWithoutElement;
														}
													}
												}();
												var paddingAttrs = _List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
														{bi: 0, br: buttonPaddingLeft, bt: buttonPaddingRight, by: 0})
													]);
												var borderRadiusAttr = $author$project$T2$Border$borderRoundedDefault;
												var borderAttrs = function () {
													switch (style) {
														case 0:
															return _List_Nil;
														case 1:
															return ((state === 1) || (state === 2)) ? _List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$solid,
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
																	$author$project$T2$Internal$Color$fgButtonOutlinedDisabled(context))
																]) : _List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$solid,
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
																	$author$project$T2$Internal$Color$bcButtonOutlinedEnabled(context))
																]);
														case 2:
															return _List_Nil;
														case 3:
															return _List_Nil;
														case 4:
															return _List_Nil;
														case 5:
															return _List_Nil;
														case 6:
															return _List_Nil;
														case 7:
															return _List_Nil;
														case 8:
															return ((state === 1) || (state === 2)) ? _List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$solid,
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
																	$author$project$T2$Internal$Color$fgButtonOutlinedDisabled(context))
																]) : _List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$solid,
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
																	$author$project$T2$Internal$Color$bcButtonOutlinedDangerEnabled(context))
																]);
														case 9:
															return _List_Nil;
														case 10:
															return ((state === 1) || (state === 2)) ? _List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$solid,
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
																	$author$project$T2$Internal$Color$fgButtonOutlinedDisabled(context))
																]) : _List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$solid,
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
																	$author$project$T2$Internal$Color$bcButtonOutlinedWarningEnabled(context))
																]);
														case 11:
															return _List_Nil;
														case 12:
															return _List_Nil;
														case 13:
															return _List_Nil;
														case 14:
															return _List_Nil;
														case 15:
															return _List_Nil;
														default:
															return _List_Nil;
													}
												}();
												var ariaAttrs = ((state === 1) || (state === 2)) ? _List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
														A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true'))
													]) : _List_fromArray(
													[$lucamug$elm_ui_with_context$Element$WithContext$pointer]);
												var buttonAttrs = function () {
													var buttonHeight = function () {
														switch (size) {
															case 0:
																return $lucamug$elm_ui_with_context$Element$WithContext$px(36);
															case 1:
																return $lucamug$elm_ui_with_context$Element$WithContext$px(40);
															default:
																return $lucamug$elm_ui_with_context$Element$WithContext$px(48);
														}
													}();
													return A2(
														$elm$core$List$cons,
														borderRadiusAttr,
														_Utils_ap(
															cursorAttrs,
															_Utils_ap(
																ariaAttrs,
																_List_fromArray(
																	[
																		$lucamug$elm_ui_with_context$Element$WithContext$height(buttonHeight),
																		$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																		$elm$html$Html$Attributes$classList(
																			_List_fromArray(
																				[
																					_Utils_Tuple2('tt-element-hover-transition', true),
																					_Utils_Tuple2('tt-button', true)
																				])))
																	]))));
												}();
												var _v0 = function () {
													switch (style) {
														case 0:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonFilledFocused, $author$project$T2$Internal$Color$bgButtonFilledHovered, $author$project$T2$Internal$Color$bgButtonFilledPressed);
														case 1:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonOutlinedFocused, $author$project$T2$Internal$Color$bgButtonOutlinedHovered, $author$project$T2$Internal$Color$bgButtonOutlinedPressed);
														case 2:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonTextOnlyFocused, $author$project$T2$Internal$Color$bgButtonTextOnlyHovered, $author$project$T2$Internal$Color$bgButtonTextOnlyPressed);
														case 3:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonElevatedFocused, $author$project$T2$Internal$Color$bgButtonElevatedHovered, $author$project$T2$Internal$Color$bgButtonElevatedPressed);
														case 4:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonFilledSecondaryFocused, $author$project$T2$Internal$Color$bgButtonFilledSecondaryHovered, $author$project$T2$Internal$Color$bgButtonFilledSecondaryPressed);
														case 5:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonAccentFocused, $author$project$T2$Internal$Color$bgButtonAccentHovered, $author$project$T2$Internal$Color$bgButtonAccentPressed);
														case 6:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonFilledDangerFocused, $author$project$T2$Internal$Color$bgButtonFilledDangerHovered, $author$project$T2$Internal$Color$bgButtonFilledDangerPressed);
														case 7:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonFilledWarningFocused, $author$project$T2$Internal$Color$bgButtonFilledWarningHovered, $author$project$T2$Internal$Color$bgButtonFilledWarningPressed);
														case 8:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonOutlinedDangerFocused, $author$project$T2$Internal$Color$bgButtonOutlinedDangerHovered, $author$project$T2$Internal$Color$bgButtonOutlinedDangerPressed);
														case 9:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonTextDangerFocused, $author$project$T2$Internal$Color$bgButtonTextDangerHovered, $author$project$T2$Internal$Color$bgButtonTextDangerPressed);
														case 10:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonOutlinedWarningFocused, $author$project$T2$Internal$Color$bgButtonOutlinedWarningHovered, $author$project$T2$Internal$Color$bgButtonOutlinedWarningPressed);
														case 11:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonTextSecondaryContentFocused, $author$project$T2$Internal$Color$bgButtonTextSecondaryContentHovered, $author$project$T2$Internal$Color$bgButtonTextSecondaryContentPressed);
														case 12:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonFilledLinkedinFocused, $author$project$T2$Internal$Color$bgButtonFilledLinkedinHovered, $author$project$T2$Internal$Color$bgButtonFilledLinkedinPressed);
														case 13:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonFilledTwitterXFocused, $author$project$T2$Internal$Color$bgButtonFilledTwitterXHovered, $author$project$T2$Internal$Color$bgButtonFilledTwitterXPressed);
														case 14:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonFilledFacebookFocused, $author$project$T2$Internal$Color$bgButtonFilledFacebookHovered, $author$project$T2$Internal$Color$bgButtonFilledFacebookPressed);
														case 15:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonFilledWhatsappFocused, $author$project$T2$Internal$Color$bgButtonFilledWhatsappHovered, $author$project$T2$Internal$Color$bgButtonFilledWhatsappPressed);
														default:
															return _Utils_Tuple3($author$project$T2$Internal$Color$bgButtonTextOnlyFocused, $author$project$T2$Internal$Color$bgButtonTextOnlyHovered, $author$project$T2$Internal$Color$bgButtonTextOnlyPressed);
													}
												}();
												var bgFocused = _v0.a;
												var bgHovered = _v0.b;
												var bgPressed = _v0.c;
												var bgFocusedAttrs = ((state === 1) || (state === 2)) ? _List_Nil : _List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
														bgFocused(context))
													]);
												var bgHoveredAttrs = _List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
														bgHovered(context))
													]);
												var buttonPressedAttrs = ((state === 1) || (state === 2)) ? _List_Nil : _List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$mouseDown(
														_List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
																bgPressed(context))
															]))
													]);
												var _v2 = function () {
													var _v3 = _Utils_Tuple2(style, state);
													switch (_v3.b) {
														case 0:
															switch (_v3.a) {
																case 0:
																	var _v4 = _v3.a;
																	var _v5 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledEnabled, $author$project$T2$Internal$Color$bgButtonFilledEnabled);
																case 1:
																	var _v10 = _v3.a;
																	var _v11 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonOutlinedEnabled, $author$project$T2$Internal$Color$bgButtonOutlinedEnabled);
																case 2:
																	var _v16 = _v3.a;
																	var _v17 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonTextOnlyEnabled, $author$project$T2$Internal$Color$bgButtonTextOnlyEnabled);
																case 11:
																	var _v22 = _v3.a;
																	var _v23 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonTextSecondaryContentEnabled, $author$project$T2$Internal$Color$bgButtonTextSecondaryContentEnabled);
																case 3:
																	var _v28 = _v3.a;
																	var _v29 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonElevatedEnabled, $author$project$T2$Internal$Color$bgButtonElevatedEnabled);
																case 4:
																	var _v34 = _v3.a;
																	var _v35 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledSecondaryEnabled, $author$project$T2$Internal$Color$bgButtonFilledSecondaryEnabled);
																case 5:
																	var _v40 = _v3.a;
																	var _v41 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonAccentEnabled, $author$project$T2$Internal$Color$bgButtonAccentEnabled);
																case 6:
																	var _v46 = _v3.a;
																	var _v47 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledDangerEnabled, $author$project$T2$Internal$Color$bgButtonFilledDangerEnabled);
																case 7:
																	var _v52 = _v3.a;
																	var _v53 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledWarningEnabled, $author$project$T2$Internal$Color$bgButtonFilledWarningEnabled);
																case 8:
																	var _v58 = _v3.a;
																	var _v59 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonOutlinedDangerEnabled, $author$project$T2$Internal$Color$bgButtonOutlinedDangerEnabled);
																case 10:
																	var _v64 = _v3.a;
																	var _v65 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonOutlinedWarningEnabled, $author$project$T2$Internal$Color$bgButtonOutlinedWarningEnabled);
																case 9:
																	var _v70 = _v3.a;
																	var _v71 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonTextDangerEnabled, $author$project$T2$Internal$Color$bgButtonTextDangerEnabled);
																case 12:
																	var _v76 = _v3.a;
																	var _v77 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledLinkedinEnabled, $author$project$T2$Internal$Color$bgButtonFilledLinkedinEnabled);
																case 13:
																	var _v82 = _v3.a;
																	var _v83 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledTwitterXEnabled, $author$project$T2$Internal$Color$bgButtonFilledTwitterXEnabled);
																case 14:
																	var _v88 = _v3.a;
																	var _v89 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledFacebookEnabled, $author$project$T2$Internal$Color$bgButtonFilledFacebookEnabled);
																case 15:
																	var _v94 = _v3.a;
																	var _v95 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledWhatsappEnabled, $author$project$T2$Internal$Color$bgButtonFilledWhatsappEnabled);
																default:
																	var _v100 = _v3.a;
																	var _v101 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonTextIndeedEnabled, $author$project$T2$Internal$Color$bgButtonTextOnlyEnabled);
															}
														case 1:
															switch (_v3.a) {
																case 0:
																	var _v6 = _v3.a;
																	var _v7 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledDisabled, $author$project$T2$Internal$Color$bgButtonFilledDisabled);
																case 1:
																	var _v12 = _v3.a;
																	var _v13 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonOutlinedDisabled, $author$project$T2$Internal$Color$bgButtonOutlinedDisabled);
																case 2:
																	var _v18 = _v3.a;
																	var _v19 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonTextOnlyDisabled, $author$project$T2$Internal$Color$bgButtonTextOnlyDisabled);
																case 11:
																	var _v24 = _v3.a;
																	var _v25 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonTextSecondaryContentDisabled, $author$project$T2$Internal$Color$bgButtonTextSecondaryContentDisabled);
																case 3:
																	var _v30 = _v3.a;
																	var _v31 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonElevatedDisabled, $author$project$T2$Internal$Color$bgButtonElevatedDisabled);
																case 4:
																	var _v36 = _v3.a;
																	var _v37 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledSecondaryDisabled, $author$project$T2$Internal$Color$bgButtonFilledSecondaryDisabled);
																case 5:
																	var _v42 = _v3.a;
																	var _v43 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonAccentDisabled, $author$project$T2$Internal$Color$bgButtonAccentDisabled);
																case 6:
																	var _v48 = _v3.a;
																	var _v49 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledDangerDisabled, $author$project$T2$Internal$Color$bgButtonFilledDangerDisabled);
																case 7:
																	var _v54 = _v3.a;
																	var _v55 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledWarningDisabled, $author$project$T2$Internal$Color$bgButtonFilledWarningDisabled);
																case 8:
																	var _v60 = _v3.a;
																	var _v61 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonOutlinedDisabled, $author$project$T2$Internal$Color$bgButtonOutlinedDisabled);
																case 10:
																	var _v66 = _v3.a;
																	var _v67 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonOutlinedDisabled, $author$project$T2$Internal$Color$bgButtonOutlinedDisabled);
																case 9:
																	var _v72 = _v3.a;
																	var _v73 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonTextOnlyDisabled, $author$project$T2$Internal$Color$bgButtonTextOnlyDisabled);
																case 12:
																	var _v78 = _v3.a;
																	var _v79 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledLinkedinDisabled, $author$project$T2$Internal$Color$bgButtonFilledLinkedinDisabled);
																case 13:
																	var _v84 = _v3.a;
																	var _v85 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledTwitterXDisabled, $author$project$T2$Internal$Color$bgButtonFilledTwitterXDisabled);
																case 14:
																	var _v90 = _v3.a;
																	var _v91 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledFacebookDisabled, $author$project$T2$Internal$Color$bgButtonFilledFacebookDisabled);
																case 15:
																	var _v96 = _v3.a;
																	var _v97 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledWhatsappDisabled, $author$project$T2$Internal$Color$bgButtonFilledWhatsappDisabled);
																default:
																	var _v102 = _v3.a;
																	var _v103 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonTextOnlyDisabled, $author$project$T2$Internal$Color$bgButtonTextOnlyDisabled);
															}
														default:
															switch (_v3.a) {
																case 0:
																	var _v8 = _v3.a;
																	var _v9 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledLoading, $author$project$T2$Internal$Color$bgButtonFilledLoading);
																case 1:
																	var _v14 = _v3.a;
																	var _v15 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonOutlinedLoading, $author$project$T2$Internal$Color$bgButtonOutlinedLoading);
																case 2:
																	var _v20 = _v3.a;
																	var _v21 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonTextOnlyLoading, $author$project$T2$Internal$Color$bgButtonTextOnlyLoading);
																case 11:
																	var _v26 = _v3.a;
																	var _v27 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonTextSecondaryContentLoading, $author$project$T2$Internal$Color$bgButtonTextSecondaryContentLoading);
																case 3:
																	var _v32 = _v3.a;
																	var _v33 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonElevatedLoading, $author$project$T2$Internal$Color$bgButtonElevatedLoading);
																case 4:
																	var _v38 = _v3.a;
																	var _v39 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledSecondaryLoading, $author$project$T2$Internal$Color$bgButtonFilledSecondaryLoading);
																case 5:
																	var _v44 = _v3.a;
																	var _v45 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonAccentLoading, $author$project$T2$Internal$Color$bgButtonAccentLoading);
																case 6:
																	var _v50 = _v3.a;
																	var _v51 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledDangerLoading, $author$project$T2$Internal$Color$bgButtonFilledDangerLoading);
																case 7:
																	var _v56 = _v3.a;
																	var _v57 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledWarningLoading, $author$project$T2$Internal$Color$bgButtonFilledWarningLoading);
																case 8:
																	var _v62 = _v3.a;
																	var _v63 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonOutlinedLoading, $author$project$T2$Internal$Color$bgButtonOutlinedLoading);
																case 10:
																	var _v68 = _v3.a;
																	var _v69 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonOutlinedLoading, $author$project$T2$Internal$Color$bgButtonOutlinedLoading);
																case 9:
																	var _v74 = _v3.a;
																	var _v75 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonTextOnlyLoading, $author$project$T2$Internal$Color$bgButtonTextOnlyLoading);
																case 12:
																	var _v80 = _v3.a;
																	var _v81 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledLinkedinLoading, $author$project$T2$Internal$Color$bgButtonFilledLinkedinLoading);
																case 13:
																	var _v86 = _v3.a;
																	var _v87 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledTwitterXFocused, $author$project$T2$Internal$Color$bgButtonFilledTwitterXFocused);
																case 14:
																	var _v92 = _v3.a;
																	var _v93 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledFacebookLoading, $author$project$T2$Internal$Color$bgButtonFilledFacebookLoading);
																case 15:
																	var _v98 = _v3.a;
																	var _v99 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonFilledWhatsappLoading, $author$project$T2$Internal$Color$bgButtonFilledWhatsappLoading);
																default:
																	var _v104 = _v3.a;
																	var _v105 = _v3.b;
																	return _Utils_Tuple2($author$project$T2$Internal$Color$fgButtonTextOnlyLoading, $author$project$T2$Internal$Color$bgButtonTextOnlyLoading);
															}
													}
												}();
												var fgColor = _v2.a;
												var bgColor = _v2.b;
												var bgColorAttrs = ((state === 1) && (style === 1)) ? _List_Nil : _List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
														bgColor(context))
													]);
												var labelView = function () {
													var labelPaddingX = $author$project$T2$Internal$Spacing$spacing8;
													var fontColorHovered = function () {
														switch (style) {
															case 0:
																return $elm$core$Maybe$Nothing;
															case 1:
																return $elm$core$Maybe$Just(
																	$author$project$T2$Internal$Color$fgButtonOutlinedHovered(context));
															case 2:
																return $elm$core$Maybe$Just(
																	$author$project$T2$Internal$Color$fgButtonTextOnlyHovered(context));
															case 3:
																return $elm$core$Maybe$Just(
																	$author$project$T2$Internal$Color$fgButtonElevatedHovered(context));
															case 4:
																return $elm$core$Maybe$Nothing;
															case 5:
																return $elm$core$Maybe$Nothing;
															case 6:
																return $elm$core$Maybe$Nothing;
															case 7:
																return $elm$core$Maybe$Nothing;
															case 8:
																return $elm$core$Maybe$Nothing;
															case 9:
																return $elm$core$Maybe$Nothing;
															case 10:
																return $elm$core$Maybe$Nothing;
															case 11:
																return $elm$core$Maybe$Just(
																	$author$project$T2$Internal$Color$fgButtonTextSecondaryContentHovered(context));
															case 12:
																return $elm$core$Maybe$Nothing;
															case 13:
																return $elm$core$Maybe$Nothing;
															case 14:
																return $elm$core$Maybe$Nothing;
															case 15:
																return $elm$core$Maybe$Nothing;
															default:
																return $elm$core$Maybe$Just(
																	$author$project$T2$Internal$Color$fgButtonTextIndeedHovered(context));
														}
													}();
													var fontColorHoveredAttrs = function () {
														if ((state === 1) || (state === 2)) {
															return _List_Nil;
														} else {
															if (!fontColorHovered.$) {
																var color = fontColorHovered.a;
																return _List_fromArray(
																	[
																		$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
																		_List_fromArray(
																			[
																				$lucamug$elm_ui_with_context$Element$WithContext$Font$color(color)
																			]))
																	]);
															} else {
																return _List_Nil;
															}
														}
													}();
													var fontAttrs = function () {
														switch (size) {
															case 0:
																return A2(
																	$author$project$T2$Text$labelMediumAttrs,
																	_Utils_ap(
																		fontColorHoveredAttrs,
																		_List_fromArray(
																			[$lucamug$elm_ui_with_context$Element$WithContext$Font$center])),
																	fgColor(context));
															case 1:
																return A2(
																	$author$project$T2$Text$labelMediumAttrs,
																	_Utils_ap(
																		fontColorHoveredAttrs,
																		_List_fromArray(
																			[$lucamug$elm_ui_with_context$Element$WithContext$Font$center])),
																	fgColor(context));
															default:
																return A2(
																	$author$project$T2$Text$labelLargeAttrs,
																	_Utils_ap(
																		fontColorHoveredAttrs,
																		_List_fromArray(
																			[$lucamug$elm_ui_with_context$Element$WithContext$Font$center])),
																	fgColor(context));
														}
													}();
													return A2(
														$lucamug$elm_ui_with_context$Element$WithContext$el,
														_Utils_ap(
															_List_fromArray(
																[
																	A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, labelPaddingX, 0),
																	$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
																	$lucamug$elm_ui_with_context$Element$WithContext$alignLeft
																]),
															fontAttrs),
														$lucamug$elm_ui_with_context$Element$WithContext$text(
															preserveLabel ? label : $elm_community$string_extra$String$Extra$toSentenceCase(
																$elm$core$String$toLower(label))));
												}();
												var leftIconView = (state === 2) ? $lucamug$elm_ui_with_context$Element$WithContext$none : A5(
													$author$project$T2$Internal$Button$internalRenderIconView,
													_List_fromArray(
														[$lucamug$elm_ui_with_context$Element$WithContext$alignLeft]),
													leftIconRendererMaybe,
													fgColor(context),
													size,
													altText);
												var rightIconView = (state === 2) ? $lucamug$elm_ui_with_context$Element$WithContext$none : A5(
													$author$project$T2$Internal$Button$internalRenderIconView,
													_List_fromArray(
														[$lucamug$elm_ui_with_context$Element$WithContext$alignRight]),
													rightIconRendererMaybe,
													fgColor(context),
													size,
													altText);
												var buttonLabelView = A2(
													$lucamug$elm_ui_with_context$Element$WithContext$row,
													_Utils_ap(
														cursorAttrs,
														_List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
																$lucamug$elm_ui_with_context$Element$WithContext$centerX
															])),
													_List_fromArray(
														[loadingSpinnerInlined, leftIconView, labelView, rightIconView]));
												var _v106 = function () {
													switch (style) {
														case 0:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
														case 1:
															return ((state === 1) || (state === 2)) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
																$elm$core$Maybe$Just(
																	$author$project$T2$Internal$Color$bcButtonOutlinedHovered(context)),
																$elm$core$Maybe$Just(
																	$author$project$T2$Internal$Color$bcButtonOutlinedFocused(context)));
														case 2:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
														case 3:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
														case 4:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
														case 5:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
														case 6:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
														case 7:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
														case 8:
															return ((state === 1) || (state === 2)) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
																$elm$core$Maybe$Just(
																	$author$project$T2$Internal$Color$bcButtonOutlinedDangerHovered(context)),
																$elm$core$Maybe$Just(
																	$author$project$T2$Internal$Color$bcButtonOutlinedDangerFocused(context)));
														case 9:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
														case 10:
															return ((state === 1) || (state === 2)) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
																$elm$core$Maybe$Just(
																	$author$project$T2$Internal$Color$bcButtonOutlinedWarningHovered(context)),
																$elm$core$Maybe$Just(
																	$author$project$T2$Internal$Color$bcButtonOutlinedWarningFocused(context)));
														case 11:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
														case 12:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
														case 13:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
														case 14:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
														case 15:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
														default:
															return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
													}
												}();
												var bcHovered = _v106.a;
												var bcFocused = _v106.b;
												var bcFocusedAttrs = function () {
													if (!bcFocused.$) {
														var color = bcFocused.a;
														return _List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$Border$color(color)
															]);
													} else {
														return _List_Nil;
													}
												}();
												var buttonFocusedAttrs = _List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$focused(
														_Utils_ap(bcFocusedAttrs, bgFocusedAttrs))
													]);
												var bcHoveredAttrs = function () {
													if (!bcHovered.$) {
														var color = bcHovered.a;
														return _List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$Border$color(color)
															]);
													} else {
														return _List_Nil;
													}
												}();
												var buttonHoveredAttrs = ((state === 1) || (state === 2)) ? _List_Nil : _List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
														_Utils_ap(bgHoveredAttrs, bcHoveredAttrs))
													]);
												switch (behaviour.$) {
													case 0:
														return A2(
															$lucamug$elm_ui_with_context$Element$WithContext$Input$button,
															_Utils_ap(
																buttonAttrs,
																_Utils_ap(
																	paddingAttrs,
																	_Utils_ap(
																		borderAttrs,
																		_Utils_ap(
																			bgColorAttrs,
																			_Utils_ap(
																				buttonPressedAttrs,
																				_Utils_ap(
																					buttonFocusedAttrs,
																					_Utils_ap(
																						buttonHoveredAttrs,
																						_Utils_ap(shadowAttrs, attrs)))))))),
															{u: buttonLabelView, ew: $elm$core$Maybe$Nothing});
													case 1:
														var msg = behaviour.a;
														return A2(
															$lucamug$elm_ui_with_context$Element$WithContext$Input$button,
															_Utils_ap(
																buttonAttrs,
																_Utils_ap(
																	paddingAttrs,
																	_Utils_ap(
																		borderAttrs,
																		_Utils_ap(
																			bgColorAttrs,
																			_Utils_ap(
																				buttonPressedAttrs,
																				_Utils_ap(
																					buttonFocusedAttrs,
																					_Utils_ap(
																						buttonHoveredAttrs,
																						_Utils_ap(shadowAttrs, attrs)))))))),
															{
																u: buttonLabelView,
																ew: $elm$core$Maybe$Just(msg)
															});
													case 2:
														var url = behaviour.a;
														return A2(
															$lucamug$elm_ui_with_context$Element$WithContext$link,
															_Utils_ap(
																buttonAttrs,
																_Utils_ap(
																	paddingAttrs,
																	_Utils_ap(
																		borderAttrs,
																		_Utils_ap(
																			bgColorAttrs,
																			_Utils_ap(
																				buttonPressedAttrs,
																				_Utils_ap(
																					buttonFocusedAttrs,
																					_Utils_ap(
																						buttonHoveredAttrs,
																						_Utils_ap(shadowAttrs, attrs)))))))),
															{u: buttonLabelView, R: url});
													default:
														var url = behaviour.a;
														return A2(
															$lucamug$elm_ui_with_context$Element$WithContext$newTabLink,
															_Utils_ap(
																buttonAttrs,
																_Utils_ap(
																	paddingAttrs,
																	_Utils_ap(
																		borderAttrs,
																		_Utils_ap(
																			bgColorAttrs,
																			_Utils_ap(
																				buttonPressedAttrs,
																				_Utils_ap(
																					buttonFocusedAttrs,
																					_Utils_ap(
																						buttonHoveredAttrs,
																						_Utils_ap(shadowAttrs, attrs)))))))),
															{u: buttonLabelView, R: url});
												}
											});
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$T2$Internal$Button$renderButton = F9(
	function (attrs, style, state, size, behaviour, leftIconRendererMaybe, rightIconRendererMaybe, label, altText) {
		return $author$project$T2$Internal$Button$renderButtonInternal(attrs)(style)(state)(size)(behaviour)(leftIconRendererMaybe)(rightIconRendererMaybe)(label)(altText)(false);
	});
var $author$project$T2$Button$linkButtonFilledSecondaryEnabledMedium = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			4,
			0,
			1,
			$author$project$T2$Internal$Button$LinkForCurrentPage(url),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $author$project$T2$Internal$Button$TextContentSecondary = 11;
var $author$project$T2$Button$linkButtonTextContentSecondaryEnabledMedium = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			11,
			0,
			1,
			$author$project$T2$Internal$Button$LinkForCurrentPage(url),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $author$project$T2$Button$linkButtonTextContentSecondaryEnabledMediumWithLeftIcon = F3(
	function (attrs, icon, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			11,
			0,
			1,
			$author$project$T2$Internal$Button$LinkForCurrentPage(url),
			$elm$core$Maybe$Just(icon),
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $author$project$T2$Internal$Button$TextOnly = 2;
var $author$project$T2$Button$linkButtonTextEnabledMedium = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			2,
			0,
			1,
			$author$project$T2$Internal$Button$LinkForCurrentPage(url),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $author$project$T2$Internal$IconButton$LinkForCurrentPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$T2$IconButton$linkIconButtonIconTertiaryEnabledMedium = F3(
	function (attrs, icon, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A7(
			$author$project$T2$Internal$IconButton$renderIconButton,
			attrs,
			3,
			0,
			1,
			$author$project$T2$Internal$IconButton$LinkForCurrentPage(url),
			icon,
			label);
	});
var $author$project$T2$Internal$Color$linkIndicatorActiveTopBar = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	}
};
var $author$project$T2$Internal$ListItem$Enabled = 0;
var $author$project$T2$Internal$ListItem$LinkForCurrentPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$T2$Internal$ListItem$OneLine = 0;
var $author$project$T2$Internal$ListItem$Small = 0;
var $author$project$T2$Internal$ListItem$Disabled = 1;
var $author$project$T2$Internal$ListItem$Selected = 2;
var $mdgriffith$elm_ui$Element$Font$alignRight = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.kp);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$alignRight = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$alignRight);
var $author$project$T2$Internal$Color$bgListItemDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgListItemEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$Swatch$green20 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 74, 57);
var $author$project$T2$Internal$Color$bgListItemFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green20;
	}
};
var $author$project$T2$Internal$Color$bgListItemHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$bgListItemSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green20;
	}
};
var $author$project$T2$Internal$Color$fgListItemDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	}
};
var $author$project$T2$Internal$Color$fgListItemEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgListItemSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green90;
	}
};
var $author$project$T2$Internal$Color$fgSecListItemEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$ListItem$internalRenderIconView = F4(
	function (iconOption, color, size, altText) {
		if (!iconOption.$) {
			var iconRenderer = iconOption.a;
			var iconSize = function () {
				switch (size) {
					case 0:
						return 1;
					case 1:
						return 2;
					default:
						return 4;
				}
			}();
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_Nil,
				A4(iconRenderer, iconSize, color, $elm$core$Maybe$Nothing, altText));
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$none;
		}
	});
var $author$project$T2$Internal$Text$ParagraphLarge = 17;
var $author$project$T2$Text$paragraphLargeAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 17, color);
	});
var $author$project$T2$Internal$Text$ParagraphLargeBold = 22;
var $author$project$T2$Text$paragraphLargeBoldAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 22, color);
	});
var $author$project$T2$Internal$Text$ParagraphMediumBold = 24;
var $author$project$T2$Text$paragraphMediumBoldAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 24, color);
	});
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $author$project$T2$Internal$ListItem$renderListItem = F9(
	function (attrs, style, state, size, behaviour, leftIconMaybe, rightIconMaybe, label, secondaryInfo) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var secondaryLabelFontAttrs = function () {
					switch (size) {
						case 0:
							return $author$project$T2$Text$paragraphSmallXAttrs;
						case 1:
							return $author$project$T2$Text$paragraphSmallAttrs;
						default:
							return $author$project$T2$Text$paragraphMediumAttrs;
					}
				}();
				var primaryLabelFontAttrs = function () {
					switch (size) {
						case 0:
							return (state === 2) ? $author$project$T2$Text$paragraphSmallBoldAttrs : $author$project$T2$Text$paragraphSmallAttrs;
						case 1:
							return (state === 2) ? $author$project$T2$Text$paragraphMediumBoldAttrs : $author$project$T2$Text$paragraphMediumAttrs;
						default:
							return (state === 2) ? $author$project$T2$Text$paragraphLargeBoldAttrs : $author$project$T2$Text$paragraphLargeAttrs;
					}
				}();
				var itemSpacing = function () {
					switch (size) {
						case 0:
							return $author$project$T2$Internal$Spacing$spacing12;
						case 1:
							return $author$project$T2$Internal$Spacing$spacing16;
						default:
							return $author$project$T2$Internal$Spacing$spacing16;
					}
				}();
				var itemHeight = function () {
					switch (size) {
						case 0:
							if (!style) {
								return 36;
							} else {
								return 52;
							}
						case 1:
							if (!style) {
								return 40;
							} else {
								return 60;
							}
						default:
							if (!style) {
								return 44;
							} else {
								return 68;
							}
					}
				}();
				var itemAttrs = _Utils_ap(
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(itemSpacing),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							$lucamug$elm_ui_with_context$Element$WithContext$px(itemHeight)),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('tt-element-hover-transition'))
						]),
					attrs);
				var borderAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
						{bi: $author$project$T2$Internal$Spacing$spacing8, br: $author$project$T2$Internal$Spacing$spacing16, bt: $author$project$T2$Internal$Spacing$spacing24, by: $author$project$T2$Internal$Spacing$spacing8})
					]);
				var bgHovered = function () {
					switch (state) {
						case 0:
							return $author$project$T2$Internal$Color$bgListItemHovered;
						case 1:
							return $author$project$T2$Internal$Color$bgListItemDisabled;
						default:
							return $author$project$T2$Internal$Color$bgListItemHovered;
					}
				}();
				var bgHoveredAttrs = (state === 1) ? _List_Nil : _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								bgHovered(context))
							]))
					]);
				var bgFocused = function () {
					switch (state) {
						case 0:
							return $author$project$T2$Internal$Color$bgListItemFocused;
						case 1:
							return $author$project$T2$Internal$Color$bgListItemDisabled;
						default:
							return $author$project$T2$Internal$Color$bgListItemFocused;
					}
				}();
				var bgFocusedAttrs = (state === 1) ? _List_Nil : _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$focused(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								bgFocused(context))
							]))
					]);
				var _v0 = function () {
					switch (state) {
						case 0:
							return _Utils_Tuple3($author$project$T2$Internal$Color$bgListItemEnabled, $author$project$T2$Internal$Color$fgListItemEnabled, $author$project$T2$Internal$Color$fgSecListItemEnabled);
						case 1:
							return _Utils_Tuple3($author$project$T2$Internal$Color$bgListItemDisabled, $author$project$T2$Internal$Color$fgListItemDisabled, $author$project$T2$Internal$Color$fgListItemDisabled);
						default:
							return _Utils_Tuple3($author$project$T2$Internal$Color$bgListItemSelected, $author$project$T2$Internal$Color$fgListItemSelected, $author$project$T2$Internal$Color$fgListItemSelected);
					}
				}();
				var bgColor = _v0.a;
				var fgColor = _v0.b;
				var fgSecColor = _v0.c;
				var bgColorAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						bgColor(context))
					]);
				var listItemBaseAttrs = _Utils_ap(
					borderAttrs,
					_Utils_ap(
						bgColorAttrs,
						_Utils_ap(
							bgFocusedAttrs,
							_Utils_ap(bgHoveredAttrs, itemAttrs))));
				var leftIconView = A4(
					$author$project$T2$Internal$ListItem$internalRenderIconView,
					leftIconMaybe,
					fgSecColor(context),
					size,
					label);
				var rightIconView = A4(
					$author$project$T2$Internal$ListItem$internalRenderIconView,
					rightIconMaybe,
					fgSecColor(context),
					size,
					label);
				var textView = function () {
					if (!style) {
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing12),
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
									A2(
										$elm$core$List$cons,
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										A2(
											primaryLabelFontAttrs,
											_List_Nil,
											fgColor(context))),
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$text(label)
										])),
									function () {
									if (!secondaryInfo.$) {
										var info = secondaryInfo.a;
										return A2(
											$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
											_Utils_ap(
												_List_fromArray(
													[$lucamug$elm_ui_with_context$Element$WithContext$alignRight, $lucamug$elm_ui_with_context$Element$WithContext$Font$alignRight]),
												A2(
													secondaryLabelFontAttrs,
													_List_Nil,
													fgSecColor(context))),
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$text(info)
												]));
									} else {
										return $lucamug$elm_ui_with_context$Element$WithContext$none;
									}
								}()
								]));
					} else {
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing4 + 2)
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
									A2(
										primaryLabelFontAttrs,
										_List_Nil,
										fgColor(context)),
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$text(label)
										])),
									function () {
									if (!secondaryInfo.$) {
										var info = secondaryInfo.a;
										return A2(
											$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
											A2(
												secondaryLabelFontAttrs,
												_List_Nil,
												fgSecColor(context)),
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$text(info)
												]));
									} else {
										return $lucamug$elm_ui_with_context$Element$WithContext$none;
									}
								}()
								]));
					}
				}();
				var listItemLabelView = _List_fromArray(
					[leftIconView, textView, rightIconView]);
				switch (behaviour.$) {
					case 0:
						return A2($lucamug$elm_ui_with_context$Element$WithContext$row, listItemBaseAttrs, listItemLabelView);
					case 1:
						var onSelectMsg = behaviour.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							_Utils_ap(
								listItemBaseAttrs,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(onSelectMsg),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2(
											$elm$html$Html$Events$stopPropagationOn,
											'click',
											$elm$json$Json$Decode$succeed(
												_Utils_Tuple2(onSelectMsg, true)))),
										$lucamug$elm_ui_with_context$Element$WithContext$pointer
									])),
							listItemLabelView);
					case 2:
						var url = behaviour.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$link,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							{
								u: A2($lucamug$elm_ui_with_context$Element$WithContext$row, listItemBaseAttrs, listItemLabelView),
								R: url
							});
					default:
						var url = behaviour.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$newTabLink,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							{
								u: A2($lucamug$elm_ui_with_context$Element$WithContext$row, listItemBaseAttrs, listItemLabelView),
								R: url
							});
				}
			});
	});
var $author$project$T2$ListItem$linkListItemOneLineEnabledSmall = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A9(
			$author$project$T2$Internal$ListItem$renderListItem,
			attrs,
			0,
			0,
			0,
			$author$project$T2$Internal$ListItem$LinkForCurrentPage(url),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			$elm$core$Maybe$Nothing);
	});
var $mdgriffith$elm_ui$Element$moveDown = function (y) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveY,
		$mdgriffith$elm_ui$Internal$Model$MoveY(y));
};
var $lucamug$elm_ui_with_context$Element$WithContext$moveDown = function (y) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attr(
		$mdgriffith$elm_ui$Element$moveDown(y));
};
var $mdgriffith$elm_ui$Internal$Model$MoveX = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$moveX = $mdgriffith$elm_ui$Internal$Flag$flag(25);
var $mdgriffith$elm_ui$Element$moveRight = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveX,
		$mdgriffith$elm_ui$Internal$Model$MoveX(x));
};
var $lucamug$elm_ui_with_context$Element$WithContext$moveRight = function (x) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attr(
		$mdgriffith$elm_ui$Element$moveRight(x));
};
var $author$project$T2$Internal$Icon$internalNotification = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#notification');
	});
var $author$project$T2$Icon$notification = $author$project$T2$Internal$Icon$internalNotification;
var $mdgriffith$elm_ui$Internal$Model$OnLeft = 3;
var $mdgriffith$elm_ui$Element$onLeft = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 3, element);
};
var $lucamug$elm_ui_with_context$Element$WithContext$onLeft = $lucamug$elm_ui_with_context$Element$WithContext$createNearby($mdgriffith$elm_ui$Element$onLeft);
var $author$project$T2$Internal$Color$bcMenuDivider = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	}
};
var $author$project$T2$Internal$Color$bgMenu = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Menu$renderMenu = F2(
	function (attrs, listOfContentElList) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var viewDividerBetweenItems = function (contentList) {
					return A2(
						$elm$core$List$cons,
						A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							$author$project$T2$Divider$divider1(
								$author$project$T2$Internal$Color$bcMenuDivider(context))),
						contentList);
				};
				var listOfContentElListWithDividers = function () {
					if (!listOfContentElList.b) {
						return _List_Nil;
					} else {
						var h = listOfContentElList.a;
						var t = listOfContentElList.b;
						return _Utils_ap(
							h,
							A2($elm$core$List$concatMap, viewDividerBetweenItems, t));
					}
				}();
				var bgColor = $author$project$T2$Internal$Color$bgMenu;
				var itemAttrs = _Utils_ap(
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$author$project$T2$Elevation$elevation1,
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
							bgColor(context)),
							$author$project$T2$Border$borderRoundedDefault,
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, $author$project$T2$Internal$Spacing$spacing8),
							$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8)
						]),
					attrs);
				return A2($lucamug$elm_ui_with_context$Element$WithContext$column, itemAttrs, listOfContentElListWithDividers);
			});
	});
var $author$project$T2$Internal$Icon$internalStar = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#star');
	});
var $author$project$T2$Icon$star = $author$project$T2$Internal$Icon$internalStar;
var $author$project$T2$Internal$Icon$internalUser = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#user');
	});
var $author$project$T2$Icon$user = $author$project$T2$Internal$Icon$internalUser;
var $author$project$T2$Util$lastActionReadableTime = F2(
	function (timeInMillis, currentTime) {
		var timeDifference = $elm$time$Time$posixToMillis(currentTime) - $elm$time$Time$posixToMillis(timeInMillis);
		var seconds = (timeDifference / 1000) | 0;
		var minutes = (seconds / 60) | 0;
		var hours = (minutes / 60) | 0;
		var days = (hours / 24) | 0;
		var months = (days / 30) | 0;
		var years = (days / 365) | 0;
		return (seconds < 1) ? 'Hace 1 segundo' : ((seconds < 60) ? ('Hace ' + ($elm$core$String$fromInt(seconds) + ' segundos')) : ((minutes < 60) ? ('Hace ' + ($elm$core$String$fromInt(minutes) + ' minutos')) : ((hours < 24) ? ('Hace ' + ($elm$core$String$fromInt(hours) + ' horas')) : ((days < 30) ? ('Hace ' + ($elm$core$String$fromInt(days) + ' días')) : ((months < 12) ? ('Hace ' + ($elm$core$String$fromInt(months) + ' meses')) : ('Hace ' + ($elm$core$String$fromInt(years) + ' años')))))));
	});
var $author$project$T2$Internal$ListItem$TwoLines = 1;
var $author$project$T2$ListItem$linkListItemTwoLinesEnabledSmallWithLeftIcon = F5(
	function (attrs, icon, url, label, secondaryInfo) {
		return A9(
			$author$project$T2$Internal$ListItem$renderListItem,
			attrs,
			1,
			0,
			0,
			$author$project$T2$Internal$ListItem$LinkForCurrentPage(url),
			$elm$core$Maybe$Just(icon),
			$elm$core$Maybe$Nothing,
			label,
			$elm$core$Maybe$Just(secondaryInfo));
	});
var $author$project$T2$Internal$Icon$internalStarFilled = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + ('; --icon-fill: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))))
				]),
			'#star-filled');
	});
var $author$project$T2$Icon$starFilled = $author$project$T2$Internal$Icon$internalStarFilled;
var $author$project$T2$Internal$TopBar$viewSavedJobAdCardNotification = F2(
	function (currentTimePosix, tkFavoriteNotificationFromLocalStorage) {
		var savedAtHumanReadable = A2(
			$author$project$T2$Util$lastActionReadableTime,
			$elm$time$Time$millisToPosix(tkFavoriteNotificationFromLocalStorage.jM),
			currentTimePosix);
		return A5(
			$author$project$T2$ListItem$linkListItemTwoLinesEnabledSmallWithLeftIcon,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					A2($elm$html$Html$Attributes$attribute, 'role', 'option')),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$tabindex(-1)),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class('favorite-notification-card')),
					$lucamug$elm_ui_with_context$Element$WithContext$focused(_List_Nil)
				]),
			$author$project$T2$Icon$starFilled,
			'/tus-empleos-guardados',
			tkFavoriteNotificationFromLocalStorage.jb,
			'agregado como favorito - ' + savedAtHumanReadable);
	});
var $author$project$T2$Internal$TopBar$viewMobileNotificationDrawer = F3(
	function (showNotifications, notificationsMenuInfo, context) {
		if (showNotifications) {
			var favoritesRecentlyAdded = notificationsMenuInfo.cw.c0.eO;
			var favoritesAdded = notificationsMenuInfo.cw.c0.fI;
			var showNoNotificationsFound = (!$elm$core$List$length(favoritesRecentlyAdded)) && (!$elm$core$List$length(favoritesAdded));
			var currentTimePosix = notificationsMenuInfo.dP;
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width(
						$lucamug$elm_ui_with_context$Element$WithContext$px(context.S.dp - 100))
					]),
				A2(
					$author$project$T2$Internal$Menu$renderMenu,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'z-index', '1000')),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$attribute, 'role', 'listbox')),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$id('notification-container'))
						]),
					_List_fromArray(
						[
							showNoNotificationsFound ? _List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								A2(
									$author$project$T2$Text$paragraphMediumAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Font$center,
											A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0)
										]),
									$author$project$T2$Internal$Color$contentPrimary(context)),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text('No existe actividad reciente')
									]))
							]) : _Utils_ap(
							A2(
								$elm$core$List$map,
								$author$project$T2$Internal$TopBar$viewSavedJobAdCardNotification(currentTimePosix),
								favoritesRecentlyAdded),
							A2(
								$elm$core$List$map,
								$author$project$T2$Internal$TopBar$viewSavedJobAdCardNotification(currentTimePosix),
								favoritesAdded))
						])));
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$none;
		}
	});
var $lucamug$elm_ui_with_context$Element$WithContext$withAttribute = F2(
	function (selector, f) {
		return function (context) {
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$Internal$runAttr,
				context,
				f(
					selector(context)));
		};
	});
var $author$project$T2$Internal$TopBar$renderNavigationTopBar = F9(
	function (urlPath, internalUserInfo, internalModel, notificationsMenuInfoMaybe, serverInfoLabelMaybe, toggleUserAccountSubmenuMsg, toggleMobileNavigationDrawerMsg, toggleThemeMsg, hideUserAccountSubmenuMsg) {
		var viewUserAccountSubmenu = F2(
			function (isRecruiter, closeSessionUrl) {
				return internalModel.dj ? A2(
					$author$project$T2$Internal$Menu$renderMenu,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$moveDown(4),
							$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
							$lucamug$elm_ui_with_context$Element$WithContext$width(
							A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 180, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'z-index', '1000')),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$attribute, 'role', 'listbox'))
						]),
					_List_fromArray(
						[
							_List_fromArray(
							[
								isRecruiter ? A2(
								$author$project$T2$ListItem$linkListItemOneLineEnabledSmall,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$attribute, 'role', 'option')),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$tabindex(-1)),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$attribute, 'data-dropdown-id', 'user-account-control')),
										$lucamug$elm_ui_with_context$Element$WithContext$focused(_List_Nil)
									]),
								{u: 'Editar perfil', R: '/reclutador/editar-perfil/'}) : $lucamug$elm_ui_with_context$Element$WithContext$none,
								A2(
								$author$project$T2$ListItem$linkListItemOneLineEnabledSmall,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$attribute, 'role', 'option')),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$tabindex(-1)),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$attribute, 'data-dropdown-id', 'user-account-control')),
										$lucamug$elm_ui_with_context$Element$WithContext$focused(_List_Nil)
									]),
								{
									u: 'Cambiar contraseña',
									R: isRecruiter ? '/reclutador/editar-perfil?tab=seguridad' : '/candidato/cambia-tu-contrasena'
								})
							]),
							_List_fromArray(
							[
								A2(
								$author$project$T2$ListItem$linkListItemOneLineEnabledSmall,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$attribute, 'role', 'option')),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$tabindex(-1)),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$attribute, 'data-dropdown-id', 'user-account-control')),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('talapoin-logout')),
										$lucamug$elm_ui_with_context$Element$WithContext$focused(_List_Nil)
									]),
								{u: 'Cerrar sesión', R: closeSessionUrl})
							])
						])) : $lucamug$elm_ui_with_context$Element$WithContext$none;
			});
		var usersAccessUrlPath = '/acceder';
		var themeTogglerIconButton = function (context) {
			var _v9 = context.cF;
			if (!_v9) {
				return A4($author$project$T2$IconButton$iconButtonIconEnabledMedium, _List_Nil, toggleThemeMsg, $author$project$T2$Icon$moon, 'Cambiar a modo oscuro');
			} else {
				return A4($author$project$T2$IconButton$iconButtonIconEnabledMedium, _List_Nil, toggleThemeMsg, $author$project$T2$Icon$sun, 'Cambiar a modo claro');
			}
		};
		var serverInfoLabelAttr = function (context) {
			if (!serverInfoLabelMaybe.$) {
				var serverInfoLabel = serverInfoLabelMaybe.a;
				return _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$below(
						A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							_Utils_ap(
								A2(
									$author$project$T2$Text$labelSmalXAttrs,
									_List_Nil,
									$author$project$T2$Internal$Color$contentSecondary(context)),
								(!context.bT) ? _List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width(
										$lucamug$elm_ui_with_context$Element$WithContext$px(300))
									]) : _List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width(
										$lucamug$elm_ui_with_context$Element$WithContext$px(480))
									])),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text(serverInfoLabel)
								])))
					]);
			} else {
				return _List_Nil;
			}
		};
		var publishJobAdUrlPath = '/reclutador/publicar';
		var jobAdSearchUrlPath = '/empleos';
		var jobAdFavoritesPublicAreaUrlPath = '/tus-empleos-guardados';
		var viewLoggedInUserSectionMediumToLargeScreens = F3(
			function (loggedUserInfo, isRecruiter, context) {
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing24),
							$lucamug$elm_ui_with_context$Element$WithContext$alignRight
						]),
					_List_fromArray(
						[
							isRecruiter ? $lucamug$elm_ui_with_context$Element$WithContext$none : A3(
							$author$project$T2$IconButton$linkIconButtonIconTertiaryEnabledMedium,
							_List_Nil,
							$author$project$T2$Icon$star,
							{u: 'Favoritos', R: jobAdFavoritesPublicAreaUrlPath}),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, $author$project$T2$Internal$Spacing$spacing12, $author$project$T2$Internal$Spacing$spacing4),
									$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(10),
									$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8),
									$lucamug$elm_ui_with_context$Element$WithContext$pointer,
									$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(toggleUserAccountSubmenuMsg),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('talapoin-account-menu')),
									A2($author$project$T2$Internal$TopBar$internalOnBlurAttribute, 'user-account-control', hideUserAccountSubmenuMsg),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('tt-element-hover-transition', true),
												_Utils_Tuple2('tt-button', true)
											]))),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$attribute, 'data-dropdown-id', 'user-account-control')),
									$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
											$author$project$T2$Internal$Color$bgUserAccountButtonTopBarHovered(context))
										])),
									$lucamug$elm_ui_with_context$Element$WithContext$focused(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
											$author$project$T2$Internal$Color$bgUserAccountButtonTopBarFocused(context))
										])),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$tabindex(0)),
									$lucamug$elm_ui_with_context$Element$WithContext$below(
									A2(viewUserAccountSubmenu, isRecruiter, loggedUserInfo.gw))
								]),
							_List_fromArray(
								[
									function () {
									var _v7 = loggedUserInfo.eM;
									if (!_v7.$) {
										var profilePictureUrl = _v7.a;
										return A3($author$project$T2$Avatar$avatarImageEnabledMedium, _List_Nil, profilePictureUrl, loggedUserInfo.c1);
									} else {
										return A2($author$project$T2$Avatar$avatarSecondaryEnabledMedium, _List_Nil, loggedUserInfo.c1);
									}
								}(),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing4)
										]),
									_List_fromArray(
										[
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$row,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing4)
												]),
											_List_fromArray(
												[
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
													A2(
														$author$project$T2$Text$labelSmallAttrs,
														_List_Nil,
														$author$project$T2$Internal$Color$fgUserFullnameTopBar(context)),
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$text(loggedUserInfo.c1)
														])),
													A4(
													$author$project$T2$Internal$Icon$internalChevronDown,
													1,
													$author$project$T2$Internal$Color$fgUserMenuIconTopBar(context),
													$elm$core$Maybe$Nothing,
													'abrir menu')
												])),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
											A2(
												$author$project$T2$Text$labelSmalXAttrs,
												_List_Nil,
												$author$project$T2$Internal$Color$fgUserEmailTopBar(context)),
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$text(loggedUserInfo.cl)
												]))
										]))
								])),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_Nil,
							_List_fromArray(
								[
									themeTogglerIconButton(context)
								]))
						]));
			});
		var viewNotificationsTopBarEl = function (notificationsMenuInfo) {
			return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
				function (context) {
					var counter = notificationsMenuInfo.cw.dL;
					return (counter > 0) ? A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$pointer,
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$id('mobile-icon-bell-with-notification'))
							]),
						_List_fromArray(
							[
								A4(
								$author$project$T2$IconButton$iconButtonIconTertiaryEnabledMedium,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$inFront(
										A2(
											$author$project$T2$Badge$badgePrimaryXSmall,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$moveRight(20)
												]),
											$elm$core$String$fromInt(counter)))
									]),
								notificationsMenuInfo.cx,
								$author$project$T2$Icon$notification,
								'Notificaciones'),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$onLeft(
										A3($author$project$T2$Internal$TopBar$viewMobileNotificationDrawer, internalModel.e8, notificationsMenuInfo, context))
									]),
								$lucamug$elm_ui_with_context$Element$WithContext$none)
							])) : A3(
						$author$project$T2$IconButton$linkIconButtonIconTertiaryEnabledMedium,
						_List_Nil,
						$author$project$T2$Icon$star,
						{u: 'Favoritos', R: jobAdFavoritesPublicAreaUrlPath});
				});
		};
		var viewLoggedInUserSectionSmallScreens = F2(
			function (loggedUserInfo, isRecruiter) {
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing12),
							$lucamug$elm_ui_with_context$Element$WithContext$alignRight
						]),
					_List_fromArray(
						[
							function () {
							if (isRecruiter) {
								return $lucamug$elm_ui_with_context$Element$WithContext$none;
							} else {
								if (!notificationsMenuInfoMaybe.$) {
									var notificationMenuInfo = notificationsMenuInfoMaybe.a;
									return viewNotificationsTopBarEl(notificationMenuInfo);
								} else {
									return A3(
										$author$project$T2$IconButton$linkIconButtonIconTertiaryEnabledMedium,
										_List_Nil,
										$author$project$T2$Icon$star,
										{u: 'Favoritos', R: jobAdFavoritesPublicAreaUrlPath});
								}
							}
						}(),
							A4(
							$author$project$T2$IconButton$iconButtonIconTertiaryEnabledMedium,
							_List_fromArray(
								[
									A2($author$project$T2$Internal$TopBar$internalOnBlurAttribute, 'user-account-control', hideUserAccountSubmenuMsg),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$attribute, 'data-dropdown-id', 'user-account-control')),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$tabindex(0)),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('talapoin-account-menu')),
									$lucamug$elm_ui_with_context$Element$WithContext$below(
									A2(viewUserAccountSubmenu, isRecruiter, loggedUserInfo.gw))
								]),
							toggleUserAccountSubmenuMsg,
							$author$project$T2$Icon$user,
							'Abrir menú de usuario')
						]));
			});
		var isActiveLinkItemAttrs = _List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$below(
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							$lucamug$elm_ui_with_context$Element$WithContext$px(4)),
							A2($lucamug$elm_ui_with_context$Element$WithContext$withAttribute, $author$project$T2$Internal$Color$linkIndicatorActiveTopBar, $lucamug$elm_ui_with_context$Element$WithContext$Background$color),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(10),
							$lucamug$elm_ui_with_context$Element$WithContext$moveDown(8)
						]),
					$lucamug$elm_ui_with_context$Element$WithContext$none))
			]);
		var mediumToLargeScreensTopBar = function (context) {
			var isSidebarPresent = !_Utils_eq(internalUserInfo, $author$project$T2$Internal$TopBar$Visitor);
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$row,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Region$navigation,
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						$lucamug$elm_ui_with_context$Element$WithContext$px($author$project$T2$Internal$Spacing$spacing64)),
						$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
						function () {
							var _v3 = context.bT;
							switch (_v3) {
								case 0:
									return {bi: 0, br: $author$project$T2$Internal$Spacing$spacing16, bt: $author$project$T2$Internal$Spacing$spacing16, by: 0};
								case 1:
									return {
										bi: 0,
										br: isSidebarPresent ? $author$project$T2$Internal$Spacing$spacing16 : $author$project$T2$Internal$Spacing$spacing36,
										bt: $author$project$T2$Internal$Spacing$spacing36,
										by: 0
									};
								case 2:
									return {
										bi: 0,
										br: isSidebarPresent ? $author$project$T2$Internal$Spacing$spacing16 : $author$project$T2$Internal$Spacing$spacing64,
										bt: $author$project$T2$Internal$Spacing$spacing64,
										by: 0
									};
								default:
									return {
										bi: 0,
										br: isSidebarPresent ? $author$project$T2$Internal$Spacing$spacing16 : $author$project$T2$Internal$Spacing$spacing64,
										bt: $author$project$T2$Internal$Spacing$spacing64,
										by: 0
									};
							}
						}())
					]),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$row,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing24)
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$link,
								_Utils_ap(
									_List_Nil,
									serverInfoLabelAttr(context)),
								{
									u: $author$project$T2$Logo$talentecaLogoHorizontalNormal(
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width(
												A2(
													$lucamug$elm_ui_with_context$Element$WithContext$maximum,
													172,
													A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 172, $lucamug$elm_ui_with_context$Element$WithContext$fill)))
											])),
									R: '/'
								}),
								function () {
								if ((context.bT === 1) || (!context.bT)) {
									return $lucamug$elm_ui_with_context$Element$WithContext$none;
								} else {
									switch (internalUserInfo.$) {
										case 0:
											return A2(
												$author$project$T2$Button$linkButtonTextEnabledMedium,
												_List_Nil,
												{u: 'Publicar nueva vacante', R: publishJobAdUrlPath});
										case 1:
											return A2(
												$author$project$T2$Button$linkButtonTextEnabledMedium,
												_List_Nil,
												{u: 'Buscar empleo', R: jobAdSearchUrlPath});
										default:
											return A2(
												$author$project$T2$Button$linkButtonTextEnabledMedium,
												_List_Nil,
												{u: 'Publicar nueva vacante', R: publishJobAdUrlPath});
									}
								}
							}()
							])),
						function () {
						switch (internalUserInfo.$) {
							case 0:
								var loggedUserInfo = internalUserInfo.a;
								return A3(viewLoggedInUserSectionMediumToLargeScreens, loggedUserInfo, true, context);
							case 1:
								var loggedUserInfo = internalUserInfo.a;
								return A3(viewLoggedInUserSectionMediumToLargeScreens, loggedUserInfo, false, context);
							default:
								return A2(
									$lucamug$elm_ui_with_context$Element$WithContext$row,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing12),
											$lucamug$elm_ui_with_context$Element$WithContext$alignRight
										]),
									_List_fromArray(
										[
											A2(
											$author$project$T2$Button$linkButtonFilledSecondaryEnabledMedium,
											_List_Nil,
											{u: 'Buscar empleo', R: jobAdSearchUrlPath}),
											((context.bT === 1) || (!context.bT)) ? $lucamug$elm_ui_with_context$Element$WithContext$none : A2(
											$lucamug$elm_ui_with_context$Element$WithContext$column,
											A2($elm$core$String$startsWith, jobAdFavoritesPublicAreaUrlPath, urlPath) ? isActiveLinkItemAttrs : _List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$T2$Button$linkButtonTextContentSecondaryEnabledMediumWithLeftIcon,
													_List_Nil,
													$author$project$T2$Icon$star,
													{u: 'Favoritos', R: jobAdFavoritesPublicAreaUrlPath})
												])),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$column,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$T2$Button$linkButtonTextContentSecondaryEnabledMedium,
													A2(
														$elm$core$List$cons,
														$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
															$elm$html$Html$Attributes$class('talapoin-login-button')),
														A2($elm$core$String$startsWith, usersAccessUrlPath, urlPath) ? isActiveLinkItemAttrs : _List_Nil),
													{u: 'Acceder', R: usersAccessUrlPath})
												])),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$column,
											_List_Nil,
											_List_fromArray(
												[
													themeTogglerIconButton(context)
												]))
										]));
						}
					}()
					]));
		};
		var smallScreenTopBar = function (context) {
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$row,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Region$navigation,
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						$lucamug$elm_ui_with_context$Element$WithContext$px($author$project$T2$Internal$Spacing$spacing64)),
						$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
						{bi: 0, br: $author$project$T2$Internal$Spacing$spacing8, bt: $author$project$T2$Internal$Spacing$spacing8, by: 0})
					]),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$row,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing24)
							]),
						_List_fromArray(
							[
								A4($author$project$T2$IconButton$iconButtonIconTertiaryEnabledMedium, _List_Nil, toggleMobileNavigationDrawerMsg, $author$project$T2$Icon$hamburger, 'Abrir menú principal'),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$link,
								_Utils_ap(
									_List_Nil,
									serverInfoLabelAttr(context)),
								{
									u: $author$project$T2$Logo$talentecaLogoHorizontalNormal(
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width(
												A2(
													$lucamug$elm_ui_with_context$Element$WithContext$maximum,
													130,
													A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 130, $lucamug$elm_ui_with_context$Element$WithContext$fill)))
											])),
									R: '/'
								})
							])),
						function () {
						switch (internalUserInfo.$) {
							case 0:
								var loggedUserInfo = internalUserInfo.a;
								return A2(viewLoggedInUserSectionSmallScreens, loggedUserInfo, true);
							case 1:
								var loggedUserInfo = internalUserInfo.a;
								return A2(viewLoggedInUserSectionSmallScreens, loggedUserInfo, false);
							default:
								return A2(
									$lucamug$elm_ui_with_context$Element$WithContext$row,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing12),
											$lucamug$elm_ui_with_context$Element$WithContext$alignRight
										]),
									_List_fromArray(
										[
											A2(
											$author$project$T2$Button$linkButtonTextContentSecondaryEnabledMedium,
											A2(
												$elm$core$List$cons,
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
													$elm$html$Html$Attributes$class('talapoin-login-button')),
												A2($elm$core$String$startsWith, usersAccessUrlPath, urlPath) ? isActiveLinkItemAttrs : _List_Nil),
											{u: 'Acceder', R: usersAccessUrlPath}),
											function () {
											if (!notificationsMenuInfoMaybe.$) {
												var notificationMenuInfo = notificationsMenuInfoMaybe.a;
												return viewNotificationsTopBarEl(notificationMenuInfo);
											} else {
												return A3(
													$author$project$T2$IconButton$linkIconButtonIconTertiaryEnabledMedium,
													_List_Nil,
													$author$project$T2$Icon$star,
													{u: 'Favoritos', R: jobAdFavoritesPublicAreaUrlPath});
											}
										}()
										]));
						}
					}()
					]));
		};
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
							$author$project$T2$Internal$Color$bgTopBar(context)),
							$author$project$T2$Elevation$elevation1,
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'z-index', '10'))
						]),
					function () {
						var _v0 = context.bT;
						switch (_v0) {
							case 0:
								return smallScreenTopBar(context);
							case 1:
								return mediumToLargeScreensTopBar(context);
							case 2:
								return mediumToLargeScreensTopBar(context);
							default:
								return mediumToLargeScreensTopBar(context);
						}
					}());
			});
	});
var $author$project$T2$TopBar$navigationTopBar = F6(
	function (config, internalModel, toggleUserAccountSubmenuMsg, toggleMobileNavigationDrawerMsg, toggleThemeMsg, hideUserAccountSubmenuMsg) {
		var internalUserInfo = config.bR.js ? $author$project$T2$Internal$TopBar$Recruiter(
			A4(
				$author$project$T2$Internal$TopBar$InternalLoggedUserInfo,
				A2($elm$core$Maybe$withDefault, '-', config.bR.jv),
				A2($elm$core$Maybe$withDefault, '-', config.bR.jt),
				config.bR.jz,
				config.bR.jo)) : (config.cR.dF ? $author$project$T2$Internal$TopBar$Candidate(
			A4(
				$author$project$T2$Internal$TopBar$InternalLoggedUserInfo,
				A2($elm$core$Maybe$withDefault, '-', config.cR.gk),
				A2($elm$core$Maybe$withDefault, '-', config.cR.gj),
				$elm$core$Maybe$Nothing,
				config.cR.gc)) : $author$project$T2$Internal$TopBar$Visitor);
		return A9($author$project$T2$Internal$TopBar$renderNavigationTopBar, config.fl, internalUserInfo, internalModel, config.iU, config.e6, toggleUserAccountSubmenuMsg, toggleMobileNavigationDrawerMsg, toggleThemeMsg, hideUserAccountSubmenuMsg);
	});
var $mdgriffith$elm_ui$Element$scrollbarY = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.jP);
var $lucamug$elm_ui_with_context$Element$WithContext$scrollbarY = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$scrollbarY);
var $author$project$T2$Internal$Sidebar$Candidate = function (a) {
	return {$: 1, a: a};
};
var $author$project$T2$Internal$Sidebar$Recruiter = function (a) {
	return {$: 0, a: a};
};
var $author$project$T2$Internal$Sidebar$Visitor = {$: 2};
var $author$project$T2$Internal$Color$bgSidebar = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Sidebar$Auxiliary = 1;
var $author$project$T2$Internal$Sidebar$Primary = 0;
var $author$project$T2$Internal$Icon$internalConsole = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + ('; --icon-fill: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))))
				]),
			'#console');
	});
var $author$project$T2$Icon$console = $author$project$T2$Internal$Icon$internalConsole;
var $author$project$T2$Internal$Icon$internalCv = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#cv');
	});
var $author$project$T2$Icon$cv = $author$project$T2$Internal$Icon$internalCv;
var $author$project$T2$Internal$Icon$internalDashboard = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#dashboard');
	});
var $author$project$T2$Icon$dashboard = $author$project$T2$Internal$Icon$internalDashboard;
var $author$project$T2$Internal$Icon$internalMyApplication = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#myapplications');
	});
var $author$project$T2$Icon$myApplication = $author$project$T2$Internal$Icon$internalMyApplication;
var $author$project$T2$Internal$Icon$internalPostJob = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#postjob');
	});
var $author$project$T2$Icon$postJob = $author$project$T2$Internal$Icon$internalPostJob;
var $author$project$T2$Internal$Icon$internalSearch = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#search');
	});
var $author$project$T2$Icon$search = $author$project$T2$Internal$Icon$internalSearch;
var $author$project$T2$Internal$Icon$internalSettings = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#settings');
	});
var $author$project$T2$Icon$settings = $author$project$T2$Internal$Icon$internalSettings;
var $author$project$T2$Internal$SidebarItem$Enabled = 0;
var $author$project$T2$Internal$SidebarItem$LinkForCurrentPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$T2$Internal$Color$bgSidebarItemEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$bgSidebarItemFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgSidebarItemHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green20;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$bgSidebarItemSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgSidebarItemEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $mdgriffith$elm_ui$Element$fillPortion = $mdgriffith$elm_ui$Internal$Model$Fill;
var $lucamug$elm_ui_with_context$Element$WithContext$fillPortion = $mdgriffith$elm_ui$Element$fillPortion;
var $author$project$T2$Internal$SidebarItem$internalRenderIconView = F3(
	function (iconMaybe, color, altText) {
		if (!iconMaybe.$) {
			var iconRenderer = iconMaybe.a;
			var iconSize = 2;
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_Nil,
				A4(iconRenderer, iconSize, color, $elm$core$Maybe$Nothing, altText));
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$none;
		}
	});
var $author$project$T2$Internal$SidebarItem$renderSidebarItem = F6(
	function (attrs, state, behaviour, iconMaybe, label, badgeLabelMaybe) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var primaryLabelFontAttrs = $author$project$T2$Text$labelMediumAttrs;
				var itemAttrs = _Utils_ap(
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing12),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							$lucamug$elm_ui_with_context$Element$WithContext$px(40)),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('tt-element-hover-transition'))
						]),
					attrs);
				var borderAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$padding($author$project$T2$Internal$Spacing$spacing8),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(10)
					]);
				var bgHovered = $author$project$T2$Internal$Color$bgSidebarItemHovered;
				var bgHoveredAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								bgHovered(context))
							]))
					]);
				var bgFocused = $author$project$T2$Internal$Color$bgSidebarItemFocused;
				var bgFocusedAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$focused(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								bgFocused(context))
							]))
					]);
				var badgeEl = function () {
					if (!badgeLabelMaybe.$) {
						var badgeLabel = badgeLabelMaybe.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width(
									$lucamug$elm_ui_with_context$Element$WithContext$fillPortion(1))
								]),
							A2(
								$author$project$T2$Badge$badgePrimaryXSmall,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('tt-sidebar-item-label'))
									]),
								badgeLabel));
					} else {
						return $lucamug$elm_ui_with_context$Element$WithContext$none;
					}
				}();
				var _v0 = function () {
					if (!state) {
						return _Utils_Tuple2($author$project$T2$Internal$Color$bgSidebarItemEnabled, $author$project$T2$Internal$Color$fgSidebarItemEnabled);
					} else {
						return _Utils_Tuple2($author$project$T2$Internal$Color$bgSidebarItemSelected, $author$project$T2$Internal$Color$fgSidebarItemEnabled);
					}
				}();
				var bgColor = _v0.a;
				var fgColor = _v0.b;
				var bgColorAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						bgColor(context))
					]);
				var sidebarItemBaseAttrs = _Utils_ap(
					borderAttrs,
					_Utils_ap(
						bgColorAttrs,
						_Utils_ap(
							bgFocusedAttrs,
							_Utils_ap(bgHoveredAttrs, itemAttrs))));
				var iconView = A3(
					$author$project$T2$Internal$SidebarItem$internalRenderIconView,
					iconMaybe,
					fgColor(context),
					label);
				var textView = A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing4),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('tt-sidebar-item-label'))
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							A2(
								$elm$core$List$cons,
								$lucamug$elm_ui_with_context$Element$WithContext$width(
									$lucamug$elm_ui_with_context$Element$WithContext$fillPortion(4)),
								A2(
									primaryLabelFontAttrs,
									_List_Nil,
									fgColor(context))),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text(label)
								])),
							badgeEl
						]));
				var sidebarItemLabelView = _List_fromArray(
					[iconView, textView]);
				switch (behaviour.$) {
					case 0:
						var url = behaviour.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$link,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							{
								u: A2($lucamug$elm_ui_with_context$Element$WithContext$row, sidebarItemBaseAttrs, sidebarItemLabelView),
								R: url
							});
					case 1:
						var url = behaviour.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$newTabLink,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							{
								u: A2($lucamug$elm_ui_with_context$Element$WithContext$row, sidebarItemBaseAttrs, sidebarItemLabelView),
								R: url
							});
					default:
						var msg = behaviour.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$Input$button,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							{
								u: A2($lucamug$elm_ui_with_context$Element$WithContext$row, sidebarItemBaseAttrs, sidebarItemLabelView),
								ew: $elm$core$Maybe$Just(msg)
							});
				}
			});
	});
var $author$project$T2$SidebarItem$sidebarItemEnabledLinkForCurrentPage = F3(
	function (attrs, icon, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A6(
			$author$project$T2$Internal$SidebarItem$renderSidebarItem,
			attrs,
			0,
			$author$project$T2$Internal$SidebarItem$LinkForCurrentPage(url),
			$elm$core$Maybe$Just(icon),
			label,
			$elm$core$Maybe$Nothing);
	});
var $author$project$T2$SidebarItem$sidebarItemEnabledLinkForCurrentPageWithBadge = F4(
	function (attrs, icon, _v0, badgeLabel) {
		var url = _v0.R;
		var label = _v0.u;
		return A6(
			$author$project$T2$Internal$SidebarItem$renderSidebarItem,
			attrs,
			0,
			$author$project$T2$Internal$SidebarItem$LinkForCurrentPage(url),
			$elm$core$Maybe$Just(icon),
			label,
			$elm$core$Maybe$Just(badgeLabel));
	});
var $author$project$T2$SidebarItem$sidebarItemEnabledLinkForCurrentPageWithoutIcon = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A6(
			$author$project$T2$Internal$SidebarItem$renderSidebarItem,
			attrs,
			0,
			$author$project$T2$Internal$SidebarItem$LinkForCurrentPage(url),
			$elm$core$Maybe$Nothing,
			label,
			$elm$core$Maybe$Nothing);
	});
var $author$project$T2$Internal$SidebarItem$Selected = 1;
var $author$project$T2$SidebarItem$sidebarItemSelectedLinkForCurrentPage = F3(
	function (attrs, icon, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A6(
			$author$project$T2$Internal$SidebarItem$renderSidebarItem,
			attrs,
			1,
			$author$project$T2$Internal$SidebarItem$LinkForCurrentPage(url),
			$elm$core$Maybe$Just(icon),
			label,
			$elm$core$Maybe$Nothing);
	});
var $author$project$T2$SidebarItem$sidebarItemSelectedLinkForCurrentPageWithBadge = F4(
	function (attrs, icon, _v0, badgeLabel) {
		var url = _v0.R;
		var label = _v0.u;
		return A6(
			$author$project$T2$Internal$SidebarItem$renderSidebarItem,
			attrs,
			1,
			$author$project$T2$Internal$SidebarItem$LinkForCurrentPage(url),
			$elm$core$Maybe$Just(icon),
			label,
			$elm$core$Maybe$Just(badgeLabel));
	});
var $author$project$T2$Internal$Icon$internalSuitcase = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-fill: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#suitcase');
	});
var $author$project$T2$Icon$suitcase = $author$project$T2$Internal$Icon$internalSuitcase;
var $author$project$T2$Internal$Icon$internalTemplate = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#template');
	});
var $author$project$T2$Icon$template = $author$project$T2$Internal$Icon$internalTemplate;
var $author$project$T2$Internal$Icon$internalUsers = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#users');
	});
var $author$project$T2$Icon$users = $author$project$T2$Internal$Icon$internalUsers;
var $author$project$T2$Internal$Sidebar$renderSidebar = F3(
	function (urlPath, internalUserInfo, msgToggleTheme) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var recruiterSidebarItems = function (recruiterInfo) {
					return _Utils_ap(
						_List_fromArray(
							[
								{
								F: $elm$core$Maybe$Nothing,
								hI: $elm$core$Maybe$Just($author$project$T2$Icon$search),
								u: 'Buscar empleos',
								H: 0,
								R: '/empleos'
							},
								{
								F: $elm$core$Maybe$Nothing,
								hI: $elm$core$Maybe$Just($author$project$T2$Icon$postJob),
								u: 'Publicar empleo',
								H: 0,
								R: '/reclutador/publicar'
							},
								{
								F: $elm$core$Maybe$Nothing,
								hI: $elm$core$Maybe$Just($author$project$T2$Icon$dashboard),
								u: 'Panel',
								H: 0,
								R: '/reclutador'
							},
								{
								F: $elm$core$Maybe$Nothing,
								hI: $elm$core$Maybe$Just($author$project$T2$Icon$suitcase),
								u: 'Vacantes',
								H: 0,
								R: '/reclutador/tus-anuncios'
							},
								{
								F: $elm$core$Maybe$Nothing,
								hI: $elm$core$Maybe$Just($author$project$T2$Icon$template),
								u: 'Plantillas de vacantes',
								H: 0,
								R: '/reclutador/tus-plantillas'
							},
								{
								F: $elm$core$Maybe$Nothing,
								hI: $elm$core$Maybe$Just($author$project$T2$Icon$users),
								u: 'Base de candidatos',
								H: 0,
								R: '/base-de-candidatos'
							}
							]),
						_Utils_ap(
							recruiterInfo.hY ? _List_fromArray(
								[
									{
									F: $elm$core$Maybe$Nothing,
									hI: $elm$core$Maybe$Just($author$project$T2$Icon$settings),
									u: 'Administración',
									H: 0,
									R: '/admin-console/'
								}
								]) : _List_Nil,
							_Utils_ap(
								recruiterInfo.h_ ? _List_fromArray(
									[
										{
										F: $elm$core$Maybe$Nothing,
										hI: $elm$core$Maybe$Just($author$project$T2$Icon$console),
										u: 'Consola Corporativa',
										H: 0,
										R: '/reclutador/consola-corporativa'
									}
									]) : _List_Nil,
								_List_fromArray(
									[
										{F: $elm$core$Maybe$Nothing, hI: $elm$core$Maybe$Nothing, u: 'Precios', H: 1, R: '/precios'},
										{F: $elm$core$Maybe$Nothing, hI: $elm$core$Maybe$Nothing, u: 'Soporte', H: 1, R: '/preguntas-frecuentes?section=reclutadores'}
									]))));
				};
				var recruiterHomeUrlPath = '/reclutador';
				var mediumToLargeScreensSibebar = function (items) {
					var sidebarItemView = function (item) {
						if (_Utils_eq(urlPath, item.R) || (((item.R === '/candidato/home') && (urlPath === '/candidato')) || (((item.R === '/empleos') && A2($elm$core$String$startsWith, '/empleos-', urlPath)) || (((item.R === '/reclutador/publicar') && A2($elm$core$String$startsWith, '/reclutador/publicar/', urlPath)) || (((item.R === '/reclutador/tus-anuncios') && A2($elm$core$String$startsWith, '/admin/tus-candidatos', urlPath)) || ((item.R === '/admin-console/') && A2($elm$core$String$startsWith, '/admin-console/', urlPath))))))) {
							var _v2 = _Utils_Tuple2(item.F, item.hI);
							if (!_v2.a.$) {
								if (!_v2.b.$) {
									var badgeLabel = _v2.a.a;
									var icon = _v2.b.a;
									return A4(
										$author$project$T2$SidebarItem$sidebarItemSelectedLinkForCurrentPageWithBadge,
										_List_Nil,
										icon,
										{u: item.u, R: item.R},
										badgeLabel);
								} else {
									var badgeLabel = _v2.a.a;
									var _v4 = _v2.b;
									return A2(
										$author$project$T2$SidebarItem$sidebarItemEnabledLinkForCurrentPageWithoutIcon,
										_List_Nil,
										{u: item.u, R: item.R});
								}
							} else {
								if (!_v2.b.$) {
									var _v3 = _v2.a;
									var icon = _v2.b.a;
									return A3(
										$author$project$T2$SidebarItem$sidebarItemSelectedLinkForCurrentPage,
										_List_Nil,
										icon,
										{u: item.u, R: item.R});
								} else {
									var _v5 = _v2.a;
									var _v6 = _v2.b;
									return A2(
										$author$project$T2$SidebarItem$sidebarItemEnabledLinkForCurrentPageWithoutIcon,
										_List_Nil,
										{u: item.u, R: item.R});
								}
							}
						} else {
							var _v7 = _Utils_Tuple2(item.F, item.hI);
							if (!_v7.a.$) {
								if (!_v7.b.$) {
									var badgeLabel = _v7.a.a;
									var icon = _v7.b.a;
									return A4(
										$author$project$T2$SidebarItem$sidebarItemEnabledLinkForCurrentPageWithBadge,
										_List_Nil,
										icon,
										{u: item.u, R: item.R},
										badgeLabel);
								} else {
									var badgeLabel = _v7.a.a;
									var _v9 = _v7.b;
									return A2(
										$author$project$T2$SidebarItem$sidebarItemEnabledLinkForCurrentPageWithoutIcon,
										_List_Nil,
										{u: item.u, R: item.R});
								}
							} else {
								if (!_v7.b.$) {
									var _v8 = _v7.a;
									var icon = _v7.b.a;
									return A3(
										$author$project$T2$SidebarItem$sidebarItemEnabledLinkForCurrentPage,
										_List_Nil,
										icon,
										{u: item.u, R: item.R});
								} else {
									var _v10 = _v7.a;
									var _v11 = _v7.b;
									return A2(
										$author$project$T2$SidebarItem$sidebarItemEnabledLinkForCurrentPageWithoutIcon,
										_List_Nil,
										{u: item.u, R: item.R});
								}
							}
						}
					};
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Region$navigation,
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8)
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$column,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing4)
									]),
								A2(
									$elm$core$List$map,
									sidebarItemView,
									A2(
										$elm$core$List$filter,
										function (item) {
											return !item.H;
										},
										items))),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$column,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing4),
										$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
										{bi: 0, br: 0, bt: 0, by: $author$project$T2$Internal$Spacing$spacing24})
									]),
								A2(
									$elm$core$List$map,
									sidebarItemView,
									A2(
										$elm$core$List$filter,
										function (item) {
											return item.H === 1;
										},
										items)))
							]));
				};
				var viewSidebar = function (items) {
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$class('tt-sidebar')),
								$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
							]),
						A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
									$author$project$T2$Internal$Color$bgSidebar(context)),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('tt-sidebar-inner')),
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, $author$project$T2$Internal$Spacing$spacing12, $author$project$T2$Internal$Spacing$spacing12 + 2)
								]),
							function () {
								var _v1 = context.bT;
								switch (_v1) {
									case 0:
										return $lucamug$elm_ui_with_context$Element$WithContext$none;
									case 1:
										return mediumToLargeScreensSibebar(items);
									case 2:
										return mediumToLargeScreensSibebar(items);
									default:
										return mediumToLargeScreensSibebar(items);
								}
							}()));
				};
				var candidateSidebarItems = function (candidateInfo) {
					return _Utils_ap(
						_List_fromArray(
							[
								{
								F: $elm$core$Maybe$Nothing,
								hI: $elm$core$Maybe$Just($author$project$T2$Icon$search),
								u: 'Buscar empleos',
								H: 0,
								R: '/empleos'
							},
								{
								F: $elm$core$Maybe$Nothing,
								hI: $elm$core$Maybe$Just($author$project$T2$Icon$dashboard),
								u: 'Panel',
								H: 0,
								R: '/candidato/home'
							},
								{
								F: $elm$core$Maybe$Nothing,
								hI: $elm$core$Maybe$Just($author$project$T2$Icon$cv),
								u: 'Hoja de vida',
								H: 0,
								R: '/candidato/mi-hoja-de-vida'
							},
								{
								F: $elm$core$Maybe$Nothing,
								hI: $elm$core$Maybe$Just($author$project$T2$Icon$myApplication),
								u: 'Postulaciones',
								H: 0,
								R: '/candidato/tus-postulaciones'
							},
								{
								F: (candidateInfo.cW > 0) ? $elm$core$Maybe$Just(
									$elm$core$String$fromInt(candidateInfo.cW)) : $elm$core$Maybe$Nothing,
								hI: $elm$core$Maybe$Just($author$project$T2$Icon$star),
								u: 'Empleos favoritos',
								H: 0,
								R: '/candidato/tus-empleos-guardados'
							},
								{
								F: $elm$core$Maybe$Nothing,
								hI: $elm$core$Maybe$Just($author$project$T2$Icon$notification),
								u: 'Alertas de empleos',
								H: 0,
								R: '/candidato/tus-alertas'
							}
							]),
						_List_fromArray(
							[
								{F: $elm$core$Maybe$Nothing, hI: $elm$core$Maybe$Nothing, u: 'Soporte', H: 1, R: '/preguntas-frecuentes?section=candidatos'}
							]));
				};
				switch (internalUserInfo.$) {
					case 0:
						var recruiterLoggedInInfo = internalUserInfo.a;
						return viewSidebar(
							recruiterSidebarItems(recruiterLoggedInInfo));
					case 1:
						var candidateLoggedInInfo = internalUserInfo.a;
						return viewSidebar(
							candidateSidebarItems(candidateLoggedInInfo));
					default:
						return $lucamug$elm_ui_with_context$Element$WithContext$none;
				}
			});
	});
var $author$project$T2$Sidebar$sidebarDefault = function (config) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			var internalUserInfo = config.bR.js ? $author$project$T2$Internal$Sidebar$Recruiter(
				{hY: config.bR.jq, h_: config.bR.jr}) : (config.cR.dF ? $author$project$T2$Internal$Sidebar$Candidate(
				{cW: config.gd}) : $author$project$T2$Internal$Sidebar$Visitor);
			var sidebarMenuIsVisible = !_Utils_eq(internalUserInfo, $author$project$T2$Internal$Sidebar$Visitor);
			return sidebarMenuIsVisible ? A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'z-index', '1')),
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						$author$project$T2$Internal$Color$bgSidebar(context))
					]),
				A3($author$project$T2$Internal$Sidebar$renderSidebar, config.fl, internalUserInfo, config.iK)) : $lucamug$elm_ui_with_context$Element$WithContext$none;
		});
};
var $author$project$T2$Footer$smallScreenFooterWithoutTopLinksAndNoFollowUs = $lucamug$elm_ui_with_context$Element$WithContext$withContext(
	function (context) {
		var _v0 = context.bT;
		switch (_v0) {
			case 0:
				return A2($author$project$T2$Internal$Footer$renderMobileFooter, false, $elm$core$Maybe$Nothing);
			case 1:
				return A2($author$project$T2$Internal$Footer$renderMobileFooter, false, $elm$core$Maybe$Nothing);
			case 2:
				return A2($author$project$T2$Internal$Footer$renderMobileFooter, false, $elm$core$Maybe$Nothing);
			default:
				return A2($author$project$T2$Internal$Footer$renderMobileFooter, false, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$T2$Internal$Banner$Error = 0;
var $author$project$T2$Internal$Banner$Medium = 1;
var $author$project$T2$Internal$Link$Bold = 1;
var $author$project$T2$Internal$Link$Large = 1;
var $author$project$T2$Link$actionLinkContentInverseBoldEnabledLarge = F3(
	function (attrs, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(1)(1)($elm$core$Maybe$Nothing)(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(3);
	});
var $author$project$T2$Internal$Link$LargeX = 0;
var $author$project$T2$Link$actionLinkContentInverseBoldEnabledLargeX = F3(
	function (attrs, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(0)(1)($elm$core$Maybe$Nothing)(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(3);
	});
var $author$project$T2$Link$actionLinkContentInverseBoldEnabledMedium = F3(
	function (attrs, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(2)(1)($elm$core$Maybe$Nothing)(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(3);
	});
var $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLarge = F3(
	function (attrs, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(1)(1)($elm$core$Maybe$Nothing)(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(1);
	});
var $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLargeX = F3(
	function (attrs, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(0)(1)($elm$core$Maybe$Nothing)(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(1);
	});
var $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledMedium = F3(
	function (attrs, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(2)(1)($elm$core$Maybe$Nothing)(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(1);
	});
var $mdgriffith$elm_ui$Element$Font$alignLeft = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.kl);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$alignLeft);
var $author$project$T2$Internal$Color$bgBannerError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$bgBannerInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	}
};
var $author$project$T2$Internal$Color$bgBannerSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	}
};
var $author$project$T2$Internal$Color$bgBannerWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$Icon$internalCheckFilled = F4(
	function (size, mainColor, secondaryColor, title) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var iconBackgroundColorHex = $author$project$T2$Internal$Color$Extra$colorToHex(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$T2$Internal$Color$bgPrimary(context),
						secondaryColor));
				return A4(
					$author$project$T2$Internal$Icon$internalRenderIconSvg,
					size,
					title,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$style(
							'--icon-fill: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + ('; --icon-stroke: ' + (iconBackgroundColorHex + ';'))))
						]),
					'#check-filled');
			});
	});
var $author$project$T2$Icon$checkFilled = $author$project$T2$Internal$Icon$internalCheckFilled;
var $author$project$T2$Internal$Color$cicBannerError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$cicBannerInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$cicBannerSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$cicBannerWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Icon$internalErrorFilled = F4(
	function (size, mainColor, secondaryColor, title) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var iconBackgroundColorHex = $author$project$T2$Internal$Color$Extra$colorToHex(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$T2$Internal$Color$bgPrimary(context),
						secondaryColor));
				return A4(
					$author$project$T2$Internal$Icon$internalRenderIconSvg,
					size,
					title,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$style(
							'--icon-fill: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + ('; --icon-stroke:' + (iconBackgroundColorHex + ';'))))
						]),
					'#error-filled');
			});
	});
var $author$project$T2$Icon$errorFilled = $author$project$T2$Internal$Icon$internalErrorFilled;
var $author$project$T2$Internal$Color$fgBannerError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgBannerInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgBannerSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green00;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgBannerWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$icBannerError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red01;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red01;
	}
};
var $author$project$T2$Internal$Color$icBannerInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$icBannerSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen10;
	}
};
var $author$project$T2$Internal$Color$icBannerWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow00;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow05;
	}
};
var $author$project$T2$Internal$Color$icsBannerError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$icsBannerInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$icsBannerSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$icsBannerWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Icon$internalInfoFilled = F4(
	function (size, mainColor, secondaryColor, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-fill: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + ('; --icon-stroke:' + (A2(
						$elm$core$Maybe$withDefault,
						'#fff',
						A2(
							$elm$core$Maybe$map,
							function (c) {
								return $author$project$T2$Internal$Color$Extra$colorToHex(c);
							},
							secondaryColor)) + ';'))))
				]),
			'#info-filled');
	});
var $author$project$T2$Icon$infoFilled = $author$project$T2$Internal$Icon$internalInfoFilled;
var $author$project$T2$Internal$Banner$internalRenderCloseIconView = F3(
	function (color, size, closeMsg) {
		var iconSize = function () {
			switch (size) {
				case 0:
					return 1;
				case 1:
					return 3;
				default:
					return 2;
			}
		}();
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
					$lucamug$elm_ui_with_context$Element$WithContext$pointer,
					$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(closeMsg)
				]),
			A4($author$project$T2$Internal$Icon$internalExit, iconSize, color, $elm$core$Maybe$Nothing, 'Cerrar banner'));
	});
var $author$project$T2$Internal$Icon$LargeX = 5;
var $author$project$T2$Internal$Icon$LargeXX = 7;
var $author$project$T2$Internal$Color$primaryB = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen70;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen70;
	}
};
var $author$project$T2$Internal$Banner$internalRenderIconView = F6(
	function (iconRenderer, mainColor, secondaryColor, size, altText, context) {
		var iconSize = function () {
			switch (size) {
				case 0:
					return 4;
				case 1:
					return 5;
				default:
					return 7;
			}
		}();
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
					$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
					$author$project$T2$Internal$Color$primaryB(context))
				]),
			A4(
				iconRenderer,
				iconSize,
				mainColor,
				$elm$core$Maybe$Just(secondaryColor),
				altText));
	});
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$T2$Internal$Text$ParagraphLargeX = 16;
var $author$project$T2$Text$paragraphLargeXAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 16, color);
	});
var $author$project$T2$Internal$Icon$internalWarningFilled = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$style(
					'--icon-fill: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#warning-filled');
	});
var $author$project$T2$Icon$warningFilled = $author$project$T2$Internal$Icon$internalWarningFilled;
var $author$project$T2$Internal$Banner$renderBanner = F6(
	function (attrs, status, size, message, closeMsg, maybeAction) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var icon = function () {
					switch (status) {
						case 2:
							return $author$project$T2$Icon$checkFilled;
						case 1:
							return $author$project$T2$Icon$warningFilled;
						case 0:
							return $author$project$T2$Icon$errorFilled;
						default:
							return $author$project$T2$Icon$infoFilled;
					}
				}();
				var closeIconColor = function () {
					switch (status) {
						case 2:
							return $author$project$T2$Internal$Color$cicBannerSuccess;
						case 1:
							return $author$project$T2$Internal$Color$cicBannerWarning;
						case 0:
							return $author$project$T2$Internal$Color$cicBannerError;
						default:
							return $author$project$T2$Internal$Color$cicBannerInfo;
					}
				}();
				var closeIconView = A3(
					$author$project$T2$Internal$Banner$internalRenderCloseIconView,
					closeIconColor(context),
					size,
					closeMsg);
				var bannerPaddingY = function () {
					switch (size) {
						case 0:
							return $author$project$T2$Internal$Spacing$spacing16 + 2;
						case 1:
							return $author$project$T2$Internal$Spacing$spacing12 + 2;
						default:
							return $author$project$T2$Internal$Spacing$spacing12;
					}
				}();
				var bannerPaddingX = function () {
					switch (size) {
						case 0:
							return $author$project$T2$Internal$Spacing$spacing12;
						case 1:
							return $author$project$T2$Internal$Spacing$spacing16;
						default:
							return $author$project$T2$Internal$Spacing$spacing20;
					}
				}();
				var paddingAttrs = _List_fromArray(
					[
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, bannerPaddingX, bannerPaddingY)
					]);
				var bannerAttrs = _Utils_ap(
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(12),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'animation', 'pulse 0.1s'))
						]),
					attrs);
				var _v0 = function () {
					switch (status) {
						case 2:
							return _Utils_Tuple2($author$project$T2$Internal$Color$icBannerSuccess, $author$project$T2$Internal$Color$icsBannerSuccess);
						case 1:
							return _Utils_Tuple2($author$project$T2$Internal$Color$icBannerWarning, $author$project$T2$Internal$Color$icsBannerWarning);
						case 0:
							return _Utils_Tuple2($author$project$T2$Internal$Color$icBannerError, $author$project$T2$Internal$Color$icsBannerError);
						default:
							return _Utils_Tuple2($author$project$T2$Internal$Color$icBannerInfo, $author$project$T2$Internal$Color$icsBannerInfo);
					}
				}();
				var iconMainColor = _v0.a;
				var iconSecondaryColor = _v0.b;
				var leftIconView = A6(
					$author$project$T2$Internal$Banner$internalRenderIconView,
					icon,
					iconMainColor(context),
					iconSecondaryColor(context),
					size,
					message,
					context);
				var _v2 = function () {
					switch (status) {
						case 2:
							return _Utils_Tuple2($author$project$T2$Internal$Color$fgBannerSuccess, $author$project$T2$Internal$Color$bgBannerSuccess);
						case 1:
							return _Utils_Tuple2($author$project$T2$Internal$Color$fgBannerWarning, $author$project$T2$Internal$Color$bgBannerWarning);
						case 0:
							return _Utils_Tuple2($author$project$T2$Internal$Color$fgBannerError, $author$project$T2$Internal$Color$bgBannerError);
						default:
							return _Utils_Tuple2($author$project$T2$Internal$Color$fgBannerInfo, $author$project$T2$Internal$Color$bgBannerInfo);
					}
				}();
				var fgColor = _v2.a;
				var bgColor = _v2.b;
				var bgColorAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						bgColor(context))
					]);
				var labelView = function () {
					var textViewAttrs = function () {
						switch (size) {
							case 0:
								return $author$project$T2$Text$paragraphMediumAttrs;
							case 1:
								return $author$project$T2$Text$paragraphLargeAttrs;
							default:
								return $author$project$T2$Text$paragraphLargeXAttrs;
						}
					}();
					var actionView = function () {
						if (!maybeAction.$) {
							var action = maybeAction.a;
							var linkEl = function () {
								switch (status) {
									case 2:
										if (context.cF === 1) {
											switch (size) {
												case 0:
													return $author$project$T2$Link$actionLinkContentInverseBoldEnabledMedium;
												case 1:
													return $author$project$T2$Link$actionLinkContentInverseBoldEnabledLarge;
												default:
													return $author$project$T2$Link$actionLinkContentInverseBoldEnabledLargeX;
											}
										} else {
											switch (size) {
												case 0:
													return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledMedium;
												case 1:
													return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLarge;
												default:
													return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLargeX;
											}
										}
									case 1:
										if (context.cF === 1) {
											switch (size) {
												case 0:
													return $author$project$T2$Link$actionLinkContentInverseBoldEnabledMedium;
												case 1:
													return $author$project$T2$Link$actionLinkContentInverseBoldEnabledLarge;
												default:
													return $author$project$T2$Link$actionLinkContentInverseBoldEnabledLargeX;
											}
										} else {
											switch (size) {
												case 0:
													return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledMedium;
												case 1:
													return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLarge;
												default:
													return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLargeX;
											}
										}
									case 0:
										if (context.cF === 1) {
											switch (size) {
												case 0:
													return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledMedium;
												case 1:
													return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLarge;
												default:
													return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLargeX;
											}
										} else {
											switch (size) {
												case 0:
													return $author$project$T2$Link$actionLinkContentInverseBoldEnabledMedium;
												case 1:
													return $author$project$T2$Link$actionLinkContentInverseBoldEnabledLarge;
												default:
													return $author$project$T2$Link$actionLinkContentInverseBoldEnabledLargeX;
											}
										}
									default:
										if (context.cF === 1) {
											switch (size) {
												case 0:
													return $author$project$T2$Link$actionLinkContentInverseBoldEnabledMedium;
												case 1:
													return $author$project$T2$Link$actionLinkContentInverseBoldEnabledLarge;
												default:
													return $author$project$T2$Link$actionLinkContentInverseBoldEnabledLargeX;
											}
										} else {
											switch (size) {
												case 0:
													return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledMedium;
												case 1:
													return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLarge;
												default:
													return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLargeX;
											}
										}
								}
							}();
							return A3(
								linkEl,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8)
									]),
								action.u,
								action.a);
						} else {
							return $lucamug$elm_ui_with_context$Element$WithContext$none;
						}
					}();
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8),
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
								$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								A2(
									textViewAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$centerY,
											$lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft
										]),
									fgColor(context)),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text(message)
									])),
								actionView
							]));
				}();
				var bannerView = A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_Utils_ap(
						bannerAttrs,
						_Utils_ap(paddingAttrs, bgColorAttrs)),
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$html(
							A3(
								$elm$html$Html$node,
								'style',
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' @keyframes pulse { 0%   {background-color: transparent;} 100% {background-color: transparent;} } ')
									]))),
							leftIconView,
							labelView,
							closeIconView
						]));
				return bannerView;
			});
	});
var $author$project$T2$Banner$bannerErrorMedium = F3(
	function (attrs, msg, label) {
		return A6($author$project$T2$Internal$Banner$renderBanner, attrs, 0, 1, label, msg, $elm$core$Maybe$Nothing);
	});
var $author$project$T2$Internal$Banner$Info = 3;
var $author$project$T2$Banner$bannerInfoMedium = F3(
	function (attrs, msg, label) {
		return A6($author$project$T2$Internal$Banner$renderBanner, attrs, 3, 1, label, msg, $elm$core$Maybe$Nothing);
	});
var $author$project$T2$Internal$Banner$Success = 2;
var $author$project$T2$Banner$bannerSuccessMedium = F3(
	function (attrs, msg, label) {
		return A6($author$project$T2$Internal$Banner$renderBanner, attrs, 2, 1, label, msg, $elm$core$Maybe$Nothing);
	});
var $author$project$T2$Internal$Banner$Warning = 1;
var $author$project$T2$Banner$bannerWarningMedium = F3(
	function (attrs, msg, label) {
		return A6($author$project$T2$Internal$Banner$renderBanner, attrs, 1, 1, label, msg, $elm$core$Maybe$Nothing);
	});
var $author$project$T2$Layout$viewBannerMessage = function (bannerInfo) {
	if (!bannerInfo.$) {
		var _v1 = bannerInfo.a;
		var text = _v1.a;
		var status = _v1.b;
		var onCloseMsg = _v1.c;
		return A3(
			function () {
				switch (status) {
					case 2:
						return $author$project$T2$Banner$bannerSuccessMedium;
					case 0:
						return $author$project$T2$Banner$bannerErrorMedium;
					case 1:
						return $author$project$T2$Banner$bannerWarningMedium;
					default:
						return $author$project$T2$Banner$bannerInfoMedium;
				}
			}(),
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$id('banner')),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
				]),
			onCloseMsg,
			text);
	} else {
		return $lucamug$elm_ui_with_context$Element$WithContext$none;
	}
};
var $author$project$T2$Layout$viewLayout = F4(
	function (model, context, content, bannerInfo) {
		if ($author$project$T2$Util$isMediumScreenOrLarger(context.bT)) {
			var sidebarMenuIsVisible = model.J.eP.js || model.J.cQ.dF;
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width(
						$lucamug$elm_ui_with_context$Element$WithContext$px(context.S.dp)),
						$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
					]),
				_List_fromArray(
					[
						model.hE ? $lucamug$elm_ui_with_context$Element$WithContext$none : A6(
						$author$project$T2$TopBar$navigationTopBar,
						{cR: model.J.cQ, iU: model.iU, bR: model.J.eP, e6: model.J.jT, fl: model.R.eD},
						model.aO,
						model.iP,
						model.iQ,
						model.iO,
						model.iM),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$row,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
							]),
						_List_fromArray(
							[
								$author$project$T2$Sidebar$sidebarDefault(
								{gd: model.gd, cR: model.J.cQ, iK: model.iO, bR: model.J.eP, fl: model.R.eD}),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$column,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
									]),
								_List_fromArray(
									[
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$column,
										A2(
											$elm$core$List$cons,
											$lucamug$elm_ui_with_context$Element$WithContext$width(
												$lucamug$elm_ui_with_context$Element$WithContext$px(
													context.S.dp - (sidebarMenuIsVisible ? 64 : 0))),
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
													$lucamug$elm_ui_with_context$Element$WithContext$height(
													A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 0, $lucamug$elm_ui_with_context$Element$WithContext$fill))
												])),
										_List_fromArray(
											[
												$author$project$T2$Layout$viewBannerMessage(bannerInfo),
												content,
												function () {
												var _v0 = model.hf;
												switch (_v0) {
													case 0:
														return $lucamug$elm_ui_with_context$Element$WithContext$none;
													case 1:
														return $author$project$T2$Footer$footerWithoutTopLinksAndWithFollowUs;
													default:
														return $author$project$T2$Footer$smallScreenFooterWithoutTopLinksAndNoFollowUs;
												}
											}()
											]))
									]))
							]))
					]));
		} else {
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width(
						$lucamug$elm_ui_with_context$Element$WithContext$px(context.S.dp)),
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						$lucamug$elm_ui_with_context$Element$WithContext$px(context.S.bn)),
						$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
						$lucamug$elm_ui_with_context$Element$WithContext$inFront(
						A4(
							$author$project$T2$Drawer$navigationDrawer,
							{cR: model.J.cQ, bR: model.J.eP, fl: model.R.eD, S: context.S},
							model.aI,
							model.iL,
							model.iO))
					]),
				_List_fromArray(
					[
						model.hE ? $lucamug$elm_ui_with_context$Element$WithContext$none : A6(
						$author$project$T2$TopBar$navigationTopBar,
						{cR: model.J.cQ, iU: model.iU, bR: model.J.eP, e6: model.J.jT, fl: model.R.eD},
						model.aO,
						model.iP,
						model.iQ,
						model.iO,
						model.iM),
						$author$project$T2$Layout$viewBannerMessage(bannerInfo),
						content,
						function () {
						var _v1 = model.hf;
						switch (_v1) {
							case 0:
								return $lucamug$elm_ui_with_context$Element$WithContext$none;
							case 1:
								return A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$alignBottom
										]),
									$author$project$T2$Footer$footerWithoutTopLinksAndWithFollowUs);
							default:
								return A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$alignBottom
										]),
									$author$project$T2$Footer$smallScreenFooterWithoutTopLinksAndNoFollowUs);
						}
					}()
					]));
		}
	});
var $author$project$T2$Layout$bodyWithContainer = F5(
	function (model, context, attrs, bannerInfo, content) {
		return A4(
			$lucamug$elm_ui_with_context$Element$WithContext$layoutWith,
			context,
			{
				ey: _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$focusStyle(
						{
							dz: $elm$core$Maybe$Nothing,
							dC: $elm$core$Maybe$Just(
								$author$project$T2$Internal$Color$bgPrimary(context)),
							e7: $elm$core$Maybe$Nothing
						})
					])
			},
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$author$project$T2$Background$primary
				]),
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_Utils_ap(
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
						]),
					_Utils_ap(
						attrs,
						A2(
							$author$project$T2$Text$paragraphMediumAttrs,
							_List_Nil,
							$author$project$T2$Internal$Color$contentPrimary(context)))),
				A4($author$project$T2$Layout$viewLayout, model, context, content, bannerInfo)));
	});
var $mdgriffith$elm_ui$Internal$Model$Behind = 5;
var $mdgriffith$elm_ui$Element$behindContent = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 5, element);
};
var $lucamug$elm_ui_with_context$Element$WithContext$behindContent = $lucamug$elm_ui_with_context$Element$WithContext$createNearby($mdgriffith$elm_ui$Element$behindContent);
var $author$project$T2$Internal$Elevation$Elevation2 = 1;
var $author$project$T2$Elevation$elevation2 = $author$project$T2$Internal$Elevation$renderElevation(1);
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $mdgriffith$elm_ui$Element$image = F2(
	function (attrs, _v0) {
		var src = _v0.j2;
		var description = _v0.g$;
		var imageAttributes = A2(
			$elm$core$List$filter,
			function (a) {
				switch (a.$) {
					case 7:
						return true;
					case 8:
						return true;
					default:
						return false;
				}
			},
			attrs);
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.hJ),
				attrs),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[
						A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asEl,
						$mdgriffith$elm_ui$Internal$Model$NodeName('img'),
						_Utils_ap(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Internal$Model$Attr(
									$elm$html$Html$Attributes$src(src)),
									$mdgriffith$elm_ui$Internal$Model$Attr(
									$elm$html$Html$Attributes$alt(description))
								]),
							imageAttributes),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil))
					])));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$image = A2(
	$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
	$mdgriffith$elm_ui$Element$image,
	$elm$core$Basics$always($elm$core$Basics$identity));
var $mdgriffith$elm_ui$Element$map = $mdgriffith$elm_ui$Internal$Model$map;
var $lucamug$elm_ui_with_context$Element$WithContext$map = F2(
	function (f, _v0) {
		var g = _v0;
		return A2(
			$elm$core$Basics$composeR,
			g,
			$mdgriffith$elm_ui$Element$map(f));
	});
var $author$project$T2$Internal$Icon$Large96 = 10;
var $author$project$Page$Home$MsgGetJobAdSummary = {$: 1};
var $author$project$Page$Home$MsgHideMenuOptions = {$: 60};
var $author$project$Page$Home$MsgShowMenuOptions = {$: 59};
var $author$project$Page$Home$MsgShowSidebar = {$: 57};
var $author$project$Page$Home$MsgUserClickGoToJobAdSerchPageButton = {$: 56};
var $author$project$Page$Home$MsgUserClickUploadCvButton = {$: 55};
var $author$project$Page$Home$MsgUserClickedBackIcon = function (a) {
	return {$: 82, a: a};
};
var $author$project$T2$Internal$Color$bgApplyTopBar = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Border$RoundedTop = 1;
var $author$project$T2$Border$borderRoundedTop = $author$project$T2$Internal$Border$borderShapeAttr(1);
var $author$project$T2$Internal$Border$Sharp = 5;
var $author$project$T2$Border$borderSharp = $author$project$T2$Internal$Border$borderShapeAttr(5);
var $author$project$T2$Internal$Button$OnClick = function (a) {
	return {$: 1, a: a};
};
var $author$project$T2$Internal$Button$Small = 0;
var $author$project$T2$Button$buttonOutlinedEnabledSmall = F3(
	function (attrs, msg, label) {
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			1,
			0,
			0,
			$author$project$T2$Internal$Button$OnClick(msg),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $author$project$T2$Internal$Color$fgApplyTopBar = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Icon$LargeXXX = 8;
var $author$project$T2$Internal$Button$Filled = 0;
var $author$project$T2$Button$buttonFilledEnabledMedium = F3(
	function (attrs, msg, label) {
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			0,
			0,
			1,
			$author$project$T2$Internal$Button$OnClick(msg),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $author$project$T2$Button$buttonFilledEnabledSmall = F3(
	function (attrs, msg, label) {
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			0,
			0,
			0,
			$author$project$T2$Internal$Button$OnClick(msg),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $author$project$T2$Internal$Card$Enabled = 0;
var $author$project$T2$Internal$Card$Medium = 1;
var $author$project$T2$Internal$Card$Disabled = 1;
var $author$project$T2$Internal$Color$bgCardDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$bgCardEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$bgCardFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green20;
	}
};
var $author$project$T2$Internal$Color$bgCardHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$bgCardSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green30;
	}
};
var $author$project$T2$Internal$Card$renderCard = F4(
	function (attrs, state, size, content) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var itemAttrs = _Utils_ap(
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing12),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('tt-element-hover-transition')),
							$author$project$T2$Elevation$elevation1
						]),
					attrs);
				var borderAttrs = _List_fromArray(
					[
						$author$project$T2$Border$borderRoundedDefault,
						$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
						{
							bi: function () {
								switch (size) {
									case 0:
										return $author$project$T2$Internal$Spacing$spacing8;
									case 1:
										return $author$project$T2$Internal$Spacing$spacing12;
									default:
										return $author$project$T2$Internal$Spacing$spacing16;
								}
							}(),
							br: function () {
								switch (size) {
									case 0:
										return $author$project$T2$Internal$Spacing$spacing12;
									case 1:
										return $author$project$T2$Internal$Spacing$spacing16;
									default:
										return $author$project$T2$Internal$Spacing$spacing20;
								}
							}(),
							bt: function () {
								switch (size) {
									case 0:
										return $author$project$T2$Internal$Spacing$spacing12;
									case 1:
										return $author$project$T2$Internal$Spacing$spacing16;
									default:
										return $author$project$T2$Internal$Spacing$spacing20;
								}
							}(),
							by: function () {
								switch (size) {
									case 0:
										return $author$project$T2$Internal$Spacing$spacing8;
									case 1:
										return $author$project$T2$Internal$Spacing$spacing12;
									default:
										return $author$project$T2$Internal$Spacing$spacing16;
								}
							}()
						})
					]);
				var bgHovered = function () {
					switch (state) {
						case 0:
							return $author$project$T2$Internal$Color$bgCardHovered;
						case 1:
							return $author$project$T2$Internal$Color$bgCardDisabled;
						default:
							return $author$project$T2$Internal$Color$bgCardHovered;
					}
				}();
				var bgHoveredAttrs = (state === 1) ? _List_Nil : _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								bgHovered(context))
							]))
					]);
				var bgFocused = function () {
					switch (state) {
						case 0:
							return $author$project$T2$Internal$Color$bgCardFocused;
						case 1:
							return $author$project$T2$Internal$Color$bgCardDisabled;
						default:
							return $author$project$T2$Internal$Color$bgCardFocused;
					}
				}();
				var bgFocusedAttrs = (state === 1) ? _List_Nil : _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$focused(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								bgFocused(context))
							]))
					]);
				var bgColor = function () {
					switch (state) {
						case 0:
							return $author$project$T2$Internal$Color$bgCardEnabled;
						case 1:
							return $author$project$T2$Internal$Color$bgCardDisabled;
						default:
							return $author$project$T2$Internal$Color$bgCardSelected;
					}
				}();
				var bgColorAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						bgColor(context))
					]);
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_Utils_ap(
						itemAttrs,
						_Utils_ap(
							borderAttrs,
							_Utils_ap(
								bgColorAttrs,
								_Utils_ap(bgFocusedAttrs, bgHoveredAttrs)))),
					content);
			});
	});
var $author$project$T2$Card$cardEnabledMedium = F2(
	function (attrs, content) {
		return A4($author$project$T2$Internal$Card$renderCard, attrs, 0, 1, content);
	});
var $author$project$T2$Internal$Card$Small = 0;
var $author$project$T2$Card$cardEnabledSmall = F2(
	function (attrs, content) {
		return A4($author$project$T2$Internal$Card$renderCard, attrs, 0, 0, content);
	});
var $author$project$T2$Button$linkButtonFilledEnabledMedium = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			0,
			0,
			1,
			$author$project$T2$Internal$Button$LinkForCurrentPage(url),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $author$project$T2$Button$linkButtonFilledEnabledSmall = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			0,
			0,
			0,
			$author$project$T2$Internal$Button$LinkForCurrentPage(url),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $author$project$T2$Internal$Color$warning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow30;
	}
};
var $author$project$T2$Internal$Error$renderSectionError = F5(
	function (attrs, title, subtitleMaybe, msgReloadActionMaybe, linkButtonValuesMaybe) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var cardElement = (!context.bT) ? $author$project$T2$Card$cardEnabledSmall : $author$project$T2$Card$cardEnabledMedium;
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$author$project$T2$Background$primary,
							$lucamug$elm_ui_with_context$Element$WithContext$padding(
							(!context.bT) ? $author$project$T2$Internal$Spacing$spacing16 : $author$project$T2$Internal$Spacing$spacing36)
						]),
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_Utils_ap(
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$centerY]),
							attrs),
						A2(
							cardElement,
							_List_Nil,
							A2(
								$lucamug$elm_ui_with_context$Element$WithContext$column,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										(!context.bT) ? $lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing12) : $lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16)
									]),
								_List_fromArray(
									[
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$wrappedRow,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
												$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8)
											]),
										_List_fromArray(
											[
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$el,
												_List_fromArray(
													[$lucamug$elm_ui_with_context$Element$WithContext$centerX]),
												A4(
													$author$project$T2$Internal$Icon$internalWarningFilled,
													(!context.bT) ? 5 : 8,
													$author$project$T2$Internal$Color$warning(context),
													$elm$core$Maybe$Nothing,
													title)),
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
												(!context.bT) ? A2(
													$author$project$T2$Text$headingSmallXAttrs,
													_List_Nil,
													$author$project$T2$Internal$Color$contentPrimary(context)) : A2(
													$author$project$T2$Text$headingSmallAttrs,
													_List_Nil,
													$author$project$T2$Internal$Color$contentPrimary(context)),
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$text(title)
													]))
											])),
										function () {
										if (!subtitleMaybe.$) {
											var subtitle = subtitleMaybe.a;
											return A2(
												$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
												(!context.bT) ? A2(
													$author$project$T2$Text$paragraphMediumAttrs,
													_List_Nil,
													$author$project$T2$Internal$Color$contentSecondary(context)) : A2(
													$author$project$T2$Text$paragraphLargeAttrs,
													_List_Nil,
													$author$project$T2$Internal$Color$contentSecondary(context)),
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$text(subtitle)
													]));
										} else {
											return $lucamug$elm_ui_with_context$Element$WithContext$none;
										}
									}(),
										function () {
										if (!msgReloadActionMaybe.$) {
											var msgReloadAction = msgReloadActionMaybe.a;
											return A3(
												(!context.bT) ? $author$project$T2$Button$buttonFilledEnabledSmall : $author$project$T2$Button$buttonFilledEnabledMedium,
												_List_fromArray(
													[$lucamug$elm_ui_with_context$Element$WithContext$alignRight]),
												msgReloadAction,
												'Reintentar');
										} else {
											if (!linkButtonValuesMaybe.$) {
												var linkButtonValues = linkButtonValuesMaybe.a;
												return A2(
													(!context.bT) ? $author$project$T2$Button$linkButtonFilledEnabledSmall : $author$project$T2$Button$linkButtonFilledEnabledMedium,
													_List_fromArray(
														[$lucamug$elm_ui_with_context$Element$WithContext$alignRight]),
													linkButtonValues);
											} else {
												return $lucamug$elm_ui_with_context$Element$WithContext$none;
											}
										}
									}()
									])))));
			});
	});
var $author$project$T2$Error$internalRenderGeneralSectionError = F4(
	function (attrs, title, subtitle, msgReloadAction) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var _v0 = context.cF;
				if (!_v0) {
					return A5(
						$author$project$T2$Internal$Error$renderSectionError,
						attrs,
						title,
						subtitle,
						$elm$core$Maybe$Just(msgReloadAction),
						$elm$core$Maybe$Nothing);
				} else {
					return A5(
						$author$project$T2$Internal$Error$renderSectionError,
						attrs,
						title,
						subtitle,
						$elm$core$Maybe$Just(msgReloadAction),
						$elm$core$Maybe$Nothing);
				}
			});
	});
var $author$project$T2$Error$generalSectionError = F4(
	function (attrs, title, subtitle, msgReloadAction) {
		return A4($author$project$T2$Error$internalRenderGeneralSectionError, attrs, title, subtitle, msgReloadAction);
	});
var $author$project$T2$Error$internalRenderGeneralSectionErrorWithLink = F4(
	function (attrs, title, subtitle, linkButtonValues) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var _v0 = context.cF;
				if (!_v0) {
					return A5(
						$author$project$T2$Internal$Error$renderSectionError,
						attrs,
						title,
						subtitle,
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(linkButtonValues));
				} else {
					return A5(
						$author$project$T2$Internal$Error$renderSectionError,
						attrs,
						title,
						subtitle,
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(linkButtonValues));
				}
			});
	});
var $author$project$T2$Error$generalSectionErrorWithLink = F4(
	function (attrs, title, subtitle, linkButtonValues) {
		return A4($author$project$T2$Error$internalRenderGeneralSectionErrorWithLink, attrs, title, subtitle, linkButtonValues);
	});
var $author$project$Page$Home$getMainContainerHeight = function (model) {
	var calculatedHeight = (model.S.bn - model.bC) - model.ec;
	return model.G ? $elm$core$Basics$round(calculatedHeight * 0.9) : calculatedHeight;
};
var $author$project$Page$Home$getMainContainerWidth = function (model) {
	return model.G ? 650 : model.S.dp;
};
var $author$project$Page$Home$getMainContainerSize = function (model) {
	return {
		bn: $author$project$Page$Home$getMainContainerHeight(model),
		dp: $author$project$Page$Home$getMainContainerWidth(model)
	};
};
var $author$project$T2$Internal$Color$Swatch$blackAlfa15Percent = A4($lucamug$elm_ui_with_context$Element$WithContext$rgba255, 0, 0, 0, 0.15);
var $author$project$T2$Internal$Color$Swatch$whiteAlfa30Percent = A4($lucamug$elm_ui_with_context$Element$WithContext$rgba255, 255, 255, 255, 0.3);
var $author$project$T2$Internal$Color$grayOrLight = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$blackAlfa15Percent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$whiteAlfa30Percent;
	}
};
var $author$project$T2$Internal$Text$HeadingMedium = 7;
var $author$project$T2$Text$headingMediumAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 7, color);
	});
var $author$project$T2$Internal$Icon$internalChevronLeft = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#chevron-left');
	});
var $author$project$T2$Internal$Icon$internalMoreOptionsFilled = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-fill: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#moreoptions-filled');
	});
var $author$project$T2$Internal$Icon$internalSuitcaseFilled = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-fill: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#suitcase-filled');
	});
var $author$project$Page$Home$referenceDataName = 'data-dropdown-id';
var $author$project$Page$Home$onBlurAttribute = F2(
	function (id, hideMsg) {
		var dataDecoder = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['relatedTarget', 'attributes', $author$project$Page$Home$referenceDataName, 'value']),
			$elm$json$Json$Decode$string);
		var attrToMsg = function (maybeAttr) {
			if (!maybeAttr.$) {
				var attr = maybeAttr.a;
				return _Utils_eq(attr, id) ? $elm$json$Json$Decode$fail('') : $elm$json$Json$Decode$succeed(hideMsg);
			} else {
				return $elm$json$Json$Decode$succeed(hideMsg);
			}
		};
		return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
			A2(
				$elm$html$Html$Events$on,
				'blur',
				A2(
					$elm$json$Json$Decode$andThen,
					attrToMsg,
					$elm$json$Json$Decode$maybe(dataDecoder))));
	});
var $author$project$T2$Internal$LoadingSpinner$Medium = 2;
var $author$project$T2$Text$labelSmallXAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 15, color);
	});
var $author$project$T2$Internal$LoadingSpinner$getSpinnerLabelAttrs = F2(
	function (size, context) {
		return A2(
			function () {
				switch (size) {
					case 0:
						return $author$project$T2$Text$labelSmallXAttrs;
					case 1:
						return $author$project$T2$Text$labelSmallAttrs;
					case 2:
						return $author$project$T2$Text$labelMediumAttrs;
					default:
						return $author$project$T2$Text$labelLargeAttrs;
				}
			}(),
			_List_Nil,
			$author$project$T2$Internal$Color$contentSecondary(context));
	});
var $author$project$T2$Internal$LoadingSpinner$renderSectionLoadingSpinner = F2(
	function (label, size) {
		var spinnerSize = $author$project$T2$Internal$LoadingSpinner$getSpinnerSize(size);
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$padding($author$project$T2$Internal$Spacing$spacing16)
						]),
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$centerX,
								$lucamug$elm_ui_with_context$Element$WithContext$centerY,
								$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16)
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$centerY]),
								A2(
									$author$project$T2$Internal$LoadingSpinner$internalSpinnerRotation,
									spinnerSize,
									$author$project$T2$Internal$Color$contentSecondary(context))),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								A2($author$project$T2$Internal$LoadingSpinner$getSpinnerLabelAttrs, size, context),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text(label)
									]))
							])));
			});
	});
var $author$project$T2$LoadingSpinner$sectionLoadingSpinnerMedium = function (label) {
	return A2($author$project$T2$Internal$LoadingSpinner$renderSectionLoadingSpinner, label, 2);
};
var $mdgriffith$elm_ui$Element$spaceEvenly = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$spacing, $mdgriffith$elm_ui$Internal$Style$classes.j_);
var $lucamug$elm_ui_with_context$Element$WithContext$spaceEvenly = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$spaceEvenly);
var $mdgriffith$elm_ui$Element$Font$underline = $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.kH);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$underline = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$underline);
var $author$project$T2$Internal$TextInput$InputText = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Home$MsgCategoryDropdownClosed = {$: 31};
var $author$project$Page$Home$MsgCategoryDropdownSelectChanged = function (a) {
	return {$: 32, a: a};
};
var $author$project$Page$Home$MsgCategoryDropdownToggled = {$: 30};
var $author$project$Page$Home$MsgEducationLevelDropdownClosed = {$: 37};
var $author$project$Page$Home$MsgEducationLevelDropdownSelectChanged = function (a) {
	return {$: 38, a: a};
};
var $author$project$Page$Home$MsgEducationLevelDropdownToggled = {$: 36};
var $author$project$Page$Home$MsgExperienceDropdownClosed = {$: 34};
var $author$project$Page$Home$MsgExperienceDropdownSelectChanged = function (a) {
	return {$: 35, a: a};
};
var $author$project$Page$Home$MsgExperienceDropdownToggled = {$: 33};
var $author$project$Page$Home$MsgUserAddedOneSkill = {$: 40};
var $author$project$Page$Home$MsgUserChangedExperienceYears = function (a) {
	return {$: 42, a: a};
};
var $author$project$Page$Home$MsgUserFocusedInput = {$: 79};
var $author$project$Page$Home$MsgUserLeftInput = {$: 80};
var $author$project$Page$Home$MsgUserSkippedApplyQuestions = {$: 28};
var $author$project$Page$Home$MsgUserSubmittedApplyQuestions = {$: 44};
var $author$project$T2$Internal$Icon$internalAdd = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#add');
	});
var $author$project$T2$Icon$add = $author$project$T2$Internal$Icon$internalAdd;
var $author$project$T2$Internal$Border$ApplyContainer = 2;
var $author$project$T2$Internal$Border$WidthY = {$: 6};
var $author$project$T2$Internal$Color$bcApplyContainer = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$bcDefault = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$bcTable = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Border$borderColorAttr = function (style) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContextAttribute(
		function (context) {
			switch (style) {
				case 0:
					return $lucamug$elm_ui_with_context$Element$WithContext$Border$color(
						$author$project$T2$Internal$Color$bcDefault(context));
				case 1:
					return $lucamug$elm_ui_with_context$Element$WithContext$Border$color(
						$author$project$T2$Internal$Color$bcTable(context));
				default:
					return $lucamug$elm_ui_with_context$Element$WithContext$Border$color(
						$author$project$T2$Internal$Color$bcApplyContainer(context));
			}
		});
};
var $mdgriffith$elm_ui$Element$Border$widthXY = F2(
	function (x, y) {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$borderWidth,
			A5(
				$mdgriffith$elm_ui$Internal$Model$BorderWidth,
				'b-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y))),
				y,
				x,
				y,
				x));
	});
var $mdgriffith$elm_ui$Element$Border$widthEach = function (_v0) {
	var bottom = _v0.bi;
	var top = _v0.by;
	var left = _v0.br;
	var right = _v0.bt;
	return (_Utils_eq(top, bottom) && _Utils_eq(left, right)) ? (_Utils_eq(top, right) ? $mdgriffith$elm_ui$Element$Border$width(top) : A2($mdgriffith$elm_ui$Element$Border$widthXY, left, top)) : A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderWidth,
		A5(
			$mdgriffith$elm_ui$Internal$Model$BorderWidth,
			'b-' + ($elm$core$String$fromInt(top) + ('-' + ($elm$core$String$fromInt(right) + ('-' + ($elm$core$String$fromInt(bottom) + ('-' + $elm$core$String$fromInt(left))))))),
			top,
			right,
			bottom,
			left));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$widthEach = function (edges) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Border$widthEach(edges));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$widthXY = F2(
	function (x, y) {
		return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
			A2($mdgriffith$elm_ui$Element$Border$widthXY, x, y));
	});
var $author$project$T2$Internal$Border$borderWidthAttr = function (borderWidth) {
	switch (borderWidth.$) {
		case 0:
			return $lucamug$elm_ui_with_context$Element$WithContext$Border$width(1);
		case 1:
			return $lucamug$elm_ui_with_context$Element$WithContext$Border$widthEach(
				{bi: 0, br: 0, bt: 0, by: 1});
		case 2:
			return $lucamug$elm_ui_with_context$Element$WithContext$Border$widthEach(
				{bi: 1, br: 0, bt: 0, by: 0});
		case 3:
			return $lucamug$elm_ui_with_context$Element$WithContext$Border$widthEach(
				{bi: 1, br: 0, bt: 0, by: 0});
		case 4:
			return $lucamug$elm_ui_with_context$Element$WithContext$Border$widthEach(
				{bi: 1, br: 0, bt: 0, by: 0});
		case 5:
			return A2($lucamug$elm_ui_with_context$Element$WithContext$Border$widthXY, 1, 0);
		case 6:
			return A2($lucamug$elm_ui_with_context$Element$WithContext$Border$widthXY, 0, 1);
		default:
			var customWidth = borderWidth.a;
			return $lucamug$elm_ui_with_context$Element$WithContext$Border$widthEach(customWidth);
	}
};
var $author$project$T2$Internal$Border$borderStyleAttrs = F3(
	function (borderWidth, borderShape, style) {
		return _List_fromArray(
			[
				$author$project$T2$Internal$Border$borderWidthAttr(borderWidth),
				$author$project$T2$Internal$Border$borderShapeAttr(borderShape),
				$author$project$T2$Internal$Border$borderColorAttr(style)
			]);
	});
var $author$project$T2$Border$borderSharpWidthYApplyContainer = A3($author$project$T2$Internal$Border$borderStyleAttrs, $author$project$T2$Internal$Border$WidthY, 5, 2);
var $author$project$T2$Button$buttonOutlinedEnabledMedium = F3(
	function (attrs, msg, label) {
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			1,
			0,
			1,
			$author$project$T2$Internal$Button$OnClick(msg),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $author$project$T2$Internal$Button$Ignore = {$: 0};
var $author$project$T2$Button$buttonOutlinedLoadingMedium = F2(
	function (attrs, label) {
		return A9($author$project$T2$Internal$Button$renderButton, attrs, 1, 2, 1, $author$project$T2$Internal$Button$Ignore, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, label, label);
	});
var $author$project$T2$Button$buttonTextDisabledMediumWithLeftIcon = F3(
	function (attrs, icon, label) {
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			2,
			1,
			1,
			$author$project$T2$Internal$Button$Ignore,
			$elm$core$Maybe$Just(icon),
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $author$project$T2$Button$buttonTextEnabledMedium = F3(
	function (attrs, msg, label) {
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			2,
			0,
			1,
			$author$project$T2$Internal$Button$OnClick(msg),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $author$project$T2$Button$buttonTextEnabledMediumWithLeftIcon = F4(
	function (attrs, msg, icon, label) {
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			2,
			0,
			1,
			$author$project$T2$Internal$Button$OnClick(msg),
			$elm$core$Maybe$Just(icon),
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $author$project$T2$Internal$Color$fgApplyActiveQuestionChatBubble = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTextInputLabel = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green99;
	}
};
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			M: _List_Nil,
			I: 0,
			L: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.I * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						M: A2($elm$core$List$cons, mappedLeaf, builder.M),
						I: builder.I + 1,
						L: builder.L
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$T2$Internal$TextInput$Enabled = 0;
var $author$project$T2$Internal$TextInput$Medium = 1;
var $author$project$T2$Internal$TextInput$Outlined = 1;
var $author$project$T2$Internal$TextInput$Disabled = 1;
var $author$project$T2$Internal$TextInput$Error = 3;
var $author$project$T2$Internal$TextInput$Success = 2;
var $author$project$T2$Internal$TextInput$Warning = 4;
var $author$project$T2$Internal$Color$bcTextInputFilledDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bcTextInputFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bcTextInputFilledError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$bcTextInputFilledFocus = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$bcTextInputFilledSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen30;
	}
};
var $author$project$T2$Internal$Color$bcTextInputFilledWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow30;
	}
};
var $author$project$T2$Internal$Color$bcTextInputOutlinedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bcTextInputOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$bcTextInputOutlinedError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$bcTextInputOutlinedSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen30;
	}
};
var $author$project$T2$Internal$Color$bcTextInputOutlinedWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow30;
	}
};
var $author$project$T2$Internal$Color$bgTextInputFilledActive = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgTextInputFilledDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgTextInputFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	}
};
var $author$project$T2$Internal$Color$bgTextInputFilledError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red01;
	}
};
var $author$project$T2$Internal$Color$bgTextInputFilledHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgTextInputFilledSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen10;
	}
};
var $author$project$T2$Internal$Color$bgTextInputFilledWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow00;
	}
};
var $author$project$T2$Internal$Color$bgTextInputOutlinedActive = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgTextInputOutlinedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgTextInputOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$bgTextInputOutlinedError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red00;
	}
};
var $author$project$T2$Internal$Color$bgTextInputOutlinedSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen10;
	}
};
var $author$project$T2$Internal$Color$bgTextInputOutlinedWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow00;
	}
};
var $mdgriffith$elm_ui$Element$Input$TextInputNode = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$Input$TextArea = {$: 1};
var $mdgriffith$elm_ui$Internal$Model$LivePolite = {$: 6};
var $mdgriffith$elm_ui$Element$Region$announce = $mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$LivePolite);
var $mdgriffith$elm_ui$Element$Input$applyLabel = F3(
	function (attrs, label, input) {
		if (label.$ === 1) {
			var labelText = label.a;
			return A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asColumn,
				$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
				attrs,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[input])));
		} else {
			var position = label.a;
			var labelAttrs = label.b;
			var labelChild = label.c;
			var labelElement = A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				labelAttrs,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[labelChild])));
			switch (position) {
				case 2:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asColumn,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cq),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[labelElement, input])));
				case 3:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asColumn,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cq),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[input, labelElement])));
				case 0:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asRow,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cq),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[input, labelElement])));
				default:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asRow,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cq),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[labelElement, input])));
			}
		}
	});
var $mdgriffith$elm_ui$Element$Input$autofill = A2(
	$elm$core$Basics$composeL,
	$mdgriffith$elm_ui$Internal$Model$Attr,
	$elm$html$Html$Attributes$attribute('autocomplete'));
var $mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding = function (attrs) {
	var gatherSpacing = F2(
		function (attr, found) {
			if ((attr.$ === 4) && (attr.b.$ === 5)) {
				var _v2 = attr.b;
				var x = _v2.b;
				var y = _v2.c;
				if (found.$ === 1) {
					return $elm$core$Maybe$Just(y);
				} else {
					return found;
				}
			} else {
				return found;
			}
		});
	var _v0 = A3($elm$core$List$foldr, gatherSpacing, $elm$core$Maybe$Nothing, attrs);
	if (_v0.$ === 1) {
		return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
	} else {
		var vSpace = _v0.a;
		return $mdgriffith$elm_ui$Element$moveUp(
			$elm$core$Basics$floor(vSpace / 2));
	}
};
var $mdgriffith$elm_ui$Element$rgb = F3(
	function (r, g, b) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, r, g, b, 1);
	});
var $mdgriffith$elm_ui$Element$Input$darkGrey = A3($mdgriffith$elm_ui$Element$rgb, 186 / 255, 189 / 255, 182 / 255);
var $mdgriffith$elm_ui$Element$Input$defaultTextPadding = A2($mdgriffith$elm_ui$Element$paddingXY, 12, 12);
var $mdgriffith$elm_ui$Element$Input$white = A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1);
var $mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Input$defaultTextPadding,
		$mdgriffith$elm_ui$Element$Border$rounded(3),
		$mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Element$Input$darkGrey),
		$mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$Input$white),
		$mdgriffith$elm_ui$Element$Border$width(1),
		$mdgriffith$elm_ui$Element$spacing(5),
		$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
		$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink)
	]);
var $mdgriffith$elm_ui$Element$Input$getHeight = function (attr) {
	if (attr.$ === 8) {
		var h = attr.a;
		return $elm$core$Maybe$Just(h);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Label = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute = function (label) {
	if (label.$ === 1) {
		var textLabel = label.a;
		return $mdgriffith$elm_ui$Internal$Model$Describe(
			$mdgriffith$elm_ui$Internal$Model$Label(textLabel));
	} else {
		return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
	}
};
var $mdgriffith$elm_ui$Element$Input$isConstrained = function (len) {
	isConstrained:
	while (true) {
		switch (len.$) {
			case 1:
				return false;
			case 0:
				return true;
			case 2:
				return true;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isConstrained;
			default:
				var l = len.b;
				return true;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$isHiddenLabel = function (label) {
	if (label.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Element$Input$isStacked = function (label) {
	if (!label.$) {
		var loc = label.a;
		switch (loc) {
			case 0:
				return false;
			case 1:
				return false;
			case 2:
				return true;
			default:
				return true;
		}
	} else {
		return true;
	}
};
var $mdgriffith$elm_ui$Element$Input$negateBox = function (box) {
	return {bi: -box.bi, br: -box.br, bt: -box.bt, by: -box.by};
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $mdgriffith$elm_ui$Element$Input$isFill = function (len) {
	isFill:
	while (true) {
		switch (len.$) {
			case 2:
				return true;
			case 1:
				return false;
			case 0:
				return false;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isFill;
			default:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isFill;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$isPixel = function (len) {
	isPixel:
	while (true) {
		switch (len.$) {
			case 1:
				return false;
			case 0:
				return true;
			case 2:
				return false;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isPixel;
			default:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isPixel;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$redistributeOver = F4(
	function (isMultiline, stacked, attr, els) {
		switch (attr.$) {
			case 9:
				return _Utils_update(
					els,
					{
						v: A2($elm$core$List$cons, attr, els.v)
					});
			case 7:
				var width = attr.a;
				return $mdgriffith$elm_ui$Element$Input$isFill(width) ? _Utils_update(
					els,
					{
						C: A2($elm$core$List$cons, attr, els.C),
						O: A2($elm$core$List$cons, attr, els.O),
						v: A2($elm$core$List$cons, attr, els.v)
					}) : (stacked ? _Utils_update(
					els,
					{
						C: A2($elm$core$List$cons, attr, els.C)
					}) : _Utils_update(
					els,
					{
						v: A2($elm$core$List$cons, attr, els.v)
					}));
			case 8:
				var height = attr.a;
				return (!stacked) ? _Utils_update(
					els,
					{
						C: A2($elm$core$List$cons, attr, els.C),
						v: A2($elm$core$List$cons, attr, els.v)
					}) : ($mdgriffith$elm_ui$Element$Input$isFill(height) ? _Utils_update(
					els,
					{
						C: A2($elm$core$List$cons, attr, els.C),
						v: A2($elm$core$List$cons, attr, els.v)
					}) : ($mdgriffith$elm_ui$Element$Input$isPixel(height) ? _Utils_update(
					els,
					{
						v: A2($elm$core$List$cons, attr, els.v)
					}) : _Utils_update(
					els,
					{
						v: A2($elm$core$List$cons, attr, els.v)
					})));
			case 6:
				return _Utils_update(
					els,
					{
						C: A2($elm$core$List$cons, attr, els.C)
					});
			case 5:
				return _Utils_update(
					els,
					{
						C: A2($elm$core$List$cons, attr, els.C)
					});
			case 4:
				switch (attr.b.$) {
					case 5:
						var _v1 = attr.b;
						return _Utils_update(
							els,
							{
								C: A2($elm$core$List$cons, attr, els.C),
								O: A2($elm$core$List$cons, attr, els.O),
								v: A2($elm$core$List$cons, attr, els.v),
								bD: A2($elm$core$List$cons, attr, els.bD)
							});
					case 7:
						var cls = attr.a;
						var _v2 = attr.b;
						var pad = _v2.a;
						var t = _v2.b;
						var r = _v2.c;
						var b = _v2.d;
						var l = _v2.e;
						if (isMultiline) {
							return _Utils_update(
								els,
								{
									ac: A2($elm$core$List$cons, attr, els.ac),
									v: A2($elm$core$List$cons, attr, els.v)
								});
						} else {
							var newTop = t - A2($elm$core$Basics$min, t, b);
							var newLineHeight = $mdgriffith$elm_ui$Element$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'line-height',
									'calc(1.0em + ' + ($elm$core$String$fromFloat(
										2 * A2($elm$core$Basics$min, t, b)) + 'px)')));
							var newHeight = $mdgriffith$elm_ui$Element$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'height',
									'calc(1.0em + ' + ($elm$core$String$fromFloat(
										2 * A2($elm$core$Basics$min, t, b)) + 'px)')));
							var newBottom = b - A2($elm$core$Basics$min, t, b);
							var reducedVerticalPadding = A2(
								$mdgriffith$elm_ui$Internal$Model$StyleClass,
								$mdgriffith$elm_ui$Internal$Flag$padding,
								A5(
									$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
									A4($mdgriffith$elm_ui$Internal$Model$paddingNameFloat, newTop, r, newBottom, l),
									newTop,
									r,
									newBottom,
									l));
							return _Utils_update(
								els,
								{
									ac: A2($elm$core$List$cons, attr, els.ac),
									O: A2(
										$elm$core$List$cons,
										newHeight,
										A2($elm$core$List$cons, newLineHeight, els.O)),
									v: A2($elm$core$List$cons, reducedVerticalPadding, els.v)
								});
						}
					case 6:
						var _v3 = attr.b;
						return _Utils_update(
							els,
							{
								ac: A2($elm$core$List$cons, attr, els.ac),
								v: A2($elm$core$List$cons, attr, els.v)
							});
					case 10:
						return _Utils_update(
							els,
							{
								ac: A2($elm$core$List$cons, attr, els.ac),
								v: A2($elm$core$List$cons, attr, els.v)
							});
					case 2:
						return _Utils_update(
							els,
							{
								C: A2($elm$core$List$cons, attr, els.C)
							});
					case 1:
						var _v4 = attr.b;
						return _Utils_update(
							els,
							{
								C: A2($elm$core$List$cons, attr, els.C)
							});
					default:
						var flag = attr.a;
						var cls = attr.b;
						return _Utils_update(
							els,
							{
								v: A2($elm$core$List$cons, attr, els.v)
							});
				}
			case 0:
				return els;
			case 1:
				var a = attr.a;
				return _Utils_update(
					els,
					{
						O: A2($elm$core$List$cons, attr, els.O)
					});
			case 2:
				return _Utils_update(
					els,
					{
						O: A2($elm$core$List$cons, attr, els.O)
					});
			case 3:
				return _Utils_update(
					els,
					{
						v: A2($elm$core$List$cons, attr, els.v)
					});
			default:
				return _Utils_update(
					els,
					{
						O: A2($elm$core$List$cons, attr, els.O)
					});
		}
	});
var $mdgriffith$elm_ui$Element$Input$redistribute = F3(
	function (isMultiline, stacked, attrs) {
		return function (redist) {
			return {
				ac: $elm$core$List$reverse(redist.ac),
				C: $elm$core$List$reverse(redist.C),
				O: $elm$core$List$reverse(redist.O),
				v: $elm$core$List$reverse(redist.v),
				bD: $elm$core$List$reverse(redist.bD)
			};
		}(
			A3(
				$elm$core$List$foldl,
				A2($mdgriffith$elm_ui$Element$Input$redistributeOver, isMultiline, stacked),
				{ac: _List_Nil, C: _List_Nil, O: _List_Nil, v: _List_Nil, bD: _List_Nil},
				attrs));
	});
var $mdgriffith$elm_ui$Element$Input$renderBox = function (_v0) {
	var top = _v0.by;
	var right = _v0.bt;
	var bottom = _v0.bi;
	var left = _v0.br;
	return $elm$core$String$fromInt(top) + ('px ' + ($elm$core$String$fromInt(right) + ('px ' + ($elm$core$String$fromInt(bottom) + ('px ' + ($elm$core$String$fromInt(left) + 'px'))))));
};
var $mdgriffith$elm_ui$Element$Input$charcoal = A3($mdgriffith$elm_ui$Element$rgb, 136 / 255, 138 / 255, 133 / 255);
var $mdgriffith$elm_ui$Element$Input$renderPlaceholder = F3(
	function (_v0, forPlaceholder, on) {
		var placeholderAttrs = _v0.a;
		var placeholderEl = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_Utils_ap(
				forPlaceholder,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$Input$charcoal),
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.eu + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.i5)),
							$mdgriffith$elm_ui$Element$clip,
							$mdgriffith$elm_ui$Element$Border$color(
							A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0)),
							$mdgriffith$elm_ui$Element$Background$color(
							A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$alpha(
							on ? 1 : 0)
						]),
					placeholderAttrs)),
			placeholderEl);
	});
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$spellcheck = $elm$html$Html$Attributes$boolProperty('spellcheck');
var $mdgriffith$elm_ui$Element$Input$spellcheck = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$spellcheck);
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $mdgriffith$elm_ui$Element$Input$value = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$value);
var $mdgriffith$elm_ui$Element$Input$textHelper = F3(
	function (textInput, attrs, textOptions) {
		var withDefaults = _Utils_ap($mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle, attrs);
		var redistributed = A3(
			$mdgriffith$elm_ui$Element$Input$redistribute,
			_Utils_eq(textInput.X, $mdgriffith$elm_ui$Element$Input$TextArea),
			$mdgriffith$elm_ui$Element$Input$isStacked(textOptions.u),
			withDefaults);
		var onlySpacing = function (attr) {
			if ((attr.$ === 4) && (attr.b.$ === 5)) {
				var _v9 = attr.b;
				return true;
			} else {
				return false;
			}
		};
		var heightConstrained = function () {
			var _v7 = textInput.X;
			if (!_v7.$) {
				var inputType = _v7.a;
				return false;
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$mdgriffith$elm_ui$Element$Input$isConstrained,
						$elm$core$List$head(
							$elm$core$List$reverse(
								A2($elm$core$List$filterMap, $mdgriffith$elm_ui$Element$Input$getHeight, withDefaults)))));
			}
		}();
		var getPadding = function (attr) {
			if ((attr.$ === 4) && (attr.b.$ === 7)) {
				var cls = attr.a;
				var _v6 = attr.b;
				var pad = _v6.a;
				var t = _v6.b;
				var r = _v6.c;
				var b = _v6.d;
				var l = _v6.e;
				return $elm$core$Maybe$Just(
					{
						bi: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(b - 3)),
						br: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(l - 3)),
						bt: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(r - 3)),
						by: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(t - 3))
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var parentPadding = A2(
			$elm$core$Maybe$withDefault,
			{bi: 0, br: 0, bt: 0, by: 0},
			$elm$core$List$head(
				$elm$core$List$reverse(
					A2($elm$core$List$filterMap, getPadding, withDefaults))));
		var inputElement = A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			function () {
				var _v3 = textInput.X;
				if (!_v3.$) {
					var inputType = _v3.a;
					return $mdgriffith$elm_ui$Internal$Model$NodeName('input');
				} else {
					return $mdgriffith$elm_ui$Internal$Model$NodeName('textarea');
				}
			}(),
			_Utils_ap(
				function () {
					var _v4 = textInput.X;
					if (!_v4.$) {
						var inputType = _v4.a;
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Internal$Model$Attr(
								$elm$html$Html$Attributes$type_(inputType)),
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.hV)
							]);
					} else {
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Element$clip,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.hR),
								$mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding(withDefaults),
								$mdgriffith$elm_ui$Element$paddingEach(parentPadding),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								A2(
									$elm$html$Html$Attributes$style,
									'margin',
									$mdgriffith$elm_ui$Element$Input$renderBox(
										$mdgriffith$elm_ui$Element$Input$negateBox(parentPadding)))),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$style, 'box-sizing', 'content-box'))
							]);
					}
				}(),
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Input$value(textOptions.s),
							$mdgriffith$elm_ui$Internal$Model$Attr(
							$elm$html$Html$Events$onInput(textOptions.bQ)),
							$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(textOptions.u),
							$mdgriffith$elm_ui$Element$Input$spellcheck(textInput.as),
							A2(
							$elm$core$Maybe$withDefault,
							$mdgriffith$elm_ui$Internal$Model$NoAttribute,
							A2($elm$core$Maybe$map, $mdgriffith$elm_ui$Element$Input$autofill, textInput.an))
						]),
					redistributed.O)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil));
		var wrappedInput = function () {
			var _v0 = textInput.X;
			if (_v0.$ === 1) {
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					_Utils_ap(
						(heightConstrained ? $elm$core$List$cons($mdgriffith$elm_ui$Element$scrollbarY) : $elm$core$Basics$identity)(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.d5),
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.hU)
								])),
						redistributed.v),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[
								A4(
								$mdgriffith$elm_ui$Internal$Model$element,
								$mdgriffith$elm_ui$Internal$Model$asParagraph,
								$mdgriffith$elm_ui$Internal$Model$div,
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
										A2(
											$elm$core$List$cons,
											$mdgriffith$elm_ui$Element$inFront(inputElement),
											A2(
												$elm$core$List$cons,
												$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.hT),
												redistributed.bD)))),
								$mdgriffith$elm_ui$Internal$Model$Unkeyed(
									function () {
										if (textOptions.s === '') {
											var _v1 = textOptions.i;
											if (_v1.$ === 1) {
												return _List_fromArray(
													[
														$mdgriffith$elm_ui$Element$text('\u00A0')
													]);
											} else {
												var place = _v1.a;
												return _List_fromArray(
													[
														A3($mdgriffith$elm_ui$Element$Input$renderPlaceholder, place, _List_Nil, textOptions.s === '')
													]);
											}
										} else {
											return _List_fromArray(
												[
													$mdgriffith$elm_ui$Internal$Model$unstyled(
													A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Style$classes.hS)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(textOptions.s + '\u00A0')
															])))
												]);
										}
									}()))
							])));
			} else {
				var inputType = _v0.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						A2(
							$elm$core$List$cons,
							A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.d5),
							$elm$core$List$concat(
								_List_fromArray(
									[
										redistributed.v,
										function () {
										var _v2 = textOptions.i;
										if (_v2.$ === 1) {
											return _List_Nil;
										} else {
											var place = _v2.a;
											return _List_fromArray(
												[
													$mdgriffith$elm_ui$Element$behindContent(
													A3($mdgriffith$elm_ui$Element$Input$renderPlaceholder, place, redistributed.ac, textOptions.s === ''))
												]);
										}
									}()
									])))),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[inputElement])));
			}
		}();
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			A2(
				$elm$core$List$cons,
				A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.gX),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$Input$isHiddenLabel(textOptions.u) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Element$spacing(5),
					A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$Region$announce, redistributed.C))),
			textOptions.u,
			wrappedInput);
	});
var $mdgriffith$elm_ui$Element$Input$currentPassword = F2(
	function (attrs, pass) {
		return A3(
			$mdgriffith$elm_ui$Element$Input$textHelper,
			{
				an: $elm$core$Maybe$Just('current-password'),
				as: false,
				X: $mdgriffith$elm_ui$Element$Input$TextInputNode(
					pass.jU ? 'text' : 'password')
			},
			attrs,
			{u: pass.u, bQ: pass.bQ, i: pass.i, s: pass.s});
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$runLabel = F2(
	function (context, _v0) {
		var f = _v0;
		return f(context);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$runPlaceholder = F2(
	function (context, _v0) {
		var f = _v0;
		return f(context);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$currentPassword = A2(
	$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
	$mdgriffith$elm_ui$Element$Input$currentPassword,
	F2(
		function (context, config) {
			return {
				u: A2($lucamug$elm_ui_with_context$Element$WithContext$Input$runLabel, context, config.u),
				bQ: config.bQ,
				i: A2(
					$elm$core$Maybe$map,
					$lucamug$elm_ui_with_context$Element$WithContext$Input$runPlaceholder(context),
					config.i),
				jU: config.jU,
				s: config.s
			};
		}));
var $mdgriffith$elm_ui$Element$Input$email = $mdgriffith$elm_ui$Element$Input$textHelper(
	{
		an: $elm$core$Maybe$Just('email'),
		as: false,
		X: $mdgriffith$elm_ui$Element$Input$TextInputNode('email')
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$textHelper = function (f) {
	return A2(
		$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
		f,
		F2(
			function (context, config) {
				return {
					u: A2($lucamug$elm_ui_with_context$Element$WithContext$Input$runLabel, context, config.u),
					bQ: config.bQ,
					i: A2(
						$elm$core$Maybe$map,
						$lucamug$elm_ui_with_context$Element$WithContext$Input$runPlaceholder(context),
						config.i),
					s: config.s
				};
			}));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Input$email = $lucamug$elm_ui_with_context$Element$WithContext$Input$textHelper($mdgriffith$elm_ui$Element$Input$email);
var $author$project$T2$Internal$Color$fgTextInputErrorHint = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red50;
	}
};
var $author$project$T2$Internal$Color$fgTextInputFilledActive = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTextInputFilledDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgTextInputFilledError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTextInputFilledSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTextInputFilledWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTextInputHint = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgTextInputLabelDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	}
};
var $author$project$T2$Internal$Color$fgTextInputOutlinedActive = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTextInputOutlinedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$fgTextInputOutlinedError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTextInputOutlinedSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTextInputOutlinedWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $lucamug$elm_ui_with_context$Element$WithContext$Input$Label = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Element$Input$HiddenLabel = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Element$Input$labelHidden = $mdgriffith$elm_ui$Element$Input$HiddenLabel;
var $lucamug$elm_ui_with_context$Element$WithContext$Input$labelHidden = function (content) {
	return function (_v0) {
		return $mdgriffith$elm_ui$Element$Input$labelHidden(content);
	};
};
var $mdgriffith$elm_ui$Element$moveLeft = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveX,
		$mdgriffith$elm_ui$Internal$Model$MoveX(-x));
};
var $lucamug$elm_ui_with_context$Element$WithContext$moveLeft = function (x) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attr(
		$mdgriffith$elm_ui$Element$moveLeft(x));
};
var $mdgriffith$elm_ui$Element$Input$multiline = F2(
	function (attrs, multi) {
		return A3(
			$mdgriffith$elm_ui$Element$Input$textHelper,
			{an: $elm$core$Maybe$Nothing, as: multi.j1, X: $mdgriffith$elm_ui$Element$Input$TextArea},
			attrs,
			{u: multi.u, bQ: multi.bQ, i: multi.i, s: multi.s});
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$multiline = A2(
	$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
	$mdgriffith$elm_ui$Element$Input$multiline,
	F2(
		function (context, config) {
			return {
				u: A2($lucamug$elm_ui_with_context$Element$WithContext$Input$runLabel, context, config.u),
				bQ: config.bQ,
				i: A2(
					$elm$core$Maybe$map,
					$lucamug$elm_ui_with_context$Element$WithContext$Input$runPlaceholder(context),
					config.i),
				j1: config.j1,
				s: config.s
			};
		}));
var $author$project$T2$Internal$Color$phTextInputFilledDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$phTextInputFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray95;
	}
};
var $author$project$T2$Internal$Color$phTextInputFilledFocus = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray70;
	}
};
var $author$project$T2$Internal$Color$phTextInputOutlinedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$phTextInputOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray70;
	}
};
var $author$project$T2$Internal$Color$phTextInputOutlinedFocus = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray70;
	}
};
var $author$project$T2$Internal$Color$phTextInputOutlinedWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray95;
	}
};
var $lucamug$elm_ui_with_context$Element$WithContext$Input$Placeholder = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Element$Input$Placeholder = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$Input$placeholder = $mdgriffith$elm_ui$Element$Input$Placeholder;
var $lucamug$elm_ui_with_context$Element$WithContext$Input$placeholder = F2(
	function (attrs, child) {
		return function (context) {
			return A2(
				$mdgriffith$elm_ui$Element$Input$placeholder,
				A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$attributes, context, attrs),
				A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$run, context, child));
		};
	});
var $mdgriffith$elm_ui$Internal$Model$boxShadowClass = function (shadow) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				shadow.eg ? 'box-inset' : 'box-',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.iW.a) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.iW.b) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.f6) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.jW) + 'px',
				$mdgriffith$elm_ui$Internal$Model$formatColorClass(shadow.gy)
			]));
};
var $mdgriffith$elm_ui$Internal$Flag$shadows = $mdgriffith$elm_ui$Internal$Flag$flag(19);
var $mdgriffith$elm_ui$Element$Border$shadow = function (almostShade) {
	var shade = {f6: almostShade.f6, gy: almostShade.gy, eg: false, iW: almostShade.iW, jW: almostShade.jW};
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$shadows,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			$mdgriffith$elm_ui$Internal$Model$boxShadowClass(shade),
			'box-shadow',
			$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(shade)));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$shadow = function (almostShade) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr(
		$mdgriffith$elm_ui$Element$Border$shadow(almostShade));
};
var $mdgriffith$elm_ui$Element$Input$text = $mdgriffith$elm_ui$Element$Input$textHelper(
	{
		an: $elm$core$Maybe$Nothing,
		as: false,
		X: $mdgriffith$elm_ui$Element$Input$TextInputNode('text')
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$text = $lucamug$elm_ui_with_context$Element$WithContext$Input$textHelper($mdgriffith$elm_ui$Element$Input$text);
var $author$project$T2$Internal$TextInput$renderTextInput = function (attrs) {
	return function (style) {
		return function (state) {
			return function (size) {
				return function (inputType) {
					return function (behaviour) {
						return function (value) {
							return function (leftIconMaybe) {
								return function (rightIconMaybe) {
									return function (labelMaybe) {
										return function (placeholderMaybe) {
											return function (hintMaybe) {
												return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
													function (context) {
														var labelEl = function () {
															if (!labelMaybe.$) {
																var labelText = labelMaybe.a;
																var labelFontColor = (state === 1) ? $author$project$T2$Internal$Color$fgTextInputLabelDisabled : $author$project$T2$Internal$Color$fgTextInputLabel;
																var labelFontAttrs = function () {
																	switch (size) {
																		case 0:
																			return $author$project$T2$Text$labelSmallAttrs;
																		case 1:
																			return $author$project$T2$Text$labelMediumAttrs;
																		default:
																			return $author$project$T2$Text$labelLargeAttrs;
																	}
																}();
																return A2(
																	$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																	A2(
																		labelFontAttrs,
																		_List_fromArray(
																			[
																				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
																				$lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft
																			]),
																		labelFontColor(context)),
																	_List_fromArray(
																		[
																			$lucamug$elm_ui_with_context$Element$WithContext$text(labelText)
																		]));
															} else {
																return $lucamug$elm_ui_with_context$Element$WithContext$none;
															}
														}();
														var inputHeight = function () {
															switch (inputType.$) {
																case 0:
																	switch (size) {
																		case 0:
																			return 36;
																		case 1:
																			return 48;
																		default:
																			return 56;
																	}
																case 1:
																	switch (size) {
																		case 0:
																			return 36;
																		case 1:
																			return 48;
																		default:
																			return 56;
																	}
																case 3:
																	switch (size) {
																		case 0:
																			return 36;
																		case 1:
																			return 48;
																		default:
																			return 56;
																	}
																case 2:
																	switch (size) {
																		case 0:
																			return 120;
																		case 1:
																			return 124;
																		default:
																			return 128;
																	}
																default:
																	switch (size) {
																		case 0:
																			return 36;
																		case 1:
																			return 48;
																		default:
																			return 56;
																	}
															}
														}();
														var inputFieldYPadding = function () {
															switch (size) {
																case 0:
																	return $author$project$T2$Internal$Spacing$spacing8;
																case 1:
																	return $author$project$T2$Internal$Spacing$spacing12;
																default:
																	return $author$project$T2$Internal$Spacing$spacing12 + 2;
															}
														}();
														var inputFieldXPadding = $author$project$T2$Internal$Spacing$spacing12;
														var iconSize = function () {
															switch (size) {
																case 0:
																	return 1;
																case 1:
																	return 2;
																default:
																	return 4;
															}
														}();
														var hintView = function () {
															if (!hintMaybe.$) {
																var hint = hintMaybe.a;
																var iconEl = function () {
																	switch (state) {
																		case 2:
																			return A4(
																				$author$project$T2$Internal$Icon$internalCheckFilled,
																				1,
																				$author$project$T2$Internal$Color$bcTextInputFilledSuccess(context),
																				$elm$core$Maybe$Nothing,
																				'success');
																		case 3:
																			return A4(
																				$author$project$T2$Internal$Icon$internalErrorFilled,
																				1,
																				$author$project$T2$Internal$Color$bcTextInputFilledError(context),
																				$elm$core$Maybe$Nothing,
																				'error');
																		case 4:
																			return A4(
																				$author$project$T2$Internal$Icon$internalWarningFilled,
																				1,
																				$author$project$T2$Internal$Color$bcTextInputFilledWarning(context),
																				$elm$core$Maybe$Nothing,
																				'warning');
																		case 0:
																			return $lucamug$elm_ui_with_context$Element$WithContext$none;
																		default:
																			return $lucamug$elm_ui_with_context$Element$WithContext$none;
																	}
																}();
																var hintFontColor = (state === 1) ? $author$project$T2$Internal$Color$fgTextInputLabelDisabled : ((state === 3) ? $author$project$T2$Internal$Color$fgTextInputErrorHint : (((state === 2) || (state === 4)) ? $author$project$T2$Internal$Color$fgTextInputLabel : $author$project$T2$Internal$Color$fgTextInputHint));
																var hintFontAttrs = function () {
																	switch (size) {
																		case 0:
																			return $author$project$T2$Text$paragraphSmallAttrs;
																		case 1:
																			return $author$project$T2$Text$paragraphMediumAttrs;
																		default:
																			return $author$project$T2$Text$paragraphLargeAttrs;
																	}
																}();
																return A2(
																	$lucamug$elm_ui_with_context$Element$WithContext$row,
																	_List_fromArray(
																		[
																			$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8)
																		]),
																	_List_fromArray(
																		[
																			iconEl,
																			A2(
																			$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																			A2(
																				hintFontAttrs,
																				_List_Nil,
																				hintFontColor(context)),
																			_List_fromArray(
																				[
																					$lucamug$elm_ui_with_context$Element$WithContext$text(hint)
																				]))
																		]));
															} else {
																return $lucamug$elm_ui_with_context$Element$WithContext$none;
															}
														}();
														var fieldPadding = function () {
															var inputTextPaddingTop = function () {
																switch (size) {
																	case 0:
																		return 1;
																	case 1:
																		return 3;
																	default:
																		return 3;
																}
															}();
															var inputPaddingXWhenIcon = ($author$project$T2$Internal$Icon$pixelsForSize(iconSize) + inputFieldXPadding) + $author$project$T2$Internal$Spacing$spacing8;
															var _v80 = _Utils_Tuple2(leftIconMaybe, rightIconMaybe);
															if (!_v80.a.$) {
																if (_v80.b.$ === 1) {
																	var _v81 = _v80.b;
																	return _List_fromArray(
																		[
																			$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
																			{bi: inputFieldYPadding + inputTextPaddingTop, br: inputPaddingXWhenIcon, bt: 0, by: inputFieldYPadding + inputTextPaddingTop})
																		]);
																} else {
																	return _List_fromArray(
																		[
																			$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
																			{bi: inputFieldYPadding + inputTextPaddingTop, br: inputPaddingXWhenIcon, bt: inputPaddingXWhenIcon, by: inputFieldYPadding + inputTextPaddingTop})
																		]);
																}
															} else {
																if (!_v80.b.$) {
																	var _v82 = _v80.a;
																	return _List_fromArray(
																		[
																			$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
																			{bi: inputFieldYPadding + inputTextPaddingTop, br: inputFieldXPadding, bt: inputPaddingXWhenIcon, by: inputFieldYPadding + inputTextPaddingTop})
																		]);
																} else {
																	var _v83 = _v80.a;
																	var _v84 = _v80.b;
																	return _List_fromArray(
																		[
																			$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
																			{bi: inputFieldYPadding + inputTextPaddingTop, br: inputFieldXPadding, bt: inputFieldXPadding, by: inputFieldYPadding + inputTextPaddingTop})
																		]);
																}
															}
														}();
														var borderWidth = function () {
															var width = function () {
																var _v59 = _Utils_Tuple2(style, state);
																if (!_v59.a) {
																	switch (_v59.b) {
																		case 0:
																			var _v60 = _v59.a;
																			var _v61 = _v59.b;
																			return 1;
																		case 1:
																			var _v62 = _v59.a;
																			var _v63 = _v59.b;
																			return 1;
																		case 2:
																			var _v64 = _v59.a;
																			var _v65 = _v59.b;
																			return 2;
																		case 3:
																			var _v66 = _v59.a;
																			var _v67 = _v59.b;
																			return 2;
																		default:
																			var _v68 = _v59.a;
																			var _v69 = _v59.b;
																			return 2;
																	}
																} else {
																	switch (_v59.b) {
																		case 0:
																			var _v70 = _v59.a;
																			var _v71 = _v59.b;
																			return 1;
																		case 1:
																			var _v72 = _v59.a;
																			var _v73 = _v59.b;
																			return 1;
																		case 2:
																			var _v74 = _v59.a;
																			var _v75 = _v59.b;
																			return 2;
																		case 3:
																			var _v76 = _v59.a;
																			var _v77 = _v59.b;
																			return 2;
																		default:
																			var _v78 = _v59.a;
																			var _v79 = _v59.b;
																			return 2;
																	}
																}
															}();
															return _List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$width(width)
																]);
														}();
														var borderColor = function () {
															var bc = function () {
																var _v38 = _Utils_Tuple2(style, state);
																if (!_v38.a) {
																	switch (_v38.b) {
																		case 0:
																			var _v39 = _v38.a;
																			var _v40 = _v38.b;
																			return $elm$core$Maybe$Just($author$project$T2$Internal$Color$bcTextInputFilledEnabled);
																		case 1:
																			var _v41 = _v38.a;
																			var _v42 = _v38.b;
																			return $elm$core$Maybe$Just($author$project$T2$Internal$Color$bcTextInputFilledDisabled);
																		case 2:
																			var _v43 = _v38.a;
																			var _v44 = _v38.b;
																			return $elm$core$Maybe$Just($author$project$T2$Internal$Color$bcTextInputFilledSuccess);
																		case 3:
																			var _v45 = _v38.a;
																			var _v46 = _v38.b;
																			return $elm$core$Maybe$Just($author$project$T2$Internal$Color$bcTextInputFilledError);
																		default:
																			var _v47 = _v38.a;
																			var _v48 = _v38.b;
																			return $elm$core$Maybe$Just($author$project$T2$Internal$Color$bcTextInputFilledWarning);
																	}
																} else {
																	switch (_v38.b) {
																		case 0:
																			var _v49 = _v38.a;
																			var _v50 = _v38.b;
																			return $elm$core$Maybe$Just($author$project$T2$Internal$Color$bcTextInputOutlinedEnabled);
																		case 1:
																			var _v51 = _v38.a;
																			var _v52 = _v38.b;
																			return $elm$core$Maybe$Just($author$project$T2$Internal$Color$bcTextInputOutlinedDisabled);
																		case 2:
																			var _v53 = _v38.a;
																			var _v54 = _v38.b;
																			return $elm$core$Maybe$Just($author$project$T2$Internal$Color$bcTextInputOutlinedSuccess);
																		case 3:
																			var _v55 = _v38.a;
																			var _v56 = _v38.b;
																			return $elm$core$Maybe$Just($author$project$T2$Internal$Color$bcTextInputOutlinedError);
																		default:
																			var _v57 = _v38.a;
																			var _v58 = _v38.b;
																			return $elm$core$Maybe$Just($author$project$T2$Internal$Color$bcTextInputOutlinedWarning);
																	}
																}
															}();
															if (!bc.$) {
																var color = bc.a;
																return _List_fromArray(
																	[
																		$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
																		color(context))
																	]);
															} else {
																return _List_Nil;
															}
														}();
														var _v0 = function () {
															var _v1 = _Utils_Tuple2(style, state);
															if (!_v1.a) {
																switch (_v1.b) {
																	case 0:
																		var _v2 = _v1.a;
																		var _v3 = _v1.b;
																		return _Utils_Tuple3($author$project$T2$Internal$Color$fgTextInputFilledActive, $author$project$T2$Internal$Color$bgTextInputFilledEnabled, $author$project$T2$Internal$Color$phTextInputFilledEnabled);
																	case 1:
																		var _v4 = _v1.a;
																		var _v5 = _v1.b;
																		return _Utils_Tuple3($author$project$T2$Internal$Color$fgTextInputFilledDisabled, $author$project$T2$Internal$Color$bgTextInputFilledDisabled, $author$project$T2$Internal$Color$phTextInputFilledDisabled);
																	case 2:
																		var _v6 = _v1.a;
																		var _v7 = _v1.b;
																		return _Utils_Tuple3($author$project$T2$Internal$Color$fgTextInputFilledSuccess, $author$project$T2$Internal$Color$bgTextInputFilledSuccess, $author$project$T2$Internal$Color$phTextInputFilledEnabled);
																	case 3:
																		var _v8 = _v1.a;
																		var _v9 = _v1.b;
																		return _Utils_Tuple3($author$project$T2$Internal$Color$fgTextInputFilledError, $author$project$T2$Internal$Color$bgTextInputFilledError, $author$project$T2$Internal$Color$phTextInputFilledEnabled);
																	default:
																		var _v10 = _v1.a;
																		var _v11 = _v1.b;
																		return _Utils_Tuple3($author$project$T2$Internal$Color$fgTextInputFilledWarning, $author$project$T2$Internal$Color$bgTextInputFilledWarning, $author$project$T2$Internal$Color$phTextInputFilledEnabled);
																}
															} else {
																switch (_v1.b) {
																	case 0:
																		var _v12 = _v1.a;
																		var _v13 = _v1.b;
																		return _Utils_Tuple3($author$project$T2$Internal$Color$fgTextInputOutlinedActive, $author$project$T2$Internal$Color$bgTextInputOutlinedEnabled, $author$project$T2$Internal$Color$phTextInputOutlinedEnabled);
																	case 1:
																		var _v14 = _v1.a;
																		var _v15 = _v1.b;
																		return _Utils_Tuple3($author$project$T2$Internal$Color$fgTextInputOutlinedDisabled, $author$project$T2$Internal$Color$bgTextInputOutlinedDisabled, $author$project$T2$Internal$Color$phTextInputOutlinedDisabled);
																	case 2:
																		var _v16 = _v1.a;
																		var _v17 = _v1.b;
																		return _Utils_Tuple3($author$project$T2$Internal$Color$fgTextInputOutlinedSuccess, $author$project$T2$Internal$Color$bgTextInputOutlinedSuccess, $author$project$T2$Internal$Color$phTextInputOutlinedEnabled);
																	case 3:
																		var _v18 = _v1.a;
																		var _v19 = _v1.b;
																		return _Utils_Tuple3($author$project$T2$Internal$Color$fgTextInputOutlinedError, $author$project$T2$Internal$Color$bgTextInputOutlinedError, $author$project$T2$Internal$Color$phTextInputOutlinedEnabled);
																	default:
																		var _v20 = _v1.a;
																		var _v21 = _v1.b;
																		return _Utils_Tuple3($author$project$T2$Internal$Color$fgTextInputOutlinedWarning, $author$project$T2$Internal$Color$bgTextInputOutlinedWarning, $author$project$T2$Internal$Color$phTextInputOutlinedWarning);
																}
															}
														}();
														var fgColor = _v0.a;
														var bgColor = _v0.b;
														var phColor = _v0.c;
														var fontColor = (value === '') ? phColor(context) : fgColor(context);
														var leadingIconView = function () {
															if (!leftIconMaybe.$) {
																var leftIcon = leftIconMaybe.a;
																return _List_fromArray(
																	[
																		$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
																		A2(
																			$lucamug$elm_ui_with_context$Element$WithContext$el,
																			_Utils_ap(
																				_List_fromArray(
																					[
																						$lucamug$elm_ui_with_context$Element$WithContext$centerY,
																						$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
																						{bi: 0, br: inputFieldXPadding, bt: 0, by: 0})
																					]),
																				function () {
																					var _v36 = leftIcon.iX;
																					if (!_v36.$) {
																						var onClickMsg = _v36.a;
																						return _List_fromArray(
																							[
																								$lucamug$elm_ui_with_context$Element$WithContext$pointer,
																								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(onClickMsg)
																							]);
																					} else {
																						return _List_Nil;
																					}
																				}()),
																			A4(leftIcon.hI, iconSize, fontColor, $elm$core$Maybe$Nothing, '')))
																	]);
															} else {
																return _List_Nil;
															}
														}();
														var trailingIconView = function () {
															if (!rightIconMaybe.$) {
																var rightIcon = rightIconMaybe.a;
																return _List_fromArray(
																	[
																		$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
																		A2(
																			$lucamug$elm_ui_with_context$Element$WithContext$el,
																			_Utils_ap(
																				_List_fromArray(
																					[
																						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																						A2($elm$html$Html$Attributes$style, 'left', '100%')),
																						$lucamug$elm_ui_with_context$Element$WithContext$centerY,
																						$lucamug$elm_ui_with_context$Element$WithContext$moveLeft(
																						$author$project$T2$Internal$Icon$pixelsForSize(iconSize) + inputFieldXPadding)
																					]),
																				function () {
																					var _v34 = rightIcon.iX;
																					if (!_v34.$) {
																						var onClickMsg = _v34.a;
																						return _List_fromArray(
																							[
																								$lucamug$elm_ui_with_context$Element$WithContext$pointer,
																								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(onClickMsg)
																							]);
																					} else {
																						return _List_Nil;
																					}
																				}()),
																			A4(rightIcon.hI, iconSize, fontColor, $elm$core$Maybe$Nothing, '')))
																	]);
															} else {
																return _List_Nil;
															}
														}();
														var fieldAttrs = function () {
															var textFieldTextAttrs = function () {
																switch (size) {
																	case 0:
																		return $author$project$T2$Text$paragraphSmallAttrs(_List_Nil);
																	case 1:
																		return $author$project$T2$Text$paragraphMediumAttrs(_List_Nil);
																	default:
																		return $author$project$T2$Text$paragraphLargeAttrs(_List_Nil);
																}
															}();
															var mouseDownBc = function () {
																if (state !== 1) {
																	if (!style) {
																		return $author$project$T2$Internal$Color$bgTextInputFilledActive;
																	} else {
																		return $author$project$T2$Internal$Color$bgTextInputOutlinedActive;
																	}
																} else {
																	if (!style) {
																		return $author$project$T2$Internal$Color$bgTextInputFilledDisabled;
																	} else {
																		return $author$project$T2$Internal$Color$bgTextInputOutlinedDisabled;
																	}
																}
															}();
															var hoverEl = function () {
																switch (state) {
																	case 0:
																		if (!style) {
																			return _List_fromArray(
																				[
																					$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
																					_List_fromArray(
																						[
																							$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
																							$author$project$T2$Internal$Color$bgTextInputFilledHovered(context)),
																							$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
																							$author$project$T2$Internal$Color$fgTextInputFilledActive(context))
																						]))
																				]);
																		} else {
																			return _List_fromArray(
																				[
																					$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
																					_List_fromArray(
																						[
																							$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
																							$author$project$T2$Internal$Color$bgTextInputOutlinedEnabled(context)),
																							$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
																							$author$project$T2$Internal$Color$fgTextInputOutlinedActive(context))
																						]))
																				]);
																		}
																	case 2:
																		return _List_Nil;
																	case 3:
																		return _List_Nil;
																	case 4:
																		return _List_Nil;
																	default:
																		return _List_Nil;
																}
															}();
															var focusFg = function () {
																if (state !== 1) {
																	if (value === '') {
																		if (!style) {
																			return $author$project$T2$Internal$Color$phTextInputFilledFocus;
																		} else {
																			return $author$project$T2$Internal$Color$phTextInputOutlinedFocus;
																		}
																	} else {
																		if (!style) {
																			return $author$project$T2$Internal$Color$fgTextInputFilledActive;
																		} else {
																			return $author$project$T2$Internal$Color$fgTextInputOutlinedActive;
																		}
																	}
																} else {
																	if (!style) {
																		return $author$project$T2$Internal$Color$fgTextInputFilledDisabled;
																	} else {
																		return $author$project$T2$Internal$Color$fgTextInputOutlinedDisabled;
																	}
																}
															}();
															var bcFocused = function () {
																switch (state) {
																	case 0:
																		return $author$project$T2$Internal$Color$bcTextInputFilledFocus;
																	case 1:
																		return $author$project$T2$Internal$Color$bcTextInputFilledDisabled;
																	case 2:
																		return $author$project$T2$Internal$Color$bcTextInputFilledSuccess;
																	case 3:
																		return $author$project$T2$Internal$Color$bcTextInputFilledError;
																	default:
																		return $author$project$T2$Internal$Color$bcTextInputFilledWarning;
																}
															}();
															var baseFieldAttrs = _Utils_ap(
																_Utils_ap(
																	_List_fromArray(
																		[
																			$author$project$T2$Border$borderRoundedDefault,
																			$lucamug$elm_ui_with_context$Element$WithContext$height(
																			$lucamug$elm_ui_with_context$Element$WithContext$px(inputHeight)),
																			$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
																			$lucamug$elm_ui_with_context$Element$WithContext$centerY,
																			$lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft,
																			$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
																			bgColor(context)),
																			$lucamug$elm_ui_with_context$Element$WithContext$focused(
																			_List_fromArray(
																				[
																					$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
																					mouseDownBc(context)),
																					$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
																					focusFg(context)),
																					$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
																					{
																						f6: 0,
																						gy: bcFocused(context),
																						iW: _Utils_Tuple2(0, 0),
																						jW: 1
																					})
																				]))
																		]),
																	textFieldTextAttrs(fontColor)),
																_Utils_ap(
																	hoverEl,
																	(state === 1) ? _List_fromArray(
																		[
																			$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																			$elm$html$Html$Attributes$disabled(true)),
																			$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																			A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true')),
																			$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																			$elm$html$Html$Attributes$class('tt-cursor-not-allowed'))
																		]) : _List_Nil));
															return _Utils_ap(
																baseFieldAttrs,
																_Utils_ap(
																	fieldPadding,
																	_Utils_ap(
																		borderColor,
																		_Utils_ap(
																			borderWidth,
																			_Utils_ap(leadingIconView, trailingIconView)))));
														}();
														var placeholder = A2(
															$elm$core$Maybe$map,
															function (pl) {
																return A2(
																	$lucamug$elm_ui_with_context$Element$WithContext$Input$placeholder,
																	_List_fromArray(
																		[
																			$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
																			phColor(context)),
																			$lucamug$elm_ui_with_context$Element$WithContext$centerY
																		]),
																	$lucamug$elm_ui_with_context$Element$WithContext$text(pl));
															},
															placeholderMaybe);
														var elementInputType = function () {
															switch (inputType.$) {
																case 0:
																	var inputTextElAttrs = inputType.a;
																	return A2(
																		$lucamug$elm_ui_with_context$Element$WithContext$Input$text,
																		_Utils_ap(fieldAttrs, inputTextElAttrs),
																		{
																			u: $lucamug$elm_ui_with_context$Element$WithContext$Input$labelHidden(
																				A2($elm$core$Maybe$withDefault, '', labelMaybe)),
																			bQ: behaviour,
																			i: placeholder,
																			s: value
																		});
																case 1:
																	var inputTextElAttrs = inputType.a;
																	return A2(
																		$lucamug$elm_ui_with_context$Element$WithContext$Input$email,
																		_Utils_ap(fieldAttrs, inputTextElAttrs),
																		{
																			u: $lucamug$elm_ui_with_context$Element$WithContext$Input$labelHidden(
																				A2($elm$core$Maybe$withDefault, '', labelMaybe)),
																			bQ: behaviour,
																			i: placeholder,
																			s: value
																		});
																case 3:
																	var inputTextElAttrs = inputType.a;
																	return A2(
																		$lucamug$elm_ui_with_context$Element$WithContext$Input$currentPassword,
																		_Utils_ap(fieldAttrs, inputTextElAttrs),
																		{
																			u: $lucamug$elm_ui_with_context$Element$WithContext$Input$labelHidden(
																				A2($elm$core$Maybe$withDefault, '', labelMaybe)),
																			bQ: behaviour,
																			i: placeholder,
																			jU: false,
																			s: value
																		});
																case 2:
																	var inputTextElAttrs = inputType.a;
																	return A2(
																		$lucamug$elm_ui_with_context$Element$WithContext$Input$multiline,
																		_Utils_ap(fieldAttrs, inputTextElAttrs),
																		{
																			u: $lucamug$elm_ui_with_context$Element$WithContext$Input$labelHidden(
																				A2($elm$core$Maybe$withDefault, '', labelMaybe)),
																			bQ: behaviour,
																			i: placeholder,
																			j1: false,
																			s: value
																		});
																default:
																	var inputTextElAttrs = inputType.a;
																	return A2(
																		$lucamug$elm_ui_with_context$Element$WithContext$Input$text,
																		_Utils_ap(fieldAttrs, inputTextElAttrs),
																		{
																			u: $lucamug$elm_ui_with_context$Element$WithContext$Input$labelHidden(
																				A2($elm$core$Maybe$withDefault, '', labelMaybe)),
																			bQ: behaviour,
																			i: placeholder,
																			s: value
																		});
															}
														}();
														return A2(
															$lucamug$elm_ui_with_context$Element$WithContext$column,
															_Utils_ap(
																_List_fromArray(
																	[
																		$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8),
																		$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
																	]),
																attrs),
															_List_fromArray(
																[
																	labelEl,
																	A2(
																	$lucamug$elm_ui_with_context$Element$WithContext$el,
																	A2(
																		$elm$core$List$cons,
																		$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
																		function () {
																			switch (inputType.$) {
																				case 0:
																					return _List_Nil;
																				case 1:
																					return _List_Nil;
																				case 3:
																					return _List_Nil;
																				case 2:
																					return _List_fromArray(
																						[
																							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																							$elm$html$Html$Attributes$class('tt-textarea'))
																						]);
																				default:
																					return _List_Nil;
																			}
																		}()),
																	elementInputType),
																	hintView
																]));
													});
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$T2$TextInput$textInputOutlinedEnabledMedium = F7(
	function (attrs, msg, label, placeholder, value, hint, inputType) {
		return $author$project$T2$Internal$TextInput$renderTextInput(attrs)(1)(0)(1)(inputType)(msg)(value)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)(label)(placeholder)(hint);
	});
var $author$project$T2$TextInput$textInputOutlinedErrorMedium = F7(
	function (attrs, msg, label, placeholder, value, hint, inputType) {
		return $author$project$T2$Internal$TextInput$renderTextInput(attrs)(1)(3)(1)(inputType)(msg)(value)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)(label)(placeholder)(hint);
	});
var $author$project$Page$Home$MsgUserClosedCandidateInfoLoadedMessage = {$: 74};
var $author$project$T2$Internal$Color$bgApplyWelcomeQuestionChatBubble = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray10;
	}
};
var $author$project$T2$Internal$Border$RoundedBottom = 2;
var $author$project$T2$Border$borderRoundedBottom = $author$project$T2$Internal$Border$borderShapeAttr(2);
var $author$project$T2$Internal$Logo$Inverse = 1;
var $author$project$T2$Logo$talentecaLogoHorizontalInverse = function (attrs) {
	return A3($author$project$T2$Internal$Logo$renderLogo, attrs, 0, 1);
};
var $author$project$Page$Home$MsgUserClosedCandidateNotLoggedInMessage = {$: 83};
var $author$project$T2$Internal$Color$bgApplyLoginDialog = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $mdgriffith$elm_ui$Element$Font$bold = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.f7);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$bold = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$bold);
var $author$project$T2$Internal$Border$Default = 0;
var $author$project$T2$Internal$Border$WidthBottom = {$: 2};
var $author$project$T2$Border$borderSharpWidthBottomDefault = A3($author$project$T2$Internal$Border$borderStyleAttrs, $author$project$T2$Internal$Border$WidthBottom, 5, 0);
var $author$project$T2$Button$buttonFilledLoadingSmall = F2(
	function (attrs, label) {
		return A9($author$project$T2$Internal$Button$renderButton, attrs, 0, 2, 0, $author$project$T2$Internal$Button$Ignore, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, label, label);
	});
var $author$project$T2$Icon$exit = $author$project$T2$Internal$Icon$internalExit;
var $author$project$T2$Internal$IconButton$Small = 0;
var $author$project$T2$IconButton$iconButtonIconTertiaryEnabledSmall = F4(
	function (attrs, msg, icon, alt) {
		return A7(
			$author$project$T2$Internal$IconButton$renderIconButton,
			attrs,
			3,
			0,
			0,
			$author$project$T2$Internal$IconButton$OnClick(msg),
			icon,
			alt);
	});
var $author$project$T2$Internal$Logo$IsotypeOnly = 2;
var $author$project$T2$Logo$talentecaLogoIsotypeOnlyNormal = function (attrs) {
	return A3($author$project$T2$Internal$Logo$renderLogo, attrs, 2, 0);
};
var $author$project$Page$Home$viewCandidateNotLoggedInTalentecaDialog = function (model) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			if (model.p.ai) {
				var continueAsMessage = 'Continuar ' + A2(
					$elm$core$Maybe$withDefault,
					'con Talenteca',
					A2(
						$elm$core$Maybe$map,
						function (f) {
							return 'como ' + A2(
								$elm$core$Maybe$withDefault,
								f,
								$elm$core$List$head(
									A2($elm$core$String$split, ' ', f)));
						},
						model.N.hl));
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
							$author$project$T2$Internal$Color$bgApplyLoginDialog(context)),
							$author$project$T2$Border$borderRoundedTop,
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('sentry-mask'))
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							_Utils_ap(
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$spacing(12),
										A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12)
									]),
								$author$project$T2$Border$borderSharpWidthBottomDefault),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
									A2(
										$author$project$T2$Text$paragraphMediumAttrs,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
											]),
										$author$project$T2$Internal$Color$contentPrimary(context)),
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$text('... o inicia sesión en Talenteca')
										])),
									A4(
									$author$project$T2$IconButton$iconButtonIconTertiaryEnabledSmall,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$class('close-modal'))
										]),
									$author$project$Page$Home$MsgUserClosedCandidateNotLoggedInMessage,
									$author$project$T2$Icon$exit,
									'cerrar')
								])),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(16),
									$lucamug$elm_ui_with_context$Element$WithContext$padding(12)
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$row,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$spacing(4),
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									_List_fromArray(
										[
											$author$project$T2$Logo$talentecaLogoIsotypeOnlyNormal(
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$width(
													$lucamug$elm_ui_with_context$Element$WithContext$px(28))
												])),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$column,
											A2(
												$author$project$T2$Text$paragraphSmallAttrs,
												_List_fromArray(
													[
														A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 4, 0),
														$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
														$lucamug$elm_ui_with_context$Element$WithContext$spacing(4)
													]),
												$author$project$T2$Internal$Color$contentPrimary(context)),
											_List_fromArray(
												[
													function () {
													var _v0 = model.N.hl;
													if (!_v0.$) {
														var fullname = _v0.a;
														return A2(
															$lucamug$elm_ui_with_context$Element$WithContext$el,
															_List_fromArray(
																[$lucamug$elm_ui_with_context$Element$WithContext$Font$bold]),
															$lucamug$elm_ui_with_context$Element$WithContext$text(fullname));
													} else {
														return $lucamug$elm_ui_with_context$Element$WithContext$none;
													}
												}(),
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$el,
													_List_Nil,
													$lucamug$elm_ui_with_context$Element$WithContext$text(model.N.cl))
												]))
										])),
									model.p.E ? A2(
									$author$project$T2$Button$buttonFilledLoadingSmall,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$centerX,
											$lucamug$elm_ui_with_context$Element$WithContext$pointer,
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$class('login-not-with-google-button'))
										]),
									'Cargando') : A3(
									$author$project$T2$Button$buttonFilledEnabledSmall,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$centerX,
											$lucamug$elm_ui_with_context$Element$WithContext$pointer,
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$class('login-not-with-google-button'))
										]),
									$author$project$Page$Home$MsgUserClickedSendMagicLink(model.N.cl),
									continueAsMessage)
								]))
						]));
			} else {
				return $lucamug$elm_ui_with_context$Element$WithContext$none;
			}
		});
};
var $author$project$Page$Home$TkSnackbarMessageError = 0;
var $author$project$T2$Internal$Alert$Small = 0;
var $author$project$T2$Alert$initAlertLowErrorSmall = F2(
	function (id, message) {
		return $author$project$T2$Internal$Alert$init(id)(0)(0)(0)(message)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)(false)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing);
	});
var $author$project$T2$Alert$initAlertLowSuccessSmall = F2(
	function (id, message) {
		return $author$project$T2$Internal$Alert$init(id)(0)(2)(0)(message)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)(false)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing);
	});
var $author$project$T2$Link$actionLinkBoldEnabledLarge = F3(
	function (attrs, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(1)(1)($elm$core$Maybe$Nothing)(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(0);
	});
var $author$project$T2$Link$actionLinkBoldEnabledMedium = F3(
	function (attrs, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(2)(1)($elm$core$Maybe$Nothing)(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(0);
	});
var $author$project$T2$Link$actionLinkBoldEnabledSmall = F3(
	function (attrs, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(3)(1)($elm$core$Maybe$Nothing)(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(0);
	});
var $author$project$T2$Link$actionLinkContentInverseBoldEnabledSmall = F3(
	function (attrs, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(3)(1)($elm$core$Maybe$Nothing)(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(3);
	});
var $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledSmall = F3(
	function (attrs, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(3)(1)($elm$core$Maybe$Nothing)(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(1);
	});
var $author$project$T2$Internal$Color$bcAlertHighError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bcAlertHighInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bcAlertHighSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bcAlertHighWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgAlertHighError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$bgAlertHighInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	}
};
var $author$project$T2$Internal$Color$bgAlertHighSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	}
};
var $author$project$T2$Internal$Color$bgAlertHighWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$Color$bgAlertLowError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red01;
	}
};
var $author$project$T2$Internal$Color$bgAlertLowInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$bgAlertLowSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen10;
	}
};
var $author$project$T2$Internal$Color$bgAlertLowWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow05;
	}
};
var $author$project$T2$Internal$Color$cicAlertError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$cicAlertHighInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$cicAlertHighSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$cicAlertLowInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$cicAlertLowSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$cicAlertWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgAlertHighInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgAlertHighSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgAlertLowError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgAlertLowInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgAlertLowSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgAlertLowWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$icAlertHighError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red01;
	}
};
var $author$project$T2$Internal$Color$icAlertHighInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$icAlertHighSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen10;
	}
};
var $author$project$T2$Internal$Color$icAlertHighWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow05;
	}
};
var $author$project$T2$Internal$Color$icAlertLowError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$icAlertLowInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	}
};
var $author$project$T2$Internal$Color$icAlertLowSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	}
};
var $author$project$T2$Internal$Color$icAlertLowWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$Color$icsAlertError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$icsAlertHighInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$icsAlertHighWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$icsAlertLowInfo = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$icsAlertLowWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$icsAlertSuccess = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Alert$internalRenderCloseIconView = F3(
	function (color, size, closeMsg) {
		var iconSize = function () {
			switch (size) {
				case 0:
					return 1;
				case 1:
					return 3;
				default:
					return 2;
			}
		}();
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
					$lucamug$elm_ui_with_context$Element$WithContext$pointer,
					$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(closeMsg),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class('close'))
				]),
			A4($author$project$T2$Internal$Icon$internalExit, iconSize, color, $elm$core$Maybe$Nothing, 'Cerrar alerta'));
	});
var $author$project$T2$Internal$Alert$internalRenderIconView = F6(
	function (internalIconRendered, mainColor, secondaryColor, size, altText, context) {
		var iconSize = function () {
			switch (size) {
				case 0:
					return 4;
				case 1:
					return 5;
				default:
					return 7;
			}
		}();
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
					$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
					$author$project$T2$Internal$Color$primaryB(context))
				]),
			A4(
				internalIconRendered,
				iconSize,
				mainColor,
				$elm$core$Maybe$Just(secondaryColor),
				altText));
	});
var $author$project$T2$Internal$Text$LabelLargeX = 11;
var $author$project$T2$Text$labelLargeXAttrs = F2(
	function (attrs, color) {
		return A3($author$project$T2$Internal$Text$renderAttributes, attrs, 11, color);
	});
var $author$project$T2$Link$linkBoldEnabledLarge = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(1)(1)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(0);
	});
var $author$project$T2$Link$linkBoldEnabledMedium = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(2)(1)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(0);
	});
var $author$project$T2$Link$linkBoldEnabledSmall = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(3)(1)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(0);
	});
var $author$project$T2$Link$linkContentInverseBoldEnabledLarge = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(1)(1)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(3);
	});
var $author$project$T2$Link$linkContentInverseBoldEnabledMedium = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(2)(1)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(3);
	});
var $author$project$T2$Link$linkContentInverseBoldEnabledSmall = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(3)(1)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(3);
	});
var $author$project$T2$Link$linkContentPrimaryBoldEnabledLarge = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(1)(1)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(1);
	});
var $author$project$T2$Link$linkContentPrimaryBoldEnabledMedium = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(2)(1)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(1);
	});
var $author$project$T2$Link$linkContentPrimaryBoldEnabledSmall = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(3)(1)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtCurrentPage)(1);
	});
var $author$project$T2$Link$linkSubtleEnabledLargeForNewTab = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(1)(0)($elm$core$Maybe$Nothing)(label)(url)($elm$core$Maybe$Nothing)($author$project$T2$Internal$Link$OpenAtNewTab)(0);
	});
var $author$project$T2$Internal$Alert$view = F3(
	function (attrs, toMsg, alert) {
		return (alert.K === 1) ? $lucamug$elm_ui_with_context$Element$WithContext$none : $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var icon = function () {
					var _v62 = alert.dm;
					switch (_v62) {
						case 2:
							return $author$project$T2$Internal$Icon$internalCheckFilled;
						case 1:
							return $author$project$T2$Internal$Icon$internalWarningFilled;
						case 0:
							return $author$project$T2$Internal$Icon$internalErrorFilled;
						default:
							return $author$project$T2$Internal$Icon$internalInfoFilled;
					}
				}();
				var closeIconColor = function () {
					var _v59 = alert.dm;
					switch (_v59) {
						case 2:
							var _v60 = alert.dV;
							if (!_v60) {
								return $author$project$T2$Internal$Color$cicAlertLowSuccess;
							} else {
								return $author$project$T2$Internal$Color$cicAlertHighSuccess;
							}
						case 1:
							return $author$project$T2$Internal$Color$cicAlertWarning;
						case 0:
							return $author$project$T2$Internal$Color$cicAlertError;
						default:
							var _v61 = alert.dV;
							if (!_v61) {
								return $author$project$T2$Internal$Color$cicAlertLowInfo;
							} else {
								return $author$project$T2$Internal$Color$cicAlertHighInfo;
							}
					}
				}();
				var closeIconView = alert.dT ? A3(
					$author$project$T2$Internal$Alert$internalRenderCloseIconView,
					closeIconColor(context),
					alert.jW,
					toMsg(
						$author$project$T2$Internal$Alert$Dismiss(alert.ax))) : $lucamug$elm_ui_with_context$Element$WithContext$none;
				var borderAttrs = function () {
					var _v57 = alert.dV;
					if (!_v57) {
						return _List_Nil;
					} else {
						var bcColor = function () {
							var _v58 = alert.dm;
							switch (_v58) {
								case 2:
									return $author$project$T2$Internal$Color$bcAlertHighSuccess;
								case 1:
									return $author$project$T2$Internal$Color$bcAlertHighWarning;
								case 0:
									return $author$project$T2$Internal$Color$bcAlertHighError;
								default:
									return $author$project$T2$Internal$Color$bcAlertHighInfo;
							}
						}();
						return _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Border$solid,
								$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
								$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
								bcColor(context))
							]);
					}
				}();
				var alertPaddingY = function () {
					var _v56 = alert.jW;
					switch (_v56) {
						case 0:
							return $author$project$T2$Internal$Spacing$spacing8;
						case 1:
							return $author$project$T2$Internal$Spacing$spacing12;
						default:
							return $author$project$T2$Internal$Spacing$spacing16;
					}
				}();
				var alertPaddingX = function () {
					var _v55 = alert.jW;
					switch (_v55) {
						case 0:
							return $author$project$T2$Internal$Spacing$spacing12;
						case 1:
							return $author$project$T2$Internal$Spacing$spacing16;
						default:
							return $author$project$T2$Internal$Spacing$spacing20;
					}
				}();
				var paddingAttrs = _List_fromArray(
					[
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, alertPaddingX, alertPaddingY)
					]);
				var alertAttrs = _Utils_ap(
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$T2$Border$borderRoundedDefault,
								$lucamug$elm_ui_with_context$Element$WithContext$spacing(12),
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$id(alert.ax)),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'animation', 'pulse 0.1s'))
							]),
						function () {
							var _v54 = alert.K;
							if (_v54 === 2) {
								return _List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2(
											$elm$html$Html$Events$on,
											'webkitAnimationEnd',
											$elm$json$Json$Decode$succeed(
												toMsg(
													$author$project$T2$Internal$Alert$FinishDismiss(alert.ax))))),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2(
											$elm$html$Html$Events$on,
											'animationend',
											$elm$json$Json$Decode$succeed(
												toMsg(
													$author$project$T2$Internal$Alert$FinishDismiss(alert.ax)))))
									]);
							} else {
								return _List_Nil;
							}
						}()),
					attrs);
				var _v0 = function () {
					var _v1 = alert.dm;
					switch (_v1) {
						case 2:
							var _v2 = alert.dV;
							if (!_v2) {
								return _Utils_Tuple2($author$project$T2$Internal$Color$icAlertLowSuccess, $author$project$T2$Internal$Color$icsAlertSuccess);
							} else {
								return _Utils_Tuple2($author$project$T2$Internal$Color$icAlertHighSuccess, $author$project$T2$Internal$Color$icsAlertSuccess);
							}
						case 1:
							var _v3 = alert.dV;
							if (!_v3) {
								return _Utils_Tuple2($author$project$T2$Internal$Color$icAlertLowWarning, $author$project$T2$Internal$Color$icsAlertLowWarning);
							} else {
								return _Utils_Tuple2($author$project$T2$Internal$Color$icAlertHighWarning, $author$project$T2$Internal$Color$icsAlertHighWarning);
							}
						case 0:
							var _v4 = alert.dV;
							if (!_v4) {
								return _Utils_Tuple2($author$project$T2$Internal$Color$icAlertLowError, $author$project$T2$Internal$Color$icsAlertError);
							} else {
								return _Utils_Tuple2($author$project$T2$Internal$Color$icAlertHighError, $author$project$T2$Internal$Color$icsAlertError);
							}
						default:
							var _v5 = alert.dV;
							if (!_v5) {
								return _Utils_Tuple2($author$project$T2$Internal$Color$icAlertLowInfo, $author$project$T2$Internal$Color$icsAlertLowInfo);
							} else {
								return _Utils_Tuple2($author$project$T2$Internal$Color$icAlertHighInfo, $author$project$T2$Internal$Color$icsAlertHighInfo);
							}
					}
				}();
				var iconMainColor = _v0.a;
				var iconSecondaryColor = _v0.b;
				var leftIconView = A6(
					$author$project$T2$Internal$Alert$internalRenderIconView,
					icon,
					iconMainColor(context),
					iconSecondaryColor(context),
					alert.jW,
					alert.u,
					context);
				var _v6 = function () {
					var _v7 = _Utils_Tuple2(alert.dV, alert.dm);
					if (!_v7.a) {
						switch (_v7.b) {
							case 2:
								var _v8 = _v7.a;
								var _v9 = _v7.b;
								return _Utils_Tuple2($author$project$T2$Internal$Color$fgAlertLowSuccess, $author$project$T2$Internal$Color$bgAlertLowSuccess);
							case 1:
								var _v10 = _v7.a;
								var _v11 = _v7.b;
								return _Utils_Tuple2($author$project$T2$Internal$Color$fgAlertLowWarning, $author$project$T2$Internal$Color$bgAlertLowWarning);
							case 0:
								var _v12 = _v7.a;
								var _v13 = _v7.b;
								return _Utils_Tuple2($author$project$T2$Internal$Color$fgAlertLowError, $author$project$T2$Internal$Color$bgAlertLowError);
							default:
								var _v14 = _v7.a;
								var _v15 = _v7.b;
								return _Utils_Tuple2($author$project$T2$Internal$Color$fgAlertLowInfo, $author$project$T2$Internal$Color$bgAlertLowInfo);
						}
					} else {
						switch (_v7.b) {
							case 2:
								var _v16 = _v7.a;
								var _v17 = _v7.b;
								return _Utils_Tuple2($author$project$T2$Internal$Color$fgAlertHighSuccess, $author$project$T2$Internal$Color$bgAlertHighSuccess);
							case 1:
								var _v18 = _v7.a;
								var _v19 = _v7.b;
								return _Utils_Tuple2($author$project$T2$Internal$Color$fgAlertLowWarning, $author$project$T2$Internal$Color$bgAlertHighWarning);
							case 0:
								var _v20 = _v7.a;
								var _v21 = _v7.b;
								return _Utils_Tuple2($author$project$T2$Internal$Color$fgAlertLowError, $author$project$T2$Internal$Color$bgAlertHighError);
							default:
								var _v22 = _v7.a;
								var _v23 = _v7.b;
								return _Utils_Tuple2($author$project$T2$Internal$Color$fgAlertHighInfo, $author$project$T2$Internal$Color$bgAlertHighInfo);
						}
					}
				}();
				var fgColor = _v6.a;
				var bgColor = _v6.b;
				var bgColorAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						bgColor(context))
					]);
				var labelView = function () {
					var titleView = function () {
						var _v52 = alert.b0;
						if (!_v52.$) {
							var title = _v52.a;
							var titleAttrs = function () {
								var _v53 = alert.jW;
								switch (_v53) {
									case 0:
										return $author$project$T2$Text$labelMediumAttrs;
									case 1:
										return $author$project$T2$Text$labelLargeAttrs;
									default:
										return $author$project$T2$Text$labelLargeXAttrs;
								}
							}();
							return A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								A2(
									titleAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$centerY,
											$lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft
										]),
									fgColor(context)),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text(title)
									]));
						} else {
							return $lucamug$elm_ui_with_context$Element$WithContext$none;
						}
					}();
					var textViewAttrs = function () {
						var _v51 = alert.jW;
						switch (_v51) {
							case 0:
								return $author$project$T2$Text$paragraphSmallAttrs;
							case 1:
								return $author$project$T2$Text$paragraphMediumAttrs;
							default:
								return $author$project$T2$Text$paragraphLargeAttrs;
						}
					}();
					var actionView = function () {
						var _v26 = alert.dt;
						if (!_v26.$) {
							var action = _v26.a;
							var _v27 = action.a;
							if (!_v27.$) {
								var actionMsg = _v27.a;
								var linkEl = function () {
									var _v28 = alert.dm;
									switch (_v28) {
										case 2:
											if (context.cF === 1) {
												if (!alert.dV) {
													var _v29 = alert.jW;
													switch (_v29) {
														case 0:
															return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledSmall;
														case 1:
															return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledMedium;
														default:
															return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLarge;
													}
												} else {
													var _v30 = alert.jW;
													switch (_v30) {
														case 0:
															return $author$project$T2$Link$actionLinkContentInverseBoldEnabledSmall;
														case 1:
															return $author$project$T2$Link$actionLinkContentInverseBoldEnabledMedium;
														default:
															return $author$project$T2$Link$actionLinkContentInverseBoldEnabledLarge;
													}
												}
											} else {
												var _v31 = alert.jW;
												switch (_v31) {
													case 0:
														return $author$project$T2$Link$actionLinkBoldEnabledSmall;
													case 1:
														return $author$project$T2$Link$actionLinkBoldEnabledMedium;
													default:
														return $author$project$T2$Link$actionLinkBoldEnabledLarge;
												}
											}
										case 1:
											if (context.cF === 1) {
												var _v32 = alert.jW;
												switch (_v32) {
													case 0:
														return $author$project$T2$Link$actionLinkContentInverseBoldEnabledSmall;
													case 1:
														return $author$project$T2$Link$actionLinkContentInverseBoldEnabledMedium;
													default:
														return $author$project$T2$Link$actionLinkContentInverseBoldEnabledLarge;
												}
											} else {
												var _v33 = alert.jW;
												switch (_v33) {
													case 0:
														return $author$project$T2$Link$actionLinkBoldEnabledSmall;
													case 1:
														return $author$project$T2$Link$actionLinkBoldEnabledMedium;
													default:
														return $author$project$T2$Link$actionLinkBoldEnabledLarge;
												}
											}
										case 0:
											if (context.cF === 1) {
												var _v34 = alert.jW;
												switch (_v34) {
													case 0:
														return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledSmall;
													case 1:
														return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledMedium;
													default:
														return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLarge;
												}
											} else {
												var _v35 = alert.jW;
												switch (_v35) {
													case 0:
														return $author$project$T2$Link$actionLinkBoldEnabledSmall;
													case 1:
														return $author$project$T2$Link$actionLinkBoldEnabledMedium;
													default:
														return $author$project$T2$Link$actionLinkBoldEnabledLarge;
												}
											}
										default:
											if (context.cF === 1) {
												if (!alert.dV) {
													var _v36 = alert.jW;
													switch (_v36) {
														case 0:
															return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledSmall;
														case 1:
															return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledMedium;
														default:
															return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLarge;
													}
												} else {
													var _v37 = alert.jW;
													switch (_v37) {
														case 0:
															return $author$project$T2$Link$actionLinkContentInverseBoldEnabledSmall;
														case 1:
															return $author$project$T2$Link$actionLinkContentInverseBoldEnabledMedium;
														default:
															return $author$project$T2$Link$actionLinkContentInverseBoldEnabledLarge;
													}
												}
											} else {
												var _v38 = alert.jW;
												switch (_v38) {
													case 0:
														return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledSmall;
													case 1:
														return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledMedium;
													default:
														return $author$project$T2$Link$actionLinkContentPrimaryBoldEnabledLarge;
												}
											}
									}
								}();
								return A3(
									linkEl,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8)
										]),
									action.u,
									actionMsg);
							} else {
								var _v39 = action.b;
								if (!_v39.$) {
									var actionLink = _v39.a;
									var linkEl = function () {
										var _v40 = alert.dm;
										switch (_v40) {
											case 2:
												if (context.cF === 1) {
													if (!alert.dV) {
														var _v41 = alert.jW;
														switch (_v41) {
															case 0:
																return $author$project$T2$Link$linkContentPrimaryBoldEnabledSmall;
															case 1:
																return $author$project$T2$Link$linkContentPrimaryBoldEnabledMedium;
															default:
																return $author$project$T2$Link$linkContentPrimaryBoldEnabledLarge;
														}
													} else {
														var _v42 = alert.jW;
														switch (_v42) {
															case 0:
																return $author$project$T2$Link$linkContentInverseBoldEnabledSmall;
															case 1:
																return $author$project$T2$Link$linkContentInverseBoldEnabledMedium;
															default:
																return $author$project$T2$Link$linkContentInverseBoldEnabledLarge;
														}
													}
												} else {
													var _v43 = alert.jW;
													switch (_v43) {
														case 0:
															return $author$project$T2$Link$linkBoldEnabledSmall;
														case 1:
															return $author$project$T2$Link$linkBoldEnabledMedium;
														default:
															return $author$project$T2$Link$linkBoldEnabledLarge;
													}
												}
											case 1:
												if (context.cF === 1) {
													var _v44 = alert.jW;
													switch (_v44) {
														case 0:
															return $author$project$T2$Link$linkContentInverseBoldEnabledSmall;
														case 1:
															return $author$project$T2$Link$linkContentInverseBoldEnabledMedium;
														default:
															return $author$project$T2$Link$linkContentInverseBoldEnabledLarge;
													}
												} else {
													var _v45 = alert.jW;
													switch (_v45) {
														case 0:
															return $author$project$T2$Link$linkBoldEnabledSmall;
														case 1:
															return $author$project$T2$Link$linkBoldEnabledMedium;
														default:
															return $author$project$T2$Link$linkBoldEnabledLarge;
													}
												}
											case 0:
												if (context.cF === 1) {
													var _v46 = alert.jW;
													switch (_v46) {
														case 0:
															return $author$project$T2$Link$linkContentPrimaryBoldEnabledSmall;
														case 1:
															return $author$project$T2$Link$linkContentPrimaryBoldEnabledMedium;
														default:
															return $author$project$T2$Link$linkContentPrimaryBoldEnabledLarge;
													}
												} else {
													var _v47 = alert.jW;
													switch (_v47) {
														case 0:
															return $author$project$T2$Link$linkBoldEnabledSmall;
														case 1:
															return $author$project$T2$Link$linkBoldEnabledMedium;
														default:
															return $author$project$T2$Link$linkBoldEnabledLarge;
													}
												}
											default:
												if (context.cF === 1) {
													if (!alert.dV) {
														var _v48 = alert.jW;
														switch (_v48) {
															case 0:
																return $author$project$T2$Link$linkContentPrimaryBoldEnabledSmall;
															case 1:
																return $author$project$T2$Link$linkContentPrimaryBoldEnabledMedium;
															default:
																return $author$project$T2$Link$linkContentPrimaryBoldEnabledLarge;
														}
													} else {
														var _v49 = alert.jW;
														switch (_v49) {
															case 0:
																return $author$project$T2$Link$linkContentInverseBoldEnabledSmall;
															case 1:
																return $author$project$T2$Link$linkContentInverseBoldEnabledMedium;
															default:
																return $author$project$T2$Link$linkContentInverseBoldEnabledLarge;
														}
													}
												} else {
													var _v50 = alert.jW;
													switch (_v50) {
														case 0:
															return $author$project$T2$Link$linkContentPrimaryBoldEnabledSmall;
														case 1:
															return $author$project$T2$Link$linkContentPrimaryBoldEnabledMedium;
														default:
															return $author$project$T2$Link$linkContentPrimaryBoldEnabledLarge;
													}
												}
										}
									}();
									return A2(
										linkEl,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
												$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
												$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8)
											]),
										{u: action.u, R: actionLink});
								} else {
									return $lucamug$elm_ui_with_context$Element$WithContext$none;
								}
							}
						} else {
							return $lucamug$elm_ui_with_context$Element$WithContext$none;
						}
					}();
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8),
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
								$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
							]),
						_List_fromArray(
							[
								titleView,
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								A2(
									textViewAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$centerY,
											$lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft,
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$class('message'))
										]),
									fgColor(context)),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text(alert.u),
										function () {
										var _v24 = alert.fj;
										if (!_v24.$) {
											var trailinLink = _v24.a;
											var linkEl = function () {
												var _v25 = alert.jW;
												switch (_v25) {
													case 0:
														return $author$project$T2$Link$linkSubtleEnabledSmallForNewTab;
													case 1:
														return $author$project$T2$Link$linkSubtleEnabledMediumForNewTab;
													default:
														return $author$project$T2$Link$linkSubtleEnabledLargeForNewTab;
												}
											}();
											return A2(linkEl, _List_Nil, trailinLink);
										} else {
											return $lucamug$elm_ui_with_context$Element$WithContext$none;
										}
									}()
									])),
								actionView
							]));
				}();
				var alertView = A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_Utils_ap(
						alertAttrs,
						_Utils_ap(
							borderAttrs,
							_Utils_ap(paddingAttrs, bgColorAttrs))),
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$html(
							A3(
								$elm$html$Html$node,
								'style',
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' @keyframes pulse { 0%   {background-color: transparent;} 100% {background-color: transparent;} } ')
									]))),
							leftIconView,
							labelView,
							closeIconView
						]));
				return alertView;
			});
	});
var $author$project$T2$Alert$view = $author$project$T2$Internal$Alert$view;
var $author$project$Page$Home$viewSnackBarMessage = F2(
	function (message, messageType) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
					$lucamug$elm_ui_with_context$Element$WithContext$centerX,
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 20, 0),
					$lucamug$elm_ui_with_context$Element$WithContext$moveUp(76),
					$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$shrink)
				]),
			A3(
				$author$project$T2$Alert$view,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$class('alert-message'))
					]),
				function (_v0) {
					return $author$project$Page$Home$PassThrough;
				},
				A2(
					function () {
						if (!messageType) {
							return $author$project$T2$Alert$initAlertLowErrorSmall;
						} else {
							return $author$project$T2$Alert$initAlertLowSuccessSmall;
						}
					}(),
					'snackbar-message',
					message)));
	});
var $author$project$Page$Home$viewSnackBarError = function (maybeErrorMessage) {
	if (!maybeErrorMessage.$) {
		var errorMessage = maybeErrorMessage.a;
		return A2($author$project$Page$Home$viewSnackBarMessage, errorMessage, 0);
	} else {
		return $lucamug$elm_ui_with_context$Element$WithContext$none;
	}
};
var $author$project$T2$Internal$Image$Fixed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$T2$Layout$maxWidth = function (max) {
	return $lucamug$elm_ui_with_context$Element$WithContext$width(
		A2($lucamug$elm_ui_with_context$Element$WithContext$maximum, max, $lucamug$elm_ui_with_context$Element$WithContext$fill));
};
var $author$project$T2$Internal$Image$renderImage = F5(
	function (assetFolder, baseFileName, layout, attrs, description) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var fileName = function () {
					var _v1 = context.cF;
					if (!_v1) {
						return baseFileName + '-light';
					} else {
						return baseFileName + '-dark';
					}
				}();
				var baseDimentionsAttrs = function () {
					if (!layout.$) {
						var width = layout.a;
						var height = layout.b;
						return _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width(
								$lucamug$elm_ui_with_context$Element$WithContext$px(width)),
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								$lucamug$elm_ui_with_context$Element$WithContext$px(height))
							]);
					} else {
						var maxWidth = layout.a;
						return _List_fromArray(
							[
								$author$project$T2$Layout$maxWidth(maxWidth)
							]);
					}
				}();
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$image,
					_Utils_ap(baseDimentionsAttrs, attrs),
					{g$: description, j2: context.b5 + ('images-new-branding/' + (assetFolder + ('/' + (fileName + '.webp'))))});
			});
	});
var $author$project$T2$Image$homeTalentinoFixedLayout = F4(
	function (attrs, width, height, description) {
		return A5(
			$author$project$T2$Internal$Image$renderImage,
			'talentino',
			'talentino-home',
			A2($author$project$T2$Internal$Image$Fixed, width, height),
			attrs,
			description);
	});
var $author$project$Page$Home$viewTalentinoIllustration = function (height) {
	var _v0 = _Utils_Tuple2(
		$elm$core$Basics$round(height / 1.4),
		$elm$core$Basics$round(height));
	var newBrandingWidth = _v0.a;
	var newBrandingHeight = _v0.b;
	var talentinoEl = A4($author$project$T2$Image$homeTalentinoFixedLayout, _List_Nil, newBrandingWidth, newBrandingHeight, 'Talenteca Recluta Mejor');
	return A2($lucamug$elm_ui_with_context$Element$WithContext$el, _List_Nil, talentinoEl);
};
var $author$project$Page$Home$viewChatContainer = F5(
	function (model, showTalentecaLogoWaterMark, chatMessagesEl, bottomEl, maybeErrorMessage) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var talentecaLogoWaterMark = showTalentecaLogoWaterMark ? _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
						A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$centerX,
									$lucamug$elm_ui_with_context$Element$WithContext$centerY,
									$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.2)
								]),
							$author$project$T2$Logo$talentecaLogoHorizontalInverse(_List_Nil)))
					]) : _List_Nil;
				var chatContainerHeight = (!model.G) ? (model.S.bn - model.ec) : $elm$core$Basics$round(model.S.bn * 0.9);
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_Utils_ap(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width(
								$lucamug$elm_ui_with_context$Element$WithContext$px(
									$author$project$Page$Home$getMainContainerSize(model).dp)),
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								$lucamug$elm_ui_with_context$Element$WithContext$px(
									(chatContainerHeight - ((!model.G) ? (model.a6 ? model.bq : model.bC) : 0)) - model.bc)),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'min-height',
									$elm$core$String$fromInt(
										(chatContainerHeight - ((!model.G) ? (model.a6 ? model.bq : model.bC) : 0)) - model.bc) + 'px')),
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								$author$project$T2$Internal$Color$bgSecondary(context)),
								(!model.G) ? $author$project$T2$Border$borderSharp : $author$project$T2$Border$borderRoundedBottom,
								$lucamug$elm_ui_with_context$Element$WithContext$inFront(
								$author$project$Page$Home$viewSnackBarError(maybeErrorMessage)),
								$lucamug$elm_ui_with_context$Element$WithContext$inFront(
								model.c.bV ? A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.5),
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
											$author$project$T2$Internal$Color$bcApplyContainer(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClosedCandidateInfoLoadedMessage)
										]),
									$lucamug$elm_ui_with_context$Element$WithContext$none) : $lucamug$elm_ui_with_context$Element$WithContext$none),
								$lucamug$elm_ui_with_context$Element$WithContext$inFront(
								model.c.bV ? A2(
									$lucamug$elm_ui_with_context$Element$WithContext$row,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
											$lucamug$elm_ui_with_context$Element$WithContext$moveUp(5),
											$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClosedCandidateInfoLoadedMessage)
										]),
									_List_fromArray(
										[
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$moveLeft(20)
												]),
											$author$project$Page$Home$viewTalentinoIllustration(150)),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$padding(12),
													$author$project$T2$Elevation$elevation2,
													$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
													$author$project$T2$Internal$Color$bgApplyWelcomeQuestionChatBubble(context)),
													$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
													$author$project$T2$Internal$Color$contentPrimary(context)),
													$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
													$lucamug$elm_ui_with_context$Element$WithContext$moveLeft(20),
													$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
													{aR: 0, aS: 8, bd: 8, be: 8}),
													$lucamug$elm_ui_with_context$Element$WithContext$inFront(
													A2(
														$lucamug$elm_ui_with_context$Element$WithContext$el,
														_List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
																$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
																$lucamug$elm_ui_with_context$Element$WithContext$moveUp(7),
																$lucamug$elm_ui_with_context$Element$WithContext$moveRight(7),
																$lucamug$elm_ui_with_context$Element$WithContext$pointer,
																$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClosedCandidateInfoLoadedMessage),
																$author$project$T2$Elevation$elevation2,
																$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
																$author$project$T2$Internal$Color$bgApplyWelcomeQuestionChatBubble(context)),
																$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(25),
																$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																$elm$html$Html$Attributes$class('close-talentino-help'))
															]),
														A4(
															$author$project$T2$Internal$Icon$internalExit,
															3,
															$author$project$T2$Internal$Color$contentPrimary(context),
															$elm$core$Maybe$Nothing,
															'cerrar')))
												]),
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$text('Hola ' + (model.c.l.c1.cr + ', hemos cargado los datos de tu perfil de candidato. Puedes editarlos antes de enviar.'))
												]))
										])) : $lucamug$elm_ui_with_context$Element$WithContext$none)
							]),
						talentecaLogoWaterMark),
					_List_fromArray(
						[
							chatMessagesEl,
							bottomEl,
							$author$project$Page$Home$viewCandidateNotLoggedInTalentecaDialog(model)
						]));
			});
	});
var $author$project$T2$Internal$Dropdown$Below = 1;
var $author$project$T2$Internal$Dropdown$Default = 0;
var $author$project$T2$Internal$Dropdown$Medium = 1;
var $author$project$T2$Internal$Dropdown$Outlined = 1;
var $author$project$T2$Internal$Dropdown$Disabled = 4;
var $author$project$T2$Internal$Dropdown$Error = 2;
var $author$project$T2$Internal$Dropdown$Success = 3;
var $author$project$T2$Internal$Dropdown$Warning = 1;
var $mdgriffith$elm_ui$Internal$Model$Above = 0;
var $mdgriffith$elm_ui$Element$above = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 0, element);
};
var $lucamug$elm_ui_with_context$Element$WithContext$above = $lucamug$elm_ui_with_context$Element$WithContext$createNearby($mdgriffith$elm_ui$Element$above);
var $author$project$T2$Internal$ListItem$Large = 2;
var $author$project$T2$Internal$ListItem$OnClick = function (a) {
	return {$: 1, a: a};
};
var $author$project$T2$ListItem$actionListItemOneLineEnabledLarge = F3(
	function (attrs, msg, label) {
		return A9(
			$author$project$T2$Internal$ListItem$renderListItem,
			attrs,
			0,
			0,
			2,
			$author$project$T2$Internal$ListItem$OnClick(msg),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			$elm$core$Maybe$Nothing);
	});
var $author$project$T2$Internal$ListItem$Medium = 1;
var $author$project$T2$ListItem$actionListItemOneLineEnabledMedium = F3(
	function (attrs, msg, label) {
		return A9(
			$author$project$T2$Internal$ListItem$renderListItem,
			attrs,
			0,
			0,
			1,
			$author$project$T2$Internal$ListItem$OnClick(msg),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			$elm$core$Maybe$Nothing);
	});
var $author$project$T2$ListItem$actionListItemOneLineEnabledSmall = F3(
	function (attrs, msg, label) {
		return A9(
			$author$project$T2$Internal$ListItem$renderListItem,
			attrs,
			0,
			0,
			0,
			$author$project$T2$Internal$ListItem$OnClick(msg),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			$elm$core$Maybe$Nothing);
	});
var $author$project$T2$ListItem$actionListItemOneLineSelectedLarge = F3(
	function (attrs, msg, label) {
		return A9(
			$author$project$T2$Internal$ListItem$renderListItem,
			attrs,
			0,
			2,
			2,
			$author$project$T2$Internal$ListItem$OnClick(msg),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			$elm$core$Maybe$Nothing);
	});
var $author$project$T2$ListItem$actionListItemOneLineSelectedMedium = F3(
	function (attrs, msg, label) {
		return A9(
			$author$project$T2$Internal$ListItem$renderListItem,
			attrs,
			0,
			2,
			1,
			$author$project$T2$Internal$ListItem$OnClick(msg),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			$elm$core$Maybe$Nothing);
	});
var $author$project$T2$ListItem$actionListItemOneLineSelectedSmall = F3(
	function (attrs, msg, label) {
		return A9(
			$author$project$T2$Internal$ListItem$renderListItem,
			attrs,
			0,
			2,
			0,
			$author$project$T2$Internal$ListItem$OnClick(msg),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			$elm$core$Maybe$Nothing);
	});
var $author$project$T2$Internal$ListItem$Ignore = {$: 0};
var $author$project$T2$ListItem$listItemOneLineDisabledLarge = F2(
	function (attrs, label) {
		return A9($author$project$T2$Internal$ListItem$renderListItem, attrs, 0, 1, 2, $author$project$T2$Internal$ListItem$Ignore, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, label, $elm$core$Maybe$Nothing);
	});
var $author$project$T2$ListItem$listItemOneLineDisabledMedium = F2(
	function (attrs, label) {
		return A9($author$project$T2$Internal$ListItem$renderListItem, attrs, 0, 1, 1, $author$project$T2$Internal$ListItem$Ignore, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, label, $elm$core$Maybe$Nothing);
	});
var $author$project$T2$ListItem$listItemOneLineDisabledSmall = F2(
	function (attrs, label) {
		return A9($author$project$T2$Internal$ListItem$renderListItem, attrs, 0, 1, 0, $author$project$T2$Internal$ListItem$Ignore, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, label, $elm$core$Maybe$Nothing);
	});
var $author$project$T2$Internal$Dropdown$renderMenuItem = F5(
	function (config, model, onSelect, index, item) {
		var isSelected = _Utils_eq(
			model.a7,
			$elm$core$Maybe$Just(index));
		var baseItemAttrs = _List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$attribute, 'role', 'option')),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				$elm$html$Html$Attributes$disabled(item.t))
			]);
		return item.t ? A2(
			function () {
				var _v0 = config.jW;
				switch (_v0) {
					case 0:
						return $author$project$T2$ListItem$listItemOneLineDisabledSmall;
					case 1:
						return $author$project$T2$ListItem$listItemOneLineDisabledMedium;
					default:
						return $author$project$T2$ListItem$listItemOneLineDisabledLarge;
				}
			}(),
			baseItemAttrs,
			item.u) : (isSelected ? A3(
			function () {
				var _v1 = config.jW;
				switch (_v1) {
					case 0:
						return $author$project$T2$ListItem$actionListItemOneLineSelectedSmall;
					case 1:
						return $author$project$T2$ListItem$actionListItemOneLineSelectedMedium;
					default:
						return $author$project$T2$ListItem$actionListItemOneLineSelectedLarge;
				}
			}(),
			baseItemAttrs,
			onSelect(index),
			item.u) : A3(
			function () {
				var _v2 = config.jW;
				switch (_v2) {
					case 0:
						return $author$project$T2$ListItem$actionListItemOneLineEnabledSmall;
					case 1:
						return $author$project$T2$ListItem$actionListItemOneLineEnabledMedium;
					default:
						return $author$project$T2$ListItem$actionListItemOneLineEnabledLarge;
				}
			}(),
			baseItemAttrs,
			onSelect(index),
			item.u));
	});
var $author$project$T2$Internal$Dropdown$renderMenu = F4(
	function (config, model, onClose, onSelect) {
		if (model.K === 1) {
			var placementStyle = function () {
				var _v1 = config.j;
				if (_v1 === 1) {
					return 'top';
				} else {
					return 'bottom';
				}
			}();
			var placementEl = function () {
				var _v0 = config.j;
				if (_v0 === 1) {
					return $lucamug$elm_ui_with_context$Element$WithContext$below;
				} else {
					return $lucamug$elm_ui_with_context$Element$WithContext$above;
				}
			}();
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						placementEl(
						A2(
							$author$project$T2$Internal$Menu$renderMenu,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$id(model.ax + '-menu')),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$style, 'z-index', '1000')),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$style, 'position', 'absolute')),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$style, placementStyle, '100%')),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$style, 'left', '0')),
									$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(onClose),
									$lucamug$elm_ui_with_context$Element$WithContext$height(
									A2($lucamug$elm_ui_with_context$Element$WithContext$maximum, 300, $lucamug$elm_ui_with_context$Element$WithContext$shrink)),
									$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY
								]),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									A3($author$project$T2$Internal$Dropdown$renderMenuItem, config, model, onSelect),
									model.bp)
								])))
					]),
				$lucamug$elm_ui_with_context$Element$WithContext$none);
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$none;
		}
	});
var $author$project$T2$Internal$Color$bcDropdownFilledDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bcDropdownFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bcDropdownFilledFocus = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$bcDropdownOutlinedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bcDropdownOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$bgDropdownFilledDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgDropdownFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	}
};
var $author$project$T2$Internal$Color$bgDropdownFilledHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$bgDropdownOutlinedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgDropdownOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgDropdownFilledDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgDropdownFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgDropdownOutlinedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$fgDropdownOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Dropdown$internalRenderIconView = F5(
	function (iconAttrs, iconOption, color, size, altText) {
		if (!iconOption.$) {
			var icon = iconOption.a;
			var iconSize = function () {
				switch (size) {
					case 0:
						return 1;
					case 1:
						return 2;
					default:
						return 4;
				}
			}();
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				iconAttrs,
				A4(icon, iconSize, color, $elm$core$Maybe$Nothing, altText));
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$none;
		}
	});
var $author$project$T2$Internal$Dropdown$renderButton = F6(
	function (attrs, config, behaviour, leftIconMaybe, label, altText) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var paddingAttrs = function () {
					var dropdownPaddingRight = function () {
						var _v15 = config.jW;
						switch (_v15) {
							case 0:
								return $author$project$T2$Internal$Spacing$spacing12;
							case 1:
								return $author$project$T2$Internal$Spacing$spacing16;
							default:
								return $author$project$T2$Internal$Spacing$spacing20;
						}
					}();
					var dropdownPaddingLeft = function () {
						if (!leftIconMaybe.$) {
							var _v13 = config.jW;
							switch (_v13) {
								case 0:
									return $author$project$T2$Internal$Spacing$spacing12;
								case 1:
									return $author$project$T2$Internal$Spacing$spacing16;
								default:
									return $author$project$T2$Internal$Spacing$spacing20;
							}
						} else {
							var _v14 = config.jW;
							switch (_v14) {
								case 0:
									return $author$project$T2$Internal$Spacing$spacing8;
								case 1:
									return $author$project$T2$Internal$Spacing$spacing12;
								default:
									return $author$project$T2$Internal$Spacing$spacing16;
							}
						}
					}();
					var dropdownFieldYPadding = function () {
						var _v11 = config.jW;
						switch (_v11) {
							case 0:
								return $author$project$T2$Internal$Spacing$spacing4 - 1;
							case 1:
								return $author$project$T2$Internal$Spacing$spacing12 - 2;
							default:
								return $author$project$T2$Internal$Spacing$spacing12 + 1;
						}
					}();
					if (leftIconMaybe.$ === 1) {
						return _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
								{bi: dropdownFieldYPadding, br: dropdownPaddingLeft, bt: dropdownPaddingRight, by: dropdownFieldYPadding})
							]);
					} else {
						return _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
								{bi: dropdownFieldYPadding, br: dropdownPaddingLeft, bt: dropdownPaddingRight, by: dropdownFieldYPadding})
							]);
					}
				}();
				var mouseDownBc = function () {
					if (config.dm !== 4) {
						var _v8 = config.z;
						if (!_v8) {
							return $author$project$T2$Internal$Color$bgDropdownFilledEnabled;
						} else {
							return $author$project$T2$Internal$Color$bgDropdownOutlinedEnabled;
						}
					} else {
						var _v9 = config.z;
						if (!_v9) {
							return $author$project$T2$Internal$Color$bgDropdownFilledDisabled;
						} else {
							return $author$project$T2$Internal$Color$bgDropdownOutlinedDisabled;
						}
					}
				}();
				var hoverAttrs = function () {
					if (config.dm === 4) {
						return _List_Nil;
					} else {
						var _v7 = config.z;
						if (!_v7) {
							return _List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
											$author$project$T2$Internal$Color$bgDropdownFilledHovered(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
											$author$project$T2$Internal$Color$fgDropdownFilledEnabled(context))
										]))
								]);
						} else {
							return _List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
											$author$project$T2$Internal$Color$bgDropdownOutlinedEnabled(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
											$author$project$T2$Internal$Color$fgDropdownOutlinedEnabled(context))
										]))
								]);
						}
					}
				}();
				var focusFg = function () {
					if (config.dm !== 4) {
						var _v5 = config.z;
						if (!_v5) {
							return $author$project$T2$Internal$Color$fgDropdownFilledEnabled;
						} else {
							return $author$project$T2$Internal$Color$fgDropdownOutlinedEnabled;
						}
					} else {
						var _v6 = config.z;
						if (!_v6) {
							return $author$project$T2$Internal$Color$fgDropdownFilledDisabled;
						} else {
							return $author$project$T2$Internal$Color$fgDropdownOutlinedDisabled;
						}
					}
				}();
				var cursorAttrs = (config.dm === 4) ? _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$class('tt-cursor-not-allowed'))
					]) : _List_fromArray(
					[$lucamug$elm_ui_with_context$Element$WithContext$pointer]);
				var borderRadiusAttr = $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(10);
				var borderAttrs = function () {
					var bc = function () {
						var _v4 = config.z;
						if (!_v4) {
							return (config.dm === 4) ? $author$project$T2$Internal$Color$bcDropdownFilledDisabled : $author$project$T2$Internal$Color$bcDropdownFilledEnabled;
						} else {
							return (config.dm === 4) ? $author$project$T2$Internal$Color$bcDropdownOutlinedDisabled : $author$project$T2$Internal$Color$bcDropdownOutlinedEnabled;
						}
					}();
					return _List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
							bc(context)),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1)
						]);
				}();
				var bcFocused = (config.dm === 4) ? $author$project$T2$Internal$Color$bcDropdownFilledDisabled : $author$project$T2$Internal$Color$bcDropdownFilledFocus;
				var buttonFocusedAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$focused(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								mouseDownBc(context)),
								$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
								focusFg(context)),
								$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
								bcFocused(context))
							]))
					]);
				var ariaAttrs = (config.dm === 4) ? _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true'))
					]) : _List_fromArray(
					[$lucamug$elm_ui_with_context$Element$WithContext$pointer]);
				var buttonAttrs = function () {
					var buttonHeight = function () {
						var _v3 = config.jW;
						switch (_v3) {
							case 0:
								return $lucamug$elm_ui_with_context$Element$WithContext$px(36);
							case 1:
								return $lucamug$elm_ui_with_context$Element$WithContext$px(40);
							default:
								return $lucamug$elm_ui_with_context$Element$WithContext$px(48);
						}
					}();
					return A2(
						$elm$core$List$cons,
						borderRadiusAttr,
						_Utils_ap(
							cursorAttrs,
							_Utils_ap(
								ariaAttrs,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$height(buttonHeight),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('tt-element-hover-transition', true),
													_Utils_Tuple2('tt-button', true)
												])))
									]))));
				}();
				var _v0 = function () {
					var _v1 = config.z;
					if (!_v1) {
						return (config.dm === 4) ? _Utils_Tuple2($author$project$T2$Internal$Color$fgDropdownFilledDisabled, $author$project$T2$Internal$Color$bgDropdownFilledDisabled) : _Utils_Tuple2($author$project$T2$Internal$Color$fgDropdownFilledEnabled, $author$project$T2$Internal$Color$bgDropdownFilledEnabled);
					} else {
						return (config.dm === 4) ? _Utils_Tuple2($author$project$T2$Internal$Color$fgDropdownOutlinedDisabled, $author$project$T2$Internal$Color$bgDropdownOutlinedDisabled) : _Utils_Tuple2($author$project$T2$Internal$Color$fgDropdownOutlinedEnabled, $author$project$T2$Internal$Color$bgDropdownOutlinedEnabled);
					}
				}();
				var fgColor = _v0.a;
				var bgColor = _v0.b;
				var bgColorAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						bgColor(context))
					]);
				var labelView = function () {
					var labelPaddingX = $author$project$T2$Internal$Spacing$spacing8;
					var fontAttrs = function () {
						var _v2 = config.jW;
						switch (_v2) {
							case 0:
								return A2(
									$author$project$T2$Text$labelSmallAttrs,
									_List_Nil,
									fgColor(context));
							case 1:
								return A2(
									$author$project$T2$Text$labelMediumAttrs,
									_List_Nil,
									fgColor(context));
							default:
								return A2(
									$author$project$T2$Text$labelLargeAttrs,
									_List_Nil,
									fgColor(context));
						}
					}();
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_Utils_ap(
							_List_fromArray(
								[
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, labelPaddingX, 0),
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$alignLeft
								]),
							fontAttrs),
						$lucamug$elm_ui_with_context$Element$WithContext$text(label));
				}();
				var leftIconView = A5(
					$author$project$T2$Internal$Dropdown$internalRenderIconView,
					_List_fromArray(
						[$lucamug$elm_ui_with_context$Element$WithContext$alignLeft]),
					leftIconMaybe,
					fgColor(context),
					config.jW,
					altText);
				var rightIconView = A5(
					$author$project$T2$Internal$Dropdown$internalRenderIconView,
					_List_fromArray(
						[$lucamug$elm_ui_with_context$Element$WithContext$alignRight]),
					$elm$core$Maybe$Just($author$project$T2$Internal$Icon$internalChevronDown),
					fgColor(context),
					config.jW,
					altText);
				var buttonLabelView = A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_Utils_ap(
						cursorAttrs,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$centerX
							])),
					_List_fromArray(
						[leftIconView, labelView, rightIconView]));
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$Input$button,
					_Utils_ap(
						buttonAttrs,
						_Utils_ap(
							paddingAttrs,
							_Utils_ap(
								borderAttrs,
								_Utils_ap(
									bgColorAttrs,
									_Utils_ap(
										buttonFocusedAttrs,
										_Utils_ap(hoverAttrs, attrs)))))),
					{
						u: buttonLabelView,
						ew: (config.dm === 4) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(behaviour)
					});
			});
	});
var $author$project$T2$Internal$Dropdown$renderTriggerButton = F3(
	function (onToggleMsg, model, config) {
		var buttonLabel = function () {
			var _v0 = model.a7;
			if (!_v0.$) {
				var index = _v0.a;
				var _v1 = A2(
					$elm$core$Array$get,
					index,
					$elm$core$Array$fromList(model.bp));
				if (!_v1.$) {
					var item = _v1.a;
					return item.u;
				} else {
					return config.u;
				}
			} else {
				return config.u;
			}
		}();
		return A6(
			$author$project$T2$Internal$Dropdown$renderButton,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'listbox')),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					A2($elm$html$Html$Attributes$attribute, 'aria-controls', model.ax + '-menu')),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class('tt-dropdown'))
				]),
			config,
			onToggleMsg,
			config.h,
			buttonLabel,
			buttonLabel);
	});
var $author$project$T2$Internal$Dropdown$view = F7(
	function (attrs, config, model, onToggle, onClose, onSelect, labelMaybe) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var labelEl = function () {
					if (!labelMaybe.$) {
						var labelText = labelMaybe.a;
						var labelFontColor = (config.dm === 4) ? $author$project$T2$Internal$Color$fgTextInputLabelDisabled : $author$project$T2$Internal$Color$fgTextInputLabel;
						var labelFontAttrs = function () {
							var _v5 = config.jW;
							switch (_v5) {
								case 0:
									return $author$project$T2$Text$labelSmallAttrs;
								case 1:
									return $author$project$T2$Text$labelMediumAttrs;
								default:
									return $author$project$T2$Text$labelLargeAttrs;
							}
						}();
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							A2(
								labelFontAttrs,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft
									]),
								labelFontColor(context)),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text(labelText)
								]));
					} else {
						return $lucamug$elm_ui_with_context$Element$WithContext$none;
					}
				}();
				var hintView = function () {
					var _v1 = config.d;
					if (!_v1.$) {
						var hint = _v1.a;
						var iconEl = function () {
							var _v3 = config.dm;
							switch (_v3) {
								case 3:
									return A4(
										$author$project$T2$Internal$Icon$internalCheckFilled,
										1,
										$author$project$T2$Internal$Color$bcTextInputFilledSuccess(context),
										$elm$core$Maybe$Nothing,
										'success');
								case 2:
									return A4(
										$author$project$T2$Internal$Icon$internalErrorFilled,
										1,
										$author$project$T2$Internal$Color$bcTextInputFilledError(context),
										$elm$core$Maybe$Nothing,
										'error');
								case 1:
									return A4(
										$author$project$T2$Internal$Icon$internalWarningFilled,
										1,
										$author$project$T2$Internal$Color$bcTextInputFilledWarning(context),
										$elm$core$Maybe$Nothing,
										'warning');
								case 0:
									return $lucamug$elm_ui_with_context$Element$WithContext$none;
								default:
									return $lucamug$elm_ui_with_context$Element$WithContext$none;
							}
						}();
						var hintFontColor = (config.dm === 4) ? $author$project$T2$Internal$Color$fgTextInputLabelDisabled : ((config.dm === 2) ? $author$project$T2$Internal$Color$fgTextInputErrorHint : (((config.dm === 3) || (config.dm === 1)) ? $author$project$T2$Internal$Color$fgTextInputLabel : $author$project$T2$Internal$Color$fgTextInputHint));
						var hintFontAttrs = function () {
							var _v2 = config.jW;
							switch (_v2) {
								case 0:
									return $author$project$T2$Text$paragraphSmallAttrs;
								case 1:
									return $author$project$T2$Text$paragraphMediumAttrs;
								default:
									return $author$project$T2$Text$paragraphLargeAttrs;
							}
						}();
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8)
								]),
							_List_fromArray(
								[
									iconEl,
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
									A2(
										hintFontAttrs,
										_List_Nil,
										hintFontColor(context)),
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$text(hint)
										]))
								]));
					} else {
						return $lucamug$elm_ui_with_context$Element$WithContext$none;
					}
				}();
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
						]),
					_List_fromArray(
						[
							labelEl,
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_Utils_ap(
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$id(model.ax)),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$attribute, 'role', 'combobox')),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2(
											$elm$html$Html$Attributes$attribute,
											'aria-expanded',
											(model.K === 1) ? 'true' : 'false')),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$style, 'position', 'relative'))
									]),
								attrs),
							function () {
								var _v0 = config.j;
								if (_v0 === 1) {
									return _List_fromArray(
										[
											A3($author$project$T2$Internal$Dropdown$renderTriggerButton, onToggle, model, config),
											A4($author$project$T2$Internal$Dropdown$renderMenu, config, model, onClose, onSelect)
										]);
								} else {
									return _List_fromArray(
										[
											A4($author$project$T2$Internal$Dropdown$renderMenu, config, model, onClose, onSelect),
											A3($author$project$T2$Internal$Dropdown$renderTriggerButton, onToggle, model, config)
										]);
								}
							}()),
							hintView
						]));
			});
	});
var $author$project$T2$Dropdown$dropdownBelowOutlinedDefaultMedium = F8(
	function (attrs, label, hint, dropdownModel, onToggleMsg, onCloseMsg, onSelectMsg, labelMaybe) {
		return A7(
			$author$project$T2$Internal$Dropdown$view,
			attrs,
			{d: hint, u: label, h: $elm$core$Maybe$Nothing, j: 1, jW: 1, dm: 0, z: 1},
			dropdownModel,
			onToggleMsg,
			onCloseMsg,
			onSelectMsg,
			labelMaybe);
	});
var $author$project$T2$Dropdown$dropdownBelowOutlinedErrorMedium = F8(
	function (attrs, label, hint, dropdownModel, onToggleMsg, onCloseMsg, onSelectMsg, labelMaybe) {
		return A7(
			$author$project$T2$Internal$Dropdown$view,
			attrs,
			{d: hint, u: label, h: $elm$core$Maybe$Nothing, j: 1, jW: 1, dm: 2, z: 1},
			dropdownModel,
			onToggleMsg,
			onCloseMsg,
			onSelectMsg,
			labelMaybe);
	});
var $author$project$Page$Home$viewDropdownQuestion = F7(
	function (questionTitle, question, dropDownModel, onToggle, onClose, onSelect, dropdownContainerClass) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
				]),
			_List_fromArray(
				[
					A8(
					_Utils_eq(question.bI, $elm$core$Maybe$Nothing) ? $author$project$T2$Dropdown$dropdownBelowOutlinedDefaultMedium : $author$project$T2$Dropdown$dropdownBelowOutlinedErrorMedium,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$id(dropDownModel.ax)),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class(dropdownContainerClass)),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('sentry-mask'))
						]),
					'Selecciona una opción',
					question.bI,
					dropDownModel,
					onToggle,
					onClose,
					onSelect,
					$elm$core$Maybe$Just(questionTitle))
				]));
	});
var $author$project$Page$Home$MsgUserChangedSkill = F2(
	function (a, b) {
		return {$: 39, a: a, b: b};
	});
var $author$project$Page$Home$MsgUserDeletedSkill = function (a) {
	return {$: 41, a: a};
};
var $author$project$T2$TextInput$textInputOutlinedEnabledMediumWithRightIcon = F8(
	function (attrs, icon, msg, label, placeholder, value, hint, inputType) {
		return $author$project$T2$Internal$TextInput$renderTextInput(attrs)(1)(0)(1)(inputType)(msg)(value)($elm$core$Maybe$Nothing)(
			$elm$core$Maybe$Just(icon))(label)(placeholder)(hint);
	});
var $author$project$T2$TextInput$textInputOutlinedErrorMediumWithRightIcon = F8(
	function (attrs, icon, msg, label, placeholder, value, hint, inputType) {
		return $author$project$T2$Internal$TextInput$renderTextInput(attrs)(1)(3)(1)(inputType)(msg)(value)($elm$core$Maybe$Nothing)(
			$elm$core$Maybe$Just(icon))(label)(placeholder)(hint);
	});
var $author$project$Page$Home$viewSkillTextField = F2(
	function (index, skill) {
		var rightIcon = (index > 1) ? $elm$core$Maybe$Just(
			{
				hI: $author$project$T2$Icon$exit,
				iX: $elm$core$Maybe$Just(
					$author$project$Page$Home$MsgUserDeletedSkill(index))
			}) : $elm$core$Maybe$Nothing;
		var placeholder = (!index) ? 'Ej. Ventas' : ((index === 1) ? 'Ej. Atención telefónica' : '');
		var commonInputAttrs = _List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				$elm$html$Html$Attributes$id(
					'skill-' + $elm$core$String$fromInt(index))),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				$elm$html$Html$Events$onFocus($author$project$Page$Home$MsgUserFocusedInput)),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				$elm$html$Html$Events$onBlur($author$project$Page$Home$MsgUserLeftInput)),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				$elm$html$Html$Attributes$tabindex(5 + index))
			]);
		var commonContainerAttrs = _List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
			]);
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(8)
				]),
			_List_fromArray(
				[
					function () {
					if (!_Utils_eq(skill.bI, $elm$core$Maybe$Nothing)) {
						if (!rightIcon.$) {
							var ri = rightIcon.a;
							return A8(
								$author$project$T2$TextInput$textInputOutlinedErrorMediumWithRightIcon,
								commonContainerAttrs,
								ri,
								$author$project$Page$Home$MsgUserChangedSkill(index),
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Just(placeholder),
								skill.m,
								skill.bI,
								$author$project$T2$Internal$TextInput$InputText(commonInputAttrs));
						} else {
							return A7(
								$author$project$T2$TextInput$textInputOutlinedErrorMedium,
								commonContainerAttrs,
								$author$project$Page$Home$MsgUserChangedSkill(index),
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Just(placeholder),
								skill.m,
								skill.bI,
								$author$project$T2$Internal$TextInput$InputText(commonInputAttrs));
						}
					} else {
						if (!rightIcon.$) {
							var ri = rightIcon.a;
							return A8(
								$author$project$T2$TextInput$textInputOutlinedEnabledMediumWithRightIcon,
								commonContainerAttrs,
								ri,
								$author$project$Page$Home$MsgUserChangedSkill(index),
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Just(placeholder),
								skill.m,
								$elm$core$Maybe$Nothing,
								$author$project$T2$Internal$TextInput$InputText(commonInputAttrs));
						} else {
							return A7(
								$author$project$T2$TextInput$textInputOutlinedEnabledMedium,
								commonContainerAttrs,
								$author$project$Page$Home$MsgUserChangedSkill(index),
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Just(placeholder),
								skill.m,
								$elm$core$Maybe$Nothing,
								$author$project$T2$Internal$TextInput$InputText(commonInputAttrs));
						}
					}
				}()
				]));
	});
var $author$project$T2$Internal$Color$bgApplyActiveQuestionChatBubble = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green50;
	}
};
var $author$project$T2$Internal$Color$bgApplyInactiveQuestionChatBubble = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$Page$Home$viewTalentinoActiveQuestionBubble = F3(
	function (model, extraAttrs, contentEl) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var bubbleBaseWidth = $author$project$Page$Home$getMainContainerWidth(model);
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					A2(
						$elm$core$List$cons,
						$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
						extraAttrs),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(50),
									$author$project$T2$Elevation$elevation2,
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
									$author$project$T2$Internal$Color$bgApplyInactiveQuestionChatBubble(context)),
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 8)
								]),
							$author$project$Page$Home$viewTalentinoIllustration(36)),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 12),
									$author$project$T2$Elevation$elevation2,
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class(
										'bubble ' + function () {
											var _v0 = context.cF;
											if (!_v0) {
												return 'tt-light';
											} else {
												return 'tt-dark';
											}
										}())),
									$author$project$T2$Border$borderRoundedDefault,
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
									$author$project$T2$Internal$Color$bgApplyActiveQuestionChatBubble(context)),
									$lucamug$elm_ui_with_context$Element$WithContext$width(
									A3(
										$elm$core$Basics$apL,
										$lucamug$elm_ui_with_context$Element$WithContext$maximum,
										$elm$core$Basics$ceiling(((bubbleBaseWidth - 32) * 80) / 100),
										$lucamug$elm_ui_with_context$Element$WithContext$fill))
								]),
							contentEl)
						]));
			});
	});
var $author$project$Page$Home$viewApplyQuestionsStage = function (model) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			var applyQuestionsStageModel = model.o;
			return A5(
				$author$project$Page$Home$viewChatContainer,
				model,
				true,
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(28),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 0, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
							$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$id('chatContainer'))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Page$Home$viewTalentinoActiveQuestionBubble,
							model,
							_List_Nil,
							A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								A2(
									$author$project$T2$Text$paragraphMediumAttrs,
									_List_Nil,
									$author$project$T2$Internal$Color$fgApplyActiveQuestionChatBubble(context)),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text('Por favor, escoge 5 opciones rápidas para entender mejor tu perfil')
									]))),
							A7(
							$author$project$Page$Home$viewDropdownQuestion,
							'¿En qué area de las empresas tienes más experiencia o interés?',
							applyQuestionsStageModel.q.cS,
							applyQuestionsStageModel.ab,
							$author$project$Page$Home$MsgCategoryDropdownToggled,
							$author$project$Page$Home$MsgCategoryDropdownClosed,
							function (i) {
								return $author$project$Page$Home$MsgCategoryDropdownSelectChanged(i);
							},
							'category-container'),
							A7(
							$author$project$Page$Home$viewDropdownQuestion,
							'¿Cuál es tu nivel de experiencia profesional?',
							applyQuestionsStageModel.q.cZ,
							applyQuestionsStageModel.ag,
							$author$project$Page$Home$MsgExperienceDropdownToggled,
							$author$project$Page$Home$MsgExperienceDropdownClosed,
							function (i) {
								return $author$project$Page$Home$MsgExperienceDropdownSelectChanged(i);
							},
							'experience_level-container'),
							A7(
							$author$project$Page$Home$viewDropdownQuestion,
							'¿Cuál es tu último nivel de estudios alcanzado?',
							applyQuestionsStageModel.q.cY,
							applyQuestionsStageModel.ad,
							$author$project$Page$Home$MsgEducationLevelDropdownToggled,
							$author$project$Page$Home$MsgEducationLevelDropdownClosed,
							function (i) {
								return $author$project$Page$Home$MsgEducationLevelDropdownSelectChanged(i);
							},
							'education_level-container'),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0),
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									A7(
										(!_Utils_eq(applyQuestionsStageModel.q.c_.bI, $elm$core$Maybe$Nothing)) ? $author$project$T2$TextInput$textInputOutlinedErrorMedium : $author$project$T2$TextInput$textInputOutlinedEnabledMedium,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
											]),
										$author$project$Page$Home$MsgUserChangedExperienceYears,
										$elm$core$Maybe$Just('¿Cuántos años de experiencia profesional tienes?'),
										$elm$core$Maybe$Just(''),
										applyQuestionsStageModel.q.c_.m,
										function () {
											var _v0 = applyQuestionsStageModel.q.c_.bI;
											if (!_v0.$) {
												var errorMessage = _v0.a;
												return $elm$core$Maybe$Just(errorMessage);
											} else {
												return A2(
													$elm$core$Maybe$map,
													function (experiencesYearsAsInt) {
														return $elm$core$String$fromInt(model.ci - experiencesYearsAsInt);
													},
													$elm$core$String$toInt(applyQuestionsStageModel.q.c_.m));
											}
										}(),
										$author$project$T2$Internal$TextInput$InputText(
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
													$elm$html$Html$Attributes$id('experience_years')),
													$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
													$elm$html$Html$Events$onFocus($author$project$Page$Home$MsgUserFocusedInput)),
													$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
													$elm$html$Html$Events$onBlur($author$project$Page$Home$MsgUserLeftInput)),
													$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
													$elm$html$Html$Attributes$tabindex(4))
												]))))
								])),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0),
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
									A2(
										$author$project$T2$Text$labelMediumAttrs,
										_List_Nil,
										$author$project$T2$Internal$Color$fgTextInputLabel(context)),
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$text('¿Cuáles son tus principales conocimientos/habilidades?')
										])),
								_Utils_ap(
									$elm$core$Array$toList(
										A2(
											$elm$core$Array$indexedMap,
											F2(
												function (index, skill) {
													return A2($author$project$Page$Home$viewSkillTextField, index, skill);
												}),
											applyQuestionsStageModel.q.jY)),
									_List_fromArray(
										[
											function () {
											var currentSkillsFilled = A3(
												$elm$core$Array$foldl,
												F2(
													function (skill, acc) {
														return ($elm$core$String$trim(skill.m) !== '') && acc;
													}),
												true,
												applyQuestionsStageModel.q.jY);
											return currentSkillsFilled ? A4(
												$author$project$T2$Button$buttonTextEnabledMediumWithLeftIcon,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$centerX,
														$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
														$elm$html$Html$Attributes$class('add-skill'))
													]),
												$author$project$Page$Home$MsgUserAddedOneSkill,
												$author$project$T2$Icon$add,
												'Agregar nueva habilidad') : A3(
												$author$project$T2$Button$buttonTextDisabledMediumWithLeftIcon,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$centerX,
														$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
														$elm$html$Html$Attributes$class('add-skill'))
													]),
												$author$project$T2$Icon$add,
												'Agregar nueva habilidad');
										}()
										]))))
						])),
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_Utils_ap(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12)
							]),
						$author$project$T2$Border$borderSharpWidthYApplyContainer),
					_List_fromArray(
						[
							A3(
							$author$project$T2$Button$buttonTextEnabledMedium,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$alignLeft]),
							$author$project$Page$Home$MsgUserSkippedApplyQuestions,
							'Saltar paso'),
							model.o.bJ ? A2(
							$author$project$T2$Button$buttonOutlinedLoadingMedium,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('talapoin-submit-stage-2'))
								]),
							'Enviando') : A3(
							$author$project$T2$Button$buttonOutlinedEnabledMedium,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('talapoin-submit-stage-2'))
								]),
							$author$project$Page$Home$MsgUserSubmittedApplyQuestions,
							'Enviar')
						])),
				model.o.Q);
		});
};
var $author$project$T2$Internal$Checkbox$Checked = 0;
var $author$project$T2$Internal$TextInput$InputMultiline = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Home$MsgCvFileFromCandidateApplySelected = {$: 103};
var $author$project$Page$Home$MsgUserChangedMessage = function (a) {
	return {$: 46, a: a};
};
var $author$project$Page$Home$MsgUserChangedPublicCvCheckbox = function (a) {
	return {$: 48, a: a};
};
var $author$project$Page$Home$MsgUserChangedSubscribeToNotificationsCheckbox = function (a) {
	return {$: 47, a: a};
};
var $author$project$Page$Home$MsgUserPressedApproveCurrentCv = {$: 108};
var $author$project$Page$Home$MsgUserPressedCvUploadButton = {$: 105};
var $author$project$Page$Home$MsgUserPressedDownloadCv = function (a) {
	return {$: 107, a: a};
};
var $author$project$Page$Home$MsgUserSubmittedCandidateCvInfo = {$: 50};
var $author$project$Page$Home$MsgUserSubmittedMessage = {$: 49};
var $author$project$T2$Internal$Checkbox$UnChecked = 1;
var $elm$html$Html$Attributes$accept = $elm$html$Html$Attributes$stringProperty('accept');
var $author$project$T2$Link$actionLinkSubtleEnabledMedium = F3(
	function (attrs, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(2)(0)($elm$core$Maybe$Nothing)(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(0);
	});
var $author$project$T2$Internal$Checkbox$Default = 0;
var $author$project$T2$Internal$Checkbox$Enabled = 0;
var $author$project$T2$Internal$Checkbox$Small = 0;
var $author$project$T2$Internal$Checkbox$Disabled = 1;
var $author$project$T2$Internal$Color$bgCheckboxEnabledDefaultCheckedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgCheckboxEnabledDefaultCheckedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$bgCheckboxEnabledDefaultUnCheckedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgCheckboxEnabledDefaultUnCheckedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$bgCheckboxEnabledErrorFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red00;
	}
};
var $author$project$T2$Internal$Color$bgCheckboxEnabledErrorHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red00;
	}
};
var $author$project$T2$Internal$Color$bgCheckboxEnabledWarningFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow00;
	}
};
var $author$project$T2$Internal$Color$bgCheckboxEnabledWarningHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow00;
	}
};
var $author$project$T2$Internal$Icon$internalCheckboxBlank = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#checkbox');
	});
var $author$project$T2$Icon$checkboxBlank = $author$project$T2$Internal$Icon$internalCheckboxBlank;
var $author$project$T2$Internal$Icon$internalCheckboxChecked = F4(
	function (size, mainColor, _v0, title) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var iconBackgroundColorHex = $author$project$T2$Internal$Color$Extra$colorToHex(
					$author$project$T2$Internal$Color$bgPrimary(context));
				return A4(
					$author$project$T2$Internal$Icon$internalRenderIconSvg,
					size,
					title,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$style(
							'--icon-stroke: ' + (iconBackgroundColorHex + ('; --icon-fill:' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + ';'))))
						]),
					'#checkbox-checked');
			});
	});
var $author$project$T2$Icon$checkboxChecked = $author$project$T2$Internal$Icon$internalCheckboxChecked;
var $author$project$T2$Internal$Color$fgCheckboxDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	}
};
var $author$project$T2$Internal$Color$fgCheckboxEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$ibcCheckboxDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$ibcCheckboxEnabledChecked = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$ibcCheckboxEnabledUnCheckedDefault = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray70;
	}
};
var $author$project$T2$Internal$Color$ibcCheckboxEnabledUnCheckedError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red50;
	}
};
var $author$project$T2$Internal$Color$ibcCheckboxEnabledUnCheckedWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$Checkbox$internalRenderIconView = F6(
	function (attrs, iconRenderer, color, secondaryColor, size, altText) {
		var iconSize = function () {
			switch (size) {
				case 0:
					return 2;
				case 1:
					return 4;
				default:
					return 5;
			}
		}();
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			attrs,
			A4(iconRenderer, iconSize, color, secondaryColor, altText));
	});
var $author$project$T2$Internal$Checkbox$renderCheckbox = F6(
	function (config, attrs, state, checkboxType, size, label) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var iconBorderColor = function () {
					if (!state) {
						switch (checkboxType) {
							case 0:
								return $elm$core$Maybe$Nothing;
							case 1:
								return $elm$core$Maybe$Just(
									$author$project$T2$Internal$Color$ibcCheckboxEnabledUnCheckedError(context));
							default:
								return $elm$core$Maybe$Just(
									$author$project$T2$Internal$Color$ibcCheckboxEnabledUnCheckedWarning(context));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var iconBcColor = function () {
					if (!state) {
						var _v13 = config.K;
						if (!_v13) {
							return $author$project$T2$Internal$Color$ibcCheckboxEnabledChecked;
						} else {
							switch (checkboxType) {
								case 0:
									return $author$project$T2$Internal$Color$ibcCheckboxEnabledUnCheckedDefault;
								case 1:
									return $author$project$T2$Internal$Color$ibcCheckboxEnabledUnCheckedError;
								default:
									return $author$project$T2$Internal$Color$ibcCheckboxEnabledUnCheckedWarning;
							}
						}
					} else {
						return $author$project$T2$Internal$Color$ibcCheckboxDisabled;
					}
				}();
				var hoverEl = function () {
					if (!state) {
						switch (checkboxType) {
							case 0:
								var _v11 = config.K;
								if (_v11 === 1) {
									return _List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
													{
														f6: 0,
														gy: $author$project$T2$Internal$Color$bgCheckboxEnabledDefaultUnCheckedHovered(context),
														iW: _Utils_Tuple2(0, 0),
														jW: 4
													}),
													$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
													$author$project$T2$Internal$Color$bgCheckboxEnabledDefaultUnCheckedHovered(context))
												]))
										]);
								} else {
									return _List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
													{
														f6: 0,
														gy: $author$project$T2$Internal$Color$bgCheckboxEnabledDefaultCheckedHovered(context),
														iW: _Utils_Tuple2(0, 0),
														jW: 4
													}),
													$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
													$author$project$T2$Internal$Color$bgCheckboxEnabledDefaultCheckedHovered(context))
												]))
										]);
								}
							case 1:
								return _List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
												{
													f6: 0,
													gy: $author$project$T2$Internal$Color$bgCheckboxEnabledErrorHovered(context),
													iW: _Utils_Tuple2(0, 0),
													jW: 4
												}),
												$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
												$author$project$T2$Internal$Color$bgCheckboxEnabledErrorHovered(context))
											]))
									]);
							default:
								return _List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
												{
													f6: 0,
													gy: $author$project$T2$Internal$Color$bgCheckboxEnabledWarningHovered(context),
													iW: _Utils_Tuple2(0, 0),
													jW: 4
												}),
												$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
												$author$project$T2$Internal$Color$bgCheckboxEnabledWarningHovered(context))
											]))
									]);
						}
					} else {
						return _List_Nil;
					}
				}();
				var focusEl = function () {
					if (!state) {
						switch (checkboxType) {
							case 0:
								var _v8 = config.K;
								if (_v8 === 1) {
									return _List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
											$author$project$T2$Internal$Color$bgCheckboxEnabledDefaultUnCheckedFocused(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
											{
												f6: 0,
												gy: $author$project$T2$Internal$Color$bgCheckboxEnabledDefaultUnCheckedFocused(context),
												iW: _Utils_Tuple2(0, 0),
												jW: 4
											})
										]);
								} else {
									return _List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
											$author$project$T2$Internal$Color$bgCheckboxEnabledDefaultCheckedFocused(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
											{
												f6: 0,
												gy: $author$project$T2$Internal$Color$bgCheckboxEnabledDefaultCheckedFocused(context),
												iW: _Utils_Tuple2(0, 0),
												jW: 4
											})
										]);
								}
							case 1:
								return _List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
										$author$project$T2$Internal$Color$bgCheckboxEnabledErrorFocused(context)),
										$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
										{
											f6: 0,
											gy: $author$project$T2$Internal$Color$bgCheckboxEnabledErrorFocused(context),
											iW: _Utils_Tuple2(0, 0),
											jW: 4
										})
									]);
							default:
								return _List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
										$author$project$T2$Internal$Color$bgCheckboxEnabledWarningFocused(context)),
										$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
										{
											f6: 0,
											gy: $author$project$T2$Internal$Color$bgCheckboxEnabledWarningFocused(context),
											iW: _Utils_Tuple2(0, 0),
											jW: 4
										})
									]);
						}
					} else {
						return _List_Nil;
					}
				}();
				var iconAttrs = _Utils_ap(
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
							$lucamug$elm_ui_with_context$Element$WithContext$focused(focusEl),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(2)
						]),
					_Utils_ap(
						hoverEl,
						(state === 1) ? _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$disabled(true)),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$class('tt-cursor-not-allowed'))
							]) : _List_fromArray(
							[$lucamug$elm_ui_with_context$Element$WithContext$pointer])));
				var fgColor = function () {
					if (!state) {
						return $author$project$T2$Internal$Color$fgCheckboxEnabled;
					} else {
						return $author$project$T2$Internal$Color$fgCheckboxDisabled;
					}
				}();
				var labelEl = function () {
					var fontAttrs = function () {
						switch (size) {
							case 0:
								return $author$project$T2$Text$paragraphSmallAttrs;
							case 1:
								return $author$project$T2$Text$paragraphMediumAttrs;
							default:
								return $author$project$T2$Text$paragraphLargeAttrs;
						}
					}();
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						A2(
							fontAttrs,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$centerY,
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2(
										$elm$html$Html$Attributes$attribute,
										'aria-checked',
										function () {
											var _v3 = config.K;
											if (!_v3) {
												return 'true';
											} else {
												return 'false';
											}
										}())),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('checkbox-label')),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$attribute, 'data-label', label))
								]),
							fgColor(context)),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text(label)
							]));
				}();
				var elementsSpacing = function () {
					switch (size) {
						case 0:
							return $author$project$T2$Internal$Spacing$spacing4 + 2;
						case 1:
							return $author$project$T2$Internal$Spacing$spacing8;
						default:
							return $author$project$T2$Internal$Spacing$spacing8;
					}
				}();
				var itemAttrs = _Utils_ap(
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(elementsSpacing),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$pointer
						]),
					_Utils_ap(
						(state === 1) ? _List_Nil : _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(config.ex)
							]),
						attrs));
				var _v0 = function () {
					var _v1 = config.K;
					if (!_v1) {
						return _Utils_Tuple2($author$project$T2$Icon$checkboxChecked, iconBorderColor);
					} else {
						return _Utils_Tuple2($author$project$T2$Icon$checkboxBlank, $elm$core$Maybe$Nothing);
					}
				}();
				var checkboxIcon = _v0.a;
				var secondaryColor = _v0.b;
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					itemAttrs,
					_List_fromArray(
						[
							A6(
							$author$project$T2$Internal$Checkbox$internalRenderIconView,
							iconAttrs,
							checkboxIcon,
							iconBcColor(context),
							secondaryColor,
							size,
							label),
							labelEl
						]));
			});
	});
var $author$project$T2$Checkbox$checkboxEnabledDefaultSmall = F3(
	function (config, attrs, label) {
		return A6($author$project$T2$Internal$Checkbox$renderCheckbox, config, attrs, 0, 0, 0, label);
	});
var $author$project$T2$Internal$Color$contentTertiary = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	}
};
var $author$project$T2$Internal$Icon$internalEdit = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#edit');
	});
var $author$project$T2$Icon$edit = $author$project$T2$Internal$Icon$internalEdit;
var $elm$html$Html$Attributes$hidden = $elm$html$Html$Attributes$boolProperty('hidden');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $author$project$Page$Home$viewCandidateCvStage = function (model) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			var candidateCvStageModel = model.x;
			var cvExists = function () {
				var _v8 = candidateCvStageModel.B.gl;
				if (!_v8.$) {
					return true;
				} else {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (_v9) {
								return true;
							},
							candidateCvStageModel.B.ge));
				}
			}();
			var isCurrentCvFromProfile = function () {
				var _v7 = candidateCvStageModel.B.gl;
				if (!_v7.$) {
					return false;
				} else {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (currentCandidateApplyInfo) {
								return currentCandidateApplyInfo.ej;
							},
							model.ak));
				}
			}();
			var candidateAlreadyApplied = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (currentCandidateApplyInfo) {
						return currentCandidateApplyInfo.dD;
					},
					model.ak));
			var showButtonForApproval = (isCurrentCvFromProfile || (candidateAlreadyApplied && cvExists)) && (!model.cj);
			return A5(
				$author$project$Page$Home$viewChatContainer,
				model,
				true,
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(28),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 0, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
							$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$id('chatContainer')),
							$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
							A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$style, 'display', 'none'))
									]),
								$lucamug$elm_ui_with_context$Element$WithContext$html(
									A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('file'),
												$elm$html$Html$Attributes$id($author$project$Page$Home$cvInputFieldIdForApply),
												$elm$html$Html$Attributes$name('cvFile'),
												A2(
												$elm$html$Html$Events$on,
												'change',
												$elm$json$Json$Decode$succeed($author$project$Page$Home$MsgCvFileFromCandidateApplySelected)),
												$elm$html$Html$Attributes$hidden(true),
												$elm$html$Html$Attributes$accept('application/pdf,application/x-pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/rtf,application/vnd.ms-word.document.12,application/vnd.oasis.opendocument.text')
											]),
										_List_Nil))))
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A3(
								$author$project$Page$Home$viewTalentinoActiveQuestionBubble,
								model,
								_List_Nil,
								A2(
									$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
									A2(
										$author$project$T2$Text$paragraphMediumAttrs,
										_List_Nil,
										$author$project$T2$Internal$Color$fgApplyActiveQuestionChatBubble(context)),
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$text('¿Quieres enviarle un mensaje al reclutador? (opcional)')
										]))),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
									]),
								A7(
									$author$project$T2$TextInput$textInputOutlinedEnabledMedium,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									$author$project$Page$Home$MsgUserChangedMessage,
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Just('Ingresa tu mensaje. Ej: ¿Por qué eres un buen candidato para este puesto?'),
									candidateCvStageModel.B.am,
									$elm$core$Maybe$Nothing,
									$author$project$T2$Internal$TextInput$InputMultiline(
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Attributes$id('message')),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Events$onFocus($author$project$Page$Home$MsgUserFocusedInput)),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Events$onBlur($author$project$Page$Home$MsgUserLeftInput))
											])))),
								A3(
								$author$project$T2$Checkbox$checkboxEnabledDefaultSmall,
								{
									ex: $author$project$Page$Home$MsgUserChangedSubscribeToNotificationsCheckbox(!candidateCvStageModel.B.j9),
									K: candidateCvStageModel.B.j9 ? 0 : 1
								},
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('alerts-checkbox')),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('sentry-mask'))
									]),
								'Quiero enterarme de empleos similares')
							]),
						_Utils_ap(
							model.aH ? _List_Nil : _List_fromArray(
								[
									A3(
									$author$project$T2$Checkbox$checkboxEnabledDefaultSmall,
									{
										ex: $author$project$Page$Home$MsgUserChangedPublicCvCheckbox(!candidateCvStageModel.B.jf),
										K: candidateCvStageModel.B.jf ? 0 : 1
									},
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$class('sentry-mask'))
										]),
									'Permitir que otros reclutadores vean mi CV')
								]),
							candidateCvStageModel.bu ? _List_fromArray(
								[
									function () {
									var label = isCurrentCvFromProfile ? 'Cargamos el último CV/hoja de vida que tenemos de ti. Revísalo y actualízalo si es necesario.' : ((candidateAlreadyApplied && cvExists) ? 'Revisa el CV/hoja de vida que has agregado en caso de que desees actualizarlo.' : 'Aumenta tus probabilidades para conseguir este puesto! Incluye tu CV/hoja de vida.');
									return A3(
										$author$project$Page$Home$viewTalentinoActiveQuestionBubble,
										model,
										_List_Nil,
										A2(
											$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
											A2(
												$author$project$T2$Text$paragraphMediumAttrs,
												_List_Nil,
												$author$project$T2$Internal$Color$fgApplyActiveQuestionChatBubble(context)),
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$text(label)
												])));
								}(),
									function () {
									var msgForDownloadCv = function () {
										var _v6 = candidateCvStageModel.B.gl;
										if (!_v6.$) {
											return $elm$core$Maybe$Nothing;
										} else {
											return A2(
												$elm$core$Maybe$andThen,
												function (currentCandidateApplyInfo) {
													return A2(
														$elm$core$Maybe$map,
														function (cvDownloadLink) {
															return $author$project$Page$Home$MsgUserPressedDownloadCv(cvDownloadLink);
														},
														currentCandidateApplyInfo.dR);
												},
												model.ak);
										}
									}();
									var fileNameMaybe = function () {
										var _v5 = candidateCvStageModel.B.gl;
										if (!_v5.$) {
											var candidateCurrentCv = _v5.a;
											return $elm$core$Maybe$Just(candidateCurrentCv.ha);
										} else {
											return A2(
												$elm$core$Maybe$andThen,
												function (candidateCurrentCv) {
													return $elm$core$List$head(
														$elm$core$List$reverse(
															A2($elm$core$String$split, '/', candidateCurrentCv.cN)));
												},
												candidateCvStageModel.B.ge);
										}
									}();
									var fileNameShrinkedMaybe = A2(
										$elm$core$Maybe$map,
										function (fileName) {
											var _v3 = A2($elm$core$String$split, '.', fileName);
											if ((_v3.b && _v3.b.b) && (!_v3.b.b.b)) {
												var name = _v3.a;
												var _v4 = _v3.b;
												var ext = _v4.a;
												return ($elm$core$String$length(name) > 25) ? (A3($elm$core$String$slice, 0, 10, name) + ('...' + (A3(
													$elm$core$String$slice,
													-9,
													$elm$core$String$length(name),
													name) + ('.' + ext)))) : fileName;
											} else {
												return fileName;
											}
										},
										fileNameMaybe);
									var cvFromProfileDate = isCurrentCvFromProfile ? A2(
										$elm$core$Maybe$andThen,
										function (c) {
											return c.dQ;
										},
										model.ak) : $elm$core$Maybe$Nothing;
									if (!fileNameShrinkedMaybe.$) {
										var fileNameShrinked = fileNameShrinkedMaybe.a;
										var bubbleBaseWidth = $author$project$Page$Home$getMainContainerWidth(model);
										return A2(
											$lucamug$elm_ui_with_context$Element$WithContext$column,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$spacing(28),
													$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
												]),
											_List_fromArray(
												[
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$column,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
															$lucamug$elm_ui_with_context$Element$WithContext$spacing(8)
														]),
													_List_fromArray(
														[
															A2(
															$lucamug$elm_ui_with_context$Element$WithContext$row,
															_List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$spacing(4),
																	$lucamug$elm_ui_with_context$Element$WithContext$alignRight
																]),
															_List_fromArray(
																[
																	A2(
																	$lucamug$elm_ui_with_context$Element$WithContext$el,
																	_List_fromArray(
																		[$lucamug$elm_ui_with_context$Element$WithContext$centerY]),
																	A4($author$project$T2$IconButton$iconButtonIconTertiaryEnabledSmall, _List_Nil, $author$project$Page$Home$MsgUserPressedCvUploadButton, $author$project$T2$Icon$edit, 'Editar')),
																	A2(
																	$lucamug$elm_ui_with_context$Element$WithContext$el,
																	_List_fromArray(
																		[
																			A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 8),
																			$author$project$T2$Elevation$elevation2,
																			$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
																			{aR: 8, aS: 8, bd: 8, be: 0}),
																			$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
																			$author$project$T2$Internal$Color$bgPrimary(context)),
																			$lucamug$elm_ui_with_context$Element$WithContext$width(
																			A3(
																				$elm$core$Basics$apL,
																				$lucamug$elm_ui_with_context$Element$WithContext$maximum,
																				$elm$core$Basics$ceiling(((bubbleBaseWidth - 32) * 80) / 100),
																				$lucamug$elm_ui_with_context$Element$WithContext$fill))
																		]),
																	A2(
																		$lucamug$elm_ui_with_context$Element$WithContext$row,
																		_List_fromArray(
																			[
																				$lucamug$elm_ui_with_context$Element$WithContext$spacing(8)
																			]),
																		_List_fromArray(
																			[
																				A4(
																				$author$project$T2$Internal$Icon$internalCv,
																				5,
																				$author$project$T2$Internal$Color$grayOrLight(context),
																				$elm$core$Maybe$Nothing,
																				'upload'),
																				function () {
																				if (!msgForDownloadCv.$) {
																					var downloadMsg = msgForDownloadCv.a;
																					return A3(
																						$author$project$T2$Link$actionLinkSubtleEnabledMedium,
																						_List_fromArray(
																							[
																								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
																								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																								$elm$html$Html$Attributes$class('uploaded-cv-file-name')),
																								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																								$elm$html$Html$Attributes$class('sentry-mask'))
																							]),
																						fileNameShrinked,
																						downloadMsg);
																				} else {
																					return A2(
																						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																						A2(
																							$author$project$T2$Text$paragraphMediumAttrs,
																							_List_fromArray(
																								[
																									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
																									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																									$elm$html$Html$Attributes$class('uploaded-cv-file-name')),
																									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																									$elm$html$Html$Attributes$class('sentry-mask'))
																								]),
																							$author$project$T2$Internal$Color$contentPrimary(context)),
																						_List_fromArray(
																							[
																								$lucamug$elm_ui_with_context$Element$WithContext$text(fileNameShrinked)
																							]));
																				}
																			}()
																			])))
																])),
															function () {
															if (!cvFromProfileDate.$) {
																var date = cvFromProfileDate.a;
																return A2(
																	$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																	A2(
																		$author$project$T2$Text$labelSmallAttrs,
																		_List_fromArray(
																			[$lucamug$elm_ui_with_context$Element$WithContext$alignRight]),
																		$author$project$T2$Internal$Color$contentTertiary(context)),
																	_List_fromArray(
																		[
																			A2(
																			$lucamug$elm_ui_with_context$Element$WithContext$el,
																			_List_fromArray(
																				[$lucamug$elm_ui_with_context$Element$WithContext$alignRight]),
																			$lucamug$elm_ui_with_context$Element$WithContext$text(date))
																		]));
															} else {
																return $lucamug$elm_ui_with_context$Element$WithContext$none;
															}
														}()
														])),
													showButtonForApproval ? $lucamug$elm_ui_with_context$Element$WithContext$none : A3(
													$author$project$Page$Home$viewTalentinoActiveQuestionBubble,
													model,
													_List_Nil,
													A2(
														$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
														A2(
															$author$project$T2$Text$paragraphMediumAttrs,
															_List_Nil,
															$author$project$T2$Internal$Color$fgApplyActiveQuestionChatBubble(context)),
														_List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$text('¡Genial! Ahora puedes finalizar tu postulación')
															])))
												]));
									} else {
										return A2(
											$lucamug$elm_ui_with_context$Element$WithContext$column,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
													$lucamug$elm_ui_with_context$Element$WithContext$spacing(4)
												]),
											_List_fromArray(
												[
													model.ay ? A2(
													$author$project$T2$Button$buttonFilledLoadingSmall,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$centerX,
															$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
															$elm$html$Html$Attributes$class('upload-cv'))
														]),
													'Cargando archivo...') : A3(
													$author$project$T2$Button$buttonFilledEnabledSmall,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$centerX,
															$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
															$elm$html$Html$Attributes$class('upload-cv'))
														]),
													$author$project$Page$Home$MsgUserPressedCvUploadButton,
													'Subir archivo'),
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
													A2(
														$author$project$T2$Text$labelSmallAttrs,
														_List_fromArray(
															[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$Font$center]),
														$author$project$T2$Internal$Color$contentTertiary(context)),
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$text('(recuerda que puedes subir un archivo de hasta '),
															A2(
															$lucamug$elm_ui_with_context$Element$WithContext$el,
															_List_fromArray(
																[$lucamug$elm_ui_with_context$Element$WithContext$Font$bold]),
															$lucamug$elm_ui_with_context$Element$WithContext$text('10MB'))
														]))
												]));
									}
								}(),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, 80)
										]),
									$lucamug$elm_ui_with_context$Element$WithContext$none)
								]) : _List_Nil))),
				(candidateCvStageModel.bu && (!showButtonForApproval)) ? A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_Utils_ap(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12)
							]),
						$author$project$T2$Border$borderSharpWidthYApplyContainer),
					_List_fromArray(
						[
							candidateCvStageModel.bo ? A2(
							$author$project$T2$Button$buttonOutlinedLoadingMedium,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$centerX,
									$lucamug$elm_ui_with_context$Element$WithContext$centerY,
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('talapoin-submit-stage-3'))
								]),
							'Enviando') : A3(
							$author$project$T2$Button$buttonOutlinedEnabledMedium,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$centerX,
									$lucamug$elm_ui_with_context$Element$WithContext$centerY,
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('talapoin-submit-stage-3'))
								]),
							$author$project$Page$Home$MsgUserSubmittedCandidateCvInfo,
							'Finalizar aplicación')
						])) : A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_Utils_ap(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12)
							]),
						$author$project$T2$Border$borderSharpWidthYApplyContainer),
					_List_fromArray(
						[
							A3(
							$author$project$T2$Button$buttonOutlinedEnabledMedium,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$centerX,
									$lucamug$elm_ui_with_context$Element$WithContext$centerY,
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('continue-cv'))
								]),
							(candidateCvStageModel.bu && showButtonForApproval) ? $author$project$Page$Home$MsgUserPressedApproveCurrentCv : $author$project$Page$Home$MsgUserSubmittedMessage,
							'Continuar')
						])),
				candidateCvStageModel.aM);
		});
};
var $author$project$T2$Internal$Color$fgApplyInactiveQuestionChatBubble = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$Page$Home$getCandidateInfoStageErrorMessage = function (model) {
	var _v0 = model.c.w;
	switch (_v0) {
		case 0:
			return model.c.l.cl.bI;
		case 1:
			return model.c.l.c1.bI;
		case 2:
			return model.c.l.i6.bI;
		case 3:
			return model.c.l.gS.bI;
		case 4:
			return model.c.l.cs.bI;
		case 5:
			return model.c.l.c4.bI;
		default:
			return model.c.Q;
	}
};
var $author$project$Page$Home$MsgCountryDropdownSelectChanged = function (a) {
	return {$: 117, a: a};
};
var $author$project$Page$Home$MsgCountryDropdownToggled = {$: 115};
var $author$project$Page$Home$MsgUserChangedEmail = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Home$MsgUserChangedFullname = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Home$MsgUserChangedHeadline = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$Home$MsgUserChangedPhone = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Page$Home$MsgUserLeftEmailInput = {$: 14};
var $author$project$Page$Home$MsgUserLeftFullnameInput = {$: 15};
var $author$project$Page$Home$MsgUserLeftHeadlineInput = {$: 18};
var $author$project$Page$Home$MsgUserLeftPhoneInput = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$Home$MsgUserPressedCloseCountryOptionalStep = {$: 118};
var $author$project$Page$Home$MsgUserSubmittedCandidateInfo = function (a) {
	return {$: 20, a: a};
};
var $author$project$Page$Home$MsgUserSubmittedCountry = {$: 114};
var $author$project$Page$Home$MsgUserSubmittedEmail = {$: 7};
var $author$project$Page$Home$MsgUserSubmittedFullname = {$: 9};
var $author$project$Page$Home$MsgUserSubmittedHeadline = {$: 19};
var $author$project$Page$Home$MsgUserSubmittedLocation = {$: 12};
var $author$project$Page$Home$MsgUserSubmittedPhone = function (a) {
	return {$: 11, a: a};
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$T2$Internal$Color$bgApplyInputSection = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$IconButton$Filled = 0;
var $author$project$T2$Internal$IconButton$Ignore = {$: 0};
var $author$project$T2$IconButton$iconButtonFilledDisabledMedium = F3(
	function (attrs, icon, alt) {
		return A7($author$project$T2$Internal$IconButton$renderIconButton, attrs, 0, 1, 1, $author$project$T2$Internal$IconButton$Ignore, icon, alt);
	});
var $author$project$T2$IconButton$iconButtonFilledEnabledMedium = F4(
	function (attrs, msg, icon, alt) {
		return A7(
			$author$project$T2$Internal$IconButton$renderIconButton,
			attrs,
			0,
			0,
			1,
			$author$project$T2$Internal$IconButton$OnClick(msg),
			icon,
			alt);
	});
var $author$project$Page$Home$onEnter = function (msg) {
	return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
		A2(
			$elm$html$Html$Events$on,
			'keyup',
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return (key === 'Enter') ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('Not the enter key');
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
};
var $author$project$T2$Internal$Icon$internalSend = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#send');
	});
var $author$project$T2$Icon$send = $author$project$T2$Internal$Icon$internalSend;
var $author$project$Page$Home$viewCommonInputAndButton = F8(
	function (model, tkCommonField, inputPlaceholder, inputType, inputMsg, inputOnBlurMsg, btnMsg, inputId) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var hasError = !_Utils_eq(tkCommonField.bI, $elm$core$Maybe$Nothing);
				var buttonActive = !((!_Utils_eq(tkCommonField.bI, $elm$core$Maybe$Nothing)) || (tkCommonField.cr === ''));
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
							$author$project$T2$Internal$Color$bgApplyInputSection(context)),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12),
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
							(!model.G) ? $author$project$T2$Border$borderSharp : $author$project$T2$Border$borderRoundedBottom
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							A7(
								hasError ? $author$project$T2$TextInput$textInputOutlinedErrorMedium : $author$project$T2$TextInput$textInputOutlinedEnabledMedium,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$author$project$T2$Border$borderRoundedDefault
									]),
								inputMsg,
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Just(inputPlaceholder),
								tkCommonField.cr,
								$elm$core$Maybe$Nothing,
								inputType(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Events$onBlur(inputOnBlurMsg)),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$id(inputId)),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$autocomplete(false)),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$spellcheck(false)),
											$author$project$Page$Home$onEnter(btnMsg)
										])))),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_Nil,
							buttonActive ? A4(
								$author$project$T2$IconButton$iconButtonFilledEnabledMedium,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('talapoin-submit-intermedite-step'))
									]),
								btnMsg,
								$author$project$T2$Icon$send,
								'Enviar') : A3(
								$author$project$T2$IconButton$iconButtonFilledDisabledMedium,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('talapoin-submit-intermedite-step'))
									]),
								$author$project$T2$Icon$send,
								'Enviar'))
						]));
			});
	});
var $author$project$Page$Home$viewCountryInputAndButton = F8(
	function (model, dropDownModel, dropdownContainerClass, btnMsg, btnCloseOptionalStep, onToggle, onClose, onSelect) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
							$author$project$T2$Internal$Color$bgApplyInputSection(context)),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12),
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
							(!model.G) ? $author$project$T2$Border$borderSharp : $author$project$T2$Border$borderRoundedBottom,
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('sentry-mask'))
						]),
					_List_fromArray(
						[
							A8(
							$author$project$T2$Dropdown$dropdownBelowOutlinedDefaultMedium,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$id(dropDownModel.ax)),
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class(dropdownContainerClass))
								]),
							'Selecciona un país',
							$elm$core$Maybe$Nothing,
							dropDownModel,
							onToggle,
							onClose,
							onSelect,
							$elm$core$Maybe$Nothing),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_Nil,
							A4(
								$author$project$T2$IconButton$iconButtonIconEnabledMedium,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('talapoin-cancel-country-step'))
									]),
								btnCloseOptionalStep,
								$author$project$T2$Icon$exit,
								'Cancelar')),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_Nil,
							A4(
								$author$project$T2$IconButton$iconButtonFilledEnabledMedium,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('talapoin-submit-country-step'))
									]),
								btnMsg,
								$author$project$T2$Icon$send,
								'Enviar'))
						]));
			});
	});
var $author$project$Page$Home$MsgCitiesListSearchReceived = function (a) {
	return {$: 119, a: a};
};
var $author$project$Page$Home$MsgUserPressedChangeCountry = {$: 112};
var $author$project$T2$Internal$Autocomplete$Above = 0;
var $author$project$T2$Internal$Autocomplete$InputChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$T2$Internal$Autocomplete$ToggleOpen = {$: 1};
var $mdgriffith$elm_ui$Element$Events$onFocus = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onFocus);
var $lucamug$elm_ui_with_context$Element$WithContext$Events$onFocus = function (msg) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Events$onFocus(msg));
};
var $mdgriffith$elm_ui$Element$Events$onLoseFocus = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onBlur);
var $lucamug$elm_ui_with_context$Element$WithContext$Events$onLoseFocus = function (msg) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Events$onLoseFocus(msg));
};
var $author$project$T2$Internal$Autocomplete$SelectHeaderItem = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$T2$Internal$Autocomplete$renderSectionHeaderHighlighted = F5(
	function (label, maybeValue, toMsg, size, isSelected) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var textAttrs = function () {
					switch (size) {
						case 0:
							return A2(
								$author$project$T2$Text$paragraphSmallBoldAttrs,
								_List_Nil,
								$author$project$T2$Internal$Color$contentSecondary(context));
						case 1:
							return A2(
								$author$project$T2$Text$paragraphMediumBoldAttrs,
								_List_Nil,
								$author$project$T2$Internal$Color$contentSecondary(context));
						default:
							return A2(
								$author$project$T2$Text$paragraphLargeBoldAttrs,
								_List_Nil,
								$author$project$T2$Internal$Color$contentSecondary(context));
					}
				}();
				var clickAttrs = function () {
					if (!maybeValue.$) {
						var value = maybeValue.a;
						return _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
								toMsg(
									A2($author$project$T2$Internal$Autocomplete$SelectHeaderItem, value, label))),
								$lucamug$elm_ui_with_context$Element$WithContext$pointer,
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, 'role', 'option'))
							]);
					} else {
						return _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, 'role', 'presentation'))
							]);
					}
				}();
				var bgAttrs = isSelected ? _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						$author$project$T2$Internal$Color$bgListItemSelected(context))
					]) : _List_Nil;
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_Utils_ap(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
								{bi: $author$project$T2$Internal$Spacing$spacing8, br: $author$project$T2$Internal$Spacing$spacing16, bt: $author$project$T2$Internal$Spacing$spacing24, by: $author$project$T2$Internal$Spacing$spacing8})
							]),
						_Utils_ap(bgAttrs, clickAttrs)),
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						textAttrs,
						$lucamug$elm_ui_with_context$Element$WithContext$text(
							$elm$core$String$toUpper(label))));
			});
	});
var $author$project$T2$Internal$Autocomplete$renderGroupedMenuItems = F5(
	function (renderItem, toMsg, size, selectedIndex, groupedItems) {
		var step = F2(
			function (gi, _v2) {
				var rowIndex = _v2.a;
				var itemIndex = _v2.b;
				var acc = _v2.c;
				if (!gi.$) {
					var label = gi.a.u;
					var value = gi.a.m;
					var headerEl = A5(
						$author$project$T2$Internal$Autocomplete$renderSectionHeaderHighlighted,
						label,
						value,
						toMsg,
						size,
						_Utils_eq(selectedIndex, rowIndex));
					return _Utils_Tuple3(
						rowIndex + 1,
						itemIndex,
						_Utils_ap(
							acc,
							_List_fromArray(
								[headerEl])));
				} else {
					var item = gi.a;
					return _Utils_Tuple3(
						rowIndex + 1,
						itemIndex + 1,
						_Utils_ap(
							acc,
							_List_fromArray(
								[
									A3(renderItem, rowIndex, itemIndex, item)
								])));
				}
			});
		var _v0 = A3(
			$elm$core$List$foldl,
			step,
			_Utils_Tuple3(0, 0, _List_Nil),
			groupedItems);
		var flatList = _v0.c;
		return _List_fromArray(
			[flatList]);
	});
var $author$project$T2$Internal$Autocomplete$SelectItem = function (a) {
	return {$: 3, a: a};
};
var $author$project$T2$Internal$Autocomplete$renderMenuItemCore = F6(
	function (inputSize, selectedIndex, toMsg, rowIndex, itemIndex, item) {
		var baseItemAttrs = _List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$attribute, 'role', 'option')),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				$elm$html$Html$Attributes$disabled(item.t))
			]);
		return item.t ? A2(
			function () {
				switch (inputSize) {
					case 0:
						return $author$project$T2$ListItem$listItemOneLineDisabledSmall;
					case 1:
						return $author$project$T2$ListItem$listItemOneLineDisabledMedium;
					default:
						return $author$project$T2$ListItem$listItemOneLineDisabledLarge;
				}
			}(),
			baseItemAttrs,
			item.u) : (_Utils_eq(selectedIndex, rowIndex) ? A3(
			function () {
				switch (inputSize) {
					case 0:
						return $author$project$T2$ListItem$actionListItemOneLineSelectedSmall;
					case 1:
						return $author$project$T2$ListItem$actionListItemOneLineSelectedMedium;
					default:
						return $author$project$T2$ListItem$actionListItemOneLineSelectedLarge;
				}
			}(),
			baseItemAttrs,
			toMsg(
				$author$project$T2$Internal$Autocomplete$SelectItem(itemIndex)),
			item.u) : A3(
			function () {
				switch (inputSize) {
					case 0:
						return $author$project$T2$ListItem$actionListItemOneLineEnabledSmall;
					case 1:
						return $author$project$T2$ListItem$actionListItemOneLineEnabledMedium;
					default:
						return $author$project$T2$ListItem$actionListItemOneLineEnabledLarge;
				}
			}(),
			baseItemAttrs,
			toMsg(
				$author$project$T2$Internal$Autocomplete$SelectItem(itemIndex)),
			item.u));
	});
var $author$project$T2$Internal$Autocomplete$renderMenuItem = F5(
	function (config, model, rowIndex, itemIndex, item) {
		return A6($author$project$T2$Internal$Autocomplete$renderMenuItemCore, config.e, model.a7, model.aN, rowIndex, itemIndex, item);
	});
var $author$project$T2$Internal$Autocomplete$renderInputGrouped = F3(
	function (config, groupedItems, model) {
		var placementStyle = function () {
			var _v3 = config.j;
			if (_v3 === 1) {
				return 'top';
			} else {
				return 'bottom';
			}
		}();
		var moveAttr = function () {
			var _v2 = config.j;
			if (_v2 === 1) {
				return $lucamug$elm_ui_with_context$Element$WithContext$moveDown;
			} else {
				return $lucamug$elm_ui_with_context$Element$WithContext$moveUp;
			}
		}();
		var menuPlacementEl = function () {
			var _v1 = config.j;
			if (_v1 === 1) {
				return $lucamug$elm_ui_with_context$Element$WithContext$below;
			} else {
				return $lucamug$elm_ui_with_context$Element$WithContext$above;
			}
		}();
		var flatItems = A2(
			$elm$core$List$filterMap,
			function (gi) {
				if (gi.$ === 1) {
					var item = gi.a;
					return $elm$core$Maybe$Just(item);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			groupedItems);
		var menuEl = (model.h7 && (!$elm$core$List$isEmpty(flatItems))) ? _List_fromArray(
			[
				menuPlacementEl(
				A2(
					$author$project$T2$Internal$Menu$renderMenu,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$id(model.ax + '-menu')),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'z-index', '1000')),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'position', 'absolute')),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$style, placementStyle, '100%')),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'left', '0')),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$attribute, 'role', 'listbox')),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							A2($lucamug$elm_ui_with_context$Element$WithContext$maximum, 300, $lucamug$elm_ui_with_context$Element$WithContext$shrink)),
							$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
							moveAttr(4)
						]),
					A5(
						$author$project$T2$Internal$Autocomplete$renderGroupedMenuItems,
						A2($author$project$T2$Internal$Autocomplete$renderMenuItem, config, model),
						model.aN,
						config.e,
						model.a7,
						groupedItems)))
			]) : _List_Nil;
		return $author$project$T2$Internal$TextInput$renderTextInput(menuEl)(config.g)(config.f)(config.e)(
			$author$project$T2$Internal$TextInput$InputText(
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$autocomplete(false)),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2($elm$html$Html$Attributes$attribute, 'aria-autocomplete', 'list')),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$id(model.ax + '-input')),
						$lucamug$elm_ui_with_context$Element$WithContext$Events$onFocus(
						model.aN($author$project$T2$Internal$Autocomplete$ToggleOpen)),
						$lucamug$elm_ui_with_context$Element$WithContext$Events$onLoseFocus(model.db)
					])))(
			A2($elm$core$Basics$composeL, model.aN, $author$project$T2$Internal$Autocomplete$InputChanged))(model.jk)(config.h)(config.k)(config.u)(config.i)(config.d);
	});
var $author$project$T2$Internal$Autocomplete$viewGrouped = F4(
	function (attrs, config, model, groupedItems) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_Utils_ap(
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$id(model.ax)),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2($elm$html$Html$Attributes$attribute, 'role', 'combobox')),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2(
							$elm$html$Html$Attributes$attribute,
							'aria-expanded',
							model.h7 ? 'true' : 'false')),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'position', 'relative'))
					]),
				attrs),
			A3($author$project$T2$Internal$Autocomplete$renderInputGrouped, config, groupedItems, model));
	});
var $author$project$T2$Internal$Autocomplete$view = F3(
	function (attrs, config, model) {
		return A4(
			$author$project$T2$Internal$Autocomplete$viewGrouped,
			attrs,
			config,
			model,
			$author$project$T2$Internal$Autocomplete$toUngrouped(model.bp));
	});
var $author$project$T2$Autocomplete$autocompleteAboveOutlinedEnabledMedium = F5(
	function (attrs, label, placeholder, hint, autocompleteModel) {
		return A3(
			$author$project$T2$Internal$Autocomplete$view,
			attrs,
			{d: hint, e: 1, f: 0, g: 1, u: label, h: $elm$core$Maybe$Nothing, i: placeholder, j: 0, k: $elm$core$Maybe$Nothing},
			autocompleteModel);
	});
var $author$project$T2$Button$buttonTextEnabledSmall = F3(
	function (attrs, msg, label) {
		return A9(
			$author$project$T2$Internal$Button$renderButton,
			attrs,
			2,
			0,
			0,
			$author$project$T2$Internal$Button$OnClick(msg),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			label);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Lazy$apply3 = F5(
	function (context, fn, a, b, c) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$Internal$run,
			context,
			A3(fn, a, b, c));
	});
var $mdgriffith$elm_ui$Element$Lazy$embed = function (x) {
	switch (x.$) {
		case 0:
			var html = x.a;
			return html;
		case 1:
			var styled = x.a;
			return styled.hH(
				A2(
					$mdgriffith$elm_ui$Internal$Model$OnlyDynamic,
					{
						he: {dz: $elm$core$Maybe$Nothing, dC: $elm$core$Maybe$Nothing, e7: $elm$core$Maybe$Nothing},
						hG: 1,
						iE: 0
					},
					styled.j7));
		case 2:
			var text = x.a;
			return $elm$core$Basics$always(
				$elm$virtual_dom$VirtualDom$text(text));
		default:
			return $elm$core$Basics$always(
				$elm$virtual_dom$VirtualDom$text(''));
	}
};
var $mdgriffith$elm_ui$Element$Lazy$apply5 = F6(
	function (fn, a, b, c, d, e) {
		return $mdgriffith$elm_ui$Element$Lazy$embed(
			A5(fn, a, b, c, d, e));
	});
var $elm$virtual_dom$VirtualDom$lazy7 = _VirtualDom_lazy7;
var $mdgriffith$elm_ui$Element$Lazy$lazy5 = F6(
	function (fn, a, b, c, d, e) {
		return $mdgriffith$elm_ui$Internal$Model$Unstyled(
			A7($elm$virtual_dom$VirtualDom$lazy7, $mdgriffith$elm_ui$Element$Lazy$apply5, fn, a, b, c, d, e));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Lazy$lazy3 = F4(
	function (fn, a, b, c) {
		return function (context) {
			return A6($mdgriffith$elm_ui$Element$Lazy$lazy5, $lucamug$elm_ui_with_context$Element$WithContext$Lazy$apply3, context, fn, a, b, c);
		};
	});
var $author$project$Model$TkCityDo = F4(
	function (region_name, region_id, city_name, city_id) {
		return {gq: city_id, gr: city_name, jD: region_id, jE: region_name};
	});
var $author$project$Model$cityApiResponseDoJsonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'city_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'city_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'region_id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'region_name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$TkCityDo)))));
var $author$project$Model$cityListApiResponseDoJsonDecoder = $elm$json$Json$Decode$list($author$project$Model$cityApiResponseDoJsonDecoder);
var $author$project$Model$citiesListDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail']),
	$author$project$Model$cityListApiResponseDoJsonDecoder);
var $author$project$Page$Home$viewCityFuseJsElement = F4(
	function (msgCitiesListSearchReceived, marmosetAssetsBaseUrl, countryCode, value) {
		var sanitizedCountryCode = $elm$url$Url$percentEncode(countryCode);
		return $lucamug$elm_ui_with_context$Element$WithContext$html(
			A3(
				$elm$html$Html$node,
				'fuse-js',
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'value', value),
						A2($elm$html$Html$Attributes$attribute, 'url', marmosetAssetsBaseUrl + ('/country/' + (sanitizedCountryCode + '/cities'))),
						A2($elm$html$Html$Attributes$attribute, 'refresh', 'false'),
						A2($elm$html$Html$Attributes$attribute, 'keys', 'city_name,city_name_normalized,region_name,region_name_normalized,city_region'),
						A2($elm$html$Html$Attributes$attribute, 'id', 'city'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'threshold',
						$elm$core$String$fromFloat(0.3)),
						A2(
						$elm$html$Html$Events$on,
						'change',
						A2($elm$json$Json$Decode$map, msgCitiesListSearchReceived, $author$project$Model$citiesListDecoder))
					]),
				_List_Nil));
	});
var $author$project$Page$Home$viewLocationInputAndButton = F3(
	function (model, tkLocationField, btnMsg) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var buttonActive = !((!_Utils_eq(tkLocationField.bI, $elm$core$Maybe$Nothing)) || (tkLocationField.cr === ''));
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
									$author$project$T2$Internal$Color$bgApplyInputSection(context)),
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$height(
									$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12),
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
									(!model.G) ? $author$project$T2$Border$borderSharp : $author$project$T2$Border$borderRoundedBottom,
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('sentry-mask'))
								]),
							_List_fromArray(
								[
									A5(
									$author$project$T2$Autocomplete$autocompleteAboveOutlinedEnabledMedium,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Just('Ingresa un municipio / delegación'),
									$elm$core$Maybe$Nothing,
									model.c.aj),
									(_Utils_eq(model.c.aj.bp, _List_Nil) && ((!(model.c.aj.jk === '')) && _Utils_eq(model.c.aj.jR, $elm$core$Maybe$Nothing))) ? A3(
									$author$project$T2$Button$buttonTextEnabledSmall,
									_List_fromArray(
										[$lucamug$elm_ui_with_context$Element$WithContext$centerX]),
									$author$project$Page$Home$MsgUserPressedChangeCountry,
									'Cambiar país') : $lucamug$elm_ui_with_context$Element$WithContext$none,
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_Nil,
									buttonActive ? A4(
										$author$project$T2$IconButton$iconButtonFilledEnabledMedium,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Attributes$class('talapoin-submit-location-step'))
											]),
										btnMsg,
										$author$project$T2$Icon$send,
										'Enviar') : A3(
										$author$project$T2$IconButton$iconButtonFilledDisabledMedium,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Attributes$class('talapoin-submit-location-step'))
											]),
										$author$project$T2$Icon$send,
										'Enviar'))
								])),
							A4(
							$lucamug$elm_ui_with_context$Element$WithContext$Lazy$lazy3,
							$author$project$Page$Home$viewCityFuseJsElement($author$project$Page$Home$MsgCitiesListSearchReceived),
							model.J.iA,
							A2($elm$core$Maybe$withDefault, 'mx', model.gT),
							model.c.l.cs.cr)
						]));
			});
	});
var $author$project$Page$Home$viewBottomImput = F2(
	function (model, tkJobAdSummaryDo) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (_v0) {
				var _v1 = model.c.w;
				switch (_v1) {
					case 0:
						return A8($author$project$Page$Home$viewCommonInputAndButton, model, model.c.l.cl, 'Ingresa tu correo electrónico', $author$project$T2$Internal$TextInput$InputText, $author$project$Page$Home$MsgUserChangedEmail, $author$project$Page$Home$MsgUserLeftEmailInput, $author$project$Page$Home$MsgUserSubmittedEmail, 'email');
					case 1:
						return A8($author$project$Page$Home$viewCommonInputAndButton, model, model.c.l.c1, 'Ingresa tu nombre y apellido', $author$project$T2$Internal$TextInput$InputText, $author$project$Page$Home$MsgUserChangedFullname, $author$project$Page$Home$MsgUserLeftFullnameInput, $author$project$Page$Home$MsgUserSubmittedFullname, 'fullname');
					case 2:
						var phoneInputLabel = (tkJobAdSummaryDo.gT === 'mx') ? 'Ingresa tu número celular' : 'Ingresa tu código de país + número de celular';
						return A8(
							$author$project$Page$Home$viewCommonInputAndButton,
							model,
							model.c.l.i6,
							phoneInputLabel,
							$author$project$T2$Internal$TextInput$InputText,
							$author$project$Page$Home$MsgUserChangedPhone(tkJobAdSummaryDo),
							$author$project$Page$Home$MsgUserLeftPhoneInput(tkJobAdSummaryDo),
							$author$project$Page$Home$MsgUserSubmittedPhone(tkJobAdSummaryDo),
							'phonenumber');
					case 3:
						return A8(
							$author$project$Page$Home$viewCountryInputAndButton,
							model,
							model.c.Y,
							'country-container',
							$author$project$Page$Home$MsgUserSubmittedCountry,
							$author$project$Page$Home$MsgUserPressedCloseCountryOptionalStep,
							$author$project$Page$Home$MsgCountryDropdownToggled,
							$author$project$Page$Home$MsgCountryDropdownClosed,
							function (i) {
								return $author$project$Page$Home$MsgCountryDropdownSelectChanged(i);
							});
					case 4:
						return A3($author$project$Page$Home$viewLocationInputAndButton, model, model.c.l.cs, $author$project$Page$Home$MsgUserSubmittedLocation);
					case 5:
						return A8($author$project$Page$Home$viewCommonInputAndButton, model, model.c.l.c4, 'Ej: \"Analista de Marketing con experiencia en la Industria Automotriz\"  o \"Graduado de Ingeniería Mecánica, experto en motores eléctricos\"', $author$project$T2$Internal$TextInput$InputText, $author$project$Page$Home$MsgUserChangedHeadline, $author$project$Page$Home$MsgUserLeftHeadlineInput, $author$project$Page$Home$MsgUserSubmittedHeadline, 'headline');
					default:
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_Utils_ap(
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$height(
										$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
										A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12)
									]),
								$author$project$T2$Border$borderSharpWidthYApplyContainer),
							model.c.bK ? A2(
								$author$project$T2$Button$buttonOutlinedLoadingMedium,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$centerX,
										$lucamug$elm_ui_with_context$Element$WithContext$centerY,
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('talapoin-submit-stage-1'))
									]),
								'Enviando') : A3(
								$author$project$T2$Button$buttonOutlinedEnabledMedium,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$centerX,
										$lucamug$elm_ui_with_context$Element$WithContext$centerY,
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('talapoin-submit-stage-1'))
									]),
								$author$project$Page$Home$MsgUserSubmittedCandidateInfo(tkJobAdSummaryDo),
								'Enviar mis datos'));
				}
			});
	});
var $author$project$Page$Home$MsgUserClosedCandidateAlreadyAppliedMessage = {$: 84};
var $author$project$T2$Internal$Color$contentInversePrimary = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Elevation$Elevation4 = 3;
var $author$project$T2$Elevation$elevation4 = $author$project$T2$Internal$Elevation$renderElevation(3);
var $author$project$Page$Home$viewCandidateAlreadyAppliedMessage = function (model) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			return model.bU ? A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 8, 16),
						$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
					]),
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$padding(8),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
							$author$project$T2$Internal$Color$contentInversePrimary(context)),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(7),
							$author$project$T2$Elevation$elevation4,
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('talapoin-candidate-already-applied-message')),
							$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClosedCandidateAlreadyAppliedMessage),
							$lucamug$elm_ui_with_context$Element$WithContext$inFront(
							A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
										$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
										$lucamug$elm_ui_with_context$Element$WithContext$moveUp(7),
										$lucamug$elm_ui_with_context$Element$WithContext$moveRight(7),
										$lucamug$elm_ui_with_context$Element$WithContext$pointer,
										$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClosedCandidateAlreadyAppliedMessage),
										$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
										$author$project$T2$Internal$Color$contentInversePrimary(context)),
										$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(25)
									]),
								A4(
									$author$project$T2$Internal$Icon$internalExit,
									3,
									$author$project$T2$Internal$Color$contentPrimary(context),
									$elm$core$Maybe$Nothing,
									'cerrar')))
						]),
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$text('Ya te postulaste a este anuncio de empleo. Si deseas puedes continuar para actualizar tus datos'),
							$lucamug$elm_ui_with_context$Element$WithContext$text(' o puedes buscar anuncios similares '),
							A3($author$project$T2$Link$actionLinkBoldEnabledMedium, _List_Nil, 'aquí', $author$project$Page$Home$MsgUserClickGoToJobAdSerchPageButton)
						]))) : $lucamug$elm_ui_with_context$Element$WithContext$none;
		});
};
var $author$project$Page$Home$MsgUserEditAnswer = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$Home$viewCandidateAnswerBubble = F3(
	function (model, question, contentEl) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var bubbleBaseWidth = $author$project$Page$Home$getMainContainerWidth(model);
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_Utils_ap(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$spacing(4),
								$lucamug$elm_ui_with_context$Element$WithContext$alignRight
							]),
						(model.c.D && (!_Utils_eq(question, model.c.w))) ? _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.5)
							]) : _List_Nil),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$centerY]),
							A4(
								$author$project$T2$IconButton$iconButtonIconTertiaryEnabledSmall,
								_List_Nil,
								$author$project$Page$Home$MsgUserEditAnswer(question),
								$author$project$T2$Icon$edit,
								'Editar')),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 8),
									$author$project$T2$Elevation$elevation2,
									$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
									$author$project$Page$Home$MsgUserEditAnswer(question)),
									$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
									{aR: 8, aS: 8, bd: 8, be: 0}),
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
									$author$project$T2$Internal$Color$bgPrimary(context)),
									$lucamug$elm_ui_with_context$Element$WithContext$width(
									A3(
										$elm$core$Basics$apL,
										$lucamug$elm_ui_with_context$Element$WithContext$maximum,
										$elm$core$Basics$ceiling(((bubbleBaseWidth - 32) * 80) / 100),
										$lucamug$elm_ui_with_context$Element$WithContext$fill))
								]),
							contentEl)
						]));
			});
	});
var $author$project$T2$Internal$Color$bgApplyLoginButton = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green50;
	}
};
var $author$project$T2$Logo$talentecaLogoIsotypeOnlyInverse = function (attrs) {
	return A3($author$project$T2$Internal$Logo$renderLogo, attrs, 2, 1);
};
var $author$project$T2$Internal$Color$white = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$Page$Home$viewCandidateNotLoggedInTalentecaButton = function (model) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			if (model.p.ah) {
				var continueAsMessage = 'Continuar ' + A2(
					$elm$core$Maybe$withDefault,
					'con Talenteca',
					A2(
						$elm$core$Maybe$map,
						function (f) {
							return 'como ' + A2(
								$elm$core$Maybe$withDefault,
								f,
								$elm$core$List$head(
									A2($elm$core$String$split, ' ', f)));
						},
						model.N.hl));
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$centerX,
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'position', 'sticky')),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'top', '0')),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'z-index', '1')),
							$lucamug$elm_ui_with_context$Element$WithContext$pointer,
							$lucamug$elm_ui_with_context$Element$WithContext$width(
							(!model.p.ch) ? $lucamug$elm_ui_with_context$Element$WithContext$shrink : $lucamug$elm_ui_with_context$Element$WithContext$px(model.p.ch)),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('sentry-mask'))
						]),
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$row,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								$author$project$T2$Internal$Color$bgApplyLoginButton(context)),
								$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(25),
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 6, 8),
								$lucamug$elm_ui_with_context$Element$WithContext$spacing(4),
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$author$project$T2$Elevation$elevation1,
								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
								$author$project$Page$Home$MsgUserClickedSendMagicLink(model.N.cl)),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$class('login-not-with-google-button'))
							]),
						_List_fromArray(
							[
								((context.cF === 1) ? $author$project$T2$Logo$talentecaLogoIsotypeOnlyInverse : $author$project$T2$Logo$talentecaLogoIsotypeOnlyNormal)(
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width(
										$lucamug$elm_ui_with_context$Element$WithContext$px(28))
									])),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$column,
								A2(
									$author$project$T2$Text$paragraphSmallAttrs,
									_List_fromArray(
										[
											A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 4, 0),
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									$author$project$T2$Internal$Color$white(context)),
								model.p.E ? _List_fromArray(
									[
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_List_fromArray(
											[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$Font$bold]),
										$lucamug$elm_ui_with_context$Element$WithContext$text('Cargando...'))
									]) : _List_fromArray(
									[
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_List_fromArray(
											[$lucamug$elm_ui_with_context$Element$WithContext$Font$bold]),
										$lucamug$elm_ui_with_context$Element$WithContext$text(continueAsMessage)),
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_List_Nil,
										$lucamug$elm_ui_with_context$Element$WithContext$text(model.N.cl))
									]))
							])));
			} else {
				return $lucamug$elm_ui_with_context$Element$WithContext$none;
			}
		});
};
var $author$project$Page$Home$viewTalentinoQuestionBubble = F3(
	function (model, question, contentEl) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var bubbleBaseWidth = $author$project$Page$Home$getMainContainerWidth(model);
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_Utils_ap(
						_List_fromArray(
							[
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 8),
								$author$project$T2$Elevation$elevation2,
								$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
								{aR: 8, aS: 8, bd: 0, be: 8}),
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								$author$project$T2$Internal$Color$bgApplyInactiveQuestionChatBubble(context)),
								$lucamug$elm_ui_with_context$Element$WithContext$width(
								A3(
									$elm$core$Basics$apL,
									$lucamug$elm_ui_with_context$Element$WithContext$maximum,
									$elm$core$Basics$ceiling(((bubbleBaseWidth - 32) * 80) / 100),
									$lucamug$elm_ui_with_context$Element$WithContext$shrink))
							]),
						(model.c.D && (!_Utils_eq(question, model.c.w))) ? _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.5)
							]) : _List_Nil),
					contentEl);
			});
	});
var $author$project$Page$Home$viewCandidateInfoStage = F2(
	function (model, tkJobAdSummaryDo) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				return A5(
					$author$project$Page$Home$viewChatContainer,
					model,
					true,
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
								{
									bi: 16,
									br: 16,
									bt: 16,
									by: (model.p.ah || model.p.bW) ? 4 : 16
								}),
								$lucamug$elm_ui_with_context$Element$WithContext$spacing(12),
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 0, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
								$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$id('chatContainer')),
								$lucamug$elm_ui_with_context$Element$WithContext$inFront(
								$author$project$Page$Home$viewCandidateAlreadyAppliedMessage(model)),
								(!model.G) ? $author$project$T2$Border$borderSharp : $author$project$T2$Border$borderRoundedBottom
							]),
						function () {
							var viewQuestionAndAnswer = F3(
								function (question, questionEl, answerEl) {
									var extraAttrs = (model.c.D && (!_Utils_eq(question, model.c.w))) ? _List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.3)
										]) : _List_Nil;
									return _List_fromArray(
										[
											(_Utils_eq(model.c.w, question) ? A2($author$project$Page$Home$viewTalentinoActiveQuestionBubble, model, extraAttrs) : A2($author$project$Page$Home$viewTalentinoQuestionBubble, model, question))(questionEl),
											A3($author$project$Page$Home$viewCandidateAnswerBubble, model, question, answerEl)
										]);
								});
							var candidateInfoDo = model.c.l;
							return A2(
								$elm$core$List$cons,
								$author$project$Page$Home$viewCandidateNotLoggedInTalentecaButton(model),
								_Utils_ap(
									function () {
										var _v0 = candidateInfoDo.cl.m;
										if (!_v0.$) {
											var email = _v0.a;
											return _Utils_ap(
												A3(
													viewQuestionAndAnswer,
													0,
													A2(
														$lucamug$elm_ui_with_context$Element$WithContext$column,
														A2(
															$author$project$T2$Text$paragraphMediumAttrs,
															_List_Nil,
															((!model.c.w) ? $author$project$T2$Internal$Color$fgApplyActiveQuestionChatBubble : $author$project$T2$Internal$Color$fgApplyInactiveQuestionChatBubble)(context)),
														_List_fromArray(
															[
																A2(
																$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																_List_Nil,
																_List_fromArray(
																	[
																		$lucamug$elm_ui_with_context$Element$WithContext$text('Soy Talentino y te ayudaré con este empleo.')
																	])),
																A2(
																$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																_List_Nil,
																_List_fromArray(
																	[
																		$lucamug$elm_ui_with_context$Element$WithContext$text('Inicia sesión con Google o escribe tu correo electrónico')
																	]))
															])),
													A2(
														$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
														A2(
															$author$project$T2$Text$paragraphMediumAttrs,
															_List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$class('sentry-mask'))
																]),
															$author$project$T2$Internal$Color$contentPrimary(context)),
														_List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$text(email)
															]))),
												function () {
													var _v1 = candidateInfoDo.c1.m;
													if (!_v1.$) {
														var fullname = _v1.a;
														return _Utils_ap(
															A3(
																viewQuestionAndAnswer,
																1,
																A2(
																	$lucamug$elm_ui_with_context$Element$WithContext$wrappedRow,
																	A2(
																		$author$project$T2$Text$paragraphMediumAttrs,
																		_List_Nil,
																		((model.c.w === 1) ? $author$project$T2$Internal$Color$fgApplyActiveQuestionChatBubble : $author$project$T2$Internal$Color$fgApplyInactiveQuestionChatBubble)(context)),
																	_List_fromArray(
																		[
																			$lucamug$elm_ui_with_context$Element$WithContext$text('¿Cuál es tu nombre completo?')
																		])),
																A2(
																	$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																	A2(
																		$author$project$T2$Text$paragraphMediumAttrs,
																		_List_fromArray(
																			[
																				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																				$elm$html$Html$Attributes$class('sentry-mask'))
																			]),
																		$author$project$T2$Internal$Color$contentPrimary(context)),
																	_List_fromArray(
																		[
																			$lucamug$elm_ui_with_context$Element$WithContext$text(fullname)
																		]))),
															_Utils_ap(
																function () {
																	var _v2 = candidateInfoDo.i6.m;
																	if (!_v2.$) {
																		var phone = _v2.a;
																		return A3(
																			viewQuestionAndAnswer,
																			2,
																			A2(
																				$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																				A2(
																					$author$project$T2$Text$paragraphMediumAttrs,
																					_List_fromArray(
																						[
																							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																							$elm$html$Html$Attributes$class('sentry-mask'))
																						]),
																					((model.c.w === 2) ? $author$project$T2$Internal$Color$fgApplyActiveQuestionChatBubble : $author$project$T2$Internal$Color$fgApplyInactiveQuestionChatBubble)(context)),
																				_List_fromArray(
																					[
																						$lucamug$elm_ui_with_context$Element$WithContext$text('Hola ' + (fullname + '. Por favor, ¿cuál es tu número celular?'))
																					])),
																			A2(
																				$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																				A2(
																					$author$project$T2$Text$paragraphMediumAttrs,
																					_List_fromArray(
																						[
																							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																							$elm$html$Html$Attributes$class('sentry-mask'))
																						]),
																					$author$project$T2$Internal$Color$contentPrimary(context)),
																				_List_fromArray(
																					[
																						$lucamug$elm_ui_with_context$Element$WithContext$text(phone)
																					])));
																	} else {
																		return _List_Nil;
																	}
																}(),
																_Utils_ap(
																	function () {
																		var _v3 = candidateInfoDo.cs.m;
																		if (!_v3.$) {
																			return A3(
																				viewQuestionAndAnswer,
																				4,
																				A2(
																					$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																					A2(
																						$author$project$T2$Text$paragraphMediumAttrs,
																						_List_Nil,
																						((model.c.w === 4) ? $author$project$T2$Internal$Color$fgApplyActiveQuestionChatBubble : $author$project$T2$Internal$Color$fgApplyInactiveQuestionChatBubble)(context)),
																					_List_fromArray(
																						[
																							$lucamug$elm_ui_with_context$Element$WithContext$text('¿En qué municipio, delegación o ciudad vives?')
																						])),
																				A2(
																					$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																					A2(
																						$author$project$T2$Text$paragraphMediumAttrs,
																						_List_fromArray(
																							[
																								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																								$elm$html$Html$Attributes$class('sentry-mask'))
																							]),
																						$author$project$T2$Internal$Color$contentPrimary(context)),
																					_List_fromArray(
																						[
																							$lucamug$elm_ui_with_context$Element$WithContext$text(candidateInfoDo.cs.cr)
																						])));
																		} else {
																			return _List_Nil;
																		}
																	}(),
																	function () {
																		var _v4 = candidateInfoDo.c4.m;
																		if (!_v4.$) {
																			var headline = _v4.a;
																			return A3(
																				viewQuestionAndAnswer,
																				5,
																				A2(
																					$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																					A2(
																						$author$project$T2$Text$paragraphMediumAttrs,
																						_List_Nil,
																						((model.c.w === 5) ? $author$project$T2$Internal$Color$fgApplyActiveQuestionChatBubble : $author$project$T2$Internal$Color$fgApplyInactiveQuestionChatBubble)(context)),
																					_List_fromArray(
																						[
																							$lucamug$elm_ui_with_context$Element$WithContext$text('En una sola línea, ¿cómo resumes tu perfil profesional?')
																						])),
																				A2(
																					$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																					A2(
																						$author$project$T2$Text$paragraphMediumAttrs,
																						_List_fromArray(
																							[
																								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																								$elm$html$Html$Attributes$class('sentry-mask'))
																							]),
																						$author$project$T2$Internal$Color$contentPrimary(context)),
																					_List_fromArray(
																						[
																							$lucamug$elm_ui_with_context$Element$WithContext$text(headline)
																						])));
																		} else {
																			return _List_Nil;
																		}
																	}())));
													} else {
														return _List_Nil;
													}
												}());
										} else {
											return _List_Nil;
										}
									}(),
									_List_fromArray(
										[
											function () {
											var questionToShow = model.c.D ? model.c.aA : model.c.w;
											var questionTitle = function () {
												switch (questionToShow) {
													case 0:
														return '¿cuál es tu correo electrónico?';
													case 1:
														return '¿Cuál es tu nombre completo?';
													case 2:
														return 'Hola ' + (A2($elm$core$Maybe$withDefault, '', candidateInfoDo.c1.m) + '. Por favor, ¿cuál es tu número celular?');
													case 3:
														return '¿En qué país vives?';
													case 4:
														return '¿En qué municipio, delegación o ciudad vives?';
													case 5:
														return 'En una sola línea, ¿cómo resumes tu perfil profesional?';
													default:
														return '¡Excelente! Tus datos serán visibles para que el reclutador te pueda contactar, revísalos antes de continuar.';
												}
											}();
											var extraAttrs = (model.c.D && (!_Utils_eq(questionToShow, model.c.w))) ? _List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.3)
												]) : _List_Nil;
											return A3(
												$author$project$Page$Home$viewTalentinoActiveQuestionBubble,
												model,
												extraAttrs,
												A2(
													$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
													A2(
														$author$project$T2$Text$paragraphMediumAttrs,
														_List_Nil,
														$author$project$T2$Internal$Color$fgApplyActiveQuestionChatBubble(context)),
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$text(questionTitle)
														])));
										}()
										])));
						}()),
					A2($author$project$Page$Home$viewBottomImput, model, tkJobAdSummaryDo),
					$author$project$Page$Home$getCandidateInfoStageErrorMessage(model));
			});
	});
var $author$project$T2$Internal$Icon$Large120 = 11;
var $author$project$Page$Home$MsgUserClickedCloseIcon = {$: 81};
var $author$project$T2$Internal$Color$contentAccent = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$turquoise60;
	}
};
var $author$project$T2$Internal$Icon$internalCheck = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#check2');
	});
var $mdgriffith$elm_ui$Element$Font$justify = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.kk);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$justify = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$justify);
var $author$project$Page$Home$viewCompleteApplyStage = F2(
	function (model, tkJobAd) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width(
							$lucamug$elm_ui_with_context$Element$WithContext$px(
								$author$project$Page$Home$getMainContainerSize(model).dp)),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							$lucamug$elm_ui_with_context$Element$WithContext$px(
								$author$project$Page$Home$getMainContainerSize(model).bn - model.bc)),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
							$author$project$T2$Internal$Color$bgSecondary(context))
						]),
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$padding(24),
								$lucamug$elm_ui_with_context$Element$WithContext$spacing(28),
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$centerY
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[$lucamug$elm_ui_with_context$Element$WithContext$centerX]),
								A4(
									$author$project$T2$Internal$Icon$internalCheck,
									11,
									$author$project$T2$Internal$Color$contentAccent(context),
									$elm$core$Maybe$Nothing,
									'upload')),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								A2(
									$author$project$T2$Text$headingSmallAttrs,
									_List_fromArray(
										[$lucamug$elm_ui_with_context$Element$WithContext$Font$justify]),
									$author$project$T2$Internal$Color$contentPrimary(context)),
								_List_fromArray(
									[
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Attributes$id('success-message'))
											]),
										$lucamug$elm_ui_with_context$Element$WithContext$text(
											'¡tu postulación para ' + ($elm$core$String$toUpper(tkJobAd.jb) + ' ha sido enviada!')))
									])),
								A3(
								$author$project$T2$Button$buttonOutlinedEnabledSmall,
								_List_fromArray(
									[$lucamug$elm_ui_with_context$Element$WithContext$centerX]),
								$author$project$Page$Home$MsgUserClickedCloseIcon,
								'Cerrar')
							])));
			});
	});
var $author$project$T2$Internal$LoadingSpinner$Large = 3;
var $author$project$T2$LoadingSpinner$sectionLoadingSpinnerLarge = function (label) {
	return A2($author$project$T2$Internal$LoadingSpinner$renderSectionLoadingSpinner, label, 3);
};
var $author$project$Page$Home$viewExternalApplyStage = F2(
	function (model, tkJobAdSummaryDo) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				return A5(
					$author$project$Page$Home$viewChatContainer,
					model,
					true,
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
								$lucamug$elm_ui_with_context$Element$WithContext$spacing(20),
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 0, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
								$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$id('chatContainer'))
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								A2(
									$author$project$T2$Text$headingSmallXAttrs,
									_List_fromArray(
										[$lucamug$elm_ui_with_context$Element$WithContext$Font$center, $lucamug$elm_ui_with_context$Element$WithContext$centerY]),
									$author$project$T2$Internal$Color$contentPrimary(context)),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text('Te enviaremos a un sitio externo para continuar con tu postulación a:')
									])),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								A2(
									$author$project$T2$Text$headingSmallXAttrs,
									_List_fromArray(
										[$lucamug$elm_ui_with_context$Element$WithContext$Font$center, $lucamug$elm_ui_with_context$Element$WithContext$centerY]),
									$author$project$T2$Internal$Color$contentPrimary(context)),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text(
										$elm$core$String$toUpper(tkJobAdSummaryDo.jb))
									])),
								$author$project$T2$LoadingSpinner$sectionLoadingSpinnerLarge('')
							])),
					$lucamug$elm_ui_with_context$Element$WithContext$none,
					$elm$core$Maybe$Nothing);
			});
	});
var $author$project$Page$Home$MsgUserChangedSingleChoiceFilterQuestionAnswer = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Page$Home$MsgUserLeftOpenFilterQuestionInput = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Page$Home$MsgUserPressedEnterKeyInFilterQuestionInput = function (a) {
	return {$: 85, a: a};
};
var $author$project$Page$Home$MsgUserSkippedFilterQuestions = {$: 25};
var $author$project$Page$Home$MsgUserSubmittedFilterQuestions = {$: 26};
var $author$project$T2$Internal$RadioButtonGroup$Enabled = 0;
var $author$project$T2$Internal$RadioButtonGroup$Medium = 1;
var $author$project$T2$Internal$RadioButtonGroup$Vertical = 0;
var $author$project$T2$Internal$RadioButtonGroup$Disabled = 1;
var $author$project$T2$Internal$RadioButton$Selected = 0;
var $author$project$T2$Internal$RadioButton$UnSelected = 1;
var $author$project$T2$Internal$Color$contentError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red40;
	}
};
var $author$project$T2$Internal$Color$contentWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$Color$fgHintRadioButtonLabel = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgRadioButtonDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	}
};
var $author$project$T2$Internal$RadioButton$Default = 0;
var $author$project$T2$Internal$RadioButton$Disabled = 1;
var $author$project$T2$Internal$RadioButton$Large = 2;
var $author$project$T2$Internal$Color$bgRadioButtonEnabledDefaultSelectedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgRadioButtonEnabledDefaultSelectedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$bgRadioButtonEnabledDefaultUnSelectedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green01;
	}
};
var $author$project$T2$Internal$Color$bgRadioButtonEnabledDefaultUnSelectedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$bgRadioButtonEnabledErrorFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red00;
	}
};
var $author$project$T2$Internal$Color$bgRadioButtonEnabledErrorHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red00;
	}
};
var $author$project$T2$Internal$Color$bgRadioButtonEnabledWarningFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow00;
	}
};
var $author$project$T2$Internal$Color$bgRadioButtonEnabledWarningHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow00;
	}
};
var $author$project$T2$Internal$Color$fgRadioButtonEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$ibcRadioButtonDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$ibcRadioButtonEnabledSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$ibcRadioButtonEnabledUnSelectedDefault = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$ibcRadioButtonEnabledUnSelectedError = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red50;
	}
};
var $author$project$T2$Internal$Color$ibcRadioButtonEnabledUnSelectedWarning = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$RadioButton$internalRenderIconView = F6(
	function (attrs, iconRenderer, color, secondaryColor, size, altText) {
		var iconSize = function () {
			switch (size) {
				case 0:
					return 2;
				case 1:
					return 4;
				default:
					return 5;
			}
		}();
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			attrs,
			A4(iconRenderer, iconSize, color, secondaryColor, altText));
	});
var $author$project$T2$Internal$Icon$internalRadioButtonBlank = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#radiobutton');
	});
var $author$project$T2$Icon$radioButtonBlank = $author$project$T2$Internal$Icon$internalRadioButtonBlank;
var $author$project$T2$Internal$Icon$internalRadioButtonSelected = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + ('; --icon-fill:' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + ';'))))
				]),
			'#radiobutton-selected');
	});
var $author$project$T2$Icon$radioButtonSelected = $author$project$T2$Internal$Icon$internalRadioButtonSelected;
var $author$project$T2$Internal$RadioButton$renderRadioButton = F6(
	function (config, attrs, state, checkboxType, size, label) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var iconBorderColor = function () {
					if (!state) {
						switch (checkboxType) {
							case 0:
								return $elm$core$Maybe$Nothing;
							case 1:
								return $elm$core$Maybe$Just(
									$author$project$T2$Internal$Color$ibcRadioButtonEnabledUnSelectedError(context));
							default:
								return $elm$core$Maybe$Just(
									$author$project$T2$Internal$Color$ibcRadioButtonEnabledUnSelectedWarning(context));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var iconBcColor = function () {
					if (!state) {
						var _v12 = config.K;
						if (!_v12) {
							switch (checkboxType) {
								case 0:
									return $author$project$T2$Internal$Color$ibcRadioButtonEnabledSelected;
								case 1:
									return $author$project$T2$Internal$Color$ibcRadioButtonEnabledUnSelectedError;
								default:
									return $author$project$T2$Internal$Color$ibcRadioButtonEnabledUnSelectedWarning;
							}
						} else {
							switch (checkboxType) {
								case 0:
									return $author$project$T2$Internal$Color$ibcRadioButtonEnabledUnSelectedDefault;
								case 1:
									return $author$project$T2$Internal$Color$ibcRadioButtonEnabledUnSelectedError;
								default:
									return $author$project$T2$Internal$Color$ibcRadioButtonEnabledUnSelectedWarning;
							}
						}
					} else {
						return $author$project$T2$Internal$Color$ibcRadioButtonDisabled;
					}
				}();
				var hoverEl = function () {
					if (!state) {
						switch (checkboxType) {
							case 0:
								var _v10 = config.K;
								if (_v10 === 1) {
									return _List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
													{
														f6: 0,
														gy: $author$project$T2$Internal$Color$bgRadioButtonEnabledDefaultUnSelectedHovered(context),
														iW: _Utils_Tuple2(0, 0),
														jW: 5
													}),
													$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
													$author$project$T2$Internal$Color$bgRadioButtonEnabledDefaultUnSelectedHovered(context))
												]))
										]);
								} else {
									return _List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
													{
														f6: 0,
														gy: $author$project$T2$Internal$Color$bgRadioButtonEnabledDefaultSelectedHovered(context),
														iW: _Utils_Tuple2(0, 0),
														jW: 5
													}),
													$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
													$author$project$T2$Internal$Color$bgRadioButtonEnabledDefaultSelectedHovered(context))
												]))
										]);
								}
							case 1:
								return _List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
												{
													f6: 0,
													gy: $author$project$T2$Internal$Color$bgRadioButtonEnabledErrorHovered(context),
													iW: _Utils_Tuple2(0, 0),
													jW: 5
												}),
												$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
												$author$project$T2$Internal$Color$bgRadioButtonEnabledErrorHovered(context))
											]))
									]);
							default:
								return _List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
												{
													f6: 0,
													gy: $author$project$T2$Internal$Color$bgRadioButtonEnabledWarningHovered(context),
													iW: _Utils_Tuple2(0, 0),
													jW: 5
												}),
												$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
												$author$project$T2$Internal$Color$bgRadioButtonEnabledWarningHovered(context))
											]))
									]);
						}
					} else {
						return _List_Nil;
					}
				}();
				var focusEl = function () {
					if (!state) {
						switch (checkboxType) {
							case 0:
								var _v7 = config.K;
								if (_v7 === 1) {
									return _List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
											$author$project$T2$Internal$Color$bgRadioButtonEnabledDefaultUnSelectedFocused(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
											{
												f6: 0,
												gy: $author$project$T2$Internal$Color$bgRadioButtonEnabledDefaultUnSelectedFocused(context),
												iW: _Utils_Tuple2(0, 0),
												jW: 5
											})
										]);
								} else {
									return _List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
											$author$project$T2$Internal$Color$bgRadioButtonEnabledDefaultSelectedFocused(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
											{
												f6: 0,
												gy: $author$project$T2$Internal$Color$bgRadioButtonEnabledDefaultSelectedFocused(context),
												iW: _Utils_Tuple2(0, 0),
												jW: 5
											})
										]);
								}
							case 1:
								return _List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
										$author$project$T2$Internal$Color$bgRadioButtonEnabledErrorFocused(context)),
										$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
										{
											f6: 0,
											gy: $author$project$T2$Internal$Color$bgRadioButtonEnabledErrorFocused(context),
											iW: _Utils_Tuple2(0, 0),
											jW: 5
										})
									]);
							default:
								return _List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
										$author$project$T2$Internal$Color$bgRadioButtonEnabledWarningFocused(context)),
										$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
										{
											f6: 0,
											gy: $author$project$T2$Internal$Color$bgRadioButtonEnabledWarningFocused(context),
											iW: _Utils_Tuple2(0, 0),
											jW: 5
										})
									]);
						}
					} else {
						return _List_Nil;
					}
				}();
				var iconAttrs = _Utils_ap(
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
							$lucamug$elm_ui_with_context$Element$WithContext$focused(focusEl),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(50)
						]),
					_Utils_ap(
						hoverEl,
						(state === 1) ? _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$disabled(true)),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$class('tt-cursor-not-allowed'))
							]) : _List_fromArray(
							[$lucamug$elm_ui_with_context$Element$WithContext$pointer])));
				var fgColor = function () {
					if (!state) {
						return $author$project$T2$Internal$Color$fgRadioButtonEnabled;
					} else {
						return $author$project$T2$Internal$Color$fgRadioButtonDisabled;
					}
				}();
				var labelEl = function () {
					var fontAttrs = function () {
						switch (size) {
							case 0:
								return $author$project$T2$Text$paragraphSmallAttrs;
							case 1:
								return $author$project$T2$Text$paragraphMediumAttrs;
							default:
								return $author$project$T2$Text$paragraphLargeAttrs;
						}
					}();
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						A2(
							fontAttrs,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$centerY,
									$lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft
								]),
							fgColor(context)),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text(label)
							]));
				}();
				var elementsSpacing = function () {
					switch (size) {
						case 0:
							return $author$project$T2$Internal$Spacing$spacing4 + 2;
						case 1:
							return $author$project$T2$Internal$Spacing$spacing8;
						default:
							return $author$project$T2$Internal$Spacing$spacing8;
					}
				}();
				var itemAttrs = _Utils_ap(
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(elementsSpacing),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$pointer
						]),
					_Utils_ap(
						(state === 1) ? _List_Nil : _List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(config.ex)
							]),
						attrs));
				var _v0 = function () {
					var _v1 = config.K;
					if (!_v1) {
						return _Utils_Tuple2($author$project$T2$Icon$radioButtonSelected, iconBorderColor);
					} else {
						return _Utils_Tuple2($author$project$T2$Icon$radioButtonBlank, $elm$core$Maybe$Nothing);
					}
				}();
				var checkboxIcon = _v0.a;
				var secondaryColor = _v0.b;
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					itemAttrs,
					_List_fromArray(
						[
							A6(
							$author$project$T2$Internal$RadioButton$internalRenderIconView,
							iconAttrs,
							checkboxIcon,
							iconBcColor(context),
							secondaryColor,
							size,
							label),
							labelEl
						]));
			});
	});
var $author$project$T2$RadioButton$radioButtonDisabledLarge = F3(
	function (config, attrs, label) {
		return A6($author$project$T2$Internal$RadioButton$renderRadioButton, config, attrs, 1, 0, 2, label);
	});
var $author$project$T2$Internal$RadioButton$Medium = 1;
var $author$project$T2$RadioButton$radioButtonDisabledMedium = F3(
	function (config, attrs, label) {
		return A6($author$project$T2$Internal$RadioButton$renderRadioButton, config, attrs, 1, 0, 1, label);
	});
var $author$project$T2$Internal$RadioButton$Small = 0;
var $author$project$T2$RadioButton$radioButtonDisabledSmall = F3(
	function (config, attrs, label) {
		return A6($author$project$T2$Internal$RadioButton$renderRadioButton, config, attrs, 1, 0, 0, label);
	});
var $author$project$T2$Internal$RadioButton$Enabled = 0;
var $author$project$T2$RadioButton$radioButtonEnabledDefaultLarge = F3(
	function (config, attrs, label) {
		return A6($author$project$T2$Internal$RadioButton$renderRadioButton, config, attrs, 0, 0, 2, label);
	});
var $author$project$T2$RadioButton$radioButtonEnabledDefaultMedium = F3(
	function (config, attrs, label) {
		return A6($author$project$T2$Internal$RadioButton$renderRadioButton, config, attrs, 0, 0, 1, label);
	});
var $author$project$T2$RadioButton$radioButtonEnabledDefaultSmall = F3(
	function (config, attrs, label) {
		return A6($author$project$T2$Internal$RadioButton$renderRadioButton, config, attrs, 0, 0, 0, label);
	});
var $author$project$T2$Internal$RadioButton$Error = 1;
var $author$project$T2$RadioButton$radioButtonEnabledErrorLarge = F3(
	function (config, attrs, label) {
		return A6($author$project$T2$Internal$RadioButton$renderRadioButton, config, attrs, 0, 1, 2, label);
	});
var $author$project$T2$RadioButton$radioButtonEnabledErrorMedium = F3(
	function (config, attrs, label) {
		return A6($author$project$T2$Internal$RadioButton$renderRadioButton, config, attrs, 0, 1, 1, label);
	});
var $author$project$T2$RadioButton$radioButtonEnabledErrorSmall = F3(
	function (config, attrs, label) {
		return A6($author$project$T2$Internal$RadioButton$renderRadioButton, config, attrs, 0, 1, 0, label);
	});
var $author$project$T2$Internal$RadioButton$Warning = 2;
var $author$project$T2$RadioButton$radioButtonEnabledWarningLarge = F3(
	function (config, attrs, label) {
		return A6($author$project$T2$Internal$RadioButton$renderRadioButton, config, attrs, 0, 2, 2, label);
	});
var $author$project$T2$RadioButton$radioButtonEnabledWarningMedium = F3(
	function (config, attrs, label) {
		return A6($author$project$T2$Internal$RadioButton$renderRadioButton, config, attrs, 0, 2, 1, label);
	});
var $author$project$T2$RadioButton$radioButtonEnabledWarningSmall = F3(
	function (config, attrs, label) {
		return A6($author$project$T2$Internal$RadioButton$renderRadioButton, config, attrs, 0, 2, 0, label);
	});
var $author$project$T2$Internal$RadioButtonGroup$renderRadioButtonGroup = F7(
	function (radioButtonList, attrs, state, layout, size, maybeLabel, hintMaybe) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var labelEl = function () {
					if (!maybeLabel.$) {
						var label = maybeLabel.a;
						var labelFgColor = (state === 1) ? $author$project$T2$Internal$Color$fgRadioButtonDisabled : $author$project$T2$Internal$Color$fgTextInputLabel;
						var fontAttrs = function () {
							switch (size) {
								case 0:
									return $author$project$T2$Text$labelSmallAttrs;
								case 1:
									return $author$project$T2$Text$labelMediumAttrs;
								default:
									return $author$project$T2$Text$labelLargeAttrs;
							}
						}();
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							A2(
								fontAttrs,
								_List_fromArray(
									[$lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft]),
								labelFgColor(context)),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text(label)
								]));
					} else {
						return $lucamug$elm_ui_with_context$Element$WithContext$none;
					}
				}();
				var hintView = function () {
					if (!hintMaybe.$) {
						var hint = hintMaybe.a;
						var iconEl = function () {
							var iconSize = function () {
								switch (size) {
									case 0:
										return 1;
									case 1:
										return 2;
									default:
										return 4;
								}
							}();
							switch (state) {
								case 2:
									return A4(
										$author$project$T2$Internal$Icon$internalErrorFilled,
										iconSize,
										$author$project$T2$Internal$Color$contentError(context),
										$elm$core$Maybe$Nothing,
										'error');
								case 3:
									return A4(
										$author$project$T2$Internal$Icon$internalWarningFilled,
										iconSize,
										$author$project$T2$Internal$Color$contentWarning(context),
										$elm$core$Maybe$Nothing,
										'warning');
								case 0:
									return $lucamug$elm_ui_with_context$Element$WithContext$none;
								default:
									return $lucamug$elm_ui_with_context$Element$WithContext$none;
							}
						}();
						var hintFgColor = function () {
							switch (state) {
								case 2:
									return $author$project$T2$Internal$Color$contentError;
								case 3:
									return $author$project$T2$Internal$Color$contentPrimary;
								case 0:
									return $author$project$T2$Internal$Color$fgHintRadioButtonLabel;
								default:
									return $author$project$T2$Internal$Color$fgRadioButtonDisabled;
							}
						}();
						var hintElementAttrs = function () {
							switch (size) {
								case 0:
									return $author$project$T2$Text$paragraphSmallAttrs;
								case 1:
									return $author$project$T2$Text$paragraphMediumAttrs;
								default:
									return $author$project$T2$Text$paragraphLargeAttrs;
							}
						}();
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(8)
								]),
							_List_fromArray(
								[
									iconEl,
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
									A2(
										hintElementAttrs,
										_List_Nil,
										hintFgColor(context)),
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$text(hint)
										]))
								]));
					} else {
						return $lucamug$elm_ui_with_context$Element$WithContext$none;
					}
				}();
				var getRadioButtonEl = function (radioButton) {
					var selectedState = radioButton.ie ? 0 : 1;
					switch (size) {
						case 0:
							switch (state) {
								case 0:
									return A3(
										radioButton.h2 ? $author$project$T2$RadioButton$radioButtonEnabledDefaultSmall : $author$project$T2$RadioButton$radioButtonDisabledSmall,
										{ex: radioButton.kA, K: selectedState},
										radioButton.f1,
										radioButton.u);
								case 2:
									return A3(
										radioButton.h2 ? $author$project$T2$RadioButton$radioButtonEnabledErrorSmall : $author$project$T2$RadioButton$radioButtonDisabledSmall,
										{ex: radioButton.kA, K: selectedState},
										radioButton.f1,
										radioButton.u);
								case 3:
									return A3(
										radioButton.h2 ? $author$project$T2$RadioButton$radioButtonEnabledWarningSmall : $author$project$T2$RadioButton$radioButtonDisabledSmall,
										{ex: radioButton.kA, K: selectedState},
										radioButton.f1,
										radioButton.u);
								default:
									return A3(
										$author$project$T2$RadioButton$radioButtonDisabledSmall,
										{ex: radioButton.kA, K: selectedState},
										radioButton.f1,
										radioButton.u);
							}
						case 1:
							switch (state) {
								case 0:
									return A3(
										radioButton.h2 ? $author$project$T2$RadioButton$radioButtonEnabledDefaultMedium : $author$project$T2$RadioButton$radioButtonDisabledMedium,
										{ex: radioButton.kA, K: selectedState},
										radioButton.f1,
										radioButton.u);
								case 2:
									return A3(
										radioButton.h2 ? $author$project$T2$RadioButton$radioButtonEnabledErrorMedium : $author$project$T2$RadioButton$radioButtonDisabledMedium,
										{ex: radioButton.kA, K: selectedState},
										radioButton.f1,
										radioButton.u);
								case 3:
									return A3(
										radioButton.h2 ? $author$project$T2$RadioButton$radioButtonEnabledWarningMedium : $author$project$T2$RadioButton$radioButtonDisabledMedium,
										{ex: radioButton.kA, K: selectedState},
										radioButton.f1,
										radioButton.u);
								default:
									return A3(
										$author$project$T2$RadioButton$radioButtonDisabledMedium,
										{ex: radioButton.kA, K: selectedState},
										radioButton.f1,
										radioButton.u);
							}
						default:
							switch (state) {
								case 0:
									return A3(
										radioButton.h2 ? $author$project$T2$RadioButton$radioButtonEnabledDefaultLarge : $author$project$T2$RadioButton$radioButtonDisabledLarge,
										{ex: radioButton.kA, K: selectedState},
										radioButton.f1,
										radioButton.u);
								case 2:
									return A3(
										radioButton.h2 ? $author$project$T2$RadioButton$radioButtonEnabledErrorLarge : $author$project$T2$RadioButton$radioButtonDisabledLarge,
										{ex: radioButton.kA, K: selectedState},
										radioButton.f1,
										radioButton.u);
								case 3:
									return A3(
										radioButton.h2 ? $author$project$T2$RadioButton$radioButtonEnabledWarningLarge : $author$project$T2$RadioButton$radioButtonDisabledLarge,
										{ex: radioButton.kA, K: selectedState},
										radioButton.f1,
										radioButton.u);
								default:
									return A3(
										$author$project$T2$RadioButton$radioButtonDisabledLarge,
										{ex: radioButton.kA, K: selectedState},
										radioButton.f1,
										radioButton.u);
							}
					}
				};
				var radioButtonElements = A2($elm$core$List$map, getRadioButtonEl, radioButtonList);
				var radioButtonListEl = function () {
					if (!layout) {
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(8)
								]),
							radioButtonElements);
					} else {
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(12)
								]),
							radioButtonElements);
					}
				}();
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_Utils_ap(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
							]),
						attrs),
					_List_fromArray(
						[labelEl, radioButtonListEl, hintView]));
			});
	});
var $author$project$T2$RadioButtonGroup$radioButtonGroupEnabledVerticalMedium = F4(
	function (radioButtonList, attrs, label, hintMaybe) {
		return A7(
			$author$project$T2$Internal$RadioButtonGroup$renderRadioButtonGroup,
			radioButtonList,
			attrs,
			0,
			0,
			1,
			$elm$core$Maybe$Just(label),
			hintMaybe);
	});
var $author$project$T2$Internal$RadioButtonGroup$Error = 2;
var $author$project$T2$RadioButtonGroup$radioButtonGroupErrorVerticalMedium = F4(
	function (radioButtonList, attrs, label, hintMaybe) {
		return A7(
			$author$project$T2$Internal$RadioButtonGroup$renderRadioButtonGroup,
			radioButtonList,
			attrs,
			2,
			0,
			1,
			$elm$core$Maybe$Just(label),
			hintMaybe);
	});
var $author$project$Page$Home$viewFilterQuestionsStage = function (model) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			var viewSingleChoiceQuestion = function (question) {
				var answer = A2($elm$core$Dict$get, question.ax, model.A.fW);
				var answerErrorMessage = A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.bI;
					},
					answer);
				var answerValue = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.m;
						},
						answer));
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('sentry-mask'))
						]),
					_List_fromArray(
						[
							A4(
							function () {
								if (!answerErrorMessage.$) {
									return $author$project$T2$RadioButtonGroup$radioButtonGroupErrorVerticalMedium;
								} else {
									return $author$project$T2$RadioButtonGroup$radioButtonGroupEnabledVerticalMedium;
								}
							}(),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (l) {
										return A2(
											$elm$core$List$map,
											function (e) {
												return {
													f1: _List_Nil,
													h2: true,
													ie: _Utils_eq(answerValue, e.kv),
													u: e.kv,
													kA: A2($author$project$Page$Home$MsgUserChangedSingleChoiceFilterQuestionAnswer, question, e.kv),
													m: e.kv
												};
											},
											l);
									},
									question.fW)),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							question.kw,
							answerErrorMessage)
						]));
			};
			var viewOpenQuestion = function (question) {
				var answer = A2($elm$core$Dict$get, question.ax, model.A.fW);
				var answerErrorMessage = A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.bI;
					},
					answer);
				var answerValue = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.m;
						},
						answer));
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('sentry-mask'))
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							A7(
								(!_Utils_eq(answerErrorMessage, $elm$core$Maybe$Nothing)) ? $author$project$T2$TextInput$textInputOutlinedErrorMedium : $author$project$T2$TextInput$textInputOutlinedEnabledMedium,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
									]),
								$author$project$Page$Home$MsgUserChangedOpenFilterQuestionAnswer(question),
								$elm$core$Maybe$Just(question.kw),
								$elm$core$Maybe$Just(''),
								answerValue,
								answerErrorMessage,
								$author$project$T2$Internal$TextInput$InputText(
									_List_fromArray(
										[
											$author$project$Page$Home$onEnter(
											$author$project$Page$Home$MsgUserPressedEnterKeyInFilterQuestionInput('question-' + question.ax)),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Events$onFocus($author$project$Page$Home$MsgUserFocusedInput)),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$id('question-' + question.ax)),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Events$onBlur(
												A2($author$project$Page$Home$MsgUserLeftOpenFilterQuestionInput, question, answerValue)))
										]))))
						]));
			};
			var viewQuestion = function (question) {
				return (question.kG === 'SINGLE_CHOICE_QUESTION_TYPE') ? viewSingleChoiceQuestion(question) : viewOpenQuestion(question);
			};
			var numberOfQuestions = $elm$core$List$length(model.az);
			return A5(
				$author$project$Page$Home$viewChatContainer,
				model,
				false,
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(28),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 0, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$id('chatContainer'))
						]),
					A2(
						$elm$core$List$cons,
						A3(
							$author$project$Page$Home$viewTalentinoActiveQuestionBubble,
							model,
							_List_Nil,
							A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								A2(
									$author$project$T2$Text$paragraphMediumAttrs,
									_List_Nil,
									$author$project$T2$Internal$Color$fgApplyActiveQuestionChatBubble(context)),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text(
										(numberOfQuestions === 1) ? 'Ahora por favor responde esta pregunta del reclutador' : ('Ahora por favor responde estas ' + ($elm$core$String$fromInt(numberOfQuestions) + ' preguntas del reclutador')))
									]))),
						A2($elm$core$List$map, viewQuestion, model.az))),
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_Utils_ap(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12)
							]),
						$author$project$T2$Border$borderSharpWidthYApplyContainer),
					_List_fromArray(
						[
							A3(
							$author$project$T2$Button$buttonTextEnabledMedium,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$alignLeft]),
							$author$project$Page$Home$MsgUserSkippedFilterQuestions,
							'Saltar paso'),
							model.A.bL ? A2(
							$author$project$T2$Button$buttonOutlinedLoadingMedium,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$alignRight]),
							'Enviando') : A3(
							$author$project$T2$Button$buttonOutlinedEnabledMedium,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$alignRight]),
							$author$project$Page$Home$MsgUserSubmittedFilterQuestions,
							'Enviar')
						])),
				model.A.Q);
		});
};
var $author$project$Page$Home$viewLoginErrorMessage = function (model) {
	return $author$project$Page$Home$viewSnackBarError(model.p.ao);
};
var $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputOne = function (a) {
	return {$: 87, a: a};
};
var $author$project$Page$Home$MsgUserClosedLoginModal = {$: 71};
var $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputFive = {$: 95};
var $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputFour = {$: 93};
var $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputSix = {$: 97};
var $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputThree = {$: 91};
var $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputTwo = {$: 89};
var $author$project$T2$Internal$Color$Swatch$greenAlfa15Percent = A4($lucamug$elm_ui_with_context$Element$WithContext$rgba255, 0, 18, 14, 0.15);
var $author$project$T2$Internal$Color$bcTransparent = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$greenAlfa15Percent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$whiteAlfa30Percent;
	}
};
var $author$project$Page$Home$onBackspace = function (msg) {
	return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
		A2(
			$elm$html$Html$Events$on,
			'keydown',
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return (key === 'Backspace') ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('Not the Backspace key');
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
};
var $author$project$Page$Home$viewLoginModal = function (model) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			if ((model.N.hv && model.n.a9) || model.V) {
				var viewCodeTextField = F4(
					function (onChangeMsg, onBackspaceMsg, value, inputId) {
						return A7(
							model.n.co ? $author$project$T2$TextInput$textInputOutlinedErrorMedium : $author$project$T2$TextInput$textInputOutlinedEnabledMedium,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$shrink),
									$lucamug$elm_ui_with_context$Element$WithContext$Font$center,
									$lucamug$elm_ui_with_context$Element$WithContext$Font$bold
								]),
							onChangeMsg,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Nothing,
							value,
							$elm$core$Maybe$Nothing,
							$author$project$T2$Internal$TextInput$InputText(
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$id(inputId)),
										$author$project$Page$Home$onBackspace(
										(value === '') ? onBackspaceMsg : $author$project$Page$Home$PassThrough)
									])));
					});
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width(
							$lucamug$elm_ui_with_context$Element$WithContext$px(
								$author$project$Page$Home$getMainContainerSize(model).dp)),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							$lucamug$elm_ui_with_context$Element$WithContext$px(
								$author$project$Page$Home$getMainContainerSize(model).bn)),
							$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
							$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
							A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
										$author$project$T2$Internal$Color$bcTransparent(context)),
										$lucamug$elm_ui_with_context$Element$WithContext$width(
										$lucamug$elm_ui_with_context$Element$WithContext$px(
											$author$project$Page$Home$getMainContainerSize(model).dp)),
										$lucamug$elm_ui_with_context$Element$WithContext$height(
										$lucamug$elm_ui_with_context$Element$WithContext$px(
											$author$project$Page$Home$getMainContainerSize(model).bn)),
										$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClosedLoginModal)
									]),
								$lucamug$elm_ui_with_context$Element$WithContext$none))
						]),
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$shrink),
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								$author$project$T2$Internal$Color$bgApplyLoginDialog(context)),
								$lucamug$elm_ui_with_context$Element$WithContext$centerY,
								$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
								$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$id('verification-code-modal'))
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								A2(
									$author$project$T2$Text$paragraphLargeAttrs,
									_List_Nil,
									$author$project$T2$Internal$Color$contentPrimary(context)),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text('Te enviamos un código a ' + (model.N.cl + '. Introdúcelo para llenar tus datos.'))
									])),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$row,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$spacing(4),
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$padding(8)
									]),
								_List_fromArray(
									[
										A4(viewCodeTextField, $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputOne, $author$project$Page$Home$PassThrough, model.n.aZ, 'magic-link-input-1'),
										A4(viewCodeTextField, $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputTwo, $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputTwo, model.n.a0, 'magic-link-input-2'),
										A4(viewCodeTextField, $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputThree, $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputThree, model.n.a$, 'magic-link-input-3'),
										A4(viewCodeTextField, $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputFour, $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputFour, model.n.aY, 'magic-link-input-4'),
										A4(viewCodeTextField, $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputFive, $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputFive, model.n.aX, 'magic-link-input-5'),
										A4(viewCodeTextField, $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputSix, $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputSix, model.n.a_, 'magic-link-input-6'),
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
												$author$project$T2$Internal$Color$bgApplyLoginDialog(context)),
												$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
												$author$project$T2$Internal$Color$bgApplyLoginDialog(context))
											]),
										$lucamug$elm_ui_with_context$Element$WithContext$text('.'))
									])),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$row,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$spaceEvenly,
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$alignLeft
									]),
								_List_fromArray(
									[
										A3(
										$author$project$T2$Button$buttonTextEnabledMedium,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Attributes$id('cancel-login-with-verification-code-button'))
											]),
										$author$project$Page$Home$MsgUserClosedLoginModal,
										'Ahora no')
									]))
							])));
			} else {
				return $lucamug$elm_ui_with_context$Element$WithContext$none;
			}
		});
};
var $author$project$Page$Home$MsgShowSendToFriendModal = {$: 61};
var $author$project$Page$Home$MsgUserPressedSaveJobAd = function (a) {
	return {$: 110, a: a};
};
var $author$project$T2$ListItem$linkListItemOneLineEnabledMedium = F2(
	function (attrs, _v0) {
		var url = _v0.R;
		var label = _v0.u;
		return A9(
			$author$project$T2$Internal$ListItem$renderListItem,
			attrs,
			0,
			0,
			1,
			$author$project$T2$Internal$ListItem$LinkForCurrentPage(url),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			label,
			$elm$core$Maybe$Nothing);
	});
var $author$project$T2$ListItem$listItemOneLineEnabledMedium = F2(
	function (attrs, label) {
		return A9($author$project$T2$Internal$ListItem$renderListItem, attrs, 0, 0, 1, $author$project$T2$Internal$ListItem$Ignore, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, label, $elm$core$Maybe$Nothing);
	});
var $author$project$Page$Home$viewMoreOptions = F2(
	function (model, position) {
		return model.bv ? A2(
			$author$project$T2$Internal$Menu$renderMenu,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$moveLeft(210),
					$lucamug$elm_ui_with_context$Element$WithContext$moveDown(20),
					$lucamug$elm_ui_with_context$Element$WithContext$width(
					A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 235, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					A2($elm$html$Html$Attributes$style, 'z-index', '1000')),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					A2($elm$html$Html$Attributes$attribute, 'role', 'listbox'))
				]),
			_List_fromArray(
				[
					model.aH ? _List_fromArray(
					[
						A2(
						$author$project$T2$ListItem$linkListItemOneLineEnabledMedium,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, 'role', 'option')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, $author$project$Page$Home$referenceDataName, 'job-ad-actions')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$tabindex(-1)),
								$lucamug$elm_ui_with_context$Element$WithContext$focused(_List_Nil)
							]),
						{u: 'Ver todas las vacantes de empleo', R: '/empleos'})
					]) : _List_fromArray(
					[
						A2(
						$author$project$T2$ListItem$listItemOneLineEnabledMedium,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, 'role', 'option')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, $author$project$Page$Home$referenceDataName, 'job-ad-actions')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$tabindex(-1)),
								$lucamug$elm_ui_with_context$Element$WithContext$focused(_List_Nil),
								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
								$author$project$Page$Home$MsgUserPressedSaveJobAd(position))
							]),
						'Añadir a favoritos'),
						A2(
						$author$project$T2$ListItem$listItemOneLineEnabledMedium,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, 'role', 'option')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$class('send-to-friend-option')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, $author$project$Page$Home$referenceDataName, 'job-ad-actions')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$tabindex(-1)),
								$lucamug$elm_ui_with_context$Element$WithContext$focused(_List_Nil),
								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgShowSendToFriendModal)
							]),
						'Enviar a un amigo'),
						A2(
						$author$project$T2$ListItem$linkListItemOneLineEnabledMedium,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, 'role', 'option')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, $author$project$Page$Home$referenceDataName, 'job-ad-actions')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$tabindex(-1)),
								$lucamug$elm_ui_with_context$Element$WithContext$focused(_List_Nil)
							]),
						{u: 'Ver todas las vacantes de empleo', R: '/empleos'})
					])
				])) : $lucamug$elm_ui_with_context$Element$WithContext$none;
	});
var $author$project$T2$Internal$TextInput$InputEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Home$MsgBotChangedSendToFriendSpamControl = function (a) {
	return {$: 67, a: a};
};
var $author$project$Page$Home$MsgHideSendToFriendModal = {$: 62};
var $author$project$Page$Home$MsgUserChangedSendToFriendEmail = function (a) {
	return {$: 63, a: a};
};
var $author$project$Page$Home$MsgUserChangedSendToFriendEmailFriend = function (a) {
	return {$: 65, a: a};
};
var $author$project$Page$Home$MsgUserChangedSendToFriendName = function (a) {
	return {$: 64, a: a};
};
var $author$project$Page$Home$MsgUserChangedSendToFriendNameFriend = function (a) {
	return {$: 66, a: a};
};
var $author$project$Page$Home$MsgUserSentSendToFriendForm = {$: 68};
var $author$project$T2$Internal$Color$bcModalCloseIcon = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$bgHeaderModal = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$bgModal = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Button$buttonTextLoadingMedium = F2(
	function (attrs, label) {
		return A9($author$project$T2$Internal$Button$renderButton, attrs, 2, 2, 1, $author$project$T2$Internal$Button$Ignore, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, label, label);
	});
var $author$project$T2$Internal$Color$fgModal = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Icon$internalBack = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#back');
	});
var $author$project$Page$Home$TkSnackbarMessageSuccess = 1;
var $author$project$Page$Home$viewSnackBarSuccess = function (maybeErrorMessage) {
	if (!maybeErrorMessage.$) {
		var errorMessage = maybeErrorMessage.a;
		return A2($author$project$Page$Home$viewSnackBarMessage, errorMessage, 1);
	} else {
		return $lucamug$elm_ui_with_context$Element$WithContext$none;
	}
};
var $author$project$Page$Home$viewSendToFriendModal = function (model) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			return model.bX ? A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
					]),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$row,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								$lucamug$elm_ui_with_context$Element$WithContext$px(64)),
								$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
								$author$project$T2$Elevation$elevation1,
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								$author$project$T2$Internal$Color$bgHeaderModal(context)),
								$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
								{bi: $author$project$T2$Internal$Spacing$spacing12, br: $author$project$T2$Internal$Spacing$spacing8, bt: $author$project$T2$Internal$Spacing$spacing16, by: $author$project$T2$Internal$Spacing$spacing12}),
								$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing24)
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$centerY,
										$lucamug$elm_ui_with_context$Element$WithContext$pointer,
										$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
										$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgHideSendToFriendModal)
									]),
								A4(
									$author$project$T2$Internal$Icon$internalBack,
									1,
									$author$project$T2$Internal$Color$bcModalCloseIcon(context),
									$elm$core$Maybe$Nothing,
									'Atrás')),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								_Utils_ap(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing16),
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									A2(
										$author$project$T2$Text$headingSmallXAttrs,
										_List_Nil,
										$author$project$T2$Internal$Color$fgModal(context))),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text('Enviar por email')
									])),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[$lucamug$elm_ui_with_context$Element$WithContext$alignRight]),
								model.r.E ? A2(
									$author$project$T2$Button$buttonTextLoadingMedium,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$class('submit-form'))
										]),
									'Enviando') : A3(
									$author$project$T2$Button$buttonTextEnabledMedium,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$class('submit-form'))
										]),
									$author$project$Page$Home$MsgUserSentSendToFriendForm,
									'Enviar'))
							])),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								$lucamug$elm_ui_with_context$Element$WithContext$px(
									$author$project$Page$Home$getMainContainerSize(model).bn - model.bc)),
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								$author$project$T2$Internal$Color$bgModal(context)),
								$lucamug$elm_ui_with_context$Element$WithContext$padding(28),
								$lucamug$elm_ui_with_context$Element$WithContext$spacing(20),
								$lucamug$elm_ui_with_context$Element$WithContext$inFront(
								$author$project$Page$Home$viewSnackBarError(model.r.Q)),
								$lucamug$elm_ui_with_context$Element$WithContext$inFront(
								$author$project$Page$Home$viewSnackBarSuccess(
									model.r.cD ? $elm$core$Maybe$Just('Se envió correctamente.') : $elm$core$Maybe$Nothing))
							]),
						_List_fromArray(
							[
								A7(
								(!_Utils_eq(model.r.aC.bI, $elm$core$Maybe$Nothing)) ? $author$project$T2$TextInput$textInputOutlinedErrorMedium : $author$project$T2$TextInput$textInputOutlinedEnabledMedium,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
									]),
								$author$project$Page$Home$MsgUserChangedSendToFriendName,
								$elm$core$Maybe$Just('Tu nombre *'),
								$elm$core$Maybe$Nothing,
								model.r.aC.m,
								model.r.aC.bI,
								$author$project$T2$Internal$TextInput$InputText(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$id('name'))
										]))),
								A7(
								(!_Utils_eq(model.r.cl.bI, $elm$core$Maybe$Nothing)) ? $author$project$T2$TextInput$textInputOutlinedErrorMedium : $author$project$T2$TextInput$textInputOutlinedEnabledMedium,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
									]),
								$author$project$Page$Home$MsgUserChangedSendToFriendEmail,
								$elm$core$Maybe$Just('Tu email *'),
								$elm$core$Maybe$Nothing,
								model.r.cl.m,
								model.r.cl.bI,
								$author$project$T2$Internal$TextInput$InputEmail(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$id('my-email'))
										]))),
								A7(
								(!_Utils_eq(model.r.aw.bI, $elm$core$Maybe$Nothing)) ? $author$project$T2$TextInput$textInputOutlinedErrorMedium : $author$project$T2$TextInput$textInputOutlinedEnabledMedium,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
									]),
								$author$project$Page$Home$MsgUserChangedSendToFriendNameFriend,
								$elm$core$Maybe$Just('Nombre de tu amigo *'),
								$elm$core$Maybe$Nothing,
								model.r.aw.m,
								model.r.aw.bI,
								$author$project$T2$Internal$TextInput$InputText(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$id('friendName'))
										]))),
								A7(
								(!_Utils_eq(model.r.av.bI, $elm$core$Maybe$Nothing)) ? $author$project$T2$TextInput$textInputOutlinedErrorMedium : $author$project$T2$TextInput$textInputOutlinedEnabledMedium,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
									]),
								$author$project$Page$Home$MsgUserChangedSendToFriendEmailFriend,
								$elm$core$Maybe$Just('Email de tu amigo *'),
								$elm$core$Maybe$Nothing,
								model.r.av.m,
								model.r.av.bI,
								$author$project$T2$Internal$TextInput$InputEmail(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$id('friendEmail'))
										]))),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										A2($elm$html$Html$Attributes$style, 'display', 'none'))
									]),
								A7(
									$author$project$T2$TextInput$textInputOutlinedEnabledMedium,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									$author$project$Page$Home$MsgBotChangedSendToFriendSpamControl,
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Nothing,
									model.r.cC,
									$elm$core$Maybe$Nothing,
									$author$project$T2$Internal$TextInput$InputText(_List_Nil)))
							]))
					])) : $lucamug$elm_ui_with_context$Element$WithContext$none;
		});
};
var $author$project$Page$Home$MsgHideSidebar = {$: 58};
var $author$project$Page$Home$MsgUserClickJobAdLink = function (a) {
	return {$: 86, a: a};
};
var $author$project$T2$Link$actionLinkContentInverseBoldEnabledMediumWithLeftIcon = F4(
	function (attrs, icon, text, onClickMsg) {
		return $author$project$T2$Internal$Link$renderLink(attrs)(0)(2)(1)(
			$elm$core$Maybe$Just(icon))(text)('')($elm$core$Maybe$Nothing)(
			$author$project$T2$Internal$Link$OnClick(onClickMsg))(3);
	});
var $author$project$T2$Internal$Icon$internalExternalLink = F4(
	function (size, mainColor, _v0, title) {
		return A4(
			$author$project$T2$Internal$Icon$internalRenderIconSvg,
			size,
			title,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$style(
					'--icon-stroke: ' + ($author$project$T2$Internal$Color$Extra$colorToHex(mainColor) + '; '))
				]),
			'#externallink');
	});
var $author$project$T2$Icon$externalLink = $author$project$T2$Internal$Icon$internalExternalLink;
var $mdgriffith$elm_ui$Element$Border$innerShadow = function (almostShade) {
	var shade = {f6: almostShade.f6, gy: almostShade.gy, eg: true, iW: almostShade.iW, jW: almostShade.jW};
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$shadows,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			$mdgriffith$elm_ui$Internal$Model$boxShadowClass(shade),
			'box-shadow',
			$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(shade)));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$innerShadow = function (almostShade) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr(
		$mdgriffith$elm_ui$Element$Border$innerShadow(almostShade));
};
var $lucamug$elm_ui_with_context$Element$WithContext$rgba = $mdgriffith$elm_ui$Element$rgba;
var $author$project$T2$Internal$Tag$Default = 0;
var $author$project$T2$Internal$Tag$Enabled = 0;
var $author$project$T2$Internal$Tag$Filled = 0;
var $author$project$T2$Internal$Tag$Small = 0;
var $author$project$T2$Internal$Tag$Disabled = 1;
var $author$project$T2$Internal$Tag$Outlined = 2;
var $author$project$T2$Internal$Tag$Selected = 2;
var $author$project$T2$Internal$Tag$internalRenderIconView = F4(
	function (iconOption, color, size, altText) {
		if (!iconOption.$) {
			var iconRenderer = iconOption.a;
			var iconSize = function () {
				switch (size) {
					case 0:
						return 1;
					case 1:
						return 2;
					default:
						return 4;
				}
			}();
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_Nil,
				A4(iconRenderer, iconSize, color, $elm$core$Maybe$Nothing, altText));
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$none;
		}
	});
var $author$project$T2$Internal$Color$bgTagErrorFilledFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red40;
	}
};
var $author$project$T2$Internal$Color$bgTagErrorOutlinedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red00;
	}
};
var $author$project$T2$Internal$Color$Swatch$red90 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 162, 138);
var $author$project$T2$Internal$Color$bgTagErrorSubtleFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red10;
	}
};
var $author$project$T2$Internal$Color$bgTagFilledFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green95;
	}
};
var $author$project$T2$Internal$Color$bgTagOutlinedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$bgTagSubtleFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green20;
	}
};
var $author$project$T2$Internal$Color$bgTagSuccessFilledFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	}
};
var $author$project$T2$Internal$Color$Swatch$sGreen00 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 23, 10);
var $author$project$T2$Internal$Color$Swatch$sGreen95 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 189, 237, 211);
var $author$project$T2$Internal$Color$bgTagSuccessOutlinedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen00;
	}
};
var $author$project$T2$Internal$Color$Swatch$sGreen90 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 144, 226, 182);
var $author$project$T2$Internal$Color$bgTagSuccessSubtleFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen10;
	}
};
var $author$project$T2$Internal$Color$Swatch$yellow60 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 228, 72);
var $author$project$T2$Internal$Color$bgTagWarningFilledFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow20;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow60;
	}
};
var $author$project$T2$Internal$Color$bgTagWarningOutlinedFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow00;
	}
};
var $author$project$T2$Internal$Color$bgTagWarningSubtleFocused = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow10;
	}
};
var $author$project$T2$Internal$Tag$internalResolveBgFocused = F2(
	function (variant, style) {
		switch (variant) {
			case 0:
				switch (style) {
					case 0:
						return $author$project$T2$Internal$Color$bgTagFilledFocused;
					case 1:
						return $author$project$T2$Internal$Color$bgTagSubtleFocused;
					default:
						return $author$project$T2$Internal$Color$bgTagOutlinedFocused;
				}
			case 1:
				switch (style) {
					case 0:
						return $author$project$T2$Internal$Color$bgTagErrorFilledFocused;
					case 1:
						return $author$project$T2$Internal$Color$bgTagErrorSubtleFocused;
					default:
						return $author$project$T2$Internal$Color$bgTagErrorOutlinedFocused;
				}
			case 2:
				switch (style) {
					case 0:
						return $author$project$T2$Internal$Color$bgTagWarningFilledFocused;
					case 1:
						return $author$project$T2$Internal$Color$bgTagWarningSubtleFocused;
					default:
						return $author$project$T2$Internal$Color$bgTagWarningOutlinedFocused;
				}
			default:
				switch (style) {
					case 0:
						return $author$project$T2$Internal$Color$bgTagSuccessFilledFocused;
					case 1:
						return $author$project$T2$Internal$Color$bgTagSuccessSubtleFocused;
					default:
						return $author$project$T2$Internal$Color$bgTagSuccessOutlinedFocused;
				}
		}
	});
var $author$project$T2$Internal$Color$bcTagErrorOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$bcTagErrorOutlinedSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$bcTagOutlinedDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bcTagOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$bcTagOutlinedSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$bcTagSuccessOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	}
};
var $author$project$T2$Internal$Color$bcTagSuccessOutlinedSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	}
};
var $author$project$T2$Internal$Color$bcTagWarningOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$Color$bcTagWarningOutlinedSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$Tag$internalResolveBorderColor = F3(
	function (variant, state, context) {
		switch (variant) {
			case 0:
				switch (state) {
					case 0:
						return $author$project$T2$Internal$Color$bcTagOutlinedEnabled(context);
					case 2:
						return $author$project$T2$Internal$Color$bcTagOutlinedSelected(context);
					default:
						return $author$project$T2$Internal$Color$bcTagOutlinedDisabled(context);
				}
			case 1:
				switch (state) {
					case 0:
						return $author$project$T2$Internal$Color$bcTagErrorOutlinedEnabled(context);
					case 2:
						return $author$project$T2$Internal$Color$bcTagErrorOutlinedSelected(context);
					default:
						return $author$project$T2$Internal$Color$bcTagOutlinedDisabled(context);
				}
			case 2:
				switch (state) {
					case 0:
						return $author$project$T2$Internal$Color$bcTagWarningOutlinedEnabled(context);
					case 2:
						return $author$project$T2$Internal$Color$bcTagWarningOutlinedSelected(context);
					default:
						return $author$project$T2$Internal$Color$bcTagOutlinedDisabled(context);
				}
			default:
				switch (state) {
					case 0:
						return $author$project$T2$Internal$Color$bcTagSuccessOutlinedEnabled(context);
					case 2:
						return $author$project$T2$Internal$Color$bcTagSuccessOutlinedSelected(context);
					default:
						return $author$project$T2$Internal$Color$bcTagOutlinedDisabled(context);
				}
		}
	});
var $author$project$T2$Internal$Color$bgTagDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray30;
	}
};
var $author$project$T2$Internal$Color$fgTagDisabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$gray60;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$Swatch$green80 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 65, 179, 168);
var $author$project$T2$Internal$Color$bgTagFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green80;
	}
};
var $author$project$T2$Internal$Color$bgTagFilledSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green20;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green99;
	}
};
var $author$project$T2$Internal$Color$bgTagOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgTagOutlinedSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green90;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$bgTagSubtleEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green05;
	}
};
var $author$project$T2$Internal$Color$bgTagSubtleSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green30;
	}
};
var $author$project$T2$Internal$Color$fgTagFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgTagFilledSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgTagOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgTagOutlinedSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTagSubtleEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTagSubtleSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Tag$internalResolveDefaultColors = F2(
	function (style, state) {
		var _v0 = _Utils_Tuple2(style, state);
		switch (_v0.a) {
			case 0:
				switch (_v0.b) {
					case 0:
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagFilledEnabled, $author$project$T2$Internal$Color$bgTagFilledEnabled);
					case 2:
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagFilledSelected, $author$project$T2$Internal$Color$bgTagFilledSelected);
					default:
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagDisabled, $author$project$T2$Internal$Color$bgTagDisabled);
				}
			case 1:
				switch (_v0.b) {
					case 0:
						var _v7 = _v0.a;
						var _v8 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagSubtleEnabled, $author$project$T2$Internal$Color$bgTagSubtleEnabled);
					case 2:
						var _v9 = _v0.a;
						var _v10 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagSubtleSelected, $author$project$T2$Internal$Color$bgTagSubtleSelected);
					default:
						var _v11 = _v0.a;
						var _v12 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagDisabled, $author$project$T2$Internal$Color$bgTagDisabled);
				}
			default:
				switch (_v0.b) {
					case 0:
						var _v13 = _v0.a;
						var _v14 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagOutlinedEnabled, $author$project$T2$Internal$Color$bgTagOutlinedEnabled);
					case 2:
						var _v15 = _v0.a;
						var _v16 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagOutlinedSelected, $author$project$T2$Internal$Color$bgTagOutlinedSelected);
					default:
						var _v17 = _v0.a;
						var _v18 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagDisabled, $author$project$T2$Internal$Color$bgTagDisabled);
				}
		}
	});
var $author$project$T2$Internal$Color$bgTagErrorFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red10;
	}
};
var $author$project$T2$Internal$Color$bgTagErrorFilledSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red05;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red30;
	}
};
var $author$project$T2$Internal$Color$bgTagErrorOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$Swatch$red80 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 124, 91);
var $author$project$T2$Internal$Color$bgTagErrorOutlinedSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red01;
	}
};
var $author$project$T2$Internal$Color$bgTagErrorSubtleEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red01;
	}
};
var $author$project$T2$Internal$Color$bgTagErrorSubtleSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red20;
	}
};
var $author$project$T2$Internal$Color$fgTagErrorFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgTagErrorFilledSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTagErrorOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgTagErrorOutlinedSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgTagErrorSubtleEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red00;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTagErrorSubtleSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red00;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Tag$internalResolveErrorColors = F2(
	function (style, state) {
		var _v0 = _Utils_Tuple2(style, state);
		switch (_v0.a) {
			case 0:
				switch (_v0.b) {
					case 0:
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagErrorFilledEnabled, $author$project$T2$Internal$Color$bgTagErrorFilledEnabled);
					case 2:
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagErrorFilledSelected, $author$project$T2$Internal$Color$bgTagErrorFilledSelected);
					default:
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagDisabled, $author$project$T2$Internal$Color$bgTagDisabled);
				}
			case 1:
				switch (_v0.b) {
					case 0:
						var _v7 = _v0.a;
						var _v8 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagErrorSubtleEnabled, $author$project$T2$Internal$Color$bgTagErrorSubtleEnabled);
					case 2:
						var _v9 = _v0.a;
						var _v10 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagErrorSubtleSelected, $author$project$T2$Internal$Color$bgTagErrorSubtleSelected);
					default:
						var _v11 = _v0.a;
						var _v12 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagDisabled, $author$project$T2$Internal$Color$bgTagDisabled);
				}
			default:
				switch (_v0.b) {
					case 0:
						var _v13 = _v0.a;
						var _v14 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagErrorOutlinedEnabled, $author$project$T2$Internal$Color$bgTagErrorOutlinedEnabled);
					case 2:
						var _v15 = _v0.a;
						var _v16 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagErrorOutlinedSelected, $author$project$T2$Internal$Color$bgTagErrorOutlinedSelected);
					default:
						var _v17 = _v0.a;
						var _v18 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagDisabled, $author$project$T2$Internal$Color$bgTagDisabled);
				}
		}
	});
var $author$project$T2$Internal$Color$Swatch$sGreen20 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 110, 48);
var $author$project$T2$Internal$Color$Swatch$sGreen80 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 87, 215, 153);
var $author$project$T2$Internal$Color$bgTagSuccessFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen20;
	}
};
var $author$project$T2$Internal$Color$bgTagSuccessFilledSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen50;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen60;
	}
};
var $author$project$T2$Internal$Color$bgTagSuccessOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$Swatch$sGreen01 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 31, 13);
var $author$project$T2$Internal$Color$bgTagSuccessOutlinedSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen01;
	}
};
var $author$project$T2$Internal$Color$bgTagSuccessSubtleEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen01;
	}
};
var $author$project$T2$Internal$Color$bgTagSuccessSubtleSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen20;
	}
};
var $author$project$T2$Internal$Color$Swatch$sGreen100 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 255, 255);
var $author$project$T2$Internal$Color$fgTagSuccessFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen100;
	}
};
var $author$project$T2$Internal$Color$fgTagSuccessFilledSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray00;
	}
};
var $author$project$T2$Internal$Color$fgTagSuccessOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgTagSuccessOutlinedSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgTagSuccessSubtleEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTagSuccessSubtleSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Tag$internalResolveSuccessColors = F2(
	function (style, state) {
		var _v0 = _Utils_Tuple2(style, state);
		switch (_v0.a) {
			case 0:
				switch (_v0.b) {
					case 0:
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagSuccessFilledEnabled, $author$project$T2$Internal$Color$bgTagSuccessFilledEnabled);
					case 2:
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagSuccessFilledSelected, $author$project$T2$Internal$Color$bgTagSuccessFilledSelected);
					default:
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagDisabled, $author$project$T2$Internal$Color$bgTagDisabled);
				}
			case 1:
				switch (_v0.b) {
					case 0:
						var _v7 = _v0.a;
						var _v8 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagSuccessSubtleEnabled, $author$project$T2$Internal$Color$bgTagSuccessSubtleEnabled);
					case 2:
						var _v9 = _v0.a;
						var _v10 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagSuccessSubtleSelected, $author$project$T2$Internal$Color$bgTagSuccessSubtleSelected);
					default:
						var _v11 = _v0.a;
						var _v12 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagDisabled, $author$project$T2$Internal$Color$bgTagDisabled);
				}
			default:
				switch (_v0.b) {
					case 0:
						var _v13 = _v0.a;
						var _v14 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagSuccessOutlinedEnabled, $author$project$T2$Internal$Color$bgTagSuccessOutlinedEnabled);
					case 2:
						var _v15 = _v0.a;
						var _v16 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagSuccessOutlinedSelected, $author$project$T2$Internal$Color$bgTagSuccessOutlinedSelected);
					default:
						var _v17 = _v0.a;
						var _v18 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagDisabled, $author$project$T2$Internal$Color$bgTagDisabled);
				}
		}
	});
var $author$project$T2$Internal$Color$bgTagWarningFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow40;
	}
};
var $author$project$T2$Internal$Color$Swatch$yellow70 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 234, 98);
var $author$project$T2$Internal$Color$bgTagWarningFilledSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow70;
	}
};
var $author$project$T2$Internal$Color$bgTagWarningOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgTagWarningOutlinedSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow80;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow00;
	}
};
var $author$project$T2$Internal$Color$bgTagWarningSubtleEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow10;
	}
};
var $author$project$T2$Internal$Color$bgTagWarningSubtleSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow70;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow30;
	}
};
var $author$project$T2$Internal$Color$fgTagWarningFilledEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green00;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgTagWarningFilledSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green00;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgTagWarningOutlinedEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgTagWarningOutlinedSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$white;
	}
};
var $author$project$T2$Internal$Color$fgTagWarningSubtleEnabled = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgTagWarningSubtleSelected = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Tag$internalResolveWarningColors = F2(
	function (style, state) {
		var _v0 = _Utils_Tuple2(style, state);
		switch (_v0.a) {
			case 0:
				switch (_v0.b) {
					case 0:
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagWarningFilledEnabled, $author$project$T2$Internal$Color$bgTagWarningFilledEnabled);
					case 2:
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagWarningFilledSelected, $author$project$T2$Internal$Color$bgTagWarningFilledSelected);
					default:
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagDisabled, $author$project$T2$Internal$Color$bgTagDisabled);
				}
			case 1:
				switch (_v0.b) {
					case 0:
						var _v7 = _v0.a;
						var _v8 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagWarningSubtleEnabled, $author$project$T2$Internal$Color$bgTagWarningSubtleEnabled);
					case 2:
						var _v9 = _v0.a;
						var _v10 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagWarningSubtleSelected, $author$project$T2$Internal$Color$bgTagWarningSubtleSelected);
					default:
						var _v11 = _v0.a;
						var _v12 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagDisabled, $author$project$T2$Internal$Color$bgTagDisabled);
				}
			default:
				switch (_v0.b) {
					case 0:
						var _v13 = _v0.a;
						var _v14 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagWarningOutlinedEnabled, $author$project$T2$Internal$Color$bgTagWarningOutlinedEnabled);
					case 2:
						var _v15 = _v0.a;
						var _v16 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagWarningOutlinedSelected, $author$project$T2$Internal$Color$bgTagWarningOutlinedSelected);
					default:
						var _v17 = _v0.a;
						var _v18 = _v0.b;
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagDisabled, $author$project$T2$Internal$Color$bgTagDisabled);
				}
		}
	});
var $author$project$T2$Internal$Tag$internalResolveColors = F3(
	function (variant, style, state) {
		if (state === 1) {
			return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagDisabled, $author$project$T2$Internal$Color$bgTagDisabled);
		} else {
			switch (variant) {
				case 0:
					return A2($author$project$T2$Internal$Tag$internalResolveDefaultColors, style, state);
				case 1:
					return A2($author$project$T2$Internal$Tag$internalResolveErrorColors, style, state);
				case 2:
					return A2($author$project$T2$Internal$Tag$internalResolveWarningColors, style, state);
				default:
					return A2($author$project$T2$Internal$Tag$internalResolveSuccessColors, style, state);
			}
		}
	});
var $author$project$T2$Internal$Color$bgTagErrorFilledHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red20;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red30;
	}
};
var $author$project$T2$Internal$Color$bgTagErrorOutlinedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgTagErrorSubtleHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$red05;
	}
};
var $author$project$T2$Internal$Color$bgTagFilledHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green40;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green90;
	}
};
var $author$project$T2$Internal$Color$bgTagOutlinedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgTagSubtleHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green10;
	}
};
var $author$project$T2$Internal$Color$bgTagSuccessFilledHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen70;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen40;
	}
};
var $author$project$T2$Internal$Color$bgTagSuccessOutlinedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$Swatch$sGreen05 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 0, 43, 19);
var $author$project$T2$Internal$Color$bgTagSuccessSubtleHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$sGreen95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$sGreen05;
	}
};
var $author$project$T2$Internal$Color$Swatch$yellow50 = A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 216, 74);
var $author$project$T2$Internal$Color$bgTagWarningFilledHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow50;
	}
};
var $author$project$T2$Internal$Color$bgTagWarningOutlinedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow99;
	} else {
		return $author$project$T2$Internal$Color$Swatch$transparent;
	}
};
var $author$project$T2$Internal$Color$bgTagWarningSubtleHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$yellow95;
	} else {
		return $author$project$T2$Internal$Color$Swatch$yellow05;
	}
};
var $author$project$T2$Internal$Color$fgTagErrorFilledHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgTagErrorOutlinedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgTagErrorSubtleHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$red00;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTagFilledHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$white;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgTagOutlinedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTagSubtleHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green30;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTagSuccessFilledHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgTagSuccessOutlinedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgTagSuccessSubtleHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray99;
	}
};
var $author$project$T2$Internal$Color$fgTagWarningFilledHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green00;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Color$fgTagWarningOutlinedHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$gray80;
	}
};
var $author$project$T2$Internal$Color$fgTagWarningSubtleHovered = function (context) {
	var _v0 = context.cF;
	if (!_v0) {
		return $author$project$T2$Internal$Color$Swatch$green10;
	} else {
		return $author$project$T2$Internal$Color$Swatch$green00;
	}
};
var $author$project$T2$Internal$Tag$internalResolveHoveredColors = F2(
	function (variant, style) {
		switch (variant) {
			case 0:
				switch (style) {
					case 0:
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagFilledHovered, $author$project$T2$Internal$Color$bgTagFilledHovered);
					case 1:
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagSubtleHovered, $author$project$T2$Internal$Color$bgTagSubtleHovered);
					default:
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagOutlinedHovered, $author$project$T2$Internal$Color$bgTagOutlinedHovered);
				}
			case 1:
				switch (style) {
					case 0:
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagErrorFilledHovered, $author$project$T2$Internal$Color$bgTagErrorFilledHovered);
					case 1:
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagErrorSubtleHovered, $author$project$T2$Internal$Color$bgTagErrorSubtleHovered);
					default:
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagErrorOutlinedHovered, $author$project$T2$Internal$Color$bgTagErrorOutlinedHovered);
				}
			case 2:
				switch (style) {
					case 0:
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagWarningFilledHovered, $author$project$T2$Internal$Color$bgTagWarningFilledHovered);
					case 1:
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagWarningSubtleHovered, $author$project$T2$Internal$Color$bgTagWarningSubtleHovered);
					default:
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagWarningOutlinedHovered, $author$project$T2$Internal$Color$bgTagWarningOutlinedHovered);
				}
			default:
				switch (style) {
					case 0:
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagSuccessFilledHovered, $author$project$T2$Internal$Color$bgTagSuccessFilledHovered);
					case 1:
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagSuccessSubtleHovered, $author$project$T2$Internal$Color$bgTagSuccessSubtleHovered);
					default:
						return _Utils_Tuple2($author$project$T2$Internal$Color$fgTagSuccessOutlinedHovered, $author$project$T2$Internal$Color$bgTagSuccessOutlinedHovered);
				}
		}
	});
var $author$project$T2$Internal$Tag$renderTag = F9(
	function (attrs, style, state, size, variant, leftIconMaybe, rightIconMaybe, label, altText) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var tagPaddingRight = function () {
					switch (size) {
						case 0:
							return $author$project$T2$Internal$Spacing$spacing12;
						case 1:
							return $author$project$T2$Internal$Spacing$spacing16;
						default:
							return $author$project$T2$Internal$Spacing$spacing20;
					}
				}();
				var tagPaddingLeft = function () {
					switch (size) {
						case 0:
							return $author$project$T2$Internal$Spacing$spacing12;
						case 1:
							return $author$project$T2$Internal$Spacing$spacing16;
						default:
							return $author$project$T2$Internal$Spacing$spacing20;
					}
				}();
				var paddingAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
						{bi: 0, br: tagPaddingLeft, bt: tagPaddingRight, by: 0})
					]);
				var cursorAttrs = (state === 1) ? _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$class('tt-cursor-not-allowed'))
					]) : _List_fromArray(
					[$lucamug$elm_ui_with_context$Element$WithContext$pointer]);
				var borderRadius = 16;
				var borderAttrs = (style === 2) ? ((state === 1) ? _List_Nil : _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Border$solid,
						$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
						A3($author$project$T2$Internal$Tag$internalResolveBorderColor, variant, state, context))
					])) : _List_Nil;
				var bgFocused = A2($author$project$T2$Internal$Tag$internalResolveBgFocused, variant, style);
				var bgFocusedAttrs = ((state === 1) || (state === 2)) ? _List_Nil : _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$focused(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								bgFocused(context))
							]))
					]);
				var ariaAttrs = (state === 1) ? _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true'))
					]) : _List_fromArray(
					[$lucamug$elm_ui_with_context$Element$WithContext$pointer]);
				var tagAttrs = function () {
					var buttonHeight = function () {
						switch (size) {
							case 0:
								return $lucamug$elm_ui_with_context$Element$WithContext$px(32);
							case 1:
								return $lucamug$elm_ui_with_context$Element$WithContext$px(40);
							default:
								return $lucamug$elm_ui_with_context$Element$WithContext$px(48);
						}
					}();
					return _Utils_ap(
						attrs,
						A2(
							$elm$core$List$cons,
							$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(borderRadius),
							_Utils_ap(
								cursorAttrs,
								_Utils_ap(
									ariaAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$height(buttonHeight),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$class('tt-element-hover-transition'))
										])))));
				}();
				var _v0 = A2($author$project$T2$Internal$Tag$internalResolveHoveredColors, variant, style);
				var fgHovered = _v0.a;
				var bgHovered = _v0.b;
				var bgHoveredAttrs = ((state === 1) || (state === 2)) ? _List_Nil : _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
								bgHovered(context))
							]))
					]);
				var _v1 = A3($author$project$T2$Internal$Tag$internalResolveColors, variant, style, state);
				var fgColor = _v1.a;
				var bgColor = _v1.b;
				var bgColorAttrs = _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						bgColor(context))
					]);
				var labelView = function () {
					var labelPaddingX = $author$project$T2$Internal$Spacing$spacing8;
					var fontColorHoveredAttrs = ((state === 1) || (state === 2)) ? _List_Nil : _List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
									fgHovered(context))
								]))
						]);
					var fontAttrs = function () {
						switch (size) {
							case 0:
								return A2(
									$author$project$T2$Text$labelSmallAttrs,
									fontColorHoveredAttrs,
									fgColor(context));
							case 1:
								return A2(
									$author$project$T2$Text$labelMediumAttrs,
									fontColorHoveredAttrs,
									fgColor(context));
							default:
								return A2(
									$author$project$T2$Text$labelLargeAttrs,
									fontColorHoveredAttrs,
									fgColor(context));
						}
					}();
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_Utils_ap(
							_List_fromArray(
								[
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, labelPaddingX, 0),
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							fontAttrs),
						$lucamug$elm_ui_with_context$Element$WithContext$text(label));
				}();
				var leftIconView = A4(
					$author$project$T2$Internal$Tag$internalRenderIconView,
					leftIconMaybe,
					fgColor(context),
					size,
					altText);
				var rightIconView = A4(
					$author$project$T2$Internal$Tag$internalRenderIconView,
					rightIconMaybe,
					fgColor(context),
					size,
					altText);
				var tagView = A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_Utils_ap(
						tagAttrs,
						_Utils_ap(
							borderAttrs,
							_Utils_ap(
								paddingAttrs,
								_Utils_ap(
									bgColorAttrs,
									_Utils_ap(bgFocusedAttrs, bgHoveredAttrs))))),
					_List_fromArray(
						[leftIconView, labelView, rightIconView]));
				return tagView;
			});
	});
var $author$project$T2$Tag$tagFilledEnabledDefaultSmall = F2(
	function (attrs, label) {
		return A9($author$project$T2$Internal$Tag$renderTag, attrs, 0, 0, 0, 0, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, label, label);
	});
var $author$project$Page$Home$viewSidebarInfo = F2(
	function (model, tkJobAdSummaryDo) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var viewUploadCvInfo = _List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						A2(
							$author$project$T2$Text$paragraphMediumBoldAttrs,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$Font$center]),
							$author$project$T2$Internal$Color$contentInversePrimary(context)),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text(
								$elm$core$String$toUpper('Sube tu CV'))
							])),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						A2(
							$author$project$T2$Text$paragraphMediumAttrs,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft]),
							$author$project$T2$Internal$Color$contentInversePrimary(context)),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text('Estás compartiendo tus datos de contacto con empresas para que puedan ofrecerte trabajo si tu perfil se ajusta a sus vacantes disponibles.')
							])),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						A2(
							$author$project$T2$Text$paragraphMediumAttrs,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft]),
							$author$project$T2$Internal$Color$contentInversePrimary(context)),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text('Si tienes alguna duda o comentario puedes ir a '),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$link,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$Font$underline
									]),
								{
									u: A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_List_Nil,
										$lucamug$elm_ui_with_context$Element$WithContext$text('preguntas frecuentes')),
									R: '/preguntas-frecuentes?section=candidatos'
								})
							]))
					]);
				var viewSkillBubble = function (skill) {
					return A2($author$project$T2$Tag$tagFilledEnabledDefaultSmall, _List_Nil, skill);
				};
				var viewJobAdInfo = _List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						A2(
							$author$project$T2$Text$paragraphMediumBoldAttrs,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$Font$center]),
							$author$project$T2$Internal$Color$contentInversePrimary(context)),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text(
								$elm$core$String$toUpper(tkJobAdSummaryDo.jb))
							])),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$Font$center]),
						A4(
							$author$project$T2$Link$actionLinkContentInverseBoldEnabledMediumWithLeftIcon,
							_List_Nil,
							$author$project$T2$Icon$externalLink,
							'ver anuncio completo',
							$author$project$Page$Home$MsgUserClickJobAdLink(tkJobAdSummaryDo.ik))),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						A2(
							$author$project$T2$Text$paragraphMediumAttrs,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$Font$center]),
							$author$project$T2$Internal$Color$contentInversePrimary(context)),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text(tkJobAdSummaryDo.gI + (' - ' + tkJobAdSummaryDo.cs))
							])),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						A2(
							$author$project$T2$Text$paragraphMediumAttrs,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$Font$center]),
							$author$project$T2$Internal$Color$contentInversePrimary(context)),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text(tkJobAdSummaryDo.jJ + (' | ' + tkJobAdSummaryDo.ji))
							])),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$row,
						_List_fromArray(
							[
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, 8),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'justify-content', 'center')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'gap', '8px'))
							]),
						A2($elm$core$List$map, viewSkillBubble, tkJobAdSummaryDo.dk)),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						A2(
							$author$project$T2$Text$paragraphMediumAttrs,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$Font$justify]),
							$author$project$T2$Internal$Color$contentInversePrimary(context)),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text(tkJobAdSummaryDo.g$)
							]))
					]);
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							$lucamug$elm_ui_with_context$Element$WithContext$px(
								$author$project$Page$Home$getMainContainerSize(model).bn)),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
									$lucamug$elm_ui_with_context$Element$WithContext$width(
									$lucamug$elm_ui_with_context$Element$WithContext$px(
										(($author$project$Page$Home$getMainContainerSize(model).dp / 4) | 0) * 3)),
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
									$author$project$T2$Internal$Color$contentSecondary(context)),
									$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
									$author$project$T2$Internal$Color$contentInversePrimary(context)),
									$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(
									model.aH ? 32 : 8)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
											$author$project$T2$Internal$Color$warning(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$Font$center,
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$text(tkJobAdSummaryDo.hF)
										])),
								model.aH ? viewUploadCvInfo : viewJobAdInfo)),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgHideSidebar),
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
									$author$project$T2$Internal$Color$bcTransparent(context)),
									$lucamug$elm_ui_with_context$Element$WithContext$Border$innerShadow(
									{
										f6: 30,
										gy: A4($lucamug$elm_ui_with_context$Element$WithContext$rgba, 0, 0, 0, 0.2),
										iW: _Utils_Tuple2(10, 0),
										jW: 10
									})
								]),
							$lucamug$elm_ui_with_context$Element$WithContext$none)
						]));
			});
	});
var $author$project$T2$Internal$Border$WidthAll = {$: 0};
var $author$project$T2$Border$borderSharpWidthDefault = A3($author$project$T2$Internal$Border$borderStyleAttrs, $author$project$T2$Internal$Border$WidthAll, 5, 0);
var $author$project$Page$Home$viewCandidateNotLoggedInGoogleButton = function (model) {
	return model.p.bW ? A2(
		$lucamug$elm_ui_with_context$Element$WithContext$el,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$centerX,
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'position', 'sticky')),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'top', '0')),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'z-index', '1')),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				$elm$html$Html$Attributes$class('sentry-mask')),
				$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
				{bi: 0, br: 0, bt: 44, by: 0})
			]),
		A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$id('candidate_google_button_container'))
				]),
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$id('candidate_google_button'))
					]),
				$lucamug$elm_ui_with_context$Element$WithContext$none))) : $author$project$Page$Home$viewCandidateNotLoggedInTalentecaButton(model);
};
var $author$project$Page$Home$viewWelcomeQuestion = function (model) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			var viewHeightAttr = $lucamug$elm_ui_with_context$Element$WithContext$height(
				$lucamug$elm_ui_with_context$Element$WithContext$px(
					$author$project$Page$Home$getMainContainerSize(model).bn - model.bc));
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
						$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
						{bi: 16, br: 16, bt: 16, by: 16}),
						viewHeightAttr,
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						$author$project$T2$Internal$Color$bgSecondary(context)),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$id('chatContainer')),
						(!model.G) ? $author$project$T2$Border$borderSharp : $author$project$T2$Border$borderRoundedBottom,
						$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
						A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$centerX,
									$lucamug$elm_ui_with_context$Element$WithContext$centerY,
									$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.2)
								]),
							$author$project$T2$Logo$talentecaLogoHorizontalNormal(
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width(
										A2(
											$lucamug$elm_ui_with_context$Element$WithContext$maximum,
											172,
											A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 172, $lucamug$elm_ui_with_context$Element$WithContext$fill)))
									]))))
					]),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$spacing(24)
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$row,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 0, 0)
									]),
								_List_fromArray(
									[
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										(!model.G) ? _List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$moveLeft(10)
											]) : _List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$moveLeft(0),
												$lucamug$elm_ui_with_context$Element$WithContext$alignLeft
											]),
										$author$project$Page$Home$viewTalentinoIllustration(100)),
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$column,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
												A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 0, 8),
												$lucamug$elm_ui_with_context$Element$WithContext$centerX
											]),
										_List_fromArray(
											[
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$el,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
														$author$project$T2$Internal$Color$bgApplyWelcomeQuestionChatBubble(context)),
														$lucamug$elm_ui_with_context$Element$WithContext$width(
														$lucamug$elm_ui_with_context$Element$WithContext$px(210)),
														A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 8),
														$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
														{aR: 0, aS: 8, bd: 8, be: 8}),
														$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
														A2($elm$html$Html$Attributes$style, 'box-shadow', '0px 3px 1px -2px rgba(0,0,0,0.20), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)'))
													]),
												A2(
													$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
													A2(
														$author$project$T2$Text$paragraphMediumAttrs,
														_List_Nil,
														$author$project$T2$Internal$Color$contentPrimary(context)),
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$text(
															model.aH ? 'Soy Talentino y te ayudaré a subir tu CV en 5 minutos.' : 'Soy Talentino y te ayudaré con este empleo.')
														]))),
												A2(
												$lucamug$elm_ui_with_context$Element$WithContext$el,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
														$author$project$T2$Internal$Color$bgApplyWelcomeQuestionChatBubble(context)),
														$lucamug$elm_ui_with_context$Element$WithContext$width(
														$lucamug$elm_ui_with_context$Element$WithContext$px(210)),
														A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 8),
														$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
														{aR: 0, aS: 8, bd: 8, be: 8}),
														$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
														A2($elm$html$Html$Attributes$style, 'box-shadow', '0px 3px 1px -2px rgba(0,0,0,0.20), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)'))
													]),
												A2(
													$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
													A2(
														$author$project$T2$Text$paragraphMediumAttrs,
														_List_Nil,
														$author$project$T2$Internal$Color$contentPrimary(context)),
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$text('Inicia sesión con Google o escribe tu correo electrónico')
														])))
											]))
									])),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$column,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
										$lucamug$elm_ui_with_context$Element$WithContext$centerX,
										$lucamug$elm_ui_with_context$Element$WithContext$spacing(12),
										A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, 16),
										$lucamug$elm_ui_with_context$Element$WithContext$moveRight(22)
									]),
								_List_fromArray(
									[
										$author$project$Page$Home$viewCandidateNotLoggedInGoogleButton(model),
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
												$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
												{bi: 0, br: 0, bt: 44, by: 0})
											]),
										A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
													$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
													A2(
														$lucamug$elm_ui_with_context$Element$WithContext$el,
														_Utils_ap(
															_List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
																	$lucamug$elm_ui_with_context$Element$WithContext$centerY
																]),
															$author$project$T2$Border$borderSharpWidthDefault),
														$lucamug$elm_ui_with_context$Element$WithContext$none))
												]),
											A2(
												$lucamug$elm_ui_with_context$Element$WithContext$el,
												_List_fromArray(
													[
														A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 0),
														$lucamug$elm_ui_with_context$Element$WithContext$centerX,
														$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
														$author$project$T2$Internal$Color$bgSecondary(context))
													]),
												$lucamug$elm_ui_with_context$Element$WithContext$text('o')))),
										function () {
										var hasError = !_Utils_eq(model.c.l.cl.bI, $elm$core$Maybe$Nothing);
										return A2(
											$lucamug$elm_ui_with_context$Element$WithContext$row,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
													$lucamug$elm_ui_with_context$Element$WithContext$height(
													$lucamug$elm_ui_with_context$Element$WithContext$px(44)),
													$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8)
												]),
											_List_fromArray(
												[
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$el,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
														]),
													A7(
														hasError ? $author$project$T2$TextInput$textInputOutlinedErrorMedium : $author$project$T2$TextInput$textInputOutlinedEnabledMedium,
														_List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$width(
																$lucamug$elm_ui_with_context$Element$WithContext$px(270)),
																$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
																{aR: 4, aS: 25, bd: 4, be: 25})
															]),
														$author$project$Page$Home$MsgUserChangedEmail,
														$elm$core$Maybe$Nothing,
														$elm$core$Maybe$Just('Ingresa tu correo electrónico'),
														model.c.l.cl.cr,
														model.c.l.cl.bI,
														$author$project$T2$Internal$TextInput$InputText(
															_List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Events$onBlur($author$project$Page$Home$MsgUserLeftEmailInput)),
																	$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$id('email')),
																	$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$autocomplete(false)),
																	$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$spellcheck(false)),
																	$author$project$Page$Home$onEnter($author$project$Page$Home$MsgUserSubmittedEmail)
																])))),
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$el,
													_List_fromArray(
														[$lucamug$elm_ui_with_context$Element$WithContext$centerY]),
													A4(
														$author$project$T2$IconButton$iconButtonFilledEnabledMedium,
														_List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																$elm$html$Html$Attributes$class('talapoin-submit-intermedite-step'))
															]),
														$author$project$Page$Home$MsgUserSubmittedEmail,
														$author$project$T2$Icon$send,
														'Enviar'))
												]));
									}()
									]))
							]))
					]));
		});
};
var $author$project$Page$Home$viewElement = function (model) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			var viewLoading = A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						$lucamug$elm_ui_with_context$Element$WithContext$px(
							$author$project$Page$Home$getMainContainerSize(model).bn)),
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						$author$project$T2$Internal$Color$bgSecondary(context)),
						(!model.G) ? $author$project$T2$Border$borderSharp : $author$project$T2$Border$borderRoundedDefault
					]),
				$author$project$T2$LoadingSpinner$sectionLoadingSpinnerMedium('Cargando...'));
			var viewJobAdNotFound = A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						$lucamug$elm_ui_with_context$Element$WithContext$px(
							$author$project$Page$Home$getMainContainerSize(model).bn)),
						$author$project$T2$Background$primary,
						(!model.G) ? $author$project$T2$Border$borderSharp : $author$project$T2$Border$borderRoundedDefault
					]),
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$centerX,
							$lucamug$elm_ui_with_context$Element$WithContext$centerY,
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 30, 40),
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(24)
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$centerX]),
							A4(
								$author$project$T2$Internal$Icon$internalSuitcaseFilled,
								10,
								$author$project$T2$Internal$Color$grayOrLight(context),
								$elm$core$Maybe$Nothing,
								'empleos')),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							A2(
								$author$project$T2$Text$headingMediumAttrs,
								_List_fromArray(
									[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$Font$center]),
								$author$project$T2$Internal$Color$contentPrimary(context)),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text('¡este empleo no se encuentra disponible!')
								])),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							A2(
								$author$project$T2$Text$paragraphLargeAttrs,
								_List_fromArray(
									[
										A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 4, 24)
									]),
								$author$project$T2$Internal$Color$contentPrimary(context)),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text('Sube tu CV para que te escriban las empresas\ncuando se abran nuevos empleos o explora todos los trabajos y postúlate a\nuno nuevo hoy')
								])),
							A3(
							$author$project$T2$Button$buttonOutlinedEnabledSmall,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$pointer]),
							$author$project$Page$Home$MsgUserClickUploadCvButton,
							'Sube tu Cv'),
							A3(
							$author$project$T2$Button$buttonOutlinedEnabledSmall,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$pointer]),
							$author$project$Page$Home$MsgUserClickGoToJobAdSerchPageButton,
							'Ver todos los empleos')
						])));
			var viewInactiveJobAd = A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						$lucamug$elm_ui_with_context$Element$WithContext$px(
							$author$project$Page$Home$getMainContainerSize(model).bn)),
						$author$project$T2$Background$primary,
						(!model.G) ? $author$project$T2$Border$borderSharp : $author$project$T2$Border$borderRoundedDefault
					]),
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$centerX,
							$lucamug$elm_ui_with_context$Element$WithContext$centerY,
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 30, 40),
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(24)
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$centerX]),
							A4(
								$author$project$T2$Internal$Icon$internalSuitcaseFilled,
								10,
								$author$project$T2$Internal$Color$grayOrLight(context),
								$elm$core$Maybe$Nothing,
								'empleos')),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							A2(
								$author$project$T2$Text$headingMediumAttrs,
								_List_fromArray(
									[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$Font$center]),
								$author$project$T2$Internal$Color$contentPrimary(context)),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text('¡este empleo no se encuentra disponible!')
								])),
							A3(
							$author$project$T2$Button$buttonOutlinedEnabledSmall,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$pointer]),
							$author$project$Page$Home$MsgUserClickGoToJobAdSerchPageButton,
							'Buscar empleos')
						])));
			var _v0 = model.em;
			if (!_v0.$) {
				var _v1 = model.bM;
				switch (_v1.$) {
					case 0:
						return A4(
							$author$project$T2$Error$generalSectionError,
							_List_Nil,
							'Algo falló de nuestro lado',
							$elm$core$Maybe$Just('No fue posible iniciar el proceso de postulación automáticamente'),
							$author$project$Page$Home$MsgGetJobAdSummary);
					case 2:
						var httpError = _v1.a;
						if (httpError.$ === 3) {
							var status = httpError.a;
							return ((status >= 500) && (status <= 599)) ? A4(
								$author$project$T2$Error$generalSectionErrorWithLink,
								_List_Nil,
								'Algo falló de nuestro lado',
								$elm$core$Maybe$Just('No fue posible iniciar el proceso de postulación automáticamente'),
								{u: 'REGRESAR AL HOME', R: model.cy}) : viewJobAdNotFound;
						} else {
							return A4(
								$author$project$T2$Error$generalSectionErrorWithLink,
								_List_Nil,
								'Algo falló de nuestro lado',
								$elm$core$Maybe$Just('No fue posible iniciar el proceso de postulación automáticamente'),
								{u: 'REGRESAR AL HOME', R: model.cy});
						}
					case 1:
						return viewLoading;
					default:
						var tkJobAdSummaryDo = _v1.a;
						return tkJobAdSummaryDo.hX ? A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
									$author$project$T2$Internal$Color$bgSecondary(context)),
									$lucamug$elm_ui_with_context$Element$WithContext$inFront(
									model.bY ? A2($author$project$Page$Home$viewSidebarInfo, model, tkJobAdSummaryDo) : $lucamug$elm_ui_with_context$Element$WithContext$none),
									$lucamug$elm_ui_with_context$Element$WithContext$inFront(
									$author$project$Page$Home$viewSendToFriendModal(model)),
									$lucamug$elm_ui_with_context$Element$WithContext$inFront(
									$author$project$Page$Home$viewLoginModal(model)),
									$lucamug$elm_ui_with_context$Element$WithContext$inFront(
									$author$project$Page$Home$viewLoginErrorMessage(model)),
									(!model.G) ? $author$project$T2$Border$borderSharp : $author$project$T2$Border$borderRoundedDefault
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$row,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$height(
											$lucamug$elm_ui_with_context$Element$WithContext$px(64)),
											$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
											$author$project$T2$Elevation$elevation1,
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
											$author$project$T2$Internal$Color$bgApplyTopBar(context)),
											$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
											{bi: $author$project$T2$Internal$Spacing$spacing12, br: $author$project$T2$Internal$Spacing$spacing8, bt: $author$project$T2$Internal$Spacing$spacing16, by: $author$project$T2$Internal$Spacing$spacing12}),
											$lucamug$elm_ui_with_context$Element$WithContext$spaceEvenly,
											(!model.G) ? $author$project$T2$Border$borderSharp : $author$project$T2$Border$borderRoundedTop
										]),
									_List_fromArray(
										[
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$centerY,
													$lucamug$elm_ui_with_context$Element$WithContext$pointer,
													$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
													$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
													$author$project$Page$Home$MsgUserClickedBackIcon(tkJobAdSummaryDo.hq)),
													$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
													$elm$html$Html$Attributes$class('talapoin-back-to-previous-stage'))
												]),
											A4(
												$author$project$T2$Internal$Icon$internalChevronLeft,
												1,
												$author$project$T2$Internal$Color$fgApplyTopBar(context),
												$elm$core$Maybe$Nothing,
												'Atrás')),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$column,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$Font$center,
													$lucamug$elm_ui_with_context$Element$WithContext$spaceEvenly,
													$lucamug$elm_ui_with_context$Element$WithContext$pointer,
													$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgShowSidebar),
													model.G ? $lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill) : $lucamug$elm_ui_with_context$Element$WithContext$width(
													$lucamug$elm_ui_with_context$Element$WithContext$px(model.S.dp - 80)),
													$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
												]),
											_List_fromArray(
												[
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$el,
													A2(
														$author$project$T2$Text$headingSmallXAttrs,
														_List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
																$lucamug$elm_ui_with_context$Element$WithContext$Font$center,
																$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																$elm$html$Html$Attributes$class('truncate-text'))
															]),
														$author$project$T2$Internal$Color$fgApplyTopBar(context)),
													$lucamug$elm_ui_with_context$Element$WithContext$text(tkJobAdSummaryDo.jb)),
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
													A2(
														$author$project$T2$Text$paragraphMediumAttrs,
														_List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$Font$underline,
																$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																$elm$html$Html$Attributes$id('scroll_reference'))
															]),
														$author$project$T2$Internal$Color$fgApplyTopBar(context)),
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$text(
															model.aH ? 'por qué estoy aquí' : 'ver vacante')
														]))
												])),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
													$elm$html$Html$Attributes$tabindex(0)),
													$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
													A2($elm$html$Html$Attributes$attribute, $author$project$Page$Home$referenceDataName, 'job-ad-actions')),
													A2($author$project$Page$Home$onBlurAttribute, 'job-ad-actions', $author$project$Page$Home$MsgHideMenuOptions),
													$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
													$elm$html$Html$Attributes$class('dropdown-menu')),
													$lucamug$elm_ui_with_context$Element$WithContext$pointer,
													$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
													model.bv ? $author$project$Page$Home$MsgHideMenuOptions : $author$project$Page$Home$MsgShowMenuOptions),
													$lucamug$elm_ui_with_context$Element$WithContext$below(
													A2($author$project$Page$Home$viewMoreOptions, model, tkJobAdSummaryDo.jb))
												]),
											A4(
												$author$project$T2$Internal$Icon$internalMoreOptionsFilled,
												3,
												$author$project$T2$Internal$Color$fgApplyTopBar(context),
												$elm$core$Maybe$Nothing,
												'atrás'))
										])),
									function () {
									var _v3 = model.fZ;
									switch (_v3) {
										case 0:
											return $author$project$Page$Home$viewWelcomeQuestion(model);
										case 1:
											return A2($author$project$Page$Home$viewCandidateInfoStage, model, tkJobAdSummaryDo);
										case 2:
											return A2($author$project$Page$Home$viewExternalApplyStage, model, tkJobAdSummaryDo);
										case 3:
											return $author$project$Page$Home$viewFilterQuestionsStage(model);
										case 4:
											return $author$project$Page$Home$viewApplyQuestionsStage(model);
										case 5:
											return $author$project$Page$Home$viewCandidateCvStage(model);
										case 6:
											return A2($author$project$Page$Home$viewCompleteApplyStage, model, tkJobAdSummaryDo);
										default:
											return $lucamug$elm_ui_with_context$Element$WithContext$none;
									}
								}()
								])) : viewInactiveJobAd;
				}
			} else {
				return viewJobAdNotFound;
			}
		});
};
var $author$project$Main$viewHomePage = function (model) {
	return A2(
		$lucamug$elm_ui_with_context$Element$WithContext$map,
		$author$project$Main$MsgHome,
		$author$project$Page$Home$viewElement(model._));
};
var $author$project$Main$viewPageContent = function (model) {
	return A2(
		$lucamug$elm_ui_with_context$Element$WithContext$el,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
				$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
			]),
		function () {
			var _v0 = $author$project$Route$fromUrl(model.R);
			return $author$project$Main$viewHomePage(model);
		}());
};
var $author$project$Main$viewBody = function (model) {
	return $author$project$T2$Util$isMediumScreenOrLarger(model.U.bT) ? A2(
		$lucamug$elm_ui_with_context$Element$WithContext$row,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
				$lucamug$elm_ui_with_context$Element$WithContext$height(
				$lucamug$elm_ui_with_context$Element$WithContext$px(model.S.bn)),
				$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
				$author$project$T2$Internal$Color$bgSecondary(model.U)),
				$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$image,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							$lucamug$elm_ui_with_context$Element$WithContext$px(model.S.bn)),
							$lucamug$elm_ui_with_context$Element$WithContext$centerX,
							$lucamug$elm_ui_with_context$Element$WithContext$centerY
						]),
					{
						g$: 'background-image',
						j2: function () {
							var _v0 = model.U.cF;
							if (!_v0) {
								return model.J.b5 + 'images/defaults/default-job-ad-background-light2.webp';
							} else {
								return model.J.b5 + 'images/defaults/default-job-ad-background-dark.webp';
							}
						}()
					}))
			]),
		_List_fromArray(
			[
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						$lucamug$elm_ui_with_context$Element$WithContext$px(
							$elm$core$Basics$round((model.S.bn - model.bC) * 0.9)))
					]),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width(
								A2(
									$lucamug$elm_ui_with_context$Element$WithContext$minimum,
									320,
									A2($lucamug$elm_ui_with_context$Element$WithContext$maximum, 650, $lucamug$elm_ui_with_context$Element$WithContext$fill))),
								$lucamug$elm_ui_with_context$Element$WithContext$centerY,
								$lucamug$elm_ui_with_context$Element$WithContext$centerX,
								$author$project$T2$Border$borderRoundedDefault,
								$author$project$T2$Elevation$elevation2
							]),
						_List_fromArray(
							[
								$author$project$Main$viewPageContent(model)
							]))
					]))
			])) : A2(
		$lucamug$elm_ui_with_context$Element$WithContext$el,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
				$lucamug$elm_ui_with_context$Element$WithContext$height(
				$lucamug$elm_ui_with_context$Element$WithContext$px(
					(model.S.bn - model.bC) - function () {
						var _v1 = model.bh;
						if (!_v1.$) {
							return 64;
						} else {
							return 0;
						}
					}()))
			]),
		$author$project$Main$viewPageContent(model));
};
var $author$project$T2$Internal$ToastAlertGroup$Center = 2;
var $author$project$T2$Internal$ToastAlertGroup$Right = 0;
var $author$project$T2$Internal$ToastAlertGroup$Left = 1;
var $author$project$T2$Layout$mainLayoutLateralPadding = function (context) {
	var _v0 = context.bT;
	switch (_v0) {
		case 0:
			return $author$project$T2$Internal$Spacing$spacing16;
		case 1:
			return $author$project$T2$Internal$Spacing$spacing36;
		case 2:
			return $author$project$T2$Internal$Spacing$spacing64;
		default:
			return $author$project$T2$Internal$Spacing$spacing64;
	}
};
var $author$project$T2$Internal$ToastAlertGroup$renderToastAlertWidth = $lucamug$elm_ui_with_context$Element$WithContext$withContextAttribute(
	function (context) {
		if (!context.bT) {
			return $lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink);
		} else {
			var minimumWidth = function () {
				var _v1 = context.bT;
				switch (_v1) {
					case 0:
						return 212;
					case 1:
						return 280;
					case 2:
						return 390;
					default:
						return 500;
				}
			}();
			var maximumWidth = function () {
				var _v0 = context.bT;
				switch (_v0) {
					case 0:
						return 282;
					case 1:
						return 348;
					case 2:
						return 444;
					default:
						return 600;
				}
			}();
			return $lucamug$elm_ui_with_context$Element$WithContext$width(
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$maximum,
					maximumWidth,
					A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, minimumWidth, $lucamug$elm_ui_with_context$Element$WithContext$shrink)));
		}
	});
var $author$project$T2$Internal$ToastAlertGroup$renderAlerts = F2(
	function (alertsList, alignment) {
		return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
			function (context) {
				var hasAlerts = !$elm$core$List$isEmpty(alertsList);
				var alignmentAttrs = function () {
					switch (alignment) {
						case 0:
							return _List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$style, 'right', '0')),
									$lucamug$elm_ui_with_context$Element$WithContext$Font$alignRight
								]);
						case 1:
							return _List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$style, 'left', '0')),
									$lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft
								]);
						default:
							return _List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$style, 'left', '0')),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$style, 'right', '0')),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$style, 'margin', 'auto')),
									$lucamug$elm_ui_with_context$Element$WithContext$Font$center
								]);
					}
				}();
				var alertView = function (alert) {
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
							]),
						alert);
				};
				return hasAlerts ? A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_Utils_ap(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'position', 'fixed')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'top',
									$elm$core$String$fromInt($author$project$T2$Internal$Spacing$spacing64) + 'px')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'z-index', '20')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'word-break', 'break-word')),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paddingXY,
								$author$project$T2$Layout$mainLayoutLateralPadding(context),
								$author$project$T2$Internal$Spacing$spacing12),
								$lucamug$elm_ui_with_context$Element$WithContext$spacing($author$project$T2$Internal$Spacing$spacing8),
								$author$project$T2$Internal$ToastAlertGroup$renderToastAlertWidth
							]),
						alignmentAttrs),
					A2($elm$core$List$map, alertView, alertsList)) : $lucamug$elm_ui_with_context$Element$WithContext$none;
			});
	});
var $author$project$T2$ToastAlerts$view = F3(
	function (alignment, toMsg, model) {
		var alertViews = A2(
			$elm$core$List$map,
			function (_v1) {
				var alertId = _v1.a;
				var alert = _v1.b;
				return A3(
					$author$project$T2$Alert$view,
					_List_Nil,
					A2(
						$elm$core$Basics$composeR,
						$author$project$T2$ToastAlerts$AlertMsg(alertId),
						toMsg),
					alert);
			},
			$elm$core$Dict$toList(model.aa));
		var renderGroup = function () {
			switch (alignment) {
				case 1:
					return A2($author$project$T2$Internal$ToastAlertGroup$renderAlerts, alertViews, 1);
				case 2:
					return A2($author$project$T2$Internal$ToastAlertGroup$renderAlerts, alertViews, 2);
				default:
					return A2($author$project$T2$Internal$ToastAlertGroup$renderAlerts, alertViews, 0);
			}
		}();
		return renderGroup;
	});
var $author$project$Main$viewGlobalAlerts = function (model) {
	var position = function () {
		var _v0 = model.U.bT;
		switch (_v0) {
			case 0:
				return 2;
			case 1:
				return 0;
			case 2:
				return 0;
			default:
				return 0;
		}
	}();
	return A3($author$project$T2$ToastAlerts$view, position, $author$project$Main$ToastAlertsMsg, model.aD);
};
var $author$project$Main$view = function (model) {
	var counterForFavoritesNotifications = $elm$core$List$length(model.bx.c0.eO);
	return {
		bF: _List_fromArray(
			[
				A5(
				$author$project$T2$Layout$bodyWithContainer,
				{gd: counterForFavoritesNotifications, J: model.J, hf: 0, hE: !model.U.bT, iI: $author$project$Main$MsgHideAccountInfoDropdown, iJ: $author$project$Main$MsgShowAccountInfoDropdown, iL: $author$project$Main$MsgUserCloseNavigationDrawer, iM: $author$project$Main$MsgUserPressedHideTopBarAccountBtn, iN: $author$project$Main$MsgUserPressedMenuButtonMobile, iO: $author$project$Main$MsgUserPressedToggleTheme, iP: $author$project$Main$MsgUserPressedTopBarAccountBtn, iQ: $author$project$Main$MsgUserPressedTopBarMobileMenuBtn, aI: model.aI, iU: $elm$core$Maybe$Nothing, bZ: model.bZ, at: model.at, aO: model.aO, R: model.R},
				model.U,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$inFront(
						$author$project$Main$viewGlobalAlerts(model))
					]),
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var message = _v0.a;
						var status = _v0.b;
						return _Utils_Tuple3(message, status, $author$project$Main$MsgUserPressedDismissAlertButton);
					},
					model.bh),
				$author$project$Main$viewBody(model))
			]),
		b0: 'Postularse | Talenteca · Bolsa de empleo para todo México'
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{hQ: $author$project$Main$init, i_: $author$project$Main$MsgUrlChanged, i$: $author$project$Main$MsgUrlRequested, ka: $author$project$Main$subscriptions, kI: $author$project$Main$update, kL: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (windowSize) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (versionedAssetsUrl) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (tonkeanBaseUrl) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (themeString) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (serverInfoLabelMaybe) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (recruiterPrivateHomeUrl) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (recruiterLoggedInInfo) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (marmosetAssetsBaseUrl) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (marmosetApiBaseUrl) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (isWebShareSupported) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (isProductionTestServer) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (isProductionRealServer) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (isProductionFakeServer) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (isProduction) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (isDevelopment) {
																															return A2(
																																$elm$json$Json$Decode$andThen,
																																function (enableNewBrandingThemes) {
																																	return A2(
																																		$elm$json$Json$Decode$andThen,
																																		function (countryCode) {
																																			return A2(
																																				$elm$json$Json$Decode$andThen,
																																				function (candidatePrivateHomeUrl) {
																																					return A2(
																																						$elm$json$Json$Decode$andThen,
																																						function (candidateLoggedInInfo) {
																																							return $elm$json$Json$Decode$succeed(
																																								{cQ: candidateLoggedInInfo, gm: candidatePrivateHomeUrl, gT: countryCode, g3: enableNewBrandingThemes, h1: isDevelopment, h9: isProduction, ia: isProductionFakeServer, ib: isProductionRealServer, ic: isProductionTestServer, ii: isWebShareSupported, bO: marmosetApiBaseUrl, iA: marmosetAssetsBaseUrl, eP: recruiterLoggedInInfo, cy: recruiterPrivateHomeUrl, jT: serverInfoLabelMaybe, fg: themeString, kB: tonkeanBaseUrl, b5: versionedAssetsUrl, S: windowSize});
																																						},
																																						A2(
																																							$elm$json$Json$Decode$field,
																																							'candidateLoggedInInfo',
																																							A2(
																																								$elm$json$Json$Decode$andThen,
																																								function (candidateLoggedInNameMaybe) {
																																									return A2(
																																										$elm$json$Json$Decode$andThen,
																																										function (candidateLoggedInEmailMaybe) {
																																											return A2(
																																												$elm$json$Json$Decode$andThen,
																																												function (candidateIsLoggedIn) {
																																													return A2(
																																														$elm$json$Json$Decode$andThen,
																																														function (candidateCloseSessionUrl) {
																																															return $elm$json$Json$Decode$succeed(
																																																{gc: candidateCloseSessionUrl, dF: candidateIsLoggedIn, gj: candidateLoggedInEmailMaybe, gk: candidateLoggedInNameMaybe});
																																														},
																																														A2($elm$json$Json$Decode$field, 'candidateCloseSessionUrl', $elm$json$Json$Decode$string));
																																												},
																																												A2($elm$json$Json$Decode$field, 'candidateIsLoggedIn', $elm$json$Json$Decode$bool));
																																										},
																																										A2(
																																											$elm$json$Json$Decode$field,
																																											'candidateLoggedInEmailMaybe',
																																											$elm$json$Json$Decode$oneOf(
																																												_List_fromArray(
																																													[
																																														$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																														A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																																													]))));
																																								},
																																								A2(
																																									$elm$json$Json$Decode$field,
																																									'candidateLoggedInNameMaybe',
																																									$elm$json$Json$Decode$oneOf(
																																										_List_fromArray(
																																											[
																																												$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																																											]))))));
																																				},
																																				A2($elm$json$Json$Decode$field, 'candidatePrivateHomeUrl', $elm$json$Json$Decode$string));
																																		},
																																		A2($elm$json$Json$Decode$field, 'countryCode', $elm$json$Json$Decode$string));
																																},
																																A2($elm$json$Json$Decode$field, 'enableNewBrandingThemes', $elm$json$Json$Decode$bool));
																														},
																														A2($elm$json$Json$Decode$field, 'isDevelopment', $elm$json$Json$Decode$bool));
																												},
																												A2($elm$json$Json$Decode$field, 'isProduction', $elm$json$Json$Decode$bool));
																										},
																										A2($elm$json$Json$Decode$field, 'isProductionFakeServer', $elm$json$Json$Decode$bool));
																								},
																								A2($elm$json$Json$Decode$field, 'isProductionRealServer', $elm$json$Json$Decode$bool));
																						},
																						A2($elm$json$Json$Decode$field, 'isProductionTestServer', $elm$json$Json$Decode$bool));
																				},
																				A2($elm$json$Json$Decode$field, 'isWebShareSupported', $elm$json$Json$Decode$bool));
																		},
																		A2($elm$json$Json$Decode$field, 'marmosetApiBaseUrl', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'marmosetAssetsBaseUrl', $elm$json$Json$Decode$string));
														},
														A2(
															$elm$json$Json$Decode$field,
															'recruiterLoggedInInfo',
															A2(
																$elm$json$Json$Decode$andThen,
																function (recruiterPublicMediumPictureProfileUrlMaybe) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (recruiterLoggedInNameMaybe) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (recruiterLoggedInIdMaybe) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (recruiterLoggedInEmailMaybe) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (recruiterIsLoggedIn) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (recruiterIsCorporateAdmin) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (recruiterIsAdmin) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (recruiterCloseSessionUrl) {
																															return $elm$json$Json$Decode$succeed(
																																{jo: recruiterCloseSessionUrl, jq: recruiterIsAdmin, jr: recruiterIsCorporateAdmin, js: recruiterIsLoggedIn, jt: recruiterLoggedInEmailMaybe, ju: recruiterLoggedInIdMaybe, jv: recruiterLoggedInNameMaybe, jz: recruiterPublicMediumPictureProfileUrlMaybe});
																														},
																														A2($elm$json$Json$Decode$field, 'recruiterCloseSessionUrl', $elm$json$Json$Decode$string));
																												},
																												A2($elm$json$Json$Decode$field, 'recruiterIsAdmin', $elm$json$Json$Decode$bool));
																										},
																										A2($elm$json$Json$Decode$field, 'recruiterIsCorporateAdmin', $elm$json$Json$Decode$bool));
																								},
																								A2($elm$json$Json$Decode$field, 'recruiterIsLoggedIn', $elm$json$Json$Decode$bool));
																						},
																						A2(
																							$elm$json$Json$Decode$field,
																							'recruiterLoggedInEmailMaybe',
																							$elm$json$Json$Decode$oneOf(
																								_List_fromArray(
																									[
																										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																									]))));
																				},
																				A2(
																					$elm$json$Json$Decode$field,
																					'recruiterLoggedInIdMaybe',
																					$elm$json$Json$Decode$oneOf(
																						_List_fromArray(
																							[
																								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																							]))));
																		},
																		A2(
																			$elm$json$Json$Decode$field,
																			'recruiterLoggedInNameMaybe',
																			$elm$json$Json$Decode$oneOf(
																				_List_fromArray(
																					[
																						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																					]))));
																},
																A2(
																	$elm$json$Json$Decode$field,
																	'recruiterPublicMediumPictureProfileUrlMaybe',
																	$elm$json$Json$Decode$oneOf(
																		_List_fromArray(
																			[
																				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																			]))))));
												},
												A2($elm$json$Json$Decode$field, 'recruiterPrivateHomeUrl', $elm$json$Json$Decode$string));
										},
										A2(
											$elm$json$Json$Decode$field,
											'serverInfoLabelMaybe',
											$elm$json$Json$Decode$oneOf(
												_List_fromArray(
													[
														$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
														A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
													]))));
								},
								A2($elm$json$Json$Decode$field, 'themeString', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'tonkeanBaseUrl', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'versionedAssetsUrl', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'windowSize',
			A2(
				$elm$json$Json$Decode$andThen,
				function (width) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (height) {
							return $elm$json$Json$Decode$succeed(
								{bn: height, dp: width});
						},
						A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
				},
				A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int)))))(0)}});}(this));